var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a5, b3) => {
  for (var prop in b3 || (b3 = {}))
    if (__hasOwnProp.call(b3, prop))
      __defNormalProp(a5, prop, b3[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b3)) {
      if (__propIsEnum.call(b3, prop))
        __defNormalProp(a5, prop, b3[prop]);
    }
  return a5;
};
var __spreadProps = (a5, b3) => __defProps(a5, __getOwnPropDescs(b3));
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var index_exports = {};
__export(index_exports, {
  Widget: () => Widget2
});
module.exports = __toCommonJS(index_exports);

// src/Widget.tsx
var import_react = require("react");

// ../node_modules/@forgerock/login-widget/index.js
function _mergeNamespaces(n2, m) {
  m.forEach(function(e2) {
    e2 && typeof e2 !== "string" && !Array.isArray(e2) && Object.keys(e2).forEach(function(k2) {
      if (k2 !== "default" && !(k2 in n2)) {
        var d4 = Object.getOwnPropertyDescriptor(e2, k2);
        Object.defineProperty(n2, k2, d4.get ? d4 : {
          enumerable: true,
          get: function() {
            return e2[k2];
          }
        });
      }
    });
  });
  return Object.freeze(n2);
}
function noop() {
}
function assign(tar, src) {
  for (const k2 in src)
    tar[k2] = src[k2];
  return tar;
}
function run(fn) {
  return fn();
}
function blank_object() {
  return /* @__PURE__ */ Object.create(null);
}
function run_all(fns) {
  fns.forEach(run);
}
function is_function(thing) {
  return typeof thing === "function";
}
function safe_not_equal(a5, b3) {
  return a5 != a5 ? b3 == b3 : a5 !== b3 || (a5 && typeof a5 === "object" || typeof a5 === "function");
}
function is_empty(obj) {
  return Object.keys(obj).length === 0;
}
function subscribe(store, ...callbacks) {
  if (store == null) {
    return noop;
  }
  const unsub = store.subscribe(...callbacks);
  return unsub.unsubscribe ? () => unsub.unsubscribe() : unsub;
}
function get_store_value(store) {
  let value;
  subscribe(store, (_2) => value = _2)();
  return value;
}
function component_subscribe(component, store, callback) {
  component.$$.on_destroy.push(subscribe(store, callback));
}
function create_slot(definition, ctx, $$scope, fn) {
  if (definition) {
    const slot_ctx = get_slot_context(definition, ctx, $$scope, fn);
    return definition[0](slot_ctx);
  }
}
function get_slot_context(definition, ctx, $$scope, fn) {
  return definition[1] && fn ? assign($$scope.ctx.slice(), definition[1](fn(ctx))) : $$scope.ctx;
}
function get_slot_changes(definition, $$scope, dirty, fn) {
  if (definition[2] && fn) {
    const lets = definition[2](fn(dirty));
    if ($$scope.dirty === void 0) {
      return lets;
    }
    if (typeof lets === "object") {
      const merged = [];
      const len = Math.max($$scope.dirty.length, lets.length);
      for (let i9 = 0; i9 < len; i9 += 1) {
        merged[i9] = $$scope.dirty[i9] | lets[i9];
      }
      return merged;
    }
    return $$scope.dirty | lets;
  }
  return $$scope.dirty;
}
function update_slot_base(slot, slot_definition, ctx, $$scope, slot_changes, get_slot_context_fn) {
  if (slot_changes) {
    const slot_context = get_slot_context(slot_definition, ctx, $$scope, get_slot_context_fn);
    slot.p(slot_context, slot_changes);
  }
}
function get_all_dirty_from_scope($$scope) {
  if ($$scope.ctx.length > 32) {
    const dirty = [];
    const length = $$scope.ctx.length / 32;
    for (let i9 = 0; i9 < length; i9++) {
      dirty[i9] = -1;
    }
    return dirty;
  }
  return -1;
}
function append(target, node) {
  target.appendChild(node);
}
function insert(target, node, anchor) {
  target.insertBefore(node, anchor || null);
}
function detach(node) {
  if (node.parentNode) {
    node.parentNode.removeChild(node);
  }
}
function destroy_each(iterations, detaching) {
  for (let i9 = 0; i9 < iterations.length; i9 += 1) {
    if (iterations[i9])
      iterations[i9].d(detaching);
  }
}
function element(name) {
  return document.createElement(name);
}
function svg_element(name) {
  return document.createElementNS("http://www.w3.org/2000/svg", name);
}
function text(data) {
  return document.createTextNode(data);
}
function space() {
  return text(" ");
}
function empty() {
  return text("");
}
function listen(node, event, handler, options) {
  node.addEventListener(event, handler, options);
  return () => node.removeEventListener(event, handler, options);
}
function prevent_default(fn) {
  return function(event) {
    event.preventDefault();
    return fn.call(this, event);
  };
}
function attr(node, attribute, value) {
  if (value == null)
    node.removeAttribute(attribute);
  else if (node.getAttribute(attribute) !== value)
    node.setAttribute(attribute, value);
}
function to_number(value) {
  return value === "" ? null : +value;
}
function children(element2) {
  return Array.from(element2.childNodes);
}
function set_data(text2, data) {
  data = "" + data;
  if (text2.wholeText !== data)
    text2.data = data;
}
function set_input_value(input, value) {
  input.value = value == null ? "" : value;
}
var HtmlTag = class {
  constructor(is_svg = false) {
    this.is_svg = false;
    this.is_svg = is_svg;
    this.e = this.n = null;
  }
  c(html) {
    this.h(html);
  }
  m(html, target, anchor = null) {
    if (!this.e) {
      if (this.is_svg)
        this.e = svg_element(target.nodeName);
      else
        this.e = element(target.nodeName);
      this.t = target;
      this.c(html);
    }
    this.i(anchor);
  }
  h(html) {
    this.e.innerHTML = html;
    this.n = Array.from(this.e.childNodes);
  }
  i(anchor) {
    for (let i9 = 0; i9 < this.n.length; i9 += 1) {
      insert(this.t, this.n[i9], anchor);
    }
  }
  p(html) {
    this.d();
    this.h(html);
    this.i(this.a);
  }
  d() {
    this.n.forEach(detach);
  }
};
function construct_svelte_component(component, props) {
  return new component(props);
}
var current_component;
function set_current_component(component) {
  current_component = component;
}
function get_current_component() {
  if (!current_component)
    throw new Error("Function called outside component initialization");
  return current_component;
}
function onMount(fn) {
  get_current_component().$$.on_mount.push(fn);
}
function afterUpdate(fn) {
  get_current_component().$$.after_update.push(fn);
}
var dirty_components = [];
var binding_callbacks = [];
var render_callbacks = [];
var flush_callbacks = [];
var resolved_promise = Promise.resolve();
var update_scheduled = false;
function schedule_update() {
  if (!update_scheduled) {
    update_scheduled = true;
    resolved_promise.then(flush);
  }
}
function add_render_callback(fn) {
  render_callbacks.push(fn);
}
function add_flush_callback(fn) {
  flush_callbacks.push(fn);
}
var seen_callbacks = /* @__PURE__ */ new Set();
var flushidx = 0;
function flush() {
  if (flushidx !== 0) {
    return;
  }
  const saved_component = current_component;
  do {
    try {
      while (flushidx < dirty_components.length) {
        const component = dirty_components[flushidx];
        flushidx++;
        set_current_component(component);
        update(component.$$);
      }
    } catch (e2) {
      dirty_components.length = 0;
      flushidx = 0;
      throw e2;
    }
    set_current_component(null);
    dirty_components.length = 0;
    flushidx = 0;
    while (binding_callbacks.length)
      binding_callbacks.pop()();
    for (let i9 = 0; i9 < render_callbacks.length; i9 += 1) {
      const callback = render_callbacks[i9];
      if (!seen_callbacks.has(callback)) {
        seen_callbacks.add(callback);
        callback();
      }
    }
    render_callbacks.length = 0;
  } while (dirty_components.length);
  while (flush_callbacks.length) {
    flush_callbacks.pop()();
  }
  update_scheduled = false;
  seen_callbacks.clear();
  set_current_component(saved_component);
}
function update($$) {
  if ($$.fragment !== null) {
    $$.update();
    run_all($$.before_update);
    const dirty = $$.dirty;
    $$.dirty = [-1];
    $$.fragment && $$.fragment.p($$.ctx, dirty);
    $$.after_update.forEach(add_render_callback);
  }
}
var outroing = /* @__PURE__ */ new Set();
var outros;
function group_outros() {
  outros = {
    r: 0,
    c: [],
    p: outros
    // parent group
  };
}
function check_outros() {
  if (!outros.r) {
    run_all(outros.c);
  }
  outros = outros.p;
}
function transition_in(block, local) {
  if (block && block.i) {
    outroing.delete(block);
    block.i(local);
  }
}
function transition_out(block, local, detach2, callback) {
  if (block && block.o) {
    if (outroing.has(block))
      return;
    outroing.add(block);
    outros.c.push(() => {
      outroing.delete(block);
      if (callback) {
        if (detach2)
          block.d(1);
        callback();
      }
    });
    block.o(local);
  } else if (callback) {
    callback();
  }
}
function get_spread_update(levels, updates) {
  const update2 = {};
  const to_null_out = {};
  const accounted_for = { $$scope: 1 };
  let i9 = levels.length;
  while (i9--) {
    const o2 = levels[i9];
    const n2 = updates[i9];
    if (n2) {
      for (const key in o2) {
        if (!(key in n2))
          to_null_out[key] = 1;
      }
      for (const key in n2) {
        if (!accounted_for[key]) {
          update2[key] = n2[key];
          accounted_for[key] = 1;
        }
      }
      levels[i9] = n2;
    } else {
      for (const key in o2) {
        accounted_for[key] = 1;
      }
    }
  }
  for (const key in to_null_out) {
    if (!(key in update2))
      update2[key] = void 0;
  }
  return update2;
}
function get_spread_object(spread_props) {
  return typeof spread_props === "object" && spread_props !== null ? spread_props : {};
}
function bind(component, name, callback) {
  const index = component.$$.props[name];
  if (index !== void 0) {
    component.$$.bound[index] = callback;
    callback(component.$$.ctx[index]);
  }
}
function create_component(block) {
  block && block.c();
}
function mount_component(component, target, anchor, customElement) {
  const { fragment, after_update } = component.$$;
  fragment && fragment.m(target, anchor);
  if (!customElement) {
    add_render_callback(() => {
      const new_on_destroy = component.$$.on_mount.map(run).filter(is_function);
      if (component.$$.on_destroy) {
        component.$$.on_destroy.push(...new_on_destroy);
      } else {
        run_all(new_on_destroy);
      }
      component.$$.on_mount = [];
    });
  }
  after_update.forEach(add_render_callback);
}
function destroy_component(component, detaching) {
  const $$ = component.$$;
  if ($$.fragment !== null) {
    run_all($$.on_destroy);
    $$.fragment && $$.fragment.d(detaching);
    $$.on_destroy = $$.fragment = null;
    $$.ctx = [];
  }
}
function make_dirty(component, i9) {
  if (component.$$.dirty[0] === -1) {
    dirty_components.push(component);
    schedule_update();
    component.$$.dirty.fill(0);
  }
  component.$$.dirty[i9 / 31 | 0] |= 1 << i9 % 31;
}
function init(component, options, instance2, create_fragment2, not_equal, props, append_styles, dirty = [-1]) {
  const parent_component = current_component;
  set_current_component(component);
  const $$ = component.$$ = {
    fragment: null,
    ctx: [],
    // state
    props,
    update: noop,
    not_equal,
    bound: blank_object(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
    // everything else
    callbacks: blank_object(),
    dirty,
    skip_bound: false,
    root: options.target || parent_component.$$.root
  };
  append_styles && append_styles($$.root);
  let ready = false;
  $$.ctx = instance2 ? instance2(component, options.props || {}, (i9, ret, ...rest) => {
    const value = rest.length ? rest[0] : ret;
    if ($$.ctx && not_equal($$.ctx[i9], $$.ctx[i9] = value)) {
      if (!$$.skip_bound && $$.bound[i9])
        $$.bound[i9](value);
      if (ready)
        make_dirty(component, i9);
    }
    return ret;
  }) : [];
  $$.update();
  ready = true;
  run_all($$.before_update);
  $$.fragment = create_fragment2 ? create_fragment2($$.ctx) : false;
  if (options.target) {
    if (options.hydrate) {
      const nodes = children(options.target);
      $$.fragment && $$.fragment.l(nodes);
      nodes.forEach(detach);
    } else {
      $$.fragment && $$.fragment.c();
    }
    if (options.intro)
      transition_in(component.$$.fragment);
    mount_component(component, options.target, options.anchor, options.customElement);
    flush();
  }
  set_current_component(parent_component);
}
var SvelteComponent = class {
  $destroy() {
    destroy_component(this, 1);
    this.$destroy = noop;
  }
  $on(type, callback) {
    if (!is_function(callback)) {
      return noop;
    }
    const callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
    callbacks.push(callback);
    return () => {
      const index = callbacks.indexOf(callback);
      if (index !== -1)
        callbacks.splice(index, 1);
    };
  }
  $set($$props) {
    if (this.$$set && !is_empty($$props)) {
      this.$$.skip_bound = true;
      this.$$set($$props);
      this.$$.skip_bound = false;
    }
  }
};
var subscriber_queue = [];
function readable(value, start) {
  return {
    subscribe: writable(value, start).subscribe
  };
}
function writable(value, start = noop) {
  let stop;
  const subscribers = /* @__PURE__ */ new Set();
  function set(new_value) {
    if (safe_not_equal(value, new_value)) {
      value = new_value;
      if (stop) {
        const run_queue = !subscriber_queue.length;
        for (const subscriber of subscribers) {
          subscriber[1]();
          subscriber_queue.push(subscriber, value);
        }
        if (run_queue) {
          for (let i9 = 0; i9 < subscriber_queue.length; i9 += 2) {
            subscriber_queue[i9][0](subscriber_queue[i9 + 1]);
          }
          subscriber_queue.length = 0;
        }
      }
    }
  }
  function update2(fn) {
    set(fn(value));
  }
  function subscribe2(run2, invalidate = noop) {
    const subscriber = [run2, invalidate];
    subscribers.add(subscriber);
    if (subscribers.size === 1) {
      stop = start(set) || noop;
    }
    run2(value);
    return () => {
      subscribers.delete(subscriber);
      if (subscribers.size === 0) {
        stop();
        stop = null;
      }
    };
  }
  return { set, update: update2, subscribe: subscribe2 };
}
function derived(stores, fn, initial_value) {
  const single = !Array.isArray(stores);
  const stores_array = single ? [stores] : stores;
  const auto = fn.length < 2;
  return readable(initial_value, (set) => {
    let inited = false;
    const values = [];
    let pending = 0;
    let cleanup = noop;
    const sync = () => {
      if (pending) {
        return;
      }
      cleanup();
      const result = fn(single ? values[0] : values, set);
      if (auto) {
        set(result);
      } else {
        cleanup = is_function(result) ? result : noop;
      }
    };
    const unsubscribers = stores_array.map((store, i9) => subscribe(store, (value) => {
      values[i9] = value;
      pending &= ~(1 << i9);
      if (inited) {
        sync();
      }
    }, () => {
      pending |= 1 << i9;
    }));
    inited = true;
    sync();
    return function stop() {
      run_all(unsubscribers);
      cleanup();
    };
  });
}
var componentStore = writable({
  lastAction: null,
  error: null,
  form: null,
  modal: null,
  mounted: false,
  open: null,
  reason: null,
  type: null
});
function closeComponent(args, shouldCloseDialog) {
  componentStore.update((state) => {
    var _a;
    if (state.type === "inline") {
      console.warn('Component type of "inline" has no `close` method');
      return state;
    }
    if (!((_a = state.modal) == null ? void 0 : _a.component)) {
      console.warn("Modal component is not mounted. Please instantiate the Widget before use.");
      return state;
    }
    shouldCloseDialog && state.modal.component.closeDialog();
    return __spreadProps(__spreadValues({}, state), {
      lastAction: "close",
      open: false,
      reason: (args == null ? void 0 : args.reason) || null
    });
  });
}
var componentApi = () => {
  const { update: update2 } = componentStore;
  const { subscribe: subscribe2 } = derived([componentStore], ([$componentStore], set) => {
    set({
      error: $componentStore.error,
      lastAction: $componentStore.lastAction,
      mounted: $componentStore.mounted,
      open: $componentStore.open,
      reason: $componentStore.reason
    });
  });
  return {
    /**
     * Close a modal
     * @param {object} args - object containing  the reason for closing component
     * @returns {void}
     */
    close: (args) => {
      closeComponent(args, true);
    },
    /**
     * Open a modal
     * @param: void
     * @returns: void
     */
    open: () => {
      update2((state) => {
        var _a;
        if (state.type === "inline") {
          console.warn('Component type of "inline" has no `open` method');
          return state;
        }
        if (!((_a = state.modal) == null ? void 0 : _a.component)) {
          console.warn("Modal component is not mounted. Please instantiate the Widget before use.");
          return state;
        }
        state.modal.element.showModal();
        return __spreadProps(__spreadValues({}, state), {
          lastAction: "open",
          open: true,
          reason: null
        });
      });
    },
    /**
     * Subscribe to modal events
     * returns the latest value from the event
     */
    subscribe: subscribe2
  };
};
function mount(component, element2) {
  componentStore.update((state) => {
    return __spreadProps(__spreadValues({}, state), {
      lastAction: "mount",
      modal: __spreadValues({}, component && { component, element: element2 }),
      mounted: true,
      type: component ? "modal" : "inline",
      reason: null
    });
  });
}
var T$4 = 5e3;
var E$3 = 3e4;
var o$5 = "FR-SDK";
function f$4(t3, { type: a5, payload: o2 }) {
  const i9 = Object.freeze({ type: a5, payload: o2 });
  return (e2) => {
    if (!Array.isArray(e2))
      return t3;
    const c5 = e2.map((r10) => r10);
    function n2() {
      const r10 = c5.shift();
      return r10 && r10(t3, i9, n2), t3;
    }
    return n2();
  };
}
function T$3(t3, o2 = T$4) {
  const i9 = o2 || T$4, r10 = new Promise(
    (n2, m) => setTimeout(() => m(new Error("Timeout")), i9)
  );
  return Promise.race([t3, r10]);
}
var e$2 = /* @__PURE__ */ ((E2) => (E2.Authenticate = "AUTHENTICATE", E2.Authorize = "AUTHORIZE", E2.EndSession = "END_SESSION", E2.Logout = "LOGOUT", E2.ExchangeToken = "EXCHANGE_TOKEN", E2.RefreshToken = "REFRESH_TOKEN", E2.ResumeAuthenticate = "RESUME_AUTHENTICATE", E2.RevokeToken = "REVOKE_TOKEN", E2.StartAuthenticate = "START_AUTHENTICATE", E2.UserInfo = "USER_INFO", E2.WellKnown = "WELL_KNOWN", E2))(e$2 || {});
function d$3(e2, n2) {
  var o2, l2;
  if (!e2.authorization_endpoint)
    throw new Error("Wellknown endpoint did not return `authorization_endpoint`");
  const s5 = new URL(e2.authorization_endpoint).origin;
  let t3, r10;
  n2 != null && n2.paths ? (t3 = (o2 = n2 == null ? void 0 : n2.paths) == null ? void 0 : o2.authenticate, r10 = (l2 = n2 == null ? void 0 : n2.paths) == null ? void 0 : l2.sessions) : e2.issuer.includes("/am/") ? (t3 = `${e2.issuer.replace("oauth2", "json")}/authenticate`, r10 = `${e2.issuer.replace("oauth2", "json")}/sessions`) : e2.issuer.includes("/as/");
  const a5 = __spreadValues(__spreadProps(__spreadValues({}, t3 ? { authenticate: new URL(t3).pathname } : {}), {
    authorize: new URL(e2.authorization_endpoint).pathname,
    accessToken: new URL(e2.token_endpoint).pathname,
    endSession: new URL(e2.end_session_endpoint).pathname,
    userInfo: new URL(e2.userinfo_endpoint).pathname,
    revoke: new URL(e2.revocation_endpoint).pathname
  }), r10 ? { sessions: new URL(r10).pathname } : {});
  return {
    baseUrl: s5,
    paths: a5
  };
}
async function p$4(e2) {
  var r10;
  if (!e2.serverConfig.wellknown)
    throw new Error("wellknown URL is missing in options");
  const i9 = f$4(
    {
      url: new URL((r10 = e2.serverConfig) == null ? void 0 : r10.wellknown),
      init: { method: "GET" }
    },
    {
      type: e$2.WellKnown,
      payload: {}
    }
  )(e2.middleware);
  return await (await T$3(fetch(i9.url.toString(), i9.init), e2.serverConfig.timeout)).json();
}
function w$1(n2) {
  return __spreadProps(__spreadValues({}, n2), {
    oauthThreshold: n2.oauthThreshold || E$3,
    logLevel: n2.logLevel || "none",
    platformHeader: n2.platformHeader || false,
    prefix: n2.prefix || o$5
  });
}
var c$3 = class c {
  /**
   * Sets the default options.
   *
   * @param options The options to use as defaults
   */
  static set(e2) {
    if (!this.isValid(e2))
      throw new Error("Configuration is invalid");
    e2.serverConfig && this.validateServerConfig(e2.serverConfig), this.options = __spreadValues({}, w$1(e2));
  }
  /**
   * @method setAsync - Asynchronously calls the WellKnown endpoint to collect the APIs for OAuth
   * @param {AsyncConfigOptions} options - config options with wellknown endpoint URL
   * @returns {Promise<void>} - Returns a success or failure message object
   */
  static async setAsync(e2) {
    if (!e2.serverConfig.wellknown)
      throw new Error(
        "Missing well-known property. Use `Config.set` method if not using well-known endpoint."
      );
    e2.serverConfig.baseUrl && console.warn(
      "The baseUrl property passed in will be ignored, and replaced with well-known origin."
    );
    const r10 = await p$4(e2), i9 = d$3(r10);
    delete e2.serverConfig.wellknown;
    const t3 = e2;
    t3.serverConfig = i9, this.set(t3);
  }
  /**
   * Merges the provided options with the default options.  Ensures a server configuration exists.
   *
   * @param options The options to merge with defaults
   */
  static get(e2) {
    if (!this.options && !e2)
      throw new Error("Configuration has not been set");
    const r10 = __spreadValues(__spreadValues({}, this.options), e2);
    if (!r10.serverConfig || !r10.serverConfig.baseUrl)
      throw new Error("Server configuration has not been set");
    return r10;
  }
  static isValid(e2) {
    return !!(e2 && e2.serverConfig);
  }
  static validateServerConfig(e2) {
    e2.timeout || (e2.timeout = T$4);
    const r10 = e2.baseUrl;
    r10 && r10.charAt(r10.length - 1) !== "/" && (e2.baseUrl = r10 + "/");
  }
};
var E$2 = "forgerock-sdk";
var o$4 = "javascript";
function n$3(o2) {
  const r10 = (o2 || "").split("/").map((t3) => t3.trim()).filter((t3) => t3 !== "");
  return r10[0] !== "root" && r10.unshift("root"), r10.map((t3) => `realms/${t3}`).join("/");
}
function r$b(t3) {
  const o2 = t3.protocol === "http:" && ["", "80"].indexOf(t3.port) === -1 || t3.protocol === "https:" && ["", "443"].indexOf(t3.port) === -1 ? `:${t3.port}` : "";
  return `${t3.protocol}//${t3.hostname}${o2}`;
}
function h$1(t3, e2, o2) {
  const n2 = n$3(e2), s5 = {
    authenticate: `json/${n2}/authenticate`,
    authorize: `oauth2/${n2}/authorize`,
    accessToken: `oauth2/${n2}/access_token`,
    endSession: `oauth2/${n2}/connect/endSession`,
    userInfo: `oauth2/${n2}/userinfo`,
    revoke: `oauth2/${n2}/token/revoke`,
    sessions: `json/${n2}/sessions/`
  };
  return o2 && o2[t3] ? o2[t3] : s5[t3];
}
function f$3(t3, e2) {
  const o2 = new URL(t3);
  if (e2.startsWith("/"))
    return `${r$b(o2)}${e2}`;
  const n2 = o2.pathname.split("/"), s5 = e2.split("/").filter((i9) => !!i9), a5 = [...n2.slice(0, -1), ...s5].join("/");
  return `${r$b(o2)}${a5}`;
}
function p$3(t3) {
  const e2 = new URL(t3), o2 = {};
  return e2.searchParams.forEach((n2, s5) => o2[s5] = n2), o2;
}
function $$1(t3) {
  const e2 = [];
  for (const o2 in t3)
    t3[o2] && e2.push(o2 + "=" + encodeURIComponent(t3[o2]));
  return e2.join("&");
}
var J$1 = class J {
  /**
   * Gets the next step in the authentication tree.
   *
   * @param {Step} previousStep The previous step, including any required input.
   * @param {StepOptions} options Configuration default overrides.
   * @return {Step} The next step in the authentication tree.
   */
  static async next(t3, e2) {
    const { middleware: r10, platformHeader: n2, realmPath: u4, serverConfig: i9, tree: o2, type: a5 } = c$3.get(e2), d4 = e2 ? e2.query : {}, p4 = this.constructUrl(i9, u4, o2, d4), s5 = f$4(
      {
        url: new URL(p4),
        init: this.configureRequest(t3)
      },
      {
        type: t3 ? e$2.Authenticate : e$2.StartAuthenticate,
        payload: {
          tree: o2,
          type: a5 || "service"
        }
      }
    )(r10);
    n2 && (s5.init.headers instanceof Headers ? s5.init.headers.set("X-Requested-Platform", o$4) : Array.isArray(s5.init.headers) ? s5.init.headers.push(["X-Requested-Platform", o$4]) : s5.init.headers ? s5.init.headers["X-Requested-Platform"] = o$4 : s5.init.headers = {
      "X-Requested-Platform": o$4
    });
    const h2 = await T$3(fetch(s5.url.toString(), s5.init), i9.timeout);
    return await this.getResponseJson(h2);
  }
  static constructUrl(t3, e2, r10, n2) {
    const i9 = __spreadValues(__spreadValues({}, n2), r10 ? { authIndexType: "service", authIndexValue: r10 } : void 0), o2 = Object.keys(i9).length > 0 ? `?${$$1(i9)}` : "", a5 = h$1("authenticate", e2, t3.paths);
    return f$3(t3.baseUrl, `${a5}${o2}`);
  }
  static configureRequest(t3) {
    return {
      body: t3 ? JSON.stringify(t3) : void 0,
      credentials: "include",
      headers: new Headers({
        Accept: "application/json",
        "Accept-API-Version": "protocol=1.0,resource=2.1",
        "Content-Type": "application/json",
        "X-Requested-With": E$2
      }),
      method: "POST"
    };
  }
  static async getResponseJson(t3) {
    const e2 = t3.headers.get("content-type"), n2 = e2 && e2.indexOf("application/json") > -1 ? await t3.json() : {};
    return n2.status = t3.status, n2.ok = t3.ok, n2;
  }
};
var l = /* @__PURE__ */ ((a5) => (a5.BooleanAttributeInputCallback = "BooleanAttributeInputCallback", a5.ChoiceCallback = "ChoiceCallback", a5.ConfirmationCallback = "ConfirmationCallback", a5.DeviceProfileCallback = "DeviceProfileCallback", a5.HiddenValueCallback = "HiddenValueCallback", a5.KbaCreateCallback = "KbaCreateCallback", a5.MetadataCallback = "MetadataCallback", a5.NameCallback = "NameCallback", a5.NumberAttributeInputCallback = "NumberAttributeInputCallback", a5.PasswordCallback = "PasswordCallback", a5.PingOneProtectEvaluationCallback = "PingOneProtectEvaluationCallback", a5.PingOneProtectInitializeCallback = "PingOneProtectInitializeCallback", a5.PollingWaitCallback = "PollingWaitCallback", a5.ReCaptchaCallback = "ReCaptchaCallback", a5.RedirectCallback = "RedirectCallback", a5.SelectIdPCallback = "SelectIdPCallback", a5.StringAttributeInputCallback = "StringAttributeInputCallback", a5.SuspendedTextOutputCallback = "SuspendedTextOutputCallback", a5.TermsAndConditionsCallback = "TermsAndConditionsCallback", a5.TextInputCallback = "TextInputCallback", a5.TextOutputCallback = "TextOutputCallback", a5.ValidatedCreatePasswordCallback = "ValidatedCreatePasswordCallback", a5.ValidatedCreateUsernameCallback = "ValidatedCreateUsernameCallback", a5))(l || {});
var _$4 = /* @__PURE__ */ ((A2) => (A2.CannotContainCharacters = "CANNOT_CONTAIN_CHARACTERS", A2.CannotContainDuplicates = "CANNOT_CONTAIN_DUPLICATES", A2.CannotContainOthers = "CANNOT_CONTAIN_OTHERS", A2.LeastCapitalLetters = "AT_LEAST_X_CAPITAL_LETTERS", A2.LeastNumbers = "AT_LEAST_X_NUMBERS", A2.MatchRegexp = "MATCH_REGEXP", A2.MaximumLength = "MAX_LENGTH", A2.MaximumNumber = "MAXIMUM_NUMBER_VALUE", A2.MinimumLength = "MIN_LENGTH", A2.MinimumNumber = "MINIMUM_NUMBER_VALUE", A2.Required = "REQUIRED", A2.Unique = "UNIQUE", A2.UnknownPolicy = "UNKNOWN_POLICY", A2.ValidArrayItems = "VALID_ARRAY_ITEMS", A2.ValidDate = "VALID_DATE", A2.ValidEmailAddress = "VALID_EMAIL_ADDRESS_FORMAT", A2.ValidNameFormat = "VALID_NAME_FORMAT", A2.ValidNumber = "VALID_NUMBER", A2.ValidPhoneFormat = "VALID_PHONE_FORMAT", A2.ValidQueryFilter = "VALID_QUERY_FILTER", A2.ValidType = "VALID_TYPE", A2))(_$4 || {});
function f$2(o2, r10, n2) {
  return o2 === 1 ? r10 : n2 !== void 0 ? n2 : r10 + "s";
}
function n$2(r10, t3, e2) {
  return !r10 || r10[t3] === void 0 ? e2 : r10[t3];
}
var u$3 = {
  [_$4.CannotContainCharacters]: (a5, n2) => {
    const t3 = n$2(n2, "forbiddenChars", "");
    return `${a5} must not contain following characters: "${t3}"`;
  },
  [_$4.CannotContainDuplicates]: (a5, n2) => {
    const t3 = n$2(n2, "duplicateValue", "");
    return `${a5}  must not contain duplicates: "${t3}"`;
  },
  [_$4.CannotContainOthers]: (a5, n2) => {
    const t3 = n$2(n2, "disallowedFields", "");
    return `${a5} must not contain: "${t3}"`;
  },
  [_$4.LeastCapitalLetters]: (a5, n2) => {
    const t3 = n$2(n2, "numCaps", 0);
    return `${a5} must contain at least ${t3} capital ${f$2(t3, "letter")}`;
  },
  [_$4.LeastNumbers]: (a5, n2) => {
    const t3 = n$2(n2, "numNums", 0);
    return `${a5} must contain at least ${t3} numeric ${f$2(t3, "value")}`;
  },
  [_$4.MatchRegexp]: (a5) => `${a5} has failed the "MATCH_REGEXP" policy`,
  [_$4.MaximumLength]: (a5, n2) => {
    const t3 = n$2(n2, "maxLength", 0);
    return `${a5} must be at most ${t3} ${f$2(t3, "character")}`;
  },
  [_$4.MaximumNumber]: (a5) => `${a5} has failed the "MAXIMUM_NUMBER_VALUE" policy`,
  [_$4.MinimumLength]: (a5, n2) => {
    const t3 = n$2(n2, "minLength", 0);
    return `${a5} must be at least ${t3} ${f$2(t3, "character")}`;
  },
  [_$4.MinimumNumber]: (a5) => `${a5} has failed the "MINIMUM_NUMBER_VALUE" policy`,
  [_$4.Required]: (a5) => `${a5} is required`,
  [_$4.Unique]: (a5) => `${a5} must be unique`,
  [_$4.UnknownPolicy]: (a5, n2) => {
    const t3 = n$2(n2, "policyRequirement", "Unknown");
    return `${a5}: Unknown policy requirement "${t3}"`;
  },
  [_$4.ValidArrayItems]: (a5) => `${a5} has failed the "VALID_ARRAY_ITEMS" policy`,
  [_$4.ValidDate]: (a5) => `${a5} has an invalid date`,
  [_$4.ValidEmailAddress]: (a5) => `${a5} has an invalid email address`,
  [_$4.ValidNameFormat]: (a5) => `${a5} has an invalid name format`,
  [_$4.ValidNumber]: (a5) => `${a5} has an invalid number`,
  [_$4.ValidPhoneFormat]: (a5) => `${a5} has an invalid phone number`,
  [_$4.ValidQueryFilter]: (a5) => `${a5} has failed the "VALID_QUERY_FILTER" policy`,
  [_$4.ValidType]: (a5) => `${a5} has failed the "VALID_TYPE" policy`
};
var y$1 = class y {
  /**
   * Parses policy errors and generates human readable error messages.
   *
   * @param {Step} err The step containing the error.
   * @param {MessageCreator} messageCreator
   * Extensible and overridable custom error messages for policy failures.
   * @return {ProcessedPropertyError[]} Array of objects containing all processed policy errors.
   */
  static parseErrors(e2, r10) {
    const s5 = [];
    return e2.detail && e2.detail.failedPolicyRequirements && e2.detail.failedPolicyRequirements.map((t3) => {
      s5.push.apply(s5, [
        {
          detail: t3,
          messages: this.parseFailedPolicyRequirement(t3, r10)
        }
      ]);
    }), s5;
  }
  /**
   * Parses a failed policy and returns a string array of error messages.
   *
   * @param {FailedPolicyRequirement} failedPolicy The detail data of the failed policy.
   * @param {MessageCreator} customMessage
   * Extensible and overridable custom error messages for policy failures.
   * @return {string[]} Array of strings with all processed policy errors.
   */
  static parseFailedPolicyRequirement(e2, r10) {
    const s5 = [];
    return e2.policyRequirements.map((t3) => {
      s5.push(
        this.parsePolicyRequirement(e2.property, t3, r10)
      );
    }), s5;
  }
  /**
   * Parses a policy error into a human readable error message.
   *
   * @param {string} property The property with the policy failure.
   * @param {PolicyRequirement} policy The policy failure data.
   * @param {MessageCreator} customMessage
   * Extensible and overridable custom error messages for policy failures.
   * @return {string} Human readable error message.
   */
  static parsePolicyRequirement(e2, r10, s5 = {}) {
    const t3 = typeof r10 == "string" ? JSON.parse(r10) : __spreadValues({}, r10), a5 = t3.policyRequirement, o2 = s5[a5] || u$3[a5] || u$3[_$4.UnknownPolicy], c5 = t3.params ? __spreadProps(__spreadValues({}, t3.params), { policyRequirement: a5 }) : { policyRequirement: a5 };
    return o2(e2, c5);
  }
};
var r$a = /* @__PURE__ */ ((i9) => (i9.LoginFailure = "LoginFailure", i9.LoginSuccess = "LoginSuccess", i9.Step = "Step", i9))(r$a || {});
var i$9 = class i {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(e2) {
    this.payload = e2, this.type = r$a.LoginFailure;
  }
  /**
   * Gets the error code.
   */
  getCode() {
    return Number(this.payload.code);
  }
  /**
   * Gets the failure details.
   */
  getDetail() {
    return this.payload.detail;
  }
  /**
   * Gets the failure message.
   */
  getMessage() {
    return this.payload.message;
  }
  /**
   * Gets processed failure message.
   */
  getProcessedMessage(e2) {
    return y$1.parseErrors(this.payload, e2);
  }
  /**
   * Gets the failure reason.
   */
  getReason() {
    return this.payload.reason;
  }
};
var r$9 = class r {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(e2) {
    this.payload = e2, this.type = r$a.LoginSuccess;
  }
  /**
   * Gets the step's realm.
   */
  getRealm() {
    return this.payload.realm;
  }
  /**
   * Gets the step's session token.
   */
  getSessionToken() {
    return this.payload.tokenId;
  }
  /**
   * Gets the step's success URL.
   */
  getSuccessUrl() {
    return this.payload.successUrl;
  }
};
var r$8 = class r2 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(e2) {
    this.payload = e2;
  }
  /**
   * Gets the name of this callback type.
   */
  getType() {
    return this.payload.type;
  }
  /**
   * Gets the value of the specified input element, or the first element if `selector` is not
   * provided.
   *
   * @param selector The index position or name of the desired element
   */
  getInputValue(e2 = 0) {
    return this.getArrayElement(this.payload.input, e2).value;
  }
  /**
   * Sets the value of the specified input element, or the first element if `selector` is not
   * provided.
   *
   * @param selector The index position or name of the desired element
   */
  setInputValue(e2, t3 = 0) {
    this.getArrayElement(this.payload.input, t3).value = e2;
  }
  /**
   * Gets the value of the specified output element, or the first element if `selector`
   * is not provided.
   *
   * @param selector The index position or name of the desired element
   */
  getOutputValue(e2 = 0) {
    return this.getArrayElement(this.payload.output, e2).value;
  }
  /**
   * Gets the value of the first output element with the specified name or the
   * specified default value.
   *
   * @param name The name of the desired element
   */
  getOutputByName(e2, t3) {
    const n2 = this.payload.output.find((a5) => a5.name === e2);
    return n2 ? n2.value : t3;
  }
  getArrayElement(e2, t3 = 0) {
    if (e2 === void 0)
      throw new Error(`No NameValue array was provided to search (selector ${t3})`);
    if (typeof t3 == "number") {
      if (t3 < 0 || t3 > e2.length - 1)
        throw new Error(`Selector index ${t3} is out of range`);
      return e2[t3];
    }
    if (typeof t3 == "string") {
      const n2 = e2.find((a5) => a5.name === t3);
      if (!n2)
        throw new Error(`Missing callback input entry "${t3}"`);
      return n2;
    }
    if (typeof t3 == "object" && t3.test && t3.exec) {
      const n2 = e2.find((a5) => t3.test(a5.name));
      if (!n2)
        throw new Error(`Missing callback input entry "${t3}"`);
      return n2;
    }
    throw new Error("Invalid selector value type");
  }
};
var s$4 = class s extends r$8 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(e2) {
    super(e2), this.payload = e2;
  }
  /**
   * Gets the attribute name.
   */
  getName() {
    return this.getOutputByName("name", "");
  }
  /**
   * Gets the attribute prompt.
   */
  getPrompt() {
    return this.getOutputByName("prompt", "");
  }
  /**
   * Gets whether the attribute is required.
   */
  isRequired() {
    return this.getOutputByName("required", false);
  }
  /**
   * Gets the callback's failed policies.
   */
  getFailedPolicies() {
    const e2 = this.getOutputByName(
      "failedPolicies",
      []
    );
    try {
      return e2.map((t3) => JSON.parse(t3));
    } catch (e3) {
      throw new Error(
        'Unable to parse "failed policies" from the ForgeRock server. The JSON within `AttributeInputCallback` was either malformed or missing.'
      );
    }
  }
  /**
   * Gets the callback's applicable policies.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getPolicies() {
    return this.getOutputByName("policies", {});
  }
  /**
   * Set if validating value only.
   */
  setValidateOnly(e2) {
    this.setInputValue(e2, /validateOnly/);
  }
  /**
   * Sets the attribute's value.
   */
  setValue(e2) {
    this.setInputValue(e2);
  }
};
var h = class extends r$8 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(t3) {
    super(t3), this.payload = t3;
  }
  /**
   * Gets the choice's prompt.
   */
  getPrompt() {
    return this.getOutputByName("prompt", "");
  }
  /**
   * Gets the choice's default answer.
   */
  getDefaultChoice() {
    return this.getOutputByName("defaultChoice", 0);
  }
  /**
   * Gets the choice's possible answers.
   */
  getChoices() {
    return this.getOutputByName("choices", []);
  }
  /**
   * Sets the choice's answer by index position.
   */
  setChoiceIndex(t3) {
    const e2 = this.getChoices().length;
    if (t3 < 0 || t3 > e2 - 1)
      throw new Error(`${t3} is out of bounds`);
    this.setInputValue(t3);
  }
  /**
   * Sets the choice's answer by value.
   */
  setChoiceValue(t3) {
    const e2 = this.getChoices().indexOf(t3);
    if (e2 === -1)
      throw new Error(`"${t3}" is not a valid choice`);
    this.setInputValue(e2);
  }
};
var i$8 = class i2 extends r$8 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(t3) {
    super(t3), this.payload = t3;
  }
  /**
   * Gets the index position of the confirmation's default answer.
   */
  getDefaultOption() {
    return Number(this.getOutputByName("defaultOption", 0));
  }
  /**
   * Gets the confirmation's message type.
   */
  getMessageType() {
    return Number(this.getOutputByName("messageType", 0));
  }
  /**
   * Gets the confirmation's possible answers.
   */
  getOptions() {
    return this.getOutputByName("options", []);
  }
  /**
   * Gets the confirmation's option type.
   */
  getOptionType() {
    return Number(this.getOutputByName("optionType", 0));
  }
  /**
   * Gets the confirmation's prompt.
   */
  getPrompt() {
    return this.getOutputByName("prompt", "");
  }
  /**
   * Set option index.
   */
  setOptionIndex(t3) {
    if (t3 !== 0 && t3 !== 1)
      throw new Error(`"${t3}" is not a valid choice`);
    this.setInputValue(t3);
  }
  /**
   * Set option value.
   */
  setOptionValue(t3) {
    const e2 = this.getOptions().indexOf(t3);
    if (e2 === -1)
      throw new Error(`"${t3}" is not a valid choice`);
    this.setInputValue(e2);
  }
};
var i$7 = class i3 extends r$8 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(e2) {
    super(e2), this.payload = e2;
  }
  /**
   * Gets the callback's data.
   */
  getMessage() {
    return this.getOutputByName("message", "");
  }
  /**
   * Does callback require metadata?
   */
  isMetadataRequired() {
    return this.getOutputByName("metadata", false);
  }
  /**
   * Does callback require location data?
   */
  isLocationRequired() {
    return this.getOutputByName("location", false);
  }
  /**
   * Sets the profile.
   */
  setProfile(e2) {
    this.setInputValue(JSON.stringify(e2));
  }
};
var t$2 = class t extends r$8 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(a5) {
    super(a5), this.payload = a5;
  }
};
var u$2 = class u extends r$8 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(t3) {
    super(t3), this.payload = t3;
  }
  /**
   * Gets the callback prompt.
   */
  getPrompt() {
    return this.getOutputByName("prompt", "");
  }
  /**
   * Gets the callback's list of pre-defined security questions.
   */
  getPredefinedQuestions() {
    return this.getOutputByName("predefinedQuestions", []);
  }
  /**
   * Sets the callback's security question.
   */
  setQuestion(t3) {
    this.setValue("question", t3);
  }
  /**
   * Sets the callback's security question answer.
   */
  setAnswer(t3) {
    this.setValue("answer", t3);
  }
  setValue(t3, s5) {
    if (!this.payload.input)
      throw new Error("KBA payload is missing input");
    const e2 = this.payload.input.find((i9) => i9.name.endsWith(t3));
    if (!e2)
      throw new Error(`No input has name ending in "${t3}"`);
    e2.value = s5;
  }
};
var s$3 = class s2 extends r$8 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(t3) {
    super(t3), this.payload = t3;
  }
  /**
   * Gets the callback's data.
   */
  getData() {
    return this.getOutputByName("data", {});
  }
};
var r$7 = class r3 extends r$8 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(t3) {
    super(t3), this.payload = t3;
  }
  /**
   * Gets the callback's prompt.
   */
  getPrompt() {
    return this.getOutputByName("prompt", "");
  }
  /**
   * Sets the username.
   */
  setName(t3) {
    this.setInputValue(t3);
  }
};
var r$6 = class r4 extends r$8 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(t3) {
    super(t3), this.payload = t3;
  }
  /**
   * Gets the callback's failed policies.
   */
  getFailedPolicies() {
    return this.getOutputByName("failedPolicies", []);
  }
  /**
   * Gets the callback's applicable policies.
   */
  getPolicies() {
    return this.getOutputByName("policies", []);
  }
  /**
   * Gets the callback's prompt.
   */
  getPrompt() {
    return this.getOutputByName("prompt", "");
  }
  /**
   * Sets the password.
   */
  setPassword(t3) {
    this.setInputValue(t3);
  }
};
var r$5 = class r5 extends r$8 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(t3) {
    super(t3), this.payload = t3;
  }
  /**
   * Gets the callback's pauseBehavioralData value.
   * @returns {boolean}
   */
  getPauseBehavioralData() {
    return this.getOutputByName("pauseBehavioralData", false);
  }
  /**
   * @method setData - Set the result of data collection
   * @param {string} data - Data from calling pingProtect.get()
   * @returns {void}
   */
  setData(t3) {
    this.setInputValue(t3, /signals/);
  }
  /**
   * @method setClientError - Set the client error message
   * @param {string} errorMessage - Error message
   * @returns {void}
   */
  setClientError(t3) {
    this.setInputValue(t3, /clientError/);
  }
};
var i$6 = class i4 extends r$8 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(t3) {
    super(t3), this.payload = t3;
  }
  /**
   * Get callback's initialization config settings
   */
  getConfig() {
    return {
      envId: this.getOutputByName("envId", ""),
      consoleLogEnabled: this.getOutputByName("consoleLogEnabled", false),
      deviceAttributesToIgnore: this.getOutputByName("deviceAttributesToIgnore", []),
      customHost: this.getOutputByName("customHost", ""),
      lazyMetadata: this.getOutputByName("lazyMetadata", false),
      behavioralDataCollection: this.getOutputByName("behavioralDataCollection", true),
      deviceKeyRsyncIntervals: this.getOutputByName("deviceKeyRsyncIntervals", 14),
      enableTrust: this.getOutputByName("enableTrust", false),
      disableTags: this.getOutputByName("disableTags", false),
      disableHub: this.getOutputByName("disableHub", false)
    };
  }
  setClientError(t3) {
    this.setInputValue(t3, /clientError/);
  }
};
var r$4 = class r6 extends r$8 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(t3) {
    super(t3), this.payload = t3;
  }
  /**
   * Gets the message to display while polling.
   */
  getMessage() {
    return this.getOutputByName("message", "");
  }
  /**
   * Gets the polling interval in milliseconds.
   */
  getWaitTime() {
    return Number(this.getOutputByName("waitTime", 0));
  }
};
var r$3 = class r7 extends r$8 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(t3) {
    super(t3), this.payload = t3;
  }
  /**
   * Gets the reCAPTCHA site key.
   */
  getSiteKey() {
    return this.getOutputByName("recaptchaSiteKey", "");
  }
  /**
   * Sets the reCAPTCHA result.
   */
  setResult(t3) {
    this.setInputValue(t3);
  }
};
var c$2 = class c2 extends r$8 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(t3) {
    super(t3), this.payload = t3;
  }
  /**
   * Gets the redirect URL.
   */
  getRedirectUrl() {
    return this.getOutputByName("redirectUrl", "");
  }
};
var d$2 = class d extends r$8 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(r10) {
    super(r10), this.payload = r10;
  }
  /**
   * Gets the available providers.
   */
  getProviders() {
    return this.getOutputByName("providers", []);
  }
  /**
   * Sets the provider by name.
   */
  setProvider(r10) {
    const t3 = this.getProviders().find((e2) => e2.provider === r10);
    if (!t3)
      throw new Error(`"${r10}" is not a valid choice`);
    this.setInputValue(t3.provider);
  }
};
var u$1 = class u2 extends r$8 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(e2) {
    super(e2), this.payload = e2;
  }
  /**
   * Gets the message content.
   */
  getMessage() {
    return this.getOutputByName("message", "");
  }
  /**
   * Gets the message type.
   */
  getMessageType() {
    return this.getOutputByName("messageType", "");
  }
};
var a$5 = class a extends u$1 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(t3) {
    super(t3), this.payload = t3;
  }
};
var a$4 = class a2 extends r$8 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(t3) {
    super(t3), this.payload = t3;
  }
  /**
   * Gets the terms and conditions content.
   */
  getTerms() {
    return this.getOutputByName("terms", "");
  }
  /**
   * Gets the version of the terms and conditions.
   */
  getVersion() {
    return this.getOutputByName("version", "");
  }
  /**
   * Gets the date of the terms and conditions.
   */
  getCreateDate() {
    const t3 = this.getOutputByName("createDate", "");
    return new Date(t3);
  }
  /**
   * Sets the callback's acceptance.
   */
  setAccepted(t3 = true) {
    this.setInputValue(t3);
  }
};
var r$2 = class r8 extends r$8 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(t3) {
    super(t3), this.payload = t3;
  }
  /**
   * Gets the callback's prompt.
   */
  getPrompt() {
    return this.getOutputByName("prompt", "");
  }
  /**
   * Sets the callback's input value.
   */
  setInput(t3) {
    this.setInputValue(t3);
  }
};
var i$5 = class i5 extends r$8 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(e2) {
    super(e2), this.payload = e2;
  }
  /**
   * Gets the callback's failed policies.
   */
  getFailedPolicies() {
    const e2 = this.getOutputByName(
      "failedPolicies",
      []
    );
    try {
      return e2.map((t3) => JSON.parse(t3));
    } catch (e3) {
      throw new Error(
        'Unable to parse "failed policies" from the ForgeRock server. The JSON within `ValidatedCreatePasswordCallback` was either malformed or missing.'
      );
    }
  }
  /**
   * Gets the callback's applicable policies.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getPolicies() {
    return this.getOutputByName("policies", {});
  }
  /**
   * Gets the callback's prompt.
   */
  getPrompt() {
    return this.getOutputByName("prompt", "");
  }
  /**
   * Gets whether the password is required.
   */
  isRequired() {
    return this.getOutputByName("required", false);
  }
  /**
   * Sets the callback's password.
   */
  setPassword(e2) {
    this.setInputValue(e2);
  }
  /**
   * Set if validating value only.
   */
  setValidateOnly(e2) {
    this.setInputValue(e2, /validateOnly/);
  }
};
var s$2 = class s3 extends r$8 {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(e2) {
    super(e2), this.payload = e2;
  }
  /**
   * Gets the callback's prompt.
   */
  getPrompt() {
    return this.getOutputByName("prompt", "");
  }
  /**
   * Gets the callback's failed policies.
   */
  getFailedPolicies() {
    const e2 = this.getOutputByName(
      "failedPolicies",
      []
    );
    try {
      return e2.map((t3) => JSON.parse(t3));
    } catch (e3) {
      throw new Error(
        'Unable to parse "failed policies" from the ForgeRock server. The JSON within `ValidatedCreateUsernameCallback` was either malformed or missing.'
      );
    }
  }
  /**
   * Gets the callback's applicable policies.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getPolicies() {
    return this.getOutputByName("policies", {});
  }
  /**
   * Gets whether the username is required.
   */
  isRequired() {
    return this.getOutputByName("required", false);
  }
  /**
   * Sets the callback's username.
   */
  setName(e2) {
    this.setInputValue(e2);
  }
  /**
   * Set if validating value only.
   */
  setValidateOnly(e2) {
    this.setInputValue(e2, /validateOnly/);
  }
};
function L$1(e2) {
  switch (e2.type) {
    case l.BooleanAttributeInputCallback:
      return new s$4(e2);
    case l.ChoiceCallback:
      return new h(e2);
    case l.ConfirmationCallback:
      return new i$8(e2);
    case l.DeviceProfileCallback:
      return new i$7(e2);
    case l.HiddenValueCallback:
      return new t$2(e2);
    case l.KbaCreateCallback:
      return new u$2(e2);
    case l.MetadataCallback:
      return new s$3(e2);
    case l.NameCallback:
      return new r$7(e2);
    case l.NumberAttributeInputCallback:
      return new s$4(e2);
    case l.PasswordCallback:
      return new r$6(e2);
    case l.PingOneProtectEvaluationCallback:
      return new r$5(e2);
    case l.PingOneProtectInitializeCallback:
      return new i$6(e2);
    case l.PollingWaitCallback:
      return new r$4(e2);
    case l.ReCaptchaCallback:
      return new r$3(e2);
    case l.RedirectCallback:
      return new c$2(e2);
    case l.SelectIdPCallback:
      return new d$2(e2);
    case l.StringAttributeInputCallback:
      return new s$4(e2);
    case l.SuspendedTextOutputCallback:
      return new a$5(e2);
    case l.TermsAndConditionsCallback:
      return new a$4(e2);
    case l.TextInputCallback:
      return new r$2(e2);
    case l.TextOutputCallback:
      return new u$1(e2);
    case l.ValidatedCreatePasswordCallback:
      return new i$5(e2);
    case l.ValidatedCreateUsernameCallback:
      return new s$2(e2);
    default:
      return new r$8(e2);
  }
}
var i$4 = class i6 {
  /**
   * @param payload The raw payload returned by OpenAM
   * @param callbackFactory A function that returns am implementation of FRCallback
   */
  constructor(t3, e2) {
    this.payload = t3, this.type = r$a.Step, this.callbacks = [], t3.callbacks && (this.callbacks = this.convertCallbacks(t3.callbacks, e2));
  }
  /**
   * Gets the first callback of the specified type in this step.
   *
   * @param type The type of callback to find.
   */
  getCallbackOfType(t3) {
    const e2 = this.getCallbacksOfType(t3);
    if (e2.length !== 1)
      throw new Error(`Expected 1 callback of type "${t3}", but found ${e2.length}`);
    return e2[0];
  }
  /**
   * Gets all callbacks of the specified type in this step.
   *
   * @param type The type of callback to find.
   */
  getCallbacksOfType(t3) {
    return this.callbacks.filter((e2) => e2.getType() === t3);
  }
  /**
   * Sets the value of the first callback of the specified type in this step.
   *
   * @param type The type of callback to find.
   * @param value The value to set for the callback.
   */
  setCallbackValue(t3, e2) {
    const a5 = this.getCallbacksOfType(t3);
    if (a5.length !== 1)
      throw new Error(`Expected 1 callback of type "${t3}", but found ${a5.length}`);
    a5[0].setInputValue(e2);
  }
  /**
   * Gets the step's description.
   */
  getDescription() {
    return this.payload.description;
  }
  /**
   * Gets the step's header.
   */
  getHeader() {
    return this.payload.header;
  }
  /**
   * Gets the step's stage.
   */
  getStage() {
    return this.payload.stage;
  }
  convertCallbacks(t3, e2) {
    return t3.map((l2) => (e2 || L$1)(l2) || L$1(l2));
  }
};
var f$1 = class f {
  static get previousStepKey() {
    return `${c$3.get().prefix}-PreviousStep`;
  }
  /**
   * Requests the next step in the authentication tree.
   *
   * Call `FRAuth.next()` recursively.  At each step, check for session token or error, otherwise
   * populate the step's callbacks and call `next()` again.
   *
   * Example:
   *
   * ```js
   * async function nextStep(previousStep) {
   *   const thisStep = await FRAuth.next(previousStep);
   *
   *   switch (thisStep.type) {
   *     case StepType.LoginSuccess:
   *       const token = thisStep.getSessionToken();
   *       break;
   *     case StepType.LoginFailure:
   *       const detail = thisStep.getDetail();
   *       break;
   *     case StepType.Step:
   *       // Populate `thisStep` callbacks here, and then continue
   *       thisStep.setInputValue('foo');
   *       nextStep(thisStep);
   *       break;
   *   }
   * }
   * ```
   *
   * @param previousStep The previous step with its callback values populated
   * @param options Configuration overrides
   * @return The next step in the authentication tree
   */
  static async next(t3, r10) {
    const e2 = await J$1.next(t3 ? t3.payload : void 0, r10);
    if (e2.authId) {
      const a5 = r10 ? r10.callbackFactory : void 0;
      return new i$4(e2, a5);
    }
    return !e2.authId && e2.ok ? new r$9(e2) : new i$9(e2);
  }
  /**
   * Redirects to the URL identified in the RedirectCallback and saves the full
   * step information to localStorage for retrieval when user returns from login.
   *
   * Example:
   * ```js
   * forgerock.FRAuth.redirect(step);
   * ```
   */
  static redirect(t3) {
    const e2 = t3.getCallbackOfType(l.RedirectCallback).getRedirectUrl();
    localStorage.setItem(this.previousStepKey, JSON.stringify(t3)), location.assign(e2);
  }
  /**
   * Resumes a tree after returning from an external client or provider.
   * Requires the full URL of the current window. It will parse URL for
   * key-value pairs as well as, if required, retrieves previous step.
   *
   * Example;
   * ```js
   * forgerock.FRAuth.resume(window.location.href)
   * ```
   */
  static async resume(t3, r10) {
    var _a, _b, _c;
    const e2 = new URL(t3), a5 = e2.searchParams.get("code"), n2 = e2.searchParams.get("error"), i9 = e2.searchParams.get("errorCode"), m = e2.searchParams.get("errorMessage"), s5 = e2.searchParams.get("form_post_entry"), l2 = e2.searchParams.get("nonce"), u4 = e2.searchParams.get("RelayState"), c5 = e2.searchParams.get("responsekey"), d4 = e2.searchParams.get("scope"), o2 = e2.searchParams.get("state"), g = e2.searchParams.get("suspendedId"), h2 = (_a = e2.searchParams.get("authIndexValue")) != null ? _a : void 0;
    let y3;
    function S() {
      return a5 && o2 || s5 || c5;
    }
    if (S()) {
      const p4 = localStorage.getItem(this.previousStepKey);
      if (!p4)
        throw new Error("Error: could not retrieve original redirect information.");
      try {
        y3 = JSON.parse(p4);
      } catch (e3) {
        throw new Error("Error: could not parse redirect params or step information");
      }
      localStorage.removeItem(this.previousStepKey);
    }
    const P2 = __spreadValues(__spreadProps(__spreadValues({}, r10), {
      query: __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, a5 && { code: a5 }), n2 && { error: n2 }), i9 && { errorCode: i9 }), m && { errorMessage: m }), s5 && { form_post_entry: s5 }), l2 && { nonce: l2 }), u4 && { RelayState: u4 }), c5 && { responsekey: c5 }), d4 && { scope: d4 }), o2 && { state: o2 }), g && { suspendedId: g }), r10 && r10.query)
    }), ((_b = r10 == null ? void 0 : r10.tree) != null ? _b : h2) && {
      tree: (_c = r10 == null ? void 0 : r10.tree) != null ? _c : h2
    });
    return await this.next(y3, P2);
  }
  /**
   * Requests the first step in the authentication tree.
   * This is essentially an alias to calling FRAuth.next without a previous step.
   *
   * @param options Configuration overrides
   * @return The next step in the authentication tree
   */
  static async start(t3) {
    return await f.next(void 0, t3);
  }
};
var o$3 = [
  "userAgent",
  "appName",
  "appCodeName",
  "appVersion",
  "appMinorVersion",
  "buildID",
  "product",
  "productSub",
  "vendor",
  "vendorSub",
  "browserLanguage"
];
var a$3 = [
  "fontNames",
  "displayProps",
  "browserProps",
  "hardwareProps",
  "platformProps"
];
var e$1 = 3e4;
var r$1 = {
  mac: ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
  windows: ["Win32", "Win64", "Windows", "WinCE"],
  ios: ["iPhone", "iPad", "iPod"]
};
var n$1 = ["width", "height", "pixelDepth", "orientation.angle"];
var s$1 = [
  "cursive",
  "monospace",
  "serif",
  "sans-serif",
  "fantasy",
  "Arial",
  "Arial Black",
  "Arial Narrow",
  "Arial Rounded MT Bold",
  "Bookman Old Style",
  "Bradley Hand ITC",
  "Century",
  "Century Gothic",
  "Comic Sans MS",
  "Courier",
  "Courier New",
  "Georgia",
  "Gentium",
  "Impact",
  "King",
  "Lucida Console",
  "Lalit",
  "Modena",
  "Monotype Corsiva",
  "Papyrus",
  "Tahoma",
  "TeX",
  "Times",
  "Times New Roman",
  "Trebuchet MS",
  "Verdana",
  "Verona"
];
var i$3 = [
  "cpuClass",
  "deviceMemory",
  "hardwareConcurrency",
  "maxTouchPoints",
  "oscpu"
];
var t$1 = ["language", "platform", "userLanguage", "systemLanguage"];
var p$2 = class p {
  /**
   * @method reduceToObject - goes one to two levels into source to collect attribute
   * @param props - array of strings; can use dot notation for two level lookup
   * @param src - source of attributes to check
   */
  // eslint-disable-next-line
  reduceToObject(n2, t3) {
    return n2.reduce((e2, o2) => {
      if (o2.includes(".")) {
        const l2 = o2.split("."), d4 = l2[0], i9 = l2[1], s5 = t3[d4] && t3[d4][i9];
        e2[i9] = s5 != null ? s5 : "";
      } else
        e2[o2] = t3[o2] != null ? t3[o2] : null;
      return e2;
    }, {});
  }
  /**
   * @method reduceToString - goes one level into source to collect attribute
   * @param props - array of strings
   * @param src - source of attributes to check
   */
  // eslint-disable-next-line
  reduceToString(n2, t3) {
    return n2.reduce((e2, o2) => (e2 = `${e2}${t3[o2].filename};`, e2), "");
  }
};
var t2 = class {
  static enabled() {
    const { logLevel: o2 } = c$3.get();
    return {
      none: 0,
      error: 25,
      warn: 50,
      info: 75,
      debug: 100
    }[o2];
  }
  static info(...o2) {
    const { logger: e2 } = c$3.get();
    this.enabled() >= 50 && (e2 && e2.info ? e2.info(...o2) : console.info(...o2));
  }
  static warn(...o2) {
    const { logger: e2 } = c$3.get();
    this.enabled() >= 50 && (e2 && e2.warn ? e2.warn(...o2) : console.warn(...o2));
  }
  static error(...o2) {
    const { logger: e2 } = c$3.get();
    this.enabled() >= 25 && (e2 && e2.error ? e2.error(...o2) : console.error(...o2));
  }
  static log(...o2) {
    const { logger: e2 } = c$3.get();
    this.enabled() >= 75 && (e2 && e2.log ? e2.log(...o2) : console.log(...o2));
  }
};
var O$1 = class O extends p$2 {
  constructor(t3) {
    super(), this.config = {
      fontNames: s$1,
      devicePlatforms: r$1,
      displayProps: n$1,
      browserProps: o$3,
      hardwareProps: i$3,
      platformProps: t$1
    }, t3 && Object.keys(t3).forEach((e2) => {
      if (!a$3.includes(e2))
        throw new Error("Device profile configuration category does not exist.");
      this.config[e2] = t3[e2];
    });
  }
  getBrowserMeta() {
    return typeof navigator > "u" ? (t2.warn("Cannot collect browser metadata. navigator is not defined."), {}) : this.reduceToObject(this.config.browserProps, navigator);
  }
  getBrowserPluginsNames() {
    return typeof navigator < "u" && navigator.plugins ? this.reduceToString(Object.keys(navigator.plugins), navigator.plugins) : (t2.warn("Cannot collect browser plugin information. navigator.plugins is not defined."), "");
  }
  getDeviceName() {
    if (typeof navigator > "u")
      return t2.warn("Cannot collect device name. navigator is not defined."), "";
    const t$12 = navigator.userAgent, e2 = navigator.platform;
    switch (true) {
      case this.config.devicePlatforms.mac.includes(e2):
        return "Mac (Browser)";
      case this.config.devicePlatforms.ios.includes(e2):
        return `${e2} (Browser)`;
      case this.config.devicePlatforms.windows.includes(e2):
        return "Windows (Browser)";
      case (/Android/.test(e2) || /Android/.test(t$12)):
        return "Android (Browser)";
      case (/CrOS/.test(t$12) || /Chromebook/.test(t$12)):
        return "Chrome OS (Browser)";
      case /Linux/.test(e2):
        return "Linux (Browser)";
      default:
        return `${e2 || "Unknown"} (Browser)`;
    }
  }
  getDisplayMeta() {
    return typeof screen > "u" ? (t2.warn("Cannot collect screen information. screen is not defined."), {}) : this.reduceToObject(this.config.displayProps, screen);
  }
  getHardwareMeta() {
    return typeof navigator > "u" ? (t2.warn("Cannot collect OS metadata. Navigator is not defined."), {}) : this.reduceToObject(this.config.hardwareProps, navigator);
  }
  getIdentifier() {
    const t$12 = `${c$3.get().prefix}-DeviceID`;
    if (!(typeof globalThis.crypto < "u" && globalThis.crypto.getRandomValues))
      return t2.warn("Cannot generate profile ID. Crypto and/or getRandomValues is not supported."), "";
    if (!localStorage)
      return t2.warn("Cannot store profile ID. localStorage is not supported."), "";
    let e2 = localStorage.getItem(t$12);
    return e2 || (e2 = globalThis.crypto.getRandomValues(new Uint32Array(3)).join("-"), localStorage.setItem(t$12, e2)), e2;
  }
  getInstalledFonts() {
    if (typeof document > "u")
      return t2.warn("Cannot collect font data. Global document object is undefined."), "";
    const t$12 = document.createElement("canvas");
    if (!t$12)
      return t2.warn("Cannot collect font data. Browser does not support canvas element"), "";
    const e2 = t$12.getContext && t$12.getContext("2d");
    if (!e2)
      return t2.warn("Cannot collect font data. Browser does not support 2d canvas context"), "";
    const o2 = "abcdefghi0123456789";
    e2.font = "72px Comic Sans";
    const i9 = e2.measureText(o2).width;
    return this.config.fontNames.reduce((r10, a5) => (e2.font = `72px ${a5}, Comic Sans`, e2.measureText(o2).width !== i9 && (r10 = `${r10}${a5};`), r10), "");
  }
  async getLocationCoordinates() {
    return typeof navigator < "u" && navigator.geolocation ? new Promise(async (t$12) => {
      navigator.geolocation.getCurrentPosition(
        (e2) => t$12({
          latitude: e2.coords.latitude,
          longitude: e2.coords.longitude
        }),
        (e2) => {
          t2.warn(
            "Cannot collect geolocation information. " + e2.code + ": " + e2.message
          ), t$12({});
        },
        {
          enableHighAccuracy: true,
          timeout: e$1,
          maximumAge: 0
        }
      );
    }) : (t2.warn(
      "Cannot collect geolocation information. navigator.geolocation is not defined."
    ), Promise.resolve({}));
  }
  getOSMeta() {
    return typeof navigator > "u" ? (t2.warn("Cannot collect OS metadata. navigator is not defined."), {}) : this.reduceToObject(this.config.platformProps, navigator);
  }
  async getProfile({ location: t3, metadata: e2 }) {
    const o2 = {
      identifier: this.getIdentifier()
    };
    return e2 && (o2.metadata = {
      hardware: __spreadProps(__spreadValues({}, this.getHardwareMeta()), {
        display: this.getDisplayMeta()
      }),
      browser: __spreadProps(__spreadValues({}, this.getBrowserMeta()), {
        plugins: this.getBrowserPluginsNames()
      }),
      platform: __spreadProps(__spreadValues({}, this.getOSMeta()), {
        deviceName: this.getDeviceName(),
        fonts: this.getInstalledFonts(),
        timezone: this.getTimezoneOffset()
      })
    }), t3 && (o2.location = await this.getLocationCoordinates()), o2;
  }
  getTimezoneOffset() {
    try {
      return (/* @__PURE__ */ new Date()).getTimezoneOffset();
    } catch (e2) {
      return t2.warn("Cannot collect timezone information. getTimezoneOffset is not defined."), null;
    }
  }
};
var i$2 = class i7 {
  /**
   * @method isQRCodeStep - determines if step contains QR Code callbacks
   * @param {FRStep} step - step object from AM response
   * @returns {boolean}
   */
  static isQRCodeStep(s5) {
    const t3 = s5.getCallbacksOfType(l.HiddenValueCallback);
    return t3.length === 0 ? false : !!this.getQRCodeURICb(t3);
  }
  /**
   * @method getQRCodeData - gets the necessary information from the QR Code callbacks
   * @param {FRStep} step - step object from AM response
   * @returns {QRCodeData}
   */
  static getQRCodeData(s5) {
    const t3 = s5.getCallbacksOfType(l.HiddenValueCallback);
    if (t3.length === 0)
      throw new Error(
        "QR Code step must contain a HiddenValueCallback. Use `FRQRCode.isQRCodeStep` to guard."
      );
    const e2 = this.getQRCodeURICb(t3), a5 = e2 ? e2.getOutputValue("value") : "", u4 = typeof a5 == "string" && a5.includes("otpauth://") ? "otp" : "push", n2 = s5.getCallbacksOfType(l.TextOutputCallback).find((o2) => o2.getMessageType() !== "4");
    return {
      message: n2 ? n2.getMessage() : "",
      use: u4,
      uri: typeof a5 == "string" ? a5 : ""
    };
  }
  static getQRCodeURICb(s5) {
    return s5.find((t3) => {
      const e2 = t3.getOutputValue("value");
      return typeof e2 == "string" ? (e2 == null ? void 0 : e2.includes("otpauth://")) || (e2 == null ? void 0 : e2.includes("pushauth://")) : false;
    });
  }
};
function o$2(e2) {
  const s5 = e2.match(/\s[\w\W]"([\w]*)\\/g);
  return Array.isArray(s5) && s5.map((a5) => {
    const r10 = a5.match(/"([\w]*)\\/);
    return Array.isArray(r10) ? r10[1] : "";
  }) || [];
}
function y2(e2) {
  var _a;
  var c5, a5, r10;
  return (_a = (r10 = (a5 = (c5 = e2 == null ? void 0 : e2.match(/<em\s*.*>\s*.*<\/em>/g)) == null ? void 0 : c5[0]) == null ? void 0 : a5.replace("<em>", "")) == null ? void 0 : r10.replace("</em>", "")) != null ? _a : "New Security Key";
}
var p$1 = class p2 {
  static getDeviceName(t3) {
    var _a;
    var e2;
    const a5 = (_a = (e2 = this.getDisplayCallback(t3)) == null ? void 0 : e2.getOutputByName("message", "")) != null ? _a : "";
    return y2(a5);
  }
  /**
   * Retrieves the recovery codes by parsing the JavaScript message text in callback.
   *
   * @param step The step to evaluate
   * @return Recovery Code values in array
   */
  static getCodes(t3) {
    var e2;
    const a5 = (e2 = this.getDisplayCallback(t3)) == null ? void 0 : e2.getOutputByName("message", "");
    return o$2(a5 || "");
  }
  /**
   * Determines if the given step is a Display Recovery Codes step.
   *
   * @param step The step to evaluate
   * @return Is this step a Display Recovery Codes step
   */
  static isDisplayStep(t3) {
    return !!this.getDisplayCallback(t3);
  }
  /**
   * Gets the recovery codes step.
   *
   * @param step The step to evaluate
   * @return gets the Display Recovery Codes' callback
   */
  static getDisplayCallback(t3) {
    return t3.getCallbacksOfType(l.TextOutputCallback).find((a5) => {
      const e2 = a5.getOutputByName("message", void 0);
      return e2 && (e2.includes("Recovery Codes") || e2.includes("recovery codes"));
    });
  }
};
var n = class {
  /**
   * Retrieve tokens.
   */
  static async get(t3) {
    const e2 = localStorage.getItem(`${c$3.get().prefix}-${t3}`);
    if (e2)
      try {
        return JSON.parse(e2 || "");
      } catch (e3) {
        throw new Error("Could not parse token object from localStorage");
      }
  }
  /**
   * Saves tokens.
   */
  static async set(t3, e2) {
    const o2 = JSON.stringify(e2);
    localStorage.setItem(`${c$3.get().prefix}-${t3}`, o2);
  }
  /**
   * Removes stored tokens.
   */
  static async remove(t3) {
    localStorage.removeItem(`${c$3.get().prefix}-${t3}`);
  }
};
var a$2 = class a3 {
  /**
   * Retrieve tokens.
   */
  static async get(e2) {
    const t3 = sessionStorage.getItem(`${c$3.get().prefix}-${e2}`);
    if (t3)
      try {
        return JSON.parse(t3 || "");
      } catch (e3) {
        throw new Error("Could not parse token from sessionStorage");
      }
  }
  /**
   * Saves tokens.
   */
  static async set(e2, t3) {
    const s5 = JSON.stringify(t3);
    sessionStorage.setItem(`${c$3.get().prefix}-${e2}`, s5);
  }
  /**
   * Removes stored tokens.
   */
  static async remove(e2) {
    sessionStorage.removeItem(`${c$3.get().prefix}-${e2}`);
  }
};
var d$1 = class d2 {
  /**
   * Gets stored tokens.
   */
  static async get() {
    const { clientId: t$12, tokenStore: e2 } = this.getClientConfig();
    if (e2 === "sessionStorage")
      return await a$2.get(t$12);
    if (e2 === "localStorage")
      return await n.get(t$12);
    if (e2 === "indexedDB")
      t2.warn("IndexedDB is not supported in this version.");
    else if (e2 && e2.get)
      return await e2.get(t$12);
    return await n.get(t$12);
  }
  /**
   * Saves tokens.
   */
  static async set(t$12) {
    const { clientId: e2, tokenStore: r10 } = this.getClientConfig();
    if (r10 === "sessionStorage")
      return await a$2.set(e2, t$12);
    if (r10 === "localStorage")
      return await n.set(e2, t$12);
    if (r10 === "indexedDB")
      t2.warn("IndexedDB is not supported in this version.");
    else if (r10 && r10.set)
      return await r10.set(e2, t$12);
    return await n.set(e2, t$12);
  }
  /**
   * Removes stored tokens.
   */
  static async remove() {
    const { clientId: t$12, tokenStore: e2 } = this.getClientConfig();
    if (e2 === "sessionStorage")
      return await a$2.remove(t$12);
    if (e2 === "localStorage")
      return await n.remove(t$12);
    if (e2 === "indexedDB")
      t2.warn("IndexedDB is not supported in this version.");
    else if (e2 && e2.remove)
      return await e2.remove(t$12);
    return await n.remove(t$12);
  }
  static getClientConfig() {
    const { clientId: t3 = "unconfiguredClient", tokenStore: e2 = "localStorage" } = c$3.get();
    return { clientId: t3, tokenStore: e2 };
  }
};
function o$1(t3) {
  return t3.ok || Math.floor(t3.status / 100) === 4;
}
var c$1 = class c3 {
  /**
   * Creates a random state.
   */
  static createState() {
    return this.createRandomString(16);
  }
  /**
   * Creates a random verifier.
   */
  static createVerifier() {
    return this.createRandomString(32);
  }
  /**
   * Creates a SHA-256 hash of the verifier.
   *
   * @param verifier The verifier to hash
   */
  static async createChallenge(e2) {
    const t3 = await this.sha256(e2);
    return this.base64UrlEncode(t3);
  }
  /**
   * Creates a base64 encoded, URL-friendly version of the specified array.
   *
   * @param array The array of numbers to encode
   */
  static base64UrlEncode(e2) {
    const t3 = Array.prototype.slice.call(e2);
    return btoa(String.fromCharCode.apply(null, t3)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
  }
  /**
   * Creates a SHA-256 hash of the specified string.
   *
   * @param value The string to hash
   */
  static async sha256(e2) {
    const t3 = new TextEncoder().encode(e2), a5 = await crypto.subtle.digest("SHA-256", t3);
    return new Uint8Array(a5);
  }
  /**
   * Creates a random string.
   *
   * @param size The number for entropy (default: 32)
   */
  static createRandomString(e2 = 32) {
    const t3 = new Uint8Array(e2);
    return crypto.getRandomValues(t3), btoa(t3.join("")).replace(/[^a-zA-Z0-9]+/, "");
  }
};
var A$1 = {
  // AM error for consent requirement
  AuthenticationConsentRequired: "Authentication or consent required",
  // Manual iframe error
  AuthorizationTimeout: "Authorization timed out",
  // Chromium browser error
  FailedToFetch: "Failed to fetch",
  // Mozilla browser error
  NetworkError: "NetworkError when attempting to fetch resource.",
  // Webkit browser error
  CORSError: "Cross-origin redirection",
  // prompt=none errors
  InteractionNotAllowed: "The request requires some interaction that is not allowed.",
  // PingOne login error
  LoginRequired: "User authentication is required"
};
var b$1 = class b {
  static async createAuthorizeUrl(e2) {
    const { clientId: t3, middleware: o2, redirectUri: n2, scope: i9 } = c$3.get(e2), r10 = __spreadValues(__spreadProps(__spreadValues({}, e2.query), {
      client_id: t3,
      redirect_uri: n2,
      response_type: e2.responseType,
      scope: i9,
      state: e2.state
    }), e2.prompt ? { prompt: e2.prompt } : {});
    if (e2.verifier) {
      const a5 = await c$1.createChallenge(e2.verifier);
      r10.code_challenge = a5, r10.code_challenge_method = "S256";
    }
    const s5 = f$4(
      {
        url: new URL(this.getUrl("authorize", r10, e2)),
        init: {}
      },
      { type: e$2.Authorize }
    ), { url: c5 } = s5(o2);
    return c5.toString();
  }
  /**
   * Calls the authorize URL with an iframe. If successful,
   * it returns the callback URL with authentication code,
   * optionally using PKCE.
   * Method renamed in v3.
   * Original Name: getAuthorizeUrl
   * New Name: getAuthCodeByIframe
   */
  static async getAuthCodeByIframe(e2) {
    const t3 = await this.createAuthorizeUrl(__spreadProps(__spreadValues({}, e2), { prompt: "none" })), { serverConfig: o2 } = c$3.get(e2);
    return new Promise((n2, i9) => {
      const r10 = document.createElement("iframe"), s5 = () => {
      };
      let c5 = s5, a5 = s5, d4 = 0;
      a5 = () => {
        clearTimeout(d4), r10.removeEventListener("load", c5), r10.remove();
      }, c5 = () => {
        if (r10.contentWindow) {
          const u4 = r10.contentWindow.location.href;
          (this.containsAuthCode(u4) || this.containsAuthError(u4)) && (a5(), n2(u4));
        }
      }, d4 = setTimeout(() => {
        a5(), i9(new Error(A$1.AuthorizationTimeout));
      }, o2.timeout), r10.style.display = "none", r10.addEventListener("load", c5), document.body.appendChild(r10), r10.src = t3;
    });
  }
  /**
   * Exchanges an authorization code for OAuth tokens.
   */
  static async getOAuth2Tokens(e2) {
    const { clientId: t3, redirectUri: o2 } = c$3.get(e2), n2 = {
      client_id: t3,
      code: e2.authorizationCode,
      grant_type: "authorization_code",
      redirect_uri: o2
    };
    e2.verifier && (n2.code_verifier = e2.verifier);
    const i9 = $$1(n2), r10 = {
      body: i9,
      headers: new Headers({
        "Content-Length": i9.length.toString(),
        "Content-Type": "application/x-www-form-urlencoded"
      }),
      method: "POST"
    }, s5 = await this.request("accessToken", void 0, false, r10, e2), c5 = await this.getBody(s5);
    if (s5.status !== 200) {
      const u4 = typeof c5 == "string" ? `Expected 200, received ${s5.status}` : this.parseError(c5);
      throw new Error(u4);
    }
    const a5 = c5;
    if (!a5.access_token)
      throw new Error("Access token not found in response");
    let d4;
    return a5.expires_in && (d4 = Date.now() + a5.expires_in * 1e3), {
      accessToken: a5.access_token,
      idToken: a5.id_token,
      refreshToken: a5.refresh_token,
      tokenExpiry: d4
    };
  }
  /**
   * Gets OIDC user information.
   */
  static async getUserInfo(e2) {
    const t3 = await this.request("userInfo", void 0, true, void 0, e2);
    if (t3.status !== 200)
      throw new Error(`Failed to get user info; received ${t3.status}`);
    return await t3.json();
  }
  /**
   * Invokes the OIDC end session endpoint.
   * Can result in a redirect to `/signoff` if using PingOne
   * It's best to explicitly provide the logout redirect URL in options
   *
   * @function endSession - call authorization server to end associated session
   * @param options {LogoutOptions} - an extension of ConfigOptions, but with two additional props
   * @param options.logoutRedirectUri {string} - the URL you want the AS to redirect to after signout
   * @param options.redirect {boolean} - to explicitly deactivate redirect, pass `false`
   */
  static async endSession(e2) {
    const t3 = __spreadValues({}, e2);
    delete t3.redirect, delete t3.logoutRedirectUri;
    const o2 = {}, n2 = await d$1.get();
    o2.id_token_hint = n2 && n2.idToken || (e2 && "idToken" in e2 ? e2.idToken : "");
    const i9 = await this.request("endSession", o2, true, void 0, t3, {
      redirect: e2 == null ? void 0 : e2.redirect,
      logoutRedirectUri: e2 == null ? void 0 : e2.logoutRedirectUri
    });
    if (!o$1(i9))
      throw new Error(`Failed to end session; received ${i9.status}`);
    return i9;
  }
  /**
   * Immediately revokes the stored access token.
   */
  static async revokeToken(e2) {
    const { clientId: t3 } = c$3.get(e2), o2 = await d$1.get(), n2 = o2 && o2.accessToken, i9 = {
      client_id: t3
    };
    n2 && (i9.token = n2);
    const r10 = {
      body: $$1(i9),
      credentials: "include",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded"
      }),
      method: "POST"
    }, s5 = await this.request("revoke", void 0, false, r10, e2);
    if (!o$1(s5))
      throw new Error(`Failed to revoke token; received ${s5.status}`);
    return s5;
  }
  static async request(e2, t3, o2, n2, i9, r10) {
    const { redirectUri: s5, middleware: c5, serverConfig: a5 } = c$3.get(i9), d4 = r10 != null && r10.logoutRedirectUri ? r10.logoutRedirectUri : s5, u4 = this.getUrl(e2, t3, i9), m = (w2) => {
      switch (w2) {
        case "accessToken":
          return e$2.ExchangeToken;
        case "endSession":
          return e$2.EndSession;
        case "revoke":
          return e$2.RevokeToken;
        default:
          return e$2.UserInfo;
      }
    };
    if (n2 = n2 || {}, o2) {
      const w2 = await d$1.get(), v = w2 && w2.accessToken;
      n2.credentials = "include", n2.headers = n2.headers || new Headers(), n2.headers.set("Authorization", `Bearer ${v}`);
    }
    const h2 = f$4(
      { url: new URL(u4), init: n2 },
      { type: m(e2) }
    )(c5);
    return m(e2) === e$2.EndSession && // endSession action only
    (r10 == null ? void 0 : r10.redirect) === true ? (h2.url.searchParams.append("post_logout_redirect_uri", d4 || ""), window.location.assign(h2.url.toString()), new Response()) : m(e2) === e$2.EndSession && // endSession action only
    (r10 == null ? void 0 : r10.redirect) !== false && // Only `false` explicitly disables this behavior for rare edge cases
    // If we explicitly get a logout redirect URL, then that's enough of a hint to redirect
    // If we don't have that, let's see if they are calling the typical PingOne `/signoff` endpoint
    (r10 != null && r10.logoutRedirectUri || this.getUrl("endSession").includes("/as/signoff")) ? (h2.url.searchParams.append("post_logout_redirect_uri", d4 || ""), window.location.assign(h2.url.toString()), new Response()) : await T$3(fetch(h2.url.toString(), h2.init), a5.timeout);
  }
  static containsAuthCode(e2) {
    return !!e2 && /code=([^&]+)/.test(e2);
  }
  static containsAuthError(e2) {
    return !!e2 && /error=([^&]+)/.test(e2);
  }
  static async getBody(e2) {
    const t3 = e2.headers.get("Content-Type");
    return t3 && t3.indexOf("application/json") > -1 ? await e2.json() : await e2.text();
  }
  static parseError(e2) {
    if (e2) {
      if (e2.error && e2.error_description)
        return `${e2.error}: ${e2.error_description}`;
      if (e2.code && e2.message)
        return `${e2.code}: ${e2.message}`;
    }
  }
  static getUrl(e2, t3, o2) {
    const { realmPath: n2, serverConfig: i9 } = c$3.get(o2), r10 = h$1(e2, n2, i9.paths);
    let s5 = f$3(i9.baseUrl, r10);
    return t3 && (s5 += `?${$$1(t3)}`), s5;
  }
};
var M$1 = class M {
  /**
   * Ends the current session.
   */
  static async logout(i9) {
    const { middleware: s5, platformHeader: a5, realmPath: n2, serverConfig: r10 } = c$3.get(i9), d4 = {
      credentials: "include",
      headers: new Headers({
        "Accept-API-Version": "protocol=1.0,resource=2.0",
        "X-Requested-With": E$2
      }),
      method: "POST"
    }, l2 = `${h$1("sessions", n2, r10.paths)}?_action=logout`, m = f$3(r10.baseUrl, l2), e2 = f$4(
      { url: new URL(m), init: d4 },
      { type: e$2.Logout }
    )(s5);
    a5 && (e2.init.headers instanceof Headers ? e2.init.headers.set("X-Requested-Platform", o$4) : Array.isArray(e2.init.headers) ? e2.init.headers.push(["X-Requested-Platform", o$4]) : e2.init.headers ? e2.init.headers["X-Requested-Platform"] = o$4 : e2.init.headers = {
      "X-Requested-Platform": o$4
    });
    const o2 = await T$3(fetch(e2.url.toString(), e2.init), r10.timeout);
    if (!o$1(o2))
      throw new Error(`Failed to log out; received ${o2.status}`);
    return o2;
  }
};
function i$1(e2, n2) {
  return e2 && n2 ? n2 - e2 < Date.now() : false;
}
var r9 = /* @__PURE__ */ ((o2) => (o2.Code = "code", o2.Token = "token", o2))(r9 || {});
var T$2 = class T {
  /**
     * Token Manager class that provides high-level abstraction for Authorization Code flow,
     * PKCE value generation, token exchange and token storage.
     *
     * Supports both embedded authentication as well as external authentication via redirects
     *
     Example 1:
  
     ```js
     const tokens = forgerock.TokenManager.getTokens({
       forceRenew: true, // If you want to get new tokens, despite existing ones
       login: 'embedded', // If user authentication is handled in-app
       serverConfig: {
         timeout: 5000, // If using "legacy", use a short timeout to catch error
       },
     });
     ```
  
     Example 2:
  
     ```js
     const tokens = forgerock.TokenManager.getTokens({
       forceRenew: false, // Will immediately return stored tokens, if they exist
       login: 'redirect', // If user authentication is handled in external Web app
     });
     ```
  
     Example 3:
  
     ```js
     const tokens = forgerock.TokenManager.getTokens({
       query: {
         code: 'lFJQYdoQG1u7nUm8 ... ', // Authorization code from redirect URL
         state: 'MTY2NDkxNTQ2Nde3D ... ', // State from redirect URL
       },
     });
     ```
     */
  static async getTokens(e2) {
    var g, d4, w2;
    const { clientId: u4, oauthThreshold: f3 } = c$3.get(e2), i9 = `${c$3.get().prefix}-authflow-${u4}`, o2 = await d$1.get();
    if (o2 && !(e2 != null && e2.forceRenew) && !((g = e2 == null ? void 0 : e2.query) != null && g.code) && !i$1(f3, o2.tokenExpiry))
      return o2;
    if (o2)
      try {
        await b$1.revokeToken(e2), await T.deleteTokens();
      } catch (r10) {
        t2.warn("Existing tokens could not be revoked or deleted", r10);
      }
    if ((d4 = e2 == null ? void 0 : e2.query) != null && d4.code && ((w2 = e2 == null ? void 0 : e2.query) != null && w2.state)) {
      const r10 = sessionStorage.getItem(i9);
      sessionStorage.removeItem(i9);
      const h2 = JSON.parse(r10);
      return await this.tokenExchange(e2, h2);
    }
    const a5 = c$1.createVerifier(), n2 = c$1.createState(), s5 = Object.assign({}, e2);
    delete s5.forceRenew, delete s5.login;
    const c5 = __spreadProps(__spreadValues({}, s5), {
      responseType: r9.Code,
      state: n2,
      verifier: a5
    });
    try {
      const r10 = new URL(await b$1.getAuthCodeByIframe(c5));
      if (r10.searchParams.get("error"))
        throw Error(`${r10.searchParams.get("error_description")}`);
      if (!r10.searchParams.get("code"))
        throw Error(A$1.AuthenticationConsentRequired);
      const h2 = p$3(r10.toString());
      e2 || (e2 = {}), e2.query = h2;
    } catch (r10) {
      if (!(r10 instanceof Error) || (e2 == null ? void 0 : e2.login) !== "redirect" || A$1.AuthenticationConsentRequired !== r10.message && A$1.AuthorizationTimeout !== r10.message && A$1.FailedToFetch !== r10.message && A$1.NetworkError !== r10.message && A$1.InteractionNotAllowed !== r10.message && // Check for Ping Identity Login Required error
      // Long message, so just check substring
      !r10.message.includes(A$1.LoginRequired) && // Safari has a very long error message, so we check for a substring
      !r10.message.includes(A$1.CORSError))
        throw r10;
      sessionStorage.setItem(i9, JSON.stringify(c5));
      const h2 = await b$1.createAuthorizeUrl(c5);
      return location.assign(h2);
    }
    return await this.tokenExchange(e2, { state: n2, verifier: a5 });
  }
  static async deleteTokens() {
    await d$1.remove();
  }
  static async tokenExchange(e2, u4) {
    var n2, s5, c5, g;
    if (((n2 = e2.query) == null ? void 0 : n2.state) !== u4.state)
      throw new Error("State mismatch");
    if (!((s5 = e2.query) != null && s5.code) || Array.isArray((c5 = e2.query) == null ? void 0 : c5.code))
      throw new Error("Failed to acquire authorization code");
    const f3 = (g = e2.query) == null ? void 0 : g.code, i9 = u4.verifier, o2 = __spreadProps(__spreadValues({}, e2), { authorizationCode: f3, verifier: i9 }), a5 = await b$1.getOAuth2Tokens(o2);
    if (!a5 || !a5.accessToken)
      throw new Error("Unable to exchange authorization for tokens");
    try {
      await d$1.set(a5);
    } catch (d4) {
      t2.error("Failed to store tokens", d4);
    }
    return a5;
  }
};
var k = class {
  /**
   * Logs the user in with the specified step handler, acquires OAuth tokens, and retrieves
   * user profile.  **Currently not implemented.**
   *
   * @typeparam T The type of user object expected
   * @param handler The function to invoke when handling authentication steps
   * @param options Configuration overrides
   */
  static async login(e2, o2) {
    throw t2.info(e2, o2), new Error("FRUser.login() not implemented");
  }
  /**
   * Ends the user's session and revokes OAuth tokens.
   *
   * @param options Configuration overrides
   */
  static async logout(e2) {
    const o2 = __spreadValues({}, e2);
    delete o2.redirect;
    try {
      await M$1.logout(o2);
    } catch (e3) {
      t2.warn("Session logout was not successful");
    }
    try {
      await b$1.revokeToken(o2);
    } catch (e3) {
      t2.warn("OAuth revokeToken was not successful");
    }
    const n2 = await d$1.get(), { idToken: a5 = "" } = n2 || {};
    await T$2.deleteTokens();
    try {
      await b$1.endSession(__spreadProps(__spreadValues({}, e2), { idToken: a5 }));
    } catch (e3) {
      t2.warn("OAuth endSession was not successful");
    }
  }
};
var o = /* @__PURE__ */ ((r10) => (r10.Error = "ERROR", r10.Unsupported = "unsupported", r10))(o || {});
var E$1 = /* @__PURE__ */ ((r10) => (r10.AbortError = "AbortError", r10.DataError = "DataError", r10.ConstraintError = "ConstraintError", r10.EncodingError = "EncodingError", r10.InvalidError = "InvalidError", r10.NetworkError = "NetworkError", r10.NotAllowedError = "NotAllowedError", r10.NotSupportedError = "NotSupportedError", r10.SecurityError = "SecurityError", r10.TimeoutError = "TimeoutError", r10.UnknownError = "UnknownError", r10))(E$1 || {});
var i8 = /* @__PURE__ */ ((r10) => (r10[r10.None = 0] = "None", r10[r10.Authentication = 1] = "Authentication", r10[r10.Registration = 2] = "Registration", r10))(i8 || {});
function s4(r10) {
  return r10 || [];
}
function u3(r10) {
  const n2 = new Uint8Array(r10);
  return new TextDecoder().decode(n2);
}
function f2(r10) {
  return r10 ? r10[1] : "";
}
function a$1(r10) {
  try {
    return r10.split("}").filter((e2) => !!e2 && e2 !== "]").map((e2) => {
      const t3 = c4(e2);
      return {
        id: new Int8Array(t3).buffer,
        type: "public-key"
      };
    });
  } catch (e2) {
    const e3 = new Error("Transforming credential object to string failed");
    throw e3.name = E$1.EncodingError, e3;
  }
}
function c4(r10) {
  const n2 = /new Int8Array\((.+)\)/.exec(r10);
  return n2 === null || n2.length < 2 ? [] : JSON.parse(n2[1]);
}
function p3(r10) {
  if (Array.isArray(r10))
    return r10;
  if (typeof r10 == "string")
    return r10 && r10[0] === "[" ? JSON.parse(r10) : (r10 = r10.replace(/(\w+):/g, '"$1":'), JSON.parse(`[${r10}]`));
}
function d3(r10) {
  return r10.includes("rpId") ? r10.replace(/rpId: "(.+)",/, "$1") : r10.replace(/id: "(.+)",/, "$1");
}
function T$1(t3) {
  const s$12 = new TextEncoder(), r10 = f2(t3.match(/attestation"{0,}:\s{0,}"(\w+)"/)), c5 = Number(f2(t3.match(/timeout"{0,}:\s{0,}(\d+)/))), l2 = f2(
    t3.match(/userVerification"{0,}:\s{0,}"(\w+)"/)
  ), i9 = f2(
    t3.match(/requireResidentKey"{0,}:\s{0,}(\w+)/)
  ), o2 = f2(
    t3.match(/authenticatorAttachment"{0,}:\s{0,}"([\w-]+)/)
  ), m = f2(t3.match(/rp"{0,}:\s{0,}{([^}]+)}/)).trim(), a5 = f2(m.match(/id"{0,}:\s{0,}"([^"]*)"/)), w2 = f2(m.match(/name"{0,}:\s{0,}"([^"]*)"/)), n2 = f2(t3.match(/user"{0,}:\s{0,}{([^]{0,})},/)).trim(), u4 = f2(n2.match(/id"{0,}:\s{0,}Uint8Array.from\("([^"]+)"/)), d4 = f2(n2.match(/name"{0,}:\s{0,}"([\d\w._-]+)"/)), h2 = f2(n2.match(/displayName"{0,}:\s{0,}"([\d\w\s.@_-]+)"/)), p$12 = f2(
    // Capture the `pubKeyCredParams` without also matching `excludeCredentials` as well.
    // `excludeCredentials` values are very similar to this property, so we need to make sure
    // our last value doesn't end with "buffer", so we are only capturing objects that
    // end in a digit and possibly a space.
    t3.match(/pubKeyCredParams"*:\s*\[([^]+\d\s*})\s*]/)
  ).trim(), A2 = p3(p$12);
  if (!A2) {
    const b3 = new Error("Missing pubKeyCredParams property from registration options");
    throw b3.name = E$1.DataError, b3;
  }
  const g = f2(
    t3.match(/excludeCredentials"{0,}:\s{0,}\[([^]+)\s{0,}]/)
  ).trim(), f$12 = a$1(g), C = s4(
    t3.match(/challenge"{0,}:\s{0,}new\s{0,}(Uint|Int)8Array\(([^\)]+)/)
  ), N2 = JSON.parse(C[2]), I = new Int8Array(N2).buffer;
  return __spreadProps(__spreadValues({
    attestation: r10,
    authenticatorSelection: __spreadValues(__spreadValues({
      userVerification: l2
    }, o2 && { authenticatorAttachment: o2 }), i9 === "true" && {
      requireResidentKey: !!i9
    }),
    challenge: I
  }, f$12.length && { excludeCredentials: f$12 }), {
    pubKeyCredParams: A2,
    rp: __spreadValues({
      name: w2
    }, a5 && { id: a5 }),
    timeout: c5,
    user: {
      displayName: h2,
      id: s$12.encode(u4),
      name: d4
    }
  });
}
function E(t3) {
  let s$12, r10;
  t3.includes("acceptableCredentials") ? r10 = f2(
    t3.match(/acceptableCredentials"*\s*=\s*\[([^]+)\s*]/)
  ).trim() : r10 = f2(
    t3.match(/allowCredentials"{0,}:\s{0,}\[([^]+)\s{0,}]/)
  ).trim();
  const c5 = f2(
    t3.match(/userVerification"{0,}:\s{0,}"(\w+)"/)
  );
  r10 && (s$12 = (r10.split("},") || [r10]).map((n2) => {
    const u4 = f2(n2.match(/type"{0,}:\s{0,}"([\w-]+)"/)), d4 = s4(n2.match(/id"{0,}:\s{0,}new\s{0,}(Uint|Int)8Array\(([^\)]+)/)), h2 = JSON.parse(d4[2]), p4 = new Int8Array(h2).buffer;
    return {
      type: u4,
      id: p4
    };
  }));
  const l2 = Number(f2(t3.match(/timeout"{0,}:\s{0,}(\d+)/))), i9 = s4(
    t3.match(/challenge"{0,}:\s{0,}new\s{0,}(Uint|Int)8Array\(([^\)]+)/)
  ), o2 = JSON.parse(i9[2]), m = new Int8Array(o2).buffer, a5 = f2(t3.match(/rpId"{0,}:\s{0,}\\{0,}"([^"\\]*)/));
  return __spreadValues(__spreadValues(__spreadValues({
    challenge: m,
    timeout: l2
  }, s$12 && { allowCredentials: s$12 }), c5 && { userVerification: c5 }), a5 && { rpId: a5 });
}
var T2 = class {
  /**
   * Determines if the given step is a WebAuthn step.
   *
   * @param step The step to evaluate
   * @return A WebAuthnStepType value
   */
  static getWebAuthnStepType(e2) {
    const a5 = this.getOutcomeCallback(e2), t3 = this.getMetadataCallback(e2), i$12 = this.getTextOutputCallback(e2);
    if (a5 && t3) {
      const n2 = t3.getOutputValue("data");
      return n2 != null && n2.pubKeyCredParams ? i8.Registration : i8.Authentication;
    } else
      return a5 && i$12 ? i$12.getMessage().includes("pubKeyCredParams") ? i8.Registration : i8.Authentication : i8.None;
  }
  /**
   * Populates the step with the necessary authentication outcome.
   *
   * @param step The step that contains WebAuthn authentication data
   * @return The populated step
   */
  static async authenticate(e2) {
    const { hiddenCallback: a5, metadataCallback: t3, textOutputCallback: i9 } = this.getCallbacks(e2);
    if (a5 && (t3 || i9)) {
      let n2;
      try {
        let r10;
        if (t3) {
          const c5 = t3.getOutputValue("data");
          r10 = this.createAuthenticationPublicKey(c5);
        } else
          i9 && (r10 = E(i9.getMessage()));
        const o2 = await this.getAuthenticationCredential(r10);
        n2 = this.getAuthenticationOutcome(o2);
      } catch (r10) {
        throw r10 instanceof Error ? r10.name === E$1.NotSupportedError ? (a5.setInputValue(o.Unsupported), r10) : (a5.setInputValue(`${o.Error}::${r10.name}:${r10.message}`), r10) : r10;
      }
      return a5.setInputValue(n2), e2;
    } else {
      const n2 = new Error("Incorrect callbacks for WebAuthn authentication");
      throw n2.name = E$1.DataError, a5 == null || a5.setInputValue(`${o.Error}::${n2.name}:${n2.message}`), n2;
    }
  }
  /**
   * Populates the step with the necessary registration outcome.
   *
   * @param step The step that contains WebAuthn registration data
   * @return The populated step
   */
  // Can make this generic const in Typescript 5.0 > and the name itself will
  // be inferred from the type so `typeof deviceName` will not just return string
  // but the actual name of the deviceName passed in as a generic.
  static async register(e2, a5) {
    const { hiddenCallback: t3, metadataCallback: i9, textOutputCallback: n2 } = this.getCallbacks(e2);
    if (t3 && (i9 || n2)) {
      let r10;
      try {
        let o2;
        if (i9) {
          const c5 = i9.getOutputValue("data");
          o2 = this.createRegistrationPublicKey(c5);
          const l2 = await this.getRegistrationCredential(
            o2
          );
          r10 = this.getRegistrationOutcome(l2);
        } else if (n2) {
          o2 = T$1(n2.getMessage());
          const c5 = await this.getRegistrationCredential(
            o2
          );
          r10 = this.getRegistrationOutcome(c5);
        } else
          throw new Error("No Credential found from Public Key");
      } catch (o$12) {
        throw o$12 instanceof Error ? o$12.name === E$1.NotSupportedError ? (t3.setInputValue(o.Unsupported), o$12) : (t3.setInputValue(`${o.Error}::${o$12.name}:${o$12.message}`), o$12) : o$12;
      }
      return t3.setInputValue(
        a5 && a5.length > 0 ? `${r10}::${a5}` : r10
      ), e2;
    } else {
      const r10 = new Error("Incorrect callbacks for WebAuthn registration");
      throw r10.name = E$1.DataError, t3 == null || t3.setInputValue(`${o.Error}::${r10.name}:${r10.message}`), r10;
    }
  }
  /**
   * Returns an object containing the two WebAuthn callbacks.
   *
   * @param step The step that contains WebAuthn callbacks
   * @return The WebAuthn callbacks
   */
  static getCallbacks(e2) {
    const a5 = this.getOutcomeCallback(e2), t3 = this.getMetadataCallback(e2), i9 = this.getTextOutputCallback(e2), n2 = {
      hiddenCallback: a5
    };
    return t3 ? n2.metadataCallback = t3 : i9 && (n2.textOutputCallback = i9), n2;
  }
  /**
   * Returns the WebAuthn metadata callback containing data to pass to the browser
   * Web Authentication API.
   *
   * @param step The step that contains WebAuthn callbacks
   * @return The metadata callback
   */
  static getMetadataCallback(e2) {
    return e2.getCallbacksOfType(l.MetadataCallback).find((a5) => {
      const t3 = a5.getOutputByName("data", void 0);
      return t3 && t3.hasOwnProperty("relyingPartyId");
    });
  }
  /**
   * Returns the WebAuthn hidden value callback where the outcome should be populated.
   *
   * @param step The step that contains WebAuthn callbacks
   * @return The hidden value callback
   */
  static getOutcomeCallback(e2) {
    return e2.getCallbacksOfType(l.HiddenValueCallback).find((a5) => a5.getOutputByName("id", "") === "webAuthnOutcome");
  }
  /**
   * Returns the WebAuthn metadata callback containing data to pass to the browser
   * Web Authentication API.
   *
   * @param step The step that contains WebAuthn callbacks
   * @return The metadata callback
   */
  static getTextOutputCallback(e2) {
    return e2.getCallbacksOfType(l.TextOutputCallback).find((a5) => {
      const t3 = a5.getOutputByName("message", void 0);
      return t3 && t3.includes("webAuthnOutcome");
    });
  }
  /**
   * Retrieves the credential from the browser Web Authentication API.
   *
   * @param options The public key options associated with the request
   * @return The credential
   */
  static async getAuthenticationCredential(e2) {
    if (!window.PublicKeyCredential) {
      const t3 = new Error("PublicKeyCredential not supported by this browser");
      throw t3.name = E$1.NotSupportedError, t3;
    }
    return await navigator.credentials.get({ publicKey: e2 });
  }
  /**
   * Converts an authentication credential into the outcome expected by OpenAM.
   *
   * @param credential The credential to convert
   * @return The outcome string
   */
  static getAuthenticationOutcome(e2) {
    if (e2 === null) {
      const a5 = new Error("No credential generated from authentication");
      throw a5.name = E$1.UnknownError, a5;
    }
    try {
      const a5 = u3(e2.response.clientDataJSON), t3 = e2.response, i9 = new Int8Array(
        t3.authenticatorData
      ).toString(), n2 = new Int8Array(t3.signature).toString(), r10 = u3(e2.response.userHandle);
      let o2 = `${a5}::${i9}::${n2}::${e2.id}`;
      return r10 && (o2 = `${o2}::${r10}`), o2;
    } catch (e3) {
      const t3 = new Error("Transforming credential object to string failed");
      throw t3.name = E$1.EncodingError, t3;
    }
  }
  /**
   * Retrieves the credential from the browser Web Authentication API.
   *
   * @param options The public key options associated with the request
   * @return The credential
   */
  static async getRegistrationCredential(e2) {
    if (!window.PublicKeyCredential) {
      const t3 = new Error("PublicKeyCredential not supported by this browser");
      throw t3.name = E$1.NotSupportedError, t3;
    }
    return await navigator.credentials.create({
      publicKey: e2
    });
  }
  /**
   * Converts a registration credential into the outcome expected by OpenAM.
   *
   * @param credential The credential to convert
   * @return The outcome string
   */
  static getRegistrationOutcome(e2) {
    if (e2 === null) {
      const a5 = new Error("No credential generated from registration");
      throw a5.name = E$1.UnknownError, a5;
    }
    try {
      const a5 = u3(e2.response.clientDataJSON), t3 = e2.response, i9 = new Int8Array(
        t3.attestationObject
      ).toString();
      return `${a5}::${i9}::${e2.id}`;
    } catch (e3) {
      const t3 = new Error("Transforming credential object to string failed");
      throw t3.name = E$1.EncodingError, t3;
    }
  }
  /**
   * Converts authentication tree metadata into options required by the browser
   * Web Authentication API.
   *
   * @param metadata The metadata provided in the authentication tree MetadataCallback
   * @return The Web Authentication API request options
   */
  static createAuthenticationPublicKey(e2) {
    const {
      acceptableCredentials: a5,
      allowCredentials: t3,
      challenge: i9,
      relyingPartyId: n2,
      timeout: r10,
      userVerification: o2
    } = e2, c5 = d3(n2), l2 = a$1(t3 || a5 || "");
    return __spreadValues(__spreadValues(__spreadValues({
      challenge: Uint8Array.from(atob(i9), (p4) => p4.charCodeAt(0)).buffer,
      timeout: r10
    }, l2 && { allowCredentials: l2 }), o2 && { userVerification: o2 }), c5 && { rpId: c5 });
  }
  /**
   * Converts authentication tree metadata into options required by the browser
   * Web Authentication API.
   *
   * @param metadata The metadata provided in the authentication tree MetadataCallback
   * @return The Web Authentication API request options
   */
  static createRegistrationPublicKey(e2) {
    const { pubKeyCredParams: a5 } = e2, t3 = p3(a5);
    if (!t3) {
      const u4 = new Error("Missing pubKeyCredParams property from registration options");
      throw u4.name = E$1.DataError, u4;
    }
    const i9 = a$1(e2.excludeCredentials), {
      attestationPreference: n2,
      authenticatorSelection: r10,
      challenge: o2,
      relyingPartyId: c5,
      relyingPartyName: l2,
      timeout: p$12,
      userId: w2,
      userName: m,
      displayName: O3
    } = e2, y3 = d3(c5), k2 = __spreadValues({
      name: l2
    }, y3 && { id: y3 });
    return __spreadProps(__spreadValues({
      attestation: n2,
      authenticatorSelection: JSON.parse(r10),
      challenge: Uint8Array.from(atob(o2), (u4) => u4.charCodeAt(0)).buffer
    }, i9.length && { excludeCredentials: i9 }), {
      pubKeyCredParams: t3,
      rp: k2,
      timeout: p$12,
      user: {
        displayName: O3 || m,
        id: Int8Array.from(w2.split("").map((u4) => u4.charCodeAt(0))),
        name: m
      }
    });
  }
};
function P(e2, t3, n2) {
  const i9 = new Headers(e2.headers);
  return t3.AuthenticateToServiceConditionAdvice ? i9.set("X-Tree", t3.AuthenticateToServiceConditionAdvice[0]) : t3.TransactionConditionAdvice && i9.set("X-TxID", t3.TransactionConditionAdvice[0]), n2 && n2.idToken && i9.set("X-IdToken", n2.idToken), i9;
}
function W(e2, t3, n2) {
  const i9 = new URL(e2);
  if (t3.TransactionConditionAdvice) {
    const c5 = t3.TransactionConditionAdvice[0];
    i9.searchParams.append("_txid", c5);
  }
  return n2 && n2.idToken && i9.searchParams.append("_idtoken", n2.idToken), i9.toString();
}
function b2(e2, t3, n2, i9, c5) {
  const r10 = e2.advices && e2.advices.AuthenticateToServiceConditionAdvice, a5 = e2.advices && e2.advices.TransactionConditionAdvice;
  let d4 = "", s5 = "";
  r10 ? (d4 = r10.reduce((o2, u4) => {
    const l2 = o2 && ` ${o2}`;
    return o2 = `${u4}${l2}`, o2;
  }, ""), s5 = "AuthenticateToServiceConditionAdvice") : a5 && (d4 = a5.reduce((o2, u4) => {
    const l2 = o2 && ` ${o2}`;
    return o2 = `${u4}${l2}`, o2;
  }, ""), s5 = "TransactionConditionAdvice");
  const v = "<Advices><AttributeValuePair>", h2 = `<Attribute name="${s5}"/>`, T3 = `<Value>${d4}</Value>`, f3 = `${v}${h2}${T3}</AttributeValuePair></Advices>`, p4 = h$1("authenticate", i9, c5), m = {
    authIndexType: "composite_advice",
    authIndexValue: f3
  };
  return {
    init: {
      method: "POST",
      credentials: "include",
      headers: new Headers({
        "Accept-API-Version": "resource=2.0, protocol=1.0"
      })
    },
    timeout: n2,
    url: f$3(t3, `${p4}?${$$1(m)}`)
  };
}
function H(e2) {
  return (e2.headers.get("Content-Type") || "").includes("html") && e2.url.includes("composite_advice");
}
function L(e2) {
  return (e2.get("WWW-Authenticate") || "").includes("advices");
}
async function w(e2) {
  return !!(await e2.clone().json()).advices;
}
function A(e2) {
  const n2 = new URL(e2).searchParams.get("authIndexValue") || "", i9 = new DOMParser(), c5 = decodeURIComponent(n2), a5 = i9.parseFromString(c5, "application/xml").querySelector("Value");
  return a5 ? a5.innerHTML : "";
}
function V(e2) {
  const n2 = (e2.split(",") || []).find((c5) => c5.includes("advices")) || "";
  let i9;
  try {
    const c5 = n2.match(/"(\S+)"/), r10 = c5 ? c5[1] : "", a5 = atob(r10);
    return i9 = JSON.parse(a5), i9;
  } catch (e3) {
    t2.error("Could not parse advices value from WWW-Authenticate header");
  }
  return {};
}
function z$1(e2) {
  return e2.advices && e2.advices.AuthenticateToServiceConditionAdvice ? Array.isArray(e2.advices.AuthenticateToServiceConditionAdvice) && e2.advices.AuthenticateToServiceConditionAdvice.length > 0 : e2.advices && e2.advices.TransactionConditionAdvice ? Array.isArray(e2.advices.TransactionConditionAdvice) && e2.advices.TransactionConditionAdvice.length > 0 : false;
}
async function F(e2) {
  return !!(await e2.clone().json()).callbacks;
}
function O2(e2, t3) {
  return typeof t3 == "function" ? t3(e2) : e2.status === 401;
}
function U(e2) {
  const t3 = {};
  return e2.url.includes("AuthenticateToServiceConditionAdvice") ? t3.AuthenticateToServiceConditionAdvice = [A(e2.url)] : t3.TransactionConditionAdvice = [A(e2.url)], {
    resource: "",
    actions: {},
    attributes: {},
    advices: t3,
    ttl: 0
  };
}
function J2(e2) {
  const t3 = e2.headers.get("WWW-Authenticate") || "", n2 = V(t3);
  return {
    resource: "",
    actions: {},
    attributes: {},
    advices: n2,
    ttl: 0
  };
}
async function N(e2) {
  return await e2.json();
}
var D = class {
  /**
   * Makes a request using the specified options.
   *
   * @param options The options to use when making the request
   */
  static async request(e2) {
    let r10 = await this._request(e2, false), t3, a5 = false;
    if (O2(r10, e2.requiresNewToken) && (r10 = await this._request(e2, true)), e2.authorization && e2.authorization.handleStep)
      if (r10.status === 401 && L(r10.headers) ? (a5 = true, t3 = J2(r10)) : r10.redirected && H(r10) ? (a5 = true, t3 = U(r10)) : await w(r10) && (t3 = await N(r10)), t3 && t3.advices) {
        const { middleware: n2, realmPath: i9, serverConfig: o2 } = c$3.get(e2.authorization.config), s5 = b2(
          t3,
          o2.baseUrl,
          e2.timeout,
          i9,
          o2.paths
        ), c5 = new URL(s5.url), u4 = c5.searchParams.get("authIndexType"), m = c5.searchParams.get("authIndexValue"), w2 = f$4(
          {
            url: new URL(s5.url),
            init: s5.init
          },
          {
            type: e$2.StartAuthenticate,
            payload: { type: u4, tree: m }
          }
        ), { url: p4, init: A2 } = w2(n2);
        s5.url = p4.toString(), s5.init = A2;
        const h2 = await this._request(s5, false);
        if (!await F(h2))
          throw new Error('Error: Initial response from auth server not a "step".');
        if (!z$1(t3))
          throw new Error("Error: Transactional or Service Advice is empty.");
        await this.stepIterator(h2, e2.authorization.handleStep);
        const l2 = await d$1.get();
        a5 ? e2.url = W(e2.url, t3.advices, l2) : e2.init.headers = P(
          e2.init,
          t3.advices,
          l2
        ), r10 = await this._request(e2, false);
      } else
        throw new Error("Error: Unable to process advice");
    return r10;
  }
  static async setAuthHeaders(e2, r10) {
    let t3 = await d$1.get();
    return t3 && t3.accessToken && (t3 = await T$2.getTokens({ forceRenew: r10 }), t3 && t3.accessToken && e2.set("Authorization", `Bearer ${t3.accessToken}`)), e2;
  }
  static async stepIterator(e2, r10) {
    const t3 = await e2.json(), a5 = new i$4(t3);
    return new Promise(async (n2, i9) => {
      async function o2(s5) {
        const c5 = await r10(s5), u4 = await f$1.next(c5, { tree: "", type: "" });
        u4.type === r$a.LoginSuccess ? n2() : u4.type === r$a.LoginFailure ? i9("Authentication tree failure.") : o2(u4);
      }
      o2(a5);
    });
  }
  static async _request(e2, r10) {
    const { url: t3, init: a5, timeout: n2 } = e2;
    let i9 = new Headers(a5.headers || {});
    return e2.authorization && i9.set("x-authenticate-response", "header"), e2.bypassAuthentication || (i9 = await this.setAuthHeaders(i9, r10)), a5.headers = i9, T$3(fetch(t3, a5), n2);
  }
};
var a4 = class {
  /**
   * Gets the current user's profile.
   */
  static getCurrentUser(e2) {
    return b$1.getUserInfo(e2);
  }
};
var e = class {
  /**
   * @method getData - Method to get the device data
   * @returns {Promise<string>} - Returns the device data
   */
  static async getData() {
    return await window._pingOneSignals.getData();
  }
  /**
   * @method start - Method to initialize and start the PingOne Signals SDK
   * @param {InitParams} options - The init parameters
   * @returns {Promise<void>} - Returns a promise
   */
  static async start(a5) {
    try {
      await Promise.resolve().then(function() {
        return index3;
      });
    } catch (i9) {
      console.error("error loading ping signals", i9);
    }
    await window._pingOneSignals.init(a5), a5.behavioralDataCollection === true && window._pingOneSignals.resumeBehavioralData();
  }
  /**
   * @method pauseBehavioralData - Method to pause the behavioral data collection
   * @returns {void}
   * @description Pause the behavioral data collection only; device profile data will still be collected
   */
  static pauseBehavioralData() {
    window._pingOneSignals.pauseBehavioralData();
  }
  /**
   * @method resumeBehavioralData - Method to resume the behavioral data collection
   * @returns {void}
   * @description Resume the behavioral data collection
   */
  static resumeBehavioralData() {
    window._pingOneSignals.resumeBehavioralData();
  }
};
function logErrorAndThrow(type) {
  if (type === "missingStores") {
    const errorMessage = "Error: missing configuration.";
    console.error(errorMessage);
    console.error("Please configure Widget by importing `configuration` and calling `set` with your settings.");
    throw new Error(errorMessage);
  } else if (type === "missingBaseUrl") {
    const errorMessage = "Error: missing `serverConfig.baseUrl`.";
    console.error(errorMessage);
    console.error("Please configure Widget by importing `configuration` and calling `set` with your ForgeRock server URL.");
    throw new Error(errorMessage);
  }
}
var util$2;
(function(util2) {
  util2.assertEqual = (val) => val;
  function assertIs(_arg) {
  }
  util2.assertIs = assertIs;
  function assertNever(_x) {
    throw new Error();
  }
  util2.assertNever = assertNever;
  util2.arrayToEnum = (items) => {
    const obj = {};
    for (const item of items) {
      obj[item] = item;
    }
    return obj;
  };
  util2.getValidEnumValues = (obj) => {
    const validKeys = util2.objectKeys(obj).filter((k2) => typeof obj[obj[k2]] !== "number");
    const filtered = {};
    for (const k2 of validKeys) {
      filtered[k2] = obj[k2];
    }
    return util2.objectValues(filtered);
  };
  util2.objectValues = (obj) => {
    return util2.objectKeys(obj).map(function(e2) {
      return obj[e2];
    });
  };
  util2.objectKeys = typeof Object.keys === "function" ? (obj) => Object.keys(obj) : (object) => {
    const keys = [];
    for (const key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        keys.push(key);
      }
    }
    return keys;
  };
  util2.find = (arr, checker) => {
    for (const item of arr) {
      if (checker(item))
        return item;
    }
    return void 0;
  };
  util2.isInteger = typeof Number.isInteger === "function" ? (val) => Number.isInteger(val) : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
  function joinValues(array, separator = " | ") {
    return array.map((val) => typeof val === "string" ? `'${val}'` : val).join(separator);
  }
  util2.joinValues = joinValues;
  util2.jsonStringifyReplacer = (_2, value) => {
    if (typeof value === "bigint") {
      return value.toString();
    }
    return value;
  };
})(util$2 || (util$2 = {}));
var objectUtil;
(function(objectUtil2) {
  objectUtil2.mergeShapes = (first, second) => {
    return __spreadValues(__spreadValues({}, first), second);
  };
})(objectUtil || (objectUtil = {}));
var ZodParsedType = util$2.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]);
var getParsedType = (data) => {
  const t3 = typeof data;
  switch (t3) {
    case "undefined":
      return ZodParsedType.undefined;
    case "string":
      return ZodParsedType.string;
    case "number":
      return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
    case "boolean":
      return ZodParsedType.boolean;
    case "function":
      return ZodParsedType.function;
    case "bigint":
      return ZodParsedType.bigint;
    case "symbol":
      return ZodParsedType.symbol;
    case "object":
      if (Array.isArray(data)) {
        return ZodParsedType.array;
      }
      if (data === null) {
        return ZodParsedType.null;
      }
      if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
        return ZodParsedType.promise;
      }
      if (typeof Map !== "undefined" && data instanceof Map) {
        return ZodParsedType.map;
      }
      if (typeof Set !== "undefined" && data instanceof Set) {
        return ZodParsedType.set;
      }
      if (typeof Date !== "undefined" && data instanceof Date) {
        return ZodParsedType.date;
      }
      return ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
};
var ZodIssueCode = util$2.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
var quotelessJson = (obj) => {
  const json = JSON.stringify(obj, null, 2);
  return json.replace(/"([^"]+)":/g, "$1:");
};
var ZodError = class extends Error {
  constructor(issues) {
    super();
    this.issues = [];
    this.addIssue = (sub) => {
      this.issues = [...this.issues, sub];
    };
    this.addIssues = (subs = []) => {
      this.issues = [...this.issues, ...subs];
    };
    const actualProto = new.target.prototype;
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(this, actualProto);
    } else {
      this.__proto__ = actualProto;
    }
    this.name = "ZodError";
    this.issues = issues;
  }
  get errors() {
    return this.issues;
  }
  format(_mapper) {
    const mapper = _mapper || function(issue) {
      return issue.message;
    };
    const fieldErrors = { _errors: [] };
    const processError = (error) => {
      for (const issue of error.issues) {
        if (issue.code === "invalid_union") {
          issue.unionErrors.map(processError);
        } else if (issue.code === "invalid_return_type") {
          processError(issue.returnTypeError);
        } else if (issue.code === "invalid_arguments") {
          processError(issue.argumentsError);
        } else if (issue.path.length === 0) {
          fieldErrors._errors.push(mapper(issue));
        } else {
          let curr = fieldErrors;
          let i9 = 0;
          while (i9 < issue.path.length) {
            const el = issue.path[i9];
            const terminal = i9 === issue.path.length - 1;
            if (!terminal) {
              curr[el] = curr[el] || { _errors: [] };
            } else {
              curr[el] = curr[el] || { _errors: [] };
              curr[el]._errors.push(mapper(issue));
            }
            curr = curr[el];
            i9++;
          }
        }
      }
    };
    processError(this);
    return fieldErrors;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, util$2.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(mapper = (issue) => issue.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub of this.issues) {
      if (sub.path.length > 0) {
        fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
        fieldErrors[sub.path[0]].push(mapper(sub));
      } else {
        formErrors.push(mapper(sub));
      }
    }
    return { formErrors, fieldErrors };
  }
  get formErrors() {
    return this.flatten();
  }
};
ZodError.create = (issues) => {
  const error = new ZodError(issues);
  return error;
};
var errorMap = (issue, _ctx) => {
  let message;
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === ZodParsedType.undefined) {
        message = "Required";
      } else {
        message = `Expected ${issue.expected}, received ${issue.received}`;
      }
      break;
    case ZodIssueCode.invalid_literal:
      message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util$2.jsonStringifyReplacer)}`;
      break;
    case ZodIssueCode.unrecognized_keys:
      message = `Unrecognized key(s) in object: ${util$2.joinValues(issue.keys, ", ")}`;
      break;
    case ZodIssueCode.invalid_union:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_union_discriminator:
      message = `Invalid discriminator value. Expected ${util$2.joinValues(issue.options)}`;
      break;
    case ZodIssueCode.invalid_enum_value:
      message = `Invalid enum value. Expected ${util$2.joinValues(issue.options)}, received '${issue.received}'`;
      break;
    case ZodIssueCode.invalid_arguments:
      message = `Invalid function arguments`;
      break;
    case ZodIssueCode.invalid_return_type:
      message = `Invalid function return type`;
      break;
    case ZodIssueCode.invalid_date:
      message = `Invalid date`;
      break;
    case ZodIssueCode.invalid_string:
      if (typeof issue.validation === "object") {
        if ("includes" in issue.validation) {
          message = `Invalid input: must include "${issue.validation.includes}"`;
          if (typeof issue.validation.position === "number") {
            message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
          }
        } else if ("startsWith" in issue.validation) {
          message = `Invalid input: must start with "${issue.validation.startsWith}"`;
        } else if ("endsWith" in issue.validation) {
          message = `Invalid input: must end with "${issue.validation.endsWith}"`;
        } else {
          util$2.assertNever(issue.validation);
        }
      } else if (issue.validation !== "regex") {
        message = `Invalid ${issue.validation}`;
      } else {
        message = "Invalid";
      }
      break;
    case ZodIssueCode.too_small:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.too_big:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "bigint")
        message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.custom:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_intersection_types:
      message = `Intersection results could not be merged`;
      break;
    case ZodIssueCode.not_multiple_of:
      message = `Number must be a multiple of ${issue.multipleOf}`;
      break;
    case ZodIssueCode.not_finite:
      message = "Number must be finite";
      break;
    default:
      message = _ctx.defaultError;
      util$2.assertNever(issue);
  }
  return { message };
};
var overrideErrorMap = errorMap;
function setErrorMap(map) {
  overrideErrorMap = map;
}
function getErrorMap() {
  return overrideErrorMap;
}
var makeIssue = (params) => {
  const { data, path, errorMaps, issueData } = params;
  const fullPath = [...path, ...issueData.path || []];
  const fullIssue = __spreadProps(__spreadValues({}, issueData), {
    path: fullPath
  });
  let errorMessage = "";
  const maps = errorMaps.filter((m) => !!m).slice().reverse();
  for (const map of maps) {
    errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
  }
  return __spreadProps(__spreadValues({}, issueData), {
    path: fullPath,
    message: issueData.message || errorMessage
  });
};
var EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
  const issue = makeIssue({
    issueData,
    data: ctx.data,
    path: ctx.path,
    errorMaps: [
      ctx.common.contextualErrorMap,
      ctx.schemaErrorMap,
      getErrorMap(),
      errorMap
      // then global default map
    ].filter((x) => !!x)
  });
  ctx.common.issues.push(issue);
}
var ParseStatus = class _ParseStatus {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    if (this.value === "valid")
      this.value = "dirty";
  }
  abort() {
    if (this.value !== "aborted")
      this.value = "aborted";
  }
  static mergeArray(status, results) {
    const arrayValue = [];
    for (const s5 of results) {
      if (s5.status === "aborted")
        return INVALID;
      if (s5.status === "dirty")
        status.dirty();
      arrayValue.push(s5.value);
    }
    return { status: status.value, value: arrayValue };
  }
  static async mergeObjectAsync(status, pairs) {
    const syncPairs = [];
    for (const pair of pairs) {
      syncPairs.push({
        key: await pair.key,
        value: await pair.value
      });
    }
    return _ParseStatus.mergeObjectSync(status, syncPairs);
  }
  static mergeObjectSync(status, pairs) {
    const finalObject = {};
    for (const pair of pairs) {
      const { key, value } = pair;
      if (key.status === "aborted")
        return INVALID;
      if (value.status === "aborted")
        return INVALID;
      if (key.status === "dirty")
        status.dirty();
      if (value.status === "dirty")
        status.dirty();
      if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) {
        finalObject[key.value] = value.value;
      }
    }
    return { status: status.value, value: finalObject };
  }
};
var INVALID = Object.freeze({
  status: "aborted"
});
var DIRTY = (value) => ({ status: "dirty", value });
var OK = (value) => ({ status: "valid", value });
var isAborted = (x) => x.status === "aborted";
var isDirty = (x) => x.status === "dirty";
var isValid = (x) => x.status === "valid";
var isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;
var errorUtil;
(function(errorUtil2) {
  errorUtil2.errToObj = (message) => typeof message === "string" ? { message } : message || {};
  errorUtil2.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));
var ParseInputLazyPath = class {
  constructor(parent, value, path, key) {
    this._cachedPath = [];
    this.parent = parent;
    this.data = value;
    this._path = path;
    this._key = key;
  }
  get path() {
    if (!this._cachedPath.length) {
      if (this._key instanceof Array) {
        this._cachedPath.push(...this._path, ...this._key);
      } else {
        this._cachedPath.push(...this._path, this._key);
      }
    }
    return this._cachedPath;
  }
};
var handleResult = (ctx, result) => {
  if (isValid(result)) {
    return { success: true, data: result.value };
  } else {
    if (!ctx.common.issues.length) {
      throw new Error("Validation failed but no issues detected.");
    }
    return {
      success: false,
      get error() {
        if (this._error)
          return this._error;
        const error = new ZodError(ctx.common.issues);
        this._error = error;
        return this._error;
      }
    };
  }
};
function processCreateParams(params) {
  if (!params)
    return {};
  const { errorMap: errorMap2, invalid_type_error, required_error, description } = params;
  if (errorMap2 && (invalid_type_error || required_error)) {
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  }
  if (errorMap2)
    return { errorMap: errorMap2, description };
  const customMap = (iss, ctx) => {
    if (iss.code !== "invalid_type")
      return { message: ctx.defaultError };
    if (typeof ctx.data === "undefined") {
      return { message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError };
    }
    return { message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError };
  };
  return { errorMap: customMap, description };
}
var ZodType = class {
  constructor(def) {
    this.spa = this.safeParseAsync;
    this._def = def;
    this.parse = this.parse.bind(this);
    this.safeParse = this.safeParse.bind(this);
    this.parseAsync = this.parseAsync.bind(this);
    this.safeParseAsync = this.safeParseAsync.bind(this);
    this.spa = this.spa.bind(this);
    this.refine = this.refine.bind(this);
    this.refinement = this.refinement.bind(this);
    this.superRefine = this.superRefine.bind(this);
    this.optional = this.optional.bind(this);
    this.nullable = this.nullable.bind(this);
    this.nullish = this.nullish.bind(this);
    this.array = this.array.bind(this);
    this.promise = this.promise.bind(this);
    this.or = this.or.bind(this);
    this.and = this.and.bind(this);
    this.transform = this.transform.bind(this);
    this.brand = this.brand.bind(this);
    this.default = this.default.bind(this);
    this.catch = this.catch.bind(this);
    this.describe = this.describe.bind(this);
    this.pipe = this.pipe.bind(this);
    this.readonly = this.readonly.bind(this);
    this.isNullable = this.isNullable.bind(this);
    this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(input) {
    return getParsedType(input.data);
  }
  _getOrReturnCtx(input, ctx) {
    return ctx || {
      common: input.parent.common,
      data: input.data,
      parsedType: getParsedType(input.data),
      schemaErrorMap: this._def.errorMap,
      path: input.path,
      parent: input.parent
    };
  }
  _processInputParams(input) {
    return {
      status: new ParseStatus(),
      ctx: {
        common: input.parent.common,
        data: input.data,
        parsedType: getParsedType(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent
      }
    };
  }
  _parseSync(input) {
    const result = this._parse(input);
    if (isAsync(result)) {
      throw new Error("Synchronous parse encountered promise.");
    }
    return result;
  }
  _parseAsync(input) {
    const result = this._parse(input);
    return Promise.resolve(result);
  }
  parse(data, params) {
    const result = this.safeParse(data, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  safeParse(data, params) {
    var _a;
    const ctx = {
      common: {
        issues: [],
        async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
      },
      path: (params === null || params === void 0 ? void 0 : params.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    const result = this._parseSync({ data, path: ctx.path, parent: ctx });
    return handleResult(ctx, result);
  }
  async parseAsync(data, params) {
    const result = await this.safeParseAsync(data, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  async safeParseAsync(data, params) {
    const ctx = {
      common: {
        issues: [],
        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
        async: true
      },
      path: (params === null || params === void 0 ? void 0 : params.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
    const result = await (isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
    return handleResult(ctx, result);
  }
  refine(check, message) {
    const getIssueProperties = (val) => {
      if (typeof message === "string" || typeof message === "undefined") {
        return { message };
      } else if (typeof message === "function") {
        return message(val);
      } else {
        return message;
      }
    };
    return this._refinement((val, ctx) => {
      const result = check(val);
      const setError = () => ctx.addIssue(__spreadValues({
        code: ZodIssueCode.custom
      }, getIssueProperties(val)));
      if (typeof Promise !== "undefined" && result instanceof Promise) {
        return result.then((data) => {
          if (!data) {
            setError();
            return false;
          } else {
            return true;
          }
        });
      }
      if (!result) {
        setError();
        return false;
      } else {
        return true;
      }
    });
  }
  refinement(check, refinementData) {
    return this._refinement((val, ctx) => {
      if (!check(val)) {
        ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
        return false;
      } else {
        return true;
      }
    });
  }
  _refinement(refinement) {
    return new ZodEffects({
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "refinement", refinement }
    });
  }
  superRefine(refinement) {
    return this._refinement(refinement);
  }
  optional() {
    return ZodOptional.create(this, this._def);
  }
  nullable() {
    return ZodNullable.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ZodArray.create(this, this._def);
  }
  promise() {
    return ZodPromise.create(this, this._def);
  }
  or(option) {
    return ZodUnion.create([this, option], this._def);
  }
  and(incoming) {
    return ZodIntersection.create(this, incoming, this._def);
  }
  transform(transform) {
    return new ZodEffects(__spreadProps(__spreadValues({}, processCreateParams(this._def)), {
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "transform", transform }
    }));
  }
  default(def) {
    const defaultValueFunc = typeof def === "function" ? def : () => def;
    return new ZodDefault(__spreadProps(__spreadValues({}, processCreateParams(this._def)), {
      innerType: this,
      defaultValue: defaultValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodDefault
    }));
  }
  brand() {
    return new ZodBranded(__spreadValues({
      typeName: ZodFirstPartyTypeKind.ZodBranded,
      type: this
    }, processCreateParams(this._def)));
  }
  catch(def) {
    const catchValueFunc = typeof def === "function" ? def : () => def;
    return new ZodCatch(__spreadProps(__spreadValues({}, processCreateParams(this._def)), {
      innerType: this,
      catchValue: catchValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodCatch
    }));
  }
  describe(description) {
    const This = this.constructor;
    return new This(__spreadProps(__spreadValues({}, this._def), {
      description
    }));
  }
  pipe(target) {
    return ZodPipeline.create(this, target);
  }
  readonly() {
    return ZodReadonly.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
var cuidRegex = /^c[^\s-]{8,}$/i;
var cuid2Regex = /^[a-z][a-z0-9]*$/;
var ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
var uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
var emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
var _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
var emojiRegex;
var ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
var ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
var datetimeRegex = (args) => {
  if (args.precision) {
    if (args.offset) {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
    } else {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    }
  } else if (args.precision === 0) {
    if (args.offset) {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
    } else {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    }
  } else {
    if (args.offset) {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
    } else {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
  }
};
function isValidIP(ip, version2) {
  if ((version2 === "v4" || !version2) && ipv4Regex.test(ip)) {
    return true;
  }
  if ((version2 === "v6" || !version2) && ipv6Regex.test(ip)) {
    return true;
  }
  return false;
}
var ZodString = class _ZodString extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = String(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.string) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(
        ctx2,
        {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.string,
          received: ctx2.parsedType
        }
        //
      );
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.length < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.length > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "length") {
        const tooBig = input.data.length > check.value;
        const tooSmall = input.data.length < check.value;
        if (tooBig || tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          if (tooBig) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              maximum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          } else if (tooSmall) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              minimum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          }
          status.dirty();
        }
      } else if (check.kind === "email") {
        if (!emailRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "email",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "emoji") {
        if (!emojiRegex) {
          emojiRegex = new RegExp(_emojiRegex, "u");
        }
        if (!emojiRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "emoji",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "uuid") {
        if (!uuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "uuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid") {
        if (!cuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid2") {
        if (!cuid2Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid2",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ulid") {
        if (!ulidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ulid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "url") {
        try {
          new URL(input.data);
        } catch (_a) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "url",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "regex") {
        check.regex.lastIndex = 0;
        const testResult = check.regex.test(input.data);
        if (!testResult) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "regex",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "trim") {
        input.data = input.data.trim();
      } else if (check.kind === "includes") {
        if (!input.data.includes(check.value, check.position)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { includes: check.value, position: check.position },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "toLowerCase") {
        input.data = input.data.toLowerCase();
      } else if (check.kind === "toUpperCase") {
        input.data = input.data.toUpperCase();
      } else if (check.kind === "startsWith") {
        if (!input.data.startsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { startsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "endsWith") {
        if (!input.data.endsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { endsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "datetime") {
        const regex2 = datetimeRegex(check);
        if (!regex2.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "datetime",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ip") {
        if (!isValidIP(input.data, check.version)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ip",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util$2.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  _regex(regex2, validation, message) {
    return this.refinement((data) => regex2.test(data), __spreadValues({
      validation,
      code: ZodIssueCode.invalid_string
    }, errorUtil.errToObj(message)));
  }
  _addCheck(check) {
    return new _ZodString(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, check]
    }));
  }
  email(message) {
    return this._addCheck(__spreadValues({ kind: "email" }, errorUtil.errToObj(message)));
  }
  url(message) {
    return this._addCheck(__spreadValues({ kind: "url" }, errorUtil.errToObj(message)));
  }
  emoji(message) {
    return this._addCheck(__spreadValues({ kind: "emoji" }, errorUtil.errToObj(message)));
  }
  uuid(message) {
    return this._addCheck(__spreadValues({ kind: "uuid" }, errorUtil.errToObj(message)));
  }
  cuid(message) {
    return this._addCheck(__spreadValues({ kind: "cuid" }, errorUtil.errToObj(message)));
  }
  cuid2(message) {
    return this._addCheck(__spreadValues({ kind: "cuid2" }, errorUtil.errToObj(message)));
  }
  ulid(message) {
    return this._addCheck(__spreadValues({ kind: "ulid" }, errorUtil.errToObj(message)));
  }
  ip(options) {
    return this._addCheck(__spreadValues({ kind: "ip" }, errorUtil.errToObj(options)));
  }
  datetime(options) {
    var _a;
    if (typeof options === "string") {
      return this._addCheck({
        kind: "datetime",
        precision: null,
        offset: false,
        message: options
      });
    }
    return this._addCheck(__spreadValues({
      kind: "datetime",
      precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
      offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false
    }, errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
  }
  regex(regex2, message) {
    return this._addCheck(__spreadValues({
      kind: "regex",
      regex: regex2
    }, errorUtil.errToObj(message)));
  }
  includes(value, options) {
    return this._addCheck(__spreadValues({
      kind: "includes",
      value,
      position: options === null || options === void 0 ? void 0 : options.position
    }, errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
  }
  startsWith(value, message) {
    return this._addCheck(__spreadValues({
      kind: "startsWith",
      value
    }, errorUtil.errToObj(message)));
  }
  endsWith(value, message) {
    return this._addCheck(__spreadValues({
      kind: "endsWith",
      value
    }, errorUtil.errToObj(message)));
  }
  min(minLength, message) {
    return this._addCheck(__spreadValues({
      kind: "min",
      value: minLength
    }, errorUtil.errToObj(message)));
  }
  max(maxLength, message) {
    return this._addCheck(__spreadValues({
      kind: "max",
      value: maxLength
    }, errorUtil.errToObj(message)));
  }
  length(len, message) {
    return this._addCheck(__spreadValues({
      kind: "length",
      value: len
    }, errorUtil.errToObj(message)));
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(message) {
    return this.min(1, errorUtil.errToObj(message));
  }
  trim() {
    return new _ZodString(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, { kind: "trim" }]
    }));
  }
  toLowerCase() {
    return new _ZodString(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    }));
  }
  toUpperCase() {
    return new _ZodString(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    }));
  }
  get isDatetime() {
    return !!this._def.checks.find((ch) => ch.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((ch) => ch.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((ch) => ch.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((ch) => ch.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((ch) => ch.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((ch) => ch.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((ch) => ch.kind === "ip");
  }
  get minLength() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxLength() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
};
ZodString.create = (params) => {
  var _a;
  return new ZodString(__spreadValues({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString,
    coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
  }, processCreateParams(params)));
};
function floatSafeRemainder(val, step) {
  const valDecCount = (val.toString().split(".")[1] || "").length;
  const stepDecCount = (step.toString().split(".")[1] || "").length;
  const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
  const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
  return valInt % stepInt / Math.pow(10, decCount);
}
var ZodNumber = class _ZodNumber extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
    this.step = this.multipleOf;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = Number(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.number) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.number,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "int") {
        if (!util$2.isInteger(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: "integer",
            received: "float",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (floatSafeRemainder(input.data, check.value) !== 0) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "finite") {
        if (!Number.isFinite(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_finite,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util$2.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new _ZodNumber(__spreadProps(__spreadValues({}, this._def), {
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    }));
  }
  _addCheck(check) {
    return new _ZodNumber(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, check]
    }));
  }
  int(message) {
    return this._addCheck({
      kind: "int",
      message: errorUtil.toString(message)
    });
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  finite(message) {
    return this._addCheck({
      kind: "finite",
      message: errorUtil.toString(message)
    });
  }
  safe(message) {
    return this._addCheck({
      kind: "min",
      inclusive: true,
      value: Number.MIN_SAFE_INTEGER,
      message: errorUtil.toString(message)
    })._addCheck({
      kind: "max",
      inclusive: true,
      value: Number.MAX_SAFE_INTEGER,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
  get isInt() {
    return !!this._def.checks.find((ch) => ch.kind === "int" || ch.kind === "multipleOf" && util$2.isInteger(ch.value));
  }
  get isFinite() {
    let max = null, min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") {
        return true;
      } else if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      } else if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return Number.isFinite(min) && Number.isFinite(max);
  }
};
ZodNumber.create = (params) => {
  return new ZodNumber(__spreadValues({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodNumber,
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
  }, processCreateParams(params)));
};
var ZodBigInt = class _ZodBigInt extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = BigInt(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.bigint) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.bigint,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            type: "bigint",
            minimum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            type: "bigint",
            maximum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (input.data % check.value !== BigInt(0)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util$2.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new _ZodBigInt(__spreadProps(__spreadValues({}, this._def), {
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    }));
  }
  _addCheck(check) {
    return new _ZodBigInt(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, check]
    }));
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
};
ZodBigInt.create = (params) => {
  var _a;
  return new ZodBigInt(__spreadValues({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodBigInt,
    coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
  }, processCreateParams(params)));
};
var ZodBoolean = class extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = Boolean(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.boolean) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.boolean,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodBoolean.create = (params) => {
  return new ZodBoolean(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodBoolean,
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
  }, processCreateParams(params)));
};
var ZodDate = class _ZodDate extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = new Date(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.date) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.date,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    if (isNaN(input.data.getTime())) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_date
      });
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.getTime() < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            message: check.message,
            inclusive: true,
            exact: false,
            minimum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.getTime() > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            message: check.message,
            inclusive: true,
            exact: false,
            maximum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else {
        util$2.assertNever(check);
      }
    }
    return {
      status: status.value,
      value: new Date(input.data.getTime())
    };
  }
  _addCheck(check) {
    return new _ZodDate(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, check]
    }));
  }
  min(minDate, message) {
    return this._addCheck({
      kind: "min",
      value: minDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  max(maxDate, message) {
    return this._addCheck({
      kind: "max",
      value: maxDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  get minDate() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min != null ? new Date(min) : null;
  }
  get maxDate() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max != null ? new Date(max) : null;
  }
};
ZodDate.create = (params) => {
  return new ZodDate(__spreadValues({
    checks: [],
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
    typeName: ZodFirstPartyTypeKind.ZodDate
  }, processCreateParams(params)));
};
var ZodSymbol = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.symbol) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.symbol,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodSymbol.create = (params) => {
  return new ZodSymbol(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodSymbol
  }, processCreateParams(params)));
};
var ZodUndefined = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.undefined,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodUndefined.create = (params) => {
  return new ZodUndefined(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodUndefined
  }, processCreateParams(params)));
};
var ZodNull = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.null) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.null,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodNull.create = (params) => {
  return new ZodNull(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodNull
  }, processCreateParams(params)));
};
var ZodAny = class extends ZodType {
  constructor() {
    super(...arguments);
    this._any = true;
  }
  _parse(input) {
    return OK(input.data);
  }
};
ZodAny.create = (params) => {
  return new ZodAny(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodAny
  }, processCreateParams(params)));
};
var ZodUnknown = class extends ZodType {
  constructor() {
    super(...arguments);
    this._unknown = true;
  }
  _parse(input) {
    return OK(input.data);
  }
};
ZodUnknown.create = (params) => {
  return new ZodUnknown(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodUnknown
  }, processCreateParams(params)));
};
var ZodNever = class extends ZodType {
  _parse(input) {
    const ctx = this._getOrReturnCtx(input);
    addIssueToContext(ctx, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.never,
      received: ctx.parsedType
    });
    return INVALID;
  }
};
ZodNever.create = (params) => {
  return new ZodNever(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodNever
  }, processCreateParams(params)));
};
var ZodVoid = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.void,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodVoid.create = (params) => {
  return new ZodVoid(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodVoid
  }, processCreateParams(params)));
};
var ZodArray = class _ZodArray extends ZodType {
  _parse(input) {
    const { ctx, status } = this._processInputParams(input);
    const def = this._def;
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (def.exactLength !== null) {
      const tooBig = ctx.data.length > def.exactLength.value;
      const tooSmall = ctx.data.length < def.exactLength.value;
      if (tooBig || tooSmall) {
        addIssueToContext(ctx, {
          code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
          minimum: tooSmall ? def.exactLength.value : void 0,
          maximum: tooBig ? def.exactLength.value : void 0,
          type: "array",
          inclusive: true,
          exact: true,
          message: def.exactLength.message
        });
        status.dirty();
      }
    }
    if (def.minLength !== null) {
      if (ctx.data.length < def.minLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.minLength.message
        });
        status.dirty();
      }
    }
    if (def.maxLength !== null) {
      if (ctx.data.length > def.maxLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.maxLength.message
        });
        status.dirty();
      }
    }
    if (ctx.common.async) {
      return Promise.all([...ctx.data].map((item, i9) => {
        return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i9));
      })).then((result2) => {
        return ParseStatus.mergeArray(status, result2);
      });
    }
    const result = [...ctx.data].map((item, i9) => {
      return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i9));
    });
    return ParseStatus.mergeArray(status, result);
  }
  get element() {
    return this._def.type;
  }
  min(minLength, message) {
    return new _ZodArray(__spreadProps(__spreadValues({}, this._def), {
      minLength: { value: minLength, message: errorUtil.toString(message) }
    }));
  }
  max(maxLength, message) {
    return new _ZodArray(__spreadProps(__spreadValues({}, this._def), {
      maxLength: { value: maxLength, message: errorUtil.toString(message) }
    }));
  }
  length(len, message) {
    return new _ZodArray(__spreadProps(__spreadValues({}, this._def), {
      exactLength: { value: len, message: errorUtil.toString(message) }
    }));
  }
  nonempty(message) {
    return this.min(1, message);
  }
};
ZodArray.create = (schema, params) => {
  return new ZodArray(__spreadValues({
    type: schema,
    minLength: null,
    maxLength: null,
    exactLength: null,
    typeName: ZodFirstPartyTypeKind.ZodArray
  }, processCreateParams(params)));
};
function deepPartialify(schema) {
  if (schema instanceof ZodObject) {
    const newShape = {};
    for (const key in schema.shape) {
      const fieldSchema = schema.shape[key];
      newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
    }
    return new ZodObject(__spreadProps(__spreadValues({}, schema._def), {
      shape: () => newShape
    }));
  } else if (schema instanceof ZodArray) {
    return new ZodArray(__spreadProps(__spreadValues({}, schema._def), {
      type: deepPartialify(schema.element)
    }));
  } else if (schema instanceof ZodOptional) {
    return ZodOptional.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodNullable) {
    return ZodNullable.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodTuple) {
    return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
  } else {
    return schema;
  }
}
var ZodObject = class _ZodObject extends ZodType {
  constructor() {
    super(...arguments);
    this._cached = null;
    this.nonstrict = this.passthrough;
    this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const shape = this._def.shape();
    const keys = util$2.objectKeys(shape);
    return this._cached = { shape, keys };
  }
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.object) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const { status, ctx } = this._processInputParams(input);
    const { shape, keys: shapeKeys } = this._getCached();
    const extraKeys = [];
    if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
      for (const key in ctx.data) {
        if (!shapeKeys.includes(key)) {
          extraKeys.push(key);
        }
      }
    }
    const pairs = [];
    for (const key of shapeKeys) {
      const keyValidator = shape[key];
      const value = ctx.data[key];
      pairs.push({
        key: { status: "valid", value: key },
        value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
        alwaysSet: key in ctx.data
      });
    }
    if (this._def.catchall instanceof ZodNever) {
      const unknownKeys = this._def.unknownKeys;
      if (unknownKeys === "passthrough") {
        for (const key of extraKeys) {
          pairs.push({
            key: { status: "valid", value: key },
            value: { status: "valid", value: ctx.data[key] }
          });
        }
      } else if (unknownKeys === "strict") {
        if (extraKeys.length > 0) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.unrecognized_keys,
            keys: extraKeys
          });
          status.dirty();
        }
      } else if (unknownKeys === "strip") ;
      else {
        throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
      }
    } else {
      const catchall = this._def.catchall;
      for (const key of extraKeys) {
        const value = ctx.data[key];
        pairs.push({
          key: { status: "valid", value: key },
          value: catchall._parse(
            new ParseInputLazyPath(ctx, value, ctx.path, key)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: key in ctx.data
        });
      }
    }
    if (ctx.common.async) {
      return Promise.resolve().then(async () => {
        const syncPairs = [];
        for (const pair of pairs) {
          const key = await pair.key;
          syncPairs.push({
            key,
            value: await pair.value,
            alwaysSet: pair.alwaysSet
          });
        }
        return syncPairs;
      }).then((syncPairs) => {
        return ParseStatus.mergeObjectSync(status, syncPairs);
      });
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get shape() {
    return this._def.shape();
  }
  strict(message) {
    errorUtil.errToObj;
    return new _ZodObject(__spreadValues(__spreadProps(__spreadValues({}, this._def), {
      unknownKeys: "strict"
    }), message !== void 0 ? {
      errorMap: (issue, ctx) => {
        var _a, _b, _c, _d;
        const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
        if (issue.code === "unrecognized_keys")
          return {
            message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
          };
        return {
          message: defaultError
        };
      }
    } : {}));
  }
  strip() {
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      unknownKeys: "strip"
    }));
  }
  passthrough() {
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      unknownKeys: "passthrough"
    }));
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(augmentation) {
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      shape: () => __spreadValues(__spreadValues({}, this._def.shape()), augmentation)
    }));
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(merging) {
    const merged = new _ZodObject({
      unknownKeys: merging._def.unknownKeys,
      catchall: merging._def.catchall,
      shape: () => __spreadValues(__spreadValues({}, this._def.shape()), merging._def.shape()),
      typeName: ZodFirstPartyTypeKind.ZodObject
    });
    return merged;
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(key, schema) {
    return this.augment({ [key]: schema });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(index) {
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      catchall: index
    }));
  }
  pick(mask) {
    const shape = {};
    util$2.objectKeys(mask).forEach((key) => {
      if (mask[key] && this.shape[key]) {
        shape[key] = this.shape[key];
      }
    });
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      shape: () => shape
    }));
  }
  omit(mask) {
    const shape = {};
    util$2.objectKeys(this.shape).forEach((key) => {
      if (!mask[key]) {
        shape[key] = this.shape[key];
      }
    });
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      shape: () => shape
    }));
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return deepPartialify(this);
  }
  partial(mask) {
    const newShape = {};
    util$2.objectKeys(this.shape).forEach((key) => {
      const fieldSchema = this.shape[key];
      if (mask && !mask[key]) {
        newShape[key] = fieldSchema;
      } else {
        newShape[key] = fieldSchema.optional();
      }
    });
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      shape: () => newShape
    }));
  }
  required(mask) {
    const newShape = {};
    util$2.objectKeys(this.shape).forEach((key) => {
      if (mask && !mask[key]) {
        newShape[key] = this.shape[key];
      } else {
        const fieldSchema = this.shape[key];
        let newField = fieldSchema;
        while (newField instanceof ZodOptional) {
          newField = newField._def.innerType;
        }
        newShape[key] = newField;
      }
    });
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      shape: () => newShape
    }));
  }
  keyof() {
    return createZodEnum(util$2.objectKeys(this.shape));
  }
};
ZodObject.create = (shape, params) => {
  return new ZodObject(__spreadValues({
    shape: () => shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject
  }, processCreateParams(params)));
};
ZodObject.strictCreate = (shape, params) => {
  return new ZodObject(__spreadValues({
    shape: () => shape,
    unknownKeys: "strict",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject
  }, processCreateParams(params)));
};
ZodObject.lazycreate = (shape, params) => {
  return new ZodObject(__spreadValues({
    shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject
  }, processCreateParams(params)));
};
var ZodUnion = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const options = this._def.options;
    function handleResults(results) {
      for (const result of results) {
        if (result.result.status === "valid") {
          return result.result;
        }
      }
      for (const result of results) {
        if (result.result.status === "dirty") {
          ctx.common.issues.push(...result.ctx.common.issues);
          return result.result;
        }
      }
      const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return Promise.all(options.map(async (option) => {
        const childCtx = __spreadProps(__spreadValues({}, ctx), {
          common: __spreadProps(__spreadValues({}, ctx.common), {
            issues: []
          }),
          parent: null
        });
        return {
          result: await option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: childCtx
          }),
          ctx: childCtx
        };
      })).then(handleResults);
    } else {
      let dirty = void 0;
      const issues = [];
      for (const option of options) {
        const childCtx = __spreadProps(__spreadValues({}, ctx), {
          common: __spreadProps(__spreadValues({}, ctx.common), {
            issues: []
          }),
          parent: null
        });
        const result = option._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: childCtx
        });
        if (result.status === "valid") {
          return result;
        } else if (result.status === "dirty" && !dirty) {
          dirty = { result, ctx: childCtx };
        }
        if (childCtx.common.issues.length) {
          issues.push(childCtx.common.issues);
        }
      }
      if (dirty) {
        ctx.common.issues.push(...dirty.ctx.common.issues);
        return dirty.result;
      }
      const unionErrors = issues.map((issues2) => new ZodError(issues2));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
  }
  get options() {
    return this._def.options;
  }
};
ZodUnion.create = (types, params) => {
  return new ZodUnion(__spreadValues({
    options: types,
    typeName: ZodFirstPartyTypeKind.ZodUnion
  }, processCreateParams(params)));
};
var getDiscriminator = (type) => {
  if (type instanceof ZodLazy) {
    return getDiscriminator(type.schema);
  } else if (type instanceof ZodEffects) {
    return getDiscriminator(type.innerType());
  } else if (type instanceof ZodLiteral) {
    return [type.value];
  } else if (type instanceof ZodEnum) {
    return type.options;
  } else if (type instanceof ZodNativeEnum) {
    return Object.keys(type.enum);
  } else if (type instanceof ZodDefault) {
    return getDiscriminator(type._def.innerType);
  } else if (type instanceof ZodUndefined) {
    return [void 0];
  } else if (type instanceof ZodNull) {
    return [null];
  } else {
    return null;
  }
};
var ZodDiscriminatedUnion = class _ZodDiscriminatedUnion extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const discriminator = this.discriminator;
    const discriminatorValue = ctx.data[discriminator];
    const option = this.optionsMap.get(discriminatorValue);
    if (!option) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union_discriminator,
        options: Array.from(this.optionsMap.keys()),
        path: [discriminator]
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return option._parseAsync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    } else {
      return option._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    }
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(discriminator, options, params) {
    const optionsMap = /* @__PURE__ */ new Map();
    for (const type of options) {
      const discriminatorValues = getDiscriminator(type.shape[discriminator]);
      if (!discriminatorValues) {
        throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
      }
      for (const value of discriminatorValues) {
        if (optionsMap.has(value)) {
          throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
        }
        optionsMap.set(value, type);
      }
    }
    return new _ZodDiscriminatedUnion(__spreadValues({
      typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
      discriminator,
      options,
      optionsMap
    }, processCreateParams(params)));
  }
};
function mergeValues(a5, b3) {
  const aType = getParsedType(a5);
  const bType = getParsedType(b3);
  if (a5 === b3) {
    return { valid: true, data: a5 };
  } else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
    const bKeys = util$2.objectKeys(b3);
    const sharedKeys = util$2.objectKeys(a5).filter((key) => bKeys.indexOf(key) !== -1);
    const newObj = __spreadValues(__spreadValues({}, a5), b3);
    for (const key of sharedKeys) {
      const sharedValue = mergeValues(a5[key], b3[key]);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newObj[key] = sharedValue.data;
    }
    return { valid: true, data: newObj };
  } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
    if (a5.length !== b3.length) {
      return { valid: false };
    }
    const newArray = [];
    for (let index = 0; index < a5.length; index++) {
      const itemA = a5[index];
      const itemB = b3[index];
      const sharedValue = mergeValues(itemA, itemB);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newArray.push(sharedValue.data);
    }
    return { valid: true, data: newArray };
  } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a5 === +b3) {
    return { valid: true, data: a5 };
  } else {
    return { valid: false };
  }
}
var ZodIntersection = class extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const handleParsed = (parsedLeft, parsedRight) => {
      if (isAborted(parsedLeft) || isAborted(parsedRight)) {
        return INVALID;
      }
      const merged = mergeValues(parsedLeft.value, parsedRight.value);
      if (!merged.valid) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_intersection_types
        });
        return INVALID;
      }
      if (isDirty(parsedLeft) || isDirty(parsedRight)) {
        status.dirty();
      }
      return { status: status.value, value: merged.data };
    };
    if (ctx.common.async) {
      return Promise.all([
        this._def.left._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }),
        this._def.right._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        })
      ]).then(([left, right]) => handleParsed(left, right));
    } else {
      return handleParsed(this._def.left._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }), this._def.right._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }));
    }
  }
};
ZodIntersection.create = (left, right, params) => {
  return new ZodIntersection(__spreadValues({
    left,
    right,
    typeName: ZodFirstPartyTypeKind.ZodIntersection
  }, processCreateParams(params)));
};
var ZodTuple = class _ZodTuple extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (ctx.data.length < this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_small,
        minimum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      return INVALID;
    }
    const rest = this._def.rest;
    if (!rest && ctx.data.length > this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_big,
        maximum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      status.dirty();
    }
    const items = [...ctx.data].map((item, itemIndex) => {
      const schema = this._def.items[itemIndex] || this._def.rest;
      if (!schema)
        return null;
      return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
    }).filter((x) => !!x);
    if (ctx.common.async) {
      return Promise.all(items).then((results) => {
        return ParseStatus.mergeArray(status, results);
      });
    } else {
      return ParseStatus.mergeArray(status, items);
    }
  }
  get items() {
    return this._def.items;
  }
  rest(rest) {
    return new _ZodTuple(__spreadProps(__spreadValues({}, this._def), {
      rest
    }));
  }
};
ZodTuple.create = (schemas, params) => {
  if (!Array.isArray(schemas)) {
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  }
  return new ZodTuple(__spreadValues({
    items: schemas,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null
  }, processCreateParams(params)));
};
var ZodRecord = class _ZodRecord extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const pairs = [];
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    for (const key in ctx.data) {
      pairs.push({
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
        value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
      });
    }
    if (ctx.common.async) {
      return ParseStatus.mergeObjectAsync(status, pairs);
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get element() {
    return this._def.valueType;
  }
  static create(first, second, third) {
    if (second instanceof ZodType) {
      return new _ZodRecord(__spreadValues({
        keyType: first,
        valueType: second,
        typeName: ZodFirstPartyTypeKind.ZodRecord
      }, processCreateParams(third)));
    }
    return new _ZodRecord(__spreadValues({
      keyType: ZodString.create(),
      valueType: first,
      typeName: ZodFirstPartyTypeKind.ZodRecord
    }, processCreateParams(second)));
  }
};
var ZodMap = class extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.map) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.map,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    const pairs = [...ctx.data.entries()].map(([key, value], index) => {
      return {
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
        value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"]))
      };
    });
    if (ctx.common.async) {
      const finalMap = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const pair of pairs) {
          const key = await pair.key;
          const value = await pair.value;
          if (key.status === "aborted" || value.status === "aborted") {
            return INVALID;
          }
          if (key.status === "dirty" || value.status === "dirty") {
            status.dirty();
          }
          finalMap.set(key.value, value.value);
        }
        return { status: status.value, value: finalMap };
      });
    } else {
      const finalMap = /* @__PURE__ */ new Map();
      for (const pair of pairs) {
        const key = pair.key;
        const value = pair.value;
        if (key.status === "aborted" || value.status === "aborted") {
          return INVALID;
        }
        if (key.status === "dirty" || value.status === "dirty") {
          status.dirty();
        }
        finalMap.set(key.value, value.value);
      }
      return { status: status.value, value: finalMap };
    }
  }
};
ZodMap.create = (keyType, valueType, params) => {
  return new ZodMap(__spreadValues({
    valueType,
    keyType,
    typeName: ZodFirstPartyTypeKind.ZodMap
  }, processCreateParams(params)));
};
var ZodSet = class _ZodSet extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.set) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.set,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const def = this._def;
    if (def.minSize !== null) {
      if (ctx.data.size < def.minSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.minSize.message
        });
        status.dirty();
      }
    }
    if (def.maxSize !== null) {
      if (ctx.data.size > def.maxSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.maxSize.message
        });
        status.dirty();
      }
    }
    const valueType = this._def.valueType;
    function finalizeSet(elements2) {
      const parsedSet = /* @__PURE__ */ new Set();
      for (const element2 of elements2) {
        if (element2.status === "aborted")
          return INVALID;
        if (element2.status === "dirty")
          status.dirty();
        parsedSet.add(element2.value);
      }
      return { status: status.value, value: parsedSet };
    }
    const elements = [...ctx.data.values()].map((item, i9) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i9)));
    if (ctx.common.async) {
      return Promise.all(elements).then((elements2) => finalizeSet(elements2));
    } else {
      return finalizeSet(elements);
    }
  }
  min(minSize, message) {
    return new _ZodSet(__spreadProps(__spreadValues({}, this._def), {
      minSize: { value: minSize, message: errorUtil.toString(message) }
    }));
  }
  max(maxSize, message) {
    return new _ZodSet(__spreadProps(__spreadValues({}, this._def), {
      maxSize: { value: maxSize, message: errorUtil.toString(message) }
    }));
  }
  size(size, message) {
    return this.min(size, message).max(size, message);
  }
  nonempty(message) {
    return this.min(1, message);
  }
};
ZodSet.create = (valueType, params) => {
  return new ZodSet(__spreadValues({
    valueType,
    minSize: null,
    maxSize: null,
    typeName: ZodFirstPartyTypeKind.ZodSet
  }, processCreateParams(params)));
};
var ZodFunction = class _ZodFunction extends ZodType {
  constructor() {
    super(...arguments);
    this.validate = this.implement;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.function) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.function,
        received: ctx.parsedType
      });
      return INVALID;
    }
    function makeArgsIssue(args, error) {
      return makeIssue({
        data: args,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_arguments,
          argumentsError: error
        }
      });
    }
    function makeReturnsIssue(returns, error) {
      return makeIssue({
        data: returns,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_return_type,
          returnTypeError: error
        }
      });
    }
    const params = { errorMap: ctx.common.contextualErrorMap };
    const fn = ctx.data;
    if (this._def.returns instanceof ZodPromise) {
      const me = this;
      return OK(async function(...args) {
        const error = new ZodError([]);
        const parsedArgs = await me._def.args.parseAsync(args, params).catch((e2) => {
          error.addIssue(makeArgsIssue(args, e2));
          throw error;
        });
        const result = await Reflect.apply(fn, this, parsedArgs);
        const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e2) => {
          error.addIssue(makeReturnsIssue(result, e2));
          throw error;
        });
        return parsedReturns;
      });
    } else {
      const me = this;
      return OK(function(...args) {
        const parsedArgs = me._def.args.safeParse(args, params);
        if (!parsedArgs.success) {
          throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
        }
        const result = Reflect.apply(fn, this, parsedArgs.data);
        const parsedReturns = me._def.returns.safeParse(result, params);
        if (!parsedReturns.success) {
          throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
        }
        return parsedReturns.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...items) {
    return new _ZodFunction(__spreadProps(__spreadValues({}, this._def), {
      args: ZodTuple.create(items).rest(ZodUnknown.create())
    }));
  }
  returns(returnType) {
    return new _ZodFunction(__spreadProps(__spreadValues({}, this._def), {
      returns: returnType
    }));
  }
  implement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  strictImplement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  static create(args, returns, params) {
    return new _ZodFunction(__spreadValues({
      args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
      returns: returns || ZodUnknown.create(),
      typeName: ZodFirstPartyTypeKind.ZodFunction
    }, processCreateParams(params)));
  }
};
var ZodLazy = class extends ZodType {
  get schema() {
    return this._def.getter();
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const lazySchema = this._def.getter();
    return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
  }
};
ZodLazy.create = (getter, params) => {
  return new ZodLazy(__spreadValues({
    getter,
    typeName: ZodFirstPartyTypeKind.ZodLazy
  }, processCreateParams(params)));
};
var ZodLiteral = class extends ZodType {
  _parse(input) {
    if (input.data !== this._def.value) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_literal,
        expected: this._def.value
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
  get value() {
    return this._def.value;
  }
};
ZodLiteral.create = (value, params) => {
  return new ZodLiteral(__spreadValues({
    value,
    typeName: ZodFirstPartyTypeKind.ZodLiteral
  }, processCreateParams(params)));
};
function createZodEnum(values, params) {
  return new ZodEnum(__spreadValues({
    values,
    typeName: ZodFirstPartyTypeKind.ZodEnum
  }, processCreateParams(params)));
}
var ZodEnum = class _ZodEnum extends ZodType {
  _parse(input) {
    if (typeof input.data !== "string") {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        expected: util$2.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (this._def.values.indexOf(input.data) === -1) {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Values() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  extract(values) {
    return _ZodEnum.create(values);
  }
  exclude(values) {
    return _ZodEnum.create(this.options.filter((opt) => !values.includes(opt)));
  }
};
ZodEnum.create = createZodEnum;
var ZodNativeEnum = class extends ZodType {
  _parse(input) {
    const nativeEnumValues = util$2.getValidEnumValues(this._def.values);
    const ctx = this._getOrReturnCtx(input);
    if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
      const expectedValues = util$2.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        expected: util$2.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (nativeEnumValues.indexOf(input.data) === -1) {
      const expectedValues = util$2.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get enum() {
    return this._def.values;
  }
};
ZodNativeEnum.create = (values, params) => {
  return new ZodNativeEnum(__spreadValues({
    values,
    typeName: ZodFirstPartyTypeKind.ZodNativeEnum
  }, processCreateParams(params)));
};
var ZodPromise = class extends ZodType {
  unwrap() {
    return this._def.type;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.promise,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
    return OK(promisified.then((data) => {
      return this._def.type.parseAsync(data, {
        path: ctx.path,
        errorMap: ctx.common.contextualErrorMap
      });
    }));
  }
};
ZodPromise.create = (schema, params) => {
  return new ZodPromise(__spreadValues({
    type: schema,
    typeName: ZodFirstPartyTypeKind.ZodPromise
  }, processCreateParams(params)));
};
var ZodEffects = class extends ZodType {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const effect = this._def.effect || null;
    const checkCtx = {
      addIssue: (arg) => {
        addIssueToContext(ctx, arg);
        if (arg.fatal) {
          status.abort();
        } else {
          status.dirty();
        }
      },
      get path() {
        return ctx.path;
      }
    };
    checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
    if (effect.type === "preprocess") {
      const processed = effect.transform(ctx.data, checkCtx);
      if (ctx.common.issues.length) {
        return {
          status: "dirty",
          value: ctx.data
        };
      }
      if (ctx.common.async) {
        return Promise.resolve(processed).then((processed2) => {
          return this._def.schema._parseAsync({
            data: processed2,
            path: ctx.path,
            parent: ctx
          });
        });
      } else {
        return this._def.schema._parseSync({
          data: processed,
          path: ctx.path,
          parent: ctx
        });
      }
    }
    if (effect.type === "refinement") {
      const executeRefinement = (acc) => {
        const result = effect.refinement(acc, checkCtx);
        if (ctx.common.async) {
          return Promise.resolve(result);
        }
        if (result instanceof Promise) {
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        }
        return acc;
      };
      if (ctx.common.async === false) {
        const inner = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inner.status === "aborted")
          return INVALID;
        if (inner.status === "dirty")
          status.dirty();
        executeRefinement(inner.value);
        return { status: status.value, value: inner.value };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((inner) => {
          if (inner.status === "aborted")
            return INVALID;
          if (inner.status === "dirty")
            status.dirty();
          return executeRefinement(inner.value).then(() => {
            return { status: status.value, value: inner.value };
          });
        });
      }
    }
    if (effect.type === "transform") {
      if (ctx.common.async === false) {
        const base = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (!isValid(base))
          return base;
        const result = effect.transform(base.value, checkCtx);
        if (result instanceof Promise) {
          throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
        }
        return { status: status.value, value: result };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((base) => {
          if (!isValid(base))
            return base;
          return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
        });
      }
    }
    util$2.assertNever(effect);
  }
};
ZodEffects.create = (schema, effect, params) => {
  return new ZodEffects(__spreadValues({
    schema,
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    effect
  }, processCreateParams(params)));
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
  return new ZodEffects(__spreadValues({
    schema,
    effect: { type: "preprocess", transform: preprocess },
    typeName: ZodFirstPartyTypeKind.ZodEffects
  }, processCreateParams(params)));
};
var ZodOptional = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.undefined) {
      return OK(void 0);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodOptional.create = (type, params) => {
  return new ZodOptional(__spreadValues({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodOptional
  }, processCreateParams(params)));
};
var ZodNullable = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.null) {
      return OK(null);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodNullable.create = (type, params) => {
  return new ZodNullable(__spreadValues({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodNullable
  }, processCreateParams(params)));
};
var ZodDefault = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    let data = ctx.data;
    if (ctx.parsedType === ZodParsedType.undefined) {
      data = this._def.defaultValue();
    }
    return this._def.innerType._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
ZodDefault.create = (type, params) => {
  return new ZodDefault(__spreadValues({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodDefault,
    defaultValue: typeof params.default === "function" ? params.default : () => params.default
  }, processCreateParams(params)));
};
var ZodCatch = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const newCtx = __spreadProps(__spreadValues({}, ctx), {
      common: __spreadProps(__spreadValues({}, ctx.common), {
        issues: []
      })
    });
    const result = this._def.innerType._parse({
      data: newCtx.data,
      path: newCtx.path,
      parent: __spreadValues({}, newCtx)
    });
    if (isAsync(result)) {
      return result.then((result2) => {
        return {
          status: "valid",
          value: result2.status === "valid" ? result2.value : this._def.catchValue({
            get error() {
              return new ZodError(newCtx.common.issues);
            },
            input: newCtx.data
          })
        };
      });
    } else {
      return {
        status: "valid",
        value: result.status === "valid" ? result.value : this._def.catchValue({
          get error() {
            return new ZodError(newCtx.common.issues);
          },
          input: newCtx.data
        })
      };
    }
  }
  removeCatch() {
    return this._def.innerType;
  }
};
ZodCatch.create = (type, params) => {
  return new ZodCatch(__spreadValues({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodCatch,
    catchValue: typeof params.catch === "function" ? params.catch : () => params.catch
  }, processCreateParams(params)));
};
var ZodNaN = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.nan) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.nan,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
};
ZodNaN.create = (params) => {
  return new ZodNaN(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodNaN
  }, processCreateParams(params)));
};
var BRAND = Symbol("zod_brand");
var ZodBranded = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const data = ctx.data;
    return this._def.type._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  unwrap() {
    return this._def.type;
  }
};
var ZodPipeline = class _ZodPipeline extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.common.async) {
      const handleAsync = async () => {
        const inResult = await this._def.in._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inResult.status === "aborted")
          return INVALID;
        if (inResult.status === "dirty") {
          status.dirty();
          return DIRTY(inResult.value);
        } else {
          return this._def.out._parseAsync({
            data: inResult.value,
            path: ctx.path,
            parent: ctx
          });
        }
      };
      return handleAsync();
    } else {
      const inResult = this._def.in._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
      if (inResult.status === "aborted")
        return INVALID;
      if (inResult.status === "dirty") {
        status.dirty();
        return {
          status: "dirty",
          value: inResult.value
        };
      } else {
        return this._def.out._parseSync({
          data: inResult.value,
          path: ctx.path,
          parent: ctx
        });
      }
    }
  }
  static create(a5, b3) {
    return new _ZodPipeline({
      in: a5,
      out: b3,
      typeName: ZodFirstPartyTypeKind.ZodPipeline
    });
  }
};
var ZodReadonly = class extends ZodType {
  _parse(input) {
    const result = this._def.innerType._parse(input);
    if (isValid(result)) {
      result.value = Object.freeze(result.value);
    }
    return result;
  }
};
ZodReadonly.create = (type, params) => {
  return new ZodReadonly(__spreadValues({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodReadonly
  }, processCreateParams(params)));
};
var custom = (check, params = {}, fatal) => {
  if (check)
    return ZodAny.create().superRefine((data, ctx) => {
      var _a, _b;
      if (!check(data)) {
        const p4 = typeof params === "function" ? params(data) : typeof params === "string" ? { message: params } : params;
        const _fatal = (_b = (_a = p4.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
        const p22 = typeof p4 === "string" ? { message: p4 } : p4;
        ctx.addIssue(__spreadProps(__spreadValues({ code: "custom" }, p22), { fatal: _fatal }));
      }
    });
  return ZodAny.create();
};
var late = {
  object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind2) {
  ZodFirstPartyTypeKind2["ZodString"] = "ZodString";
  ZodFirstPartyTypeKind2["ZodNumber"] = "ZodNumber";
  ZodFirstPartyTypeKind2["ZodNaN"] = "ZodNaN";
  ZodFirstPartyTypeKind2["ZodBigInt"] = "ZodBigInt";
  ZodFirstPartyTypeKind2["ZodBoolean"] = "ZodBoolean";
  ZodFirstPartyTypeKind2["ZodDate"] = "ZodDate";
  ZodFirstPartyTypeKind2["ZodSymbol"] = "ZodSymbol";
  ZodFirstPartyTypeKind2["ZodUndefined"] = "ZodUndefined";
  ZodFirstPartyTypeKind2["ZodNull"] = "ZodNull";
  ZodFirstPartyTypeKind2["ZodAny"] = "ZodAny";
  ZodFirstPartyTypeKind2["ZodUnknown"] = "ZodUnknown";
  ZodFirstPartyTypeKind2["ZodNever"] = "ZodNever";
  ZodFirstPartyTypeKind2["ZodVoid"] = "ZodVoid";
  ZodFirstPartyTypeKind2["ZodArray"] = "ZodArray";
  ZodFirstPartyTypeKind2["ZodObject"] = "ZodObject";
  ZodFirstPartyTypeKind2["ZodUnion"] = "ZodUnion";
  ZodFirstPartyTypeKind2["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
  ZodFirstPartyTypeKind2["ZodIntersection"] = "ZodIntersection";
  ZodFirstPartyTypeKind2["ZodTuple"] = "ZodTuple";
  ZodFirstPartyTypeKind2["ZodRecord"] = "ZodRecord";
  ZodFirstPartyTypeKind2["ZodMap"] = "ZodMap";
  ZodFirstPartyTypeKind2["ZodSet"] = "ZodSet";
  ZodFirstPartyTypeKind2["ZodFunction"] = "ZodFunction";
  ZodFirstPartyTypeKind2["ZodLazy"] = "ZodLazy";
  ZodFirstPartyTypeKind2["ZodLiteral"] = "ZodLiteral";
  ZodFirstPartyTypeKind2["ZodEnum"] = "ZodEnum";
  ZodFirstPartyTypeKind2["ZodEffects"] = "ZodEffects";
  ZodFirstPartyTypeKind2["ZodNativeEnum"] = "ZodNativeEnum";
  ZodFirstPartyTypeKind2["ZodOptional"] = "ZodOptional";
  ZodFirstPartyTypeKind2["ZodNullable"] = "ZodNullable";
  ZodFirstPartyTypeKind2["ZodDefault"] = "ZodDefault";
  ZodFirstPartyTypeKind2["ZodCatch"] = "ZodCatch";
  ZodFirstPartyTypeKind2["ZodPromise"] = "ZodPromise";
  ZodFirstPartyTypeKind2["ZodBranded"] = "ZodBranded";
  ZodFirstPartyTypeKind2["ZodPipeline"] = "ZodPipeline";
  ZodFirstPartyTypeKind2["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
var instanceOfType = (cls, params = {
  message: `Input not instance of ${cls.name}`
}) => custom((data) => data instanceof cls, params);
var stringType = ZodString.create;
var numberType = ZodNumber.create;
var nanType = ZodNaN.create;
var bigIntType = ZodBigInt.create;
var booleanType = ZodBoolean.create;
var dateType = ZodDate.create;
var symbolType = ZodSymbol.create;
var undefinedType = ZodUndefined.create;
var nullType = ZodNull.create;
var anyType = ZodAny.create;
var unknownType = ZodUnknown.create;
var neverType = ZodNever.create;
var voidType = ZodVoid.create;
var arrayType = ZodArray.create;
var objectType = ZodObject.create;
var strictObjectType = ZodObject.strictCreate;
var unionType = ZodUnion.create;
var discriminatedUnionType = ZodDiscriminatedUnion.create;
var intersectionType = ZodIntersection.create;
var tupleType = ZodTuple.create;
var recordType = ZodRecord.create;
var mapType = ZodMap.create;
var setType = ZodSet.create;
var functionType = ZodFunction.create;
var lazyType = ZodLazy.create;
var literalType = ZodLiteral.create;
var enumType = ZodEnum.create;
var nativeEnumType = ZodNativeEnum.create;
var promiseType = ZodPromise.create;
var effectsType = ZodEffects.create;
var optionalType = ZodOptional.create;
var nullableType = ZodNullable.create;
var preprocessType = ZodEffects.createWithPreprocess;
var pipelineType = ZodPipeline.create;
var ostring = () => stringType().optional();
var onumber = () => numberType().optional();
var oboolean = () => booleanType().optional();
var coerce = {
  string: (arg) => ZodString.create(__spreadProps(__spreadValues({}, arg), { coerce: true })),
  number: (arg) => ZodNumber.create(__spreadProps(__spreadValues({}, arg), { coerce: true })),
  boolean: (arg) => ZodBoolean.create(__spreadProps(__spreadValues({}, arg), {
    coerce: true
  })),
  bigint: (arg) => ZodBigInt.create(__spreadProps(__spreadValues({}, arg), { coerce: true })),
  date: (arg) => ZodDate.create(__spreadProps(__spreadValues({}, arg), { coerce: true }))
};
var NEVER = INVALID;
var z = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: errorMap,
  setErrorMap,
  getErrorMap,
  makeIssue,
  EMPTY_PATH,
  addIssueToContext,
  ParseStatus,
  INVALID,
  DIRTY,
  OK,
  isAborted,
  isDirty,
  isValid,
  isAsync,
  get util() {
    return util$2;
  },
  get objectUtil() {
    return objectUtil;
  },
  ZodParsedType,
  getParsedType,
  ZodType,
  ZodString,
  ZodNumber,
  ZodBigInt,
  ZodBoolean,
  ZodDate,
  ZodSymbol,
  ZodUndefined,
  ZodNull,
  ZodAny,
  ZodUnknown,
  ZodNever,
  ZodVoid,
  ZodArray,
  ZodObject,
  ZodUnion,
  ZodDiscriminatedUnion,
  ZodIntersection,
  ZodTuple,
  ZodRecord,
  ZodMap,
  ZodSet,
  ZodFunction,
  ZodLazy,
  ZodLiteral,
  ZodEnum,
  ZodNativeEnum,
  ZodPromise,
  ZodEffects,
  ZodTransformer: ZodEffects,
  ZodOptional,
  ZodNullable,
  ZodDefault,
  ZodCatch,
  ZodNaN,
  BRAND,
  ZodBranded,
  ZodPipeline,
  ZodReadonly,
  custom,
  Schema: ZodType,
  ZodSchema: ZodType,
  late,
  get ZodFirstPartyTypeKind() {
    return ZodFirstPartyTypeKind;
  },
  coerce,
  any: anyType,
  array: arrayType,
  bigint: bigIntType,
  boolean: booleanType,
  date: dateType,
  discriminatedUnion: discriminatedUnionType,
  effect: effectsType,
  "enum": enumType,
  "function": functionType,
  "instanceof": instanceOfType,
  intersection: intersectionType,
  lazy: lazyType,
  literal: literalType,
  map: mapType,
  nan: nanType,
  nativeEnum: nativeEnumType,
  never: neverType,
  "null": nullType,
  nullable: nullableType,
  number: numberType,
  object: objectType,
  oboolean,
  onumber,
  optional: optionalType,
  ostring,
  pipeline: pipelineType,
  preprocess: preprocessType,
  promise: promiseType,
  record: recordType,
  set: setType,
  strictObject: strictObjectType,
  string: stringType,
  symbol: symbolType,
  transformer: effectsType,
  tuple: tupleType,
  "undefined": undefinedType,
  union: unionType,
  unknown: unknownType,
  "void": voidType,
  NEVER,
  ZodIssueCode,
  quotelessJson,
  ZodError
});
var configSchema = z.object({
  callbackFactory: z.function().args(z.object({
    _id: z.number().optional(),
    input: z.array(z.object({
      name: z.string(),
      value: z.unknown()
    })).optional(),
    output: z.array(z.object({
      name: z.string(),
      value: z.unknown()
    })),
    type: z.nativeEnum(l)
  })).returns(z.instanceof(r$8)).optional(),
  clientId: z.string().optional(),
  logLevel: z.union([
    z.literal("none"),
    z.literal("error"),
    z.literal("warn"),
    z.literal("info"),
    z.literal("debug")
  ]).optional(),
  middleware: z.array(z.function()).optional(),
  realmPath: z.string(),
  redirectUri: z.string().optional(),
  scope: z.string().optional(),
  serverConfig: z.object({
    baseUrl: z.string({
      invalid_type_error: "`serverConfig.baseUrl` is a required URL string (this is generated by the Zod library).",
      required_error: "Setting the `serverConfig.baseUrl` is required (this is generated by the Zod library)."
    }).url({
      message: "`serverConfig.baseUrl` must be a full URL (this is generated by the Zod library)."
    }),
    paths: z.object({
      authenticate: z.string().optional(),
      authorize: z.string().optional(),
      accessToken: z.string().optional(),
      endSession: z.string().optional(),
      userInfo: z.string().optional(),
      revoke: z.string().optional(),
      sessions: z.string().optional()
    }).strict().optional(),
    timeout: z.number({
      invalid_type_error: "`serverConfig.timeout` is a required number and in milliseconds (this is generated by the Zod library)."
    }).optional()
  }).strict(),
  support: z.union([z.literal("legacy"), z.literal("modern")]).optional(),
  tokenStore: z.union([
    z.object({
      get: z.function().args(z.string()).returns(z.promise(z.object({
        accessToken: z.string(),
        idToken: z.string().optional(),
        refreshToken: z.string().optional(),
        tokenExpiry: z.number().optional()
      }))),
      set: z.function().args(z.string()).returns(z.promise(z.void())),
      remove: z.function().args(z.string()).returns(z.promise(z.void()))
    }).strict(),
    z.literal("sessionStorage"),
    z.literal("localStorage")
  ]).optional(),
  tree: z.string().optional(),
  type: z.string().optional(),
  oauthThreshold: z.number().optional()
}).strict();
configSchema.partial();
function configure(config) {
  configSchema.parse(config);
  c$3.set(config);
}
var journeyConfigItemSchema = z.object({
  journey: z.string().optional(),
  match: z.string().regex(/^(#\/service|\?journey)/, {
    message: "HREF string must start with `?journey` or `#/service`"
  }).array()
}).optional();
var journeyConfigSchema = z.object({
  forgotPassword: journeyConfigItemSchema,
  forgotUsername: journeyConfigItemSchema,
  login: journeyConfigItemSchema,
  register: journeyConfigItemSchema
});
var defaultJourneys = {
  forgotPassword: {
    journey: "ResetPassword",
    match: ["#/service/ResetPassword", "?journey=ResetPassword"]
  },
  forgotUsername: {
    journey: "ForgottenUsername",
    match: ["#/service/ForgottenUsername", "?journey=ForgottenUsername"]
  },
  login: {
    journey: "Login",
    match: ["#/service/Login", "?journey", "?journey=Login"]
  },
  register: {
    journey: "Registration",
    match: ["#/service/Registration", "?journey=Registration"]
  }
};
journeyConfigSchema.parse(defaultJourneys);
var fallbackJourneyConfig = Object.keys(defaultJourneys).map((key) => __spreadProps(__spreadValues({}, defaultJourneys[key]), {
  key
}));
var configuredJourneysStore = writable(fallbackJourneyConfig);
function initialize$6(customJourneys) {
  if (customJourneys) {
    journeyConfigSchema.parse(customJourneys);
    const mergedJourneyObjects = __spreadValues(__spreadValues({}, defaultJourneys), customJourneys);
    const customJourneyKeys = Object.keys(mergedJourneyObjects);
    configuredJourneysStore.set(customJourneyKeys.map((key) => __spreadProps(__spreadValues({}, mergedJourneyObjects[key]), {
      key
    })));
  } else {
    configuredJourneysStore.set(fallbackJourneyConfig);
  }
  return configuredJourneysStore;
}
function htmlDecode(input) {
  if (typeof document !== "object") {
    return null;
  }
  const e2 = document.createElement("div");
  e2.innerHTML = input;
  return e2.childNodes.length === 0 ? "" : e2.childNodes[0].nodeValue;
}
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var lib$1 = { exports: {} };
var _default$1 = {};
var lib = { exports: {} };
var _default = {};
function getDefaultWhiteList$1() {
  var whiteList = {};
  whiteList["align-content"] = false;
  whiteList["align-items"] = false;
  whiteList["align-self"] = false;
  whiteList["alignment-adjust"] = false;
  whiteList["alignment-baseline"] = false;
  whiteList["all"] = false;
  whiteList["anchor-point"] = false;
  whiteList["animation"] = false;
  whiteList["animation-delay"] = false;
  whiteList["animation-direction"] = false;
  whiteList["animation-duration"] = false;
  whiteList["animation-fill-mode"] = false;
  whiteList["animation-iteration-count"] = false;
  whiteList["animation-name"] = false;
  whiteList["animation-play-state"] = false;
  whiteList["animation-timing-function"] = false;
  whiteList["azimuth"] = false;
  whiteList["backface-visibility"] = false;
  whiteList["background"] = true;
  whiteList["background-attachment"] = true;
  whiteList["background-clip"] = true;
  whiteList["background-color"] = true;
  whiteList["background-image"] = true;
  whiteList["background-origin"] = true;
  whiteList["background-position"] = true;
  whiteList["background-repeat"] = true;
  whiteList["background-size"] = true;
  whiteList["baseline-shift"] = false;
  whiteList["binding"] = false;
  whiteList["bleed"] = false;
  whiteList["bookmark-label"] = false;
  whiteList["bookmark-level"] = false;
  whiteList["bookmark-state"] = false;
  whiteList["border"] = true;
  whiteList["border-bottom"] = true;
  whiteList["border-bottom-color"] = true;
  whiteList["border-bottom-left-radius"] = true;
  whiteList["border-bottom-right-radius"] = true;
  whiteList["border-bottom-style"] = true;
  whiteList["border-bottom-width"] = true;
  whiteList["border-collapse"] = true;
  whiteList["border-color"] = true;
  whiteList["border-image"] = true;
  whiteList["border-image-outset"] = true;
  whiteList["border-image-repeat"] = true;
  whiteList["border-image-slice"] = true;
  whiteList["border-image-source"] = true;
  whiteList["border-image-width"] = true;
  whiteList["border-left"] = true;
  whiteList["border-left-color"] = true;
  whiteList["border-left-style"] = true;
  whiteList["border-left-width"] = true;
  whiteList["border-radius"] = true;
  whiteList["border-right"] = true;
  whiteList["border-right-color"] = true;
  whiteList["border-right-style"] = true;
  whiteList["border-right-width"] = true;
  whiteList["border-spacing"] = true;
  whiteList["border-style"] = true;
  whiteList["border-top"] = true;
  whiteList["border-top-color"] = true;
  whiteList["border-top-left-radius"] = true;
  whiteList["border-top-right-radius"] = true;
  whiteList["border-top-style"] = true;
  whiteList["border-top-width"] = true;
  whiteList["border-width"] = true;
  whiteList["bottom"] = false;
  whiteList["box-decoration-break"] = true;
  whiteList["box-shadow"] = true;
  whiteList["box-sizing"] = true;
  whiteList["box-snap"] = true;
  whiteList["box-suppress"] = true;
  whiteList["break-after"] = true;
  whiteList["break-before"] = true;
  whiteList["break-inside"] = true;
  whiteList["caption-side"] = false;
  whiteList["chains"] = false;
  whiteList["clear"] = true;
  whiteList["clip"] = false;
  whiteList["clip-path"] = false;
  whiteList["clip-rule"] = false;
  whiteList["color"] = true;
  whiteList["color-interpolation-filters"] = true;
  whiteList["column-count"] = false;
  whiteList["column-fill"] = false;
  whiteList["column-gap"] = false;
  whiteList["column-rule"] = false;
  whiteList["column-rule-color"] = false;
  whiteList["column-rule-style"] = false;
  whiteList["column-rule-width"] = false;
  whiteList["column-span"] = false;
  whiteList["column-width"] = false;
  whiteList["columns"] = false;
  whiteList["contain"] = false;
  whiteList["content"] = false;
  whiteList["counter-increment"] = false;
  whiteList["counter-reset"] = false;
  whiteList["counter-set"] = false;
  whiteList["crop"] = false;
  whiteList["cue"] = false;
  whiteList["cue-after"] = false;
  whiteList["cue-before"] = false;
  whiteList["cursor"] = false;
  whiteList["direction"] = false;
  whiteList["display"] = true;
  whiteList["display-inside"] = true;
  whiteList["display-list"] = true;
  whiteList["display-outside"] = true;
  whiteList["dominant-baseline"] = false;
  whiteList["elevation"] = false;
  whiteList["empty-cells"] = false;
  whiteList["filter"] = false;
  whiteList["flex"] = false;
  whiteList["flex-basis"] = false;
  whiteList["flex-direction"] = false;
  whiteList["flex-flow"] = false;
  whiteList["flex-grow"] = false;
  whiteList["flex-shrink"] = false;
  whiteList["flex-wrap"] = false;
  whiteList["float"] = false;
  whiteList["float-offset"] = false;
  whiteList["flood-color"] = false;
  whiteList["flood-opacity"] = false;
  whiteList["flow-from"] = false;
  whiteList["flow-into"] = false;
  whiteList["font"] = true;
  whiteList["font-family"] = true;
  whiteList["font-feature-settings"] = true;
  whiteList["font-kerning"] = true;
  whiteList["font-language-override"] = true;
  whiteList["font-size"] = true;
  whiteList["font-size-adjust"] = true;
  whiteList["font-stretch"] = true;
  whiteList["font-style"] = true;
  whiteList["font-synthesis"] = true;
  whiteList["font-variant"] = true;
  whiteList["font-variant-alternates"] = true;
  whiteList["font-variant-caps"] = true;
  whiteList["font-variant-east-asian"] = true;
  whiteList["font-variant-ligatures"] = true;
  whiteList["font-variant-numeric"] = true;
  whiteList["font-variant-position"] = true;
  whiteList["font-weight"] = true;
  whiteList["grid"] = false;
  whiteList["grid-area"] = false;
  whiteList["grid-auto-columns"] = false;
  whiteList["grid-auto-flow"] = false;
  whiteList["grid-auto-rows"] = false;
  whiteList["grid-column"] = false;
  whiteList["grid-column-end"] = false;
  whiteList["grid-column-start"] = false;
  whiteList["grid-row"] = false;
  whiteList["grid-row-end"] = false;
  whiteList["grid-row-start"] = false;
  whiteList["grid-template"] = false;
  whiteList["grid-template-areas"] = false;
  whiteList["grid-template-columns"] = false;
  whiteList["grid-template-rows"] = false;
  whiteList["hanging-punctuation"] = false;
  whiteList["height"] = true;
  whiteList["hyphens"] = false;
  whiteList["icon"] = false;
  whiteList["image-orientation"] = false;
  whiteList["image-resolution"] = false;
  whiteList["ime-mode"] = false;
  whiteList["initial-letters"] = false;
  whiteList["inline-box-align"] = false;
  whiteList["justify-content"] = false;
  whiteList["justify-items"] = false;
  whiteList["justify-self"] = false;
  whiteList["left"] = false;
  whiteList["letter-spacing"] = true;
  whiteList["lighting-color"] = true;
  whiteList["line-box-contain"] = false;
  whiteList["line-break"] = false;
  whiteList["line-grid"] = false;
  whiteList["line-height"] = false;
  whiteList["line-snap"] = false;
  whiteList["line-stacking"] = false;
  whiteList["line-stacking-ruby"] = false;
  whiteList["line-stacking-shift"] = false;
  whiteList["line-stacking-strategy"] = false;
  whiteList["list-style"] = true;
  whiteList["list-style-image"] = true;
  whiteList["list-style-position"] = true;
  whiteList["list-style-type"] = true;
  whiteList["margin"] = true;
  whiteList["margin-bottom"] = true;
  whiteList["margin-left"] = true;
  whiteList["margin-right"] = true;
  whiteList["margin-top"] = true;
  whiteList["marker-offset"] = false;
  whiteList["marker-side"] = false;
  whiteList["marks"] = false;
  whiteList["mask"] = false;
  whiteList["mask-box"] = false;
  whiteList["mask-box-outset"] = false;
  whiteList["mask-box-repeat"] = false;
  whiteList["mask-box-slice"] = false;
  whiteList["mask-box-source"] = false;
  whiteList["mask-box-width"] = false;
  whiteList["mask-clip"] = false;
  whiteList["mask-image"] = false;
  whiteList["mask-origin"] = false;
  whiteList["mask-position"] = false;
  whiteList["mask-repeat"] = false;
  whiteList["mask-size"] = false;
  whiteList["mask-source-type"] = false;
  whiteList["mask-type"] = false;
  whiteList["max-height"] = true;
  whiteList["max-lines"] = false;
  whiteList["max-width"] = true;
  whiteList["min-height"] = true;
  whiteList["min-width"] = true;
  whiteList["move-to"] = false;
  whiteList["nav-down"] = false;
  whiteList["nav-index"] = false;
  whiteList["nav-left"] = false;
  whiteList["nav-right"] = false;
  whiteList["nav-up"] = false;
  whiteList["object-fit"] = false;
  whiteList["object-position"] = false;
  whiteList["opacity"] = false;
  whiteList["order"] = false;
  whiteList["orphans"] = false;
  whiteList["outline"] = false;
  whiteList["outline-color"] = false;
  whiteList["outline-offset"] = false;
  whiteList["outline-style"] = false;
  whiteList["outline-width"] = false;
  whiteList["overflow"] = false;
  whiteList["overflow-wrap"] = false;
  whiteList["overflow-x"] = false;
  whiteList["overflow-y"] = false;
  whiteList["padding"] = true;
  whiteList["padding-bottom"] = true;
  whiteList["padding-left"] = true;
  whiteList["padding-right"] = true;
  whiteList["padding-top"] = true;
  whiteList["page"] = false;
  whiteList["page-break-after"] = false;
  whiteList["page-break-before"] = false;
  whiteList["page-break-inside"] = false;
  whiteList["page-policy"] = false;
  whiteList["pause"] = false;
  whiteList["pause-after"] = false;
  whiteList["pause-before"] = false;
  whiteList["perspective"] = false;
  whiteList["perspective-origin"] = false;
  whiteList["pitch"] = false;
  whiteList["pitch-range"] = false;
  whiteList["play-during"] = false;
  whiteList["position"] = false;
  whiteList["presentation-level"] = false;
  whiteList["quotes"] = false;
  whiteList["region-fragment"] = false;
  whiteList["resize"] = false;
  whiteList["rest"] = false;
  whiteList["rest-after"] = false;
  whiteList["rest-before"] = false;
  whiteList["richness"] = false;
  whiteList["right"] = false;
  whiteList["rotation"] = false;
  whiteList["rotation-point"] = false;
  whiteList["ruby-align"] = false;
  whiteList["ruby-merge"] = false;
  whiteList["ruby-position"] = false;
  whiteList["shape-image-threshold"] = false;
  whiteList["shape-outside"] = false;
  whiteList["shape-margin"] = false;
  whiteList["size"] = false;
  whiteList["speak"] = false;
  whiteList["speak-as"] = false;
  whiteList["speak-header"] = false;
  whiteList["speak-numeral"] = false;
  whiteList["speak-punctuation"] = false;
  whiteList["speech-rate"] = false;
  whiteList["stress"] = false;
  whiteList["string-set"] = false;
  whiteList["tab-size"] = false;
  whiteList["table-layout"] = false;
  whiteList["text-align"] = true;
  whiteList["text-align-last"] = true;
  whiteList["text-combine-upright"] = true;
  whiteList["text-decoration"] = true;
  whiteList["text-decoration-color"] = true;
  whiteList["text-decoration-line"] = true;
  whiteList["text-decoration-skip"] = true;
  whiteList["text-decoration-style"] = true;
  whiteList["text-emphasis"] = true;
  whiteList["text-emphasis-color"] = true;
  whiteList["text-emphasis-position"] = true;
  whiteList["text-emphasis-style"] = true;
  whiteList["text-height"] = true;
  whiteList["text-indent"] = true;
  whiteList["text-justify"] = true;
  whiteList["text-orientation"] = true;
  whiteList["text-overflow"] = true;
  whiteList["text-shadow"] = true;
  whiteList["text-space-collapse"] = true;
  whiteList["text-transform"] = true;
  whiteList["text-underline-position"] = true;
  whiteList["text-wrap"] = true;
  whiteList["top"] = false;
  whiteList["transform"] = false;
  whiteList["transform-origin"] = false;
  whiteList["transform-style"] = false;
  whiteList["transition"] = false;
  whiteList["transition-delay"] = false;
  whiteList["transition-duration"] = false;
  whiteList["transition-property"] = false;
  whiteList["transition-timing-function"] = false;
  whiteList["unicode-bidi"] = false;
  whiteList["vertical-align"] = false;
  whiteList["visibility"] = false;
  whiteList["voice-balance"] = false;
  whiteList["voice-duration"] = false;
  whiteList["voice-family"] = false;
  whiteList["voice-pitch"] = false;
  whiteList["voice-range"] = false;
  whiteList["voice-rate"] = false;
  whiteList["voice-stress"] = false;
  whiteList["voice-volume"] = false;
  whiteList["volume"] = false;
  whiteList["white-space"] = false;
  whiteList["widows"] = false;
  whiteList["width"] = true;
  whiteList["will-change"] = false;
  whiteList["word-break"] = true;
  whiteList["word-spacing"] = true;
  whiteList["word-wrap"] = true;
  whiteList["wrap-flow"] = false;
  whiteList["wrap-through"] = false;
  whiteList["writing-mode"] = false;
  whiteList["z-index"] = false;
  return whiteList;
}
function onAttr(name, value, options) {
}
function onIgnoreAttr(name, value, options) {
}
var REGEXP_URL_JAVASCRIPT = /javascript\s*\:/img;
function safeAttrValue$1(name, value) {
  if (REGEXP_URL_JAVASCRIPT.test(value)) return "";
  return value;
}
_default.whiteList = getDefaultWhiteList$1();
_default.getDefaultWhiteList = getDefaultWhiteList$1;
_default.onAttr = onAttr;
_default.onIgnoreAttr = onIgnoreAttr;
_default.safeAttrValue = safeAttrValue$1;
var util$1 = {
  indexOf: function(arr, item) {
    var i9, j;
    if (Array.prototype.indexOf) {
      return arr.indexOf(item);
    }
    for (i9 = 0, j = arr.length; i9 < j; i9++) {
      if (arr[i9] === item) {
        return i9;
      }
    }
    return -1;
  },
  forEach: function(arr, fn, scope) {
    var i9, j;
    if (Array.prototype.forEach) {
      return arr.forEach(fn, scope);
    }
    for (i9 = 0, j = arr.length; i9 < j; i9++) {
      fn.call(scope, arr[i9], i9, arr);
    }
  },
  trim: function(str) {
    if (String.prototype.trim) {
      return str.trim();
    }
    return str.replace(/(^\s*)|(\s*$)/g, "");
  },
  trimRight: function(str) {
    if (String.prototype.trimRight) {
      return str.trimRight();
    }
    return str.replace(/(\s*$)/g, "");
  }
};
var _$3 = util$1;
function parseStyle$1(css2, onAttr2) {
  css2 = _$3.trimRight(css2);
  if (css2[css2.length - 1] !== ";") css2 += ";";
  var cssLength = css2.length;
  var isParenthesisOpen = false;
  var lastPos = 0;
  var i9 = 0;
  var retCSS = "";
  function addNewAttr() {
    if (!isParenthesisOpen) {
      var source = _$3.trim(css2.slice(lastPos, i9));
      var j2 = source.indexOf(":");
      if (j2 !== -1) {
        var name = _$3.trim(source.slice(0, j2));
        var value = _$3.trim(source.slice(j2 + 1));
        if (name) {
          var ret = onAttr2(lastPos, retCSS.length, name, value, source);
          if (ret) retCSS += ret + "; ";
        }
      }
    }
    lastPos = i9 + 1;
  }
  for (; i9 < cssLength; i9++) {
    var c5 = css2[i9];
    if (c5 === "/" && css2[i9 + 1] === "*") {
      var j = css2.indexOf("*/", i9 + 2);
      if (j === -1) break;
      i9 = j + 1;
      lastPos = i9 + 1;
      isParenthesisOpen = false;
    } else if (c5 === "(") {
      isParenthesisOpen = true;
    } else if (c5 === ")") {
      isParenthesisOpen = false;
    } else if (c5 === ";") {
      if (isParenthesisOpen) ;
      else {
        addNewAttr();
      }
    } else if (c5 === "\n") {
      addNewAttr();
    }
  }
  return _$3.trim(retCSS);
}
var parser$2 = parseStyle$1;
var DEFAULT$1 = _default;
var parseStyle = parser$2;
function isNull$1(obj) {
  return obj === void 0 || obj === null;
}
function shallowCopyObject$1(obj) {
  var ret = {};
  for (var i9 in obj) {
    ret[i9] = obj[i9];
  }
  return ret;
}
function FilterCSS$2(options) {
  options = shallowCopyObject$1(options || {});
  options.whiteList = options.whiteList || DEFAULT$1.whiteList;
  options.onAttr = options.onAttr || DEFAULT$1.onAttr;
  options.onIgnoreAttr = options.onIgnoreAttr || DEFAULT$1.onIgnoreAttr;
  options.safeAttrValue = options.safeAttrValue || DEFAULT$1.safeAttrValue;
  this.options = options;
}
FilterCSS$2.prototype.process = function(css2) {
  css2 = css2 || "";
  css2 = css2.toString();
  if (!css2) return "";
  var me = this;
  var options = me.options;
  var whiteList = options.whiteList;
  var onAttr2 = options.onAttr;
  var onIgnoreAttr2 = options.onIgnoreAttr;
  var safeAttrValue2 = options.safeAttrValue;
  var retCSS = parseStyle(css2, function(sourcePosition, position, name, value, source) {
    var check = whiteList[name];
    var isWhite = false;
    if (check === true) isWhite = check;
    else if (typeof check === "function") isWhite = check(value);
    else if (check instanceof RegExp) isWhite = check.test(value);
    if (isWhite !== true) isWhite = false;
    value = safeAttrValue2(name, value);
    if (!value) return;
    var opts = {
      position,
      sourcePosition,
      source,
      isWhite
    };
    if (isWhite) {
      var ret = onAttr2(name, value, opts);
      if (isNull$1(ret)) {
        return name + ":" + value;
      } else {
        return ret;
      }
    } else {
      var ret = onIgnoreAttr2(name, value, opts);
      if (!isNull$1(ret)) {
        return ret;
      }
    }
  });
  return retCSS;
};
var css = FilterCSS$2;
(function(module2, exports) {
  var DEFAULT2 = _default;
  var FilterCSS2 = css;
  function filterCSS(html, options) {
    var xss2 = new FilterCSS2(options);
    return xss2.process(html);
  }
  exports = module2.exports = filterCSS;
  exports.FilterCSS = FilterCSS2;
  for (var i9 in DEFAULT2) exports[i9] = DEFAULT2[i9];
  if (typeof window !== "undefined") {
    window.filterCSS = module2.exports;
  }
})(lib, lib.exports);
var libExports$1 = lib.exports;
var util = {
  indexOf: function(arr, item) {
    var i9, j;
    if (Array.prototype.indexOf) {
      return arr.indexOf(item);
    }
    for (i9 = 0, j = arr.length; i9 < j; i9++) {
      if (arr[i9] === item) {
        return i9;
      }
    }
    return -1;
  },
  forEach: function(arr, fn, scope) {
    var i9, j;
    if (Array.prototype.forEach) {
      return arr.forEach(fn, scope);
    }
    for (i9 = 0, j = arr.length; i9 < j; i9++) {
      fn.call(scope, arr[i9], i9, arr);
    }
  },
  trim: function(str) {
    if (String.prototype.trim) {
      return str.trim();
    }
    return str.replace(/(^\s*)|(\s*$)/g, "");
  },
  spaceIndex: function(str) {
    var reg = /\s|\n|\t/;
    var match = reg.exec(str);
    return match ? match.index : -1;
  }
};
var FilterCSS$1 = libExports$1.FilterCSS;
var getDefaultCSSWhiteList = libExports$1.getDefaultWhiteList;
var _$2 = util;
function getDefaultWhiteList() {
  return {
    a: ["target", "href", "title"],
    abbr: ["title"],
    address: [],
    area: ["shape", "coords", "href", "alt"],
    article: [],
    aside: [],
    audio: [
      "autoplay",
      "controls",
      "crossorigin",
      "loop",
      "muted",
      "preload",
      "src"
    ],
    b: [],
    bdi: ["dir"],
    bdo: ["dir"],
    big: [],
    blockquote: ["cite"],
    br: [],
    caption: [],
    center: [],
    cite: [],
    code: [],
    col: ["align", "valign", "span", "width"],
    colgroup: ["align", "valign", "span", "width"],
    dd: [],
    del: ["datetime"],
    details: ["open"],
    div: [],
    dl: [],
    dt: [],
    em: [],
    figcaption: [],
    figure: [],
    font: ["color", "size", "face"],
    footer: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    header: [],
    hr: [],
    i: [],
    img: ["src", "alt", "title", "width", "height"],
    ins: ["datetime"],
    li: [],
    mark: [],
    nav: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    section: [],
    small: [],
    span: [],
    sub: [],
    summary: [],
    sup: [],
    strong: [],
    strike: [],
    table: ["width", "border", "align", "valign"],
    tbody: ["align", "valign"],
    td: ["width", "rowspan", "colspan", "align", "valign"],
    tfoot: ["align", "valign"],
    th: ["width", "rowspan", "colspan", "align", "valign"],
    thead: ["align", "valign"],
    tr: ["rowspan", "align", "valign"],
    tt: [],
    u: [],
    ul: [],
    video: [
      "autoplay",
      "controls",
      "crossorigin",
      "loop",
      "muted",
      "playsinline",
      "poster",
      "preload",
      "src",
      "height",
      "width"
    ]
  };
}
var defaultCSSFilter = new FilterCSS$1();
function onTag(tag, html, options) {
}
function onIgnoreTag(tag, html, options) {
}
function onTagAttr(tag, name, value) {
}
function onIgnoreTagAttr(tag, name, value) {
}
function escapeHtml(html) {
  return html.replace(REGEXP_LT, "&lt;").replace(REGEXP_GT, "&gt;");
}
function safeAttrValue(tag, name, value, cssFilter) {
  value = friendlyAttrValue(value);
  if (name === "href" || name === "src") {
    value = _$2.trim(value);
    if (value === "#") return "#";
    if (!(value.substr(0, 7) === "http://" || value.substr(0, 8) === "https://" || value.substr(0, 7) === "mailto:" || value.substr(0, 4) === "tel:" || value.substr(0, 11) === "data:image/" || value.substr(0, 6) === "ftp://" || value.substr(0, 2) === "./" || value.substr(0, 3) === "../" || value[0] === "#" || value[0] === "/")) {
      return "";
    }
  } else if (name === "background") {
    REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
      return "";
    }
  } else if (name === "style") {
    REGEXP_DEFAULT_ON_TAG_ATTR_7.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_7.test(value)) {
      return "";
    }
    REGEXP_DEFAULT_ON_TAG_ATTR_8.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_8.test(value)) {
      REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
      if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
        return "";
      }
    }
    if (cssFilter !== false) {
      cssFilter = cssFilter || defaultCSSFilter;
      value = cssFilter.process(value);
    }
  }
  value = escapeAttrValue(value);
  return value;
}
var REGEXP_LT = /</g;
var REGEXP_GT = />/g;
var REGEXP_QUOTE = /"/g;
var REGEXP_QUOTE_2 = /&quot;/g;
var REGEXP_ATTR_VALUE_1 = /&#([a-zA-Z0-9]*);?/gim;
var REGEXP_ATTR_VALUE_COLON = /&colon;?/gim;
var REGEXP_ATTR_VALUE_NEWLINE = /&newline;?/gim;
var REGEXP_DEFAULT_ON_TAG_ATTR_4 = /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a):/gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_7 = /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_8 = /u\s*r\s*l\s*\(.*/gi;
function escapeQuote(str) {
  return str.replace(REGEXP_QUOTE, "&quot;");
}
function unescapeQuote(str) {
  return str.replace(REGEXP_QUOTE_2, '"');
}
function escapeHtmlEntities(str) {
  return str.replace(REGEXP_ATTR_VALUE_1, function replaceUnicode(str2, code) {
    return code[0] === "x" || code[0] === "X" ? String.fromCharCode(parseInt(code.substr(1), 16)) : String.fromCharCode(parseInt(code, 10));
  });
}
function escapeDangerHtml5Entities(str) {
  return str.replace(REGEXP_ATTR_VALUE_COLON, ":").replace(REGEXP_ATTR_VALUE_NEWLINE, " ");
}
function clearNonPrintableCharacter(str) {
  var str2 = "";
  for (var i9 = 0, len = str.length; i9 < len; i9++) {
    str2 += str.charCodeAt(i9) < 32 ? " " : str.charAt(i9);
  }
  return _$2.trim(str2);
}
function friendlyAttrValue(str) {
  str = unescapeQuote(str);
  str = escapeHtmlEntities(str);
  str = escapeDangerHtml5Entities(str);
  str = clearNonPrintableCharacter(str);
  return str;
}
function escapeAttrValue(str) {
  str = escapeQuote(str);
  str = escapeHtml(str);
  return str;
}
function onIgnoreTagStripAll() {
  return "";
}
function StripTagBody(tags, next2) {
  if (typeof next2 !== "function") {
    next2 = function() {
    };
  }
  var isRemoveAllTag = !Array.isArray(tags);
  function isRemoveTag(tag) {
    if (isRemoveAllTag) return true;
    return _$2.indexOf(tags, tag) !== -1;
  }
  var removeList = [];
  var posStart = false;
  return {
    onIgnoreTag: function(tag, html, options) {
      if (isRemoveTag(tag)) {
        if (options.isClosing) {
          var ret = "[/removed]";
          var end = options.position + ret.length;
          removeList.push([
            posStart !== false ? posStart : options.position,
            end
          ]);
          posStart = false;
          return ret;
        } else {
          if (!posStart) {
            posStart = options.position;
          }
          return "[removed]";
        }
      } else {
        return next2(tag, html, options);
      }
    },
    remove: function(html) {
      var rethtml = "";
      var lastPos = 0;
      _$2.forEach(removeList, function(pos) {
        rethtml += html.slice(lastPos, pos[0]);
        lastPos = pos[1];
      });
      rethtml += html.slice(lastPos);
      return rethtml;
    }
  };
}
function stripCommentTag(html) {
  var retHtml = "";
  var lastPos = 0;
  while (lastPos < html.length) {
    var i9 = html.indexOf("<!--", lastPos);
    if (i9 === -1) {
      retHtml += html.slice(lastPos);
      break;
    }
    retHtml += html.slice(lastPos, i9);
    var j = html.indexOf("-->", i9);
    if (j === -1) {
      break;
    }
    lastPos = j + 3;
  }
  return retHtml;
}
function stripBlankChar(html) {
  var chars = html.split("");
  chars = chars.filter(function(char) {
    var c5 = char.charCodeAt(0);
    if (c5 === 127) return false;
    if (c5 <= 31) {
      if (c5 === 10 || c5 === 13) return true;
      return false;
    }
    return true;
  });
  return chars.join("");
}
_default$1.whiteList = getDefaultWhiteList();
_default$1.getDefaultWhiteList = getDefaultWhiteList;
_default$1.onTag = onTag;
_default$1.onIgnoreTag = onIgnoreTag;
_default$1.onTagAttr = onTagAttr;
_default$1.onIgnoreTagAttr = onIgnoreTagAttr;
_default$1.safeAttrValue = safeAttrValue;
_default$1.escapeHtml = escapeHtml;
_default$1.escapeQuote = escapeQuote;
_default$1.unescapeQuote = unescapeQuote;
_default$1.escapeHtmlEntities = escapeHtmlEntities;
_default$1.escapeDangerHtml5Entities = escapeDangerHtml5Entities;
_default$1.clearNonPrintableCharacter = clearNonPrintableCharacter;
_default$1.friendlyAttrValue = friendlyAttrValue;
_default$1.escapeAttrValue = escapeAttrValue;
_default$1.onIgnoreTagStripAll = onIgnoreTagStripAll;
_default$1.StripTagBody = StripTagBody;
_default$1.stripCommentTag = stripCommentTag;
_default$1.stripBlankChar = stripBlankChar;
_default$1.cssFilter = defaultCSSFilter;
_default$1.getDefaultCSSWhiteList = getDefaultCSSWhiteList;
var parser$1 = {};
var _$1 = util;
function getTagName(html) {
  var i9 = _$1.spaceIndex(html);
  var tagName;
  if (i9 === -1) {
    tagName = html.slice(1, -1);
  } else {
    tagName = html.slice(1, i9 + 1);
  }
  tagName = _$1.trim(tagName).toLowerCase();
  if (tagName.slice(0, 1) === "/") tagName = tagName.slice(1);
  if (tagName.slice(-1) === "/") tagName = tagName.slice(0, -1);
  return tagName;
}
function isClosing(html) {
  return html.slice(0, 2) === "</";
}
function parseTag$1(html, onTag2, escapeHtml2) {
  var rethtml = "";
  var lastPos = 0;
  var tagStart = false;
  var quoteStart = false;
  var currentPos = 0;
  var len = html.length;
  var currentTagName = "";
  var currentHtml = "";
  chariterator: for (currentPos = 0; currentPos < len; currentPos++) {
    var c5 = html.charAt(currentPos);
    if (tagStart === false) {
      if (c5 === "<") {
        tagStart = currentPos;
        continue;
      }
    } else {
      if (quoteStart === false) {
        if (c5 === "<") {
          rethtml += escapeHtml2(html.slice(lastPos, currentPos));
          tagStart = currentPos;
          lastPos = currentPos;
          continue;
        }
        if (c5 === ">" || currentPos === len - 1) {
          rethtml += escapeHtml2(html.slice(lastPos, tagStart));
          currentHtml = html.slice(tagStart, currentPos + 1);
          currentTagName = getTagName(currentHtml);
          rethtml += onTag2(
            tagStart,
            rethtml.length,
            currentTagName,
            currentHtml,
            isClosing(currentHtml)
          );
          lastPos = currentPos + 1;
          tagStart = false;
          continue;
        }
        if (c5 === '"' || c5 === "'") {
          var i9 = 1;
          var ic = html.charAt(currentPos - i9);
          while (ic.trim() === "" || ic === "=") {
            if (ic === "=") {
              quoteStart = c5;
              continue chariterator;
            }
            ic = html.charAt(currentPos - ++i9);
          }
        }
      } else {
        if (c5 === quoteStart) {
          quoteStart = false;
          continue;
        }
      }
    }
  }
  if (lastPos < len) {
    rethtml += escapeHtml2(html.substr(lastPos));
  }
  return rethtml;
}
var REGEXP_ILLEGAL_ATTR_NAME = /[^a-zA-Z0-9\\_:.-]/gim;
function parseAttr$1(html, onAttr2) {
  var lastPos = 0;
  var lastMarkPos = 0;
  var retAttrs = [];
  var tmpName = false;
  var len = html.length;
  function addAttr(name, value) {
    name = _$1.trim(name);
    name = name.replace(REGEXP_ILLEGAL_ATTR_NAME, "").toLowerCase();
    if (name.length < 1) return;
    var ret = onAttr2(name, value || "");
    if (ret) retAttrs.push(ret);
  }
  for (var i9 = 0; i9 < len; i9++) {
    var c5 = html.charAt(i9);
    var v, j;
    if (tmpName === false && c5 === "=") {
      tmpName = html.slice(lastPos, i9);
      lastPos = i9 + 1;
      lastMarkPos = html.charAt(lastPos) === '"' || html.charAt(lastPos) === "'" ? lastPos : findNextQuotationMark(html, i9 + 1);
      continue;
    }
    if (tmpName !== false) {
      if (i9 === lastMarkPos) {
        j = html.indexOf(c5, i9 + 1);
        if (j === -1) {
          break;
        } else {
          v = _$1.trim(html.slice(lastMarkPos + 1, j));
          addAttr(tmpName, v);
          tmpName = false;
          i9 = j;
          lastPos = i9 + 1;
          continue;
        }
      }
    }
    if (/\s|\n|\t/.test(c5)) {
      html = html.replace(/\s|\n|\t/g, " ");
      if (tmpName === false) {
        j = findNextEqual(html, i9);
        if (j === -1) {
          v = _$1.trim(html.slice(lastPos, i9));
          addAttr(v);
          tmpName = false;
          lastPos = i9 + 1;
          continue;
        } else {
          i9 = j - 1;
          continue;
        }
      } else {
        j = findBeforeEqual(html, i9 - 1);
        if (j === -1) {
          v = _$1.trim(html.slice(lastPos, i9));
          v = stripQuoteWrap(v);
          addAttr(tmpName, v);
          tmpName = false;
          lastPos = i9 + 1;
          continue;
        } else {
          continue;
        }
      }
    }
  }
  if (lastPos < html.length) {
    if (tmpName === false) {
      addAttr(html.slice(lastPos));
    } else {
      addAttr(tmpName, stripQuoteWrap(_$1.trim(html.slice(lastPos))));
    }
  }
  return _$1.trim(retAttrs.join(" "));
}
function findNextEqual(str, i9) {
  for (; i9 < str.length; i9++) {
    var c5 = str[i9];
    if (c5 === " ") continue;
    if (c5 === "=") return i9;
    return -1;
  }
}
function findNextQuotationMark(str, i9) {
  for (; i9 < str.length; i9++) {
    var c5 = str[i9];
    if (c5 === " ") continue;
    if (c5 === "'" || c5 === '"') return i9;
    return -1;
  }
}
function findBeforeEqual(str, i9) {
  for (; i9 > 0; i9--) {
    var c5 = str[i9];
    if (c5 === " ") continue;
    if (c5 === "=") return i9;
    return -1;
  }
}
function isQuoteWrapString(text2) {
  if (text2[0] === '"' && text2[text2.length - 1] === '"' || text2[0] === "'" && text2[text2.length - 1] === "'") {
    return true;
  } else {
    return false;
  }
}
function stripQuoteWrap(text2) {
  if (isQuoteWrapString(text2)) {
    return text2.substr(1, text2.length - 2);
  } else {
    return text2;
  }
}
parser$1.parseTag = parseTag$1;
parser$1.parseAttr = parseAttr$1;
var FilterCSS = libExports$1.FilterCSS;
var DEFAULT = _default$1;
var parser = parser$1;
var parseTag = parser.parseTag;
var parseAttr = parser.parseAttr;
var _ = util;
function isNull(obj) {
  return obj === void 0 || obj === null;
}
function getAttrs(html) {
  var i9 = _.spaceIndex(html);
  if (i9 === -1) {
    return {
      html: "",
      closing: html[html.length - 2] === "/"
    };
  }
  html = _.trim(html.slice(i9 + 1, -1));
  var isClosing2 = html[html.length - 1] === "/";
  if (isClosing2) html = _.trim(html.slice(0, -1));
  return {
    html,
    closing: isClosing2
  };
}
function shallowCopyObject(obj) {
  var ret = {};
  for (var i9 in obj) {
    ret[i9] = obj[i9];
  }
  return ret;
}
function keysToLowerCase(obj) {
  var ret = {};
  for (var i9 in obj) {
    if (Array.isArray(obj[i9])) {
      ret[i9.toLowerCase()] = obj[i9].map(function(item) {
        return item.toLowerCase();
      });
    } else {
      ret[i9.toLowerCase()] = obj[i9];
    }
  }
  return ret;
}
function FilterXSS(options) {
  options = shallowCopyObject(options || {});
  if (options.stripIgnoreTag) {
    if (options.onIgnoreTag) {
      console.error(
        'Notes: cannot use these two options "stripIgnoreTag" and "onIgnoreTag" at the same time'
      );
    }
    options.onIgnoreTag = DEFAULT.onIgnoreTagStripAll;
  }
  if (options.whiteList || options.allowList) {
    options.whiteList = keysToLowerCase(options.whiteList || options.allowList);
  } else {
    options.whiteList = DEFAULT.whiteList;
  }
  options.onTag = options.onTag || DEFAULT.onTag;
  options.onTagAttr = options.onTagAttr || DEFAULT.onTagAttr;
  options.onIgnoreTag = options.onIgnoreTag || DEFAULT.onIgnoreTag;
  options.onIgnoreTagAttr = options.onIgnoreTagAttr || DEFAULT.onIgnoreTagAttr;
  options.safeAttrValue = options.safeAttrValue || DEFAULT.safeAttrValue;
  options.escapeHtml = options.escapeHtml || DEFAULT.escapeHtml;
  this.options = options;
  if (options.css === false) {
    this.cssFilter = false;
  } else {
    options.css = options.css || {};
    this.cssFilter = new FilterCSS(options.css);
  }
}
FilterXSS.prototype.process = function(html) {
  html = html || "";
  html = html.toString();
  if (!html) return "";
  var me = this;
  var options = me.options;
  var whiteList = options.whiteList;
  var onTag2 = options.onTag;
  var onIgnoreTag2 = options.onIgnoreTag;
  var onTagAttr2 = options.onTagAttr;
  var onIgnoreTagAttr2 = options.onIgnoreTagAttr;
  var safeAttrValue2 = options.safeAttrValue;
  var escapeHtml2 = options.escapeHtml;
  var cssFilter = me.cssFilter;
  if (options.stripBlankChar) {
    html = DEFAULT.stripBlankChar(html);
  }
  if (!options.allowCommentTag) {
    html = DEFAULT.stripCommentTag(html);
  }
  var stripIgnoreTagBody = false;
  if (options.stripIgnoreTagBody) {
    stripIgnoreTagBody = DEFAULT.StripTagBody(
      options.stripIgnoreTagBody,
      onIgnoreTag2
    );
    onIgnoreTag2 = stripIgnoreTagBody.onIgnoreTag;
  }
  var retHtml = parseTag(
    html,
    function(sourcePosition, position, tag, html2, isClosing2) {
      var info = {
        sourcePosition,
        position,
        isClosing: isClosing2,
        isWhite: Object.prototype.hasOwnProperty.call(whiteList, tag)
      };
      var ret = onTag2(tag, html2, info);
      if (!isNull(ret)) return ret;
      if (info.isWhite) {
        if (info.isClosing) {
          return "</" + tag + ">";
        }
        var attrs = getAttrs(html2);
        var whiteAttrList = whiteList[tag];
        var attrsHtml = parseAttr(attrs.html, function(name, value) {
          var isWhiteAttr = _.indexOf(whiteAttrList, name) !== -1;
          var ret2 = onTagAttr2(tag, name, value, isWhiteAttr);
          if (!isNull(ret2)) return ret2;
          if (isWhiteAttr) {
            value = safeAttrValue2(tag, name, value, cssFilter);
            if (value) {
              return name + '="' + value + '"';
            } else {
              return name;
            }
          } else {
            ret2 = onIgnoreTagAttr2(tag, name, value, isWhiteAttr);
            if (!isNull(ret2)) return ret2;
            return;
          }
        });
        html2 = "<" + tag;
        if (attrsHtml) html2 += " " + attrsHtml;
        if (attrs.closing) html2 += " /";
        html2 += ">";
        return html2;
      } else {
        ret = onIgnoreTag2(tag, html2, info);
        if (!isNull(ret)) return ret;
        return escapeHtml2(html2);
      }
    },
    escapeHtml2
  );
  if (stripIgnoreTagBody) {
    retHtml = stripIgnoreTagBody.remove(retHtml);
  }
  return retHtml;
};
var xss = FilterXSS;
(function(module2, exports) {
  var DEFAULT2 = _default$1;
  var parser2 = parser$1;
  var FilterXSS2 = xss;
  function filterXSS(html, options) {
    var xss2 = new FilterXSS2(options);
    return xss2.process(html);
  }
  exports = module2.exports = filterXSS;
  exports.filterXSS = filterXSS;
  exports.FilterXSS = FilterXSS2;
  (function() {
    for (var i9 in DEFAULT2) {
      exports[i9] = DEFAULT2[i9];
    }
    for (var j in parser2) {
      exports[j] = parser2[j];
    }
  })();
  if (typeof window !== "undefined") {
    window.filterXSS = module2.exports;
  }
  function isWorkerEnv() {
    return typeof self !== "undefined" && typeof DedicatedWorkerGlobalScope !== "undefined" && self instanceof DedicatedWorkerGlobalScope;
  }
  if (isWorkerEnv()) {
    self.filterXSS = module2.exports;
  }
})(lib$1, lib$1.exports);
var libExports = lib$1.exports;
var sanitize = /* @__PURE__ */ getDefaultExportFromCjs(libExports);
var alreadyHaveAnAccount = "Already have an account? <a href='?journey'>Sign in here!</a>";
var backToDefault = "Back to Sign In";
var backToLogin = "Back to Sign In";
var closeModal = "Close";
var charactersCannotRepeatMoreThan = "Character cannot repeat more than {max} times";
var charactersCannotRepeatMoreThanCaseInsensitive = "Character cannot repeat more than {max} times (case insensitive)";
var checkYourEmail = "Check your email";
var chooseDifferentUsername = "Please choose a different username.";
var chooseYourDeviceForIdentityVerification = "Choose your device for identity verification.";
var confirmPassword = "Confirm password";
var constraintViolationForPassword = "Password does not meet the requirements.";
var constraintViolationForValue = "Value does not meet the requirements.";
var continueWith = "Continue with ";
var copyAndPasteUrlBelow = "Or, copy and paste the URL below into your authentictor app.";
var copyUrl = "Copy URL";
var customSecurityQuestion = "Custom security question";
var deviceName = "Device name";
var doesNotMeetMinimumCharacterLength = "At least {min} character(s)";
var dontGetLockedOut = "Don't get locked out of your account!";
var dontHaveAnAccount = "No account? <a href='?journey=Registration'>Register here!</a>";
var ensurePasswordIsMoreThan = "Password must contain at least {minPasswordLength} character(s).";
var ensurePasswordHasOne = "Password must contain at least 1 capital letter, 1 number, and 1 special character.";
var enterVerificationCode = "Enter verification code";
var exceedsMaximumCharacterLength = "Exceeds maximum of {max} characters";
var fieldCanNotContainFollowingCharacters = "Cannot contain these character(s): {chars}";
var fieldCanNotContainFollowingValues = "Cannot contain these value(s): {fields}";
var forgotPassword = "Forgot password?";
var forgotUsername = "Forgot username?";
var givenName = "First name";
var inputRequiredError = "Value is required";
var loading = "Loading ...";
var loginButton = "Sign in";
var loginFailure = "Sign in failed";
var loginHeader = "Sign in";
var loginSuccess = "Sign in successful!";
var mail = "Email address";
var minimumNumberOfNumbers = "At least {num} number(s)";
var minimumNumberOfLowercase = "At least {num} lowercase letter(s)";
var minimumNumberOfUppercase = "At least {num} uppercase letter(s)";
var minimumNumberOfSymbols = "At least {num} symbol(s)";
var nameCallback = "Username";
var nameYourDevice = "Name your device";
var next = "Next";
var nextButton = "Next";
var notToExceedMaximumCharacterLength = "No more than {max} characters";
var noLessThanMinimumCharacterLength = "At least {min} character(s)";
var onMobileOpenInAuthenticator = "On mobile? Open link in Authenticator.";
var optionallyNameDevice = "Optionally name your device";
var passwordCallback = "Password";
var passwordCannotContainCommonPasswords = "Password cannot contain common passwords";
var passwordCannotContainCommonPasswordsOrBeReversible = "Password cannot contain common passwords or reversible text";
var passwordCannotContainCommonPasswordsOrBeReversibleStringsLessThan = "Password cannot contain common passwords or reversible text less than {min} characters";
var passwordRequirements = "Password requirements:";
var pleaseCheckValue = "Please check this value";
var pleaseConfirm = "Please confirm";
var preferencesMarketing = "Send me special offers and services";
var preferencesUpdates = "Send me news and updates";
var provideCustomQuestion = "Provide custom security question";
var qrCodeNotWorking = "Not working or need an alternative method?";
var qrCodeFailedToRender = "QR Code failed to render. Please notify your support administrator. You are welcome to use the alternative methods below.";
var qrCodeImportFailure = "We are unable to render your QR Code. Please use one of the alternative methods below.";
var redirectingTo = "Redirecting you to";
var registerButton = "Register";
var registerHeader = "Register";
var registerSuccess = "Registration successful!";
var requiredField = "Value is required";
var registerYourDevice = "Register {name}";
var scanQrCodeWithAuthenticator = "Scan the QR code image below with the ForgeRock Authenticator app to register your device with your login.";
var securityAnswer = "Security answer";
var securityQuestions = "Security question(s)";
var securityQuestionsPrompt = "Provide security question(s) and answer(s):";
var shouldContainANumber = "Should contain a number";
var shouldContainAnUppercase = "Should contain an uppercase letter";
var shouldContainALowercase = "Should contain a lowercase letter";
var shouldContainASymbol = "Should contain a symbol";
var showPassword = "Show password";
var signalsEvaluation = "Evaluating device information.";
var skipButton = "Skip";
var sn = "Last name";
var submit = "Submit";
var submitButton = "Submit";
var successMessage = "Success!";
var termsAndConditions = "Please accept our Terms & Conditions";
var termsAndConditionsLinkText = "View full Terms & Conditions";
var tryAgain = "Please try again";
var twoFactorAuthentication = "Two factor authentication";
var useThisNewMfaToHelpVerifyYourIdentity = "Use this new device or Multi-Factor Authentication method to help verify your identity.";
var useValidEmail = "Please use a valid email address.";
var unrecoverableError = "There was an error in the form submission.";
var unknownLoginError = "Unknown login failure has occurred.";
var unknownNetworkError = "Unknown network request failure has occurred.";
var url = "URL:";
var useDeviceForIdentityVerification = "Use your device for identity verification.";
var useOneOfTheseCodes = "Use one of these codes to authenticate if you lose your device, which has been named: <em>{name}</em>";
var userName = "Username";
var usernameRequirements = "Username requirements:";
var useTheAuthenticatorAppOnYourPhone = "Find the verification code using the authenticator app on your phone.";
var validatedCreatePasswordCallback = "Password";
var validatedCreateUsernameCallback = "Username";
var valueRequirements = "Value requirements:";
var verifyYourIdentity = "Verify your identity";
var yourDevice = "Your device";
var yourMultiFactorAuthIsEnabled = "Your new device or MFA is enabled";
var yourRecoveryCodesToAccessAccountForLostDevice = "If you lose your device, or don\u2019t have it with you, a recovery code is the only way to sign in to your account with 2-step verification enabled. It\u2019s strongly recommended that you print and store these codes in a safe place. <b>Each code can only be used once</b>.";
var fallback = {
  alreadyHaveAnAccount,
  backToDefault,
  backToLogin,
  closeModal,
  charactersCannotRepeatMoreThan,
  charactersCannotRepeatMoreThanCaseInsensitive,
  checkYourEmail,
  chooseDifferentUsername,
  chooseYourDeviceForIdentityVerification,
  confirmPassword,
  constraintViolationForPassword,
  constraintViolationForValue,
  continueWith,
  copyAndPasteUrlBelow,
  copyUrl,
  customSecurityQuestion,
  deviceName,
  doesNotMeetMinimumCharacterLength,
  dontGetLockedOut,
  dontHaveAnAccount,
  ensurePasswordIsMoreThan,
  ensurePasswordHasOne,
  enterVerificationCode,
  exceedsMaximumCharacterLength,
  fieldCanNotContainFollowingCharacters,
  fieldCanNotContainFollowingValues,
  forgotPassword,
  forgotUsername,
  givenName,
  inputRequiredError,
  loading,
  loginButton,
  loginFailure,
  loginHeader,
  loginSuccess,
  mail,
  minimumNumberOfNumbers,
  minimumNumberOfLowercase,
  minimumNumberOfUppercase,
  minimumNumberOfSymbols,
  nameCallback,
  nameYourDevice,
  next,
  nextButton,
  notToExceedMaximumCharacterLength,
  noLessThanMinimumCharacterLength,
  onMobileOpenInAuthenticator,
  optionallyNameDevice,
  passwordCallback,
  passwordCannotContainCommonPasswords,
  passwordCannotContainCommonPasswordsOrBeReversible,
  passwordCannotContainCommonPasswordsOrBeReversibleStringsLessThan,
  passwordRequirements,
  pleaseCheckValue,
  pleaseConfirm,
  preferencesMarketing,
  preferencesUpdates,
  provideCustomQuestion,
  qrCodeNotWorking,
  qrCodeFailedToRender,
  qrCodeImportFailure,
  redirectingTo,
  registerButton,
  registerHeader,
  registerSuccess,
  requiredField,
  registerYourDevice,
  scanQrCodeWithAuthenticator,
  securityAnswer,
  securityQuestions,
  securityQuestionsPrompt,
  shouldContainANumber,
  shouldContainAnUppercase,
  shouldContainALowercase,
  shouldContainASymbol,
  showPassword,
  signalsEvaluation,
  skipButton,
  sn,
  submit,
  submitButton,
  successMessage,
  termsAndConditions,
  termsAndConditionsLinkText,
  tryAgain,
  twoFactorAuthentication,
  useThisNewMfaToHelpVerifyYourIdentity,
  useValidEmail,
  unrecoverableError,
  unknownLoginError,
  unknownNetworkError,
  url,
  useDeviceForIdentityVerification,
  useOneOfTheseCodes,
  userName,
  usernameRequirements,
  useTheAuthenticatorAppOnYourPhone,
  validatedCreatePasswordCallback,
  validatedCreateUsernameCallback,
  valueRequirements,
  verifyYourIdentity,
  yourDevice,
  yourMultiFactorAuthIsEnabled,
  yourRecoveryCodesToAccessAccountForLostDevice
};
var stringsSchema = z.object({
  alreadyHaveAnAccount: z.string(),
  backToDefault: z.string(),
  backToLogin: z.string(),
  dontHaveAnAccount: z.string(),
  closeModal: z.string(),
  charactersCannotRepeatMoreThan: z.string(),
  charactersCannotRepeatMoreThanCaseInsensitive: z.string(),
  checkYourEmail: z.string(),
  chooseDifferentUsername: z.string(),
  chooseYourDeviceForIdentityVerification: z.string(),
  confirmPassword: z.string(),
  constraintViolationForPassword: z.string(),
  constraintViolationForValue: z.string(),
  continueWith: z.string(),
  copyUrl: z.string(),
  copyAndPasteUrlBelow: z.string(),
  customSecurityQuestion: z.string(),
  dontGetLockedOut: z.string(),
  doesNotMeetMinimumCharacterLength: z.string(),
  deviceName: z.string(),
  ensurePasswordIsMoreThan: z.string(),
  ensurePasswordHasOne: z.string(),
  enterVerificationCode: z.string(),
  exceedsMaximumCharacterLength: z.string(),
  fieldCanNotContainFollowingCharacters: z.string(),
  fieldCanNotContainFollowingValues: z.string(),
  forgotPassword: z.string(),
  forgotUsername: z.string(),
  givenName: z.string(),
  inputRequiredError: z.string(),
  loading: z.string(),
  loginButton: z.string(),
  loginFailure: z.string(),
  loginHeader: z.string(),
  loginSuccess: z.string(),
  mail: z.string(),
  minimumNumberOfNumbers: z.string(),
  minimumNumberOfLowercase: z.string(),
  minimumNumberOfUppercase: z.string(),
  minimumNumberOfSymbols: z.string(),
  nameCallback: z.string(),
  nameYourDevice: z.string(),
  next: z.string(),
  nextButton: z.string(),
  notToExceedMaximumCharacterLength: z.string(),
  noLessThanMinimumCharacterLength: z.string(),
  useOneOfTheseCodes: z.string(),
  onMobileOpenInAuthenticator: z.string(),
  optionallyNameDevice: z.string(),
  passwordCallback: z.string(),
  passwordCannotContainCommonPasswords: z.string(),
  passwordCannotContainCommonPasswordsOrBeReversible: z.string(),
  passwordCannotContainCommonPasswordsOrBeReversibleStringsLessThan: z.string(),
  passwordRequirements: z.string(),
  pleaseCheckValue: z.string(),
  pleaseConfirm: z.string(),
  preferencesMarketing: z.string(),
  preferencesUpdates: z.string(),
  provideCustomQuestion: z.string(),
  qrCodeNotWorking: z.string(),
  qrCodeFailedToRender: z.string(),
  qrCodeImportFailure: z.string(),
  redirectingTo: z.string(),
  registerButton: z.string(),
  registerHeader: z.string(),
  registerSuccess: z.string(),
  registerYourDevice: z.string(),
  requiredField: z.string(),
  securityAnswer: z.string(),
  scanQrCodeWithAuthenticator: z.string(),
  securityQuestions: z.string(),
  securityQuestionsPrompt: z.string(),
  shouldContainANumber: z.string(),
  shouldContainAnUppercase: z.string(),
  shouldContainALowercase: z.string(),
  shouldContainASymbol: z.string(),
  showPassword: z.string(),
  signalsEvaluation: z.string(),
  skipButton: z.string(),
  sn: z.string(),
  submit: z.string(),
  submitButton: z.string(),
  successMessage: z.string(),
  termsAndConditions: z.string(),
  termsAndConditionsLinkText: z.string(),
  tryAgain: z.string(),
  twoFactorAuthentication: z.string(),
  useThisNewMfaToHelpVerifyYourIdentity: z.string(),
  useValidEmail: z.string(),
  unrecoverableError: z.string(),
  unknownLoginError: z.string(),
  unknownNetworkError: z.string(),
  url: z.string(),
  useDeviceForIdentityVerification: z.string(),
  userName: z.string(),
  usernameRequirements: z.string(),
  useTheAuthenticatorAppOnYourPhone: z.string(),
  validatedCreatePasswordCallback: z.string(),
  validatedCreateUsernameCallback: z.string(),
  valueRequirements: z.string(),
  verifyYourIdentity: z.string(),
  yourDevice: z.string(),
  yourMultiFactorAuthIsEnabled: z.string(),
  yourRecoveryCodesToAccessAccountForLostDevice: z.string()
}).strict();
stringsSchema.partial();
stringsSchema.parse(fallback);
var stringsStore = writable(null);
function initialize$5(userLocale) {
  if (userLocale) {
    stringsStore.set(__spreadValues(__spreadValues({}, fallback), userLocale));
  } else {
    stringsStore.set(fallback);
  }
  return stringsSchema;
}
var valueSchema = z.record(z.string().regex(/^[^<>]*$/)).optional();
function interpolate(key, values, externalText) {
  if (!key)
    throw new Error("No key provided to t()");
  const contentObj = get_store_value(stringsStore);
  const string = contentObj && contentObj[key] || "";
  let messageDirty = "";
  if (values) {
    valueSchema.parse(values);
    Object.keys(values).map((k2) => {
      const regex2 = new RegExp(`{${k2}}`, "g");
      messageDirty = string.replace(regex2, values[k2]);
    });
  } else {
    messageDirty = string;
  }
  if (!messageDirty && !externalText) {
    const textFromKey = key.replace(/([A-Z])/g, " $1");
    messageDirty = textFromKey.charAt(0).toUpperCase() + textFromKey.slice(1);
  } else if (!messageDirty && externalText) {
    messageDirty = externalText;
  }
  const messageClean = sanitize(messageDirty, {
    /**
     * Allow `?` as first char in `href` value for anchor tags.
     * To preserve original behavior in addition to this one exception,
     * return `undefined` for all other cases.
     */
    onTagAttr: function(tag, name, value) {
      if (tag == "a" && name == "href") {
        if (value.substr(0, 1) === "?") {
          return `${name}="${value}"`;
        }
      }
    }
  });
  return messageClean;
}
function textToKey(text2) {
  if (typeof text2 !== "string" && typeof text2 !== "number") {
    throw new Error("Parameter for textToKey function needs to be of type string or number");
  }
  if (typeof text2 === "number") {
    text2 = String(text2);
  }
  if (text2.match(/^([A-Z]+)$/)) {
    return text2.toLowerCase();
  }
  if (text2.match(/^([A-Z]+[\W]*)$/)) {
    return text2.replace(/\W/g, "").toLowerCase();
  }
  const transformedString = text2.replace(/(\W)([\w\d])/g, (_2, p1, p22) => {
    if (p1.match(/['’"”]/) && p22.match(/[a-z]/)) {
      return p22;
    }
    if (p1.match(/\W/) && p22.match(/[a-z]/)) {
      return p22.toUpperCase();
    }
    if (p1.match(/\W/) && p22.match(/\d/)) {
      return p22;
    }
    return p22;
  }).replace(/(\W)/g, "");
  return transformedString.charAt(0).toLowerCase() + transformedString.slice(1);
}
var authIdTimeoutErrorCode = "110";
var constrainedViolationMessage = "constraint violation";
function convertStringToKey(string) {
  if (!string) {
    return "";
  }
  if (string.toLocaleLowerCase().includes("constraint violation")) {
    console.error("Delta Sierra error has occurred. Please communicate this to your system administrator.");
    if (string.toLocaleLowerCase().includes("password")) {
      return "constraintViolationForPassword";
    }
    return "constraintViolationForValue";
  }
  const replaceFunction = (_2, char) => `${char.toLowerCase()}`;
  const normalizedString = string.replace(/^([A-Z])/g, replaceFunction).replace(/\s([a-z])/g, (_2, char) => `${char.toUpperCase()}`);
  const key = normalizedString.replace(/\W/g, "");
  return key;
}
function initCheckValidation() {
  let hasPrevError = false;
  return function checkValidation(callback) {
    const failedPolices = callback.getOutputByName("failedPolicies", []);
    if (failedPolices.length && !hasPrevError) {
      hasPrevError = true;
      return true;
    }
    return false;
  };
}
function shouldRedirectFromStep(step) {
  return step.getCallbacksOfType(l.RedirectCallback).length > 0;
}
function shouldPopulateWithPreviousCallbacks(nextStep, previousCallbacks, restartedStep, stepNumber) {
  var _a;
  if (!Array.isArray(previousCallbacks)) {
    return false;
  }
  if (restartedStep.type !== r$a.Step) {
    return false;
  }
  if (stepNumber !== 1) {
    return false;
  }
  const details = nextStep.payload.detail;
  const message = (_a = nextStep.payload.message) == null ? void 0 : _a.toLowerCase();
  if ((details == null ? void 0 : details.errorCode) === authIdTimeoutErrorCode || (message == null ? void 0 : message.includes(constrainedViolationMessage))) {
    return true;
  }
  return false;
}
var selfSubmittingCallbacks = [
  l.ConfirmationCallback,
  l.DeviceProfileCallback,
  l.PollingWaitCallback,
  l.SelectIdPCallback,
  l.PingOneProtectInitializeCallback,
  l.PingOneProtectEvaluationCallback
];
var userInputCallbacks = [
  l.BooleanAttributeInputCallback,
  l.ChoiceCallback,
  l.ConfirmationCallback,
  l.KbaCreateCallback,
  l.NameCallback,
  l.NumberAttributeInputCallback,
  l.PasswordCallback,
  l.ReCaptchaCallback,
  l.SelectIdPCallback,
  l.StringAttributeInputCallback,
  l.TermsAndConditionsCallback,
  l.ValidatedCreatePasswordCallback,
  l.ValidatedCreateUsernameCallback
];
var forceUserInputOptionalityCallbacks = {
  SelectIdPCallback: (callback) => {
    const selectIdpCb = callback;
    return !!selectIdpCb.getProviders().find((provider) => provider.provider === "localAuthentication");
  }
};
function isCbReadyByDefault(callback) {
  if (callback.getType() === l.ConfirmationCallback) {
    const cb = callback;
    if (cb.getOptions().length === 1) {
      return true;
    }
  }
  return false;
}
function canForceUserInputOptionality(callback) {
  const fn = forceUserInputOptionalityCallbacks[callback.getType()];
  return fn ? fn(callback) : false;
}
function isSelfSubmitting(callback) {
  return selfSubmittingCallbacks.includes(callback.getType());
}
function isStepSelfSubmittable(callbacks, userInputOptional) {
  if (userInputOptional) {
    return true;
  }
  const unsubmittableCallbacks = callbacks.filter((callback) => callback.derived.isUserInputRequired && !callback.derived.isSelfSubmitting);
  return !unsubmittableCallbacks.length;
}
function requiresUserInput(callback) {
  if (callback.getType() === l.SelectIdPCallback) {
    return false;
  }
  if (callback.getType() === l.ConfirmationCallback) {
    const cb = callback;
    if (cb.getOptions().length === 1) {
      return false;
    }
  }
  return userInputCallbacks.includes(callback.getType());
}
function isUserInputOptional(callbackMetadataArray, numOfUserInputCbs, fn) {
  const fallbackFn = (prev, curr) => {
    if (curr.derived.canForceUserInputOptionality && numOfUserInputCbs > 0) {
      prev = true;
    }
    return prev;
  };
  return callbackMetadataArray.reduce(fn || fallbackFn, false);
}
function buildCallbackMetadata(step, checkValidation, stageJson) {
  const callbackCount = {};
  return step == null ? void 0 : step.callbacks.map((callback, idx) => {
    const cb = callback;
    const callbackType = cb.getType();
    let stageCbMetadata;
    if (callbackCount[callbackType]) {
      callbackCount[callbackType] = callbackCount[callbackType] + 1;
    } else {
      callbackCount[callbackType] = 1;
    }
    if (stageJson && stageJson[callbackType]) {
      const stageCbArray = stageJson[callbackType];
      stageCbMetadata = stageCbArray[callbackCount[callbackType] - 1];
    }
    return __spreadValues({
      derived: {
        canForceUserInputOptionality: canForceUserInputOptionality(callback),
        isFirstInvalidInput: checkValidation(callback),
        isReadyForSubmission: isCbReadyByDefault(callback),
        isSelfSubmitting: isSelfSubmitting(callback),
        isUserInputRequired: requiresUserInput(callback)
      },
      idx
    }, stageCbMetadata && {
      platform: __spreadValues({}, stageCbMetadata)
    });
  });
}
function buildStepMetadata(callbackMetadataArray, stageJson, stageName) {
  const numOfUserInputCbs = callbackMetadataArray.filter((cb) => !!cb.derived.isUserInputRequired).length;
  const userInputOptional = isUserInputOptional(callbackMetadataArray, numOfUserInputCbs);
  let stageMetadata;
  if (stageJson) {
    stageMetadata = Object.keys(stageJson).reduce((prev, curr) => {
      if (typeof stageJson[curr] !== "object") {
        prev[curr] = stageJson[curr];
      }
      return prev;
    }, {});
  }
  return __spreadValues(__spreadValues({
    derived: {
      isStepSelfSubmittable: () => isStepSelfSubmittable(callbackMetadataArray, userInputOptional),
      isUserInputOptional: userInputOptional,
      numOfCallbacks: callbackMetadataArray.length,
      numOfSelfSubmittableCbs: callbackMetadataArray.filter((cb) => !!cb.derived.isSelfSubmitting).length,
      numOfUserInputCbs
    }
  }, stageMetadata && {
    platform: __spreadValues({}, stageMetadata)
  }), stageName && {
    platform: {
      stageName
    }
  });
}
function initializeStack(initOptions) {
  const initialValue = initOptions ? [initOptions] : [];
  const { update: update2, set, subscribe: subscribe2 } = writable(initialValue);
  stack = {
    latest: async () => {
      return new Promise((resolve) => {
        subscribe2((current) => {
          const lastItem = current[current.length - 1];
          resolve(lastItem);
        })();
      });
    },
    pop: async () => {
      return new Promise((resolve) => {
        update2((current) => {
          let state;
          if (current.length) {
            state = current.slice(0, -1);
          } else {
            state = current;
          }
          resolve([...state]);
          return state;
        });
      });
    },
    push: async (options) => {
      return new Promise((resolve) => {
        update2((current) => {
          var _a;
          let state;
          if (!current.length) {
            state = [__spreadValues({}, options)];
          } else if (options && (options == null ? void 0 : options.tree) !== ((_a = current[current.length - 1]) == null ? void 0 : _a.tree)) {
            state = [...current, options];
          } else {
            state = current;
          }
          resolve([...state]);
          return state;
        });
      });
    },
    reset: () => {
      set([]);
    },
    subscribe: subscribe2
  };
  return stack;
}
var journeyStore = writable({
  completed: false,
  error: null,
  loading: false,
  metadata: null,
  step: null,
  successful: false,
  response: null,
  recaptchaAction: null
});
function initialize$4(initOptions) {
  const stack2 = initializeStack();
  let stepNumber = 0;
  async function next2(prevStep, nextOptions, resumeUrl) {
    var _a, _b, _c;
    if (!((_a = c$3.get().serverConfig) == null ? void 0 : _a.baseUrl)) {
      logErrorAndThrow("missingBaseUrl");
    }
    const options = __spreadValues(__spreadValues({}, initOptions), nextOptions);
    let previousCallbacks;
    if (prevStep && prevStep.type === r$a.Step) {
      previousCallbacks = prevStep == null ? void 0 : prevStep.callbacks;
    }
    const previousPayload = prevStep == null ? void 0 : prevStep.payload;
    let nextStep;
    journeyStore.set({
      completed: false,
      error: null,
      loading: true,
      metadata: get_store_value(journeyStore).metadata,
      step: prevStep,
      successful: false,
      response: null,
      recaptchaAction: nextOptions == null ? void 0 : nextOptions.recaptchaAction
    });
    try {
      if (resumeUrl) {
        options.tree = void 0;
        nextStep = await f$1.resume(resumeUrl, options);
      } else if (prevStep) {
        options.tree = void 0;
        nextStep = await f$1.next(prevStep, options);
      } else {
        nextStep = await f$1.start(options);
      }
    } catch (err) {
      console.error(`Next step request | ${err}`);
      nextStep = new i$9({
        message: interpolate("unknownNetworkError")
      });
    }
    if (nextStep.type === r$a.Step) {
      const stageAttribute = nextStep.getStage();
      let stageJson = null;
      let stageName = null;
      if (stageAttribute && stageAttribute.includes("{")) {
        try {
          stageJson = JSON.parse(stageAttribute);
        } catch (err) {
          console.warn("Stage attribute value was not parsable");
        }
      } else if (stageAttribute) {
        stageName = stageAttribute;
      }
      const callbackMetadata = buildCallbackMetadata(nextStep, initCheckValidation(), stageJson);
      const stepMetadata = buildStepMetadata(callbackMetadata, stageJson, stageName);
      stepNumber = stepNumber + 1;
      journeyStore.set({
        completed: false,
        error: null,
        loading: false,
        metadata: {
          callbacks: callbackMetadata,
          step: stepMetadata
        },
        step: nextStep,
        successful: false,
        response: null,
        recaptchaAction: nextOptions == null ? void 0 : nextOptions.recaptchaAction
      });
    } else if (nextStep.type === r$a.LoginSuccess) {
      stack2.reset();
      journeyStore.set({
        completed: true,
        error: null,
        loading: false,
        metadata: null,
        step: null,
        successful: true,
        response: nextStep.payload,
        recaptchaAction: nextOptions == null ? void 0 : nextOptions.recaptchaAction
      });
    } else if (nextStep.type === r$a.LoginFailure) {
      const failureMessageStr = htmlDecode(nextStep.payload.message || "Unknown login error");
      let restartedStep = null;
      try {
        const restartOptions = await stack2.latest();
        restartedStep = await f$1.next(void 0, restartOptions);
      } catch (err) {
        console.error(`Restart failed step request | ${err}`);
        restartedStep = new i$9({
          message: interpolate("unknownNetworkError")
        });
      }
      if (shouldPopulateWithPreviousCallbacks(nextStep, previousCallbacks, restartedStep, stepNumber)) {
        restartedStep = restartedStep;
        restartedStep.callbacks = previousCallbacks;
        restartedStep.payload = __spreadProps(__spreadValues({}, previousPayload), {
          authId: restartedStep.payload.authId
        });
        const details = nextStep.payload.detail;
        if ((details == null ? void 0 : details.errorCode) === authIdTimeoutErrorCode) {
          restartedStep = await f$1.next(restartedStep, options);
        }
      }
      if (restartedStep.type === r$a.Step) {
        const stageAttribute = restartedStep.getStage();
        let stageJson = null;
        let stageName = null;
        if (stageAttribute && stageAttribute.includes("{")) {
          try {
            stageJson = JSON.parse(stageAttribute);
          } catch (err) {
            console.warn("Stage attribute value was not parsable");
          }
        } else if (stageAttribute) {
          stageName = stageAttribute;
        }
        const callbackMetadata = buildCallbackMetadata(restartedStep, initCheckValidation(), stageJson);
        const stepMetadata = buildStepMetadata(callbackMetadata, stageJson, stageName);
        journeyStore.set({
          completed: false,
          error: {
            code: nextStep.getCode(),
            message: failureMessageStr,
            stage: (_b = prevStep == null ? void 0 : prevStep.payload) == null ? void 0 : _b.stage,
            troubleshoot: null
          },
          loading: false,
          metadata: {
            callbacks: callbackMetadata,
            step: stepMetadata
          },
          step: restartedStep,
          successful: false,
          response: null,
          recaptchaAction: null
        });
      } else if (restartedStep.type === r$a.LoginSuccess) {
        journeyStore.set({
          completed: true,
          error: null,
          loading: false,
          metadata: null,
          step: null,
          successful: true,
          response: restartedStep.payload,
          recaptchaAction: null
        });
      } else {
        journeyStore.set({
          completed: true,
          error: {
            code: nextStep.getCode(),
            message: failureMessageStr,
            stage: (_c = prevStep == null ? void 0 : prevStep.payload) == null ? void 0 : _c.stage,
            troubleshoot: null
          },
          loading: false,
          metadata: null,
          step: null,
          successful: false,
          response: restartedStep.payload,
          recaptchaAction: null
        });
      }
    }
  }
  async function pop() {
    reset();
    const updatedStack = await stack2.pop();
    const currentJourney = updatedStack[updatedStack.length - 1];
    await start(currentJourney);
  }
  async function push(newOptions) {
    reset();
    await stack2.push(newOptions);
    await start(newOptions);
  }
  async function resume(url2, resumeOptions) {
    await next2(void 0, resumeOptions, url2);
  }
  async function start(startOptions) {
    const configTree = c$3.get().tree;
    if (!(startOptions == null ? void 0 : startOptions.tree) && configTree) {
      if (startOptions) {
        startOptions.tree = configTree;
      } else {
        startOptions = {
          tree: configTree
        };
      }
    }
    if (!(startOptions == null ? void 0 : startOptions.recaptchaAction) && (startOptions == null ? void 0 : startOptions.tree)) {
      startOptions.recaptchaAction = startOptions.tree;
    }
    await stack2.push(startOptions);
    await next2(void 0, startOptions);
  }
  function reset() {
    journeyStore.set({
      completed: false,
      error: null,
      loading: false,
      metadata: null,
      step: null,
      successful: false,
      response: null,
      recaptchaAction: null
    });
  }
  return {
    next: next2,
    pop,
    push,
    reset,
    resume,
    start,
    subscribe: journeyStore.subscribe
  };
}
var stack;
var linksSchema = z.object({
  termsAndConditions: z.string()
}).strict();
linksSchema.partial();
var linksStore = writable();
function initialize$3(customLinks) {
  if (customLinks) {
    linksSchema.parse(customLinks);
    linksStore.set(customLinks);
  } else {
    linksStore.set(void 0);
  }
  return linksStore;
}
var authorizationTimedOut = "Authorization timed out";
var interactionNeeded = "The request requires some interaction that is not allowed.";
var timeoutErrorMessage = "Timeouts are likely an issue with OAuth client misconfiguration. If you are getting a 4xx error in the network tab, copy the full `/authorize` URL and paste it directly into your browsers URL field to directly visit the page. The error should be displayed on the page.";
var sessionCookieConsentMessage = `The user either doesn't have a valid session, the cookie is not being sent due to third-party cookies being disabled, or the user is needing to provide consent as the OAuth client setting does not have "implied consent" enabled.`;
var oauthStore = writable({
  completed: false,
  error: null,
  loading: false,
  successful: false,
  response: null
});
function getTroubleshootingMessage(message) {
  switch (message) {
    case interactionNeeded:
      return sessionCookieConsentMessage;
    case authorizationTimedOut:
      return timeoutErrorMessage;
    default:
      return "";
  }
}
function initialize$2(initOptions) {
  async function get(getOptions) {
    const options = __spreadValues(__spreadValues(__spreadValues({}, { query: { prompt: "none" } }), initOptions), getOptions);
    let tokens;
    oauthStore.set({
      completed: false,
      error: null,
      loading: true,
      successful: false,
      response: null
    });
    try {
      tokens = await T$2.getTokens(options);
    } catch (err) {
      if (err instanceof Error) {
        oauthStore.set({
          completed: true,
          error: {
            message: err.message,
            troubleshoot: getTroubleshootingMessage(err.message)
          },
          loading: false,
          successful: false,
          response: null
        });
      }
      return;
    }
    oauthStore.set({
      completed: true,
      error: null,
      loading: false,
      successful: true,
      response: tokens
    });
  }
  function reset() {
    oauthStore.set({
      completed: false,
      error: null,
      loading: false,
      successful: false,
      response: null
    });
  }
  return {
    get,
    reset,
    subscribe: oauthStore.subscribe
  };
}
var userStore = writable({
  completed: false,
  error: null,
  loading: false,
  successful: false,
  response: null
});
function initialize$1(initOptions) {
  async function get(getOptions) {
    const options = __spreadValues(__spreadValues({}, initOptions), getOptions);
    userStore.set({
      completed: false,
      error: null,
      loading: true,
      successful: false,
      response: null
    });
    try {
      const user2 = await a4.getCurrentUser(options);
      userStore.set({
        completed: true,
        error: null,
        loading: false,
        successful: true,
        response: user2
      });
    } catch (err) {
      if (err instanceof Error) {
        userStore.set({
          completed: true,
          error: {
            message: err.message,
            troubleshoot: null
          },
          loading: false,
          successful: false,
          response: null
        });
      }
    }
  }
  function reset() {
    userStore.set({
      completed: false,
      error: null,
      loading: false,
      successful: false,
      response: null
    });
  }
  return {
    get,
    reset,
    subscribe: userStore.subscribe
  };
}
var logoSchema = z.object({
  dark: z.string().optional(),
  height: z.number().optional(),
  light: z.string().optional(),
  width: z.number().optional()
}).strict();
var styleSchema = z.object({
  checksAndRadios: z.union([z.literal("animated"), z.literal("standard")]).optional(),
  labels: z.union([z.literal("floating").optional(), z.literal("stacked")]).optional(),
  showPassword: z.union([z.literal("none"), z.literal("button"), z.literal("checkbox")]).optional(),
  logo: logoSchema.optional(),
  sections: z.object({
    header: z.boolean().optional()
  }).strict().optional(),
  stage: z.object({
    icon: z.boolean().optional()
  }).strict().optional()
}).strict();
styleSchema.partial();
var fallbackStyles = {
  checksAndRadios: "animated",
  labels: "floating",
  showPassword: "button",
  logo: void 0,
  sections: void 0,
  stage: void 0
};
var styleStore = writable(fallbackStyles);
function initialize(customStyle) {
  if (customStyle) {
    const accessStrictType = (str) => {
      return customStyle[str];
    };
    const newStyleConfig = Object.keys(customStyle).reduce((acc, key) => {
      if (accessStrictType(key) === void 0 || accessStrictType(key) === null) {
        return acc;
      }
      return __spreadProps(__spreadValues({}, acc), { [key]: accessStrictType(key) });
    }, fallbackStyles);
    styleStore.set(newStyleConfig);
  } else {
    styleStore.set(fallbackStyles);
  }
  return styleStore;
}
function widgetApiFactory(componentApi2) {
  let journeyStore2;
  let oauthStore2;
  let userStore2;
  function getStores() {
    return {
      journeyStore: journeyStore2,
      oauthStore: oauthStore2,
      userStore: userStore2
    };
  }
  function resetAndRestartStores() {
    journeyStore2.reset();
    oauthStore2.reset();
    userStore2.reset();
  }
  const configuration2 = (options) => {
    if (options == null ? void 0 : options.forgerock) {
      configure(__spreadValues(__spreadValues(__spreadValues({}, {
        // TODO: Could this be a default OAuth client provided by Platform UI OOTB?
        clientId: "WebLoginWidgetClient",
        // TODO: If a realmPath is not provided, should we call the realm endpoint and detect a likely default?
        // https://backstage.forgerock.com/docs/am/7/setup-guide/sec-rest-realm-rest.html#rest-api-list-realm
        realmPath: "alpha",
        // TODO: Once we move to SSR, this default should be more intelligent
        redirectUri: typeof window === "object" ? (
          // Construct URL with origin and path only, stripping off hash and query params
          `${window.location.origin}${window.location.pathname}`
        ) : "https://localhost:3000/callback",
        scope: "openid email"
      }), options == null ? void 0 : options.forgerock), { support: "legacy" }));
    }
    journeyStore2 = initialize$4(options == null ? void 0 : options.forgerock);
    oauthStore2 = initialize$2(options == null ? void 0 : options.forgerock);
    userStore2 = initialize$1(options == null ? void 0 : options.forgerock);
    initialize$5(options == null ? void 0 : options.content);
    initialize$6(options == null ? void 0 : options.journeys);
    initialize$3(options == null ? void 0 : options.links);
    initialize(options == null ? void 0 : options.style);
    return {
      /** Set the Login Widget's Configuration
       * @param {WidgetConfigOptions} options - The configuration options for the Login Widget
       * @returns {void}
       **/
      set(setOptions) {
        if (setOptions == null ? void 0 : setOptions.forgerock) {
          configure(__spreadValues(__spreadValues(__spreadValues({}, {
            // TODO: Could this be a default OAuth client provided by Platform UI OOTB?
            clientId: "WebLoginWidgetClient",
            // TODO: If a realmPath is not provided, should we call the realm endpoint and detect a likely default?
            // https://backstage.forgerock.com/docs/am/7/setup-guide/sec-rest-realm-rest.html#rest-api-list-realm
            realmPath: "alpha",
            // TODO: Once we move to SSR, this default should be more intelligent
            redirectUri: typeof window === "object" ? window.location.href : "https://localhost:3000/callback",
            scope: "openid email"
          }), setOptions == null ? void 0 : setOptions.forgerock), { support: "legacy" }));
        }
        journeyStore2 = initialize$4(setOptions == null ? void 0 : setOptions.forgerock);
        oauthStore2 = initialize$2(setOptions == null ? void 0 : setOptions.forgerock);
        userStore2 = initialize$1(setOptions == null ? void 0 : setOptions.forgerock);
        initialize$5(setOptions == null ? void 0 : setOptions.content);
        initialize$6(setOptions == null ? void 0 : setOptions.journeys);
        initialize$3(setOptions == null ? void 0 : setOptions.links);
        initialize(setOptions == null ? void 0 : setOptions.style);
      }
    };
  };
  const journey2 = (options) => {
    var _a, _b;
    if (!journeyStore2 || !oauthStore2 || !userStore2) {
      logErrorAndThrow("missingStores");
    }
    const requestsOauth = (_a = options == null ? void 0 : options.oauth) != null ? _a : true;
    const requestsUser = (_b = options == null ? void 0 : options.user) != null ? _b : true;
    const { subscribe: subscribe2 } = derived([journeyStore2, oauthStore2, userStore2], ([$journeyStore, $oauthStore, $userStore], set) => {
      set({
        journey: $journeyStore,
        oauth: $oauthStore,
        user: $userStore
      });
      if ($oauthStore.error || $userStore.error) {
        formFactor === "modal" && componentApi2.close({ reason: "auto" });
      }
      if ($journeyStore.successful && $oauthStore.successful && $userStore.completed) {
        formFactor === "modal" && componentApi2.close({ reason: "auto" });
      } else if ($journeyStore.successful && $oauthStore.successful) {
        if (requestsUser && $userStore.loading === false && $userStore.completed === false) {
          userStore2.get();
        } else if (!requestsUser) {
          formFactor === "modal" && componentApi2.close({ reason: "auto" });
        }
      } else if ($journeyStore.successful) {
        if (requestsOauth && $oauthStore.loading === false && $oauthStore.completed === false) {
          oauthStore2.get();
        } else if (!requestsOauth) {
          formFactor === "modal" && componentApi2.close({ reason: "auto" });
        }
      }
    });
    let formFactor = null;
    function change(changeOptions) {
      return start(changeOptions);
    }
    function start(startOptions) {
      oauthStore2.reset();
      userStore2.reset();
      formFactor = get_store_value(componentStore).type;
      if (startOptions == null ? void 0 : startOptions.resumeUrl) {
        journeyStore2.resume(startOptions.resumeUrl);
      } else {
        journeyStore2.start(__spreadValues(__spreadValues({
          recaptchaAction: startOptions == null ? void 0 : startOptions.recaptchaAction
        }, startOptions == null ? void 0 : startOptions.forgerock), (startOptions == null ? void 0 : startOptions.journey) && { tree: startOptions == null ? void 0 : startOptions.journey }));
      }
      return new Promise((resolve, reject) => {
        const unsubscribe = subscribe2((event) => {
          if (event.oauth.error || event.user.error) {
            reject(event);
            unsubscribe();
          }
          if (event.journey.successful && event.oauth.successful && event.user.completed) {
            resolve(event);
            unsubscribe();
          } else if (event.journey.successful && event.oauth.successful) {
            if (!requestsUser) {
              resolve(event);
              unsubscribe();
            }
          } else if (event.journey.successful) {
            if (!requestsOauth) {
              resolve(event);
              unsubscribe();
            }
          }
        });
      });
    }
    return { change, start, subscribe: subscribe2 };
  };
  const user2 = {
    /**
     * User Info
     * @param: void
     * @returns: UserStore
     */
    info() {
      if (!journeyStore2 || !oauthStore2 || !userStore2) {
        logErrorAndThrow("missingStores");
      }
      const { get, subscribe: subscribe2 } = userStore2;
      function wrappedGet(options) {
        get(options);
        return new Promise((resolve, reject) => {
          const unsubscribe = userStore2.subscribe((event) => {
            if (event.successful) {
              resolve(event);
              unsubscribe();
            } else if (event.error) {
              reject(event);
              unsubscribe();
            }
          });
        });
      }
      return { get: wrappedGet, subscribe: subscribe2 };
    },
    /**
     * Logout a user from an AM Session
     * @async
     * @param: void
     * @returns: Promise<void>
     **/
    async logout() {
      if (!journeyStore2 || !oauthStore2 || !userStore2) {
        logErrorAndThrow("missingStores");
      }
      const { clientId } = c$3.get();
      let obj;
      if (clientId) {
        obj = k;
      } else {
        obj = M$1;
      }
      try {
        await obj.logout();
        resetAndRestartStores();
      } catch (err) {
        resetAndRestartStores();
        throw err;
      }
      return;
    },
    /**
     * Returns the widget's Tokens object
     * @param void;
     * @returns OAuthStore
     */
    tokens() {
      if (!journeyStore2 || !oauthStore2 || !userStore2) {
        logErrorAndThrow("missingStores");
      }
      const { get, subscribe: subscribe2 } = oauthStore2;
      function wrappedGet(options) {
        get(options);
        return new Promise((resolve, reject) => {
          const unsubscribe = oauthStore2.subscribe((event) => {
            if (event.successful) {
              resolve(event);
              unsubscribe();
            } else if (event.error) {
              reject(event);
              unsubscribe();
            }
          });
        });
      }
      return { get: wrappedGet, subscribe: subscribe2 };
    }
  };
  return {
    component: componentApi2,
    configuration: configuration2,
    getStores,
    journey: journey2,
    protect: {
      start: e.start.bind(e),
      getData: e.getData.bind(e),
      pauseBehavioralData: e.pauseBehavioralData.bind(e),
      resumeBehavioralData: e.resumeBehavioralData.bind(e)
    },
    request: D.request.bind(D),
    user: user2
  };
}
function create_else_block$d(ctx) {
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[5].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[4],
    null
  );
  const default_slot_or_fallback = default_slot || fallback_block_1$1(ctx);
  return {
    c() {
      if (default_slot_or_fallback) default_slot_or_fallback.c();
    },
    m(target, anchor) {
      if (default_slot_or_fallback) {
        default_slot_or_fallback.m(target, anchor);
      }
      current = true;
    },
    p(ctx2, dirty) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        16)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[4],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[4]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[4],
              dirty,
              null
            ),
            null
          );
        }
      } else {
        if (default_slot_or_fallback && default_slot_or_fallback.p && (!current || dirty & /*message*/
        2)) {
          default_slot_or_fallback.p(ctx2, !current ? -1 : dirty);
        }
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot_or_fallback, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot_or_fallback, local);
      current = false;
    },
    d(detaching) {
      if (default_slot_or_fallback) default_slot_or_fallback.d(detaching);
    }
  };
}
function create_if_block$x(ctx) {
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[5].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[4],
    null
  );
  const default_slot_or_fallback = default_slot || fallback_block$2(ctx);
  return {
    c() {
      if (default_slot_or_fallback) default_slot_or_fallback.c();
    },
    m(target, anchor) {
      if (default_slot_or_fallback) {
        default_slot_or_fallback.m(target, anchor);
      }
      current = true;
    },
    p(ctx2, dirty) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        16)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[4],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[4]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[4],
              dirty,
              null
            ),
            null
          );
        }
      } else {
        if (default_slot_or_fallback && default_slot_or_fallback.p && (!current || dirty & /*message*/
        2)) {
          default_slot_or_fallback.p(ctx2, !current ? -1 : dirty);
        }
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot_or_fallback, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot_or_fallback, local);
      current = false;
    },
    d(detaching) {
      if (default_slot_or_fallback) default_slot_or_fallback.d(detaching);
    }
  };
}
function fallback_block_1$1(ctx) {
  let t3;
  return {
    c() {
      t3 = text(
        /*message*/
        ctx[1]
      );
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*message*/
      2) set_data(
        t3,
        /*message*/
        ctx2[1]
      );
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function fallback_block$2(ctx) {
  let html_tag;
  let html_anchor;
  return {
    c() {
      html_tag = new HtmlTag(false);
      html_anchor = empty();
      html_tag.a = html_anchor;
    },
    m(target, anchor) {
      html_tag.m(
        /*message*/
        ctx[1],
        target,
        anchor
      );
      insert(target, html_anchor, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*message*/
      2) html_tag.p(
        /*message*/
        ctx2[1]
      );
    },
    d(detaching) {
      if (detaching) detach(html_anchor);
      if (detaching) html_tag.d();
    }
  };
}
function create_fragment$1a(ctx) {
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block$x, create_else_block$d];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*html*/
      ctx2[0]
    ) return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(if_block_anchor.parentNode, if_block_anchor);
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if_blocks[current_block_type_index].d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function instance$1c($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { html = false } = $$props;
  let { key } = $$props;
  let { values = void 0 } = $$props;
  let message;
  $$self.$$set = ($$props2) => {
    if ("html" in $$props2) $$invalidate(0, html = $$props2.html);
    if ("key" in $$props2) $$invalidate(2, key = $$props2.key);
    if ("values" in $$props2) $$invalidate(3, values = $$props2.values);
    if ("$$scope" in $$props2) $$invalidate(4, $$scope = $$props2.$$scope);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*key, values*/
    12) {
      {
        $$invalidate(1, message = interpolate(key, values));
      }
    }
  };
  return [html, message, key, values, $$scope, slots];
}
var Locale_strings = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$1c, create_fragment$1a, safe_not_equal, { html: 0, key: 2, values: 3 });
  }
};
function create_fragment$19(ctx) {
  let svg;
  let path;
  let title;
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[3].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[2],
    null
  );
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      title = svg_element("title");
      if (default_slot) default_slot.c();
      attr(path, "d", "M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z");
      attr(
        svg,
        "class",
        /*classes*/
        ctx[0]
      );
      attr(
        svg,
        "height",
        /*size*/
        ctx[1]
      );
      attr(svg, "viewBox", "0 0 30 30");
      attr(
        svg,
        "width",
        /*size*/
        ctx[1]
      );
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
      append(svg, title);
      if (default_slot) {
        default_slot.m(title, null);
      }
      current = true;
    },
    p(ctx2, [dirty]) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        4)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[2],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[2]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[2],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (!current || dirty & /*classes*/
      1) {
        attr(
          svg,
          "class",
          /*classes*/
          ctx2[0]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "height",
          /*size*/
          ctx2[1]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "width",
          /*size*/
          ctx2[1]
        );
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(svg);
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function instance$1b($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { classes = "" } = $$props;
  let { size = "24px" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("classes" in $$props2) $$invalidate(0, classes = $$props2.classes);
    if ("size" in $$props2) $$invalidate(1, size = $$props2.size);
    if ("$$scope" in $$props2) $$invalidate(2, $$scope = $$props2.$$scope);
  };
  return [classes, size, $$scope, slots];
}
var X_icon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$1b, create_fragment$19, safe_not_equal, { classes: 0, size: 1 });
  }
};
function create_else_block$c(ctx) {
  var _a;
  let div;
  let button;
  let xicon;
  let t3;
  let div_class_value;
  let current;
  let mounted;
  let dispose;
  xicon = new X_icon({
    props: {
      classes: "tw_inline-block tw_fill-current tw_text-secondary-dark dark:tw_text-secondary-light",
      $$slots: { default: [create_default_slot_1$i] },
      $$scope: { ctx }
    }
  });
  let if_block = (
    /*$styleStore*/
    ((_a = ctx[5]) == null ? void 0 : _a.logo) && create_if_block_1$h(ctx)
  );
  return {
    c() {
      var _a2;
      div = element("div");
      button = element("button");
      create_component(xicon.$$.fragment);
      t3 = space();
      if (if_block) if_block.c();
      attr(button, "class", "tw_dialog-x md:tw_dialog-x_medium tw_focusable-element dark:tw_focusable-element_dark");
      attr(
        button,
        "aria-controls",
        /*dialogId*/
        ctx[1]
      );
      attr(div, "class", div_class_value = `tw_pt-10 md:tw_pt-10 tw_text-right ${/*$styleStore*/
      ((_a2 = ctx[5]) == null ? void 0 : _a2.logo) ? "tw_h-32 md:tw_h-36 tw_pb-6" : ""}`);
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, button);
      mount_component(xicon, button, null);
      append(div, t3);
      if (if_block) if_block.m(div, null);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler_1*/
          ctx[8]
        );
        mounted = true;
      }
    },
    p(ctx2, dirty) {
      var _a2, _b;
      const xicon_changes = {};
      if (dirty & /*$$scope*/
      1024) {
        xicon_changes.$$scope = { dirty, ctx: ctx2 };
      }
      xicon.$set(xicon_changes);
      if (!current || dirty & /*dialogId*/
      2) {
        attr(
          button,
          "aria-controls",
          /*dialogId*/
          ctx2[1]
        );
      }
      if (
        /*$styleStore*/
        (_a2 = ctx2[5]) == null ? void 0 : _a2.logo
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
        } else {
          if_block = create_if_block_1$h(ctx2);
          if_block.c();
          if_block.m(div, null);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
      if (!current || dirty & /*$styleStore*/
      32 && div_class_value !== (div_class_value = `tw_pt-10 md:tw_pt-10 tw_text-right ${/*$styleStore*/
      ((_b = ctx2[5]) == null ? void 0 : _b.logo) ? "tw_h-32 md:tw_h-36 tw_pb-6" : ""}`)) {
        attr(div, "class", div_class_value);
      }
    },
    i(local) {
      if (current) return;
      transition_in(xicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(xicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(xicon);
      if (if_block) if_block.d();
      mounted = false;
      dispose();
    }
  };
}
function create_if_block$w(ctx) {
  let div1;
  let div0;
  let div0_style_value;
  let t3;
  let button;
  let xicon;
  let current;
  let mounted;
  let dispose;
  xicon = new X_icon({
    props: {
      classes: "tw_inline-block tw_fill-current tw_text-secondary-dark dark:tw_text-secondary-light",
      $$slots: { default: [create_default_slot$w] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
      div1 = element("div");
      div0 = element("div");
      t3 = space();
      button = element("button");
      create_component(xicon.$$.fragment);
      attr(div0, "class", "tw_dialog-logo dark:tw_dialog-logo_dark");
      attr(div0, "style", div0_style_value = `--logo-dark: url("${/*$styleStore*/
      (_b = (_a = ctx[5]) == null ? void 0 : _a.logo) == null ? void 0 : _b.dark}"); --logo-light: url("${/*$styleStore*/
      (_d = (_c = ctx[5]) == null ? void 0 : _c.logo) == null ? void 0 : _d.light}"); ${/*$styleStore*/
      ((_f = (_e = ctx[5]) == null ? void 0 : _e.logo) == null ? void 0 : _f.height) ? `height: ${/*$styleStore*/
      (_g = ctx[5]) == null ? void 0 : _g.logo.height}px;` : ""} ${/*$styleStore*/
      ((_i = (_h = ctx[5]) == null ? void 0 : _h.logo) == null ? void 0 : _i.width) ? `width: ${/*$styleStore*/
      (_j = ctx[5]) == null ? void 0 : _j.logo.width}px;` : ""}`);
      attr(button, "class", "tw_dialog-x md:tw_dialog-x_medium tw_focusable-element dark:tw_focusable-element_dark");
      attr(
        button,
        "aria-controls",
        /*dialogId*/
        ctx[1]
      );
      attr(button, "aria-label", "Close");
      attr(div1, "class", "tw_dialog-header dark:tw_dialog-header_dark");
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, div0);
      append(div1, t3);
      append(div1, button);
      mount_component(xicon, button, null);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*click_handler*/
          ctx[7]
        );
        mounted = true;
      }
    },
    p(ctx2, dirty) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
      if (!current || dirty & /*$styleStore*/
      32 && div0_style_value !== (div0_style_value = `--logo-dark: url("${/*$styleStore*/
      (_b = (_a = ctx2[5]) == null ? void 0 : _a.logo) == null ? void 0 : _b.dark}"); --logo-light: url("${/*$styleStore*/
      (_d = (_c = ctx2[5]) == null ? void 0 : _c.logo) == null ? void 0 : _d.light}"); ${/*$styleStore*/
      ((_f = (_e = ctx2[5]) == null ? void 0 : _e.logo) == null ? void 0 : _f.height) ? `height: ${/*$styleStore*/
      (_g = ctx2[5]) == null ? void 0 : _g.logo.height}px;` : ""} ${/*$styleStore*/
      ((_i = (_h = ctx2[5]) == null ? void 0 : _h.logo) == null ? void 0 : _i.width) ? `width: ${/*$styleStore*/
      (_j = ctx2[5]) == null ? void 0 : _j.logo.width}px;` : ""}`)) {
        attr(div0, "style", div0_style_value);
      }
      const xicon_changes = {};
      if (dirty & /*$$scope*/
      1024) {
        xicon_changes.$$scope = { dirty, ctx: ctx2 };
      }
      xicon.$set(xicon_changes);
      if (!current || dirty & /*dialogId*/
      2) {
        attr(
          button,
          "aria-controls",
          /*dialogId*/
          ctx2[1]
        );
      }
    },
    i(local) {
      if (current) return;
      transition_in(xicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(xicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div1);
      destroy_component(xicon);
      mounted = false;
      dispose();
    }
  };
}
function create_default_slot_1$i(ctx) {
  let t3;
  let current;
  t3 = new Locale_strings({ props: { key: "closeModal" } });
  return {
    c() {
      create_component(t3.$$.fragment);
    },
    m(target, anchor) {
      mount_component(t3, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(t3, detaching);
    }
  };
}
function create_if_block_1$h(ctx) {
  let div;
  let div_style_value;
  return {
    c() {
      var _a, _b, _c, _d;
      div = element("div");
      attr(div, "class", "tw_dialog-logo dark:tw_dialog-logo_dark");
      attr(div, "style", div_style_value = `--logo-dark: url("${/*$styleStore*/
      (_b = (_a = ctx[5]) == null ? void 0 : _a.logo) == null ? void 0 : _b.dark}"); --logo-light: url("${/*$styleStore*/
      (_d = (_c = ctx[5]) == null ? void 0 : _c.logo) == null ? void 0 : _d.light}")`);
    },
    m(target, anchor) {
      insert(target, div, anchor);
    },
    p(ctx2, dirty) {
      var _a, _b, _c, _d;
      if (dirty & /*$styleStore*/
      32 && div_style_value !== (div_style_value = `--logo-dark: url("${/*$styleStore*/
      (_b = (_a = ctx2[5]) == null ? void 0 : _a.logo) == null ? void 0 : _b.dark}"); --logo-light: url("${/*$styleStore*/
      (_d = (_c = ctx2[5]) == null ? void 0 : _c.logo) == null ? void 0 : _d.light}")`)) {
        attr(div, "style", div_style_value);
      }
    },
    d(detaching) {
      if (detaching) detach(div);
    }
  };
}
function create_default_slot$w(ctx) {
  let t3;
  let current;
  t3 = new Locale_strings({ props: { key: "closeModal" } });
  return {
    c() {
      create_component(t3.$$.fragment);
    },
    m(target, anchor) {
      mount_component(t3, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(t3, detaching);
    }
  };
}
function create_fragment$18(ctx) {
  let dialog;
  let current_block_type_index;
  let if_block;
  let t3;
  let div;
  let dialog_class_value;
  let current;
  const if_block_creators = [create_if_block$w, create_else_block$c];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*withHeader*/
      ctx2[3]
    ) return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  const default_slot_template = (
    /*#slots*/
    ctx[6].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[10],
    null
  );
  return {
    c() {
      dialog = element("dialog");
      if_block.c();
      t3 = space();
      div = element("div");
      if (default_slot) default_slot.c();
      attr(div, "class", "tw_dialog-body");
      attr(
        dialog,
        "id",
        /*dialogId*/
        ctx[1]
      );
      attr(dialog, "class", dialog_class_value = `tw_dialog-box dark:tw_dialog-box_dark md:tw_dialog-box_medium ${/*forceOpen*/
      ctx[2] ? "" : "tw_dialog-box_animate"}`);
      dialog.open = /*forceOpen*/
      ctx[2];
    },
    m(target, anchor) {
      insert(target, dialog, anchor);
      if_blocks[current_block_type_index].m(dialog, null);
      append(dialog, t3);
      append(dialog, div);
      if (default_slot) {
        default_slot.m(div, null);
      }
      ctx[9](dialog);
      current = true;
    },
    p(ctx2, [dirty]) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(dialog, t3);
      }
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        1024)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[10],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[10]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[10],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (!current || dirty & /*dialogId*/
      2) {
        attr(
          dialog,
          "id",
          /*dialogId*/
          ctx2[1]
        );
      }
      if (!current || dirty & /*forceOpen*/
      4 && dialog_class_value !== (dialog_class_value = `tw_dialog-box dark:tw_dialog-box_dark md:tw_dialog-box_medium ${/*forceOpen*/
      ctx2[2] ? "" : "tw_dialog-box_animate"}`)) {
        attr(dialog, "class", dialog_class_value);
      }
      if (!current || dirty & /*forceOpen*/
      4) {
        dialog.open = /*forceOpen*/
        ctx2[2];
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(dialog);
      if_blocks[current_block_type_index].d();
      if (default_slot) default_slot.d(detaching);
      ctx[9](null);
    }
  };
}
function instance$1a($$self, $$props, $$invalidate) {
  let $styleStore;
  component_subscribe($$self, styleStore, ($$value) => $$invalidate(5, $styleStore = $$value));
  let { $$slots: slots = {}, $$scope } = $$props;
  let { dialogEl = null } = $$props;
  let { dialogId } = $$props;
  let { forceOpen = false } = $$props;
  let { withHeader = false } = $$props;
  function closeDialog(reason) {
    function completeClose() {
      dialogEl == null ? void 0 : dialogEl.close();
      dialogEl == null ? void 0 : dialogEl.classList.remove("tw_dialog-closing");
      closeComponent({ reason });
    }
    const fallbackTimer = setTimeout(completeClose, 500);
    dialogEl == null ? void 0 : dialogEl.addEventListener(
      "animationstart",
      () => {
        clearTimeout(fallbackTimer);
      },
      { once: true }
    );
    dialogEl == null ? void 0 : dialogEl.addEventListener("animationend", completeClose, { once: true });
    dialogEl == null ? void 0 : dialogEl.classList.add("tw_dialog-closing");
  }
  const click_handler = () => closeDialog("user");
  const click_handler_1 = () => closeDialog("user");
  function dialog_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      dialogEl = $$value;
      $$invalidate(0, dialogEl);
    });
  }
  $$self.$$set = ($$props2) => {
    if ("dialogEl" in $$props2) $$invalidate(0, dialogEl = $$props2.dialogEl);
    if ("dialogId" in $$props2) $$invalidate(1, dialogId = $$props2.dialogId);
    if ("forceOpen" in $$props2) $$invalidate(2, forceOpen = $$props2.forceOpen);
    if ("withHeader" in $$props2) $$invalidate(3, withHeader = $$props2.withHeader);
    if ("$$scope" in $$props2) $$invalidate(10, $$scope = $$props2.$$scope);
  };
  return [
    dialogEl,
    dialogId,
    forceOpen,
    withHeader,
    closeDialog,
    $styleStore,
    slots,
    click_handler,
    click_handler_1,
    dialog_binding,
    $$scope
  ];
}
var Dialog = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$1a, create_fragment$18, safe_not_equal, {
      dialogEl: 0,
      dialogId: 1,
      forceOpen: 2,
      withHeader: 3,
      closeDialog: 4
    });
  }
  get closeDialog() {
    return this.$$.ctx[4];
  }
};
function create_fragment$17(ctx) {
  let svg;
  let path;
  let title;
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[3].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[2],
    null
  );
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      title = svg_element("title");
      if (default_slot) default_slot.c();
      attr(path, "d", "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z");
      attr(
        svg,
        "class",
        /*classes*/
        ctx[0]
      );
      attr(
        svg,
        "height",
        /*size*/
        ctx[1]
      );
      attr(
        svg,
        "width",
        /*size*/
        ctx[1]
      );
      attr(svg, "viewBox", "0 0 16 16");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
      append(svg, title);
      if (default_slot) {
        default_slot.m(title, null);
      }
      current = true;
    },
    p(ctx2, [dirty]) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        4)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[2],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[2]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[2],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (!current || dirty & /*classes*/
      1) {
        attr(
          svg,
          "class",
          /*classes*/
          ctx2[0]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "height",
          /*size*/
          ctx2[1]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "width",
          /*size*/
          ctx2[1]
        );
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(svg);
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function instance$19($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { classes = "" } = $$props;
  let { size = "24px" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("classes" in $$props2) $$invalidate(0, classes = $$props2.classes);
    if ("size" in $$props2) $$invalidate(1, size = $$props2.size);
    if ("$$scope" in $$props2) $$invalidate(2, $$scope = $$props2.$$scope);
  };
  return [classes, size, $$scope, slots];
}
var Alert_icon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$19, create_fragment$17, safe_not_equal, { classes: 0, size: 1 });
  }
};
function create_fragment$16(ctx) {
  let svg;
  let path;
  let title;
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[3].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[2],
    null
  );
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      title = svg_element("title");
      if (default_slot) default_slot.c();
      attr(path, "d", "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z");
      attr(
        svg,
        "class",
        /*classes*/
        ctx[0]
      );
      attr(
        svg,
        "height",
        /*size*/
        ctx[1]
      );
      attr(
        svg,
        "width",
        /*size*/
        ctx[1]
      );
      attr(svg, "viewBox", "0 0 16 16");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
      append(svg, title);
      if (default_slot) {
        default_slot.m(title, null);
      }
      current = true;
    },
    p(ctx2, [dirty]) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        4)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[2],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[2]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[2],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (!current || dirty & /*classes*/
      1) {
        attr(
          svg,
          "class",
          /*classes*/
          ctx2[0]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "height",
          /*size*/
          ctx2[1]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "width",
          /*size*/
          ctx2[1]
        );
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(svg);
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function instance$18($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { classes = "" } = $$props;
  let { size = "24px" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("classes" in $$props2) $$invalidate(0, classes = $$props2.classes);
    if ("size" in $$props2) $$invalidate(1, size = $$props2.size);
    if ("$$scope" in $$props2) $$invalidate(2, $$scope = $$props2.$$scope);
  };
  return [classes, size, $$scope, slots];
}
var Info_icon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$18, create_fragment$16, safe_not_equal, { classes: 0, size: 1 });
  }
};
function create_fragment$15(ctx) {
  let svg;
  let path;
  let title;
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[3].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[2],
    null
  );
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      title = svg_element("title");
      if (default_slot) default_slot.c();
      attr(path, "d", "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z");
      attr(
        svg,
        "class",
        /*classes*/
        ctx[0]
      );
      attr(
        svg,
        "height",
        /*size*/
        ctx[1]
      );
      attr(
        svg,
        "width",
        /*size*/
        ctx[1]
      );
      attr(svg, "viewBox", "0 0 16 16");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
      append(svg, title);
      if (default_slot) {
        default_slot.m(title, null);
      }
      current = true;
    },
    p(ctx2, [dirty]) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        4)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[2],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[2]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[2],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (!current || dirty & /*classes*/
      1) {
        attr(
          svg,
          "class",
          /*classes*/
          ctx2[0]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "height",
          /*size*/
          ctx2[1]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "width",
          /*size*/
          ctx2[1]
        );
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(svg);
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function instance$17($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { classes = "" } = $$props;
  let { size = "24px" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("classes" in $$props2) $$invalidate(0, classes = $$props2.classes);
    if ("size" in $$props2) $$invalidate(1, size = $$props2.size);
    if ("$$scope" in $$props2) $$invalidate(2, $$scope = $$props2.$$scope);
  };
  return [classes, size, $$scope, slots];
}
var Warning_icon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$17, create_fragment$15, safe_not_equal, { classes: 0, size: 1 });
  }
};
function create_else_block$b(ctx) {
  let infoicon;
  let current;
  infoicon = new Info_icon({});
  return {
    c() {
      create_component(infoicon.$$.fragment);
    },
    m(target, anchor) {
      mount_component(infoicon, target, anchor);
      current = true;
    },
    i(local) {
      if (current) return;
      transition_in(infoicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(infoicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(infoicon, detaching);
    }
  };
}
function create_if_block_1$g(ctx) {
  let warningicon;
  let current;
  warningicon = new Warning_icon({});
  return {
    c() {
      create_component(warningicon.$$.fragment);
    },
    m(target, anchor) {
      mount_component(warningicon, target, anchor);
      current = true;
    },
    i(local) {
      if (current) return;
      transition_in(warningicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(warningicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(warningicon, detaching);
    }
  };
}
function create_if_block$v(ctx) {
  let alerticon;
  let current;
  alerticon = new Alert_icon({});
  return {
    c() {
      create_component(alerticon.$$.fragment);
    },
    m(target, anchor) {
      mount_component(alerticon, target, anchor);
      current = true;
    },
    i(local) {
      if (current) return;
      transition_in(alerticon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(alerticon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(alerticon, detaching);
    }
  };
}
function create_fragment$14(ctx) {
  let div;
  let p4;
  let current_block_type_index;
  let if_block;
  let t3;
  let span;
  let div_class_value;
  let div_role_value;
  let current;
  const if_block_creators = [create_if_block$v, create_if_block_1$g, create_else_block$b];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*type*/
      ctx2[1] === "error"
    ) return 0;
    if (
      /*type*/
      ctx2[1] === "warning"
    ) return 1;
    return 2;
  }
  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  const default_slot_template = (
    /*#slots*/
    ctx[5].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[4],
    null
  );
  return {
    c() {
      div = element("div");
      p4 = element("p");
      if_block.c();
      t3 = space();
      span = element("span");
      if (default_slot) default_slot.c();
      attr(p4, "class", "tw_grid tw_grid-cols-[2em_1fr]");
      attr(div, "class", div_class_value = `${generateClassString$3(
        /*type*/
        ctx[1]
      )} tw_alert dark:tw_alert_dark tw_input-spacing tw_outline-none`);
      attr(
        div,
        "id",
        /*id*/
        ctx[0]
      );
      attr(div, "tabindex", "-1");
      attr(div, "role", div_role_value = /*type*/
      ctx[1] === "error" ? "alert" : "");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, p4);
      if_blocks[current_block_type_index].m(p4, null);
      append(p4, t3);
      append(p4, span);
      if (default_slot) {
        default_slot.m(span, null);
      }
      ctx[6](div);
      current = true;
    },
    p(ctx2, [dirty]) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index !== previous_block_index) {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        }
        transition_in(if_block, 1);
        if_block.m(p4, t3);
      }
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        16)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[4],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[4]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[4],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (!current || dirty & /*type*/
      2 && div_class_value !== (div_class_value = `${generateClassString$3(
        /*type*/
        ctx2[1]
      )} tw_alert dark:tw_alert_dark tw_input-spacing tw_outline-none`)) {
        attr(div, "class", div_class_value);
      }
      if (!current || dirty & /*id*/
      1) {
        attr(
          div,
          "id",
          /*id*/
          ctx2[0]
        );
      }
      if (!current || dirty & /*type*/
      2 && div_role_value !== (div_role_value = /*type*/
      ctx2[1] === "error" ? "alert" : "")) {
        attr(div, "role", div_role_value);
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      if_blocks[current_block_type_index].d();
      if (default_slot) default_slot.d(detaching);
      ctx[6](null);
    }
  };
}
function generateClassString$3(...args) {
  return args.reduce(
    (prev, curr) => {
      switch (curr) {
        case "error":
          return `${prev} tw_alert-error dark:tw_alert-error_dark`;
        case "info":
          return `${prev} tw_alert-info dark:tw_alert-info_dark`;
        case "success":
          return `${prev} tw_alert-success dark:tw_alert-success_dark`;
        case "warning":
          return `${prev} tw_alert-warning dark:tw_alert-warning_dark`;
        default:
          return prev;
      }
    },
    ""
  );
}
function instance$16($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { id } = $$props;
  let { needsFocus = false } = $$props;
  let { type = "" } = $$props;
  let divEl;
  function div_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      divEl = $$value;
      $$invalidate(2, divEl);
    });
  }
  $$self.$$set = ($$props2) => {
    if ("id" in $$props2) $$invalidate(0, id = $$props2.id);
    if ("needsFocus" in $$props2) $$invalidate(3, needsFocus = $$props2.needsFocus);
    if ("type" in $$props2) $$invalidate(1, type = $$props2.type);
    if ("$$scope" in $$props2) $$invalidate(4, $$scope = $$props2.$$scope);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*needsFocus, divEl*/
    12) {
      {
        if (needsFocus) {
          divEl && divEl.focus();
        }
      }
    }
  };
  return [id, type, divEl, needsFocus, $$scope, slots, div_binding];
}
var Alert = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$16, create_fragment$14, safe_not_equal, { id: 0, needsFocus: 3, type: 1 });
  }
};
function create_fragment$13(ctx) {
  let div;
  let span;
  let t0;
  let div_class_value;
  let t1;
  let current;
  t0 = new Locale_strings({ props: { key: "loading" } });
  const default_slot_template = (
    /*#slots*/
    ctx[3].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[2],
    null
  );
  return {
    c() {
      div = element("div");
      span = element("span");
      create_component(t0.$$.fragment);
      t1 = space();
      if (default_slot) default_slot.c();
      attr(span, "class", "tw_sr-only");
      attr(div, "class", div_class_value = `tw_spinner tw_animate-spin tw_border-4 tw_inline-block tw_rounded-full ${/*colorClass*/
      ctx[0]} ${/*layoutClasses*/
      ctx[1]}`);
      attr(div, "role", "status");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, span);
      mount_component(t0, span, null);
      insert(target, t1, anchor);
      if (default_slot) {
        default_slot.m(target, anchor);
      }
      current = true;
    },
    p(ctx2, [dirty]) {
      if (!current || dirty & /*colorClass, layoutClasses*/
      3 && div_class_value !== (div_class_value = `tw_spinner tw_animate-spin tw_border-4 tw_inline-block tw_rounded-full ${/*colorClass*/
      ctx2[0]} ${/*layoutClasses*/
      ctx2[1]}`)) {
        attr(div, "class", div_class_value);
      }
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        4)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[2],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[2]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[2],
              dirty,
              null
            ),
            null
          );
        }
      }
    },
    i(local) {
      if (current) return;
      transition_in(t0.$$.fragment, local);
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(t0.$$.fragment, local);
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(t0);
      if (detaching) detach(t1);
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function instance$15($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { colorClass } = $$props;
  let { layoutClasses } = $$props;
  $$self.$$set = ($$props2) => {
    if ("colorClass" in $$props2) $$invalidate(0, colorClass = $$props2.colorClass);
    if ("layoutClasses" in $$props2) $$invalidate(1, layoutClasses = $$props2.layoutClasses);
    if ("$$scope" in $$props2) $$invalidate(2, $$scope = $$props2.$$scope);
  };
  return [colorClass, layoutClasses, $$scope, slots];
}
var Spinner = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$15, create_fragment$13, safe_not_equal, { colorClass: 0, layoutClasses: 1 });
  }
};
function create_if_block$u(ctx) {
  let spinner;
  let current;
  spinner = new Spinner({
    props: {
      colorClass: "white",
      layoutClasses: "tw_h-4 tw_w-4 tw_mr-2"
    }
  });
  return {
    c() {
      create_component(spinner.$$.fragment);
    },
    m(target, anchor) {
      mount_component(spinner, target, anchor);
      current = true;
    },
    i(local) {
      if (current) return;
      transition_in(spinner.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(spinner.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(spinner, detaching);
    }
  };
}
function fallback_block$1(ctx) {
  let t3;
  return {
    c() {
      t3 = text("Submit");
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_fragment$12(ctx) {
  let button;
  let t3;
  let button_class_value;
  let current;
  let mounted;
  let dispose;
  let if_block = (
    /*busy*/
    ctx[0] && create_if_block$u()
  );
  const default_slot_template = (
    /*#slots*/
    ctx[7].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[6],
    null
  );
  const default_slot_or_fallback = default_slot || fallback_block$1();
  return {
    c() {
      button = element("button");
      if (if_block) if_block.c();
      t3 = space();
      if (default_slot_or_fallback) default_slot_or_fallback.c();
      attr(button, "class", button_class_value = `${generateClassString$2(
        /*style*/
        ctx[3],
        /*width*/
        ctx[5]
      )} tw_button-base tw_focusable-element dark:tw_focusable-element_dark width-${/*width*/
      ctx[5]} ${/*classes*/
      ctx[1]}`);
      attr(
        button,
        "type",
        /*type*/
        ctx[4]
      );
    },
    m(target, anchor) {
      insert(target, button, anchor);
      if (if_block) if_block.m(button, null);
      append(button, t3);
      if (default_slot_or_fallback) {
        default_slot_or_fallback.m(button, null);
      }
      current = true;
      if (!mounted) {
        dispose = listen(button, "click", function() {
          if (is_function(
            /*onClick*/
            ctx[2]
          )) ctx[2].apply(this, arguments);
        });
        mounted = true;
      }
    },
    p(new_ctx, [dirty]) {
      ctx = new_ctx;
      if (
        /*busy*/
        ctx[0]
      ) {
        if (if_block) {
          if (dirty & /*busy*/
          1) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$u();
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(button, t3);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        64)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx,
            /*$$scope*/
            ctx[6],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx[6]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx[6],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (!current || dirty & /*style, width, classes*/
      42 && button_class_value !== (button_class_value = `${generateClassString$2(
        /*style*/
        ctx[3],
        /*width*/
        ctx[5]
      )} tw_button-base tw_focusable-element dark:tw_focusable-element_dark width-${/*width*/
      ctx[5]} ${/*classes*/
      ctx[1]}`)) {
        attr(button, "class", button_class_value);
      }
      if (!current || dirty & /*type*/
      16) {
        attr(
          button,
          "type",
          /*type*/
          ctx[4]
        );
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      transition_in(default_slot_or_fallback, local);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      transition_out(default_slot_or_fallback, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(button);
      if (if_block) if_block.d();
      if (default_slot_or_fallback) default_slot_or_fallback.d(detaching);
      mounted = false;
      dispose();
    }
  };
}
function generateClassString$2(...args) {
  return args.reduce(
    (prev, curr) => {
      switch (curr) {
        case "primary":
          return `${prev} tw_button-primary dark:tw_button-primary_dark`;
        case "secondary":
          return `${prev} tw_button-secondary dark:tw_button-secondary_dark`;
        case "outline":
          return `${prev} tw_button-outline dark:tw_button-outline_dark`;
        case "auto":
          return `${prev} tw_w-auto`;
        case "full":
          return `${prev} tw_w-full`;
        default:
          return prev;
      }
    },
    ""
  );
}
function instance$14($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { busy = false } = $$props;
  let { classes = "" } = $$props;
  let { onClick = () => {
  } } = $$props;
  let { style = "outline" } = $$props;
  let { type = null } = $$props;
  let { width = "auto" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("busy" in $$props2) $$invalidate(0, busy = $$props2.busy);
    if ("classes" in $$props2) $$invalidate(1, classes = $$props2.classes);
    if ("onClick" in $$props2) $$invalidate(2, onClick = $$props2.onClick);
    if ("style" in $$props2) $$invalidate(3, style = $$props2.style);
    if ("type" in $$props2) $$invalidate(4, type = $$props2.type);
    if ("width" in $$props2) $$invalidate(5, width = $$props2.width);
    if ("$$scope" in $$props2) $$invalidate(6, $$scope = $$props2.$$scope);
  };
  return [busy, classes, onClick, style, type, width, $$scope, slots];
}
var Button = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$14, create_fragment$12, safe_not_equal, {
      busy: 0,
      classes: 1,
      onClick: 2,
      style: 3,
      type: 4,
      width: 5
    });
  }
};
function create_fragment$11(ctx) {
  let form;
  let form_class_value;
  let current;
  let mounted;
  let dispose;
  const default_slot_template = (
    /*#slots*/
    ctx[8].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[7],
    null
  );
  return {
    c() {
      form = element("form");
      if (default_slot) default_slot.c();
      attr(
        form,
        "aria-describedby",
        /*ariaDescribedBy*/
        ctx[1]
      );
      attr(
        form,
        "id",
        /*id*/
        ctx[2]
      );
      attr(form, "class", form_class_value = `tw_form-base ${/*isFormValid*/
      ctx[3] ? "tw_form-valid" : "tw_form-invalid"} tw_outline-none`);
      form.noValidate = true;
      attr(form, "tabindex", "-1");
    },
    m(target, anchor) {
      insert(target, form, anchor);
      if (default_slot) {
        default_slot.m(form, null);
      }
      ctx[9](form);
      current = true;
      if (!mounted) {
        dispose = listen(form, "submit", prevent_default(
          /*formSubmit*/
          ctx[4]
        ));
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        128)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[7],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[7]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[7],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (!current || dirty & /*ariaDescribedBy*/
      2) {
        attr(
          form,
          "aria-describedby",
          /*ariaDescribedBy*/
          ctx2[1]
        );
      }
      if (!current || dirty & /*id*/
      4) {
        attr(
          form,
          "id",
          /*id*/
          ctx2[2]
        );
      }
      if (!current || dirty & /*isFormValid*/
      8 && form_class_value !== (form_class_value = `tw_form-base ${/*isFormValid*/
      ctx2[3] ? "tw_form-valid" : "tw_form-invalid"} tw_outline-none`)) {
        attr(form, "class", form_class_value);
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(form);
      if (default_slot) default_slot.d(detaching);
      ctx[9](null);
      mounted = false;
      dispose();
    }
  };
}
function instance$13($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { ariaDescribedBy } = $$props;
  let { formEl = null } = $$props;
  let { id = "formId" } = $$props;
  let { needsFocus = false } = $$props;
  let { onSubmitWhenValid = void 0 } = $$props;
  let isFormValid = false;
  function formSubmit(event) {
    const form = event.target;
    let isFirstInvalidInput = null;
    $$invalidate(3, isFormValid = false);
    Array.from(form.children).forEach((el, idx) => {
      const inputs = el.querySelectorAll("input, select, textarea");
      if (!(inputs == null ? void 0 : inputs.length)) {
        return;
      }
      Array.from(inputs).forEach((input) => {
        const isValid3 = input.checkValidity() && input.dataset.forceValidityFailure !== "true";
        const messageKey = input.getAttribute("aria-describedby") || "";
        const messageContainer = document.getElementById(messageKey);
        const messageEl = messageContainer == null ? void 0 : messageContainer.querySelector(".__input-message");
        if (!isValid3) {
          input.setAttribute("aria-invalid", "true");
          if (messageKey) {
            messageEl == null ? void 0 : messageEl.classList.add("tw_isInvalid");
            messageEl == null ? void 0 : messageEl.classList.remove("tw_hidden");
          }
          if (isFirstInvalidInput === null) {
            input.focus();
            isFirstInvalidInput = idx;
          }
        } else {
          input.setAttribute("aria-invalid", "false");
          messageEl == null ? void 0 : messageEl.classList.remove("tw_isInvalid");
          messageEl == null ? void 0 : messageEl.classList.add("tw_hidden");
        }
      });
    });
    if (isFirstInvalidInput === null) {
      $$invalidate(3, isFormValid = true);
      onSubmitWhenValid && onSubmitWhenValid(event, isFormValid);
    }
  }
  function form_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      formEl = $$value;
      $$invalidate(0, formEl);
    });
  }
  $$self.$$set = ($$props2) => {
    if ("ariaDescribedBy" in $$props2) $$invalidate(1, ariaDescribedBy = $$props2.ariaDescribedBy);
    if ("formEl" in $$props2) $$invalidate(0, formEl = $$props2.formEl);
    if ("id" in $$props2) $$invalidate(2, id = $$props2.id);
    if ("needsFocus" in $$props2) $$invalidate(5, needsFocus = $$props2.needsFocus);
    if ("onSubmitWhenValid" in $$props2) $$invalidate(6, onSubmitWhenValid = $$props2.onSubmitWhenValid);
    if ("$$scope" in $$props2) $$invalidate(7, $$scope = $$props2.$$scope);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*needsFocus, formEl*/
    33) {
      {
        if (needsFocus) {
          formEl && formEl.focus();
        }
      }
    }
  };
  return [
    formEl,
    ariaDescribedBy,
    id,
    isFormValid,
    formSubmit,
    needsFocus,
    onSubmitWhenValid,
    $$scope,
    slots,
    form_binding
  ];
}
var Form = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$13, create_fragment$11, safe_not_equal, {
      ariaDescribedBy: 1,
      formEl: 0,
      id: 2,
      needsFocus: 5,
      onSubmitWhenValid: 6
    });
  }
};
function create_else_block$a(ctx) {
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[4].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[3],
    null
  );
  const default_slot_or_fallback = default_slot || fallback_block_1(ctx);
  return {
    c() {
      if (default_slot_or_fallback) default_slot_or_fallback.c();
    },
    m(target, anchor) {
      if (default_slot_or_fallback) {
        default_slot_or_fallback.m(target, anchor);
      }
      current = true;
    },
    p(ctx2, dirty) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        8)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[3],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[3]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[3],
              dirty,
              null
            ),
            null
          );
        }
      } else {
        if (default_slot_or_fallback && default_slot_or_fallback.p && (!current || dirty & /*message*/
        2)) {
          default_slot_or_fallback.p(ctx2, !current ? -1 : dirty);
        }
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot_or_fallback, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot_or_fallback, local);
      current = false;
    },
    d(detaching) {
      if (default_slot_or_fallback) default_slot_or_fallback.d(detaching);
    }
  };
}
function create_if_block$t(ctx) {
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[4].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[3],
    null
  );
  const default_slot_or_fallback = default_slot || fallback_block(ctx);
  return {
    c() {
      if (default_slot_or_fallback) default_slot_or_fallback.c();
    },
    m(target, anchor) {
      if (default_slot_or_fallback) {
        default_slot_or_fallback.m(target, anchor);
      }
      current = true;
    },
    p(ctx2, dirty) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        8)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[3],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[3]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[3],
              dirty,
              null
            ),
            null
          );
        }
      } else {
        if (default_slot_or_fallback && default_slot_or_fallback.p && (!current || dirty & /*message*/
        2)) {
          default_slot_or_fallback.p(ctx2, !current ? -1 : dirty);
        }
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot_or_fallback, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot_or_fallback, local);
      current = false;
    },
    d(detaching) {
      if (default_slot_or_fallback) default_slot_or_fallback.d(detaching);
    }
  };
}
function fallback_block_1(ctx) {
  let t3;
  return {
    c() {
      t3 = text(
        /*message*/
        ctx[1]
      );
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*message*/
      2) set_data(
        t3,
        /*message*/
        ctx2[1]
      );
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function fallback_block(ctx) {
  let html_tag;
  let html_anchor;
  return {
    c() {
      html_tag = new HtmlTag(false);
      html_anchor = empty();
      html_tag.a = html_anchor;
    },
    m(target, anchor) {
      html_tag.m(
        /*message*/
        ctx[1],
        target,
        anchor
      );
      insert(target, html_anchor, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*message*/
      2) html_tag.p(
        /*message*/
        ctx2[1]
      );
    },
    d(detaching) {
      if (detaching) detach(html_anchor);
      if (detaching) html_tag.d();
    }
  };
}
function create_fragment$10(ctx) {
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block$t, create_else_block$a];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*html*/
      ctx2[0]
    ) return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(if_block_anchor.parentNode, if_block_anchor);
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if_blocks[current_block_type_index].d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function instance$12($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { html = false } = $$props;
  let { string } = $$props;
  let message;
  $$self.$$set = ($$props2) => {
    if ("html" in $$props2) $$invalidate(0, html = $$props2.html);
    if ("string" in $$props2) $$invalidate(2, string = $$props2.string);
    if ("$$scope" in $$props2) $$invalidate(3, $$scope = $$props2.$$scope);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*string*/
    4) {
      {
        $$invalidate(1, message = sanitize(string));
      }
    }
  };
  return [html, message, string, $$scope, slots];
}
var Server_strings = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$12, create_fragment$10, safe_not_equal, { html: 0, string: 2 });
  }
};
function create_fragment$$(ctx) {
  let svg;
  let path;
  let title;
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[3].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[2],
    null
  );
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      title = svg_element("title");
      if (default_slot) default_slot.c();
      attr(path, "d", "M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm0 5a1.5 1.5 0 0 1 .5 2.915l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99A1.5 1.5 0 0 1 8 5z");
      attr(
        svg,
        "class",
        /*classes*/
        ctx[0]
      );
      attr(
        svg,
        "height",
        /*size*/
        ctx[1]
      );
      attr(
        svg,
        "width",
        /*size*/
        ctx[1]
      );
      attr(svg, "viewBox", "-2 0 20 20");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
      append(svg, title);
      if (default_slot) {
        default_slot.m(title, null);
      }
      current = true;
    },
    p(ctx2, [dirty]) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        4)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[2],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[2]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[2],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (!current || dirty & /*classes*/
      1) {
        attr(
          svg,
          "class",
          /*classes*/
          ctx2[0]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "height",
          /*size*/
          ctx2[1]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "width",
          /*size*/
          ctx2[1]
        );
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(svg);
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function instance$11($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { classes = "" } = $$props;
  let { size = "24px" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("classes" in $$props2) $$invalidate(0, classes = $$props2.classes);
    if ("size" in $$props2) $$invalidate(1, size = $$props2.size);
    if ("$$scope" in $$props2) $$invalidate(2, $$scope = $$props2.$$scope);
  };
  return [classes, size, $$scope, slots];
}
var Shield_icon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$11, create_fragment$$, safe_not_equal, { classes: 0, size: 1 });
  }
};
function create_if_block$s(ctx) {
  let p4;
  let button;
  let t_value = interpolate(
    /*string*/
    ctx[1]
  ) + "";
  let t3;
  let mounted;
  let dispose;
  return {
    c() {
      p4 = element("p");
      button = element("button");
      t3 = text(t_value);
      attr(p4, "class", "tw_my-4 tw_text-base tw_text-center tw_text-link-dark dark:tw_text-link-light");
    },
    m(target, anchor) {
      insert(target, p4, anchor);
      append(p4, button);
      append(button, t3);
      if (!mounted) {
        dispose = listen(button, "click", prevent_default(
          /*click_handler*/
          ctx[4]
        ));
        mounted = true;
      }
    },
    p(ctx2, dirty) {
      if (dirty & /*string*/
      2 && t_value !== (t_value = interpolate(
        /*string*/
        ctx2[1]
      ) + "")) set_data(t3, t_value);
    },
    d(detaching) {
      if (detaching) detach(p4);
      mounted = false;
      dispose();
    }
  };
}
function create_fragment$_(ctx) {
  let if_block_anchor;
  let if_block = (
    /*$stack*/
    ctx[2].length > 1 && create_if_block$s(ctx)
  );
  return {
    c() {
      if (if_block) if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx2, [dirty]) {
      if (
        /*$stack*/
        ctx2[2].length > 1
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
        } else {
          if_block = create_if_block$s(ctx2);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (if_block) if_block.d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function instance$10($$self, $$props, $$invalidate) {
  let $stack;
  let $configuredJourneysStore;
  component_subscribe($$self, configuredJourneysStore, ($$value) => $$invalidate(5, $configuredJourneysStore = $$value));
  let { journey: journey2 } = $$props;
  let stack2 = journey2.stack;
  component_subscribe($$self, stack2, (value) => $$invalidate(2, $stack = value));
  let string = "";
  function constructString() {
    const currentJourney = $configuredJourneysStore.find((journey3) => {
      var _a;
      return journey3.journey === ((_a = $stack[$stack.length - 2]) == null ? void 0 : _a.tree);
    });
    const key = currentJourney == null ? void 0 : currentJourney.key;
    const capitalizedKey = typeof key === "string" ? key.replace(/([a-z])/, (_2, char) => `${char.toUpperCase()}`) : key;
    return `backTo${capitalizedKey || "Default"}`;
  }
  const click_handler = () => {
    journey2 == null ? void 0 : journey2.pop();
  };
  $$self.$$set = ($$props2) => {
    if ("journey" in $$props2) $$invalidate(0, journey2 = $$props2.journey);
  };
  {
    $$invalidate(1, string = constructString());
  }
  return [journey2, string, $stack, stack2, click_handler];
}
var Back_to = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$10, create_fragment$_, safe_not_equal, { journey: 0 });
  }
};
function captureLinks(linkWrapper, currentJourney) {
  const journeys = get_store_value(configuredJourneysStore);
  const stack2 = get_store_value(currentJourney.stack);
  linkWrapper.addEventListener("click", (event) => {
    const target = event.target;
    const href = target.hasAttribute("href") && target.getAttribute("href");
    const { action, journey: journey2 } = matchJourneyAndDecideAction(href, journeys, stack2);
    if (!action) {
      return;
    }
    event.preventDefault();
    if (action === "push") {
      currentJourney.push({ tree: journey2 });
    } else if (action === "pop") {
      currentJourney.pop();
    }
  });
}
function matchJourneyAndDecideAction(href, journeys, stack2) {
  if (href) {
    const match = journeys.find((item) => {
      return item.match.find((string) => {
        return href === string;
      });
    });
    if (match) {
      const previousJourney = stack2[stack2.length - 2];
      if (!previousJourney || previousJourney.tree !== match.journey) {
        return { action: "push", journey: match.journey };
      } else {
        return { action: "pop" };
      }
    } else {
      return { action: null };
    }
  } else {
    return { action: null };
  }
}
function getInputTypeFromPolicies(policies) {
  const value = policies == null ? void 0 : policies.value;
  if (typeof value !== "object") {
    return "text";
  }
  const reqs = value == null ? void 0 : value.policyRequirements;
  if (!Array.isArray(reqs)) {
    return "text";
  }
  if (reqs.includes("VALID_EMAIL_ADDRESS_FORMAT")) {
    return "email";
  }
  if (reqs.includes("VALID_USERNAME")) {
    return "text";
  }
  return "text";
}
function getValidationFailureParams(failedPolicy) {
  if ((failedPolicy == null ? void 0 : failedPolicy.policyRequirement) === "DICTIONARY") {
    const params = failedPolicy.params;
    const min = (params == null ? void 0 : params["min-substring-length"]) || 0;
    const arr = [];
    if ((params == null ? void 0 : params["check-substrings"]) && (params == null ? void 0 : params["test-reversed-password"])) {
      arr.push({
        length: min,
        message: interpolate("passwordCannotContainCommonPasswordsOrBeReversibleStringsLessThan", {
          min: String(min)
        }),
        rule: "reversibleSubstrings"
      });
    } else if (params == null ? void 0 : params["test-reversed-password"]) {
      arr.push({
        length: null,
        message: interpolate("passwordCannotContainCommonPasswordsOrBeReversible"),
        rule: "reversibleSubstrings"
      });
    } else {
      arr.push({
        length: null,
        message: interpolate("passwordCannotContainCommonPasswords"),
        rule: "reversibleSubstrings"
      });
    }
    return arr;
  } else if ((failedPolicy == null ? void 0 : failedPolicy.policyRequirement) === "CHARACTER_SET") {
    const params = failedPolicy.params;
    return params == null ? void 0 : params["character-sets"].map(convertCharacterSetToRuleObj);
  } else if ((failedPolicy == null ? void 0 : failedPolicy.policyRequirement) === "LENGTH_BASED") {
    const params = failedPolicy.params;
    const min = (params == null ? void 0 : params["min-password-length"]) || 0;
    const max = (params == null ? void 0 : params["max-password-length"]) || null;
    const arr = [];
    if (max) {
      arr.push({
        length: max,
        message: interpolate("exceedsMaximumCharacterLength", { max: String(max) }),
        rule: "maximumLength"
      });
    }
    if (min) {
      arr.push({
        length: min,
        message: interpolate("doesNotMeetMinimumCharacterLength", { min: String(min) }),
        rule: "minimumLength"
      });
    }
    return arr;
  } else if ((failedPolicy == null ? void 0 : failedPolicy.policyRequirement) === "REPEATED_CHARACTERS") {
    const params = failedPolicy.params;
    const max = params["max-consecutive-length"] || 0;
    const arr = [];
    if (!params["case-sensitive-validation"]) {
      arr.push({
        length: max,
        message: interpolate("charactersCannotRepeatMoreThanCaseInsensitive", { max: String(max) }),
        rule: "repeatedCharactersCaseInsensitive"
      });
    } else {
      arr.push({
        length: max,
        message: interpolate("charactersCannotRepeatMoreThan", { max: String(max) }),
        rule: "repeatedCharacters"
      });
    }
    return arr;
  } else if ((failedPolicy == null ? void 0 : failedPolicy.policyRequirement) === "VALID_USERNAME") {
    return [
      {
        length: null,
        message: interpolate("chooseDifferentUsername"),
        rule: "validUsername"
      }
    ];
  } else if ((failedPolicy == null ? void 0 : failedPolicy.policyRequirement) === "VALID_EMAIL_ADDRESS_FORMAT") {
    return [
      {
        length: null,
        message: interpolate("invalidEmailAddress"),
        rule: "validEmailAddress"
      }
    ];
  } else {
    return [
      {
        length: null,
        message: interpolate("pleaseCheckValue"),
        rule: "unknown"
      }
    ];
  }
}
function getValidationMessageString(policy) {
  var _a;
  switch (policy == null ? void 0 : policy.policyId) {
    case "at-least-X-capitals": {
      const params = policy == null ? void 0 : policy.params;
      const length = params == null ? void 0 : params.numCaps;
      return interpolate("minimumNumberOfUppercase", { num: String(length) });
    }
    case "at-least-X-numbers": {
      const params = policy == null ? void 0 : policy.params;
      const length = params == null ? void 0 : params.numNums;
      return interpolate("minimumNumberOfNumbers", { num: String(length) });
    }
    case "cannot-contain-characters": {
      const params = policy == null ? void 0 : policy.params;
      let chars = "";
      if (typeof params !== "object") {
        return "";
      }
      if (Array.isArray(params.forbiddenChars)) {
        chars = params.forbiddenChars.reduce((prev, curr) => {
          prev = `${prev ? `${prev}, ` : `${prev}`} ${curr}`;
          return prev;
        }, "");
      } else if (typeof params.forbiddenChars === "string") {
        chars = params.forbiddenChars;
      }
      return interpolate("fieldCanNotContainFollowingCharacters", { chars });
    }
    case "cannot-contain-others": {
      const params = policy == null ? void 0 : policy.params;
      let fields = "";
      if (typeof params !== "object") {
        return "";
      }
      if (Array.isArray(params.disallowedFields)) {
        fields = (_a = params.disallowedFields) == null ? void 0 : _a.reduce((prev, curr) => {
          prev = `${prev ? `${prev}, ` : `${prev}`} ${interpolate(curr)}`;
          return prev;
        }, "");
      } else if (typeof params.disallowedFields === "string") {
        fields = params.disallowedFields;
      }
      return interpolate("fieldCanNotContainFollowingValues", { fields });
    }
    case "maximum-length": {
      const params = policy == null ? void 0 : policy.params;
      const length = params == null ? void 0 : params.maxLength;
      if (length > 100) {
        return "";
      }
      return interpolate("notToExceedMaximumCharacterLength", { max: String(length) });
    }
    case "minimum-length": {
      const params = policy == null ? void 0 : policy.params;
      const length = params == null ? void 0 : params.minLength;
      if (length === 1) {
        return "";
      }
      return interpolate("noLessThanMinimumCharacterLength", { min: String(length) });
    }
    /**
     * The below cases can be handled, but I think they create more noise than value to the user
     */
    case "not-empty":
      return "";
    case "required":
      return "";
    case "valid-username":
      return "";
    case "valid-email-address-format":
      return "";
    case "valid-type":
      return "";
    default:
      return "";
  }
}
function getValidationFailures(callback, label) {
  const failedPolicies = callback.getFailedPolicies && callback.getFailedPolicies();
  const parsedPolicies = parseFailedPolicies(failedPolicies, label);
  return parsedPolicies.map((policy) => {
    return {
      params: policy == null ? void 0 : policy.params,
      policyRequirement: (policy == null ? void 0 : policy.policyRequirement) || "",
      restructured: getValidationFailureParams(policy)
    };
  });
}
function getValidationPolicies(policies) {
  if (typeof policies !== "object" && !policies) {
    return [];
  }
  const reqs = policies == null ? void 0 : policies.policies;
  if (!Array.isArray(reqs)) {
    return [];
  }
  return reqs.map((policy) => {
    return __spreadValues(__spreadValues({
      message: getValidationMessageString(policy)
    }, (policy == null ? void 0 : policy.params) && { params: policy == null ? void 0 : policy.params }), (policy == null ? void 0 : policy.policyId) && { policyId: policy == null ? void 0 : policy.policyId });
  }).filter((policy) => !!policy.message);
}
function isInputRequired(callback) {
  const policies = callback.getPolicies && callback.getPolicies();
  let isRequired = false;
  if (policies == null ? void 0 : policies.policyRequirements) {
    isRequired = policies.policyRequirements.includes("REQUIRED");
  } else if (callback.isRequired) {
    isRequired = callback.isRequired();
  }
  return isRequired;
}
function convertCharacterSetToRuleObj(set) {
  const arr = set.split(":");
  const num = arr[0];
  const type = arr[1];
  if (type === "0123456789") {
    if (num === "0") {
      return {
        length: null,
        message: interpolate("shouldContainANumber"),
        rule: "numbers"
      };
    } else {
      return {
        length: Number(num),
        message: interpolate("minimumNumberOfNumbers", { num: String(num) }),
        rule: "numbers"
      };
    }
  } else if (type === "ABCDEFGHIJKLMNOPQRSTUVWXYZ") {
    if (num === "0") {
      return {
        length: null,
        message: interpolate("shouldContainAnUppercase"),
        rule: "uppercase"
      };
    } else {
      return {
        length: Number(num),
        message: interpolate("minimumNumberOfUppercase", { num: String(num) }),
        rule: "uppercase"
      };
    }
  } else if (type === "abcdefghijklmnopqrstuvwxyz") {
    if (num === "0") {
      return {
        length: null,
        message: interpolate("shouldContainALowercase"),
        rule: "lowercase"
      };
    } else {
      return {
        length: Number(num),
        message: interpolate("minimumNumberOfLowercase", { num: String(num) }),
        rule: "lowercase"
      };
    }
  } else if (type.includes("@") || type.includes("!") || type.includes("*") || type.includes("#")) {
    if (num === "0") {
      return {
        length: null,
        message: interpolate("shouldContainASymbol"),
        rule: "symbols"
      };
    } else {
      return {
        length: Number(num),
        message: interpolate("minimumNumberOfSymbols", { num: String(num) }),
        rule: "symbols"
      };
    }
  } else {
    return {
      length: null,
      message: interpolate("pleaseCheckValue"),
      rule: "unknown"
    };
  }
}
function parseFailedPolicies(policies, label) {
  return policies.map((policy) => {
    if (typeof policy === "string") {
      try {
        return JSON.parse(policy);
      } catch (err) {
        console.error(`Parsing failure for ${label}`);
      }
    } else {
      return policy;
    }
  });
}
function getAttributeValidationFailureText(callback) {
  const failedPolicies = callback.getFailedPolicies && callback.getFailedPolicies();
  return failedPolicies.reduce((prev, curr) => {
    switch (curr.policyRequirement) {
      default:
        prev = `${prev}${interpolate("pleaseCheckValue")}`;
    }
    return prev;
  }, "");
}
function create_if_block$r(ctx) {
  let p4;
  let p_class_value;
  let p_id_value;
  return {
    c() {
      p4 = element("p");
      attr(p4, "class", p_class_value = `${/*classes*/
      ctx[0]} __input-message ${!/*showMessage*/
      ctx[3] ? "tw_hidden" : ""} ${generateClassString$1(
        /*type*/
        ctx[4]
      )}`);
      attr(p4, "id", p_id_value = `${/*key*/
      ctx[2] ? `${/*key*/
      ctx[2]}-message` : ""}`);
    },
    m(target, anchor) {
      insert(target, p4, anchor);
      p4.innerHTML = /*cleanMessage*/
      ctx[5];
    },
    p(ctx2, dirty) {
      if (dirty & /*cleanMessage*/
      32) p4.innerHTML = /*cleanMessage*/
      ctx2[5];
      if (dirty & /*classes, showMessage, type*/
      25 && p_class_value !== (p_class_value = `${/*classes*/
      ctx2[0]} __input-message ${!/*showMessage*/
      ctx2[3] ? "tw_hidden" : ""} ${generateClassString$1(
        /*type*/
        ctx2[4]
      )}`)) {
        attr(p4, "class", p_class_value);
      }
      if (dirty & /*key*/
      4 && p_id_value !== (p_id_value = `${/*key*/
      ctx2[2] ? `${/*key*/
      ctx2[2]}-message` : ""}`)) {
        attr(p4, "id", p_id_value);
      }
    },
    d(detaching) {
      if (detaching) detach(p4);
    }
  };
}
function create_fragment$Z(ctx) {
  let if_block_anchor;
  let if_block = (
    /*dirtyMessage*/
    ctx[1] && create_if_block$r(ctx)
  );
  return {
    c() {
      if (if_block) if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx2, [dirty]) {
      if (
        /*dirtyMessage*/
        ctx2[1]
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
        } else {
          if_block = create_if_block$r(ctx2);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (if_block) if_block.d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function generateClassString$1(...args) {
  return args.reduce(
    (prev, curr) => {
      switch (curr) {
        case "error":
          return `${prev} tw_input-error-message dark:tw_input-error-message_dark`;
        default:
          return `${prev} tw_input-info-message dark:tw_input-info-message_dark`;
      }
    },
    ""
  );
}
function instance$$($$self, $$props, $$invalidate) {
  let { classes = "" } = $$props;
  let { dirtyMessage } = $$props;
  let { key = void 0 } = $$props;
  let { showMessage = true } = $$props;
  let { type = "info" } = $$props;
  let cleanMessage = sanitize(dirtyMessage);
  $$self.$$set = ($$props2) => {
    if ("classes" in $$props2) $$invalidate(0, classes = $$props2.classes);
    if ("dirtyMessage" in $$props2) $$invalidate(1, dirtyMessage = $$props2.dirtyMessage);
    if ("key" in $$props2) $$invalidate(2, key = $$props2.key);
    if ("showMessage" in $$props2) $$invalidate(3, showMessage = $$props2.showMessage);
    if ("type" in $$props2) $$invalidate(4, type = $$props2.type);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*dirtyMessage*/
    2) {
      {
        $$invalidate(5, cleanMessage = sanitize(dirtyMessage));
      }
    }
  };
  return [classes, dirtyMessage, key, showMessage, type, cleanMessage];
}
var Input_message = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$$, create_fragment$Z, safe_not_equal, {
      classes: 0,
      dirtyMessage: 1,
      key: 2,
      showMessage: 3,
      type: 4
    });
  }
};
function create_fragment$Y(ctx) {
  let label;
  let label_class_value;
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[3].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[2],
    null
  );
  return {
    c() {
      label = element("label");
      if (default_slot) default_slot.c();
      attr(
        label,
        "for",
        /*key*/
        ctx[0]
      );
      attr(label, "class", label_class_value = `${/*classes*/
      ctx[1]} tw_input-label dark:tw_input-label_dark`);
    },
    m(target, anchor) {
      insert(target, label, anchor);
      if (default_slot) {
        default_slot.m(label, null);
      }
      current = true;
    },
    p(ctx2, [dirty]) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        4)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[2],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[2]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[2],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (!current || dirty & /*key*/
      1) {
        attr(
          label,
          "for",
          /*key*/
          ctx2[0]
        );
      }
      if (!current || dirty & /*classes*/
      2 && label_class_value !== (label_class_value = `${/*classes*/
      ctx2[1]} tw_input-label dark:tw_input-label_dark`)) {
        attr(label, "class", label_class_value);
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(label);
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function instance$_($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { key } = $$props;
  let { classes = "" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("key" in $$props2) $$invalidate(0, key = $$props2.key);
    if ("classes" in $$props2) $$invalidate(1, classes = $$props2.classes);
    if ("$$scope" in $$props2) $$invalidate(2, $$scope = $$props2.$$scope);
  };
  return [key, classes, $$scope, slots];
}
var Label = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$_, create_fragment$Y, safe_not_equal, { key: 0, classes: 1 });
  }
};
function create_default_slot$v(ctx) {
  let span;
  let t3;
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[11].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[13],
    null
  );
  return {
    c() {
      span = element("span");
      t3 = space();
      if (default_slot) default_slot.c();
      attr(span, "class", "tw_animated-check dark:tw_animated-check_dark");
    },
    m(target, anchor) {
      insert(target, span, anchor);
      insert(target, t3, anchor);
      if (default_slot) {
        default_slot.m(target, anchor);
      }
      current = true;
    },
    p(ctx2, dirty) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        8192)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[13],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[13]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[13],
              dirty,
              null
            ),
            null
          );
        }
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(span);
      if (detaching) detach(t3);
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function create_fragment$X(ctx) {
  let div1;
  let input;
  let input_data_message_value;
  let t0;
  let label;
  let t1;
  let div0;
  let message_1;
  let current;
  let mounted;
  let dispose;
  label = new Label({
    props: {
      key: (
        /*key*/
        ctx[3]
      ),
      classes: "tw_grid tw_grid-cols-[2.5em_1fr] tw_relative",
      $$slots: { default: [create_default_slot$v] },
      $$scope: { ctx }
    }
  });
  message_1 = new Input_message({
    props: {
      key: (
        /*key*/
        ctx[3]
      ),
      dirtyMessage: (
        /*message*/
        ctx[1]
      ),
      showMessage: (
        /*showMessage*/
        ctx[4]
      ),
      type: (
        /*isInvalid*/
        ctx[0] ? "error" : "info"
      )
    }
  });
  return {
    c() {
      div1 = element("div");
      input = element("input");
      t0 = space();
      create_component(label.$$.fragment);
      t1 = space();
      div0 = element("div");
      create_component(message_1.$$.fragment);
      attr(
        input,
        "aria-invalid",
        /*isInvalid*/
        ctx[0]
      );
      attr(input, "class", "tw_checkbox-input_animated dark:tw_checkbox-input_animated_dark tw_sr-only");
      input.checked = /*value*/
      ctx[5];
      attr(input, "data-message", input_data_message_value = `${/*key*/
      ctx[3]}-message`);
      attr(
        input,
        "id",
        /*key*/
        ctx[3]
      );
      input.required = /*isRequired*/
      ctx[2];
      attr(input, "type", "checkbox");
      attr(div0, "class", "tw_ml-10");
      attr(div1, "class", "tw_input-spacing");
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, input);
      ctx[12](input);
      append(div1, t0);
      mount_component(label, div1, null);
      append(div1, t1);
      append(div1, div0);
      mount_component(message_1, div0, null);
      current = true;
      if (!mounted) {
        dispose = listen(
          input,
          "change",
          /*onChangeWrapper*/
          ctx[7]
        );
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (!current || dirty & /*isInvalid*/
      1) {
        attr(
          input,
          "aria-invalid",
          /*isInvalid*/
          ctx2[0]
        );
      }
      if (!current || dirty & /*value*/
      32) {
        input.checked = /*value*/
        ctx2[5];
      }
      if (!current || dirty & /*key*/
      8 && input_data_message_value !== (input_data_message_value = `${/*key*/
      ctx2[3]}-message`)) {
        attr(input, "data-message", input_data_message_value);
      }
      if (!current || dirty & /*key*/
      8) {
        attr(
          input,
          "id",
          /*key*/
          ctx2[3]
        );
      }
      if (!current || dirty & /*isRequired*/
      4) {
        input.required = /*isRequired*/
        ctx2[2];
      }
      const label_changes = {};
      if (dirty & /*key*/
      8) label_changes.key = /*key*/
      ctx2[3];
      if (dirty & /*$$scope*/
      8192) {
        label_changes.$$scope = { dirty, ctx: ctx2 };
      }
      label.$set(label_changes);
      const message_1_changes = {};
      if (dirty & /*key*/
      8) message_1_changes.key = /*key*/
      ctx2[3];
      if (dirty & /*message*/
      2) message_1_changes.dirtyMessage = /*message*/
      ctx2[1];
      if (dirty & /*showMessage*/
      16) message_1_changes.showMessage = /*showMessage*/
      ctx2[4];
      if (dirty & /*isInvalid*/
      1) message_1_changes.type = /*isInvalid*/
      ctx2[0] ? "error" : "info";
      message_1.$set(message_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(label.$$.fragment, local);
      transition_in(message_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(label.$$.fragment, local);
      transition_out(message_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div1);
      ctx[12](null);
      destroy_component(label);
      destroy_component(message_1);
      mounted = false;
      dispose();
    }
  };
}
function instance$Z($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { checkValidity = null } = $$props;
  let { message = "" } = $$props;
  let { isFirstInvalidInput } = $$props;
  let { isRequired = false } = $$props;
  let { isInvalid = false } = $$props;
  let { key } = $$props;
  let { onChange } = $$props;
  let { showMessage = void 0 } = $$props;
  let { value } = $$props;
  let inputEl;
  function onChangeWrapper(event) {
    if (checkValidity) {
      $$invalidate(0, isInvalid = !checkValidity(event));
    }
    onChange(event);
  }
  afterUpdate(() => {
    if (isFirstInvalidInput) {
      inputEl.focus();
    }
  });
  function input_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      inputEl = $$value;
      $$invalidate(6, inputEl);
    });
  }
  $$self.$$set = ($$props2) => {
    if ("checkValidity" in $$props2) $$invalidate(8, checkValidity = $$props2.checkValidity);
    if ("message" in $$props2) $$invalidate(1, message = $$props2.message);
    if ("isFirstInvalidInput" in $$props2) $$invalidate(9, isFirstInvalidInput = $$props2.isFirstInvalidInput);
    if ("isRequired" in $$props2) $$invalidate(2, isRequired = $$props2.isRequired);
    if ("isInvalid" in $$props2) $$invalidate(0, isInvalid = $$props2.isInvalid);
    if ("key" in $$props2) $$invalidate(3, key = $$props2.key);
    if ("onChange" in $$props2) $$invalidate(10, onChange = $$props2.onChange);
    if ("showMessage" in $$props2) $$invalidate(4, showMessage = $$props2.showMessage);
    if ("value" in $$props2) $$invalidate(5, value = $$props2.value);
    if ("$$scope" in $$props2) $$invalidate(13, $$scope = $$props2.$$scope);
  };
  return [
    isInvalid,
    message,
    isRequired,
    key,
    showMessage,
    value,
    inputEl,
    onChangeWrapper,
    checkValidity,
    isFirstInvalidInput,
    onChange,
    slots,
    input_binding,
    $$scope
  ];
}
var Animated$1 = class Animated extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$Z, create_fragment$X, safe_not_equal, {
      checkValidity: 8,
      message: 1,
      isFirstInvalidInput: 9,
      isRequired: 2,
      isInvalid: 0,
      key: 3,
      onChange: 10,
      showMessage: 4,
      value: 5
    });
  }
};
function create_default_slot$u(ctx) {
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[7].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[9],
    null
  );
  return {
    c() {
      if (default_slot) default_slot.c();
    },
    m(target, anchor) {
      if (default_slot) {
        default_slot.m(target, anchor);
      }
      current = true;
    },
    p(ctx2, dirty) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        512)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[9],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[9]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[9],
              dirty,
              null
            ),
            null
          );
        }
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function create_fragment$W(ctx) {
  let input;
  let input_aria_describedby_value;
  let t3;
  let label;
  let current;
  let mounted;
  let dispose;
  label = new Label({
    props: {
      key: (
        /*key*/
        ctx[2]
      ),
      $$slots: { default: [create_default_slot$u] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      input = element("input");
      t3 = space();
      create_component(label.$$.fragment);
      attr(input, "aria-describedby", input_aria_describedby_value = `${/*key*/
      ctx[2]}-message`);
      attr(
        input,
        "aria-invalid",
        /*isInvalid*/
        ctx[1]
      );
      attr(input, "class", "tw_checkbox-input dark:tw_checkbox-input_dark tw_focusable-element dark:tw_focusable-element_dark");
      input.checked = /*value*/
      ctx[4];
      attr(
        input,
        "id",
        /*key*/
        ctx[2]
      );
      input.required = /*isRequired*/
      ctx[0];
      attr(input, "type", "checkbox");
    },
    m(target, anchor) {
      insert(target, input, anchor);
      ctx[8](input);
      insert(target, t3, anchor);
      mount_component(label, target, anchor);
      current = true;
      if (!mounted) {
        dispose = listen(input, "change", function() {
          if (is_function(
            /*onChange*/
            ctx[3]
          )) ctx[3].apply(this, arguments);
        });
        mounted = true;
      }
    },
    p(new_ctx, [dirty]) {
      ctx = new_ctx;
      if (!current || dirty & /*key*/
      4 && input_aria_describedby_value !== (input_aria_describedby_value = `${/*key*/
      ctx[2]}-message`)) {
        attr(input, "aria-describedby", input_aria_describedby_value);
      }
      if (!current || dirty & /*isInvalid*/
      2) {
        attr(
          input,
          "aria-invalid",
          /*isInvalid*/
          ctx[1]
        );
      }
      if (!current || dirty & /*value*/
      16) {
        input.checked = /*value*/
        ctx[4];
      }
      if (!current || dirty & /*key*/
      4) {
        attr(
          input,
          "id",
          /*key*/
          ctx[2]
        );
      }
      if (!current || dirty & /*isRequired*/
      1) {
        input.required = /*isRequired*/
        ctx[0];
      }
      const label_changes = {};
      if (dirty & /*key*/
      4) label_changes.key = /*key*/
      ctx[2];
      if (dirty & /*$$scope*/
      512) {
        label_changes.$$scope = { dirty, ctx };
      }
      label.$set(label_changes);
    },
    i(local) {
      if (current) return;
      transition_in(label.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(label.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(input);
      ctx[8](null);
      if (detaching) detach(t3);
      destroy_component(label, detaching);
      mounted = false;
      dispose();
    }
  };
}
function instance$Y($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { isFirstInvalidInput } = $$props;
  let { isRequired = false } = $$props;
  let { isInvalid = false } = $$props;
  let { key } = $$props;
  let { onChange } = $$props;
  let { value } = $$props;
  let inputEl;
  afterUpdate(() => {
    if (isFirstInvalidInput) {
      inputEl.focus();
    }
  });
  function input_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      inputEl = $$value;
      $$invalidate(5, inputEl);
    });
  }
  $$self.$$set = ($$props2) => {
    if ("isFirstInvalidInput" in $$props2) $$invalidate(6, isFirstInvalidInput = $$props2.isFirstInvalidInput);
    if ("isRequired" in $$props2) $$invalidate(0, isRequired = $$props2.isRequired);
    if ("isInvalid" in $$props2) $$invalidate(1, isInvalid = $$props2.isInvalid);
    if ("key" in $$props2) $$invalidate(2, key = $$props2.key);
    if ("onChange" in $$props2) $$invalidate(3, onChange = $$props2.onChange);
    if ("value" in $$props2) $$invalidate(4, value = $$props2.value);
    if ("$$scope" in $$props2) $$invalidate(9, $$scope = $$props2.$$scope);
  };
  return [
    isRequired,
    isInvalid,
    key,
    onChange,
    value,
    inputEl,
    isFirstInvalidInput,
    slots,
    input_binding,
    $$scope
  ];
}
var Checkbox = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$Y, create_fragment$W, safe_not_equal, {
      isFirstInvalidInput: 6,
      isRequired: 0,
      isInvalid: 1,
      key: 2,
      onChange: 3,
      value: 4
    });
  }
};
function create_default_slot$t(ctx) {
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[10].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[11],
    null
  );
  return {
    c() {
      if (default_slot) default_slot.c();
    },
    m(target, anchor) {
      if (default_slot) {
        default_slot.m(target, anchor);
      }
      current = true;
    },
    p(ctx2, dirty) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        2048)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[11],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[11]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[11],
              dirty,
              null
            ),
            null
          );
        }
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function create_fragment$V(ctx) {
  let div;
  let checkbox;
  let t3;
  let span;
  let message_1;
  let current;
  checkbox = new Checkbox({
    props: {
      isFirstInvalidInput: (
        /*isFirstInvalidInput*/
        ctx[2]
      ),
      isRequired: (
        /*isRequired*/
        ctx[3]
      ),
      isInvalid: (
        /*isInvalid*/
        ctx[0]
      ),
      key: (
        /*key*/
        ctx[4]
      ),
      onChange: (
        /*onChangeWrapper*/
        ctx[7]
      ),
      value: (
        /*value*/
        ctx[6]
      ),
      $$slots: { default: [create_default_slot$t] },
      $$scope: { ctx }
    }
  });
  message_1 = new Input_message({
    props: {
      dirtyMessage: (
        /*message*/
        ctx[1]
      ),
      key: (
        /*key*/
        ctx[4]
      ),
      showMessage: (
        /*showMessage*/
        ctx[5]
      ),
      type: (
        /*isInvalid*/
        ctx[0] ? "error" : "info"
      )
    }
  });
  return {
    c() {
      div = element("div");
      create_component(checkbox.$$.fragment);
      t3 = space();
      span = element("span");
      create_component(message_1.$$.fragment);
      attr(span, "class", "tw_col-start-2 tw_row-start-2");
      attr(div, "class", "tw_input-spacing tw_grid tw_grid-cols-[1.5em_1fr]");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(checkbox, div, null);
      append(div, t3);
      append(div, span);
      mount_component(message_1, span, null);
      current = true;
    },
    p(ctx2, [dirty]) {
      const checkbox_changes = {};
      if (dirty & /*isFirstInvalidInput*/
      4) checkbox_changes.isFirstInvalidInput = /*isFirstInvalidInput*/
      ctx2[2];
      if (dirty & /*isRequired*/
      8) checkbox_changes.isRequired = /*isRequired*/
      ctx2[3];
      if (dirty & /*isInvalid*/
      1) checkbox_changes.isInvalid = /*isInvalid*/
      ctx2[0];
      if (dirty & /*key*/
      16) checkbox_changes.key = /*key*/
      ctx2[4];
      if (dirty & /*value*/
      64) checkbox_changes.value = /*value*/
      ctx2[6];
      if (dirty & /*$$scope*/
      2048) {
        checkbox_changes.$$scope = { dirty, ctx: ctx2 };
      }
      checkbox.$set(checkbox_changes);
      const message_1_changes = {};
      if (dirty & /*message*/
      2) message_1_changes.dirtyMessage = /*message*/
      ctx2[1];
      if (dirty & /*key*/
      16) message_1_changes.key = /*key*/
      ctx2[4];
      if (dirty & /*showMessage*/
      32) message_1_changes.showMessage = /*showMessage*/
      ctx2[5];
      if (dirty & /*isInvalid*/
      1) message_1_changes.type = /*isInvalid*/
      ctx2[0] ? "error" : "info";
      message_1.$set(message_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(checkbox.$$.fragment, local);
      transition_in(message_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(checkbox.$$.fragment, local);
      transition_out(message_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(checkbox);
      destroy_component(message_1);
    }
  };
}
function instance$X($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { checkValidity = null } = $$props;
  let { message = "" } = $$props;
  let { isFirstInvalidInput } = $$props;
  let { isRequired = false } = $$props;
  let { isInvalid = false } = $$props;
  let { key } = $$props;
  let { onChange } = $$props;
  let { showMessage = void 0 } = $$props;
  let { value } = $$props;
  function onChangeWrapper(event) {
    if (checkValidity) {
      $$invalidate(0, isInvalid = !checkValidity(event));
    }
    onChange(event);
  }
  $$self.$$set = ($$props2) => {
    if ("checkValidity" in $$props2) $$invalidate(8, checkValidity = $$props2.checkValidity);
    if ("message" in $$props2) $$invalidate(1, message = $$props2.message);
    if ("isFirstInvalidInput" in $$props2) $$invalidate(2, isFirstInvalidInput = $$props2.isFirstInvalidInput);
    if ("isRequired" in $$props2) $$invalidate(3, isRequired = $$props2.isRequired);
    if ("isInvalid" in $$props2) $$invalidate(0, isInvalid = $$props2.isInvalid);
    if ("key" in $$props2) $$invalidate(4, key = $$props2.key);
    if ("onChange" in $$props2) $$invalidate(9, onChange = $$props2.onChange);
    if ("showMessage" in $$props2) $$invalidate(5, showMessage = $$props2.showMessage);
    if ("value" in $$props2) $$invalidate(6, value = $$props2.value);
    if ("$$scope" in $$props2) $$invalidate(11, $$scope = $$props2.$$scope);
  };
  return [
    isInvalid,
    message,
    isFirstInvalidInput,
    isRequired,
    key,
    showMessage,
    value,
    onChangeWrapper,
    checkValidity,
    onChange,
    slots,
    $$scope
  ];
}
var Standard$1 = class Standard extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$X, create_fragment$V, safe_not_equal, {
      checkValidity: 8,
      message: 1,
      isFirstInvalidInput: 2,
      isRequired: 3,
      isInvalid: 0,
      key: 4,
      onChange: 9,
      showMessage: 5,
      value: 6
    });
  }
};
function create_default_slot$s(ctx) {
  let t_value = interpolate(
    textToKey(
      /*outputName*/
      ctx[3]
    ),
    null,
    /*prompt*/
    ctx[5]
  ) + "";
  let t3;
  return {
    c() {
      t3 = text(t_value);
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*outputName, prompt*/
      40 && t_value !== (t_value = interpolate(
        textToKey(
          /*outputName*/
          ctx2[3]
        ),
        null,
        /*prompt*/
        ctx2[5]
      ) + "")) set_data(t3, t_value);
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_key_block$5(ctx) {
  var _a;
  let checkbox;
  let current;
  checkbox = new /*Checkbox*/
  ctx[7]({
    props: {
      isFirstInvalidInput: (
        /*callbackMetadata*/
        ((_a = ctx[1]) == null ? void 0 : _a.derived.isFirstInvalidInput) || false
      ),
      isInvalid: !!/*validationFailure*/
      ctx[6],
      key: (
        /*inputName*/
        ctx[2]
      ),
      message: (
        /*validationFailure*/
        ctx[6]
      ),
      onChange: (
        /*setValue*/
        ctx[8]
      ),
      value: (
        /*previousValue*/
        ctx[4]
      ),
      $$slots: { default: [create_default_slot$s] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(checkbox.$$.fragment);
    },
    m(target, anchor) {
      mount_component(checkbox, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      const checkbox_changes = {};
      if (dirty & /*callbackMetadata*/
      2) checkbox_changes.isFirstInvalidInput = /*callbackMetadata*/
      ((_a2 = ctx2[1]) == null ? void 0 : _a2.derived.isFirstInvalidInput) || false;
      if (dirty & /*validationFailure*/
      64) checkbox_changes.isInvalid = !!/*validationFailure*/
      ctx2[6];
      if (dirty & /*inputName*/
      4) checkbox_changes.key = /*inputName*/
      ctx2[2];
      if (dirty & /*validationFailure*/
      64) checkbox_changes.message = /*validationFailure*/
      ctx2[6];
      if (dirty & /*previousValue*/
      16) checkbox_changes.value = /*previousValue*/
      ctx2[4];
      if (dirty & /*$$scope, outputName, prompt*/
      4136) {
        checkbox_changes.$$scope = { dirty, ctx: ctx2 };
      }
      checkbox.$set(checkbox_changes);
    },
    i(local) {
      if (current) return;
      transition_in(checkbox.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(checkbox.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(checkbox, detaching);
    }
  };
}
function create_fragment$U(ctx) {
  let previous_key = (
    /*callback*/
    ctx[0]
  );
  let key_block_anchor;
  let current;
  let key_block = create_key_block$5(ctx);
  return {
    c() {
      key_block.c();
      key_block_anchor = empty();
    },
    m(target, anchor) {
      key_block.m(target, anchor);
      insert(target, key_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (dirty & /*callback*/
      1 && safe_not_equal(previous_key, previous_key = /*callback*/
      ctx2[0])) {
        group_outros();
        transition_out(key_block, 1, 1, noop);
        check_outros();
        key_block = create_key_block$5(ctx2);
        key_block.c();
        transition_in(key_block, 1);
        key_block.m(key_block_anchor.parentNode, key_block_anchor);
      } else {
        key_block.p(ctx2, dirty);
      }
    },
    i(local) {
      if (current) return;
      transition_in(key_block);
      current = true;
    },
    o(local) {
      transition_out(key_block);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(key_block_anchor);
      key_block.d(detaching);
    }
  };
}
function instance$W($$self, $$props, $$invalidate) {
  const stepMetadata = null;
  const selfSubmitFunction = null;
  let { callback } = $$props;
  let { callbackMetadata } = $$props;
  let { style = {} } = $$props;
  const Checkbox2 = style.checksAndRadios === "standard" ? Standard$1 : Animated$1;
  let inputName;
  let outputName;
  let previousValue;
  let prompt;
  let validationFailure;
  function setValue(event) {
    callback.setInputValue(event.target.checked);
  }
  $$self.$$set = ($$props2) => {
    if ("callback" in $$props2) $$invalidate(0, callback = $$props2.callback);
    if ("callbackMetadata" in $$props2) $$invalidate(1, callbackMetadata = $$props2.callbackMetadata);
    if ("style" in $$props2) $$invalidate(11, style = $$props2.style);
  };
  $$self.$$.update = () => {
    var _a, _b;
    if ($$self.$$.dirty & /*callback, callbackMetadata*/
    3) {
      {
        $$invalidate(2, inputName = ((_b = (_a = callback == null ? void 0 : callback.payload) == null ? void 0 : _a.input) == null ? void 0 : _b[0].name) || `boolean-attr-${callbackMetadata == null ? void 0 : callbackMetadata.idx}`);
        $$invalidate(3, outputName = callback.getOutputByName("name", ""));
        $$invalidate(4, previousValue = callback.getInputValue());
        $$invalidate(5, prompt = callback.getPrompt());
        $$invalidate(6, validationFailure = getAttributeValidationFailureText(callback));
      }
    }
  };
  return [
    callback,
    callbackMetadata,
    inputName,
    outputName,
    previousValue,
    prompt,
    validationFailure,
    Checkbox2,
    setValue,
    stepMetadata,
    selfSubmitFunction,
    style
  ];
}
var Boolean$1 = class Boolean2 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$W, create_fragment$U, safe_not_equal, {
      stepMetadata: 9,
      selfSubmitFunction: 10,
      callback: 0,
      callbackMetadata: 1,
      style: 11
    });
  }
  get stepMetadata() {
    return this.$$.ctx[9];
  }
  get selfSubmitFunction() {
    return this.$$.ctx[10];
  }
};
function get_each_context$c(ctx, list, i9) {
  const child_ctx = ctx.slice();
  child_ctx[13] = list[i9];
  return child_ctx;
}
function create_default_slot$r(ctx) {
  let span;
  let t0;
  let t1_value = (
    /*option*/
    ctx[13].text + ""
  );
  let t1;
  return {
    c() {
      span = element("span");
      t0 = space();
      t1 = text(t1_value);
      attr(span, "class", "tw_animated-radio dark:tw_animated-radio_dark");
    },
    m(target, anchor) {
      insert(target, span, anchor);
      insert(target, t0, anchor);
      insert(target, t1, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*options*/
      256 && t1_value !== (t1_value = /*option*/
      ctx2[13].text + "")) set_data(t1, t1_value);
    },
    d(detaching) {
      if (detaching) detach(span);
      if (detaching) detach(t0);
      if (detaching) detach(t1);
    }
  };
}
function create_each_block$c(ctx) {
  let div;
  let input;
  let input_checked_value;
  let input_id_value;
  let input_value_value;
  let t0;
  let label;
  let t1;
  let current;
  let mounted;
  let dispose;
  label = new Label({
    props: {
      key: `${/*key*/
      ctx[5]}-${/*option*/
      ctx[13].value}`,
      classes: "tw_input-spacing tw_grid tw_grid-cols-[2.5em_1fr] tw_relative",
      $$slots: { default: [create_default_slot$r] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      div = element("div");
      input = element("input");
      t0 = space();
      create_component(label.$$.fragment);
      t1 = space();
      attr(input, "class", "tw_radio-input_animated dark:tw_radio-input_animated_dark tw_sr-only");
      input.checked = input_checked_value = /*defaultOption*/
      ctx[0] === /*option*/
      ctx[13].value;
      attr(input, "id", input_id_value = `${/*key*/
      ctx[5]}-${/*option*/
      ctx[13].value}`);
      attr(
        input,
        "name",
        /*name*/
        ctx[6]
      );
      input.required = /*isRequired*/
      ctx[3];
      attr(input, "type", "radio");
      input.value = input_value_value = /*option*/
      ctx[13].value;
      attr(div, "class", "tw_input-spacing");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, input);
      ctx[12](input);
      append(div, t0);
      mount_component(label, div, null);
      append(div, t1);
      current = true;
      if (!mounted) {
        dispose = listen(input, "change", function() {
          if (is_function(
            /*onChange*/
            ctx[7]
          )) ctx[7].apply(this, arguments);
        });
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (!current || dirty & /*defaultOption, options*/
      257 && input_checked_value !== (input_checked_value = /*defaultOption*/
      ctx[0] === /*option*/
      ctx[13].value)) {
        input.checked = input_checked_value;
      }
      if (!current || dirty & /*key, options*/
      288 && input_id_value !== (input_id_value = `${/*key*/
      ctx[5]}-${/*option*/
      ctx[13].value}`)) {
        attr(input, "id", input_id_value);
      }
      if (!current || dirty & /*name*/
      64) {
        attr(
          input,
          "name",
          /*name*/
          ctx[6]
        );
      }
      if (!current || dirty & /*isRequired*/
      8) {
        input.required = /*isRequired*/
        ctx[3];
      }
      if (!current || dirty & /*options*/
      256 && input_value_value !== (input_value_value = /*option*/
      ctx[13].value)) {
        input.value = input_value_value;
      }
      const label_changes = {};
      if (dirty & /*key, options*/
      288) label_changes.key = `${/*key*/
      ctx[5]}-${/*option*/
      ctx[13].value}`;
      if (dirty & /*$$scope, options*/
      65792) {
        label_changes.$$scope = { dirty, ctx };
      }
      label.$set(label_changes);
    },
    i(local) {
      if (current) return;
      transition_in(label.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(label.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      ctx[12](null);
      destroy_component(label);
      mounted = false;
      dispose();
    }
  };
}
function create_fragment$T(ctx) {
  let fieldset;
  let legend;
  let t0;
  let t1;
  let div;
  let t22;
  let span;
  let message_1;
  let current;
  let each_value = (
    /*options*/
    ctx[8]
  );
  let each_blocks = [];
  for (let i9 = 0; i9 < each_value.length; i9 += 1) {
    each_blocks[i9] = create_each_block$c(get_each_context$c(ctx, each_value, i9));
  }
  const out = (i9) => transition_out(each_blocks[i9], 1, 1, () => {
    each_blocks[i9] = null;
  });
  message_1 = new Input_message({
    props: {
      dirtyMessage: (
        /*message*/
        ctx[1]
      ),
      key: (
        /*key*/
        ctx[5]
      ),
      showMessage: (
        /*showMessage*/
        ctx[9]
      ),
      type: (
        /*isInvalid*/
        ctx[4] ? "error" : "info"
      )
    }
  });
  return {
    c() {
      fieldset = element("fieldset");
      legend = element("legend");
      t0 = text(
        /*groupLabel*/
        ctx[2]
      );
      t1 = space();
      div = element("div");
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].c();
      }
      t22 = space();
      span = element("span");
      create_component(message_1.$$.fragment);
      attr(legend, "class", "tw_input-label dark:tw_input-label_dark tw_font-bold tw_mb-4");
      attr(span, "class", "tw_col-start-2 tw_row-start-2");
    },
    m(target, anchor) {
      insert(target, fieldset, anchor);
      append(fieldset, legend);
      append(legend, t0);
      append(fieldset, t1);
      append(fieldset, div);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].m(div, null);
      }
      append(div, t22);
      append(div, span);
      mount_component(message_1, span, null);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (!current || dirty & /*groupLabel*/
      4) set_data(
        t0,
        /*groupLabel*/
        ctx2[2]
      );
      if (dirty & /*key, options, defaultOption, name, isRequired, inputEl, onChange*/
      1513) {
        each_value = /*options*/
        ctx2[8];
        let i9;
        for (i9 = 0; i9 < each_value.length; i9 += 1) {
          const child_ctx = get_each_context$c(ctx2, each_value, i9);
          if (each_blocks[i9]) {
            each_blocks[i9].p(child_ctx, dirty);
            transition_in(each_blocks[i9], 1);
          } else {
            each_blocks[i9] = create_each_block$c(child_ctx);
            each_blocks[i9].c();
            transition_in(each_blocks[i9], 1);
            each_blocks[i9].m(div, t22);
          }
        }
        group_outros();
        for (i9 = each_value.length; i9 < each_blocks.length; i9 += 1) {
          out(i9);
        }
        check_outros();
      }
      const message_1_changes = {};
      if (dirty & /*message*/
      2) message_1_changes.dirtyMessage = /*message*/
      ctx2[1];
      if (dirty & /*key*/
      32) message_1_changes.key = /*key*/
      ctx2[5];
      if (dirty & /*showMessage*/
      512) message_1_changes.showMessage = /*showMessage*/
      ctx2[9];
      if (dirty & /*isInvalid*/
      16) message_1_changes.type = /*isInvalid*/
      ctx2[4] ? "error" : "info";
      message_1.$set(message_1_changes);
    },
    i(local) {
      if (current) return;
      for (let i9 = 0; i9 < each_value.length; i9 += 1) {
        transition_in(each_blocks[i9]);
      }
      transition_in(message_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      each_blocks = each_blocks.filter(Boolean);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        transition_out(each_blocks[i9]);
      }
      transition_out(message_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(fieldset);
      destroy_each(each_blocks, detaching);
      destroy_component(message_1);
    }
  };
}
function instance$V($$self, $$props, $$invalidate) {
  let { defaultOption = null } = $$props;
  let { message = "" } = $$props;
  let { groupLabel = "" } = $$props;
  let { isFirstInvalidInput } = $$props;
  let { isRequired = false } = $$props;
  let { isInvalid = false } = $$props;
  let { key } = $$props;
  let { name } = $$props;
  let { onChange } = $$props;
  let { options } = $$props;
  let { showMessage = void 0 } = $$props;
  let inputEl;
  afterUpdate(() => {
    if (isFirstInvalidInput) {
      inputEl.focus();
    }
  });
  function input_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      inputEl = $$value;
      $$invalidate(10, inputEl);
    });
  }
  $$self.$$set = ($$props2) => {
    if ("defaultOption" in $$props2) $$invalidate(0, defaultOption = $$props2.defaultOption);
    if ("message" in $$props2) $$invalidate(1, message = $$props2.message);
    if ("groupLabel" in $$props2) $$invalidate(2, groupLabel = $$props2.groupLabel);
    if ("isFirstInvalidInput" in $$props2) $$invalidate(11, isFirstInvalidInput = $$props2.isFirstInvalidInput);
    if ("isRequired" in $$props2) $$invalidate(3, isRequired = $$props2.isRequired);
    if ("isInvalid" in $$props2) $$invalidate(4, isInvalid = $$props2.isInvalid);
    if ("key" in $$props2) $$invalidate(5, key = $$props2.key);
    if ("name" in $$props2) $$invalidate(6, name = $$props2.name);
    if ("onChange" in $$props2) $$invalidate(7, onChange = $$props2.onChange);
    if ("options" in $$props2) $$invalidate(8, options = $$props2.options);
    if ("showMessage" in $$props2) $$invalidate(9, showMessage = $$props2.showMessage);
  };
  return [
    defaultOption,
    message,
    groupLabel,
    isRequired,
    isInvalid,
    key,
    name,
    onChange,
    options,
    showMessage,
    inputEl,
    isFirstInvalidInput,
    input_binding
  ];
}
var Animated2 = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$V, create_fragment$T, safe_not_equal, {
      defaultOption: 0,
      message: 1,
      groupLabel: 2,
      isFirstInvalidInput: 11,
      isRequired: 3,
      isInvalid: 4,
      key: 5,
      name: 6,
      onChange: 7,
      options: 8,
      showMessage: 9
    });
  }
};
function create_default_slot$q(ctx) {
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[8].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[10],
    null
  );
  return {
    c() {
      if (default_slot) default_slot.c();
    },
    m(target, anchor) {
      if (default_slot) {
        default_slot.m(target, anchor);
      }
      current = true;
    },
    p(ctx2, dirty) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        1024)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[10],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[10]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[10],
              dirty,
              null
            ),
            null
          );
        }
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function create_fragment$S(ctx) {
  let input;
  let input_aria_describedby_value;
  let t3;
  let label;
  let current;
  let mounted;
  let dispose;
  label = new Label({
    props: {
      key: (
        /*key*/
        ctx[2]
      ),
      $$slots: { default: [create_default_slot$q] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      input = element("input");
      t3 = space();
      create_component(label.$$.fragment);
      attr(input, "aria-describedby", input_aria_describedby_value = `${/*key*/
      ctx[2]}-message`);
      attr(input, "class", "tw_checkbox-input dark:tw_checkbox-input_dark tw_focusable-element dark:tw_focusable-element_dark");
      input.checked = /*checked*/
      ctx[0];
      attr(
        input,
        "id",
        /*key*/
        ctx[2]
      );
      attr(
        input,
        "name",
        /*name*/
        ctx[3]
      );
      input.required = /*isRequired*/
      ctx[1];
      attr(input, "type", "radio");
      input.value = /*value*/
      ctx[5];
    },
    m(target, anchor) {
      insert(target, input, anchor);
      ctx[9](input);
      insert(target, t3, anchor);
      mount_component(label, target, anchor);
      current = true;
      if (!mounted) {
        dispose = listen(input, "change", function() {
          if (is_function(
            /*onChange*/
            ctx[4]
          )) ctx[4].apply(this, arguments);
        });
        mounted = true;
      }
    },
    p(new_ctx, [dirty]) {
      ctx = new_ctx;
      if (!current || dirty & /*key*/
      4 && input_aria_describedby_value !== (input_aria_describedby_value = `${/*key*/
      ctx[2]}-message`)) {
        attr(input, "aria-describedby", input_aria_describedby_value);
      }
      if (!current || dirty & /*checked*/
      1) {
        input.checked = /*checked*/
        ctx[0];
      }
      if (!current || dirty & /*key*/
      4) {
        attr(
          input,
          "id",
          /*key*/
          ctx[2]
        );
      }
      if (!current || dirty & /*name*/
      8) {
        attr(
          input,
          "name",
          /*name*/
          ctx[3]
        );
      }
      if (!current || dirty & /*isRequired*/
      2) {
        input.required = /*isRequired*/
        ctx[1];
      }
      if (!current || dirty & /*value*/
      32) {
        input.value = /*value*/
        ctx[5];
      }
      const label_changes = {};
      if (dirty & /*key*/
      4) label_changes.key = /*key*/
      ctx[2];
      if (dirty & /*$$scope*/
      1024) {
        label_changes.$$scope = { dirty, ctx };
      }
      label.$set(label_changes);
    },
    i(local) {
      if (current) return;
      transition_in(label.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(label.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(input);
      ctx[9](null);
      if (detaching) detach(t3);
      destroy_component(label, detaching);
      mounted = false;
      dispose();
    }
  };
}
function instance$U($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { checked = false } = $$props;
  let { isFirstInvalidInput } = $$props;
  let { isRequired = false } = $$props;
  let { key } = $$props;
  let { name } = $$props;
  let { onChange } = $$props;
  let { value } = $$props;
  let inputEl;
  afterUpdate(() => {
    if (isFirstInvalidInput) {
      inputEl.focus();
    }
  });
  function input_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      inputEl = $$value;
      $$invalidate(6, inputEl);
    });
  }
  $$self.$$set = ($$props2) => {
    if ("checked" in $$props2) $$invalidate(0, checked = $$props2.checked);
    if ("isFirstInvalidInput" in $$props2) $$invalidate(7, isFirstInvalidInput = $$props2.isFirstInvalidInput);
    if ("isRequired" in $$props2) $$invalidate(1, isRequired = $$props2.isRequired);
    if ("key" in $$props2) $$invalidate(2, key = $$props2.key);
    if ("name" in $$props2) $$invalidate(3, name = $$props2.name);
    if ("onChange" in $$props2) $$invalidate(4, onChange = $$props2.onChange);
    if ("value" in $$props2) $$invalidate(5, value = $$props2.value);
    if ("$$scope" in $$props2) $$invalidate(10, $$scope = $$props2.$$scope);
  };
  return [
    checked,
    isRequired,
    key,
    name,
    onChange,
    value,
    inputEl,
    isFirstInvalidInput,
    slots,
    input_binding,
    $$scope
  ];
}
var Radio = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$U, create_fragment$S, safe_not_equal, {
      checked: 0,
      isFirstInvalidInput: 7,
      isRequired: 1,
      key: 2,
      name: 3,
      onChange: 4,
      value: 5
    });
  }
};
function get_each_context$b(ctx, list, i9) {
  const child_ctx = ctx.slice();
  child_ctx[11] = list[i9];
  return child_ctx;
}
function create_default_slot$p(ctx) {
  let t_value = (
    /*option*/
    ctx[11].text + ""
  );
  let t3;
  return {
    c() {
      t3 = text(t_value);
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*options*/
      512 && t_value !== (t_value = /*option*/
      ctx2[11].text + "")) set_data(t3, t_value);
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_each_block$b(ctx) {
  let div;
  let radio;
  let t3;
  let current;
  radio = new Radio({
    props: {
      checked: (
        /*defaultOption*/
        ctx[0] === /*option*/
        ctx[11].value
      ),
      isFirstInvalidInput: (
        /*isFirstInvalidInput*/
        ctx[3]
      ),
      isRequired: (
        /*isRequired*/
        ctx[4]
      ),
      key: `${/*key*/
      ctx[6]}-${/*option*/
      ctx[11].value}`,
      name: (
        /*name*/
        ctx[7]
      ),
      onChange: (
        /*onChange*/
        ctx[8]
      ),
      value: (
        /*option*/
        ctx[11].value
      ),
      $$slots: { default: [create_default_slot$p] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      div = element("div");
      create_component(radio.$$.fragment);
      t3 = space();
      attr(div, "class", "tw_input-spacing tw_grid tw_grid-cols-[1.5em_1fr]");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(radio, div, null);
      append(div, t3);
      current = true;
    },
    p(ctx2, dirty) {
      const radio_changes = {};
      if (dirty & /*defaultOption, options*/
      513) radio_changes.checked = /*defaultOption*/
      ctx2[0] === /*option*/
      ctx2[11].value;
      if (dirty & /*isFirstInvalidInput*/
      8) radio_changes.isFirstInvalidInput = /*isFirstInvalidInput*/
      ctx2[3];
      if (dirty & /*isRequired*/
      16) radio_changes.isRequired = /*isRequired*/
      ctx2[4];
      if (dirty & /*key, options*/
      576) radio_changes.key = `${/*key*/
      ctx2[6]}-${/*option*/
      ctx2[11].value}`;
      if (dirty & /*name*/
      128) radio_changes.name = /*name*/
      ctx2[7];
      if (dirty & /*onChange*/
      256) radio_changes.onChange = /*onChange*/
      ctx2[8];
      if (dirty & /*options*/
      512) radio_changes.value = /*option*/
      ctx2[11].value;
      if (dirty & /*$$scope, options*/
      16896) {
        radio_changes.$$scope = { dirty, ctx: ctx2 };
      }
      radio.$set(radio_changes);
    },
    i(local) {
      if (current) return;
      transition_in(radio.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(radio.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(radio);
    }
  };
}
function create_fragment$R(ctx) {
  let fieldset;
  let legend;
  let t0;
  let t1;
  let t22;
  let span;
  let message_1;
  let current;
  let each_value = (
    /*options*/
    ctx[9]
  );
  let each_blocks = [];
  for (let i9 = 0; i9 < each_value.length; i9 += 1) {
    each_blocks[i9] = create_each_block$b(get_each_context$b(ctx, each_value, i9));
  }
  const out = (i9) => transition_out(each_blocks[i9], 1, 1, () => {
    each_blocks[i9] = null;
  });
  message_1 = new Input_message({
    props: {
      dirtyMessage: (
        /*message*/
        ctx[1]
      ),
      key: (
        /*key*/
        ctx[6]
      ),
      showMessage: (
        /*showMessage*/
        ctx[10]
      ),
      type: (
        /*isInvalid*/
        ctx[5] ? "error" : "info"
      )
    }
  });
  return {
    c() {
      fieldset = element("fieldset");
      legend = element("legend");
      t0 = text(
        /*groupLabel*/
        ctx[2]
      );
      t1 = space();
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].c();
      }
      t22 = space();
      span = element("span");
      create_component(message_1.$$.fragment);
      attr(legend, "class", "tw_input-label dark:tw_input-label_dark tw_font-bold tw_mb-4");
      attr(span, "class", "tw_col-start-2 tw_row-start-2");
    },
    m(target, anchor) {
      insert(target, fieldset, anchor);
      append(fieldset, legend);
      append(legend, t0);
      append(fieldset, t1);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].m(fieldset, null);
      }
      append(fieldset, t22);
      append(fieldset, span);
      mount_component(message_1, span, null);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (!current || dirty & /*groupLabel*/
      4) set_data(
        t0,
        /*groupLabel*/
        ctx2[2]
      );
      if (dirty & /*defaultOption, options, isFirstInvalidInput, isRequired, key, name, onChange*/
      985) {
        each_value = /*options*/
        ctx2[9];
        let i9;
        for (i9 = 0; i9 < each_value.length; i9 += 1) {
          const child_ctx = get_each_context$b(ctx2, each_value, i9);
          if (each_blocks[i9]) {
            each_blocks[i9].p(child_ctx, dirty);
            transition_in(each_blocks[i9], 1);
          } else {
            each_blocks[i9] = create_each_block$b(child_ctx);
            each_blocks[i9].c();
            transition_in(each_blocks[i9], 1);
            each_blocks[i9].m(fieldset, t22);
          }
        }
        group_outros();
        for (i9 = each_value.length; i9 < each_blocks.length; i9 += 1) {
          out(i9);
        }
        check_outros();
      }
      const message_1_changes = {};
      if (dirty & /*message*/
      2) message_1_changes.dirtyMessage = /*message*/
      ctx2[1];
      if (dirty & /*key*/
      64) message_1_changes.key = /*key*/
      ctx2[6];
      if (dirty & /*showMessage*/
      1024) message_1_changes.showMessage = /*showMessage*/
      ctx2[10];
      if (dirty & /*isInvalid*/
      32) message_1_changes.type = /*isInvalid*/
      ctx2[5] ? "error" : "info";
      message_1.$set(message_1_changes);
    },
    i(local) {
      if (current) return;
      for (let i9 = 0; i9 < each_value.length; i9 += 1) {
        transition_in(each_blocks[i9]);
      }
      transition_in(message_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      each_blocks = each_blocks.filter(Boolean);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        transition_out(each_blocks[i9]);
      }
      transition_out(message_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(fieldset);
      destroy_each(each_blocks, detaching);
      destroy_component(message_1);
    }
  };
}
function instance$T($$self, $$props, $$invalidate) {
  let { defaultOption = null } = $$props;
  let { message = "" } = $$props;
  let { groupLabel = "" } = $$props;
  let { isFirstInvalidInput } = $$props;
  let { isRequired = false } = $$props;
  let { isInvalid = false } = $$props;
  let { key } = $$props;
  let { name } = $$props;
  let { onChange } = $$props;
  let { options } = $$props;
  let { showMessage = void 0 } = $$props;
  $$self.$$set = ($$props2) => {
    if ("defaultOption" in $$props2) $$invalidate(0, defaultOption = $$props2.defaultOption);
    if ("message" in $$props2) $$invalidate(1, message = $$props2.message);
    if ("groupLabel" in $$props2) $$invalidate(2, groupLabel = $$props2.groupLabel);
    if ("isFirstInvalidInput" in $$props2) $$invalidate(3, isFirstInvalidInput = $$props2.isFirstInvalidInput);
    if ("isRequired" in $$props2) $$invalidate(4, isRequired = $$props2.isRequired);
    if ("isInvalid" in $$props2) $$invalidate(5, isInvalid = $$props2.isInvalid);
    if ("key" in $$props2) $$invalidate(6, key = $$props2.key);
    if ("name" in $$props2) $$invalidate(7, name = $$props2.name);
    if ("onChange" in $$props2) $$invalidate(8, onChange = $$props2.onChange);
    if ("options" in $$props2) $$invalidate(9, options = $$props2.options);
    if ("showMessage" in $$props2) $$invalidate(10, showMessage = $$props2.showMessage);
  };
  return [
    defaultOption,
    message,
    groupLabel,
    isFirstInvalidInput,
    isRequired,
    isInvalid,
    key,
    name,
    onChange,
    options,
    showMessage
  ];
}
var Standard2 = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$T, create_fragment$R, safe_not_equal, {
      defaultOption: 0,
      message: 1,
      groupLabel: 2,
      isFirstInvalidInput: 3,
      isRequired: 4,
      isInvalid: 5,
      key: 6,
      name: 7,
      onChange: 8,
      options: 9,
      showMessage: 10
    });
  }
};
function get_each_context$a(ctx, list, i9) {
  const child_ctx = ctx.slice();
  child_ctx[15] = list[i9];
  return child_ctx;
}
function create_if_block_1$f(ctx) {
  let label_1;
  let current;
  label_1 = new Label({
    props: {
      key: (
        /*key*/
        ctx[4]
      ),
      classes: `${/*labelClasses*/
      ctx[6]}`,
      $$slots: { default: [create_default_slot_1$h] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(label_1.$$.fragment);
    },
    m(target, anchor) {
      mount_component(label_1, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const label_1_changes = {};
      if (dirty & /*key*/
      16) label_1_changes.key = /*key*/
      ctx2[4];
      if (dirty & /*labelClasses*/
      64) label_1_changes.classes = `${/*labelClasses*/
      ctx2[6]}`;
      if (dirty & /*$$scope, label*/
      262176) {
        label_1_changes.$$scope = { dirty, ctx: ctx2 };
      }
      label_1.$set(label_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(label_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(label_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(label_1, detaching);
    }
  };
}
function create_default_slot_1$h(ctx) {
  let t3;
  return {
    c() {
      t3 = text(
        /*label*/
        ctx[5]
      );
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*label*/
      32) set_data(
        t3,
        /*label*/
        ctx2[5]
      );
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_each_block$a(ctx) {
  let option;
  let t0_value = (
    /*option*/
    ctx[15].text + ""
  );
  let t0;
  let t1;
  let option_value_value;
  let option_selected_value;
  return {
    c() {
      option = element("option");
      t0 = text(t0_value);
      t1 = space();
      option.__value = option_value_value = /*option*/
      ctx[15].value;
      option.value = option.__value;
      option.selected = option_selected_value = /*option*/
      ctx[15].value === /*defaultOption*/
      ctx[1];
    },
    m(target, anchor) {
      insert(target, option, anchor);
      append(option, t0);
      append(option, t1);
    },
    p(ctx2, dirty) {
      if (dirty & /*options*/
      256 && t0_value !== (t0_value = /*option*/
      ctx2[15].text + "")) set_data(t0, t0_value);
      if (dirty & /*options*/
      256 && option_value_value !== (option_value_value = /*option*/
      ctx2[15].value)) {
        option.__value = option_value_value;
        option.value = option.__value;
      }
      if (dirty & /*options, defaultOption*/
      258 && option_selected_value !== (option_selected_value = /*option*/
      ctx2[15].value === /*defaultOption*/
      ctx2[1])) {
        option.selected = option_selected_value;
      }
    },
    d(detaching) {
      if (detaching) detach(option);
    }
  };
}
function create_if_block$q(ctx) {
  let label_1;
  let current;
  label_1 = new Label({
    props: {
      key: (
        /*key*/
        ctx[4]
      ),
      classes: `${/*shouldDisplayOption*/
      ctx[10] ? (
        /*labelClasses*/
        ctx[6]
      ) : "tw_sr-only"}`,
      $$slots: { default: [create_default_slot$o] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(label_1.$$.fragment);
    },
    m(target, anchor) {
      mount_component(label_1, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const label_1_changes = {};
      if (dirty & /*key*/
      16) label_1_changes.key = /*key*/
      ctx2[4];
      if (dirty & /*shouldDisplayOption, labelClasses*/
      1088) label_1_changes.classes = `${/*shouldDisplayOption*/
      ctx2[10] ? (
        /*labelClasses*/
        ctx2[6]
      ) : "tw_sr-only"}`;
      if (dirty & /*$$scope, label*/
      262176) {
        label_1_changes.$$scope = { dirty, ctx: ctx2 };
      }
      label_1.$set(label_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(label_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(label_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(label_1, detaching);
    }
  };
}
function create_default_slot$o(ctx) {
  let t3;
  return {
    c() {
      t3 = text(
        /*label*/
        ctx[5]
      );
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*label*/
      32) set_data(
        t3,
        /*label*/
        ctx2[5]
      );
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_fragment$Q(ctx) {
  let t0;
  let select;
  let select_aria_describedby_value;
  let select_class_value;
  let t1;
  let if_block1_anchor;
  let current;
  let mounted;
  let dispose;
  let if_block0 = (
    /*labelOrder*/
    ctx[7] === "first" && create_if_block_1$f(ctx)
  );
  let each_value = (
    /*options*/
    ctx[8]
  );
  let each_blocks = [];
  for (let i9 = 0; i9 < each_value.length; i9 += 1) {
    each_blocks[i9] = create_each_block$a(get_each_context$a(ctx, each_value, i9));
  }
  let if_block1 = (
    /*labelOrder*/
    ctx[7] === "last" && create_if_block$q(ctx)
  );
  return {
    c() {
      if (if_block0) if_block0.c();
      t0 = space();
      select = element("select");
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].c();
      }
      t1 = space();
      if (if_block1) if_block1.c();
      if_block1_anchor = empty();
      attr(select, "aria-describedby", select_aria_describedby_value = `${/*key*/
      ctx[4]}-message`);
      attr(
        select,
        "aria-invalid",
        /*isInvalid*/
        ctx[3]
      );
      attr(select, "class", select_class_value = `${/*shouldDisplayOption*/
      ctx[10] ? (
        /*selectClasses*/
        ctx[0]
      ) : ""} tw_input-base dark:tw_input-base_dark tw_focusable-element dark:tw_focusable-element_dark tw_select-base dark:tw_select-base_dark tw_w-full`);
      attr(
        select,
        "id",
        /*key*/
        ctx[4]
      );
      select.required = /*isRequired*/
      ctx[2];
    },
    m(target, anchor) {
      if (if_block0) if_block0.m(target, anchor);
      insert(target, t0, anchor);
      insert(target, select, anchor);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].m(select, null);
      }
      ctx[14](select);
      insert(target, t1, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, if_block1_anchor, anchor);
      current = true;
      if (!mounted) {
        dispose = listen(
          select,
          "change",
          /*onChangeWrapper*/
          ctx[11]
        );
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (
        /*labelOrder*/
        ctx2[7] === "first"
      ) {
        if (if_block0) {
          if_block0.p(ctx2, dirty);
          if (dirty & /*labelOrder*/
          128) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_1$f(ctx2);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(t0.parentNode, t0);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      if (dirty & /*options, defaultOption*/
      258) {
        each_value = /*options*/
        ctx2[8];
        let i9;
        for (i9 = 0; i9 < each_value.length; i9 += 1) {
          const child_ctx = get_each_context$a(ctx2, each_value, i9);
          if (each_blocks[i9]) {
            each_blocks[i9].p(child_ctx, dirty);
          } else {
            each_blocks[i9] = create_each_block$a(child_ctx);
            each_blocks[i9].c();
            each_blocks[i9].m(select, null);
          }
        }
        for (; i9 < each_blocks.length; i9 += 1) {
          each_blocks[i9].d(1);
        }
        each_blocks.length = each_value.length;
      }
      if (!current || dirty & /*key*/
      16 && select_aria_describedby_value !== (select_aria_describedby_value = `${/*key*/
      ctx2[4]}-message`)) {
        attr(select, "aria-describedby", select_aria_describedby_value);
      }
      if (!current || dirty & /*isInvalid*/
      8) {
        attr(
          select,
          "aria-invalid",
          /*isInvalid*/
          ctx2[3]
        );
      }
      if (!current || dirty & /*shouldDisplayOption, selectClasses*/
      1025 && select_class_value !== (select_class_value = `${/*shouldDisplayOption*/
      ctx2[10] ? (
        /*selectClasses*/
        ctx2[0]
      ) : ""} tw_input-base dark:tw_input-base_dark tw_focusable-element dark:tw_focusable-element_dark tw_select-base dark:tw_select-base_dark tw_w-full`)) {
        attr(select, "class", select_class_value);
      }
      if (!current || dirty & /*key*/
      16) {
        attr(
          select,
          "id",
          /*key*/
          ctx2[4]
        );
      }
      if (!current || dirty & /*isRequired*/
      4) {
        select.required = /*isRequired*/
        ctx2[2];
      }
      if (
        /*labelOrder*/
        ctx2[7] === "last"
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
          if (dirty & /*labelOrder*/
          128) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block$q(ctx2);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block0);
      transition_in(if_block1);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(if_block1);
      current = false;
    },
    d(detaching) {
      if (if_block0) if_block0.d(detaching);
      if (detaching) detach(t0);
      if (detaching) detach(select);
      destroy_each(each_blocks, detaching);
      ctx[14](null);
      if (detaching) detach(t1);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(if_block1_anchor);
      mounted = false;
      dispose();
    }
  };
}
function instance$S($$self, $$props, $$invalidate) {
  let { selectClasses = "" } = $$props;
  let { defaultOption = null } = $$props;
  let { isFirstInvalidInput } = $$props;
  let { isRequired = false } = $$props;
  let { isInvalid = false } = $$props;
  let { key } = $$props;
  let { label } = $$props;
  let { labelClasses = "" } = $$props;
  let { labelOrder = "first" } = $$props;
  let { onChange } = $$props;
  let { options } = $$props;
  let inputEl;
  let shouldDisplayOption = true;
  if (defaultOption === null && options[0].text === label) {
    shouldDisplayOption = false;
  }
  afterUpdate(() => {
    if (isFirstInvalidInput) {
      inputEl.focus();
    }
  });
  function onChangeWrapper(event) {
    const value = event.target.value;
    const selectedOption = options.find((option) => {
      return String(option.value) === value;
    });
    $$invalidate(10, shouldDisplayOption = !(label === (selectedOption == null ? void 0 : selectedOption.text)));
    onChange(event);
  }
  function select_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      inputEl = $$value;
      $$invalidate(9, inputEl);
      $$invalidate(8, options);
    });
  }
  $$self.$$set = ($$props2) => {
    if ("selectClasses" in $$props2) $$invalidate(0, selectClasses = $$props2.selectClasses);
    if ("defaultOption" in $$props2) $$invalidate(1, defaultOption = $$props2.defaultOption);
    if ("isFirstInvalidInput" in $$props2) $$invalidate(12, isFirstInvalidInput = $$props2.isFirstInvalidInput);
    if ("isRequired" in $$props2) $$invalidate(2, isRequired = $$props2.isRequired);
    if ("isInvalid" in $$props2) $$invalidate(3, isInvalid = $$props2.isInvalid);
    if ("key" in $$props2) $$invalidate(4, key = $$props2.key);
    if ("label" in $$props2) $$invalidate(5, label = $$props2.label);
    if ("labelClasses" in $$props2) $$invalidate(6, labelClasses = $$props2.labelClasses);
    if ("labelOrder" in $$props2) $$invalidate(7, labelOrder = $$props2.labelOrder);
    if ("onChange" in $$props2) $$invalidate(13, onChange = $$props2.onChange);
    if ("options" in $$props2) $$invalidate(8, options = $$props2.options);
  };
  return [
    selectClasses,
    defaultOption,
    isRequired,
    isInvalid,
    key,
    label,
    labelClasses,
    labelOrder,
    options,
    inputEl,
    shouldDisplayOption,
    onChangeWrapper,
    isFirstInvalidInput,
    onChange,
    select_binding
  ];
}
var Select = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$S, create_fragment$Q, safe_not_equal, {
      selectClasses: 0,
      defaultOption: 1,
      isFirstInvalidInput: 12,
      isRequired: 2,
      isInvalid: 3,
      key: 4,
      label: 5,
      labelClasses: 6,
      labelOrder: 7,
      onChange: 13,
      options: 8
    });
  }
};
function create_fragment$P(ctx) {
  let div;
  let select;
  let t3;
  let message_1;
  let current;
  select = new Select({
    props: {
      defaultOption: (
        /*defaultOption*/
        ctx[1]
      ),
      isFirstInvalidInput: (
        /*isFirstInvalidInput*/
        ctx[3]
      ),
      isRequired: (
        /*isRequired*/
        ctx[4]
      ),
      isInvalid: (
        /*isInvalid*/
        ctx[0]
      ),
      key: (
        /*key*/
        ctx[5]
      ),
      label: (
        /*label*/
        ctx[6]
      ),
      labelClasses: "tw_absolute tw_input-floating-label tw_select-floating-label",
      labelOrder: "last",
      onChange: (
        /*onChangeWrapper*/
        ctx[9]
      ),
      options: (
        /*options*/
        ctx[7]
      ),
      selectClasses: "tw_select-floating"
    }
  });
  message_1 = new Input_message({
    props: {
      dirtyMessage: (
        /*message*/
        ctx[2]
      ),
      key: (
        /*key*/
        ctx[5]
      ),
      showMessage: (
        /*showMessage*/
        ctx[8]
      ),
      type: (
        /*isInvalid*/
        ctx[0] ? "error" : "info"
      )
    }
  });
  return {
    c() {
      div = element("div");
      create_component(select.$$.fragment);
      t3 = space();
      create_component(message_1.$$.fragment);
      attr(div, "class", `tw_input-spacing tw_relative`);
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(select, div, null);
      append(div, t3);
      mount_component(message_1, div, null);
      current = true;
    },
    p(ctx2, [dirty]) {
      const select_changes = {};
      if (dirty & /*defaultOption*/
      2) select_changes.defaultOption = /*defaultOption*/
      ctx2[1];
      if (dirty & /*isFirstInvalidInput*/
      8) select_changes.isFirstInvalidInput = /*isFirstInvalidInput*/
      ctx2[3];
      if (dirty & /*isRequired*/
      16) select_changes.isRequired = /*isRequired*/
      ctx2[4];
      if (dirty & /*isInvalid*/
      1) select_changes.isInvalid = /*isInvalid*/
      ctx2[0];
      if (dirty & /*key*/
      32) select_changes.key = /*key*/
      ctx2[5];
      if (dirty & /*label*/
      64) select_changes.label = /*label*/
      ctx2[6];
      if (dirty & /*options*/
      128) select_changes.options = /*options*/
      ctx2[7];
      select.$set(select_changes);
      const message_1_changes = {};
      if (dirty & /*message*/
      4) message_1_changes.dirtyMessage = /*message*/
      ctx2[2];
      if (dirty & /*key*/
      32) message_1_changes.key = /*key*/
      ctx2[5];
      if (dirty & /*showMessage*/
      256) message_1_changes.showMessage = /*showMessage*/
      ctx2[8];
      if (dirty & /*isInvalid*/
      1) message_1_changes.type = /*isInvalid*/
      ctx2[0] ? "error" : "info";
      message_1.$set(message_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(select.$$.fragment, local);
      transition_in(message_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(select.$$.fragment, local);
      transition_out(message_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(select);
      destroy_component(message_1);
    }
  };
}
function instance$R($$self, $$props, $$invalidate) {
  let { checkValidity = null } = $$props;
  let { defaultOption = null } = $$props;
  let { message = "" } = $$props;
  let { isFirstInvalidInput } = $$props;
  let { isRequired = false } = $$props;
  let { isInvalid = false } = $$props;
  let { key } = $$props;
  let { label } = $$props;
  let { onChange } = $$props;
  let { options } = $$props;
  let { showMessage = void 0 } = $$props;
  function onChangeWrapper(event) {
    if (checkValidity) {
      $$invalidate(0, isInvalid = !checkValidity(event));
    }
    onChange(event);
  }
  $$self.$$set = ($$props2) => {
    if ("checkValidity" in $$props2) $$invalidate(10, checkValidity = $$props2.checkValidity);
    if ("defaultOption" in $$props2) $$invalidate(1, defaultOption = $$props2.defaultOption);
    if ("message" in $$props2) $$invalidate(2, message = $$props2.message);
    if ("isFirstInvalidInput" in $$props2) $$invalidate(3, isFirstInvalidInput = $$props2.isFirstInvalidInput);
    if ("isRequired" in $$props2) $$invalidate(4, isRequired = $$props2.isRequired);
    if ("isInvalid" in $$props2) $$invalidate(0, isInvalid = $$props2.isInvalid);
    if ("key" in $$props2) $$invalidate(5, key = $$props2.key);
    if ("label" in $$props2) $$invalidate(6, label = $$props2.label);
    if ("onChange" in $$props2) $$invalidate(11, onChange = $$props2.onChange);
    if ("options" in $$props2) $$invalidate(7, options = $$props2.options);
    if ("showMessage" in $$props2) $$invalidate(8, showMessage = $$props2.showMessage);
  };
  return [
    isInvalid,
    defaultOption,
    message,
    isFirstInvalidInput,
    isRequired,
    key,
    label,
    options,
    showMessage,
    onChangeWrapper,
    checkValidity,
    onChange
  ];
}
var Floating_label$1 = class Floating_label extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$R, create_fragment$P, safe_not_equal, {
      checkValidity: 10,
      defaultOption: 1,
      message: 2,
      isFirstInvalidInput: 3,
      isRequired: 4,
      isInvalid: 0,
      key: 5,
      label: 6,
      onChange: 11,
      options: 7,
      showMessage: 8
    });
  }
};
function create_fragment$O(ctx) {
  let div;
  let select;
  let t3;
  let message_1;
  let current;
  select = new Select({
    props: {
      defaultOption: (
        /*defaultOption*/
        ctx[1]
      ),
      isFirstInvalidInput: (
        /*isFirstInvalidInput*/
        ctx[3]
      ),
      isRequired: (
        /*isRequired*/
        ctx[4]
      ),
      isInvalid: (
        /*isInvalid*/
        ctx[0]
      ),
      key: (
        /*key*/
        ctx[5]
      ),
      label: (
        /*label*/
        ctx[6]
      ),
      labelClasses: "tw_input-stacked-label",
      labelOrder: "first",
      onChange: (
        /*onChangeWrapper*/
        ctx[9]
      ),
      options: (
        /*options*/
        ctx[7]
      )
    }
  });
  message_1 = new Input_message({
    props: {
      dirtyMessage: (
        /*message*/
        ctx[2]
      ),
      key: (
        /*key*/
        ctx[5]
      ),
      showMessage: (
        /*showMessage*/
        ctx[8]
      ),
      type: (
        /*isInvalid*/
        ctx[0] ? "error" : "info"
      )
    }
  });
  return {
    c() {
      div = element("div");
      create_component(select.$$.fragment);
      t3 = space();
      create_component(message_1.$$.fragment);
      attr(div, "class", "tw_input-spacing");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(select, div, null);
      append(div, t3);
      mount_component(message_1, div, null);
      current = true;
    },
    p(ctx2, [dirty]) {
      const select_changes = {};
      if (dirty & /*defaultOption*/
      2) select_changes.defaultOption = /*defaultOption*/
      ctx2[1];
      if (dirty & /*isFirstInvalidInput*/
      8) select_changes.isFirstInvalidInput = /*isFirstInvalidInput*/
      ctx2[3];
      if (dirty & /*isRequired*/
      16) select_changes.isRequired = /*isRequired*/
      ctx2[4];
      if (dirty & /*isInvalid*/
      1) select_changes.isInvalid = /*isInvalid*/
      ctx2[0];
      if (dirty & /*key*/
      32) select_changes.key = /*key*/
      ctx2[5];
      if (dirty & /*label*/
      64) select_changes.label = /*label*/
      ctx2[6];
      if (dirty & /*options*/
      128) select_changes.options = /*options*/
      ctx2[7];
      select.$set(select_changes);
      const message_1_changes = {};
      if (dirty & /*message*/
      4) message_1_changes.dirtyMessage = /*message*/
      ctx2[2];
      if (dirty & /*key*/
      32) message_1_changes.key = /*key*/
      ctx2[5];
      if (dirty & /*showMessage*/
      256) message_1_changes.showMessage = /*showMessage*/
      ctx2[8];
      if (dirty & /*isInvalid*/
      1) message_1_changes.type = /*isInvalid*/
      ctx2[0] ? "error" : "info";
      message_1.$set(message_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(select.$$.fragment, local);
      transition_in(message_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(select.$$.fragment, local);
      transition_out(message_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(select);
      destroy_component(message_1);
    }
  };
}
function instance$Q($$self, $$props, $$invalidate) {
  let { checkValidity = null } = $$props;
  let { defaultOption = null } = $$props;
  let { message = "" } = $$props;
  let { isFirstInvalidInput } = $$props;
  let { isRequired = false } = $$props;
  let { isInvalid = false } = $$props;
  let { key } = $$props;
  let { label } = $$props;
  let { onChange } = $$props;
  let { options } = $$props;
  let { showMessage = void 0 } = $$props;
  function onChangeWrapper(event) {
    if (checkValidity) {
      $$invalidate(0, isInvalid = !checkValidity(event));
    }
    onChange(event);
  }
  $$self.$$set = ($$props2) => {
    if ("checkValidity" in $$props2) $$invalidate(10, checkValidity = $$props2.checkValidity);
    if ("defaultOption" in $$props2) $$invalidate(1, defaultOption = $$props2.defaultOption);
    if ("message" in $$props2) $$invalidate(2, message = $$props2.message);
    if ("isFirstInvalidInput" in $$props2) $$invalidate(3, isFirstInvalidInput = $$props2.isFirstInvalidInput);
    if ("isRequired" in $$props2) $$invalidate(4, isRequired = $$props2.isRequired);
    if ("isInvalid" in $$props2) $$invalidate(0, isInvalid = $$props2.isInvalid);
    if ("key" in $$props2) $$invalidate(5, key = $$props2.key);
    if ("label" in $$props2) $$invalidate(6, label = $$props2.label);
    if ("onChange" in $$props2) $$invalidate(11, onChange = $$props2.onChange);
    if ("options" in $$props2) $$invalidate(7, options = $$props2.options);
    if ("showMessage" in $$props2) $$invalidate(8, showMessage = $$props2.showMessage);
  };
  return [
    isInvalid,
    defaultOption,
    message,
    isFirstInvalidInput,
    isRequired,
    key,
    label,
    options,
    showMessage,
    onChangeWrapper,
    checkValidity,
    onChange
  ];
}
var Stacked_label$1 = class Stacked_label extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$Q, create_fragment$O, safe_not_equal, {
      checkValidity: 10,
      defaultOption: 1,
      message: 2,
      isFirstInvalidInput: 3,
      isRequired: 4,
      isInvalid: 0,
      key: 5,
      label: 6,
      onChange: 11,
      options: 7,
      showMessage: 8
    });
  }
};
function create_else_block$9(ctx) {
  var _a;
  let select;
  let current;
  select = new /*Select*/
  ctx[7]({
    props: {
      isFirstInvalidInput: (
        /*callbackMetadata*/
        ((_a = ctx[0]) == null ? void 0 : _a.derived.isFirstInvalidInput) || false
      ),
      defaultOption: (
        /*defaultChoice*/
        ctx[5]
      ),
      isRequired: false,
      key: (
        /*inputName*/
        ctx[3]
      ),
      label: (
        /*label*/
        ctx[4]
      ),
      onChange: (
        /*setValue*/
        ctx[8]
      ),
      options: (
        /*choiceOptions*/
        ctx[2]
      )
    }
  });
  return {
    c() {
      create_component(select.$$.fragment);
    },
    m(target, anchor) {
      mount_component(select, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      const select_changes = {};
      if (dirty & /*callbackMetadata*/
      1) select_changes.isFirstInvalidInput = /*callbackMetadata*/
      ((_a2 = ctx2[0]) == null ? void 0 : _a2.derived.isFirstInvalidInput) || false;
      if (dirty & /*defaultChoice*/
      32) select_changes.defaultOption = /*defaultChoice*/
      ctx2[5];
      if (dirty & /*inputName*/
      8) select_changes.key = /*inputName*/
      ctx2[3];
      if (dirty & /*label*/
      16) select_changes.label = /*label*/
      ctx2[4];
      if (dirty & /*choiceOptions*/
      4) select_changes.options = /*choiceOptions*/
      ctx2[2];
      select.$set(select_changes);
    },
    i(local) {
      if (current) return;
      transition_in(select.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(select.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(select, detaching);
    }
  };
}
function create_if_block$p(ctx) {
  var _a;
  let radio;
  let current;
  radio = new /*Radio*/
  ctx[6]({
    props: {
      isFirstInvalidInput: (
        /*callbackMetadata*/
        ((_a = ctx[0]) == null ? void 0 : _a.derived.isFirstInvalidInput) || false
      ),
      defaultOption: (
        /*defaultChoice*/
        ctx[5]
      ),
      isRequired: false,
      key: (
        /*inputName*/
        ctx[3]
      ),
      groupLabel: (
        /*prompt*/
        ctx[1]
      ),
      onChange: (
        /*setValue*/
        ctx[8]
      ),
      name: (
        /*inputName*/
        ctx[3]
      ),
      options: (
        /*choiceOptions*/
        ctx[2]
      )
    }
  });
  return {
    c() {
      create_component(radio.$$.fragment);
    },
    m(target, anchor) {
      mount_component(radio, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      const radio_changes = {};
      if (dirty & /*callbackMetadata*/
      1) radio_changes.isFirstInvalidInput = /*callbackMetadata*/
      ((_a2 = ctx2[0]) == null ? void 0 : _a2.derived.isFirstInvalidInput) || false;
      if (dirty & /*defaultChoice*/
      32) radio_changes.defaultOption = /*defaultChoice*/
      ctx2[5];
      if (dirty & /*inputName*/
      8) radio_changes.key = /*inputName*/
      ctx2[3];
      if (dirty & /*prompt*/
      2) radio_changes.groupLabel = /*prompt*/
      ctx2[1];
      if (dirty & /*inputName*/
      8) radio_changes.name = /*inputName*/
      ctx2[3];
      if (dirty & /*choiceOptions*/
      4) radio_changes.options = /*choiceOptions*/
      ctx2[2];
      radio.$set(radio_changes);
    },
    i(local) {
      if (current) return;
      transition_in(radio.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(radio.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(radio, detaching);
    }
  };
}
function create_fragment$N(ctx) {
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block$p, create_else_block$9];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    var _a, _b;
    if (
      /*callbackMetadata*/
      ((_b = (_a = ctx2[0]) == null ? void 0 : _a.platform) == null ? void 0 : _b.displayType) === "radio"
    ) return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(if_block_anchor.parentNode, if_block_anchor);
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if_blocks[current_block_type_index].d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function instance$P($$self, $$props, $$invalidate) {
  const selfSubmitFunction = null;
  const stepMetadata = null;
  let { callback } = $$props;
  let { callbackMetadata } = $$props;
  let { style = {} } = $$props;
  const Radio2 = style.checksAndRadios === "standard" ? Standard2 : Animated2;
  const Select2 = style.labels === "stacked" ? Stacked_label$1 : Floating_label$1;
  let choiceOptions;
  let inputName;
  let label;
  let prompt;
  let defaultChoice;
  function setValue(event) {
    callback.setChoiceIndex(Number(event.target.value));
  }
  $$self.$$set = ($$props2) => {
    if ("callback" in $$props2) $$invalidate(11, callback = $$props2.callback);
    if ("callbackMetadata" in $$props2) $$invalidate(0, callbackMetadata = $$props2.callbackMetadata);
    if ("style" in $$props2) $$invalidate(12, style = $$props2.style);
  };
  $$self.$$.update = () => {
    var _a, _b, _c;
    if ($$self.$$.dirty & /*callback, callbackMetadata, prompt*/
    2051) {
      {
        $$invalidate(2, choiceOptions = (_a = callback.getChoices()) == null ? void 0 : _a.map((text2, idx) => ({
          /**
          * Since locale content keys for the choice component are built off of the
          * values, there will not be any existing key-value pairs in the provided
          * content. The third argument here, the original value, is what will be
          * displayed. If you want to localize it, you'll need to add content keys
          * in the locale file for that to override the original value.
          */
          text: interpolate(textToKey(text2), null, text2),
          value: `${idx}`
        })));
        $$invalidate(5, defaultChoice = `${callback.getDefaultChoice()}` || null);
        $$invalidate(3, inputName = ((_c = (_b = callback == null ? void 0 : callback.payload) == null ? void 0 : _b.input) == null ? void 0 : _c[0].name) || `choice-${callbackMetadata == null ? void 0 : callbackMetadata.idx}`);
        $$invalidate(1, prompt = callback.getPrompt());
        $$invalidate(4, label = interpolate(textToKey(prompt), null, prompt));
      }
    }
  };
  return [
    callbackMetadata,
    prompt,
    choiceOptions,
    inputName,
    label,
    defaultChoice,
    Radio2,
    Select2,
    setValue,
    selfSubmitFunction,
    stepMetadata,
    callback,
    style
  ];
}
var Choice = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$P, create_fragment$N, safe_not_equal, {
      selfSubmitFunction: 9,
      stepMetadata: 10,
      callback: 11,
      callbackMetadata: 0,
      style: 12
    });
  }
  get selfSubmitFunction() {
    return this.$$.ctx[9];
  }
  get stepMetadata() {
    return this.$$.ctx[10];
  }
};
function create_fragment$M(ctx) {
  let div;
  let div_class_value;
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[2].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[1],
    null
  );
  return {
    c() {
      div = element("div");
      if (default_slot) default_slot.c();
      attr(div, "class", div_class_value = `${generateClassString(
        /*num*/
        ctx[0]
      )} tw_gap-4 tw_grid tw_grid-cols-1 tw_input-spacing`);
    },
    m(target, anchor) {
      insert(target, div, anchor);
      if (default_slot) {
        default_slot.m(div, null);
      }
      current = true;
    },
    p(ctx2, [dirty]) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        2)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[1],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[1]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[1],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (!current || dirty & /*num*/
      1 && div_class_value !== (div_class_value = `${generateClassString(
        /*num*/
        ctx2[0]
      )} tw_gap-4 tw_grid tw_grid-cols-1 tw_input-spacing`)) {
        attr(div, "class", div_class_value);
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function generateClassString(...args) {
  return args.reduce(
    (prev, curr) => {
      switch (curr) {
        case 4:
          return `${prev} md:tw_grid-cols-4`;
        case 3:
          return `${prev} md:tw_grid-cols-3`;
        case 2:
          return `${prev} md:tw_grid-cols-2`;
        default:
          return `${prev} md:tw_grid-cols-1`;
      }
    },
    ""
  );
}
function instance$O($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { num = 2 } = $$props;
  $$self.$$set = ($$props2) => {
    if ("num" in $$props2) $$invalidate(0, num = $$props2.num);
    if ("$$scope" in $$props2) $$invalidate(1, $$scope = $$props2.$$scope);
  };
  return [num, $$scope, slots];
}
var Grid = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$O, create_fragment$M, safe_not_equal, { num: 0 });
  }
};
function get_each_context$9(ctx, list, i9) {
  const child_ctx = ctx.slice();
  child_ctx[15] = list[i9];
  return child_ctx;
}
function create_else_block_1$1(ctx) {
  let grid;
  let current;
  grid = new Grid({
    props: {
      num: (
        /*options*/
        ctx[3].length >= 2 ? 2 : 1
      ),
      $$slots: { default: [create_default_slot_1$g] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(grid.$$.fragment);
    },
    m(target, anchor) {
      mount_component(grid, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const grid_changes = {};
      if (dirty & /*options*/
      8) grid_changes.num = /*options*/
      ctx2[3].length >= 2 ? 2 : 1;
      if (dirty & /*$$scope, options, defaultChoice, buttonStyle*/
      262200) {
        grid_changes.$$scope = { dirty, ctx: ctx2 };
      }
      grid.$set(grid_changes);
    },
    i(local) {
      if (current) return;
      transition_in(grid.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(grid.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(grid, detaching);
    }
  };
}
function create_if_block$o(ctx) {
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block_1$e, create_else_block$8];
  const if_blocks = [];
  function select_block_type_1(ctx2, dirty) {
    if (
      /*options*/
      ctx2[3].length > 1
    ) return 0;
    return 1;
  }
  current_block_type_index = select_block_type_1(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type_1(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(if_block_anchor.parentNode, if_block_anchor);
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if_blocks[current_block_type_index].d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function create_default_slot_2$9(ctx) {
  let t0_value = (
    /*opt*/
    ctx[15].text + ""
  );
  let t0;
  let t1;
  return {
    c() {
      t0 = text(t0_value);
      t1 = space();
    },
    m(target, anchor) {
      insert(target, t0, anchor);
      insert(target, t1, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*options*/
      8 && t0_value !== (t0_value = /*opt*/
      ctx2[15].text + "")) set_data(t0, t0_value);
    },
    d(detaching) {
      if (detaching) detach(t0);
      if (detaching) detach(t1);
    }
  };
}
function create_each_block$9(ctx) {
  let button;
  let current;
  function func() {
    return (
      /*func*/
      ctx[14](
        /*opt*/
        ctx[15]
      )
    );
  }
  button = new Button({
    props: {
      style: (
        /*options*/
        ctx[3].length > 1 && /*defaultChoice*/
        ctx[5] === Number(
          /*opt*/
          ctx[15].value
        ) ? "primary" : (
          /*buttonStyle*/
          ctx[4]
        )
      ),
      type: "button",
      width: "auto",
      onClick: func,
      $$slots: { default: [create_default_slot_2$9] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(button.$$.fragment);
    },
    m(target, anchor) {
      mount_component(button, target, anchor);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      const button_changes = {};
      if (dirty & /*options, defaultChoice, buttonStyle*/
      56) button_changes.style = /*options*/
      ctx[3].length > 1 && /*defaultChoice*/
      ctx[5] === Number(
        /*opt*/
        ctx[15].value
      ) ? "primary" : (
        /*buttonStyle*/
        ctx[4]
      );
      if (dirty & /*options*/
      8) button_changes.onClick = func;
      if (dirty & /*$$scope, options*/
      262152) {
        button_changes.$$scope = { dirty, ctx };
      }
      button.$set(button_changes);
    },
    i(local) {
      if (current) return;
      transition_in(button.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(button.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(button, detaching);
    }
  };
}
function create_default_slot_1$g(ctx) {
  let each_1_anchor;
  let current;
  let each_value = (
    /*options*/
    ctx[3]
  );
  let each_blocks = [];
  for (let i9 = 0; i9 < each_value.length; i9 += 1) {
    each_blocks[i9] = create_each_block$9(get_each_context$9(ctx, each_value, i9));
  }
  const out = (i9) => transition_out(each_blocks[i9], 1, 1, () => {
    each_blocks[i9] = null;
  });
  return {
    c() {
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].c();
      }
      each_1_anchor = empty();
    },
    m(target, anchor) {
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].m(target, anchor);
      }
      insert(target, each_1_anchor, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      if (dirty & /*options, defaultChoice, Number, buttonStyle, setBtnValue*/
      312) {
        each_value = /*options*/
        ctx2[3];
        let i9;
        for (i9 = 0; i9 < each_value.length; i9 += 1) {
          const child_ctx = get_each_context$9(ctx2, each_value, i9);
          if (each_blocks[i9]) {
            each_blocks[i9].p(child_ctx, dirty);
            transition_in(each_blocks[i9], 1);
          } else {
            each_blocks[i9] = create_each_block$9(child_ctx);
            each_blocks[i9].c();
            transition_in(each_blocks[i9], 1);
            each_blocks[i9].m(each_1_anchor.parentNode, each_1_anchor);
          }
        }
        group_outros();
        for (i9 = each_value.length; i9 < each_blocks.length; i9 += 1) {
          out(i9);
        }
        check_outros();
      }
    },
    i(local) {
      if (current) return;
      for (let i9 = 0; i9 < each_value.length; i9 += 1) {
        transition_in(each_blocks[i9]);
      }
      current = true;
    },
    o(local) {
      each_blocks = each_blocks.filter(Boolean);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        transition_out(each_blocks[i9]);
      }
      current = false;
    },
    d(detaching) {
      destroy_each(each_blocks, detaching);
      if (detaching) detach(each_1_anchor);
    }
  };
}
function create_else_block$8(ctx) {
  var _a;
  let checkbox;
  let current;
  checkbox = new /*Checkbox*/
  ctx[7]({
    props: {
      isFirstInvalidInput: (
        /*callbackMetadata*/
        ((_a = ctx[0]) == null ? void 0 : _a.derived.isFirstInvalidInput) || false
      ),
      isInvalid: false,
      key: (
        /*inputName*/
        ctx[6]
      ),
      onChange: (
        /*setCheckboxValue*/
        ctx[10]
      ),
      value: false,
      $$slots: { default: [create_default_slot$n] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(checkbox.$$.fragment);
    },
    m(target, anchor) {
      mount_component(checkbox, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      const checkbox_changes = {};
      if (dirty & /*callbackMetadata*/
      1) checkbox_changes.isFirstInvalidInput = /*callbackMetadata*/
      ((_a2 = ctx2[0]) == null ? void 0 : _a2.derived.isFirstInvalidInput) || false;
      if (dirty & /*inputName*/
      64) checkbox_changes.key = /*inputName*/
      ctx2[6];
      if (dirty & /*$$scope, options*/
      262152) {
        checkbox_changes.$$scope = { dirty, ctx: ctx2 };
      }
      checkbox.$set(checkbox_changes);
    },
    i(local) {
      if (current) return;
      transition_in(checkbox.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(checkbox.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(checkbox, detaching);
    }
  };
}
function create_if_block_1$e(ctx) {
  var _a;
  let select;
  let current;
  select = new Floating_label$1({
    props: {
      isFirstInvalidInput: (
        /*callbackMetadata*/
        ((_a = ctx[0]) == null ? void 0 : _a.derived.isFirstInvalidInput) || false
      ),
      isRequired: false,
      key: (
        /*inputName*/
        ctx[6]
      ),
      label: (
        /*label*/
        ctx[2]
      ),
      onChange: (
        /*setOptionValue*/
        ctx[9]
      ),
      options: (
        /*options*/
        ctx[3]
      )
    }
  });
  return {
    c() {
      create_component(select.$$.fragment);
    },
    m(target, anchor) {
      mount_component(select, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      const select_changes = {};
      if (dirty & /*callbackMetadata*/
      1) select_changes.isFirstInvalidInput = /*callbackMetadata*/
      ((_a2 = ctx2[0]) == null ? void 0 : _a2.derived.isFirstInvalidInput) || false;
      if (dirty & /*inputName*/
      64) select_changes.key = /*inputName*/
      ctx2[6];
      if (dirty & /*label*/
      4) select_changes.label = /*label*/
      ctx2[2];
      if (dirty & /*options*/
      8) select_changes.options = /*options*/
      ctx2[3];
      select.$set(select_changes);
    },
    i(local) {
      if (current) return;
      transition_in(select.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(select.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(select, detaching);
    }
  };
}
function create_default_slot$n(ctx) {
  let t_value = (
    /*options*/
    ctx[3][0].text + ""
  );
  let t3;
  return {
    c() {
      t3 = text(t_value);
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*options*/
      8 && t_value !== (t_value = /*options*/
      ctx2[3][0].text + "")) set_data(t3, t_value);
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_fragment$L(ctx) {
  let show_if;
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block$o, create_else_block_1$1];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    var _a;
    if (dirty & /*stepMetadata*/
    2) show_if = null;
    if (show_if == null) show_if = !!!/*stepMetadata*/
    ((_a = ctx2[1]) == null ? void 0 : _a.derived.isStepSelfSubmittable());
    if (show_if) return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx, -1);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2, dirty);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(if_block_anchor.parentNode, if_block_anchor);
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if_blocks[current_block_type_index].d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function instance$N($$self, $$props, $$invalidate) {
  const style = {};
  let { callback } = $$props;
  let { callbackMetadata } = $$props;
  let { selfSubmitFunction = null } = $$props;
  let { stepMetadata } = $$props;
  const Checkbox2 = style.checksAndRadios === "standard" ? Standard$1 : Animated$1;
  let buttonStyle;
  let defaultChoice = callback.getDefaultOption();
  let inputName;
  let label;
  let options;
  function setBtnValue(index) {
    callback.setOptionIndex(index);
    if (callbackMetadata) {
      $$invalidate(0, callbackMetadata.derived.isReadyForSubmission = true, callbackMetadata);
    }
    selfSubmitFunction && selfSubmitFunction();
  }
  function setOptionValue(event) {
    callback.setOptionIndex(Number(event.target.value));
  }
  function setCheckboxValue(event) {
    const value = event.target.checked;
    if (value) {
      callback.setOptionIndex(0);
    } else {
      callback.setOptionIndex(defaultChoice);
    }
  }
  if (callback.getInputValue() === 0) {
    callback.setOptionIndex(defaultChoice);
  }
  const func = (opt) => setBtnValue(Number(opt.value));
  $$self.$$set = ($$props2) => {
    if ("callback" in $$props2) $$invalidate(12, callback = $$props2.callback);
    if ("callbackMetadata" in $$props2) $$invalidate(0, callbackMetadata = $$props2.callbackMetadata);
    if ("selfSubmitFunction" in $$props2) $$invalidate(13, selfSubmitFunction = $$props2.selfSubmitFunction);
    if ("stepMetadata" in $$props2) $$invalidate(1, stepMetadata = $$props2.stepMetadata);
  };
  $$self.$$.update = () => {
    var _a, _b, _c;
    if ($$self.$$.dirty & /*callback, callbackMetadata, options, stepMetadata, label*/
    4111) {
      {
        $$invalidate(6, inputName = ((_b = (_a = callback == null ? void 0 : callback.payload) == null ? void 0 : _a.input) == null ? void 0 : _b[0].name) || `confirmation-${callbackMetadata == null ? void 0 : callbackMetadata.idx}`);
        $$invalidate(3, options = callback.getOptions().map((option, index) => ({ value: `${index}`, text: option })));
        $$invalidate(5, defaultChoice = callback.getDefaultOption());
        $$invalidate(2, label = interpolate(textToKey("pleaseConfirm"), null, "Please Confirm"));
        if ((_c = callbackMetadata == null ? void 0 : callbackMetadata.platform) == null ? void 0 : _c.showOnlyPositiveAnswer) {
          $$invalidate(3, options = options.slice(0, 1));
        }
        if (!(stepMetadata == null ? void 0 : stepMetadata.derived.isStepSelfSubmittable()) && options.length > 1) {
          options.unshift({ value: "", text: label });
        } else if (options.length === 1) {
          $$invalidate(4, buttonStyle = "outline");
        } else {
          $$invalidate(4, buttonStyle = "secondary");
        }
      }
    }
  };
  return [
    callbackMetadata,
    stepMetadata,
    label,
    options,
    buttonStyle,
    defaultChoice,
    inputName,
    Checkbox2,
    setBtnValue,
    setOptionValue,
    setCheckboxValue,
    style,
    callback,
    selfSubmitFunction,
    func
  ];
}
var Confirmation = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$N, create_fragment$L, safe_not_equal, {
      style: 11,
      callback: 12,
      callbackMetadata: 0,
      selfSubmitFunction: 13,
      stepMetadata: 1
    });
  }
  get style() {
    return this.$$.ctx[11];
  }
};
function instance$M($$self, $$props, $$invalidate) {
  const callback = null;
  const callbackMetadata = null;
  const selfSubmitFunction = null;
  const stepMetadata = null;
  const style = {};
  return [callback, callbackMetadata, selfSubmitFunction, stepMetadata, style];
}
var Hidden_value = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$M, null, safe_not_equal, {
      callback: 0,
      callbackMetadata: 1,
      selfSubmitFunction: 2,
      stepMetadata: 3,
      style: 4
    });
  }
  get callback() {
    return this.$$.ctx[0];
  }
  get callbackMetadata() {
    return this.$$.ctx[1];
  }
  get selfSubmitFunction() {
    return this.$$.ctx[2];
  }
  get stepMetadata() {
    return this.$$.ctx[3];
  }
  get style() {
    return this.$$.ctx[4];
  }
};
function create_if_block_7$1(ctx) {
  let label_1;
  let current;
  label_1 = new Label({
    props: {
      key: (
        /*key*/
        ctx[3]
      ),
      classes: `${/*labelClasses*/
      ctx[5]} tw_w-full tw_ml-1`,
      $$slots: { default: [create_default_slot_1$f] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(label_1.$$.fragment);
    },
    m(target, anchor) {
      mount_component(label_1, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const label_1_changes = {};
      if (dirty & /*key*/
      8) label_1_changes.key = /*key*/
      ctx2[3];
      if (dirty & /*labelClasses*/
      32) label_1_changes.classes = `${/*labelClasses*/
      ctx2[5]} tw_w-full tw_ml-1`;
      if (dirty & /*$$scope, label*/
      67108880) {
        label_1_changes.$$scope = { dirty, ctx: ctx2 };
      }
      label_1.$set(label_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(label_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(label_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(label_1, detaching);
    }
  };
}
function create_default_slot_1$f(ctx) {
  let t3;
  return {
    c() {
      t3 = text(
        /*label*/
        ctx[4]
      );
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*label*/
      16) set_data(
        t3,
        /*label*/
        ctx2[4]
      );
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_if_block_6$1(ctx) {
  let input;
  let input_aria_describedby_value;
  let input_class_value;
  let mounted;
  let dispose;
  return {
    c() {
      input = element("input");
      attr(input, "aria-describedby", input_aria_describedby_value = `${/*key*/
      ctx[3]}-message`);
      attr(
        input,
        "aria-invalid",
        /*isInvalid*/
        ctx[10]
      );
      attr(input, "class", input_class_value = `${/*inputClasses*/
      ctx[2]} tw_input-base dark:tw_input-base_dark tw_focusable-element dark:tw_focusable-element_dark tw_flex-1 tw_w-full`);
      attr(
        input,
        "data-force-validity-failure",
        /*forceValidityFailure*/
        ctx[1]
      );
      attr(
        input,
        "id",
        /*key*/
        ctx[3]
      );
      attr(
        input,
        "placeholder",
        /*placeholder*/
        ctx[8]
      );
      input.required = /*isRequired*/
      ctx[9];
      attr(input, "type", "date");
    },
    m(target, anchor) {
      insert(target, input, anchor);
      ctx[14](input);
      set_input_value(
        input,
        /*value*/
        ctx[0]
      );
      if (!mounted) {
        dispose = [
          listen(input, "change", function() {
            if (is_function(
              /*onChange*/
              ctx[7]
            )) ctx[7].apply(this, arguments);
          }),
          listen(
            input,
            "input",
            /*input_input_handler*/
            ctx[15]
          )
        ];
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*key*/
      8 && input_aria_describedby_value !== (input_aria_describedby_value = `${/*key*/
      ctx[3]}-message`)) {
        attr(input, "aria-describedby", input_aria_describedby_value);
      }
      if (dirty & /*isInvalid*/
      1024) {
        attr(
          input,
          "aria-invalid",
          /*isInvalid*/
          ctx[10]
        );
      }
      if (dirty & /*inputClasses*/
      4 && input_class_value !== (input_class_value = `${/*inputClasses*/
      ctx[2]} tw_input-base dark:tw_input-base_dark tw_focusable-element dark:tw_focusable-element_dark tw_flex-1 tw_w-full`)) {
        attr(input, "class", input_class_value);
      }
      if (dirty & /*forceValidityFailure*/
      2) {
        attr(
          input,
          "data-force-validity-failure",
          /*forceValidityFailure*/
          ctx[1]
        );
      }
      if (dirty & /*key*/
      8) {
        attr(
          input,
          "id",
          /*key*/
          ctx[3]
        );
      }
      if (dirty & /*placeholder*/
      256) {
        attr(
          input,
          "placeholder",
          /*placeholder*/
          ctx[8]
        );
      }
      if (dirty & /*isRequired*/
      512) {
        input.required = /*isRequired*/
        ctx[9];
      }
      if (dirty & /*value*/
      1) {
        set_input_value(
          input,
          /*value*/
          ctx[0]
        );
      }
    },
    d(detaching) {
      if (detaching) detach(input);
      ctx[14](null);
      mounted = false;
      run_all(dispose);
    }
  };
}
function create_if_block_5$2(ctx) {
  let input;
  let input_aria_describedby_value;
  let input_class_value;
  let mounted;
  let dispose;
  return {
    c() {
      input = element("input");
      attr(input, "aria-describedby", input_aria_describedby_value = `${/*key*/
      ctx[3]}-message`);
      attr(
        input,
        "aria-invalid",
        /*isInvalid*/
        ctx[10]
      );
      attr(input, "class", input_class_value = `${/*inputClasses*/
      ctx[2]} tw_input-base dark:tw_input-base_dark tw_focusable-element dark:tw_focusable-element_dark tw_flex-1 tw_w-full`);
      attr(
        input,
        "data-force-validity-failure",
        /*forceValidityFailure*/
        ctx[1]
      );
      attr(
        input,
        "id",
        /*key*/
        ctx[3]
      );
      attr(
        input,
        "placeholder",
        /*placeholder*/
        ctx[8]
      );
      input.required = /*isRequired*/
      ctx[9];
      attr(input, "type", "email");
    },
    m(target, anchor) {
      insert(target, input, anchor);
      ctx[16](input);
      set_input_value(
        input,
        /*value*/
        ctx[0]
      );
      if (!mounted) {
        dispose = [
          listen(input, "change", function() {
            if (is_function(
              /*onChange*/
              ctx[7]
            )) ctx[7].apply(this, arguments);
          }),
          listen(
            input,
            "input",
            /*input_input_handler_1*/
            ctx[17]
          )
        ];
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*key*/
      8 && input_aria_describedby_value !== (input_aria_describedby_value = `${/*key*/
      ctx[3]}-message`)) {
        attr(input, "aria-describedby", input_aria_describedby_value);
      }
      if (dirty & /*isInvalid*/
      1024) {
        attr(
          input,
          "aria-invalid",
          /*isInvalid*/
          ctx[10]
        );
      }
      if (dirty & /*inputClasses*/
      4 && input_class_value !== (input_class_value = `${/*inputClasses*/
      ctx[2]} tw_input-base dark:tw_input-base_dark tw_focusable-element dark:tw_focusable-element_dark tw_flex-1 tw_w-full`)) {
        attr(input, "class", input_class_value);
      }
      if (dirty & /*forceValidityFailure*/
      2) {
        attr(
          input,
          "data-force-validity-failure",
          /*forceValidityFailure*/
          ctx[1]
        );
      }
      if (dirty & /*key*/
      8) {
        attr(
          input,
          "id",
          /*key*/
          ctx[3]
        );
      }
      if (dirty & /*placeholder*/
      256) {
        attr(
          input,
          "placeholder",
          /*placeholder*/
          ctx[8]
        );
      }
      if (dirty & /*isRequired*/
      512) {
        input.required = /*isRequired*/
        ctx[9];
      }
      if (dirty & /*value*/
      1 && input.value !== /*value*/
      ctx[0]) {
        set_input_value(
          input,
          /*value*/
          ctx[0]
        );
      }
    },
    d(detaching) {
      if (detaching) detach(input);
      ctx[16](null);
      mounted = false;
      run_all(dispose);
    }
  };
}
function create_if_block_4$6(ctx) {
  let input;
  let input_aria_describedby_value;
  let input_class_value;
  let mounted;
  let dispose;
  return {
    c() {
      input = element("input");
      attr(input, "aria-describedby", input_aria_describedby_value = `${/*key*/
      ctx[3]}-message`);
      attr(
        input,
        "aria-invalid",
        /*isInvalid*/
        ctx[10]
      );
      attr(input, "class", input_class_value = `${/*inputClasses*/
      ctx[2]} tw_input-base dark:tw_input-base_dark tw_focusable-element dark:tw_focusable-element_dark tw_flex-1 tw_w-full`);
      attr(
        input,
        "data-force-validity-failure",
        /*forceValidityFailure*/
        ctx[1]
      );
      attr(
        input,
        "id",
        /*key*/
        ctx[3]
      );
      attr(
        input,
        "placeholder",
        /*placeholder*/
        ctx[8]
      );
      input.required = /*isRequired*/
      ctx[9];
      attr(input, "type", "number");
    },
    m(target, anchor) {
      insert(target, input, anchor);
      ctx[18](input);
      set_input_value(
        input,
        /*value*/
        ctx[0]
      );
      if (!mounted) {
        dispose = [
          listen(input, "change", function() {
            if (is_function(
              /*onChange*/
              ctx[7]
            )) ctx[7].apply(this, arguments);
          }),
          listen(
            input,
            "input",
            /*input_input_handler_2*/
            ctx[19]
          )
        ];
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*key*/
      8 && input_aria_describedby_value !== (input_aria_describedby_value = `${/*key*/
      ctx[3]}-message`)) {
        attr(input, "aria-describedby", input_aria_describedby_value);
      }
      if (dirty & /*isInvalid*/
      1024) {
        attr(
          input,
          "aria-invalid",
          /*isInvalid*/
          ctx[10]
        );
      }
      if (dirty & /*inputClasses*/
      4 && input_class_value !== (input_class_value = `${/*inputClasses*/
      ctx[2]} tw_input-base dark:tw_input-base_dark tw_focusable-element dark:tw_focusable-element_dark tw_flex-1 tw_w-full`)) {
        attr(input, "class", input_class_value);
      }
      if (dirty & /*forceValidityFailure*/
      2) {
        attr(
          input,
          "data-force-validity-failure",
          /*forceValidityFailure*/
          ctx[1]
        );
      }
      if (dirty & /*key*/
      8) {
        attr(
          input,
          "id",
          /*key*/
          ctx[3]
        );
      }
      if (dirty & /*placeholder*/
      256) {
        attr(
          input,
          "placeholder",
          /*placeholder*/
          ctx[8]
        );
      }
      if (dirty & /*isRequired*/
      512) {
        input.required = /*isRequired*/
        ctx[9];
      }
      if (dirty & /*value*/
      1 && to_number(input.value) !== /*value*/
      ctx[0]) {
        set_input_value(
          input,
          /*value*/
          ctx[0]
        );
      }
    },
    d(detaching) {
      if (detaching) detach(input);
      ctx[18](null);
      mounted = false;
      run_all(dispose);
    }
  };
}
function create_if_block_3$9(ctx) {
  let input;
  let input_aria_describedby_value;
  let input_class_value;
  let mounted;
  let dispose;
  return {
    c() {
      input = element("input");
      attr(input, "aria-describedby", input_aria_describedby_value = `${/*key*/
      ctx[3]}-message`);
      attr(
        input,
        "aria-invalid",
        /*isInvalid*/
        ctx[10]
      );
      attr(input, "class", input_class_value = `${/*inputClasses*/
      ctx[2]} tw_input-base dark:tw_input-base_dark tw_focusable-element dark:tw_focusable-element_dark tw_flex-1 tw_w-full`);
      attr(
        input,
        "data-force-validity-failure",
        /*forceValidityFailure*/
        ctx[1]
      );
      attr(
        input,
        "id",
        /*key*/
        ctx[3]
      );
      attr(
        input,
        "placeholder",
        /*placeholder*/
        ctx[8]
      );
      input.required = /*isRequired*/
      ctx[9];
      attr(input, "type", "password");
    },
    m(target, anchor) {
      insert(target, input, anchor);
      ctx[20](input);
      set_input_value(
        input,
        /*value*/
        ctx[0]
      );
      if (!mounted) {
        dispose = [
          listen(input, "change", function() {
            if (is_function(
              /*onChange*/
              ctx[7]
            )) ctx[7].apply(this, arguments);
          }),
          listen(
            input,
            "input",
            /*input_input_handler_3*/
            ctx[21]
          )
        ];
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*key*/
      8 && input_aria_describedby_value !== (input_aria_describedby_value = `${/*key*/
      ctx[3]}-message`)) {
        attr(input, "aria-describedby", input_aria_describedby_value);
      }
      if (dirty & /*isInvalid*/
      1024) {
        attr(
          input,
          "aria-invalid",
          /*isInvalid*/
          ctx[10]
        );
      }
      if (dirty & /*inputClasses*/
      4 && input_class_value !== (input_class_value = `${/*inputClasses*/
      ctx[2]} tw_input-base dark:tw_input-base_dark tw_focusable-element dark:tw_focusable-element_dark tw_flex-1 tw_w-full`)) {
        attr(input, "class", input_class_value);
      }
      if (dirty & /*forceValidityFailure*/
      2) {
        attr(
          input,
          "data-force-validity-failure",
          /*forceValidityFailure*/
          ctx[1]
        );
      }
      if (dirty & /*key*/
      8) {
        attr(
          input,
          "id",
          /*key*/
          ctx[3]
        );
      }
      if (dirty & /*placeholder*/
      256) {
        attr(
          input,
          "placeholder",
          /*placeholder*/
          ctx[8]
        );
      }
      if (dirty & /*isRequired*/
      512) {
        input.required = /*isRequired*/
        ctx[9];
      }
      if (dirty & /*value*/
      1 && input.value !== /*value*/
      ctx[0]) {
        set_input_value(
          input,
          /*value*/
          ctx[0]
        );
      }
    },
    d(detaching) {
      if (detaching) detach(input);
      ctx[20](null);
      mounted = false;
      run_all(dispose);
    }
  };
}
function create_if_block_2$a(ctx) {
  let input;
  let input_aria_describedby_value;
  let input_class_value;
  let mounted;
  let dispose;
  return {
    c() {
      input = element("input");
      attr(input, "aria-describedby", input_aria_describedby_value = `${/*key*/
      ctx[3]}-message`);
      attr(
        input,
        "aria-invalid",
        /*isInvalid*/
        ctx[10]
      );
      attr(input, "class", input_class_value = `${/*inputClasses*/
      ctx[2]} tw_input-base dark:tw_input-base_dark tw_focusable-element dark:tw_focusable-element_dark tw_flex-1 tw_w-full`);
      attr(
        input,
        "data-force-validity-failure",
        /*forceValidityFailure*/
        ctx[1]
      );
      attr(
        input,
        "id",
        /*key*/
        ctx[3]
      );
      attr(
        input,
        "placeholder",
        /*placeholder*/
        ctx[8]
      );
      input.required = /*isRequired*/
      ctx[9];
      attr(input, "type", "phone");
    },
    m(target, anchor) {
      insert(target, input, anchor);
      ctx[22](input);
      set_input_value(
        input,
        /*value*/
        ctx[0]
      );
      if (!mounted) {
        dispose = [
          listen(input, "change", function() {
            if (is_function(
              /*onChange*/
              ctx[7]
            )) ctx[7].apply(this, arguments);
          }),
          listen(
            input,
            "input",
            /*input_input_handler_4*/
            ctx[23]
          )
        ];
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*key*/
      8 && input_aria_describedby_value !== (input_aria_describedby_value = `${/*key*/
      ctx[3]}-message`)) {
        attr(input, "aria-describedby", input_aria_describedby_value);
      }
      if (dirty & /*isInvalid*/
      1024) {
        attr(
          input,
          "aria-invalid",
          /*isInvalid*/
          ctx[10]
        );
      }
      if (dirty & /*inputClasses*/
      4 && input_class_value !== (input_class_value = `${/*inputClasses*/
      ctx[2]} tw_input-base dark:tw_input-base_dark tw_focusable-element dark:tw_focusable-element_dark tw_flex-1 tw_w-full`)) {
        attr(input, "class", input_class_value);
      }
      if (dirty & /*forceValidityFailure*/
      2) {
        attr(
          input,
          "data-force-validity-failure",
          /*forceValidityFailure*/
          ctx[1]
        );
      }
      if (dirty & /*key*/
      8) {
        attr(
          input,
          "id",
          /*key*/
          ctx[3]
        );
      }
      if (dirty & /*placeholder*/
      256) {
        attr(
          input,
          "placeholder",
          /*placeholder*/
          ctx[8]
        );
      }
      if (dirty & /*isRequired*/
      512) {
        input.required = /*isRequired*/
        ctx[9];
      }
      if (dirty & /*value*/
      1) {
        set_input_value(
          input,
          /*value*/
          ctx[0]
        );
      }
    },
    d(detaching) {
      if (detaching) detach(input);
      ctx[22](null);
      mounted = false;
      run_all(dispose);
    }
  };
}
function create_if_block_1$d(ctx) {
  let input;
  let input_aria_describedby_value;
  let input_class_value;
  let mounted;
  let dispose;
  return {
    c() {
      input = element("input");
      attr(input, "aria-describedby", input_aria_describedby_value = `${/*key*/
      ctx[3]}-message`);
      attr(
        input,
        "aria-invalid",
        /*isInvalid*/
        ctx[10]
      );
      attr(input, "class", input_class_value = `${/*inputClasses*/
      ctx[2]} tw_input-base dark:tw_input-base_dark tw_focusable-element dark:tw_focusable-element_dark tw_flex-1 tw_w-full`);
      attr(
        input,
        "data-force-validity-failure",
        /*forceValidityFailure*/
        ctx[1]
      );
      attr(
        input,
        "id",
        /*key*/
        ctx[3]
      );
      attr(
        input,
        "placeholder",
        /*placeholder*/
        ctx[8]
      );
      input.required = /*isRequired*/
      ctx[9];
      attr(input, "type", "text");
    },
    m(target, anchor) {
      insert(target, input, anchor);
      ctx[24](input);
      set_input_value(
        input,
        /*value*/
        ctx[0]
      );
      if (!mounted) {
        dispose = [
          listen(input, "change", function() {
            if (is_function(
              /*onChange*/
              ctx[7]
            )) ctx[7].apply(this, arguments);
          }),
          listen(
            input,
            "input",
            /*input_input_handler_5*/
            ctx[25]
          )
        ];
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*key*/
      8 && input_aria_describedby_value !== (input_aria_describedby_value = `${/*key*/
      ctx[3]}-message`)) {
        attr(input, "aria-describedby", input_aria_describedby_value);
      }
      if (dirty & /*isInvalid*/
      1024) {
        attr(
          input,
          "aria-invalid",
          /*isInvalid*/
          ctx[10]
        );
      }
      if (dirty & /*inputClasses*/
      4 && input_class_value !== (input_class_value = `${/*inputClasses*/
      ctx[2]} tw_input-base dark:tw_input-base_dark tw_focusable-element dark:tw_focusable-element_dark tw_flex-1 tw_w-full`)) {
        attr(input, "class", input_class_value);
      }
      if (dirty & /*forceValidityFailure*/
      2) {
        attr(
          input,
          "data-force-validity-failure",
          /*forceValidityFailure*/
          ctx[1]
        );
      }
      if (dirty & /*key*/
      8) {
        attr(
          input,
          "id",
          /*key*/
          ctx[3]
        );
      }
      if (dirty & /*placeholder*/
      256) {
        attr(
          input,
          "placeholder",
          /*placeholder*/
          ctx[8]
        );
      }
      if (dirty & /*isRequired*/
      512) {
        input.required = /*isRequired*/
        ctx[9];
      }
      if (dirty & /*value*/
      1 && input.value !== /*value*/
      ctx[0]) {
        set_input_value(
          input,
          /*value*/
          ctx[0]
        );
      }
    },
    d(detaching) {
      if (detaching) detach(input);
      ctx[24](null);
      mounted = false;
      run_all(dispose);
    }
  };
}
function create_if_block$n(ctx) {
  let label_1;
  let current;
  label_1 = new Label({
    props: {
      key: (
        /*key*/
        ctx[3]
      ),
      classes: `${/*labelClasses*/
      ctx[5]}`,
      $$slots: { default: [create_default_slot$m] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(label_1.$$.fragment);
    },
    m(target, anchor) {
      mount_component(label_1, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const label_1_changes = {};
      if (dirty & /*key*/
      8) label_1_changes.key = /*key*/
      ctx2[3];
      if (dirty & /*labelClasses*/
      32) label_1_changes.classes = `${/*labelClasses*/
      ctx2[5]}`;
      if (dirty & /*$$scope, label*/
      67108880) {
        label_1_changes.$$scope = { dirty, ctx: ctx2 };
      }
      label_1.$set(label_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(label_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(label_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(label_1, detaching);
    }
  };
}
function create_default_slot$m(ctx) {
  let t3;
  return {
    c() {
      t3 = text(
        /*label*/
        ctx[4]
      );
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*label*/
      16) set_data(
        t3,
        /*label*/
        ctx2[4]
      );
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_fragment$K(ctx) {
  let t0;
  let t1;
  let t22;
  let t3;
  let t4;
  let t5;
  let t6;
  let if_block7_anchor;
  let current;
  let if_block0 = (
    /*labelOrder*/
    ctx[6] === "first" && create_if_block_7$1(ctx)
  );
  let if_block1 = (
    /*type*/
    ctx[11] === "date" && create_if_block_6$1(ctx)
  );
  let if_block2 = (
    /*type*/
    ctx[11] === "email" && create_if_block_5$2(ctx)
  );
  let if_block3 = (
    /*type*/
    ctx[11] === "number" && create_if_block_4$6(ctx)
  );
  let if_block4 = (
    /*type*/
    ctx[11] === "password" && create_if_block_3$9(ctx)
  );
  let if_block5 = (
    /*type*/
    ctx[11] === "phone" && create_if_block_2$a(ctx)
  );
  let if_block6 = (
    /*type*/
    ctx[11] === "text" && create_if_block_1$d(ctx)
  );
  let if_block7 = (
    /*labelOrder*/
    ctx[6] === "last" && create_if_block$n(ctx)
  );
  return {
    c() {
      if (if_block0) if_block0.c();
      t0 = space();
      if (if_block1) if_block1.c();
      t1 = space();
      if (if_block2) if_block2.c();
      t22 = space();
      if (if_block3) if_block3.c();
      t3 = space();
      if (if_block4) if_block4.c();
      t4 = space();
      if (if_block5) if_block5.c();
      t5 = space();
      if (if_block6) if_block6.c();
      t6 = space();
      if (if_block7) if_block7.c();
      if_block7_anchor = empty();
    },
    m(target, anchor) {
      if (if_block0) if_block0.m(target, anchor);
      insert(target, t0, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, t1, anchor);
      if (if_block2) if_block2.m(target, anchor);
      insert(target, t22, anchor);
      if (if_block3) if_block3.m(target, anchor);
      insert(target, t3, anchor);
      if (if_block4) if_block4.m(target, anchor);
      insert(target, t4, anchor);
      if (if_block5) if_block5.m(target, anchor);
      insert(target, t5, anchor);
      if (if_block6) if_block6.m(target, anchor);
      insert(target, t6, anchor);
      if (if_block7) if_block7.m(target, anchor);
      insert(target, if_block7_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (
        /*labelOrder*/
        ctx2[6] === "first"
      ) {
        if (if_block0) {
          if_block0.p(ctx2, dirty);
          if (dirty & /*labelOrder*/
          64) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_7$1(ctx2);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(t0.parentNode, t0);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      if (
        /*type*/
        ctx2[11] === "date"
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
        } else {
          if_block1 = create_if_block_6$1(ctx2);
          if_block1.c();
          if_block1.m(t1.parentNode, t1);
        }
      } else if (if_block1) {
        if_block1.d(1);
        if_block1 = null;
      }
      if (
        /*type*/
        ctx2[11] === "email"
      ) {
        if (if_block2) {
          if_block2.p(ctx2, dirty);
        } else {
          if_block2 = create_if_block_5$2(ctx2);
          if_block2.c();
          if_block2.m(t22.parentNode, t22);
        }
      } else if (if_block2) {
        if_block2.d(1);
        if_block2 = null;
      }
      if (
        /*type*/
        ctx2[11] === "number"
      ) {
        if (if_block3) {
          if_block3.p(ctx2, dirty);
        } else {
          if_block3 = create_if_block_4$6(ctx2);
          if_block3.c();
          if_block3.m(t3.parentNode, t3);
        }
      } else if (if_block3) {
        if_block3.d(1);
        if_block3 = null;
      }
      if (
        /*type*/
        ctx2[11] === "password"
      ) {
        if (if_block4) {
          if_block4.p(ctx2, dirty);
        } else {
          if_block4 = create_if_block_3$9(ctx2);
          if_block4.c();
          if_block4.m(t4.parentNode, t4);
        }
      } else if (if_block4) {
        if_block4.d(1);
        if_block4 = null;
      }
      if (
        /*type*/
        ctx2[11] === "phone"
      ) {
        if (if_block5) {
          if_block5.p(ctx2, dirty);
        } else {
          if_block5 = create_if_block_2$a(ctx2);
          if_block5.c();
          if_block5.m(t5.parentNode, t5);
        }
      } else if (if_block5) {
        if_block5.d(1);
        if_block5 = null;
      }
      if (
        /*type*/
        ctx2[11] === "text"
      ) {
        if (if_block6) {
          if_block6.p(ctx2, dirty);
        } else {
          if_block6 = create_if_block_1$d(ctx2);
          if_block6.c();
          if_block6.m(t6.parentNode, t6);
        }
      } else if (if_block6) {
        if_block6.d(1);
        if_block6 = null;
      }
      if (
        /*labelOrder*/
        ctx2[6] === "last"
      ) {
        if (if_block7) {
          if_block7.p(ctx2, dirty);
          if (dirty & /*labelOrder*/
          64) {
            transition_in(if_block7, 1);
          }
        } else {
          if_block7 = create_if_block$n(ctx2);
          if_block7.c();
          transition_in(if_block7, 1);
          if_block7.m(if_block7_anchor.parentNode, if_block7_anchor);
        }
      } else if (if_block7) {
        group_outros();
        transition_out(if_block7, 1, 1, () => {
          if_block7 = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block0);
      transition_in(if_block7);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(if_block7);
      current = false;
    },
    d(detaching) {
      if (if_block0) if_block0.d(detaching);
      if (detaching) detach(t0);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(t1);
      if (if_block2) if_block2.d(detaching);
      if (detaching) detach(t22);
      if (if_block3) if_block3.d(detaching);
      if (detaching) detach(t3);
      if (if_block4) if_block4.d(detaching);
      if (detaching) detach(t4);
      if (if_block5) if_block5.d(detaching);
      if (detaching) detach(t5);
      if (if_block6) if_block6.d(detaching);
      if (detaching) detach(t6);
      if (if_block7) if_block7.d(detaching);
      if (detaching) detach(if_block7_anchor);
    }
  };
}
function instance$L($$self, $$props, $$invalidate) {
  let { forceValidityFailure = false } = $$props;
  let { isFirstInvalidInput } = $$props;
  let { inputClasses = "" } = $$props;
  let { key } = $$props;
  let { label } = $$props;
  let { labelClasses = "" } = $$props;
  let { labelOrder = "first" } = $$props;
  let { onChange } = $$props;
  let { placeholder = " " } = $$props;
  let { isRequired = false } = $$props;
  let { isInvalid = null } = $$props;
  let { type = "text" } = $$props;
  let { value = "" } = $$props;
  let inputEl;
  afterUpdate(() => {
    if (isFirstInvalidInput) {
      inputEl.focus();
    }
  });
  function input_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      inputEl = $$value;
      $$invalidate(12, inputEl);
    });
  }
  function input_input_handler() {
    value = this.value;
    $$invalidate(0, value);
  }
  function input_binding_1($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      inputEl = $$value;
      $$invalidate(12, inputEl);
    });
  }
  function input_input_handler_1() {
    value = this.value;
    $$invalidate(0, value);
  }
  function input_binding_2($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      inputEl = $$value;
      $$invalidate(12, inputEl);
    });
  }
  function input_input_handler_2() {
    value = to_number(this.value);
    $$invalidate(0, value);
  }
  function input_binding_3($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      inputEl = $$value;
      $$invalidate(12, inputEl);
    });
  }
  function input_input_handler_3() {
    value = this.value;
    $$invalidate(0, value);
  }
  function input_binding_4($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      inputEl = $$value;
      $$invalidate(12, inputEl);
    });
  }
  function input_input_handler_4() {
    value = this.value;
    $$invalidate(0, value);
  }
  function input_binding_5($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      inputEl = $$value;
      $$invalidate(12, inputEl);
    });
  }
  function input_input_handler_5() {
    value = this.value;
    $$invalidate(0, value);
  }
  $$self.$$set = ($$props2) => {
    if ("forceValidityFailure" in $$props2) $$invalidate(1, forceValidityFailure = $$props2.forceValidityFailure);
    if ("isFirstInvalidInput" in $$props2) $$invalidate(13, isFirstInvalidInput = $$props2.isFirstInvalidInput);
    if ("inputClasses" in $$props2) $$invalidate(2, inputClasses = $$props2.inputClasses);
    if ("key" in $$props2) $$invalidate(3, key = $$props2.key);
    if ("label" in $$props2) $$invalidate(4, label = $$props2.label);
    if ("labelClasses" in $$props2) $$invalidate(5, labelClasses = $$props2.labelClasses);
    if ("labelOrder" in $$props2) $$invalidate(6, labelOrder = $$props2.labelOrder);
    if ("onChange" in $$props2) $$invalidate(7, onChange = $$props2.onChange);
    if ("placeholder" in $$props2) $$invalidate(8, placeholder = $$props2.placeholder);
    if ("isRequired" in $$props2) $$invalidate(9, isRequired = $$props2.isRequired);
    if ("isInvalid" in $$props2) $$invalidate(10, isInvalid = $$props2.isInvalid);
    if ("type" in $$props2) $$invalidate(11, type = $$props2.type);
    if ("value" in $$props2) $$invalidate(0, value = $$props2.value);
  };
  return [
    value,
    forceValidityFailure,
    inputClasses,
    key,
    label,
    labelClasses,
    labelOrder,
    onChange,
    placeholder,
    isRequired,
    isInvalid,
    type,
    inputEl,
    isFirstInvalidInput,
    input_binding,
    input_input_handler,
    input_binding_1,
    input_input_handler_1,
    input_binding_2,
    input_input_handler_2,
    input_binding_3,
    input_input_handler_3,
    input_binding_4,
    input_input_handler_4,
    input_binding_5,
    input_input_handler_5
  ];
}
var Input = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$L, create_fragment$K, safe_not_equal, {
      forceValidityFailure: 1,
      isFirstInvalidInput: 13,
      inputClasses: 2,
      key: 3,
      label: 4,
      labelClasses: 5,
      labelOrder: 6,
      onChange: 7,
      placeholder: 8,
      isRequired: 9,
      isInvalid: 10,
      type: 11,
      value: 0
    });
  }
};
var get_input_button_slot_changes$1 = (dirty) => ({});
var get_input_button_slot_context$1 = (ctx) => ({});
function create_fragment$J(ctx) {
  let div1;
  let input;
  let updating_value;
  let t0;
  let t1;
  let div0;
  let message_1;
  let t22;
  let div0_id_value;
  let current;
  function input_value_binding(value) {
    ctx[16](value);
  }
  let input_props = {
    forceValidityFailure: (
      /*forceValidityFailure*/
      ctx[2]
    ),
    isFirstInvalidInput: (
      /*isFirstInvalidInput*/
      ctx[4]
    ),
    inputClasses: `tw_input-floating dark:tw_input-floating_dark ${/*hasRightIcon*/
    ctx[5] ? "!tw_border-r-0 !tw_rounded-r-none" : ""}`,
    key: (
      /*key*/
      ctx[7]
    ),
    onChange: (
      /*onChangeWrapper*/
      ctx[11]
    ),
    label: (
      /*label*/
      ctx[8]
    ),
    labelClasses: "tw_absolute tw_border tw_border-transparent tw_input-floating-label",
    labelOrder: "last",
    isRequired: (
      /*isRequired*/
      ctx[6]
    ),
    isInvalid: (
      /*isInvalid*/
      ctx[0]
    ),
    type: (
      /*type*/
      ctx[10]
    )
  };
  if (
    /*value*/
    ctx[1] !== void 0
  ) {
    input_props.value = /*value*/
    ctx[1];
  }
  input = new Input({ props: input_props });
  binding_callbacks.push(() => bind(input, "value", input_value_binding));
  const input_button_slot_template = (
    /*#slots*/
    ctx[15]["input-button"]
  );
  const input_button_slot = create_slot(
    input_button_slot_template,
    ctx,
    /*$$scope*/
    ctx[14],
    get_input_button_slot_context$1
  );
  message_1 = new Input_message({
    props: {
      dirtyMessage: (
        /*message*/
        ctx[3]
      ),
      showMessage: (
        /*showMessage*/
        ctx[9]
      ),
      type: (
        /*isInvalid*/
        ctx[0] ? "error" : "info"
      )
    }
  });
  const default_slot_template = (
    /*#slots*/
    ctx[15].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[14],
    null
  );
  return {
    c() {
      div1 = element("div");
      create_component(input.$$.fragment);
      t0 = space();
      if (input_button_slot) input_button_slot.c();
      t1 = space();
      div0 = element("div");
      create_component(message_1.$$.fragment);
      t22 = space();
      if (default_slot) default_slot.c();
      attr(div0, "class", "tw_w-full");
      attr(div0, "id", div0_id_value = `${/*key*/
      ctx[7]}-message`);
      attr(div1, "class", `tw_justify-items-stretch tw_flex tw_input-spacing tw_relative tw_flex-wrap`);
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      mount_component(input, div1, null);
      append(div1, t0);
      if (input_button_slot) {
        input_button_slot.m(div1, null);
      }
      append(div1, t1);
      append(div1, div0);
      mount_component(message_1, div0, null);
      append(div0, t22);
      if (default_slot) {
        default_slot.m(div0, null);
      }
      current = true;
    },
    p(ctx2, [dirty]) {
      const input_changes = {};
      if (dirty & /*forceValidityFailure*/
      4) input_changes.forceValidityFailure = /*forceValidityFailure*/
      ctx2[2];
      if (dirty & /*isFirstInvalidInput*/
      16) input_changes.isFirstInvalidInput = /*isFirstInvalidInput*/
      ctx2[4];
      if (dirty & /*hasRightIcon*/
      32) input_changes.inputClasses = `tw_input-floating dark:tw_input-floating_dark ${/*hasRightIcon*/
      ctx2[5] ? "!tw_border-r-0 !tw_rounded-r-none" : ""}`;
      if (dirty & /*key*/
      128) input_changes.key = /*key*/
      ctx2[7];
      if (dirty & /*label*/
      256) input_changes.label = /*label*/
      ctx2[8];
      if (dirty & /*isRequired*/
      64) input_changes.isRequired = /*isRequired*/
      ctx2[6];
      if (dirty & /*isInvalid*/
      1) input_changes.isInvalid = /*isInvalid*/
      ctx2[0];
      if (dirty & /*type*/
      1024) input_changes.type = /*type*/
      ctx2[10];
      if (!updating_value && dirty & /*value*/
      2) {
        updating_value = true;
        input_changes.value = /*value*/
        ctx2[1];
        add_flush_callback(() => updating_value = false);
      }
      input.$set(input_changes);
      if (input_button_slot) {
        if (input_button_slot.p && (!current || dirty & /*$$scope*/
        16384)) {
          update_slot_base(
            input_button_slot,
            input_button_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[14],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[14]
            ) : get_slot_changes(
              input_button_slot_template,
              /*$$scope*/
              ctx2[14],
              dirty,
              get_input_button_slot_changes$1
            ),
            get_input_button_slot_context$1
          );
        }
      }
      const message_1_changes = {};
      if (dirty & /*message*/
      8) message_1_changes.dirtyMessage = /*message*/
      ctx2[3];
      if (dirty & /*showMessage*/
      512) message_1_changes.showMessage = /*showMessage*/
      ctx2[9];
      if (dirty & /*isInvalid*/
      1) message_1_changes.type = /*isInvalid*/
      ctx2[0] ? "error" : "info";
      message_1.$set(message_1_changes);
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        16384)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[14],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[14]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[14],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (!current || dirty & /*key*/
      128 && div0_id_value !== (div0_id_value = `${/*key*/
      ctx2[7]}-message`)) {
        attr(div0, "id", div0_id_value);
      }
    },
    i(local) {
      if (current) return;
      transition_in(input.$$.fragment, local);
      transition_in(input_button_slot, local);
      transition_in(message_1.$$.fragment, local);
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(input.$$.fragment, local);
      transition_out(input_button_slot, local);
      transition_out(message_1.$$.fragment, local);
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div1);
      destroy_component(input);
      if (input_button_slot) input_button_slot.d(detaching);
      destroy_component(message_1);
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function instance$K($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { checkValidity = null } = $$props;
  let { forceValidityFailure = false } = $$props;
  let { message = "" } = $$props;
  let { isFirstInvalidInput } = $$props;
  let { hasRightIcon = false } = $$props;
  let { isRequired = false } = $$props;
  let { isInvalid = false } = $$props;
  let { key } = $$props;
  let { label } = $$props;
  let { onChange } = $$props;
  let { showMessage = void 0 } = $$props;
  let { type = "text" } = $$props;
  let { value = "" } = $$props;
  function onChangeWrapper(event) {
    if (checkValidity) {
      $$invalidate(0, isInvalid = !checkValidity(event));
    }
    onChange(event);
  }
  function input_value_binding(value$1) {
    value = value$1;
    $$invalidate(1, value);
  }
  $$self.$$set = ($$props2) => {
    if ("checkValidity" in $$props2) $$invalidate(12, checkValidity = $$props2.checkValidity);
    if ("forceValidityFailure" in $$props2) $$invalidate(2, forceValidityFailure = $$props2.forceValidityFailure);
    if ("message" in $$props2) $$invalidate(3, message = $$props2.message);
    if ("isFirstInvalidInput" in $$props2) $$invalidate(4, isFirstInvalidInput = $$props2.isFirstInvalidInput);
    if ("hasRightIcon" in $$props2) $$invalidate(5, hasRightIcon = $$props2.hasRightIcon);
    if ("isRequired" in $$props2) $$invalidate(6, isRequired = $$props2.isRequired);
    if ("isInvalid" in $$props2) $$invalidate(0, isInvalid = $$props2.isInvalid);
    if ("key" in $$props2) $$invalidate(7, key = $$props2.key);
    if ("label" in $$props2) $$invalidate(8, label = $$props2.label);
    if ("onChange" in $$props2) $$invalidate(13, onChange = $$props2.onChange);
    if ("showMessage" in $$props2) $$invalidate(9, showMessage = $$props2.showMessage);
    if ("type" in $$props2) $$invalidate(10, type = $$props2.type);
    if ("value" in $$props2) $$invalidate(1, value = $$props2.value);
    if ("$$scope" in $$props2) $$invalidate(14, $$scope = $$props2.$$scope);
  };
  return [
    isInvalid,
    value,
    forceValidityFailure,
    message,
    isFirstInvalidInput,
    hasRightIcon,
    isRequired,
    key,
    label,
    showMessage,
    type,
    onChangeWrapper,
    checkValidity,
    onChange,
    $$scope,
    slots,
    input_value_binding
  ];
}
var Floating_label2 = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$K, create_fragment$J, safe_not_equal, {
      checkValidity: 12,
      forceValidityFailure: 2,
      message: 3,
      isFirstInvalidInput: 4,
      hasRightIcon: 5,
      isRequired: 6,
      isInvalid: 0,
      key: 7,
      label: 8,
      onChange: 13,
      showMessage: 9,
      type: 10,
      value: 1
    });
  }
};
var get_input_button_slot_changes = (dirty) => ({});
var get_input_button_slot_context = (ctx) => ({});
function create_fragment$I(ctx) {
  let div1;
  let input;
  let updating_value;
  let t0;
  let t1;
  let div0;
  let message_1;
  let t22;
  let div0_id_value;
  let current;
  function input_value_binding(value) {
    ctx[17](value);
  }
  let input_props = {
    forceValidityFailure: (
      /*forceValidityFailure*/
      ctx[2]
    ),
    isFirstInvalidInput: (
      /*isFirstInvalidInput*/
      ctx[3]
    ),
    inputClasses: `${/*hasRightIcon*/
    ctx[4] ? "!tw_border-r-0 !tw_rounded-r-none" : ""}`,
    key: (
      /*key*/
      ctx[7]
    ),
    onChange: (
      /*onChangeWrapper*/
      ctx[12]
    ),
    label: (
      /*label*/
      ctx[8]
    ),
    labelClasses: "tw_input-stacked-label",
    labelOrder: "first",
    placeholder: (
      /*placeholder*/
      ctx[9]
    ),
    isRequired: (
      /*isRequired*/
      ctx[6]
    ),
    isInvalid: (
      /*isInvalid*/
      ctx[0]
    ),
    type: (
      /*type*/
      ctx[11]
    )
  };
  if (
    /*value*/
    ctx[1] !== void 0
  ) {
    input_props.value = /*value*/
    ctx[1];
  }
  input = new Input({ props: input_props });
  binding_callbacks.push(() => bind(input, "value", input_value_binding));
  const input_button_slot_template = (
    /*#slots*/
    ctx[16]["input-button"]
  );
  const input_button_slot = create_slot(
    input_button_slot_template,
    ctx,
    /*$$scope*/
    ctx[15],
    get_input_button_slot_context
  );
  message_1 = new Input_message({
    props: {
      key: (
        /*key*/
        ctx[7]
      ),
      dirtyMessage: (
        /*message*/
        ctx[5]
      ),
      showMessage: (
        /*showMessage*/
        ctx[10]
      ),
      type: (
        /*isInvalid*/
        ctx[0] ? "error" : "info"
      )
    }
  });
  const default_slot_template = (
    /*#slots*/
    ctx[16].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[15],
    null
  );
  return {
    c() {
      div1 = element("div");
      create_component(input.$$.fragment);
      t0 = space();
      if (input_button_slot) input_button_slot.c();
      t1 = space();
      div0 = element("div");
      create_component(message_1.$$.fragment);
      t22 = space();
      if (default_slot) default_slot.c();
      attr(div0, "class", "tw_w-full");
      attr(div0, "id", div0_id_value = `${/*key*/
      ctx[7]}-message`);
      attr(div1, "class", "tw_input-spacing tw_flex tw_flex-wrap");
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      mount_component(input, div1, null);
      append(div1, t0);
      if (input_button_slot) {
        input_button_slot.m(div1, null);
      }
      append(div1, t1);
      append(div1, div0);
      mount_component(message_1, div0, null);
      append(div0, t22);
      if (default_slot) {
        default_slot.m(div0, null);
      }
      current = true;
    },
    p(ctx2, [dirty]) {
      const input_changes = {};
      if (dirty & /*forceValidityFailure*/
      4) input_changes.forceValidityFailure = /*forceValidityFailure*/
      ctx2[2];
      if (dirty & /*isFirstInvalidInput*/
      8) input_changes.isFirstInvalidInput = /*isFirstInvalidInput*/
      ctx2[3];
      if (dirty & /*hasRightIcon*/
      16) input_changes.inputClasses = `${/*hasRightIcon*/
      ctx2[4] ? "!tw_border-r-0 !tw_rounded-r-none" : ""}`;
      if (dirty & /*key*/
      128) input_changes.key = /*key*/
      ctx2[7];
      if (dirty & /*label*/
      256) input_changes.label = /*label*/
      ctx2[8];
      if (dirty & /*placeholder*/
      512) input_changes.placeholder = /*placeholder*/
      ctx2[9];
      if (dirty & /*isRequired*/
      64) input_changes.isRequired = /*isRequired*/
      ctx2[6];
      if (dirty & /*isInvalid*/
      1) input_changes.isInvalid = /*isInvalid*/
      ctx2[0];
      if (dirty & /*type*/
      2048) input_changes.type = /*type*/
      ctx2[11];
      if (!updating_value && dirty & /*value*/
      2) {
        updating_value = true;
        input_changes.value = /*value*/
        ctx2[1];
        add_flush_callback(() => updating_value = false);
      }
      input.$set(input_changes);
      if (input_button_slot) {
        if (input_button_slot.p && (!current || dirty & /*$$scope*/
        32768)) {
          update_slot_base(
            input_button_slot,
            input_button_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[15],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[15]
            ) : get_slot_changes(
              input_button_slot_template,
              /*$$scope*/
              ctx2[15],
              dirty,
              get_input_button_slot_changes
            ),
            get_input_button_slot_context
          );
        }
      }
      const message_1_changes = {};
      if (dirty & /*key*/
      128) message_1_changes.key = /*key*/
      ctx2[7];
      if (dirty & /*message*/
      32) message_1_changes.dirtyMessage = /*message*/
      ctx2[5];
      if (dirty & /*showMessage*/
      1024) message_1_changes.showMessage = /*showMessage*/
      ctx2[10];
      if (dirty & /*isInvalid*/
      1) message_1_changes.type = /*isInvalid*/
      ctx2[0] ? "error" : "info";
      message_1.$set(message_1_changes);
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        32768)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[15],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[15]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[15],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (!current || dirty & /*key*/
      128 && div0_id_value !== (div0_id_value = `${/*key*/
      ctx2[7]}-message`)) {
        attr(div0, "id", div0_id_value);
      }
    },
    i(local) {
      if (current) return;
      transition_in(input.$$.fragment, local);
      transition_in(input_button_slot, local);
      transition_in(message_1.$$.fragment, local);
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(input.$$.fragment, local);
      transition_out(input_button_slot, local);
      transition_out(message_1.$$.fragment, local);
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div1);
      destroy_component(input);
      if (input_button_slot) input_button_slot.d(detaching);
      destroy_component(message_1);
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function instance$J($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { checkValidity = null } = $$props;
  let { forceValidityFailure = false } = $$props;
  let { isFirstInvalidInput } = $$props;
  let { hasRightIcon = false } = $$props;
  let { message = "" } = $$props;
  let { isRequired = false } = $$props;
  let { isInvalid = false } = $$props;
  let { key } = $$props;
  let { label } = $$props;
  let { onChange } = $$props;
  let { placeholder = void 0 } = $$props;
  let { showMessage = void 0 } = $$props;
  let { type = "text" } = $$props;
  let { value = "" } = $$props;
  function onChangeWrapper(event) {
    if (checkValidity) {
      $$invalidate(0, isInvalid = !checkValidity(event));
    }
    onChange(event);
  }
  function input_value_binding(value$1) {
    value = value$1;
    $$invalidate(1, value);
  }
  $$self.$$set = ($$props2) => {
    if ("checkValidity" in $$props2) $$invalidate(13, checkValidity = $$props2.checkValidity);
    if ("forceValidityFailure" in $$props2) $$invalidate(2, forceValidityFailure = $$props2.forceValidityFailure);
    if ("isFirstInvalidInput" in $$props2) $$invalidate(3, isFirstInvalidInput = $$props2.isFirstInvalidInput);
    if ("hasRightIcon" in $$props2) $$invalidate(4, hasRightIcon = $$props2.hasRightIcon);
    if ("message" in $$props2) $$invalidate(5, message = $$props2.message);
    if ("isRequired" in $$props2) $$invalidate(6, isRequired = $$props2.isRequired);
    if ("isInvalid" in $$props2) $$invalidate(0, isInvalid = $$props2.isInvalid);
    if ("key" in $$props2) $$invalidate(7, key = $$props2.key);
    if ("label" in $$props2) $$invalidate(8, label = $$props2.label);
    if ("onChange" in $$props2) $$invalidate(14, onChange = $$props2.onChange);
    if ("placeholder" in $$props2) $$invalidate(9, placeholder = $$props2.placeholder);
    if ("showMessage" in $$props2) $$invalidate(10, showMessage = $$props2.showMessage);
    if ("type" in $$props2) $$invalidate(11, type = $$props2.type);
    if ("value" in $$props2) $$invalidate(1, value = $$props2.value);
    if ("$$scope" in $$props2) $$invalidate(15, $$scope = $$props2.$$scope);
  };
  return [
    isInvalid,
    value,
    forceValidityFailure,
    isFirstInvalidInput,
    hasRightIcon,
    message,
    isRequired,
    key,
    label,
    placeholder,
    showMessage,
    type,
    onChangeWrapper,
    checkValidity,
    onChange,
    $$scope,
    slots,
    input_value_binding
  ];
}
var Stacked_label2 = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$J, create_fragment$I, safe_not_equal, {
      checkValidity: 13,
      forceValidityFailure: 2,
      isFirstInvalidInput: 3,
      hasRightIcon: 4,
      message: 5,
      isRequired: 6,
      isInvalid: 0,
      key: 7,
      label: 8,
      onChange: 14,
      placeholder: 9,
      showMessage: 10,
      type: 11,
      value: 1
    });
  }
};
function create_fragment$H(ctx) {
  let svg;
  let path0;
  let path1;
  let title;
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[3].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[2],
    null
  );
  return {
    c() {
      svg = svg_element("svg");
      path0 = svg_element("path");
      path1 = svg_element("path");
      title = svg_element("title");
      if (default_slot) default_slot.c();
      attr(path0, "d", "M0 0h24v24H0z");
      attr(path0, "fill", "none");
      attr(path1, "d", "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z");
      attr(
        svg,
        "class",
        /*classes*/
        ctx[0]
      );
      attr(
        svg,
        "height",
        /*size*/
        ctx[1]
      );
      attr(svg, "viewBox", "0 0 24 24");
      attr(
        svg,
        "width",
        /*size*/
        ctx[1]
      );
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path0);
      append(svg, path1);
      append(svg, title);
      if (default_slot) {
        default_slot.m(title, null);
      }
      current = true;
    },
    p(ctx2, [dirty]) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        4)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[2],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[2]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[2],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (!current || dirty & /*classes*/
      1) {
        attr(
          svg,
          "class",
          /*classes*/
          ctx2[0]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "height",
          /*size*/
          ctx2[1]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "width",
          /*size*/
          ctx2[1]
        );
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(svg);
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function instance$I($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { classes = "" } = $$props;
  let { size = "24px" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("classes" in $$props2) $$invalidate(0, classes = $$props2.classes);
    if ("size" in $$props2) $$invalidate(1, size = $$props2.size);
    if ("$$scope" in $$props2) $$invalidate(2, $$scope = $$props2.$$scope);
  };
  return [classes, size, $$scope, slots];
}
var Lock_icon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$I, create_fragment$H, safe_not_equal, { classes: 0, size: 1 });
  }
};
function create_if_block$m(ctx) {
  var _a;
  let input;
  let current;
  input = new /*Input*/
  ctx[7]({
    props: {
      isFirstInvalidInput: false,
      isRequired: true,
      key: `kba-custom-question-${/*callbackMetadata*/
      (_a = ctx[0]) == null ? void 0 : _a.idx}`,
      label: interpolate("customSecurityQuestion"),
      showMessage: false,
      message: interpolate("inputRequiredError"),
      onChange: (
        /*setQuestion*/
        ctx[12]
      ),
      type: "text"
    }
  });
  return {
    c() {
      create_component(input.$$.fragment);
    },
    m(target, anchor) {
      mount_component(input, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      const input_changes = {};
      if (dirty & /*callbackMetadata*/
      1) input_changes.key = `kba-custom-question-${/*callbackMetadata*/
      (_a2 = ctx2[0]) == null ? void 0 : _a2.idx}`;
      input.$set(input_changes);
    },
    i(local) {
      if (current) return;
      transition_in(input.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(input.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(input, detaching);
    }
  };
}
function create_fragment$G(ctx) {
  var _a, _b;
  let fieldset;
  let legend;
  let t0;
  let t1;
  let h2;
  let t22;
  let t3;
  let span;
  let lockicon;
  let t4;
  let select;
  let t5;
  let t6;
  let input;
  let updating_value;
  let current;
  t0 = new Locale_strings({ props: { key: "securityQuestions" } });
  t22 = new Locale_strings({
    props: { key: "securityQuestionsPrompt" }
  });
  lockicon = new Lock_icon({ props: { size: "18" } });
  select = new /*Select*/
  ctx[8]({
    props: {
      isFirstInvalidInput: false,
      isRequired: true,
      key: (
        /*inputNameQuestion*/
        ctx[4]
      ),
      label: (
        /*prompt*/
        ctx[1]
      ),
      onChange: (
        /*selectQuestion*/
        ctx[11]
      ),
      options: (
        /*questions*/
        ctx[2]
      )
    }
  });
  let if_block = (
    /*displayCustomQuestionInput*/
    ctx[3] && create_if_block$m(ctx)
  );
  function input_value_binding(value) {
    ctx[21](value);
  }
  let input_props = {
    isFirstInvalidInput: (
      /*callbackMetadata*/
      ((_a = ctx[0]) == null ? void 0 : _a.derived.isFirstInvalidInput) || false
    ),
    isRequired: true,
    key: (
      /*inputNameAnswer*/
      ctx[5] || `kba-answer-${/*callbackMetadata*/
      (_b = ctx[0]) == null ? void 0 : _b.idx}`
    ),
    label: interpolate("securityAnswer"),
    showMessage: false,
    message: interpolate("inputRequiredError"),
    onChange: (
      /*setAnswer*/
      ctx[10]
    ),
    type: "text"
  };
  if (
    /*$value*/
    ctx[6] !== void 0
  ) {
    input_props.value = /*$value*/
    ctx[6];
  }
  input = new /*Input*/
  ctx[7]({ props: input_props });
  binding_callbacks.push(() => bind(input, "value", input_value_binding));
  return {
    c() {
      fieldset = element("fieldset");
      legend = element("legend");
      create_component(t0.$$.fragment);
      t1 = space();
      h2 = element("h2");
      create_component(t22.$$.fragment);
      t3 = space();
      span = element("span");
      create_component(lockicon.$$.fragment);
      t4 = space();
      create_component(select.$$.fragment);
      t5 = space();
      if (if_block) if_block.c();
      t6 = space();
      create_component(input.$$.fragment);
      attr(legend, "class", "tw_sr-only");
      attr(h2, "class", "dark:tw_secondary-header_dark tw_font-semibold tw_mb-4");
      attr(span, "class", "tw_kba-lock-icon dark:tw_kba-lock-icon_dark");
      attr(fieldset, "class", "tw_kba-fieldset tw_input-spacing dark:tw_kba-fieldset_dark");
    },
    m(target, anchor) {
      insert(target, fieldset, anchor);
      append(fieldset, legend);
      mount_component(t0, legend, null);
      append(fieldset, t1);
      append(fieldset, h2);
      mount_component(t22, h2, null);
      append(fieldset, t3);
      append(fieldset, span);
      mount_component(lockicon, span, null);
      append(fieldset, t4);
      mount_component(select, fieldset, null);
      append(fieldset, t5);
      if (if_block) if_block.m(fieldset, null);
      append(fieldset, t6);
      mount_component(input, fieldset, null);
      current = true;
    },
    p(ctx2, [dirty]) {
      var _a2, _b2;
      const select_changes = {};
      if (dirty & /*inputNameQuestion*/
      16) select_changes.key = /*inputNameQuestion*/
      ctx2[4];
      if (dirty & /*prompt*/
      2) select_changes.label = /*prompt*/
      ctx2[1];
      if (dirty & /*questions*/
      4) select_changes.options = /*questions*/
      ctx2[2];
      select.$set(select_changes);
      if (
        /*displayCustomQuestionInput*/
        ctx2[3]
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
          if (dirty & /*displayCustomQuestionInput*/
          8) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$m(ctx2);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(fieldset, t6);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
      const input_changes = {};
      if (dirty & /*callbackMetadata*/
      1) input_changes.isFirstInvalidInput = /*callbackMetadata*/
      ((_a2 = ctx2[0]) == null ? void 0 : _a2.derived.isFirstInvalidInput) || false;
      if (dirty & /*inputNameAnswer, callbackMetadata*/
      33) input_changes.key = /*inputNameAnswer*/
      ctx2[5] || `kba-answer-${/*callbackMetadata*/
      (_b2 = ctx2[0]) == null ? void 0 : _b2.idx}`;
      if (!updating_value && dirty & /*$value*/
      64) {
        updating_value = true;
        input_changes.value = /*$value*/
        ctx2[6];
        add_flush_callback(() => updating_value = false);
      }
      input.$set(input_changes);
    },
    i(local) {
      if (current) return;
      transition_in(t0.$$.fragment, local);
      transition_in(t22.$$.fragment, local);
      transition_in(lockicon.$$.fragment, local);
      transition_in(select.$$.fragment, local);
      transition_in(if_block);
      transition_in(input.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t0.$$.fragment, local);
      transition_out(t22.$$.fragment, local);
      transition_out(lockicon.$$.fragment, local);
      transition_out(select.$$.fragment, local);
      transition_out(if_block);
      transition_out(input.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(fieldset);
      destroy_component(t0);
      destroy_component(t22);
      destroy_component(lockicon);
      destroy_component(select);
      if (if_block) if_block.d();
      destroy_component(input);
    }
  };
}
function instance$H($$self, $$props, $$invalidate) {
  let $value;
  const selfSubmitFunction = null;
  const stepMetadata = null;
  let { callback } = $$props;
  let { callbackMetadata } = $$props;
  let { style = {} } = $$props;
  const Input2 = style.labels === "stacked" ? Stacked_label2 : Floating_label2;
  const Select2 = style.labels === "stacked" ? Stacked_label$1 : Floating_label$1;
  let customQuestionIndex = null;
  let displayCustomQuestionInput = false;
  let inputArr;
  let inputName;
  let inputNameQuestion;
  let inputNameAnswer;
  let prompt;
  let questions;
  let shouldAllowCustomQuestion;
  let value = writable("");
  component_subscribe($$self, value, (value2) => $$invalidate(6, $value = value2));
  try {
    shouldAllowCustomQuestion = callback.getOutputValue("allowUserDefinedQuestions");
  } catch (err) {
    console.error("`allowUserDefinedQuestions` property is missing in callback `KbaCreateCallback`");
  }
  function setAnswer(event) {
    callback.setAnswer(event.target.value);
  }
  function selectQuestion(event) {
    const selectValue = event.target.value;
    if (selectValue === customQuestionIndex) {
      $$invalidate(3, displayCustomQuestionInput = true);
      value.set("");
      callback.setAnswer("");
    } else {
      $$invalidate(3, displayCustomQuestionInput = false);
      callback.setQuestion(selectValue);
    }
  }
  function setQuestion(event) {
    const inputValue = event.target.value;
    callback.setQuestion(inputValue);
  }
  function input_value_binding(value$1) {
    $value = value$1;
    value.set($value);
  }
  $$self.$$set = ($$props2) => {
    if ("callback" in $$props2) $$invalidate(15, callback = $$props2.callback);
    if ("callbackMetadata" in $$props2) $$invalidate(0, callbackMetadata = $$props2.callbackMetadata);
    if ("style" in $$props2) $$invalidate(16, style = $$props2.style);
  };
  $$self.$$.update = () => {
    var _a, _b, _c, _d;
    if ($$self.$$.dirty & /*callback, callbackMetadata, inputName, inputArr, questions, prompt, shouldAllowCustomQuestion, customQuestionIndex*/
    1998855) {
      {
        $$invalidate(18, inputArr = (_a = callback == null ? void 0 : callback.payload) == null ? void 0 : _a.input);
        $$invalidate(19, inputName = ((_c = (_b = callback == null ? void 0 : callback.payload) == null ? void 0 : _b.input) == null ? void 0 : _c[0].name) || `kba-${callbackMetadata == null ? void 0 : callbackMetadata.idx}`);
        $$invalidate(4, inputNameQuestion = inputName);
        $$invalidate(5, inputNameAnswer = Array.isArray(inputArr) && inputArr[1].name);
        $$invalidate(1, prompt = callback.getPrompt());
        $$invalidate(2, questions = (_d = callback.getPredefinedQuestions()) == null ? void 0 : _d.map((label, idx) => ({ text: label, value: `${idx}` })));
        try {
          $$invalidate(20, shouldAllowCustomQuestion = callback.getOutputValue("allowUserDefinedQuestions"));
        } catch (err) {
          console.error("`allowUserDefinedQuestions` property is missing in callback `KbaCreateCallback`");
        }
        questions.unshift({ text: prompt, value: "" });
        if (shouldAllowCustomQuestion) {
          $$invalidate(17, customQuestionIndex = `${questions.length - 1}`);
          questions.push({
            text: interpolate("provideCustomQuestion"),
            value: customQuestionIndex
          });
        }
      }
    }
  };
  return [
    callbackMetadata,
    prompt,
    questions,
    displayCustomQuestionInput,
    inputNameQuestion,
    inputNameAnswer,
    $value,
    Input2,
    Select2,
    value,
    setAnswer,
    selectQuestion,
    setQuestion,
    selfSubmitFunction,
    stepMetadata,
    callback,
    style,
    customQuestionIndex,
    inputArr,
    inputName,
    shouldAllowCustomQuestion,
    input_value_binding
  ];
}
var Kba_create = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$H, create_fragment$G, safe_not_equal, {
      selfSubmitFunction: 13,
      stepMetadata: 14,
      callback: 15,
      callbackMetadata: 0,
      style: 16
    });
  }
  get selfSubmitFunction() {
    return this.$$.ctx[13];
  }
  get stepMetadata() {
    return this.$$.ctx[14];
  }
};
function create_key_block$4(ctx) {
  var _a;
  let input;
  let current;
  input = new /*Input*/
  ctx[6]({
    props: {
      isFirstInvalidInput: (
        /*callbackMetadata*/
        ((_a = ctx[1]) == null ? void 0 : _a.derived.isFirstInvalidInput) || false
      ),
      key: (
        /*inputName*/
        ctx[3]
      ),
      label: interpolate(
        textToKey(
          /*textInputLabel*/
          ctx[4] || /*callbackType*/
          ctx[2]
        ),
        null,
        /*textInputLabel*/
        ctx[4]
      ),
      onChange: (
        /*setValue*/
        ctx[7]
      ),
      type: "text",
      showMessage: false,
      value: typeof /*value*/
      ctx[5] === "string" ? (
        /*value*/
        ctx[5]
      ) : ""
    }
  });
  return {
    c() {
      create_component(input.$$.fragment);
    },
    m(target, anchor) {
      mount_component(input, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      const input_changes = {};
      if (dirty & /*callbackMetadata*/
      2) input_changes.isFirstInvalidInput = /*callbackMetadata*/
      ((_a2 = ctx2[1]) == null ? void 0 : _a2.derived.isFirstInvalidInput) || false;
      if (dirty & /*inputName*/
      8) input_changes.key = /*inputName*/
      ctx2[3];
      if (dirty & /*textInputLabel, callbackType*/
      20) input_changes.label = interpolate(
        textToKey(
          /*textInputLabel*/
          ctx2[4] || /*callbackType*/
          ctx2[2]
        ),
        null,
        /*textInputLabel*/
        ctx2[4]
      );
      if (dirty & /*value*/
      32) input_changes.value = typeof /*value*/
      ctx2[5] === "string" ? (
        /*value*/
        ctx2[5]
      ) : "";
      input.$set(input_changes);
    },
    i(local) {
      if (current) return;
      transition_in(input.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(input.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(input, detaching);
    }
  };
}
function create_fragment$F(ctx) {
  let previous_key = (
    /*callback*/
    ctx[0]
  );
  let key_block_anchor;
  let current;
  let key_block = create_key_block$4(ctx);
  return {
    c() {
      key_block.c();
      key_block_anchor = empty();
    },
    m(target, anchor) {
      key_block.m(target, anchor);
      insert(target, key_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (dirty & /*callback*/
      1 && safe_not_equal(previous_key, previous_key = /*callback*/
      ctx2[0])) {
        group_outros();
        transition_out(key_block, 1, 1, noop);
        check_outros();
        key_block = create_key_block$4(ctx2);
        key_block.c();
        transition_in(key_block, 1);
        key_block.m(key_block_anchor.parentNode, key_block_anchor);
      } else {
        key_block.p(ctx2, dirty);
      }
    },
    i(local) {
      if (current) return;
      transition_in(key_block);
      current = true;
    },
    o(local) {
      transition_out(key_block);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(key_block_anchor);
      key_block.d(detaching);
    }
  };
}
function instance$G($$self, $$props, $$invalidate) {
  const selfSubmitFunction = null;
  const stepMetadata = null;
  let { callback } = $$props;
  let { callbackMetadata } = $$props;
  let { style = {} } = $$props;
  const Input2 = style.labels === "stacked" ? Stacked_label2 : Floating_label2;
  let callbackType;
  let inputName;
  let textInputLabel;
  let value;
  function setValue(event) {
    callback.setInputValue(event.target.value);
  }
  $$self.$$set = ($$props2) => {
    if ("callback" in $$props2) $$invalidate(0, callback = $$props2.callback);
    if ("callbackMetadata" in $$props2) $$invalidate(1, callbackMetadata = $$props2.callbackMetadata);
    if ("style" in $$props2) $$invalidate(10, style = $$props2.style);
  };
  $$self.$$.update = () => {
    var _a, _b;
    if ($$self.$$.dirty & /*callback, callbackMetadata*/
    3) {
      {
        $$invalidate(2, callbackType = callback.getType());
        $$invalidate(3, inputName = ((_b = (_a = callback == null ? void 0 : callback.payload) == null ? void 0 : _a.input) == null ? void 0 : _b[0].name) || `name-${callbackMetadata == null ? void 0 : callbackMetadata.idx}`);
        $$invalidate(4, textInputLabel = callback.getPrompt());
        $$invalidate(5, value = callback == null ? void 0 : callback.getInputValue());
      }
    }
  };
  return [
    callback,
    callbackMetadata,
    callbackType,
    inputName,
    textInputLabel,
    value,
    Input2,
    setValue,
    selfSubmitFunction,
    stepMetadata,
    style
  ];
}
var Name = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$G, create_fragment$F, safe_not_equal, {
      selfSubmitFunction: 8,
      stepMetadata: 9,
      callback: 0,
      callbackMetadata: 1,
      style: 10
    });
  }
  get selfSubmitFunction() {
    return this.$$.ctx[8];
  }
  get stepMetadata() {
    return this.$$.ctx[9];
  }
};
function create_else_block$7(ctx) {
  let svg;
  let path0;
  let path1;
  let title;
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[4].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[3],
    null
  );
  return {
    c() {
      svg = svg_element("svg");
      path0 = svg_element("path");
      path1 = svg_element("path");
      title = svg_element("title");
      if (default_slot) default_slot.c();
      attr(path0, "d", "M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z");
      attr(path0, "fill", "none");
      attr(path1, "d", "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z");
      attr(
        svg,
        "class",
        /*classes*/
        ctx[0]
      );
      attr(
        svg,
        "height",
        /*size*/
        ctx[1]
      );
      attr(
        svg,
        "width",
        /*size*/
        ctx[1]
      );
      attr(svg, "viewBox", "0 0 24 24");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path0);
      append(svg, path1);
      append(svg, title);
      if (default_slot) {
        default_slot.m(title, null);
      }
      current = true;
    },
    p(ctx2, dirty) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        8)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[3],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[3]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[3],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (!current || dirty & /*classes*/
      1) {
        attr(
          svg,
          "class",
          /*classes*/
          ctx2[0]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "height",
          /*size*/
          ctx2[1]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "width",
          /*size*/
          ctx2[1]
        );
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(svg);
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function create_if_block$l(ctx) {
  let svg;
  let path0;
  let path1;
  let title;
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[4].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[3],
    null
  );
  return {
    c() {
      svg = svg_element("svg");
      path0 = svg_element("path");
      path1 = svg_element("path");
      title = svg_element("title");
      if (default_slot) default_slot.c();
      attr(path0, "d", "M0 0h24v24H0z");
      attr(path0, "fill", "none");
      attr(path1, "d", "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z");
      attr(
        svg,
        "class",
        /*classes*/
        ctx[0]
      );
      attr(
        svg,
        "height",
        /*size*/
        ctx[1]
      );
      attr(
        svg,
        "width",
        /*size*/
        ctx[1]
      );
      attr(svg, "viewBox", "0 0 24 24");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path0);
      append(svg, path1);
      append(svg, title);
      if (default_slot) {
        default_slot.m(title, null);
      }
      current = true;
    },
    p(ctx2, dirty) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        8)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[3],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[3]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[3],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (!current || dirty & /*classes*/
      1) {
        attr(
          svg,
          "class",
          /*classes*/
          ctx2[0]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "height",
          /*size*/
          ctx2[1]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "width",
          /*size*/
          ctx2[1]
        );
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(svg);
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function create_fragment$E(ctx) {
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block$l, create_else_block$7];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (!/*visible*/
    ctx2[2]) return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(if_block_anchor.parentNode, if_block_anchor);
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if_blocks[current_block_type_index].d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function instance$F($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { classes = "" } = $$props;
  let { size = "24px" } = $$props;
  let { visible = false } = $$props;
  $$self.$$set = ($$props2) => {
    if ("classes" in $$props2) $$invalidate(0, classes = $$props2.classes);
    if ("size" in $$props2) $$invalidate(1, size = $$props2.size);
    if ("visible" in $$props2) $$invalidate(2, visible = $$props2.visible);
    if ("$$scope" in $$props2) $$invalidate(3, $$scope = $$props2.$$scope);
  };
  return [classes, size, visible, $$scope, slots];
}
var Eye_icon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$F, create_fragment$E, safe_not_equal, { classes: 0, size: 1, visible: 2 });
  }
};
function create_default_slot_2$8(ctx) {
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[17].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[18],
    null
  );
  return {
    c() {
      if (default_slot) default_slot.c();
    },
    m(target, anchor) {
      if (default_slot) {
        default_slot.m(target, anchor);
      }
      current = true;
    },
    p(ctx2, dirty) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        262144)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[18],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[18]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[18],
              dirty,
              null
            ),
            null
          );
        }
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function create_if_block_1$c(ctx) {
  let button;
  let eyeicon;
  let current;
  let mounted;
  let dispose;
  eyeicon = new Eye_icon({
    props: {
      classes: "tw_password-icon dark:tw_password-icon_dark",
      visible: (
        /*isVisible*/
        ctx[8]
      ),
      $$slots: { default: [create_default_slot_1$e] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      button = element("button");
      create_component(eyeicon.$$.fragment);
      attr(button, "class", `tw_password-button dark:tw_password-button_dark tw_focusable-element tw_input-base dark:tw_input-base_dark`);
      attr(button, "type", "button");
    },
    m(target, anchor) {
      insert(target, button, anchor);
      mount_component(eyeicon, button, null);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*toggleVisibility*/
          ctx[14]
        );
        mounted = true;
      }
    },
    p(ctx2, dirty) {
      const eyeicon_changes = {};
      if (dirty & /*isVisible*/
      256) eyeicon_changes.visible = /*isVisible*/
      ctx2[8];
      if (dirty & /*$$scope*/
      262144) {
        eyeicon_changes.$$scope = { dirty, ctx: ctx2 };
      }
      eyeicon.$set(eyeicon_changes);
    },
    i(local) {
      if (current) return;
      transition_in(eyeicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(eyeicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(button);
      destroy_component(eyeicon);
      mounted = false;
      dispose();
    }
  };
}
function create_default_slot_1$e(ctx) {
  let t3;
  let current;
  t3 = new Locale_strings({ props: { key: "showPassword" } });
  return {
    c() {
      create_component(t3.$$.fragment);
    },
    m(target, anchor) {
      mount_component(t3, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(t3, detaching);
    }
  };
}
function create_input_button_slot$1(ctx) {
  let if_block_anchor;
  let current;
  let if_block = (
    /*showPassword*/
    ctx[12] === "button" && create_if_block_1$c(ctx)
  );
  return {
    c() {
      if (if_block) if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      if (
        /*showPassword*/
        ctx2[12] === "button"
      ) if_block.p(ctx2, dirty);
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (if_block) if_block.d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function create_if_block$k(ctx) {
  let div;
  let checkbox;
  let current;
  checkbox = new Checkbox({
    props: {
      isFirstInvalidInput: (
        /*isFirstInvalidInput*/
        ctx[5]
      ),
      isInvalid: false,
      key: (
        /*key*/
        ctx[3] + /*style*/
        ctx[4].showPassword
      ),
      onChange: (
        /*toggleVisibility*/
        ctx[14]
      ),
      value: false,
      $$slots: { default: [create_default_slot$l] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      div = element("div");
      create_component(checkbox.$$.fragment);
      attr(div, "class", "tw_w-full tw_input-spacing");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(checkbox, div, null);
      current = true;
    },
    p(ctx2, dirty) {
      const checkbox_changes = {};
      if (dirty & /*isFirstInvalidInput*/
      32) checkbox_changes.isFirstInvalidInput = /*isFirstInvalidInput*/
      ctx2[5];
      if (dirty & /*key, style*/
      24) checkbox_changes.key = /*key*/
      ctx2[3] + /*style*/
      ctx2[4].showPassword;
      if (dirty & /*$$scope*/
      262144) {
        checkbox_changes.$$scope = { dirty, ctx: ctx2 };
      }
      checkbox.$set(checkbox_changes);
    },
    i(local) {
      if (current) return;
      transition_in(checkbox.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(checkbox.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(checkbox);
    }
  };
}
function create_default_slot$l(ctx) {
  let t3;
  return {
    c() {
      t3 = text("Show Password");
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_fragment$D(ctx) {
  let input;
  let t3;
  let if_block_anchor;
  let current;
  input = new /*Input*/
  ctx[11]({
    props: {
      forceValidityFailure: (
        /*forceValidityFailure*/
        ctx[0]
      ),
      isFirstInvalidInput: false,
      hasRightIcon: (
        /*style*/
        ctx[4].showPassword === "button" ? true : false
      ),
      key: `${/*key*/
      ctx[3]}-confirm`,
      label: interpolate("confirmPassword", null, "Confirm Password"),
      message: (
        /*message*/
        ctx[10]
      ),
      onChange: (
        /*onChangeWrapper*/
        ctx[13]
      ),
      isInvalid: (
        /*passwordsDoNotMatch*/
        ctx[1]
      ),
      isRequired: (
        /*isRequired*/
        ctx[2]
      ),
      showMessage: (
        /*showMessage*/
        ctx[6]
      ),
      type: (
        /*type*/
        ctx[9]
      ),
      value: typeof /*value*/
      ctx[7] === "string" ? (
        /*value*/
        ctx[7]
      ) : "",
      $$slots: {
        "input-button": [create_input_button_slot$1],
        default: [create_default_slot_2$8]
      },
      $$scope: { ctx }
    }
  });
  let if_block = (
    /*showPassword*/
    ctx[12] === "checkbox" && create_if_block$k(ctx)
  );
  return {
    c() {
      create_component(input.$$.fragment);
      t3 = space();
      if (if_block) if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      mount_component(input, target, anchor);
      insert(target, t3, anchor);
      if (if_block) if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      const input_changes = {};
      if (dirty & /*forceValidityFailure*/
      1) input_changes.forceValidityFailure = /*forceValidityFailure*/
      ctx2[0];
      if (dirty & /*style*/
      16) input_changes.hasRightIcon = /*style*/
      ctx2[4].showPassword === "button" ? true : false;
      if (dirty & /*key*/
      8) input_changes.key = `${/*key*/
      ctx2[3]}-confirm`;
      if (dirty & /*message*/
      1024) input_changes.message = /*message*/
      ctx2[10];
      if (dirty & /*passwordsDoNotMatch*/
      2) input_changes.isInvalid = /*passwordsDoNotMatch*/
      ctx2[1];
      if (dirty & /*isRequired*/
      4) input_changes.isRequired = /*isRequired*/
      ctx2[2];
      if (dirty & /*showMessage*/
      64) input_changes.showMessage = /*showMessage*/
      ctx2[6];
      if (dirty & /*type*/
      512) input_changes.type = /*type*/
      ctx2[9];
      if (dirty & /*value*/
      128) input_changes.value = typeof /*value*/
      ctx2[7] === "string" ? (
        /*value*/
        ctx2[7]
      ) : "";
      if (dirty & /*$$scope, isVisible*/
      262400) {
        input_changes.$$scope = { dirty, ctx: ctx2 };
      }
      input.$set(input_changes);
      if (
        /*showPassword*/
        ctx2[12] === "checkbox"
      ) if_block.p(ctx2, dirty);
    },
    i(local) {
      if (current) return;
      transition_in(input.$$.fragment, local);
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(input.$$.fragment, local);
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      destroy_component(input, detaching);
      if (detaching) detach(t3);
      if (if_block) if_block.d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function instance$E($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { forceValidityFailure = false } = $$props;
  let { passwordsDoNotMatch = false } = $$props;
  let { isRequired = false } = $$props;
  let { key } = $$props;
  let { onChange } = $$props;
  let { resetValue } = $$props;
  let { style = {} } = $$props;
  let { isFirstInvalidInput } = $$props;
  const Input2 = style.labels === "stacked" ? Stacked_label2 : Floating_label2;
  const showPassword2 = style.showPassword;
  let { showMessage = void 0 } = $$props;
  let isVisible = false;
  let type = "password";
  let value;
  let message = "";
  function onChangeWrapper(event) {
    var _a;
    $$invalidate(7, value = (_a = event.target) == null ? void 0 : _a.value);
    onChange(typeof value === "string" ? value : void 0);
  }
  function toggleVisibility() {
    $$invalidate(8, isVisible = !isVisible);
    $$invalidate(9, type = isVisible ? "text" : "password");
  }
  $$self.$$set = ($$props2) => {
    if ("forceValidityFailure" in $$props2) $$invalidate(0, forceValidityFailure = $$props2.forceValidityFailure);
    if ("passwordsDoNotMatch" in $$props2) $$invalidate(1, passwordsDoNotMatch = $$props2.passwordsDoNotMatch);
    if ("isRequired" in $$props2) $$invalidate(2, isRequired = $$props2.isRequired);
    if ("key" in $$props2) $$invalidate(3, key = $$props2.key);
    if ("onChange" in $$props2) $$invalidate(15, onChange = $$props2.onChange);
    if ("resetValue" in $$props2) $$invalidate(16, resetValue = $$props2.resetValue);
    if ("style" in $$props2) $$invalidate(4, style = $$props2.style);
    if ("isFirstInvalidInput" in $$props2) $$invalidate(5, isFirstInvalidInput = $$props2.isFirstInvalidInput);
    if ("showMessage" in $$props2) $$invalidate(6, showMessage = $$props2.showMessage);
    if ("$$scope" in $$props2) $$invalidate(18, $$scope = $$props2.$$scope);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*resetValue, onChange, value, passwordsDoNotMatch, isRequired*/
    98438) {
      {
        if (resetValue) {
          $$invalidate(7, value = void 0);
          onChange(value);
        }
        if (passwordsDoNotMatch) {
          $$invalidate(10, message = interpolate("passwordConfirmationError", null, "Passwords do not match"));
        } else if (isRequired) {
          $$invalidate(10, message = interpolate("requiredField", null, "This field is required"));
        } else {
          $$invalidate(10, message = "");
        }
      }
    }
  };
  return [
    forceValidityFailure,
    passwordsDoNotMatch,
    isRequired,
    key,
    style,
    isFirstInvalidInput,
    showMessage,
    value,
    isVisible,
    type,
    message,
    Input2,
    showPassword2,
    onChangeWrapper,
    toggleVisibility,
    onChange,
    resetValue,
    slots,
    $$scope
  ];
}
var Confirm_input = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$E, create_fragment$D, safe_not_equal, {
      forceValidityFailure: 0,
      passwordsDoNotMatch: 1,
      isRequired: 2,
      key: 3,
      onChange: 15,
      resetValue: 16,
      style: 4,
      isFirstInvalidInput: 5,
      showMessage: 6
    });
  }
};
function create_default_slot_2$7(ctx) {
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[22].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[23],
    null
  );
  return {
    c() {
      if (default_slot) default_slot.c();
    },
    m(target, anchor) {
      if (default_slot) {
        default_slot.m(target, anchor);
      }
      current = true;
    },
    p(ctx2, dirty) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        8388608)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[23],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[23]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[23],
              dirty,
              null
            ),
            null
          );
        }
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function create_if_block_2$9(ctx) {
  let button;
  let eyeicon;
  let current;
  let mounted;
  let dispose;
  eyeicon = new Eye_icon({
    props: {
      classes: "tw_password-icon dark:tw_password-icon_dark",
      visible: (
        /*isVisible*/
        ctx[11]
      ),
      $$slots: { default: [create_default_slot_1$d] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      button = element("button");
      create_component(eyeicon.$$.fragment);
      attr(button, "class", `tw_password-button dark:tw_password-button_dark tw_focusable-element tw_input-base dark:tw_input-base_dark`);
      attr(button, "type", "button");
    },
    m(target, anchor) {
      insert(target, button, anchor);
      mount_component(eyeicon, button, null);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*toggleVisibility*/
          ctx[19]
        );
        mounted = true;
      }
    },
    p(ctx2, dirty) {
      const eyeicon_changes = {};
      if (dirty & /*isVisible*/
      2048) eyeicon_changes.visible = /*isVisible*/
      ctx2[11];
      if (dirty & /*$$scope*/
      8388608) {
        eyeicon_changes.$$scope = { dirty, ctx: ctx2 };
      }
      eyeicon.$set(eyeicon_changes);
    },
    i(local) {
      if (current) return;
      transition_in(eyeicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(eyeicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(button);
      destroy_component(eyeicon);
      mounted = false;
      dispose();
    }
  };
}
function create_default_slot_1$d(ctx) {
  let t3;
  let current;
  t3 = new Locale_strings({ props: { key: "showPassword" } });
  return {
    c() {
      create_component(t3.$$.fragment);
    },
    m(target, anchor) {
      mount_component(t3, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(t3, detaching);
    }
  };
}
function create_input_button_slot(ctx) {
  let if_block_anchor;
  let current;
  let if_block = (
    /*showPassword*/
    ctx[16] === "button" && create_if_block_2$9(ctx)
  );
  return {
    c() {
      if (if_block) if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      if (
        /*showPassword*/
        ctx2[16] === "button"
      ) if_block.p(ctx2, dirty);
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (if_block) if_block.d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function create_if_block_1$b(ctx) {
  var _a;
  let div;
  let checkbox;
  let current;
  checkbox = new Checkbox({
    props: {
      isFirstInvalidInput: (
        /*callbackMetadata*/
        ((_a = ctx[2]) == null ? void 0 : _a.derived.isFirstInvalidInput) || false
      ),
      isInvalid: false,
      key: (
        /*key*/
        ctx[0] + /*style*/
        ctx[5].showPassword
      ),
      onChange: (
        /*toggleVisibility*/
        ctx[19]
      ),
      value: false,
      $$slots: { default: [create_default_slot$k] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      div = element("div");
      create_component(checkbox.$$.fragment);
      attr(div, "class", "tw_w-full tw_input-spacing");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(checkbox, div, null);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      const checkbox_changes = {};
      if (dirty & /*callbackMetadata*/
      4) checkbox_changes.isFirstInvalidInput = /*callbackMetadata*/
      ((_a2 = ctx2[2]) == null ? void 0 : _a2.derived.isFirstInvalidInput) || false;
      if (dirty & /*key, style*/
      33) checkbox_changes.key = /*key*/
      ctx2[0] + /*style*/
      ctx2[5].showPassword;
      if (dirty & /*$$scope*/
      8388608) {
        checkbox_changes.$$scope = { dirty, ctx: ctx2 };
      }
      checkbox.$set(checkbox_changes);
    },
    i(local) {
      if (current) return;
      transition_in(checkbox.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(checkbox.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(checkbox);
    }
  };
}
function create_default_slot$k(ctx) {
  let t3;
  return {
    c() {
      t3 = text("Show Password");
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_if_block$j(ctx) {
  var _a;
  let confirminput;
  let current;
  confirminput = new Confirm_input({
    props: {
      forceValidityFailure: (
        /*doPasswordsMatch*/
        ctx[10] === false
      ),
      passwordsDoNotMatch: (
        /*doPasswordsMatch*/
        ctx[10] === false
      ),
      key: (
        /*key*/
        ctx[0]
      ),
      isRequired: (
        /*value*/
        ctx[8].length > 0
      ),
      onChange: (
        /*confirmInput*/
        ctx[17]
      ),
      resetValue: (
        /*resetValue*/
        ctx[12]
      ),
      showMessage: (
        /*doPasswordsMatch*/
        ctx[10] === false
      ),
      style: (
        /*style*/
        ctx[5]
      ),
      isFirstInvalidInput: (
        /*callbackMetadata*/
        ((_a = ctx[2]) == null ? void 0 : _a.derived.isFirstInvalidInput) || false
      )
    }
  });
  return {
    c() {
      create_component(confirminput.$$.fragment);
    },
    m(target, anchor) {
      mount_component(confirminput, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      const confirminput_changes = {};
      if (dirty & /*doPasswordsMatch*/
      1024) confirminput_changes.forceValidityFailure = /*doPasswordsMatch*/
      ctx2[10] === false;
      if (dirty & /*doPasswordsMatch*/
      1024) confirminput_changes.passwordsDoNotMatch = /*doPasswordsMatch*/
      ctx2[10] === false;
      if (dirty & /*key*/
      1) confirminput_changes.key = /*key*/
      ctx2[0];
      if (dirty & /*value*/
      256) confirminput_changes.isRequired = /*value*/
      ctx2[8].length > 0;
      if (dirty & /*resetValue*/
      4096) confirminput_changes.resetValue = /*resetValue*/
      ctx2[12];
      if (dirty & /*doPasswordsMatch*/
      1024) confirminput_changes.showMessage = /*doPasswordsMatch*/
      ctx2[10] === false;
      if (dirty & /*style*/
      32) confirminput_changes.style = /*style*/
      ctx2[5];
      if (dirty & /*callbackMetadata*/
      4) confirminput_changes.isFirstInvalidInput = /*callbackMetadata*/
      ((_a2 = ctx2[2]) == null ? void 0 : _a2.derived.isFirstInvalidInput) || false;
      confirminput.$set(confirminput_changes);
    },
    i(local) {
      if (current) return;
      transition_in(confirminput.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(confirminput.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(confirminput, detaching);
    }
  };
}
function create_key_block$3(ctx) {
  var _a, _b, _c;
  let input;
  let t0;
  let t1;
  let if_block1_anchor;
  let current;
  input = new /*Input*/
  ctx[15]({
    props: {
      isFirstInvalidInput: (
        /*callbackMetadata*/
        ((_a = ctx[2]) == null ? void 0 : _a.derived.isFirstInvalidInput) || false
      ),
      hasRightIcon: (
        /*style*/
        ctx[5].showPassword === "button" ? true : false
      ),
      key: (
        /*key*/
        ctx[0]
      ),
      label: interpolate(
        textToKey(
          /*callbackType*/
          ctx[9]
        ),
        null,
        /*textInputLabel*/
        ctx[13]
      ),
      message: (
        /*validationFailure*/
        ctx[7] || /*isRequired*/
        (ctx[4] ? interpolate("inputRequiredError") : void 0)
      ),
      onChange: (
        /*setValue*/
        ctx[18]
      ),
      isInvalid: (
        /*isInvalid*/
        ctx[3]
      ),
      isRequired: (
        /*isRequired*/
        ctx[4]
      ),
      showMessage: (
        /*showMessage*/
        ctx[6]
      ),
      type: (
        /*type*/
        ctx[14]
      ),
      value: typeof /*value*/
      ctx[8] === "string" ? (
        /*value*/
        ctx[8]
      ) : "",
      $$slots: {
        "input-button": [create_input_button_slot],
        default: [create_default_slot_2$7]
      },
      $$scope: { ctx }
    }
  });
  let if_block0 = (
    /*showPassword*/
    ctx[16] === "checkbox" && create_if_block_1$b(ctx)
  );
  let if_block1 = (
    /*callbackMetadata*/
    ((_c = (_b = ctx[2]) == null ? void 0 : _b.platform) == null ? void 0 : _c.confirmPassword) && create_if_block$j(ctx)
  );
  return {
    c() {
      create_component(input.$$.fragment);
      t0 = space();
      if (if_block0) if_block0.c();
      t1 = space();
      if (if_block1) if_block1.c();
      if_block1_anchor = empty();
    },
    m(target, anchor) {
      mount_component(input, target, anchor);
      insert(target, t0, anchor);
      if (if_block0) if_block0.m(target, anchor);
      insert(target, t1, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, if_block1_anchor, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2, _b2, _c2;
      const input_changes = {};
      if (dirty & /*callbackMetadata*/
      4) input_changes.isFirstInvalidInput = /*callbackMetadata*/
      ((_a2 = ctx2[2]) == null ? void 0 : _a2.derived.isFirstInvalidInput) || false;
      if (dirty & /*style*/
      32) input_changes.hasRightIcon = /*style*/
      ctx2[5].showPassword === "button" ? true : false;
      if (dirty & /*key*/
      1) input_changes.key = /*key*/
      ctx2[0];
      if (dirty & /*callbackType, textInputLabel*/
      8704) input_changes.label = interpolate(
        textToKey(
          /*callbackType*/
          ctx2[9]
        ),
        null,
        /*textInputLabel*/
        ctx2[13]
      );
      if (dirty & /*validationFailure, isRequired*/
      144) input_changes.message = /*validationFailure*/
      ctx2[7] || /*isRequired*/
      (ctx2[4] ? interpolate("inputRequiredError") : void 0);
      if (dirty & /*isInvalid*/
      8) input_changes.isInvalid = /*isInvalid*/
      ctx2[3];
      if (dirty & /*isRequired*/
      16) input_changes.isRequired = /*isRequired*/
      ctx2[4];
      if (dirty & /*showMessage*/
      64) input_changes.showMessage = /*showMessage*/
      ctx2[6];
      if (dirty & /*type*/
      16384) input_changes.type = /*type*/
      ctx2[14];
      if (dirty & /*value*/
      256) input_changes.value = typeof /*value*/
      ctx2[8] === "string" ? (
        /*value*/
        ctx2[8]
      ) : "";
      if (dirty & /*$$scope, isVisible*/
      8390656) {
        input_changes.$$scope = { dirty, ctx: ctx2 };
      }
      input.$set(input_changes);
      if (
        /*showPassword*/
        ctx2[16] === "checkbox"
      ) if_block0.p(ctx2, dirty);
      if (
        /*callbackMetadata*/
        (_c2 = (_b2 = ctx2[2]) == null ? void 0 : _b2.platform) == null ? void 0 : _c2.confirmPassword
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
          if (dirty & /*callbackMetadata*/
          4) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block$j(ctx2);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current) return;
      transition_in(input.$$.fragment, local);
      transition_in(if_block0);
      transition_in(if_block1);
      current = true;
    },
    o(local) {
      transition_out(input.$$.fragment, local);
      transition_out(if_block0);
      transition_out(if_block1);
      current = false;
    },
    d(detaching) {
      destroy_component(input, detaching);
      if (detaching) detach(t0);
      if (if_block0) if_block0.d(detaching);
      if (detaching) detach(t1);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(if_block1_anchor);
    }
  };
}
function create_fragment$C(ctx) {
  let previous_key = (
    /*callback*/
    ctx[1]
  );
  let key_block_anchor;
  let current;
  let key_block = create_key_block$3(ctx);
  return {
    c() {
      key_block.c();
      key_block_anchor = empty();
    },
    m(target, anchor) {
      key_block.m(target, anchor);
      insert(target, key_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (dirty & /*callback*/
      2 && safe_not_equal(previous_key, previous_key = /*callback*/
      ctx2[1])) {
        group_outros();
        transition_out(key_block, 1, 1, noop);
        check_outros();
        key_block = create_key_block$3(ctx2);
        key_block.c();
        transition_in(key_block, 1);
        key_block.m(key_block_anchor.parentNode, key_block_anchor);
      } else {
        key_block.p(ctx2, dirty);
      }
    },
    i(local) {
      if (current) return;
      transition_in(key_block);
      current = true;
    },
    o(local) {
      transition_out(key_block);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(key_block_anchor);
      key_block.d(detaching);
    }
  };
}
function instance$D($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { callback } = $$props;
  let { callbackMetadata } = $$props;
  let { key } = $$props;
  let { isInvalid = false } = $$props;
  let { isRequired = false } = $$props;
  let { style = {} } = $$props;
  const Input2 = style.labels === "stacked" ? Stacked_label2 : Floating_label2;
  const showPassword2 = style.showPassword;
  let { showMessage = void 0 } = $$props;
  let { validationFailure = "" } = $$props;
  let confirmValue;
  let callbackType;
  let doPasswordsMatch;
  let isVisible = false;
  let resetValue = false;
  let savedValue = "";
  let textInputLabel;
  let type = "password";
  let value;
  function confirmInput(val) {
    $$invalidate(20, confirmValue = val);
  }
  function setValue(event) {
    $$invalidate(8, value = event.target.value);
    callback.setInputValue(value);
    $$invalidate(21, savedValue = String(value));
  }
  function toggleVisibility() {
    $$invalidate(11, isVisible = !isVisible);
    $$invalidate(14, type = isVisible ? "text" : "password");
  }
  $$self.$$set = ($$props2) => {
    if ("callback" in $$props2) $$invalidate(1, callback = $$props2.callback);
    if ("callbackMetadata" in $$props2) $$invalidate(2, callbackMetadata = $$props2.callbackMetadata);
    if ("key" in $$props2) $$invalidate(0, key = $$props2.key);
    if ("isInvalid" in $$props2) $$invalidate(3, isInvalid = $$props2.isInvalid);
    if ("isRequired" in $$props2) $$invalidate(4, isRequired = $$props2.isRequired);
    if ("style" in $$props2) $$invalidate(5, style = $$props2.style);
    if ("showMessage" in $$props2) $$invalidate(6, showMessage = $$props2.showMessage);
    if ("validationFailure" in $$props2) $$invalidate(7, validationFailure = $$props2.validationFailure);
    if ("$$scope" in $$props2) $$invalidate(23, $$scope = $$props2.$$scope);
  };
  $$self.$$.update = () => {
    var _a, _b;
    if ($$self.$$.dirty & /*callback, callbackMetadata, savedValue, value, confirmValue*/
    3145990) {
      {
        $$invalidate(9, callbackType = callback.getType());
        $$invalidate(0, key = ((_b = (_a = callback == null ? void 0 : callback.payload) == null ? void 0 : _a.input) == null ? void 0 : _b[0].name) || `password-${callbackMetadata == null ? void 0 : callbackMetadata.idx}`);
        $$invalidate(13, textInputLabel = callback.getPrompt());
        $$invalidate(8, value = callback == null ? void 0 : callback.getInputValue());
        $$invalidate(12, resetValue = !!savedValue && value === "");
        $$invalidate(10, doPasswordsMatch = confirmValue !== void 0 ? confirmValue === value : void 0);
      }
    }
  };
  return [
    key,
    callback,
    callbackMetadata,
    isInvalid,
    isRequired,
    style,
    showMessage,
    validationFailure,
    value,
    callbackType,
    doPasswordsMatch,
    isVisible,
    resetValue,
    textInputLabel,
    type,
    Input2,
    showPassword2,
    confirmInput,
    setValue,
    toggleVisibility,
    confirmValue,
    savedValue,
    slots,
    $$scope
  ];
}
var Base = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$D, create_fragment$C, safe_not_equal, {
      callback: 1,
      callbackMetadata: 2,
      key: 0,
      isInvalid: 3,
      isRequired: 4,
      style: 5,
      showMessage: 6,
      validationFailure: 7
    });
  }
};
function create_fragment$B(ctx) {
  let base;
  let current;
  base = new Base({
    props: {
      callback: (
        /*callback*/
        ctx[0]
      ),
      callbackMetadata: (
        /*callbackMetadata*/
        ctx[1]
      ),
      style: (
        /*style*/
        ctx[2]
      ),
      key: (
        /*inputName*/
        ctx[3]
      )
    }
  });
  return {
    c() {
      create_component(base.$$.fragment);
    },
    m(target, anchor) {
      mount_component(base, target, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      const base_changes = {};
      if (dirty & /*callback*/
      1) base_changes.callback = /*callback*/
      ctx2[0];
      if (dirty & /*callbackMetadata*/
      2) base_changes.callbackMetadata = /*callbackMetadata*/
      ctx2[1];
      if (dirty & /*style*/
      4) base_changes.style = /*style*/
      ctx2[2];
      if (dirty & /*inputName*/
      8) base_changes.key = /*inputName*/
      ctx2[3];
      base.$set(base_changes);
    },
    i(local) {
      if (current) return;
      transition_in(base.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(base.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(base, detaching);
    }
  };
}
function instance$C($$self, $$props, $$invalidate) {
  const selfSubmitFunction = null;
  const stepMetadata = null;
  let { callback } = $$props;
  let { callbackMetadata } = $$props;
  let { style = {} } = $$props;
  let inputName;
  $$self.$$set = ($$props2) => {
    if ("callback" in $$props2) $$invalidate(0, callback = $$props2.callback);
    if ("callbackMetadata" in $$props2) $$invalidate(1, callbackMetadata = $$props2.callbackMetadata);
    if ("style" in $$props2) $$invalidate(2, style = $$props2.style);
  };
  $$self.$$.update = () => {
    var _a, _b;
    if ($$self.$$.dirty & /*callback, callbackMetadata*/
    3) {
      {
        $$invalidate(0, callback), $$invalidate(1, callbackMetadata);
        $$invalidate(3, inputName = ((_b = (_a = callback == null ? void 0 : callback.payload) == null ? void 0 : _a.input) == null ? void 0 : _b[0].name) || `password-${callbackMetadata == null ? void 0 : callbackMetadata.idx}`);
      }
    }
  };
  return [callback, callbackMetadata, style, inputName, selfSubmitFunction, stepMetadata];
}
var Password = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$C, create_fragment$B, safe_not_equal, {
      selfSubmitFunction: 4,
      stepMetadata: 5,
      callback: 0,
      callbackMetadata: 1,
      style: 2
    });
  }
  get selfSubmitFunction() {
    return this.$$.ctx[4];
  }
  get stepMetadata() {
    return this.$$.ctx[5];
  }
};
function create_fragment$A(ctx) {
  let p4;
  let p_class_value;
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[2].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[1],
    null
  );
  return {
    c() {
      p4 = element("p");
      if (default_slot) default_slot.c();
      attr(p4, "class", p_class_value = `${/*classes*/
      ctx[0]} tw_text-base tw_text-secondary-dark dark:tw_text-secondary-light tw_input-spacing`);
    },
    m(target, anchor) {
      insert(target, p4, anchor);
      if (default_slot) {
        default_slot.m(p4, null);
      }
      current = true;
    },
    p(ctx2, [dirty]) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        2)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[1],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[1]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[1],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (!current || dirty & /*classes*/
      1 && p_class_value !== (p_class_value = `${/*classes*/
      ctx2[0]} tw_text-base tw_text-secondary-dark dark:tw_text-secondary-light tw_input-spacing`)) {
        attr(p4, "class", p_class_value);
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(p4);
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function instance$B($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { classes = "" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("classes" in $$props2) $$invalidate(0, classes = $$props2.classes);
    if ("$$scope" in $$props2) $$invalidate(1, $$scope = $$props2.$$scope);
  };
  return [classes, $$scope, slots];
}
var Text = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$B, create_fragment$A, safe_not_equal, { classes: 0 });
  }
};
function create_else_block$6(ctx) {
  let spinner;
  let t3;
  let text_1;
  let current;
  spinner = new Spinner({
    props: {
      colorClass: "tw_text-primary-light",
      layoutClasses: "tw_h-24 tw_mb-6 tw_w-24"
    }
  });
  text_1 = new Text({
    props: {
      $$slots: { default: [create_default_slot_1$c] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(spinner.$$.fragment);
      t3 = space();
      create_component(text_1.$$.fragment);
    },
    m(target, anchor) {
      mount_component(spinner, target, anchor);
      insert(target, t3, anchor);
      mount_component(text_1, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const text_1_changes = {};
      if (dirty & /*$$scope, message*/
      258) {
        text_1_changes.$$scope = { dirty, ctx: ctx2 };
      }
      text_1.$set(text_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(spinner.$$.fragment, local);
      transition_in(text_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(spinner.$$.fragment, local);
      transition_out(text_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(spinner, detaching);
      if (detaching) detach(t3);
      destroy_component(text_1, detaching);
    }
  };
}
function create_if_block$i(ctx) {
  let text_1;
  let current;
  text_1 = new Text({
    props: {
      $$slots: { default: [create_default_slot$j] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(text_1.$$.fragment);
    },
    m(target, anchor) {
      mount_component(text_1, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const text_1_changes = {};
      if (dirty & /*$$scope, message*/
      258) {
        text_1_changes.$$scope = { dirty, ctx: ctx2 };
      }
      text_1.$set(text_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(text_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(text_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(text_1, detaching);
    }
  };
}
function create_default_slot_1$c(ctx) {
  let t3;
  return {
    c() {
      t3 = text(
        /*message*/
        ctx[1]
      );
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*message*/
      2) set_data(
        t3,
        /*message*/
        ctx2[1]
      );
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_default_slot$j(ctx) {
  let spinner;
  let t0;
  let span;
  let t1;
  let current;
  spinner = new Spinner({
    props: {
      colorClass: "white",
      layoutClasses: "tw_h-4 tw_w-4 tw_mr-2"
    }
  });
  return {
    c() {
      create_component(spinner.$$.fragment);
      t0 = space();
      span = element("span");
      t1 = text(
        /*message*/
        ctx[1]
      );
    },
    m(target, anchor) {
      mount_component(spinner, target, anchor);
      insert(target, t0, anchor);
      insert(target, span, anchor);
      append(span, t1);
      current = true;
    },
    p(ctx2, dirty) {
      if (!current || dirty & /*message*/
      2) set_data(
        t1,
        /*message*/
        ctx2[1]
      );
    },
    i(local) {
      if (current) return;
      transition_in(spinner.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(spinner.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(spinner, detaching);
      if (detaching) detach(t0);
      if (detaching) detach(span);
    }
  };
}
function create_fragment$z(ctx) {
  let div;
  let current_block_type_index;
  let if_block;
  let current;
  const if_block_creators = [create_if_block$i, create_else_block$6];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    var _a;
    if (
      /*options*/
      (_a = ctx2[0]) == null ? void 0 : _a.inline
    ) return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      div = element("div");
      if_block.c();
      attr(div, "class", "tw_text-center");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      if_blocks[current_block_type_index].m(div, null);
      current = true;
    },
    p(ctx2, [dirty]) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(div, null);
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      if_blocks[current_block_type_index].d();
    }
  };
}
function instance$A($$self, $$props, $$invalidate) {
  const style = {};
  const stepMetadata = null;
  let { callback } = $$props;
  let { callbackMetadata } = $$props;
  let { selfSubmitFunction = null } = $$props;
  let { options = null } = $$props;
  let message;
  let timer;
  $$self.$$set = ($$props2) => {
    if ("callback" in $$props2) $$invalidate(2, callback = $$props2.callback);
    if ("callbackMetadata" in $$props2) $$invalidate(3, callbackMetadata = $$props2.callbackMetadata);
    if ("selfSubmitFunction" in $$props2) $$invalidate(6, selfSubmitFunction = $$props2.selfSubmitFunction);
    if ("options" in $$props2) $$invalidate(0, options = $$props2.options);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*callback, timer, callbackMetadata, selfSubmitFunction*/
    204) {
      {
        $$invalidate(2, callback), $$invalidate(7, timer), $$invalidate(3, callbackMetadata), $$invalidate(6, selfSubmitFunction);
        $$invalidate(1, message = callback.getMessage());
        clearTimeout(timer);
        $$invalidate(7, timer = setTimeout(
          () => {
            if (callbackMetadata) {
              $$invalidate(3, callbackMetadata.derived.isReadyForSubmission = true, callbackMetadata);
            }
            selfSubmitFunction && selfSubmitFunction();
          },
          callback.getWaitTime()
        ));
      }
    }
  };
  return [
    options,
    message,
    callback,
    callbackMetadata,
    style,
    stepMetadata,
    selfSubmitFunction,
    timer
  ];
}
var Polling_wait = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$A, create_fragment$z, safe_not_equal, {
      style: 4,
      stepMetadata: 5,
      callback: 2,
      callbackMetadata: 3,
      selfSubmitFunction: 6,
      options: 0
    });
  }
  get style() {
    return this.$$.ctx[4];
  }
  get stepMetadata() {
    return this.$$.ctx[5];
  }
};
function create_default_slot$i(ctx) {
  let t3;
  return {
    c() {
      t3 = text(
        /*message*/
        ctx[0]
      );
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*message*/
      1) set_data(
        t3,
        /*message*/
        ctx2[0]
      );
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_fragment$y(ctx) {
  let div;
  let spinner;
  let t3;
  let text_1;
  let current;
  spinner = new Spinner({
    props: {
      colorClass: "tw_text-primary-light",
      layoutClasses: "tw_h-24 tw_mb-6 tw_w-24"
    }
  });
  text_1 = new Text({
    props: {
      $$slots: { default: [create_default_slot$i] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      div = element("div");
      create_component(spinner.$$.fragment);
      t3 = space();
      create_component(text_1.$$.fragment);
      attr(div, "class", "tw_text-center");
      attr(div, "aria-live", "assertive");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(spinner, div, null);
      append(div, t3);
      mount_component(text_1, div, null);
      current = true;
    },
    p(ctx2, [dirty]) {
      const text_1_changes = {};
      if (dirty & /*$$scope, message*/
      65) {
        text_1_changes.$$scope = { dirty, ctx: ctx2 };
      }
      text_1.$set(text_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(spinner.$$.fragment, local);
      transition_in(text_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(spinner.$$.fragment, local);
      transition_out(text_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(spinner);
      destroy_component(text_1);
    }
  };
}
function instance$z($$self, $$props, $$invalidate) {
  const callbackMetadata = null;
  const selfSubmitFunction = null;
  const stepMetadata = null;
  const style = {};
  let { callback } = $$props;
  let message;
  $$self.$$set = ($$props2) => {
    if ("callback" in $$props2) $$invalidate(5, callback = $$props2.callback);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*callback*/
    32) {
      {
        $$invalidate(0, message = `${interpolate("redirectingTo")} ${new URL(callback.getRedirectUrl()).hostname}`);
      }
    }
  };
  return [message, callbackMetadata, selfSubmitFunction, stepMetadata, style, callback];
}
var Redirect = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$z, create_fragment$y, safe_not_equal, {
      callbackMetadata: 1,
      selfSubmitFunction: 2,
      stepMetadata: 3,
      style: 4,
      callback: 5
    });
  }
  get callbackMetadata() {
    return this.$$.ctx[1];
  }
  get selfSubmitFunction() {
    return this.$$.ctx[2];
  }
  get stepMetadata() {
    return this.$$.ctx[3];
  }
  get style() {
    return this.$$.ctx[4];
  }
};
function create_fragment$x(ctx) {
  let svg;
  let path0;
  let path1;
  return {
    c() {
      svg = svg_element("svg");
      path0 = svg_element("path");
      path1 = svg_element("path");
      attr(path0, "d", "M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516.024.034 1.52.087 2.475-1.258.955-1.345.762-2.391.728-2.43Zm3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422.212-2.189 1.675-2.789 1.698-2.854.023-.065-.597-.79-1.254-1.157a3.692 3.692 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56.244.729.625 1.924 1.273 2.796.576.984 1.34 1.667 1.659 1.899.319.232 1.219.386 1.843.067.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758.347-.79.505-1.217.473-1.282Z");
      attr(path1, "d", "M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516.024.034 1.52.087 2.475-1.258.955-1.345.762-2.391.728-2.43Zm3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422.212-2.189 1.675-2.789 1.698-2.854.023-.065-.597-.79-1.254-1.157a3.692 3.692 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56.244.729.625 1.924 1.273 2.796.576.984 1.34 1.667 1.659 1.899.319.232 1.219.386 1.843.067.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758.347-.79.505-1.217.473-1.282Z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(
        svg,
        "height",
        /*size*/
        ctx[1]
      );
      attr(
        svg,
        "width",
        /*size*/
        ctx[1]
      );
      attr(
        svg,
        "class",
        /*classes*/
        ctx[0]
      );
      attr(svg, "fill", "currentColor");
      attr(svg, "viewBox", "0 0 16 18");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path0);
      append(svg, path1);
    },
    p(ctx2, [dirty]) {
      if (dirty & /*size*/
      2) {
        attr(
          svg,
          "height",
          /*size*/
          ctx2[1]
        );
      }
      if (dirty & /*size*/
      2) {
        attr(
          svg,
          "width",
          /*size*/
          ctx2[1]
        );
      }
      if (dirty & /*classes*/
      1) {
        attr(
          svg,
          "class",
          /*classes*/
          ctx2[0]
        );
      }
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
function instance$y($$self, $$props, $$invalidate) {
  let { classes = "" } = $$props;
  let { size = "24px" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("classes" in $$props2) $$invalidate(0, classes = $$props2.classes);
    if ("size" in $$props2) $$invalidate(1, size = $$props2.size);
  };
  return [classes, size];
}
var Apple_icon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$y, create_fragment$x, safe_not_equal, { classes: 0, size: 1 });
  }
};
function create_fragment$w(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "d", "M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(
        svg,
        "width",
        /*size*/
        ctx[1]
      );
      attr(
        svg,
        "height",
        /*size*/
        ctx[1]
      );
      attr(svg, "fill", "currentColor");
      attr(
        svg,
        "class",
        /*classes*/
        ctx[0]
      );
      attr(svg, "viewBox", "0 0 18 18");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p(ctx2, [dirty]) {
      if (dirty & /*size*/
      2) {
        attr(
          svg,
          "width",
          /*size*/
          ctx2[1]
        );
      }
      if (dirty & /*size*/
      2) {
        attr(
          svg,
          "height",
          /*size*/
          ctx2[1]
        );
      }
      if (dirty & /*classes*/
      1) {
        attr(
          svg,
          "class",
          /*classes*/
          ctx2[0]
        );
      }
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
function instance$x($$self, $$props, $$invalidate) {
  let { classes = "" } = $$props;
  let { size = "24px" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("classes" in $$props2) $$invalidate(0, classes = $$props2.classes);
    if ("size" in $$props2) $$invalidate(1, size = $$props2.size);
  };
  return [classes, size];
}
var Facebook_icon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$x, create_fragment$w, safe_not_equal, { classes: 0, size: 1 });
  }
};
function create_fragment$v(ctx) {
  let svg;
  let g;
  let path0;
  let path1;
  let path2;
  let path3;
  let path4;
  return {
    c() {
      svg = svg_element("svg");
      g = svg_element("g");
      path0 = svg_element("path");
      path1 = svg_element("path");
      path2 = svg_element("path");
      path3 = svg_element("path");
      path4 = svg_element("path");
      attr(path0, "fill", "#EA4335");
      attr(path0, "d", "M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z");
      attr(path1, "fill", "#4285F4");
      attr(path1, "d", "M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z");
      attr(path2, "fill", "#FBBC05");
      attr(path2, "d", "M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z");
      attr(path3, "fill", "#34A853");
      attr(path3, "d", "M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z");
      attr(path4, "fill", "none");
      attr(path4, "d", "M0 0h48v48H0z");
      attr(svg, "version", "1.1");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(
        svg,
        "height",
        /*size*/
        ctx[1]
      );
      attr(
        svg,
        "width",
        /*size*/
        ctx[1]
      );
      attr(svg, "viewBox", "0 0 56 56");
      attr(
        svg,
        "class",
        /*classes*/
        ctx[0]
      );
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, g);
      append(g, path0);
      append(g, path1);
      append(g, path2);
      append(g, path3);
      append(g, path4);
    },
    p(ctx2, [dirty]) {
      if (dirty & /*size*/
      2) {
        attr(
          svg,
          "height",
          /*size*/
          ctx2[1]
        );
      }
      if (dirty & /*size*/
      2) {
        attr(
          svg,
          "width",
          /*size*/
          ctx2[1]
        );
      }
      if (dirty & /*classes*/
      1) {
        attr(
          svg,
          "class",
          /*classes*/
          ctx2[0]
        );
      }
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
function instance$w($$self, $$props, $$invalidate) {
  let { classes = "" } = $$props;
  let { size = "24px" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("classes" in $$props2) $$invalidate(0, classes = $$props2.classes);
    if ("size" in $$props2) $$invalidate(1, size = $$props2.size);
  };
  return [classes, size];
}
var Google_icon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$w, create_fragment$v, safe_not_equal, { classes: 0, size: 1 });
  }
};
function get_each_context$8(ctx, list, i9) {
  const child_ctx = ctx.slice();
  child_ctx[10] = list[i9];
  return child_ctx;
}
function create_if_block_3$8(ctx) {
  let button;
  let current;
  function func_2() {
    return (
      /*func_2*/
      ctx[9](
        /*idp*/
        ctx[10]
      )
    );
  }
  button = new Button({
    props: {
      classes: "tw_button-google dark:tw_button-google_dark",
      type: "button",
      width: "auto",
      onClick: func_2,
      $$slots: { default: [create_default_slot_4$2] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(button.$$.fragment);
    },
    m(target, anchor) {
      mount_component(button, target, anchor);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      const button_changes = {};
      if (dirty & /*idps*/
      2) button_changes.onClick = func_2;
      if (dirty & /*$$scope, idps*/
      8194) {
        button_changes.$$scope = { dirty, ctx };
      }
      button.$set(button_changes);
    },
    i(local) {
      if (current) return;
      transition_in(button.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(button.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(button, detaching);
    }
  };
}
function create_if_block_2$8(ctx) {
  let button;
  let current;
  function func_1() {
    return (
      /*func_1*/
      ctx[8](
        /*idp*/
        ctx[10]
      )
    );
  }
  button = new Button({
    props: {
      classes: "tw_button-facebook dark:tw_button-facebook_dark",
      type: "button",
      width: "auto",
      onClick: func_1,
      $$slots: { default: [create_default_slot_3$3] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(button.$$.fragment);
    },
    m(target, anchor) {
      mount_component(button, target, anchor);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      const button_changes = {};
      if (dirty & /*idps*/
      2) button_changes.onClick = func_1;
      if (dirty & /*$$scope, idps*/
      8194) {
        button_changes.$$scope = { dirty, ctx };
      }
      button.$set(button_changes);
    },
    i(local) {
      if (current) return;
      transition_in(button.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(button.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(button, detaching);
    }
  };
}
function create_if_block_1$a(ctx) {
  let button;
  let current;
  function func() {
    return (
      /*func*/
      ctx[7](
        /*idp*/
        ctx[10]
      )
    );
  }
  button = new Button({
    props: {
      classes: "tw_button-apple dark:tw_button-apple_dark",
      type: "button",
      width: "auto",
      onClick: func,
      $$slots: { default: [create_default_slot_2$6] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(button.$$.fragment);
    },
    m(target, anchor) {
      mount_component(button, target, anchor);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      const button_changes = {};
      if (dirty & /*idps*/
      2) button_changes.onClick = func;
      if (dirty & /*$$scope, idps*/
      8194) {
        button_changes.$$scope = { dirty, ctx };
      }
      button.$set(button_changes);
    },
    i(local) {
      if (current) return;
      transition_in(button.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(button.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(button, detaching);
    }
  };
}
function create_default_slot_4$2(ctx) {
  let googleicon;
  let t0;
  let t1;
  let t22;
  let t3_value = (
    /*idp*/
    ctx[10].text + ""
  );
  let t3;
  let current;
  googleicon = new Google_icon({
    props: {
      classes: "tw_inline-block tw_fill-current"
    }
  });
  t1 = new Locale_strings({ props: { key: "continueWith" } });
  return {
    c() {
      create_component(googleicon.$$.fragment);
      t0 = space();
      create_component(t1.$$.fragment);
      t22 = space();
      t3 = text(t3_value);
    },
    m(target, anchor) {
      mount_component(googleicon, target, anchor);
      insert(target, t0, anchor);
      mount_component(t1, target, anchor);
      insert(target, t22, anchor);
      insert(target, t3, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      if ((!current || dirty & /*idps*/
      2) && t3_value !== (t3_value = /*idp*/
      ctx2[10].text + "")) set_data(t3, t3_value);
    },
    i(local) {
      if (current) return;
      transition_in(googleicon.$$.fragment, local);
      transition_in(t1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(googleicon.$$.fragment, local);
      transition_out(t1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(googleicon, detaching);
      if (detaching) detach(t0);
      destroy_component(t1, detaching);
      if (detaching) detach(t22);
      if (detaching) detach(t3);
    }
  };
}
function create_default_slot_3$3(ctx) {
  let facebookicon;
  let t0;
  let t1;
  let t22;
  let t3_value = (
    /*idp*/
    ctx[10].text + ""
  );
  let t3;
  let current;
  facebookicon = new Facebook_icon({
    props: {
      classes: "tw_inline-block tw_fill-current"
    }
  });
  t1 = new Locale_strings({ props: { key: "continueWith" } });
  return {
    c() {
      create_component(facebookicon.$$.fragment);
      t0 = space();
      create_component(t1.$$.fragment);
      t22 = space();
      t3 = text(t3_value);
    },
    m(target, anchor) {
      mount_component(facebookicon, target, anchor);
      insert(target, t0, anchor);
      mount_component(t1, target, anchor);
      insert(target, t22, anchor);
      insert(target, t3, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      if ((!current || dirty & /*idps*/
      2) && t3_value !== (t3_value = /*idp*/
      ctx2[10].text + "")) set_data(t3, t3_value);
    },
    i(local) {
      if (current) return;
      transition_in(facebookicon.$$.fragment, local);
      transition_in(t1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(facebookicon.$$.fragment, local);
      transition_out(t1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(facebookicon, detaching);
      if (detaching) detach(t0);
      destroy_component(t1, detaching);
      if (detaching) detach(t22);
      if (detaching) detach(t3);
    }
  };
}
function create_default_slot_2$6(ctx) {
  let appleicon;
  let t0;
  let t1;
  let t22;
  let t3_value = (
    /*idp*/
    ctx[10].text + ""
  );
  let t3;
  let current;
  appleicon = new Apple_icon({
    props: {
      classes: "tw_inline-block tw_fill-current"
    }
  });
  t1 = new Locale_strings({ props: { key: "continueWith" } });
  return {
    c() {
      create_component(appleicon.$$.fragment);
      t0 = space();
      create_component(t1.$$.fragment);
      t22 = space();
      t3 = text(t3_value);
    },
    m(target, anchor) {
      mount_component(appleicon, target, anchor);
      insert(target, t0, anchor);
      mount_component(t1, target, anchor);
      insert(target, t22, anchor);
      insert(target, t3, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      if ((!current || dirty & /*idps*/
      2) && t3_value !== (t3_value = /*idp*/
      ctx2[10].text + "")) set_data(t3, t3_value);
    },
    i(local) {
      if (current) return;
      transition_in(appleicon.$$.fragment, local);
      transition_in(t1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(appleicon.$$.fragment, local);
      transition_out(t1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(appleicon, detaching);
      if (detaching) detach(t0);
      destroy_component(t1, detaching);
      if (detaching) detach(t22);
      if (detaching) detach(t3);
    }
  };
}
function create_default_slot_1$b(ctx) {
  let show_if;
  let show_if_1;
  let show_if_2;
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block_1$a, create_if_block_2$8, create_if_block_3$8];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (dirty & /*idps*/
    2) show_if = null;
    if (dirty & /*idps*/
    2) show_if_1 = null;
    if (dirty & /*idps*/
    2) show_if_2 = null;
    if (show_if == null) show_if = !!/*idp*/
    ctx2[10].text.toUpperCase().includes("APPLE");
    if (show_if) return 0;
    if (show_if_1 == null) show_if_1 = !!/*idp*/
    ctx2[10].text.toUpperCase().includes("FACEBOOK");
    if (show_if_1) return 1;
    if (show_if_2 == null) show_if_2 = !!/*idp*/
    ctx2[10].text.toUpperCase().includes("GOOGLE");
    if (show_if_2) return 2;
    return -1;
  }
  if (~(current_block_type_index = select_block_type(ctx, -1))) {
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  }
  return {
    c() {
      if (if_block) if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].m(target, anchor);
      }
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2, dirty);
      if (current_block_type_index === previous_block_index) {
        if (~current_block_type_index) {
          if_blocks[current_block_type_index].p(ctx2, dirty);
        }
      } else {
        if (if_block) {
          group_outros();
          transition_out(if_blocks[previous_block_index], 1, 1, () => {
            if_blocks[previous_block_index] = null;
          });
          check_outros();
        }
        if (~current_block_type_index) {
          if_block = if_blocks[current_block_type_index];
          if (!if_block) {
            if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
            if_block.c();
          } else {
            if_block.p(ctx2, dirty);
          }
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        } else {
          if_block = null;
        }
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].d(detaching);
      }
      if (detaching) detach(if_block_anchor);
    }
  };
}
function create_each_block$8(ctx) {
  let grid;
  let current;
  grid = new Grid({
    props: {
      num: 1,
      $$slots: { default: [create_default_slot_1$b] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(grid.$$.fragment);
    },
    m(target, anchor) {
      mount_component(grid, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const grid_changes = {};
      if (dirty & /*$$scope, idps*/
      8194) {
        grid_changes.$$scope = { dirty, ctx: ctx2 };
      }
      grid.$set(grid_changes);
    },
    i(local) {
      if (current) return;
      transition_in(grid.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(grid.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(grid, detaching);
    }
  };
}
function create_if_block$h(ctx) {
  let grid;
  let current;
  grid = new Grid({
    props: {
      num: 1,
      $$slots: { default: [create_default_slot$h] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(grid.$$.fragment);
    },
    m(target, anchor) {
      mount_component(grid, target, anchor);
      current = true;
    },
    i(local) {
      if (current) return;
      transition_in(grid.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(grid.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(grid, detaching);
    }
  };
}
function create_default_slot$h(ctx) {
  let hr;
  return {
    c() {
      hr = element("hr");
      attr(hr, "class", "tw_border-0 tw_border-b tw_border-secondary-light dark:tw_border-secondary-dark");
    },
    m(target, anchor) {
      insert(target, hr, anchor);
    },
    p: noop,
    d(detaching) {
      if (detaching) detach(hr);
    }
  };
}
function create_fragment$u(ctx) {
  let t3;
  let if_block_anchor;
  let current;
  let each_value = (
    /*idps*/
    ctx[1]
  );
  let each_blocks = [];
  for (let i9 = 0; i9 < each_value.length; i9 += 1) {
    each_blocks[i9] = create_each_block$8(get_each_context$8(ctx, each_value, i9));
  }
  const out = (i9) => transition_out(each_blocks[i9], 1, 1, () => {
    each_blocks[i9] = null;
  });
  let if_block = (
    /*stepMetadata*/
    ctx[0] && /*stepMetadata*/
    ctx[0].derived.numOfCallbacks > 1 && create_if_block$h(ctx)
  );
  return {
    c() {
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].c();
      }
      t3 = space();
      if (if_block) if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].m(target, anchor);
      }
      insert(target, t3, anchor);
      if (if_block) if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (dirty & /*setBtnValue, idps*/
      6) {
        each_value = /*idps*/
        ctx2[1];
        let i9;
        for (i9 = 0; i9 < each_value.length; i9 += 1) {
          const child_ctx = get_each_context$8(ctx2, each_value, i9);
          if (each_blocks[i9]) {
            each_blocks[i9].p(child_ctx, dirty);
            transition_in(each_blocks[i9], 1);
          } else {
            each_blocks[i9] = create_each_block$8(child_ctx);
            each_blocks[i9].c();
            transition_in(each_blocks[i9], 1);
            each_blocks[i9].m(t3.parentNode, t3);
          }
        }
        group_outros();
        for (i9 = each_value.length; i9 < each_blocks.length; i9 += 1) {
          out(i9);
        }
        check_outros();
      }
      if (
        /*stepMetadata*/
        ctx2[0] && /*stepMetadata*/
        ctx2[0].derived.numOfCallbacks > 1
      ) {
        if (if_block) {
          if (dirty & /*stepMetadata*/
          1) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$h(ctx2);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current) return;
      for (let i9 = 0; i9 < each_value.length; i9 += 1) {
        transition_in(each_blocks[i9]);
      }
      transition_in(if_block);
      current = true;
    },
    o(local) {
      each_blocks = each_blocks.filter(Boolean);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        transition_out(each_blocks[i9]);
      }
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      destroy_each(each_blocks, detaching);
      if (detaching) detach(t3);
      if (if_block) if_block.d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function instance$v($$self, $$props, $$invalidate) {
  const style = {};
  let { callback } = $$props;
  let { callbackMetadata } = $$props;
  let { selfSubmitFunction = null } = $$props;
  let { stepMetadata } = $$props;
  let idps;
  function setBtnValue(value) {
    callback.setProvider(value);
    if (callbackMetadata) {
      $$invalidate(3, callbackMetadata.derived.isReadyForSubmission = true, callbackMetadata);
    }
    selfSubmitFunction && selfSubmitFunction();
  }
  const func = (idp) => setBtnValue(idp.value);
  const func_1 = (idp) => setBtnValue(idp.value);
  const func_2 = (idp) => setBtnValue(idp.value);
  $$self.$$set = ($$props2) => {
    if ("callback" in $$props2) $$invalidate(5, callback = $$props2.callback);
    if ("callbackMetadata" in $$props2) $$invalidate(3, callbackMetadata = $$props2.callbackMetadata);
    if ("selfSubmitFunction" in $$props2) $$invalidate(6, selfSubmitFunction = $$props2.selfSubmitFunction);
    if ("stepMetadata" in $$props2) $$invalidate(0, stepMetadata = $$props2.stepMetadata);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*callback*/
    32) {
      {
        const localAuthentication = callback.getProviders().filter((provider) => provider.provider === "localAuthentication");
        const socialProviders = callback.getProviders().filter((provider) => provider.provider !== "localAuthentication");
        if (localAuthentication.length > 0) {
          callback.setProvider("localAuthentication");
        }
        $$invalidate(1, idps = socialProviders.map((option) => ({
          value: option.provider,
          text: option.uiConfig.buttonDisplayName
        })));
      }
    }
  };
  return [
    stepMetadata,
    idps,
    setBtnValue,
    callbackMetadata,
    style,
    callback,
    selfSubmitFunction,
    func,
    func_1,
    func_2
  ];
}
var Select_idp = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$v, create_fragment$u, safe_not_equal, {
      style: 4,
      callback: 5,
      callbackMetadata: 3,
      selfSubmitFunction: 6,
      stepMetadata: 0
    });
  }
  get style() {
    return this.$$.ctx[4];
  }
};
function get_each_context_1(ctx, list, i9) {
  const child_ctx = ctx.slice();
  child_ctx[11] = list[i9];
  return child_ctx;
}
function get_each_context$7(ctx, list, i9) {
  const child_ctx = ctx.slice();
  child_ctx[8] = list[i9];
  return child_ctx;
}
function create_if_block_1$9(ctx) {
  let div;
  let p4;
  let t0;
  let t1;
  let ul;
  let div_id_value;
  let current;
  t0 = new Locale_strings({ props: { key: (
    /*messageKey*/
    ctx[1]
  ) } });
  let each_value_1 = (
    /*validationRules*/
    ctx[3]
  );
  let each_blocks = [];
  for (let i9 = 0; i9 < each_value_1.length; i9 += 1) {
    each_blocks[i9] = create_each_block_1(get_each_context_1(ctx, each_value_1, i9));
  }
  return {
    c() {
      div = element("div");
      p4 = element("p");
      create_component(t0.$$.fragment);
      t1 = space();
      ul = element("ul");
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].c();
      }
      attr(p4, "class", "tw_text-secondary-dark dark:tw_text-secondary-light tw_w-full");
      attr(ul, "class", "tw_text-secondary-dark dark:tw_text-secondary-light tw_w-full");
      attr(div, "class", "tw_input-policies tw_w-full");
      attr(div, "id", div_id_value = `${/*key*/
      ctx[0] ? `${/*key*/
      ctx[0]}-message` : ""}`);
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, p4);
      mount_component(t0, p4, null);
      append(div, t1);
      append(div, ul);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].m(ul, null);
      }
      current = true;
    },
    p(ctx2, dirty) {
      const t0_changes = {};
      if (dirty & /*messageKey*/
      2) t0_changes.key = /*messageKey*/
      ctx2[1];
      t0.$set(t0_changes);
      if (dirty & /*validationRules*/
      8) {
        each_value_1 = /*validationRules*/
        ctx2[3];
        let i9;
        for (i9 = 0; i9 < each_value_1.length; i9 += 1) {
          const child_ctx = get_each_context_1(ctx2, each_value_1, i9);
          if (each_blocks[i9]) {
            each_blocks[i9].p(child_ctx, dirty);
          } else {
            each_blocks[i9] = create_each_block_1(child_ctx);
            each_blocks[i9].c();
            each_blocks[i9].m(ul, null);
          }
        }
        for (; i9 < each_blocks.length; i9 += 1) {
          each_blocks[i9].d(1);
        }
        each_blocks.length = each_value_1.length;
      }
      if (!current || dirty & /*key*/
      1 && div_id_value !== (div_id_value = `${/*key*/
      ctx2[0] ? `${/*key*/
      ctx2[0]}-message` : ""}`)) {
        attr(div, "id", div_id_value);
      }
    },
    i(local) {
      if (current) return;
      transition_in(t0.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t0.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(t0);
      destroy_each(each_blocks, detaching);
    }
  };
}
function create_if_block$g(ctx) {
  let div;
  let p4;
  let t0;
  let t1;
  let ul;
  let div_id_value;
  let current;
  t0 = new Locale_strings({ props: { key: (
    /*messageKey*/
    ctx[1]
  ) } });
  let each_value = (
    /*simplifiedFailures*/
    ctx[4]
  );
  let each_blocks = [];
  for (let i9 = 0; i9 < each_value.length; i9 += 1) {
    each_blocks[i9] = create_each_block$7(get_each_context$7(ctx, each_value, i9));
  }
  return {
    c() {
      div = element("div");
      p4 = element("p");
      create_component(t0.$$.fragment);
      t1 = space();
      ul = element("ul");
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].c();
      }
      attr(p4, "class", "tw_text-error-dark dark:tw_text-error-light tw_w-full");
      attr(ul, "class", "tw_text-error-dark dark:tw_text-error-light tw_w-full");
      attr(div, "class", "tw_input-policies tw_w-full");
      attr(div, "id", div_id_value = `${/*key*/
      ctx[0] ? `${/*key*/
      ctx[0]}-message` : ""}`);
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, p4);
      mount_component(t0, p4, null);
      append(div, t1);
      append(div, ul);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].m(ul, null);
      }
      current = true;
    },
    p(ctx2, dirty) {
      const t0_changes = {};
      if (dirty & /*messageKey*/
      2) t0_changes.key = /*messageKey*/
      ctx2[1];
      t0.$set(t0_changes);
      if (dirty & /*simplifiedFailures*/
      16) {
        each_value = /*simplifiedFailures*/
        ctx2[4];
        let i9;
        for (i9 = 0; i9 < each_value.length; i9 += 1) {
          const child_ctx = get_each_context$7(ctx2, each_value, i9);
          if (each_blocks[i9]) {
            each_blocks[i9].p(child_ctx, dirty);
          } else {
            each_blocks[i9] = create_each_block$7(child_ctx);
            each_blocks[i9].c();
            each_blocks[i9].m(ul, null);
          }
        }
        for (; i9 < each_blocks.length; i9 += 1) {
          each_blocks[i9].d(1);
        }
        each_blocks.length = each_value.length;
      }
      if (!current || dirty & /*key*/
      1 && div_id_value !== (div_id_value = `${/*key*/
      ctx2[0] ? `${/*key*/
      ctx2[0]}-message` : ""}`)) {
        attr(div, "id", div_id_value);
      }
    },
    i(local) {
      if (current) return;
      transition_in(t0.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t0.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(t0);
      destroy_each(each_blocks, detaching);
    }
  };
}
function create_each_block_1(ctx) {
  let li;
  let t_value = (
    /*rule*/
    ctx[11].message + ""
  );
  let t3;
  return {
    c() {
      li = element("li");
      t3 = text(t_value);
      attr(li, "class", "tw_list-disc");
    },
    m(target, anchor) {
      insert(target, li, anchor);
      append(li, t3);
    },
    p(ctx2, dirty) {
      if (dirty & /*validationRules*/
      8 && t_value !== (t_value = /*rule*/
      ctx2[11].message + "")) set_data(t3, t_value);
    },
    d(detaching) {
      if (detaching) detach(li);
    }
  };
}
function create_each_block$7(ctx) {
  let li;
  let t_value = (
    /*failure*/
    ctx[8].message + ""
  );
  let t3;
  return {
    c() {
      li = element("li");
      t3 = text(t_value);
      attr(li, "class", "tw_list-disc");
    },
    m(target, anchor) {
      insert(target, li, anchor);
      append(li, t3);
    },
    p(ctx2, dirty) {
      if (dirty & /*simplifiedFailures*/
      16 && t_value !== (t_value = /*failure*/
      ctx2[8].message + "")) set_data(t3, t_value);
    },
    d(detaching) {
      if (detaching) detach(li);
    }
  };
}
function create_fragment$t(ctx) {
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block$g, create_if_block_1$9];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*simplifiedFailures*/
      ctx2[4].length
    ) return 0;
    if (
      /*showPolicies*/
      ctx2[2] && /*validationRules*/
      ctx2[3].length
    ) return 1;
    return -1;
  }
  if (~(current_block_type_index = select_block_type(ctx))) {
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  }
  return {
    c() {
      if (if_block) if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].m(target, anchor);
      }
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if (~current_block_type_index) {
          if_blocks[current_block_type_index].p(ctx2, dirty);
        }
      } else {
        if (if_block) {
          group_outros();
          transition_out(if_blocks[previous_block_index], 1, 1, () => {
            if_blocks[previous_block_index] = null;
          });
          check_outros();
        }
        if (~current_block_type_index) {
          if_block = if_blocks[current_block_type_index];
          if (!if_block) {
            if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
            if_block.c();
          } else {
            if_block.p(ctx2, dirty);
          }
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        } else {
          if_block = null;
        }
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].d(detaching);
      }
      if (detaching) detach(if_block_anchor);
    }
  };
}
function instance$u($$self, $$props, $$invalidate) {
  let { callback } = $$props;
  let { key = void 0 } = $$props;
  let { label } = $$props;
  let { messageKey } = $$props;
  let { showPolicies = false } = $$props;
  let validationFailures = getValidationFailures(callback, label);
  let validationRules = getValidationPolicies(callback.getPolicies());
  let simplifiedFailures = validationFailures.reduce(
    (prev, curr) => {
      prev = prev.concat(curr.restructured);
      return prev;
    },
    []
  );
  $$self.$$set = ($$props2) => {
    if ("callback" in $$props2) $$invalidate(5, callback = $$props2.callback);
    if ("key" in $$props2) $$invalidate(0, key = $$props2.key);
    if ("label" in $$props2) $$invalidate(6, label = $$props2.label);
    if ("messageKey" in $$props2) $$invalidate(1, messageKey = $$props2.messageKey);
    if ("showPolicies" in $$props2) $$invalidate(2, showPolicies = $$props2.showPolicies);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*callback, label, validationFailures*/
    224) {
      {
        $$invalidate(7, validationFailures = getValidationFailures(callback, label));
        $$invalidate(3, validationRules = getValidationPolicies(callback.getPolicies()));
        $$invalidate(4, simplifiedFailures = validationFailures.reduce(
          (prev, curr) => {
            prev = prev.concat(curr.restructured);
            return prev;
          },
          []
        ));
      }
    }
  };
  return [
    key,
    messageKey,
    showPolicies,
    validationRules,
    simplifiedFailures,
    callback,
    label,
    validationFailures
  ];
}
var Policies = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$u, create_fragment$t, safe_not_equal, {
      callback: 5,
      key: 0,
      label: 6,
      messageKey: 1,
      showPolicies: 2
    });
  }
};
function create_default_slot$g(ctx) {
  let policies_1;
  let current;
  policies_1 = new Policies({
    props: {
      callback: (
        /*callback*/
        ctx[0]
      ),
      key: (
        /*inputName*/
        ctx[3]
      ),
      label: (
        /*prompt*/
        ctx[2]
      ),
      messageKey: "valueRequirements"
    }
  });
  return {
    c() {
      create_component(policies_1.$$.fragment);
    },
    m(target, anchor) {
      mount_component(policies_1, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const policies_1_changes = {};
      if (dirty & /*callback*/
      1) policies_1_changes.callback = /*callback*/
      ctx2[0];
      if (dirty & /*inputName*/
      8) policies_1_changes.key = /*inputName*/
      ctx2[3];
      if (dirty & /*prompt*/
      4) policies_1_changes.label = /*prompt*/
      ctx2[2];
      policies_1.$set(policies_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(policies_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(policies_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(policies_1, detaching);
    }
  };
}
function create_key_block$2(ctx) {
  var _a;
  let input;
  let current;
  input = new /*Input*/
  ctx[9]({
    props: {
      isFirstInvalidInput: (
        /*callbackMetadata*/
        ((_a = ctx[1]) == null ? void 0 : _a.derived.isFirstInvalidInput) || false
      ),
      key: (
        /*inputName*/
        ctx[3]
      ),
      label: interpolate(
        /*outputName*/
        ctx[5],
        null,
        /*prompt*/
        ctx[2]
      ),
      message: (
        /*isRequired*/
        ctx[4] ? interpolate("inputRequiredError") : void 0
      ),
      onChange: (
        /*setValue*/
        ctx[10]
      ),
      isRequired: (
        /*isRequired*/
        ctx[4]
      ),
      isInvalid: (
        /*isInvalid*/
        ctx[8]
      ),
      type: (
        /*type*/
        ctx[7]
      ),
      showMessage: !!/*isInvalid*/
      ctx[8],
      value: (
        /*previousValue*/
        ctx[6]
      ),
      $$slots: { default: [create_default_slot$g] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(input.$$.fragment);
    },
    m(target, anchor) {
      mount_component(input, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      const input_changes = {};
      if (dirty & /*callbackMetadata*/
      2) input_changes.isFirstInvalidInput = /*callbackMetadata*/
      ((_a2 = ctx2[1]) == null ? void 0 : _a2.derived.isFirstInvalidInput) || false;
      if (dirty & /*inputName*/
      8) input_changes.key = /*inputName*/
      ctx2[3];
      if (dirty & /*outputName, prompt*/
      36) input_changes.label = interpolate(
        /*outputName*/
        ctx2[5],
        null,
        /*prompt*/
        ctx2[2]
      );
      if (dirty & /*isRequired*/
      16) input_changes.message = /*isRequired*/
      ctx2[4] ? interpolate("inputRequiredError") : void 0;
      if (dirty & /*isRequired*/
      16) input_changes.isRequired = /*isRequired*/
      ctx2[4];
      if (dirty & /*isInvalid*/
      256) input_changes.isInvalid = /*isInvalid*/
      ctx2[8];
      if (dirty & /*type*/
      128) input_changes.type = /*type*/
      ctx2[7];
      if (dirty & /*isInvalid*/
      256) input_changes.showMessage = !!/*isInvalid*/
      ctx2[8];
      if (dirty & /*previousValue*/
      64) input_changes.value = /*previousValue*/
      ctx2[6];
      if (dirty & /*$$scope, callback, inputName, prompt*/
      65549) {
        input_changes.$$scope = { dirty, ctx: ctx2 };
      }
      input.$set(input_changes);
    },
    i(local) {
      if (current) return;
      transition_in(input.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(input.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(input, detaching);
    }
  };
}
function create_fragment$s(ctx) {
  let previous_key = (
    /*callback*/
    ctx[0]
  );
  let key_block_anchor;
  let current;
  let key_block = create_key_block$2(ctx);
  return {
    c() {
      key_block.c();
      key_block_anchor = empty();
    },
    m(target, anchor) {
      key_block.m(target, anchor);
      insert(target, key_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (dirty & /*callback*/
      1 && safe_not_equal(previous_key, previous_key = /*callback*/
      ctx2[0])) {
        group_outros();
        transition_out(key_block, 1, 1, noop);
        check_outros();
        key_block = create_key_block$2(ctx2);
        key_block.c();
        transition_in(key_block, 1);
        key_block.m(key_block_anchor.parentNode, key_block_anchor);
      } else {
        key_block.p(ctx2, dirty);
      }
    },
    i(local) {
      if (current) return;
      transition_in(key_block);
      current = true;
    },
    o(local) {
      transition_out(key_block);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(key_block_anchor);
      key_block.d(detaching);
    }
  };
}
function instance$t($$self, $$props, $$invalidate) {
  const selfSubmitFunction = null;
  const stepMetadata = null;
  let { callback } = $$props;
  let { callbackMetadata } = $$props;
  let { style = {} } = $$props;
  const Input2 = style.labels === "stacked" ? Stacked_label2 : Floating_label2;
  let inputName;
  let isRequired;
  let outputName;
  let policies;
  let previousValue;
  let prompt;
  let type;
  let validationFailures;
  let isInvalid;
  function setValue(event) {
    callback.setInputValue(event.target.value);
  }
  $$self.$$set = ($$props2) => {
    if ("callback" in $$props2) $$invalidate(0, callback = $$props2.callback);
    if ("callbackMetadata" in $$props2) $$invalidate(1, callbackMetadata = $$props2.callbackMetadata);
    if ("style" in $$props2) $$invalidate(13, style = $$props2.style);
  };
  $$self.$$.update = () => {
    var _a, _b;
    if ($$self.$$.dirty & /*callback, callbackMetadata, policies, prompt, validationFailures*/
    49159) {
      {
        $$invalidate(3, inputName = ((_b = (_a = callback == null ? void 0 : callback.payload) == null ? void 0 : _a.input) == null ? void 0 : _b[0].name) || `password-${callbackMetadata == null ? void 0 : callbackMetadata.idx}`);
        $$invalidate(4, isRequired = isInputRequired(callback));
        $$invalidate(5, outputName = callback.getOutputByName("name", ""));
        $$invalidate(14, policies = callback.getPolicies());
        $$invalidate(6, previousValue = callback == null ? void 0 : callback.getInputValue());
        $$invalidate(2, prompt = callback.getPrompt());
        $$invalidate(7, type = getInputTypeFromPolicies(policies));
        $$invalidate(15, validationFailures = getValidationFailures(callback, prompt));
        $$invalidate(8, isInvalid = !!validationFailures.length);
      }
    }
  };
  return [
    callback,
    callbackMetadata,
    prompt,
    inputName,
    isRequired,
    outputName,
    previousValue,
    type,
    isInvalid,
    Input2,
    setValue,
    selfSubmitFunction,
    stepMetadata,
    style,
    policies,
    validationFailures
  ];
}
var String_attribute_input = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$t, create_fragment$s, safe_not_equal, {
      selfSubmitFunction: 11,
      stepMetadata: 12,
      callback: 0,
      callbackMetadata: 1,
      style: 13
    });
  }
  get selfSubmitFunction() {
    return this.$$.ctx[11];
  }
  get stepMetadata() {
    return this.$$.ctx[12];
  }
};
function create_fragment$r(ctx) {
  let a5;
  let a_class_value;
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[4].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[3],
    null
  );
  return {
    c() {
      a5 = element("a");
      if (default_slot) default_slot.c();
      attr(a5, "class", a_class_value = `${/*classes*/
      ctx[0]} tw_link dark:tw_link_dark`);
      attr(
        a5,
        "href",
        /*href*/
        ctx[1]
      );
      attr(
        a5,
        "target",
        /*target*/
        ctx[2]
      );
    },
    m(target, anchor) {
      insert(target, a5, anchor);
      if (default_slot) {
        default_slot.m(a5, null);
      }
      current = true;
    },
    p(ctx2, [dirty]) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        8)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[3],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[3]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[3],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (!current || dirty & /*classes*/
      1 && a_class_value !== (a_class_value = `${/*classes*/
      ctx2[0]} tw_link dark:tw_link_dark`)) {
        attr(a5, "class", a_class_value);
      }
      if (!current || dirty & /*href*/
      2) {
        attr(
          a5,
          "href",
          /*href*/
          ctx2[1]
        );
      }
      if (!current || dirty & /*target*/
      4) {
        attr(
          a5,
          "target",
          /*target*/
          ctx2[2]
        );
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(a5);
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function instance$s($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { classes = "" } = $$props;
  let { href } = $$props;
  let { target = "_self" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("classes" in $$props2) $$invalidate(0, classes = $$props2.classes);
    if ("href" in $$props2) $$invalidate(1, href = $$props2.href);
    if ("target" in $$props2) $$invalidate(2, target = $$props2.target);
    if ("$$scope" in $$props2) $$invalidate(3, $$scope = $$props2.$$scope);
  };
  return [classes, href, target, $$scope, slots];
}
var Link = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$s, create_fragment$r, safe_not_equal, { classes: 0, href: 1, target: 2 });
  }
};
function create_else_block$5(ctx) {
  let p4;
  return {
    c() {
      p4 = element("p");
      p4.innerHTML = `Error: Configuration is missing <code>termsAndConditions</code> URL.`;
      attr(p4, "class", "tw_text-error-dark dark:tw_text-error-light tw_input-spacing");
    },
    m(target, anchor) {
      insert(target, p4, anchor);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching) detach(p4);
    }
  };
}
function create_if_block$f(ctx) {
  var _a, _b;
  let link;
  let t3;
  let checkbox;
  let current;
  link = new Link({
    props: {
      classes: "tw_block tw_mb-4",
      href: (
        /*$linksStore*/
        (_a = ctx[2]) == null ? void 0 : _a.termsAndConditions
      ),
      target: "_blank",
      $$slots: { default: [create_default_slot_1$a] },
      $$scope: { ctx }
    }
  });
  checkbox = new /*Checkbox*/
  ctx[3]({
    props: {
      isFirstInvalidInput: (
        /*callbackMetadata*/
        ((_b = ctx[0]) == null ? void 0 : _b.derived.isFirstInvalidInput) || false
      ),
      key: (
        /*inputName*/
        ctx[1]
      ),
      onChange: (
        /*setValue*/
        ctx[4]
      ),
      value: false,
      $$slots: { default: [create_default_slot$f] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(link.$$.fragment);
      t3 = space();
      create_component(checkbox.$$.fragment);
    },
    m(target, anchor) {
      mount_component(link, target, anchor);
      insert(target, t3, anchor);
      mount_component(checkbox, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2, _b2;
      const link_changes = {};
      if (dirty & /*$linksStore*/
      4) link_changes.href = /*$linksStore*/
      (_a2 = ctx2[2]) == null ? void 0 : _a2.termsAndConditions;
      if (dirty & /*$$scope*/
      512) {
        link_changes.$$scope = { dirty, ctx: ctx2 };
      }
      link.$set(link_changes);
      const checkbox_changes = {};
      if (dirty & /*callbackMetadata*/
      1) checkbox_changes.isFirstInvalidInput = /*callbackMetadata*/
      ((_b2 = ctx2[0]) == null ? void 0 : _b2.derived.isFirstInvalidInput) || false;
      if (dirty & /*inputName*/
      2) checkbox_changes.key = /*inputName*/
      ctx2[1];
      if (dirty & /*$$scope*/
      512) {
        checkbox_changes.$$scope = { dirty, ctx: ctx2 };
      }
      checkbox.$set(checkbox_changes);
    },
    i(local) {
      if (current) return;
      transition_in(link.$$.fragment, local);
      transition_in(checkbox.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(link.$$.fragment, local);
      transition_out(checkbox.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(link, detaching);
      if (detaching) detach(t3);
      destroy_component(checkbox, detaching);
    }
  };
}
function create_default_slot_1$a(ctx) {
  let t_value = interpolate("termsAndConditionsLinkText") + "";
  let t3;
  return {
    c() {
      t3 = text(t_value);
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    p: noop,
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_default_slot$f(ctx) {
  let t3;
  let current;
  t3 = new Locale_strings({ props: { key: "termsAndConditions" } });
  return {
    c() {
      create_component(t3.$$.fragment);
    },
    m(target, anchor) {
      mount_component(t3, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(t3, detaching);
    }
  };
}
function create_fragment$q(ctx) {
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block$f, create_else_block$5];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    var _a;
    if (
      /*$linksStore*/
      (_a = ctx2[2]) == null ? void 0 : _a.termsAndConditions
    ) return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(if_block_anchor.parentNode, if_block_anchor);
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if_blocks[current_block_type_index].d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function instance$r($$self, $$props, $$invalidate) {
  let $linksStore;
  component_subscribe($$self, linksStore, ($$value) => $$invalidate(2, $linksStore = $$value));
  const selfSubmitFunction = null;
  const stepMetadata = null;
  let { style = {} } = $$props;
  let { callback } = $$props;
  let { callbackMetadata } = $$props;
  const Checkbox2 = style.checksAndRadios === "standard" ? Standard$1 : Animated$1;
  let inputName;
  function setValue(event) {
    callback.setAccepted(event.target.checked);
  }
  $$self.$$set = ($$props2) => {
    if ("style" in $$props2) $$invalidate(7, style = $$props2.style);
    if ("callback" in $$props2) $$invalidate(8, callback = $$props2.callback);
    if ("callbackMetadata" in $$props2) $$invalidate(0, callbackMetadata = $$props2.callbackMetadata);
  };
  $$self.$$.update = () => {
    var _a, _b;
    if ($$self.$$.dirty & /*callback, callbackMetadata*/
    257) {
      {
        $$invalidate(1, inputName = ((_b = (_a = callback == null ? void 0 : callback.payload) == null ? void 0 : _a.input) == null ? void 0 : _b[0].name) || `terms-${callbackMetadata == null ? void 0 : callbackMetadata.idx}`);
      }
    }
  };
  return [
    callbackMetadata,
    inputName,
    $linksStore,
    Checkbox2,
    setValue,
    selfSubmitFunction,
    stepMetadata,
    style,
    callback
  ];
}
var Terms_conditions = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$r, create_fragment$q, safe_not_equal, {
      selfSubmitFunction: 5,
      stepMetadata: 6,
      style: 7,
      callback: 8,
      callbackMetadata: 0
    });
  }
  get selfSubmitFunction() {
    return this.$$.ctx[5];
  }
  get stepMetadata() {
    return this.$$.ctx[6];
  }
};
function create_else_block$4(ctx) {
  let alert;
  let current;
  alert = new Alert({
    props: {
      id: "",
      needsFocus: false,
      type: (
        /*callbackMessageType*/
        ctx[1]
      ),
      $$slots: { default: [create_default_slot_1$9] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(alert.$$.fragment);
    },
    m(target, anchor) {
      mount_component(alert, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const alert_changes = {};
      if (dirty & /*callbackMessageType*/
      2) alert_changes.type = /*callbackMessageType*/
      ctx2[1];
      if (dirty & /*$$scope, cleanMessage*/
      257) {
        alert_changes.$$scope = { dirty, ctx: ctx2 };
      }
      alert.$set(alert_changes);
    },
    i(local) {
      if (current) return;
      transition_in(alert.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(alert.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(alert, detaching);
    }
  };
}
function create_if_block$e(ctx) {
  let text_1;
  let current;
  text_1 = new Text({
    props: {
      classes: (
        /*cleanMessage*/
        ctx[0].length < 100 ? "tw_font-bold tw_mt-6" : "tw_mt-6"
      ),
      $$slots: { default: [create_default_slot$e] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(text_1.$$.fragment);
    },
    m(target, anchor) {
      mount_component(text_1, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const text_1_changes = {};
      if (dirty & /*cleanMessage*/
      1) text_1_changes.classes = /*cleanMessage*/
      ctx2[0].length < 100 ? "tw_font-bold tw_mt-6" : "tw_mt-6";
      if (dirty & /*$$scope, cleanMessage*/
      257) {
        text_1_changes.$$scope = { dirty, ctx: ctx2 };
      }
      text_1.$set(text_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(text_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(text_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(text_1, detaching);
    }
  };
}
function create_default_slot_1$9(ctx) {
  let t3;
  return {
    c() {
      t3 = text(
        /*cleanMessage*/
        ctx[0]
      );
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*cleanMessage*/
      1) set_data(
        t3,
        /*cleanMessage*/
        ctx2[0]
      );
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_default_slot$e(ctx) {
  let html_tag;
  let html_anchor;
  return {
    c() {
      html_tag = new HtmlTag(false);
      html_anchor = empty();
      html_tag.a = html_anchor;
    },
    m(target, anchor) {
      html_tag.m(
        /*cleanMessage*/
        ctx[0],
        target,
        anchor
      );
      insert(target, html_anchor, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & /*cleanMessage*/
      1) html_tag.p(
        /*cleanMessage*/
        ctx2[0]
      );
    },
    d(detaching) {
      if (detaching) detach(html_anchor);
      if (detaching) html_tag.d();
    }
  };
}
function create_fragment$p(ctx) {
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block$e, create_else_block$4];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*callbackMessageType*/
      ctx2[1] === "info"
    ) return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(if_block_anchor.parentNode, if_block_anchor);
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if_blocks[current_block_type_index].d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function getCallbackMessage(messageType) {
  switch (messageType) {
    case "0":
      return "info";
    case "1":
      return "warning";
    case "2":
      return "error";
    default:
      return "info";
  }
}
function instance$q($$self, $$props, $$invalidate) {
  const callbackMetadata = null;
  const selfSubmitFunction = null;
  const stepMetadata = null;
  const style = {};
  let { callback } = $$props;
  let dirtyMessage = callback.getMessage();
  let cleanMessage = sanitize(dirtyMessage);
  let callbackMessageType = "info";
  $$self.$$set = ($$props2) => {
    if ("callback" in $$props2) $$invalidate(6, callback = $$props2.callback);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*callback, dirtyMessage*/
    192) {
      {
        $$invalidate(7, dirtyMessage = callback.getMessage());
        $$invalidate(0, cleanMessage = sanitize(dirtyMessage));
        $$invalidate(1, callbackMessageType = getCallbackMessage(callback.getMessageType()));
      }
    }
  };
  return [
    cleanMessage,
    callbackMessageType,
    callbackMetadata,
    selfSubmitFunction,
    stepMetadata,
    style,
    callback,
    dirtyMessage
  ];
}
var Text_output = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$q, create_fragment$p, safe_not_equal, {
      callbackMetadata: 2,
      selfSubmitFunction: 3,
      stepMetadata: 4,
      style: 5,
      callback: 6
    });
  }
  get callbackMetadata() {
    return this.$$.ctx[2];
  }
  get selfSubmitFunction() {
    return this.$$.ctx[3];
  }
  get stepMetadata() {
    return this.$$.ctx[4];
  }
  get style() {
    return this.$$.ctx[5];
  }
};
function create_fragment$o(ctx) {
  let p4;
  return {
    c() {
      p4 = element("p");
      p4.textContent = `Unknown callback encountered: ${/*type*/
      ctx[0]}. Please contact support.`;
      attr(p4, "class", "tw_text-base tw_text-secondary-dark dark:tw_text-secondary-light tw_input-spacing");
    },
    m(target, anchor) {
      insert(target, p4, anchor);
    },
    p: noop,
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching) detach(p4);
    }
  };
}
function instance$p($$self, $$props, $$invalidate) {
  const callbackMetadata = null;
  const selfSubmitFunction = null;
  const stepMetadata = null;
  const style = {};
  let { callback } = $$props;
  const type = callback.getType();
  $$self.$$set = ($$props2) => {
    if ("callback" in $$props2) $$invalidate(5, callback = $$props2.callback);
  };
  return [type, callbackMetadata, selfSubmitFunction, stepMetadata, style, callback];
}
var Unknown = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$p, create_fragment$o, safe_not_equal, {
      callbackMetadata: 1,
      selfSubmitFunction: 2,
      stepMetadata: 3,
      style: 4,
      callback: 5
    });
  }
  get callbackMetadata() {
    return this.$$.ctx[1];
  }
  get selfSubmitFunction() {
    return this.$$.ctx[2];
  }
  get stepMetadata() {
    return this.$$.ctx[3];
  }
  get style() {
    return this.$$.ctx[4];
  }
};
function create_default_slot$d(ctx) {
  let policies;
  let current;
  policies = new Policies({
    props: {
      callback: (
        /*callback*/
        ctx[0]
      ),
      label: (
        /*prompt*/
        ctx[3]
      ),
      messageKey: "passwordRequirements",
      showPolicies: true
    }
  });
  return {
    c() {
      create_component(policies.$$.fragment);
    },
    m(target, anchor) {
      mount_component(policies, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const policies_changes = {};
      if (dirty & /*callback*/
      1) policies_changes.callback = /*callback*/
      ctx2[0];
      if (dirty & /*prompt*/
      8) policies_changes.label = /*prompt*/
      ctx2[3];
      policies.$set(policies_changes);
    },
    i(local) {
      if (current) return;
      transition_in(policies.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(policies.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(policies, detaching);
    }
  };
}
function create_key_block$1(ctx) {
  let base;
  let current;
  base = new Base({
    props: {
      callback: (
        /*callback*/
        ctx[0]
      ),
      callbackMetadata: (
        /*callbackMetadata*/
        ctx[1]
      ),
      isInvalid: (
        /*isInvalid*/
        ctx[5]
      ),
      isRequired: (
        /*isRequired*/
        ctx[6]
      ),
      key: (
        /*inputName*/
        ctx[4]
      ),
      showMessage: (
        /*isInvalid*/
        ctx[5]
      ),
      style: (
        /*style*/
        ctx[2]
      ),
      $$slots: { default: [create_default_slot$d] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(base.$$.fragment);
    },
    m(target, anchor) {
      mount_component(base, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const base_changes = {};
      if (dirty & /*callback*/
      1) base_changes.callback = /*callback*/
      ctx2[0];
      if (dirty & /*callbackMetadata*/
      2) base_changes.callbackMetadata = /*callbackMetadata*/
      ctx2[1];
      if (dirty & /*isInvalid*/
      32) base_changes.isInvalid = /*isInvalid*/
      ctx2[5];
      if (dirty & /*inputName*/
      16) base_changes.key = /*inputName*/
      ctx2[4];
      if (dirty & /*isInvalid*/
      32) base_changes.showMessage = /*isInvalid*/
      ctx2[5];
      if (dirty & /*style*/
      4) base_changes.style = /*style*/
      ctx2[2];
      if (dirty & /*$$scope, callback, prompt*/
      1033) {
        base_changes.$$scope = { dirty, ctx: ctx2 };
      }
      base.$set(base_changes);
    },
    i(local) {
      if (current) return;
      transition_in(base.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(base.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(base, detaching);
    }
  };
}
function create_fragment$n(ctx) {
  let previous_key = (
    /*callback*/
    ctx[0]
  );
  let key_block_anchor;
  let current;
  let key_block = create_key_block$1(ctx);
  return {
    c() {
      key_block.c();
      key_block_anchor = empty();
    },
    m(target, anchor) {
      key_block.m(target, anchor);
      insert(target, key_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (dirty & /*callback*/
      1 && safe_not_equal(previous_key, previous_key = /*callback*/
      ctx2[0])) {
        group_outros();
        transition_out(key_block, 1, 1, noop);
        check_outros();
        key_block = create_key_block$1(ctx2);
        key_block.c();
        transition_in(key_block, 1);
        key_block.m(key_block_anchor.parentNode, key_block_anchor);
      } else {
        key_block.p(ctx2, dirty);
      }
    },
    i(local) {
      if (current) return;
      transition_in(key_block);
      current = true;
    },
    o(local) {
      transition_out(key_block);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(key_block_anchor);
      key_block.d(detaching);
    }
  };
}
function instance$o($$self, $$props, $$invalidate) {
  const selfSubmitFunction = null;
  const stepMetadata = null;
  let { callback } = $$props;
  let { callbackMetadata } = $$props;
  let { style = {} } = $$props;
  const isRequired = isInputRequired(callback);
  let inputName;
  let isInvalid;
  let prompt;
  let validationFailures;
  $$self.$$set = ($$props2) => {
    if ("callback" in $$props2) $$invalidate(0, callback = $$props2.callback);
    if ("callbackMetadata" in $$props2) $$invalidate(1, callbackMetadata = $$props2.callbackMetadata);
    if ("style" in $$props2) $$invalidate(2, style = $$props2.style);
  };
  $$self.$$.update = () => {
    var _a, _b;
    if ($$self.$$.dirty & /*callback, callbackMetadata, prompt, validationFailures*/
    523) {
      {
        $$invalidate(4, inputName = ((_b = (_a = callback == null ? void 0 : callback.payload) == null ? void 0 : _a.input) == null ? void 0 : _b[0].name) || `password-${callbackMetadata == null ? void 0 : callbackMetadata.idx}`);
        $$invalidate(3, prompt = callback.getPrompt());
        $$invalidate(9, validationFailures = getValidationFailures(callback, prompt));
        $$invalidate(5, isInvalid = !!validationFailures.length);
      }
    }
  };
  return [
    callback,
    callbackMetadata,
    style,
    prompt,
    inputName,
    isInvalid,
    isRequired,
    selfSubmitFunction,
    stepMetadata,
    validationFailures
  ];
}
var Validated_create_password = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$o, create_fragment$n, safe_not_equal, {
      selfSubmitFunction: 7,
      stepMetadata: 8,
      callback: 0,
      callbackMetadata: 1,
      style: 2
    });
  }
  get selfSubmitFunction() {
    return this.$$.ctx[7];
  }
  get stepMetadata() {
    return this.$$.ctx[8];
  }
};
function create_default_slot$c(ctx) {
  let policies;
  let current;
  policies = new Policies({
    props: {
      callback: (
        /*callback*/
        ctx[0]
      ),
      key: (
        /*inputName*/
        ctx[4]
      ),
      label: (
        /*prompt*/
        ctx[2]
      ),
      messageKey: "usernameRequirements"
    }
  });
  return {
    c() {
      create_component(policies.$$.fragment);
    },
    m(target, anchor) {
      mount_component(policies, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const policies_changes = {};
      if (dirty & /*callback*/
      1) policies_changes.callback = /*callback*/
      ctx2[0];
      if (dirty & /*inputName*/
      16) policies_changes.key = /*inputName*/
      ctx2[4];
      if (dirty & /*prompt*/
      4) policies_changes.label = /*prompt*/
      ctx2[2];
      policies.$set(policies_changes);
    },
    i(local) {
      if (current) return;
      transition_in(policies.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(policies.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(policies, detaching);
    }
  };
}
function create_key_block(ctx) {
  var _a;
  let input;
  let current;
  input = new /*Input*/
  ctx[8]({
    props: {
      isFirstInvalidInput: (
        /*callbackMetadata*/
        ((_a = ctx[1]) == null ? void 0 : _a.derived.isFirstInvalidInput) || false
      ),
      isRequired: (
        /*isRequired*/
        ctx[6]
      ),
      isInvalid: (
        /*isInvalid*/
        ctx[5]
      ),
      key: (
        /*inputName*/
        ctx[4]
      ),
      label: interpolate(
        textToKey(
          /*callbackType*/
          ctx[3]
        ),
        null,
        /*prompt*/
        ctx[2]
      ),
      message: (
        /*isRequired*/
        ctx[6] ? interpolate("inputRequiredError") : void 0
      ),
      onChange: (
        /*setValue*/
        ctx[9]
      ),
      showMessage: false,
      type: "text",
      value: typeof /*value*/
      ctx[7] === "string" ? (
        /*value*/
        ctx[7]
      ) : "",
      $$slots: { default: [create_default_slot$c] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(input.$$.fragment);
    },
    m(target, anchor) {
      mount_component(input, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      const input_changes = {};
      if (dirty & /*callbackMetadata*/
      2) input_changes.isFirstInvalidInput = /*callbackMetadata*/
      ((_a2 = ctx2[1]) == null ? void 0 : _a2.derived.isFirstInvalidInput) || false;
      if (dirty & /*isRequired*/
      64) input_changes.isRequired = /*isRequired*/
      ctx2[6];
      if (dirty & /*isInvalid*/
      32) input_changes.isInvalid = /*isInvalid*/
      ctx2[5];
      if (dirty & /*inputName*/
      16) input_changes.key = /*inputName*/
      ctx2[4];
      if (dirty & /*callbackType, prompt*/
      12) input_changes.label = interpolate(
        textToKey(
          /*callbackType*/
          ctx2[3]
        ),
        null,
        /*prompt*/
        ctx2[2]
      );
      if (dirty & /*isRequired*/
      64) input_changes.message = /*isRequired*/
      ctx2[6] ? interpolate("inputRequiredError") : void 0;
      if (dirty & /*value*/
      128) input_changes.value = typeof /*value*/
      ctx2[7] === "string" ? (
        /*value*/
        ctx2[7]
      ) : "";
      if (dirty & /*$$scope, callback, inputName, prompt*/
      16405) {
        input_changes.$$scope = { dirty, ctx: ctx2 };
      }
      input.$set(input_changes);
    },
    i(local) {
      if (current) return;
      transition_in(input.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(input.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(input, detaching);
    }
  };
}
function create_fragment$m(ctx) {
  let previous_key = (
    /*callback*/
    ctx[0]
  );
  let key_block_anchor;
  let current;
  let key_block = create_key_block(ctx);
  return {
    c() {
      key_block.c();
      key_block_anchor = empty();
    },
    m(target, anchor) {
      key_block.m(target, anchor);
      insert(target, key_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (dirty & /*callback*/
      1 && safe_not_equal(previous_key, previous_key = /*callback*/
      ctx2[0])) {
        group_outros();
        transition_out(key_block, 1, 1, noop);
        check_outros();
        key_block = create_key_block(ctx2);
        key_block.c();
        transition_in(key_block, 1);
        key_block.m(key_block_anchor.parentNode, key_block_anchor);
      } else {
        key_block.p(ctx2, dirty);
      }
    },
    i(local) {
      if (current) return;
      transition_in(key_block);
      current = true;
    },
    o(local) {
      transition_out(key_block);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(key_block_anchor);
      key_block.d(detaching);
    }
  };
}
function instance$n($$self, $$props, $$invalidate) {
  const selfSubmitFunction = null;
  const stepMetadata = null;
  let { callback } = $$props;
  let { callbackMetadata } = $$props;
  let { style = {} } = $$props;
  const Input2 = style.labels === "stacked" ? Stacked_label2 : Floating_label2;
  let callbackType;
  let inputName;
  let isInvalid;
  let isRequired;
  let prompt;
  let value;
  let validationFailures;
  function setValue(event) {
    callback.setInputValue(event.target.value);
  }
  $$self.$$set = ($$props2) => {
    if ("callback" in $$props2) $$invalidate(0, callback = $$props2.callback);
    if ("callbackMetadata" in $$props2) $$invalidate(1, callbackMetadata = $$props2.callbackMetadata);
    if ("style" in $$props2) $$invalidate(12, style = $$props2.style);
  };
  $$self.$$.update = () => {
    var _a, _b;
    if ($$self.$$.dirty & /*callback, callbackMetadata, prompt, validationFailures*/
    8199) {
      {
        $$invalidate(3, callbackType = callback.getType());
        $$invalidate(4, inputName = ((_b = (_a = callback == null ? void 0 : callback.payload) == null ? void 0 : _a.input) == null ? void 0 : _b[0].name) || `validated-name=${callbackMetadata == null ? void 0 : callbackMetadata.idx}`);
        $$invalidate(6, isRequired = isInputRequired(callback));
        $$invalidate(2, prompt = callback.getPrompt());
        $$invalidate(7, value = callback == null ? void 0 : callback.getInputValue());
        $$invalidate(13, validationFailures = getValidationFailures(callback, prompt));
        $$invalidate(5, isInvalid = !!validationFailures.length);
      }
    }
  };
  return [
    callback,
    callbackMetadata,
    prompt,
    callbackType,
    inputName,
    isInvalid,
    isRequired,
    value,
    Input2,
    setValue,
    selfSubmitFunction,
    stepMetadata,
    style,
    validationFailures
  ];
}
var Validated_create_username = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$n, create_fragment$m, safe_not_equal, {
      selfSubmitFunction: 10,
      stepMetadata: 11,
      callback: 0,
      callbackMetadata: 1,
      style: 12
    });
  }
  get selfSubmitFunction() {
    return this.$$.ctx[10];
  }
  get stepMetadata() {
    return this.$$.ctx[11];
  }
};
function create_if_block$d(ctx) {
  let div;
  let spinner;
  let t3;
  let text_1;
  let current;
  spinner = new Spinner({
    props: {
      colorClass: "tw_text-primary-light",
      layoutClasses: "tw_h-24 tw_mb-6 tw_w-24"
    }
  });
  text_1 = new Text({
    props: {
      $$slots: { default: [create_default_slot$b] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      div = element("div");
      create_component(spinner.$$.fragment);
      t3 = space();
      create_component(text_1.$$.fragment);
      attr(div, "class", "tw_text-center tw_w-full tw_py-4");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(spinner, div, null);
      append(div, t3);
      mount_component(text_1, div, null);
      current = true;
    },
    p(ctx2, dirty) {
      const text_1_changes = {};
      if (dirty & /*$$scope*/
      128) {
        text_1_changes.$$scope = { dirty, ctx: ctx2 };
      }
      text_1.$set(text_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(spinner.$$.fragment, local);
      transition_in(text_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(spinner.$$.fragment, local);
      transition_out(text_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(spinner);
      destroy_component(text_1);
    }
  };
}
function create_default_slot$b(ctx) {
  let t3;
  return {
    c() {
      t3 = text(
        /*deviceMessage*/
        ctx[1]
      );
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    p: noop,
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_fragment$l(ctx) {
  var _a;
  let if_block_anchor;
  let current;
  let if_block = (
    /*stepMetadata*/
    ((_a = ctx[0]) == null ? void 0 : _a.derived.numOfCallbacks) === 1 && create_if_block$d(ctx)
  );
  return {
    c() {
      if (if_block) if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      var _a2;
      if (
        /*stepMetadata*/
        ((_a2 = ctx2[0]) == null ? void 0 : _a2.derived.numOfCallbacks) === 1
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
          if (dirty & /*stepMetadata*/
          1) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$d(ctx2);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (if_block) if_block.d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function instance$m($$self, $$props, $$invalidate) {
  let { callback } = $$props;
  let { callbackMetadata = null } = $$props;
  let { stepMetadata = null } = $$props;
  let { selfSubmitFunction } = $$props;
  const device = new O$1({});
  let deviceMessage = callback.getMessage();
  async function initializeProfile() {
    var _a, _b;
    const location2 = (_a = callback == null ? void 0 : callback.isLocationRequired()) != null ? _a : false;
    const metadata = (_b = callback == null ? void 0 : callback.isMetadataRequired()) != null ? _b : false;
    const profile = await device.getProfile({ location: location2, metadata });
    callback.setProfile(profile);
    if (callbackMetadata) {
      $$invalidate(2, callbackMetadata.derived.isReadyForSubmission = true, callbackMetadata);
    }
    return selfSubmitFunction && selfSubmitFunction();
  }
  initializeProfile();
  $$self.$$set = ($$props2) => {
    if ("callback" in $$props2) $$invalidate(3, callback = $$props2.callback);
    if ("callbackMetadata" in $$props2) $$invalidate(2, callbackMetadata = $$props2.callbackMetadata);
    if ("stepMetadata" in $$props2) $$invalidate(0, stepMetadata = $$props2.stepMetadata);
    if ("selfSubmitFunction" in $$props2) $$invalidate(4, selfSubmitFunction = $$props2.selfSubmitFunction);
  };
  return [stepMetadata, deviceMessage, callbackMetadata, callback, selfSubmitFunction];
}
var Device_profile = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$m, create_fragment$l, safe_not_equal, {
      callback: 3,
      callbackMetadata: 2,
      stepMetadata: 0,
      selfSubmitFunction: 4
    });
  }
};
function checkForHCaptcha(captchaClassname) {
  return captchaClassname.match("h-captcha");
}
function renderCaptcha({ nameOfCaptcha, siteKey }) {
  if (nameOfCaptcha === "hcaptcha" && window.hcaptcha) {
    return window.hcaptcha.render("fr-recaptcha", {
      sitekey: siteKey,
      callback: "frHandleCaptcha",
      "expired-callback": "frHandleExpiredCallback",
      "chalexpired-callback": "frHandleExpiredCallback",
      "error-callback": "frHandleErrorCallback"
    });
  }
  if (nameOfCaptcha === "grecaptcha" && window.grecaptcha) {
    return window.grecaptcha.render("fr-recaptcha", {
      sitekey: siteKey,
      callback: window.frHandleCaptcha,
      "expired-callback": window.frHandleExpiredCallback
    });
  }
}
function handleCaptchaError(callback) {
  var _a, _b;
  const siteKey = (_a = callback == null ? void 0 : callback.getSiteKey()) != null ? _a : "";
  const className = (_b = callback == null ? void 0 : callback.getOutputByName("captchaDivClass", "h-captcha")) != null ? _b : "h-captcha";
  if (checkForHCaptcha(className)) {
    return () => renderCaptcha({ nameOfCaptcha: "hcaptcha", siteKey });
  } else {
    return () => renderCaptcha({ nameOfCaptcha: "grecaptcha", siteKey });
  }
}
function handleCaptchaToken(callback) {
  return (token) => {
    callback == null ? void 0 : callback.setResult(token);
  };
}
function create_if_block$c(ctx) {
  let div;
  return {
    c() {
      div = element("div");
      attr(div, "id", "fr-recaptcha");
      attr(div, "class", `${/*recaptchaClass*/
      ctx[2]} tw_flex-1 tw_w-full tw_input-spacing`);
      attr(
        div,
        "data-sitekey",
        /*siteKey*/
        ctx[0]
      );
      attr(div, "data-expired-callback", "frHandleExpiredCallback");
      attr(div, "data-chalexpired-callback", "frHandleExpiredCallback");
      attr(div, "data-error-callback", "frHandleErrorCallback");
      attr(div, "data-callback", "frHandleCaptcha");
    },
    m(target, anchor) {
      insert(target, div, anchor);
    },
    p: noop,
    d(detaching) {
      if (detaching) detach(div);
    }
  };
}
function create_fragment$k(ctx) {
  let if_block_anchor;
  let if_block = (
    /*isV3*/
    ctx[1] === false && create_if_block$c(ctx)
  );
  return {
    c() {
      if (if_block) if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx2, [dirty]) {
      if (
        /*isV3*/
        ctx2[1] === false
      ) if_block.p(ctx2, dirty);
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (if_block) if_block.d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function instance$l($$self, $$props, $$invalidate) {
  var _a, _b;
  let { callback } = $$props;
  const selfSubmitFunction = null;
  const stepMetadata = null;
  const style = {};
  let recaptchaAction = "";
  const siteKey = (_a = callback == null ? void 0 : callback.getSiteKey()) != null ? _a : "";
  let isV3 = callback == null ? void 0 : callback.getOutputByName("reCaptchaV3", false);
  const recaptchaClass = (_b = callback == null ? void 0 : callback.getOutputByName("captchaDivClass", "h-captcha")) != null ? _b : "h-captcha";
  onMount(() => {
    if (isV3) {
      return;
    }
    if (callback) {
      window.frHandleCaptchaError = handleCaptchaError(callback);
      window.frHandleCaptcha = handleCaptchaToken(callback);
      window.frHandleExpiredCallback = function handleExpiredCallback() {
        callback == null ? void 0 : callback.setResult("");
        renderCaptcha({ nameOfCaptcha: "hcaptcha", siteKey });
      };
      renderCaptcha({
        nameOfCaptcha: recaptchaClass === "g-recaptcha" ? "grecaptcha" : "hcaptcha",
        siteKey
      });
    }
  });
  function executeV3Captcha() {
    if (isV3 && recaptchaAction.length) {
      try {
        window.grecaptcha.ready(async function() {
          const value = await window.grecaptcha.execute(siteKey, { action: recaptchaAction });
          callback == null ? void 0 : callback.setResult(value);
        });
      } catch (err) {
        throw new Error(`Error executing recaptcha. Please make sure you have passed a siteKey and you have loaded the google recaptcha script in your app prior to this Error: ${err}`);
      }
    }
  }
  journeyStore.subscribe((value) => {
    var _a2;
    $$invalidate(7, recaptchaAction = (_a2 = value == null ? void 0 : value.recaptchaAction) != null ? _a2 : "");
  });
  $$self.$$set = ($$props2) => {
    if ("callback" in $$props2) $$invalidate(3, callback = $$props2.callback);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*recaptchaAction*/
    128) {
      {
        if (recaptchaAction.length) {
          executeV3Captcha();
        }
      }
    }
  };
  return [
    siteKey,
    isV3,
    recaptchaClass,
    callback,
    selfSubmitFunction,
    stepMetadata,
    style,
    recaptchaAction
  ];
}
var Recaptcha = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$l, create_fragment$k, safe_not_equal, {
      callback: 3,
      selfSubmitFunction: 4,
      stepMetadata: 5,
      style: 6
    });
  }
  get selfSubmitFunction() {
    return this.$$.ctx[4];
  }
  get stepMetadata() {
    return this.$$.ctx[5];
  }
  get style() {
    return this.$$.ctx[6];
  }
};
function instance$k($$self, $$props, $$invalidate) {
  const callback = null;
  const callbackMetadata = null;
  const selfSubmitFunction = null;
  const stepMetadata = null;
  const style = {};
  return [callback, callbackMetadata, selfSubmitFunction, stepMetadata, style];
}
var Metadata = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$k, null, safe_not_equal, {
      callback: 0,
      callbackMetadata: 1,
      selfSubmitFunction: 2,
      stepMetadata: 3,
      style: 4
    });
  }
  get callback() {
    return this.$$.ctx[0];
  }
  get callbackMetadata() {
    return this.$$.ctx[1];
  }
  get selfSubmitFunction() {
    return this.$$.ctx[2];
  }
  get stepMetadata() {
    return this.$$.ctx[3];
  }
  get style() {
    return this.$$.ctx[4];
  }
};
function create_default_slot$a(ctx) {
  let p4;
  let t3;
  let current;
  t3 = new Locale_strings({ props: { key: "signalsEvaluation" } });
  return {
    c() {
      p4 = element("p");
      create_component(t3.$$.fragment);
    },
    m(target, anchor) {
      insert(target, p4, anchor);
      mount_component(t3, p4, null);
      current = true;
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(p4);
      destroy_component(t3);
    }
  };
}
function create_fragment$j(ctx) {
  let div;
  let spinner;
  let current;
  spinner = new Spinner({
    props: {
      colorClass: "tw_text-primary-light",
      layoutClasses: "tw_h-24 tw_mb-6 tw_w-24",
      $$slots: { default: [create_default_slot$a] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      div = element("div");
      create_component(spinner.$$.fragment);
      attr(div, "class", "tw_text-center tw_w-full tw_py-4");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(spinner, div, null);
      current = true;
    },
    p(ctx2, [dirty]) {
      const spinner_changes = {};
      if (dirty & /*$$scope*/
      16) {
        spinner_changes.$$scope = { dirty, ctx: ctx2 };
      }
      spinner.$set(spinner_changes);
    },
    i(local) {
      if (current) return;
      transition_in(spinner.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(spinner.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(spinner);
    }
  };
}
function instance$j($$self, $$props, $$invalidate) {
  let { callback } = $$props;
  let { selfSubmitFunction = null } = $$props;
  let { pingProtect = { envId: "" } } = $$props;
  let pauseBehavioralData = false;
  onMount(() => {
    async function handleGetData() {
      try {
        await e.getData();
      } catch (error) {
        if (error instanceof Error) {
          callback.setClientError(error.message);
        } else {
          callback.setClientError("An error occurred while initializing PingProtect");
        }
      }
      return selfSubmitFunction && selfSubmitFunction();
    }
    handleGetData();
  });
  $$self.$$set = ($$props2) => {
    if ("callback" in $$props2) $$invalidate(0, callback = $$props2.callback);
    if ("selfSubmitFunction" in $$props2) $$invalidate(1, selfSubmitFunction = $$props2.selfSubmitFunction);
    if ("pingProtect" in $$props2) $$invalidate(2, pingProtect = $$props2.pingProtect);
  };
  $$self.$$.update = () => {
    var _a;
    if ($$self.$$.dirty & /*pingProtect, pauseBehavioralData*/
    12) {
      {
        $$invalidate(3, pauseBehavioralData = (_a = pingProtect == null ? void 0 : pingProtect.behavioralDataCollection) != null ? _a : false);
        if (typeof window !== "undefined") {
          if (pauseBehavioralData === true) {
            e.pauseBehavioralData();
          } else {
            e.resumeBehavioralData();
          }
        }
      }
    }
  };
  return [callback, selfSubmitFunction, pingProtect, pauseBehavioralData];
}
var Ping_protect_evaluation = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$j, create_fragment$j, safe_not_equal, {
      callback: 0,
      selfSubmitFunction: 1,
      pingProtect: 2
    });
  }
};
function create_if_block$b(ctx) {
  let spinner;
  let current;
  spinner = new Spinner({
    props: {
      colorClass: "tw_text-primary-light",
      layoutClasses: "tw_h-24 tw_mb-6 tw_w-24"
    }
  });
  return {
    c() {
      create_component(spinner.$$.fragment);
    },
    m(target, anchor) {
      mount_component(spinner, target, anchor);
      current = true;
    },
    i(local) {
      if (current) return;
      transition_in(spinner.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(spinner.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(spinner, detaching);
    }
  };
}
function create_fragment$i(ctx) {
  let div;
  let current;
  let if_block = !/*loaded*/
  ctx[0] && create_if_block$b();
  return {
    c() {
      div = element("div");
      if (if_block) if_block.c();
    },
    m(target, anchor) {
      insert(target, div, anchor);
      if (if_block) if_block.m(div, null);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (!/*loaded*/
      ctx2[0]) {
        if (if_block) {
          if (dirty & /*loaded*/
          1) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$b();
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(div, null);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      if (if_block) if_block.d();
    }
  };
}
function instance$i($$self, $$props, $$invalidate) {
  const style = {};
  const stepMetadata = null;
  let { callback } = $$props;
  let { selfSubmitFunction = null } = $$props;
  let loaded = false;
  onMount(() => {
    async function loadingPingProtect() {
      const config = callback.getConfig();
      try {
        await e.start(config);
        $$invalidate(0, loaded = true);
      } catch (error) {
        if (error instanceof Error) {
          callback.setClientError(error.message);
        } else {
          callback.setClientError("An error occurred while initializing PingProtect");
        }
      }
      return selfSubmitFunction && selfSubmitFunction();
    }
    loadingPingProtect();
  });
  $$self.$$set = ($$props2) => {
    if ("callback" in $$props2) $$invalidate(3, callback = $$props2.callback);
    if ("selfSubmitFunction" in $$props2) $$invalidate(4, selfSubmitFunction = $$props2.selfSubmitFunction);
  };
  return [loaded, style, stepMetadata, callback, selfSubmitFunction];
}
var Ping_protect_initialize = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$i, create_fragment$i, safe_not_equal, {
      style: 1,
      stepMetadata: 2,
      callback: 3,
      selfSubmitFunction: 4
    });
  }
  get style() {
    return this.$$.ctx[1];
  }
  get stepMetadata() {
    return this.$$.ctx[2];
  }
};
function get_else_ctx(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_FRCallback*/
      child_ctx[23]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function get_if_ctx_20(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_PingProtectInitialize*/
      child_ctx[22]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function get_if_ctx_19(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_PingProtectEvaluation*/
      child_ctx[21]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function get_if_ctx_18(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_RecaptchaCallback*/
      child_ctx[20]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function get_if_ctx_17(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_MetadataCallback*/
      child_ctx[18]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function get_if_ctx_16(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_DeviceProfileCallback*/
      child_ctx[19]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function get_if_ctx_15(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_SuspendedTextOutputCallback*/
      child_ctx[17]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function get_if_ctx_14(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_TextOutputCallback*/
      child_ctx[16]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function get_if_ctx_13(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_TermsAndConditionsCallback*/
      child_ctx[15]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function get_if_ctx_12(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_ValidatedCreateUsernameCallback*/
      child_ctx[14]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function get_if_ctx_11(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_ValidatedCreatePasswordCallback*/
      child_ctx[13]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function get_if_ctx_10(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_StringAttributeInputCallback*/
      child_ctx[12]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function get_if_ctx_9(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_SelectIdPCallback*/
      child_ctx[11]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function get_if_ctx_8(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_RedirectCallback*/
      child_ctx[10]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function get_if_ctx_7(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_PollingWaitCallback*/
      child_ctx[9]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function get_if_ctx_6(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_PasswordCallback*/
      child_ctx[8]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function get_if_ctx_5(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_NameCallback*/
      child_ctx[7]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function get_if_ctx_4(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_KbaCreateCallback*/
      child_ctx[6]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function get_if_ctx_3(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_HiddenValueCallback*/
      child_ctx[5]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function get_if_ctx_2(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_ConfirmationCallback*/
      child_ctx[4]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function get_if_ctx_1(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_ChoiceCallback*/
      child_ctx[3]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function get_if_ctx$1(ctx) {
  const child_ctx = ctx.slice();
  const constants_0 = __spreadProps(__spreadValues(
    {},
    /*props*/
    child_ctx[0]
  ), {
    callback: (
      /*_BooleanAttributeInputCallback*/
      child_ctx[2]
    )
  });
  child_ctx[24] = constants_0;
  return child_ctx;
}
function create_else_block$3(ctx) {
  let unknown;
  let current;
  const unknown_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let unknown_props = {};
  for (let i9 = 0; i9 < unknown_spread_levels.length; i9 += 1) {
    unknown_props = assign(unknown_props, unknown_spread_levels[i9]);
  }
  unknown = new Unknown({ props: unknown_props });
  return {
    c() {
      create_component(unknown.$$.fragment);
    },
    m(target, anchor) {
      mount_component(unknown, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const unknown_changes = dirty & /*props, _FRCallback*/
      8388609 ? get_spread_update(unknown_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      unknown.$set(unknown_changes);
    },
    i(local) {
      if (current) return;
      transition_in(unknown.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(unknown.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(unknown, detaching);
    }
  };
}
function create_if_block_20(ctx) {
  let pingprotectinitialize;
  let current;
  const pingprotectinitialize_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let pingprotectinitialize_props = {};
  for (let i9 = 0; i9 < pingprotectinitialize_spread_levels.length; i9 += 1) {
    pingprotectinitialize_props = assign(pingprotectinitialize_props, pingprotectinitialize_spread_levels[i9]);
  }
  pingprotectinitialize = new Ping_protect_initialize({ props: pingprotectinitialize_props });
  return {
    c() {
      create_component(pingprotectinitialize.$$.fragment);
    },
    m(target, anchor) {
      mount_component(pingprotectinitialize, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const pingprotectinitialize_changes = dirty & /*props, _PingProtectInitialize*/
      4194305 ? get_spread_update(pingprotectinitialize_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      pingprotectinitialize.$set(pingprotectinitialize_changes);
    },
    i(local) {
      if (current) return;
      transition_in(pingprotectinitialize.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(pingprotectinitialize.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(pingprotectinitialize, detaching);
    }
  };
}
function create_if_block_19(ctx) {
  let pingprotectevaluation;
  let current;
  const pingprotectevaluation_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let pingprotectevaluation_props = {};
  for (let i9 = 0; i9 < pingprotectevaluation_spread_levels.length; i9 += 1) {
    pingprotectevaluation_props = assign(pingprotectevaluation_props, pingprotectevaluation_spread_levels[i9]);
  }
  pingprotectevaluation = new Ping_protect_evaluation({ props: pingprotectevaluation_props });
  return {
    c() {
      create_component(pingprotectevaluation.$$.fragment);
    },
    m(target, anchor) {
      mount_component(pingprotectevaluation, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const pingprotectevaluation_changes = dirty & /*props, _PingProtectEvaluation*/
      2097153 ? get_spread_update(pingprotectevaluation_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      pingprotectevaluation.$set(pingprotectevaluation_changes);
    },
    i(local) {
      if (current) return;
      transition_in(pingprotectevaluation.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(pingprotectevaluation.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(pingprotectevaluation, detaching);
    }
  };
}
function create_if_block_18(ctx) {
  let recaptcha;
  let current;
  const recaptcha_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let recaptcha_props = {};
  for (let i9 = 0; i9 < recaptcha_spread_levels.length; i9 += 1) {
    recaptcha_props = assign(recaptcha_props, recaptcha_spread_levels[i9]);
  }
  recaptcha = new Recaptcha({ props: recaptcha_props });
  return {
    c() {
      create_component(recaptcha.$$.fragment);
    },
    m(target, anchor) {
      mount_component(recaptcha, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const recaptcha_changes = dirty & /*props, _RecaptchaCallback*/
      1048577 ? get_spread_update(recaptcha_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      recaptcha.$set(recaptcha_changes);
    },
    i(local) {
      if (current) return;
      transition_in(recaptcha.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(recaptcha.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(recaptcha, detaching);
    }
  };
}
function create_if_block_17(ctx) {
  let metadata;
  let current;
  const metadata_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let metadata_props = {};
  for (let i9 = 0; i9 < metadata_spread_levels.length; i9 += 1) {
    metadata_props = assign(metadata_props, metadata_spread_levels[i9]);
  }
  metadata = new Metadata({ props: metadata_props });
  return {
    c() {
      create_component(metadata.$$.fragment);
    },
    m(target, anchor) {
      mount_component(metadata, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const metadata_changes = dirty & /*props, _MetadataCallback*/
      262145 ? get_spread_update(metadata_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      metadata.$set(metadata_changes);
    },
    i(local) {
      if (current) return;
      transition_in(metadata.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(metadata.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(metadata, detaching);
    }
  };
}
function create_if_block_16(ctx) {
  let deviceprofile;
  let current;
  const deviceprofile_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let deviceprofile_props = {};
  for (let i9 = 0; i9 < deviceprofile_spread_levels.length; i9 += 1) {
    deviceprofile_props = assign(deviceprofile_props, deviceprofile_spread_levels[i9]);
  }
  deviceprofile = new Device_profile({ props: deviceprofile_props });
  return {
    c() {
      create_component(deviceprofile.$$.fragment);
    },
    m(target, anchor) {
      mount_component(deviceprofile, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const deviceprofile_changes = dirty & /*props, _DeviceProfileCallback*/
      524289 ? get_spread_update(deviceprofile_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      deviceprofile.$set(deviceprofile_changes);
    },
    i(local) {
      if (current) return;
      transition_in(deviceprofile.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(deviceprofile.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(deviceprofile, detaching);
    }
  };
}
function create_if_block_15(ctx) {
  let textoutput;
  let current;
  const textoutput_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let textoutput_props = {};
  for (let i9 = 0; i9 < textoutput_spread_levels.length; i9 += 1) {
    textoutput_props = assign(textoutput_props, textoutput_spread_levels[i9]);
  }
  textoutput = new Text_output({ props: textoutput_props });
  return {
    c() {
      create_component(textoutput.$$.fragment);
    },
    m(target, anchor) {
      mount_component(textoutput, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const textoutput_changes = dirty & /*props, _SuspendedTextOutputCallback*/
      131073 ? get_spread_update(textoutput_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      textoutput.$set(textoutput_changes);
    },
    i(local) {
      if (current) return;
      transition_in(textoutput.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(textoutput.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(textoutput, detaching);
    }
  };
}
function create_if_block_14(ctx) {
  let textoutput;
  let current;
  const textoutput_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let textoutput_props = {};
  for (let i9 = 0; i9 < textoutput_spread_levels.length; i9 += 1) {
    textoutput_props = assign(textoutput_props, textoutput_spread_levels[i9]);
  }
  textoutput = new Text_output({ props: textoutput_props });
  return {
    c() {
      create_component(textoutput.$$.fragment);
    },
    m(target, anchor) {
      mount_component(textoutput, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const textoutput_changes = dirty & /*props, _TextOutputCallback*/
      65537 ? get_spread_update(textoutput_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      textoutput.$set(textoutput_changes);
    },
    i(local) {
      if (current) return;
      transition_in(textoutput.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(textoutput.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(textoutput, detaching);
    }
  };
}
function create_if_block_13(ctx) {
  let termsconditions;
  let current;
  const termsconditions_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let termsconditions_props = {};
  for (let i9 = 0; i9 < termsconditions_spread_levels.length; i9 += 1) {
    termsconditions_props = assign(termsconditions_props, termsconditions_spread_levels[i9]);
  }
  termsconditions = new Terms_conditions({ props: termsconditions_props });
  return {
    c() {
      create_component(termsconditions.$$.fragment);
    },
    m(target, anchor) {
      mount_component(termsconditions, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const termsconditions_changes = dirty & /*props, _TermsAndConditionsCallback*/
      32769 ? get_spread_update(termsconditions_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      termsconditions.$set(termsconditions_changes);
    },
    i(local) {
      if (current) return;
      transition_in(termsconditions.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(termsconditions.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(termsconditions, detaching);
    }
  };
}
function create_if_block_12(ctx) {
  let validatedcreateusername;
  let current;
  const validatedcreateusername_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let validatedcreateusername_props = {};
  for (let i9 = 0; i9 < validatedcreateusername_spread_levels.length; i9 += 1) {
    validatedcreateusername_props = assign(validatedcreateusername_props, validatedcreateusername_spread_levels[i9]);
  }
  validatedcreateusername = new Validated_create_username({ props: validatedcreateusername_props });
  return {
    c() {
      create_component(validatedcreateusername.$$.fragment);
    },
    m(target, anchor) {
      mount_component(validatedcreateusername, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const validatedcreateusername_changes = dirty & /*props, _ValidatedCreateUsernameCallback*/
      16385 ? get_spread_update(validatedcreateusername_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      validatedcreateusername.$set(validatedcreateusername_changes);
    },
    i(local) {
      if (current) return;
      transition_in(validatedcreateusername.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(validatedcreateusername.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(validatedcreateusername, detaching);
    }
  };
}
function create_if_block_11(ctx) {
  let validatedcreatepassword;
  let current;
  const validatedcreatepassword_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let validatedcreatepassword_props = {};
  for (let i9 = 0; i9 < validatedcreatepassword_spread_levels.length; i9 += 1) {
    validatedcreatepassword_props = assign(validatedcreatepassword_props, validatedcreatepassword_spread_levels[i9]);
  }
  validatedcreatepassword = new Validated_create_password({ props: validatedcreatepassword_props });
  return {
    c() {
      create_component(validatedcreatepassword.$$.fragment);
    },
    m(target, anchor) {
      mount_component(validatedcreatepassword, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const validatedcreatepassword_changes = dirty & /*props, _ValidatedCreatePasswordCallback*/
      8193 ? get_spread_update(validatedcreatepassword_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      validatedcreatepassword.$set(validatedcreatepassword_changes);
    },
    i(local) {
      if (current) return;
      transition_in(validatedcreatepassword.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(validatedcreatepassword.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(validatedcreatepassword, detaching);
    }
  };
}
function create_if_block_10(ctx) {
  let stringattributeinput;
  let current;
  const stringattributeinput_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let stringattributeinput_props = {};
  for (let i9 = 0; i9 < stringattributeinput_spread_levels.length; i9 += 1) {
    stringattributeinput_props = assign(stringattributeinput_props, stringattributeinput_spread_levels[i9]);
  }
  stringattributeinput = new String_attribute_input({ props: stringattributeinput_props });
  return {
    c() {
      create_component(stringattributeinput.$$.fragment);
    },
    m(target, anchor) {
      mount_component(stringattributeinput, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const stringattributeinput_changes = dirty & /*props, _StringAttributeInputCallback*/
      4097 ? get_spread_update(stringattributeinput_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      stringattributeinput.$set(stringattributeinput_changes);
    },
    i(local) {
      if (current) return;
      transition_in(stringattributeinput.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(stringattributeinput.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(stringattributeinput, detaching);
    }
  };
}
function create_if_block_9(ctx) {
  let selectidp;
  let current;
  const selectidp_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let selectidp_props = {};
  for (let i9 = 0; i9 < selectidp_spread_levels.length; i9 += 1) {
    selectidp_props = assign(selectidp_props, selectidp_spread_levels[i9]);
  }
  selectidp = new Select_idp({ props: selectidp_props });
  return {
    c() {
      create_component(selectidp.$$.fragment);
    },
    m(target, anchor) {
      mount_component(selectidp, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const selectidp_changes = dirty & /*props, _SelectIdPCallback*/
      2049 ? get_spread_update(selectidp_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      selectidp.$set(selectidp_changes);
    },
    i(local) {
      if (current) return;
      transition_in(selectidp.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(selectidp.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(selectidp, detaching);
    }
  };
}
function create_if_block_8(ctx) {
  let redirect;
  let current;
  const redirect_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let redirect_props = {};
  for (let i9 = 0; i9 < redirect_spread_levels.length; i9 += 1) {
    redirect_props = assign(redirect_props, redirect_spread_levels[i9]);
  }
  redirect = new Redirect({ props: redirect_props });
  return {
    c() {
      create_component(redirect.$$.fragment);
    },
    m(target, anchor) {
      mount_component(redirect, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const redirect_changes = dirty & /*props, _RedirectCallback*/
      1025 ? get_spread_update(redirect_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      redirect.$set(redirect_changes);
    },
    i(local) {
      if (current) return;
      transition_in(redirect.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(redirect.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(redirect, detaching);
    }
  };
}
function create_if_block_7(ctx) {
  let pollingwait;
  let current;
  const pollingwait_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let pollingwait_props = {};
  for (let i9 = 0; i9 < pollingwait_spread_levels.length; i9 += 1) {
    pollingwait_props = assign(pollingwait_props, pollingwait_spread_levels[i9]);
  }
  pollingwait = new Polling_wait({ props: pollingwait_props });
  return {
    c() {
      create_component(pollingwait.$$.fragment);
    },
    m(target, anchor) {
      mount_component(pollingwait, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const pollingwait_changes = dirty & /*props, _PollingWaitCallback*/
      513 ? get_spread_update(pollingwait_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      pollingwait.$set(pollingwait_changes);
    },
    i(local) {
      if (current) return;
      transition_in(pollingwait.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(pollingwait.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(pollingwait, detaching);
    }
  };
}
function create_if_block_6(ctx) {
  let password;
  let current;
  const password_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let password_props = {};
  for (let i9 = 0; i9 < password_spread_levels.length; i9 += 1) {
    password_props = assign(password_props, password_spread_levels[i9]);
  }
  password = new Password({ props: password_props });
  return {
    c() {
      create_component(password.$$.fragment);
    },
    m(target, anchor) {
      mount_component(password, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const password_changes = dirty & /*props, _PasswordCallback*/
      257 ? get_spread_update(password_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      password.$set(password_changes);
    },
    i(local) {
      if (current) return;
      transition_in(password.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(password.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(password, detaching);
    }
  };
}
function create_if_block_5$1(ctx) {
  let name;
  let current;
  const name_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let name_props = {};
  for (let i9 = 0; i9 < name_spread_levels.length; i9 += 1) {
    name_props = assign(name_props, name_spread_levels[i9]);
  }
  name = new Name({ props: name_props });
  return {
    c() {
      create_component(name.$$.fragment);
    },
    m(target, anchor) {
      mount_component(name, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const name_changes = dirty & /*props, _NameCallback*/
      129 ? get_spread_update(name_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      name.$set(name_changes);
    },
    i(local) {
      if (current) return;
      transition_in(name.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(name.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(name, detaching);
    }
  };
}
function create_if_block_4$5(ctx) {
  let kbacreate;
  let current;
  const kbacreate_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let kbacreate_props = {};
  for (let i9 = 0; i9 < kbacreate_spread_levels.length; i9 += 1) {
    kbacreate_props = assign(kbacreate_props, kbacreate_spread_levels[i9]);
  }
  kbacreate = new Kba_create({ props: kbacreate_props });
  return {
    c() {
      create_component(kbacreate.$$.fragment);
    },
    m(target, anchor) {
      mount_component(kbacreate, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const kbacreate_changes = dirty & /*props, _KbaCreateCallback*/
      65 ? get_spread_update(kbacreate_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      kbacreate.$set(kbacreate_changes);
    },
    i(local) {
      if (current) return;
      transition_in(kbacreate.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(kbacreate.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(kbacreate, detaching);
    }
  };
}
function create_if_block_3$7(ctx) {
  let hiddenvalue;
  let current;
  const hiddenvalue_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let hiddenvalue_props = {};
  for (let i9 = 0; i9 < hiddenvalue_spread_levels.length; i9 += 1) {
    hiddenvalue_props = assign(hiddenvalue_props, hiddenvalue_spread_levels[i9]);
  }
  hiddenvalue = new Hidden_value({ props: hiddenvalue_props });
  return {
    c() {
      create_component(hiddenvalue.$$.fragment);
    },
    m(target, anchor) {
      mount_component(hiddenvalue, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const hiddenvalue_changes = dirty & /*props, _HiddenValueCallback*/
      33 ? get_spread_update(hiddenvalue_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      hiddenvalue.$set(hiddenvalue_changes);
    },
    i(local) {
      if (current) return;
      transition_in(hiddenvalue.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(hiddenvalue.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(hiddenvalue, detaching);
    }
  };
}
function create_if_block_2$7(ctx) {
  let confirmation;
  let current;
  const confirmation_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let confirmation_props = {};
  for (let i9 = 0; i9 < confirmation_spread_levels.length; i9 += 1) {
    confirmation_props = assign(confirmation_props, confirmation_spread_levels[i9]);
  }
  confirmation = new Confirmation({ props: confirmation_props });
  return {
    c() {
      create_component(confirmation.$$.fragment);
    },
    m(target, anchor) {
      mount_component(confirmation, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const confirmation_changes = dirty & /*props, _ConfirmationCallback*/
      17 ? get_spread_update(confirmation_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      confirmation.$set(confirmation_changes);
    },
    i(local) {
      if (current) return;
      transition_in(confirmation.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(confirmation.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(confirmation, detaching);
    }
  };
}
function create_if_block_1$8(ctx) {
  let choice;
  let current;
  const choice_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let choice_props = {};
  for (let i9 = 0; i9 < choice_spread_levels.length; i9 += 1) {
    choice_props = assign(choice_props, choice_spread_levels[i9]);
  }
  choice = new Choice({ props: choice_props });
  return {
    c() {
      create_component(choice.$$.fragment);
    },
    m(target, anchor) {
      mount_component(choice, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const choice_changes = dirty & /*props, _ChoiceCallback*/
      9 ? get_spread_update(choice_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      choice.$set(choice_changes);
    },
    i(local) {
      if (current) return;
      transition_in(choice.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(choice.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(choice, detaching);
    }
  };
}
function create_if_block$a(ctx) {
  let boolean;
  let current;
  const boolean_spread_levels = [
    /*newProps*/
    ctx[24]
  ];
  let boolean_props = {};
  for (let i9 = 0; i9 < boolean_spread_levels.length; i9 += 1) {
    boolean_props = assign(boolean_props, boolean_spread_levels[i9]);
  }
  boolean = new Boolean$1({ props: boolean_props });
  return {
    c() {
      create_component(boolean.$$.fragment);
    },
    m(target, anchor) {
      mount_component(boolean, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const boolean_changes = dirty & /*props, _BooleanAttributeInputCallback*/
      5 ? get_spread_update(boolean_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[24]
      )]) : {};
      boolean.$set(boolean_changes);
    },
    i(local) {
      if (current) return;
      transition_in(boolean.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(boolean.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(boolean, detaching);
    }
  };
}
function create_fragment$h(ctx) {
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [
    create_if_block$a,
    create_if_block_1$8,
    create_if_block_2$7,
    create_if_block_3$7,
    create_if_block_4$5,
    create_if_block_5$1,
    create_if_block_6,
    create_if_block_7,
    create_if_block_8,
    create_if_block_9,
    create_if_block_10,
    create_if_block_11,
    create_if_block_12,
    create_if_block_13,
    create_if_block_14,
    create_if_block_15,
    create_if_block_16,
    create_if_block_17,
    create_if_block_18,
    create_if_block_19,
    create_if_block_20,
    create_else_block$3
  ];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*cbType*/
      ctx2[1] === l.BooleanAttributeInputCallback
    ) return 0;
    if (
      /*cbType*/
      ctx2[1] === l.ChoiceCallback
    ) return 1;
    if (
      /*cbType*/
      ctx2[1] === l.ConfirmationCallback
    ) return 2;
    if (
      /*cbType*/
      ctx2[1] === l.HiddenValueCallback
    ) return 3;
    if (
      /*cbType*/
      ctx2[1] === l.KbaCreateCallback
    ) return 4;
    if (
      /*cbType*/
      ctx2[1] === l.NameCallback
    ) return 5;
    if (
      /*cbType*/
      ctx2[1] === l.PasswordCallback
    ) return 6;
    if (
      /*cbType*/
      ctx2[1] === l.PollingWaitCallback
    ) return 7;
    if (
      /*cbType*/
      ctx2[1] === l.RedirectCallback
    ) return 8;
    if (
      /*cbType*/
      ctx2[1] === l.SelectIdPCallback
    ) return 9;
    if (
      /*cbType*/
      ctx2[1] === l.StringAttributeInputCallback
    ) return 10;
    if (
      /*cbType*/
      ctx2[1] === l.ValidatedCreatePasswordCallback
    ) return 11;
    if (
      /*cbType*/
      ctx2[1] === l.ValidatedCreateUsernameCallback
    ) return 12;
    if (
      /*cbType*/
      ctx2[1] === l.TermsAndConditionsCallback
    ) return 13;
    if (
      /*cbType*/
      ctx2[1] === l.TextOutputCallback
    ) return 14;
    if (
      /*cbType*/
      ctx2[1] === l.SuspendedTextOutputCallback
    ) return 15;
    if (
      /*cbType*/
      ctx2[1] === l.DeviceProfileCallback
    ) return 16;
    if (
      /*cbType*/
      ctx2[1] === l.MetadataCallback
    ) return 17;
    if (
      /*cbType*/
      ctx2[1] === l.ReCaptchaCallback
    ) return 18;
    if (
      /*cbType*/
      ctx2[1] === l.PingOneProtectEvaluationCallback
    ) return 19;
    if (
      /*cbType*/
      ctx2[1] === l.PingOneProtectInitializeCallback
    ) return 20;
    return 21;
  }
  function select_block_ctx(ctx2, index) {
    if (index === 0) return get_if_ctx$1(ctx2);
    if (index === 1) return get_if_ctx_1(ctx2);
    if (index === 2) return get_if_ctx_2(ctx2);
    if (index === 3) return get_if_ctx_3(ctx2);
    if (index === 4) return get_if_ctx_4(ctx2);
    if (index === 5) return get_if_ctx_5(ctx2);
    if (index === 6) return get_if_ctx_6(ctx2);
    if (index === 7) return get_if_ctx_7(ctx2);
    if (index === 8) return get_if_ctx_8(ctx2);
    if (index === 9) return get_if_ctx_9(ctx2);
    if (index === 10) return get_if_ctx_10(ctx2);
    if (index === 11) return get_if_ctx_11(ctx2);
    if (index === 12) return get_if_ctx_12(ctx2);
    if (index === 13) return get_if_ctx_13(ctx2);
    if (index === 14) return get_if_ctx_14(ctx2);
    if (index === 15) return get_if_ctx_15(ctx2);
    if (index === 16) return get_if_ctx_16(ctx2);
    if (index === 17) return get_if_ctx_17(ctx2);
    if (index === 18) return get_if_ctx_18(ctx2);
    if (index === 19) return get_if_ctx_19(ctx2);
    if (index === 20) return get_if_ctx_20(ctx2);
    return get_else_ctx(ctx2);
  }
  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](select_block_ctx(ctx, current_block_type_index));
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(select_block_ctx(ctx2, current_block_type_index), dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](select_block_ctx(ctx2, current_block_type_index));
          if_block.c();
        } else {
          if_block.p(select_block_ctx(ctx2, current_block_type_index), dirty);
        }
        transition_in(if_block, 1);
        if_block.m(if_block_anchor.parentNode, if_block_anchor);
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if_blocks[current_block_type_index].d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function instance$h($$self, $$props, $$invalidate) {
  let { props } = $$props;
  let cbType;
  let _BooleanAttributeInputCallback;
  let _ChoiceCallback;
  let _ConfirmationCallback;
  let _HiddenValueCallback;
  let _KbaCreateCallback;
  let _NameCallback;
  let _PasswordCallback;
  let _PollingWaitCallback;
  let _RedirectCallback;
  let _SelectIdPCallback;
  let _StringAttributeInputCallback;
  let _ValidatedCreatePasswordCallback;
  let _ValidatedCreateUsernameCallback;
  let _TermsAndConditionsCallback;
  let _TextOutputCallback;
  let _SuspendedTextOutputCallback;
  let _MetadataCallback;
  let _DeviceProfileCallback;
  let _RecaptchaCallback;
  let _PingProtectEvaluation;
  let _PingProtectInitialize;
  let _FRCallback;
  $$self.$$set = ($$props2) => {
    if ("props" in $$props2) $$invalidate(0, props = $$props2.props);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*props, cbType*/
    3) {
      {
        $$invalidate(1, cbType = props.callback.getType());
        switch (cbType) {
          case l.BooleanAttributeInputCallback:
            $$invalidate(2, _BooleanAttributeInputCallback = props.callback);
            break;
          case l.ChoiceCallback:
            $$invalidate(3, _ChoiceCallback = props.callback);
            break;
          case l.ConfirmationCallback:
            $$invalidate(4, _ConfirmationCallback = props.callback);
            break;
          case l.HiddenValueCallback:
            $$invalidate(5, _HiddenValueCallback = props.callback);
            break;
          case l.KbaCreateCallback:
            $$invalidate(6, _KbaCreateCallback = props.callback);
            break;
          case l.NameCallback:
            $$invalidate(7, _NameCallback = props.callback);
            break;
          case l.ReCaptchaCallback:
            $$invalidate(20, _RecaptchaCallback = props.callback);
            break;
          case l.PasswordCallback:
            $$invalidate(8, _PasswordCallback = props.callback);
            break;
          case l.PollingWaitCallback:
            $$invalidate(9, _PollingWaitCallback = props.callback);
            break;
          case l.RedirectCallback:
            $$invalidate(10, _RedirectCallback = props.callback);
            break;
          case l.SelectIdPCallback:
            $$invalidate(11, _SelectIdPCallback = props.callback);
            break;
          case l.StringAttributeInputCallback:
            $$invalidate(12, _StringAttributeInputCallback = props.callback);
            break;
          case l.ValidatedCreatePasswordCallback:
            $$invalidate(13, _ValidatedCreatePasswordCallback = props.callback);
            break;
          case l.ValidatedCreateUsernameCallback:
            $$invalidate(14, _ValidatedCreateUsernameCallback = props.callback);
            break;
          case l.TermsAndConditionsCallback:
            $$invalidate(15, _TermsAndConditionsCallback = props.callback);
            break;
          case l.TextOutputCallback:
            $$invalidate(16, _TextOutputCallback = props.callback);
            break;
          case l.SuspendedTextOutputCallback:
            $$invalidate(17, _SuspendedTextOutputCallback = props.callback);
            break;
          case l.DeviceProfileCallback:
            $$invalidate(19, _DeviceProfileCallback = props.callback);
            break;
          case l.MetadataCallback:
            $$invalidate(18, _MetadataCallback = props.callback);
            break;
          case l.PingOneProtectEvaluationCallback:
            $$invalidate(21, _PingProtectEvaluation = props.callback);
            break;
          case l.PingOneProtectInitializeCallback:
            $$invalidate(22, _PingProtectInitialize = props.callback);
            break;
          default:
            $$invalidate(23, _FRCallback = props.callback);
        }
      }
    }
  };
  return [
    props,
    cbType,
    _BooleanAttributeInputCallback,
    _ChoiceCallback,
    _ConfirmationCallback,
    _HiddenValueCallback,
    _KbaCreateCallback,
    _NameCallback,
    _PasswordCallback,
    _PollingWaitCallback,
    _RedirectCallback,
    _SelectIdPCallback,
    _StringAttributeInputCallback,
    _ValidatedCreatePasswordCallback,
    _ValidatedCreateUsernameCallback,
    _TermsAndConditionsCallback,
    _TextOutputCallback,
    _SuspendedTextOutputCallback,
    _MetadataCallback,
    _DeviceProfileCallback,
    _RecaptchaCallback,
    _PingProtectEvaluation,
    _PingProtectInitialize,
    _FRCallback
  ];
}
var Callback_mapper = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$h, create_fragment$h, safe_not_equal, { props: 0 });
  }
};
function get_each_context$6(ctx, list, i9) {
  const child_ctx = ctx.slice();
  child_ctx[16] = list[i9];
  child_ctx[18] = i9;
  return child_ctx;
}
function create_if_block_4$4(ctx) {
  let div;
  let shieldicon;
  let current;
  shieldicon = new Shield_icon({
    props: {
      classes: "tw_text-gray-400 tw_fill-current",
      size: "72px"
    }
  });
  return {
    c() {
      div = element("div");
      create_component(shieldicon.$$.fragment);
      attr(div, "class", "tw_flex tw_justify-center");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(shieldicon, div, null);
      current = true;
    },
    i(local) {
      if (current) return;
      transition_in(shieldicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(shieldicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(shieldicon);
    }
  };
}
function create_if_block_3$6(ctx) {
  let alert;
  let current;
  alert = new Alert({
    props: {
      id: formFailureMessageId$3,
      needsFocus: (
        /*alertNeedsFocus*/
        ctx[6]
      ),
      type: "error",
      $$slots: { default: [create_default_slot_4$1] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(alert.$$.fragment);
    },
    m(target, anchor) {
      mount_component(alert, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const alert_changes = {};
      if (dirty & /*alertNeedsFocus*/
      64) alert_changes.needsFocus = /*alertNeedsFocus*/
      ctx2[6];
      if (dirty & /*$$scope, formMessageKey, form*/
      524420) {
        alert_changes.$$scope = { dirty, ctx: ctx2 };
      }
      alert.$set(alert_changes);
    },
    i(local) {
      if (current) return;
      transition_in(alert.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(alert.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(alert, detaching);
    }
  };
}
function create_default_slot_4$1(ctx) {
  var _a;
  let t_value = interpolate(
    /*formMessageKey*/
    ctx[7],
    null,
    /*form*/
    (_a = ctx[2]) == null ? void 0 : _a.message
  ) + "";
  let t3;
  return {
    c() {
      t3 = text(t_value);
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    p(ctx2, dirty) {
      var _a2;
      if (dirty & /*formMessageKey, form*/
      132 && t_value !== (t_value = interpolate(
        /*formMessageKey*/
        ctx2[7],
        null,
        /*form*/
        (_a2 = ctx2[2]) == null ? void 0 : _a2.message
      ) + "")) set_data(t3, t_value);
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_each_block$6(ctx) {
  var _a, _b;
  let callbackmapper;
  let current;
  callbackmapper = new Callback_mapper({
    props: {
      props: {
        callback: (
          /*callback*/
          ctx[16]
        ),
        callbackMetadata: (
          /*metadata*/
          (_a = ctx[4]) == null ? void 0 : _a.callbacks[
            /*idx*/
            ctx[18]
          ]
        ),
        selfSubmitFunction: (
          /*determineSubmission*/
          ctx[12]
        ),
        stepMetadata: (
          /*metadata*/
          ((_b = ctx[4]) == null ? void 0 : _b.step) && __spreadValues(
            {},
            /*metadata*/
            ctx[4].step
          )
        ),
        style: (
          /*$styleStore*/
          ctx[11]
        )
      }
    }
  });
  return {
    c() {
      create_component(callbackmapper.$$.fragment);
    },
    m(target, anchor) {
      mount_component(callbackmapper, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2, _b2;
      const callbackmapper_changes = {};
      if (dirty & /*step, metadata, $styleStore*/
      2096) callbackmapper_changes.props = {
        callback: (
          /*callback*/
          ctx2[16]
        ),
        callbackMetadata: (
          /*metadata*/
          (_a2 = ctx2[4]) == null ? void 0 : _a2.callbacks[
            /*idx*/
            ctx2[18]
          ]
        ),
        selfSubmitFunction: (
          /*determineSubmission*/
          ctx2[12]
        ),
        stepMetadata: (
          /*metadata*/
          ((_b2 = ctx2[4]) == null ? void 0 : _b2.step) && __spreadValues(
            {},
            /*metadata*/
            ctx2[4].step
          )
        ),
        style: (
          /*$styleStore*/
          ctx2[11]
        )
      };
      callbackmapper.$set(callbackmapper_changes);
    },
    i(local) {
      if (current) return;
      transition_in(callbackmapper.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(callbackmapper.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(callbackmapper, detaching);
    }
  };
}
function create_if_block_2$6(ctx) {
  var _a;
  let button;
  let current;
  button = new Button({
    props: {
      busy: (
        /*journey*/
        (_a = ctx[3]) == null ? void 0 : _a.loading
      ),
      style: "primary",
      type: "submit",
      width: "full",
      $$slots: { default: [create_default_slot_3$2] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(button.$$.fragment);
    },
    m(target, anchor) {
      mount_component(button, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      const button_changes = {};
      if (dirty & /*journey*/
      8) button_changes.busy = /*journey*/
      (_a2 = ctx2[3]) == null ? void 0 : _a2.loading;
      if (dirty & /*$$scope*/
      524288) {
        button_changes.$$scope = { dirty, ctx: ctx2 };
      }
      button.$set(button_changes);
    },
    i(local) {
      if (current) return;
      transition_in(button.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(button.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(button, detaching);
    }
  };
}
function create_if_block_1$7(ctx) {
  var _a;
  let button;
  let current;
  button = new Button({
    props: {
      busy: (
        /*journey*/
        (_a = ctx[3]) == null ? void 0 : _a.loading
      ),
      style: "primary",
      type: "submit",
      width: "full",
      $$slots: { default: [create_default_slot_2$5] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(button.$$.fragment);
    },
    m(target, anchor) {
      mount_component(button, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      const button_changes = {};
      if (dirty & /*journey*/
      8) button_changes.busy = /*journey*/
      (_a2 = ctx2[3]) == null ? void 0 : _a2.loading;
      if (dirty & /*$$scope*/
      524288) {
        button_changes.$$scope = { dirty, ctx: ctx2 };
      }
      button.$set(button_changes);
    },
    i(local) {
      if (current) return;
      transition_in(button.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(button.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(button, detaching);
    }
  };
}
function create_if_block$9(ctx) {
  var _a;
  let button;
  let current;
  button = new Button({
    props: {
      busy: (
        /*journey*/
        (_a = ctx[3]) == null ? void 0 : _a.loading
      ),
      style: "primary",
      type: "submit",
      width: "full",
      $$slots: { default: [create_default_slot_1$8] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(button.$$.fragment);
    },
    m(target, anchor) {
      mount_component(button, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      const button_changes = {};
      if (dirty & /*journey*/
      8) button_changes.busy = /*journey*/
      (_a2 = ctx2[3]) == null ? void 0 : _a2.loading;
      if (dirty & /*$$scope*/
      524288) {
        button_changes.$$scope = { dirty, ctx: ctx2 };
      }
      button.$set(button_changes);
    },
    i(local) {
      if (current) return;
      transition_in(button.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(button.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(button, detaching);
    }
  };
}
function create_default_slot_3$2(ctx) {
  let t3;
  let current;
  t3 = new Locale_strings({ props: { key: "nextButton" } });
  return {
    c() {
      create_component(t3.$$.fragment);
    },
    m(target, anchor) {
      mount_component(t3, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(t3, detaching);
    }
  };
}
function create_default_slot_2$5(ctx) {
  let t3;
  let current;
  t3 = new Locale_strings({ props: { key: "nextButton" } });
  return {
    c() {
      create_component(t3.$$.fragment);
    },
    m(target, anchor) {
      mount_component(t3, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(t3, detaching);
    }
  };
}
function create_default_slot_1$8(ctx) {
  let t3;
  let current;
  t3 = new Locale_strings({ props: { key: "nextButton" } });
  return {
    c() {
      create_component(t3.$$.fragment);
    },
    m(target, anchor) {
      mount_component(t3, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(t3, detaching);
    }
  };
}
function create_default_slot$9(ctx) {
  var _a, _b, _c, _d, _e;
  let t0;
  let header;
  let h1;
  let sanitize0;
  let t1;
  let p4;
  let sanitize1;
  let t22;
  let t3;
  let t4;
  let show_if;
  let current_block_type_index;
  let if_block2;
  let t5;
  let backto;
  let current;
  let if_block0 = (
    /*form*/
    ((_a = ctx[2]) == null ? void 0 : _a.icon) && /*componentStyle*/
    ctx[1] !== "inline" && create_if_block_4$4()
  );
  sanitize0 = new Server_strings({
    props: {
      html: true,
      string: (
        /*step*/
        ((_b = ctx[5]) == null ? void 0 : _b.getHeader()) || ""
      )
    }
  });
  sanitize1 = new Server_strings({
    props: {
      html: true,
      string: (
        /*step*/
        ((_c = ctx[5]) == null ? void 0 : _c.getDescription()) || ""
      )
    }
  });
  let if_block1 = (
    /*form*/
    ((_d = ctx[2]) == null ? void 0 : _d.message) && create_if_block_3$6(ctx)
  );
  let each_value = (
    /*step*/
    (_e = ctx[5]) == null ? void 0 : _e.callbacks
  );
  let each_blocks = [];
  for (let i9 = 0; i9 < each_value.length; i9 += 1) {
    each_blocks[i9] = create_each_block$6(get_each_context$6(ctx, each_value, i9));
  }
  const out = (i9) => transition_out(each_blocks[i9], 1, 1, () => {
    each_blocks[i9] = null;
  });
  const if_block_creators = [create_if_block$9, create_if_block_1$7, create_if_block_2$6];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    var _a2, _b2, _c2, _d2, _e2, _f;
    if (dirty & /*metadata*/
    16) show_if = null;
    if (show_if == null) show_if = !!!/*metadata*/
    ((_b2 = (_a2 = ctx2[4]) == null ? void 0 : _a2.step) == null ? void 0 : _b2.derived.isStepSelfSubmittable());
    if (show_if) return 0;
    if (
      /*metadata*/
      (_d2 = (_c2 = ctx2[4]) == null ? void 0 : _c2.step) == null ? void 0 : _d2.derived.isUserInputOptional
    ) return 1;
    if (!/*metadata*/
    ((_f = (_e2 = ctx2[4]) == null ? void 0 : _e2.step) == null ? void 0 : _f.derived.numOfSelfSubmittableCbs)) return 2;
    return -1;
  }
  if (~(current_block_type_index = select_block_type(ctx, -1))) {
    if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  }
  backto = new Back_to({ props: { journey: (
    /*journey*/
    ctx[3]
  ) } });
  return {
    c() {
      if (if_block0) if_block0.c();
      t0 = space();
      header = element("header");
      h1 = element("h1");
      create_component(sanitize0.$$.fragment);
      t1 = space();
      p4 = element("p");
      create_component(sanitize1.$$.fragment);
      t22 = space();
      if (if_block1) if_block1.c();
      t3 = space();
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].c();
      }
      t4 = space();
      if (if_block2) if_block2.c();
      t5 = space();
      create_component(backto.$$.fragment);
      attr(h1, "class", "tw_primary-header dark:tw_primary-header_dark");
      attr(p4, "class", "tw_text-center tw_-mt-5 tw_mb-2 tw_py-4 tw_text-secondary-dark dark:tw_text-secondary-light");
      attr(header, "id", formHeaderId$3);
    },
    m(target, anchor) {
      if (if_block0) if_block0.m(target, anchor);
      insert(target, t0, anchor);
      insert(target, header, anchor);
      append(header, h1);
      mount_component(sanitize0, h1, null);
      append(header, t1);
      append(header, p4);
      mount_component(sanitize1, p4, null);
      ctx[14](header);
      insert(target, t22, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, t3, anchor);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].m(target, anchor);
      }
      insert(target, t4, anchor);
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].m(target, anchor);
      }
      insert(target, t5, anchor);
      mount_component(backto, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2, _b2, _c2, _d2, _e2;
      if (
        /*form*/
        ((_a2 = ctx2[2]) == null ? void 0 : _a2.icon) && /*componentStyle*/
        ctx2[1] !== "inline"
      ) {
        if (if_block0) {
          if (dirty & /*form, componentStyle*/
          6) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_4$4();
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(t0.parentNode, t0);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      const sanitize0_changes = {};
      if (dirty & /*step*/
      32) sanitize0_changes.string = /*step*/
      ((_b2 = ctx2[5]) == null ? void 0 : _b2.getHeader()) || "";
      sanitize0.$set(sanitize0_changes);
      const sanitize1_changes = {};
      if (dirty & /*step*/
      32) sanitize1_changes.string = /*step*/
      ((_c2 = ctx2[5]) == null ? void 0 : _c2.getDescription()) || "";
      sanitize1.$set(sanitize1_changes);
      if (
        /*form*/
        (_d2 = ctx2[2]) == null ? void 0 : _d2.message
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
          if (dirty & /*form*/
          4) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block_3$6(ctx2);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(t3.parentNode, t3);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
      if (dirty & /*step, metadata, determineSubmission, $styleStore*/
      6192) {
        each_value = /*step*/
        (_e2 = ctx2[5]) == null ? void 0 : _e2.callbacks;
        let i9;
        for (i9 = 0; i9 < each_value.length; i9 += 1) {
          const child_ctx = get_each_context$6(ctx2, each_value, i9);
          if (each_blocks[i9]) {
            each_blocks[i9].p(child_ctx, dirty);
            transition_in(each_blocks[i9], 1);
          } else {
            each_blocks[i9] = create_each_block$6(child_ctx);
            each_blocks[i9].c();
            transition_in(each_blocks[i9], 1);
            each_blocks[i9].m(t4.parentNode, t4);
          }
        }
        group_outros();
        for (i9 = each_value.length; i9 < each_blocks.length; i9 += 1) {
          out(i9);
        }
        check_outros();
      }
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2, dirty);
      if (current_block_type_index === previous_block_index) {
        if (~current_block_type_index) {
          if_blocks[current_block_type_index].p(ctx2, dirty);
        }
      } else {
        if (if_block2) {
          group_outros();
          transition_out(if_blocks[previous_block_index], 1, 1, () => {
            if_blocks[previous_block_index] = null;
          });
          check_outros();
        }
        if (~current_block_type_index) {
          if_block2 = if_blocks[current_block_type_index];
          if (!if_block2) {
            if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
            if_block2.c();
          } else {
            if_block2.p(ctx2, dirty);
          }
          transition_in(if_block2, 1);
          if_block2.m(t5.parentNode, t5);
        } else {
          if_block2 = null;
        }
      }
      const backto_changes = {};
      if (dirty & /*journey*/
      8) backto_changes.journey = /*journey*/
      ctx2[3];
      backto.$set(backto_changes);
    },
    i(local) {
      if (current) return;
      transition_in(if_block0);
      transition_in(sanitize0.$$.fragment, local);
      transition_in(sanitize1.$$.fragment, local);
      transition_in(if_block1);
      for (let i9 = 0; i9 < each_value.length; i9 += 1) {
        transition_in(each_blocks[i9]);
      }
      transition_in(if_block2);
      transition_in(backto.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(sanitize0.$$.fragment, local);
      transition_out(sanitize1.$$.fragment, local);
      transition_out(if_block1);
      each_blocks = each_blocks.filter(Boolean);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        transition_out(each_blocks[i9]);
      }
      transition_out(if_block2);
      transition_out(backto.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (if_block0) if_block0.d(detaching);
      if (detaching) detach(t0);
      if (detaching) detach(header);
      destroy_component(sanitize0);
      destroy_component(sanitize1);
      ctx[14](null);
      if (detaching) detach(t22);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(t3);
      destroy_each(each_blocks, detaching);
      if (detaching) detach(t4);
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].d(detaching);
      }
      if (detaching) detach(t5);
      destroy_component(backto, detaching);
    }
  };
}
function create_fragment$g(ctx) {
  let form_1;
  let updating_formEl;
  let current;
  function form_1_formEl_binding(value) {
    ctx[15](value);
  }
  let form_1_props = {
    ariaDescribedBy: (
      /*formAriaDescriptor*/
      ctx[8]
    ),
    id: formElementId$3,
    needsFocus: (
      /*formNeedsFocus*/
      ctx[9]
    ),
    onSubmitWhenValid: (
      /*submitFormWrapper*/
      ctx[13]
    ),
    $$slots: { default: [create_default_slot$9] },
    $$scope: { ctx }
  };
  if (
    /*formEl*/
    ctx[0] !== void 0
  ) {
    form_1_props.formEl = /*formEl*/
    ctx[0];
  }
  form_1 = new Form({ props: form_1_props });
  binding_callbacks.push(() => bind(form_1, "formEl", form_1_formEl_binding));
  return {
    c() {
      create_component(form_1.$$.fragment);
    },
    m(target, anchor) {
      mount_component(form_1, target, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      const form_1_changes = {};
      if (dirty & /*formAriaDescriptor*/
      256) form_1_changes.ariaDescribedBy = /*formAriaDescriptor*/
      ctx2[8];
      if (dirty & /*formNeedsFocus*/
      512) form_1_changes.needsFocus = /*formNeedsFocus*/
      ctx2[9];
      if (dirty & /*$$scope, journey, metadata, step, $styleStore, alertNeedsFocus, formMessageKey, form, linkWrapper, componentStyle*/
      527614) {
        form_1_changes.$$scope = { dirty, ctx: ctx2 };
      }
      if (!updating_formEl && dirty & /*formEl*/
      1) {
        updating_formEl = true;
        form_1_changes.formEl = /*formEl*/
        ctx2[0];
        add_flush_callback(() => updating_formEl = false);
      }
      form_1.$set(form_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(form_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(form_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(form_1, detaching);
    }
  };
}
var formFailureMessageId$3 = "genericStepFailureMessage";
var formHeaderId$3 = "genericStepHeader";
var formElementId$3 = "genericStepForm";
function instance$g($$self, $$props, $$invalidate) {
  let $styleStore;
  component_subscribe($$self, styleStore, ($$value) => $$invalidate(11, $styleStore = $$value));
  let { componentStyle } = $$props;
  let { form } = $$props;
  let { formEl = null } = $$props;
  let { journey: journey2 } = $$props;
  let { metadata } = $$props;
  let { step } = $$props;
  let alertNeedsFocus = false;
  let formMessageKey = "";
  let formAriaDescriptor = "genericStepHeader";
  let formNeedsFocus = false;
  let linkWrapper;
  function determineSubmission() {
    var _a;
    if ((_a = metadata == null ? void 0 : metadata.step) == null ? void 0 : _a.derived.isStepSelfSubmittable()) {
      submitFormWrapper();
    }
  }
  function submitFormWrapper() {
    $$invalidate(6, alertNeedsFocus = false);
    $$invalidate(9, formNeedsFocus = false);
    form == null ? void 0 : form.submit();
  }
  afterUpdate(() => {
    if (form == null ? void 0 : form.message) {
      $$invalidate(8, formAriaDescriptor = formFailureMessageId$3);
      $$invalidate(6, alertNeedsFocus = true);
      $$invalidate(9, formNeedsFocus = false);
    } else {
      $$invalidate(8, formAriaDescriptor = formHeaderId$3);
      $$invalidate(6, alertNeedsFocus = false);
      $$invalidate(9, formNeedsFocus = true);
    }
  });
  onMount(() => captureLinks(linkWrapper, journey2));
  function header_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      linkWrapper = $$value;
      $$invalidate(10, linkWrapper);
    });
  }
  function form_1_formEl_binding(value) {
    formEl = value;
    $$invalidate(0, formEl);
  }
  $$self.$$set = ($$props2) => {
    if ("componentStyle" in $$props2) $$invalidate(1, componentStyle = $$props2.componentStyle);
    if ("form" in $$props2) $$invalidate(2, form = $$props2.form);
    if ("formEl" in $$props2) $$invalidate(0, formEl = $$props2.formEl);
    if ("journey" in $$props2) $$invalidate(3, journey2 = $$props2.journey);
    if ("metadata" in $$props2) $$invalidate(4, metadata = $$props2.metadata);
    if ("step" in $$props2) $$invalidate(5, step = $$props2.step);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*step, form*/
    36) {
      {
        shouldRedirectFromStep(step) && f$1.redirect(step);
        $$invalidate(7, formMessageKey = convertStringToKey(form == null ? void 0 : form.message));
      }
    }
  };
  return [
    formEl,
    componentStyle,
    form,
    journey2,
    metadata,
    step,
    alertNeedsFocus,
    formMessageKey,
    formAriaDescriptor,
    formNeedsFocus,
    linkWrapper,
    $styleStore,
    determineSubmission,
    submitFormWrapper,
    header_binding,
    form_1_formEl_binding
  ];
}
var Generic = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$g, create_fragment$g, safe_not_equal, {
      componentStyle: 1,
      form: 2,
      formEl: 0,
      journey: 3,
      metadata: 4,
      step: 5
    });
  }
};
function create_fragment$f(ctx) {
  let svg;
  let path0;
  let path1;
  let title;
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[3].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[2],
    null
  );
  return {
    c() {
      svg = svg_element("svg");
      path0 = svg_element("path");
      path1 = svg_element("path");
      title = svg_element("title");
      if (default_slot) default_slot.c();
      attr(path0, "d", "M0 0h24v24H0z");
      attr(path0, "fill", "none");
      attr(path1, "d", "M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z");
      attr(
        svg,
        "class",
        /*classes*/
        ctx[0]
      );
      attr(
        svg,
        "height",
        /*size*/
        ctx[1]
      );
      attr(
        svg,
        "width",
        /*size*/
        ctx[1]
      );
      attr(svg, "viewBox", "0 0 24 24");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path0);
      append(svg, path1);
      append(svg, title);
      if (default_slot) {
        default_slot.m(title, null);
      }
      current = true;
    },
    p(ctx2, [dirty]) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        4)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[2],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[2]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[2],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (!current || dirty & /*classes*/
      1) {
        attr(
          svg,
          "class",
          /*classes*/
          ctx2[0]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "height",
          /*size*/
          ctx2[1]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "width",
          /*size*/
          ctx2[1]
        );
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(svg);
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function instance$f($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { classes = "" } = $$props;
  let { size = "24px" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("classes" in $$props2) $$invalidate(0, classes = $$props2.classes);
    if ("size" in $$props2) $$invalidate(1, size = $$props2.size);
    if ("$$scope" in $$props2) $$invalidate(2, $$scope = $$props2.$$scope);
  };
  return [classes, size, $$scope, slots];
}
var Key_icon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$f, create_fragment$f, safe_not_equal, { classes: 0, size: 1 });
  }
};
function get_each_context$5(ctx, list, i9) {
  const child_ctx = ctx.slice();
  child_ctx[13] = list[i9];
  child_ctx[15] = i9;
  return child_ctx;
}
function create_if_block_3$5(ctx) {
  var _a;
  let t0;
  let h1;
  let t1;
  let t22;
  let p4;
  let t3;
  let current;
  let if_block = (
    /*form*/
    ((_a = ctx[2]) == null ? void 0 : _a.icon) && create_if_block_4$3()
  );
  t1 = new Locale_strings({
    props: { key: "twoFactorAuthentication" }
  });
  t3 = new Locale_strings({
    props: { key: "useTheAuthenticatorAppOnYourPhone" }
  });
  return {
    c() {
      if (if_block) if_block.c();
      t0 = space();
      h1 = element("h1");
      create_component(t1.$$.fragment);
      t22 = space();
      p4 = element("p");
      create_component(t3.$$.fragment);
      attr(h1, "class", "tw_primary-header dark:tw_primary-header_dark");
      attr(p4, "class", "tw_text-center tw_text-sm tw_-mt-5 tw_mb-2 tw_py-4 tw_text-secondary-dark dark:tw_text-secondary-light");
    },
    m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      insert(target, t0, anchor);
      insert(target, h1, anchor);
      mount_component(t1, h1, null);
      insert(target, t22, anchor);
      insert(target, p4, anchor);
      mount_component(t3, p4, null);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      if (
        /*form*/
        (_a2 = ctx2[2]) == null ? void 0 : _a2.icon
      ) {
        if (if_block) {
          if (dirty & /*form*/
          4) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block_4$3();
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(t0.parentNode, t0);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      transition_in(t1.$$.fragment, local);
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      transition_out(t1.$$.fragment, local);
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (if_block) if_block.d(detaching);
      if (detaching) detach(t0);
      if (detaching) detach(h1);
      destroy_component(t1);
      if (detaching) detach(t22);
      if (detaching) detach(p4);
      destroy_component(t3);
    }
  };
}
function create_if_block_4$3(ctx) {
  let div;
  let keyicon;
  let current;
  keyicon = new Key_icon({
    props: {
      classes: "tw_text-gray-400 tw_fill-current",
      size: "72px"
    }
  });
  return {
    c() {
      div = element("div");
      create_component(keyicon.$$.fragment);
      attr(div, "class", "tw_flex tw_justify-center");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(keyicon, div, null);
      current = true;
    },
    i(local) {
      if (current) return;
      transition_in(keyicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(keyicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(keyicon);
    }
  };
}
function create_if_block_2$5(ctx) {
  let alert;
  let current;
  alert = new Alert({
    props: {
      id: "formFailureMessageAlert",
      needsFocus: (
        /*alertNeedsFocus*/
        ctx[5]
      ),
      type: "error",
      $$slots: { default: [create_default_slot_3$1] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(alert.$$.fragment);
    },
    m(target, anchor) {
      mount_component(alert, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const alert_changes = {};
      if (dirty & /*alertNeedsFocus*/
      32) alert_changes.needsFocus = /*alertNeedsFocus*/
      ctx2[5];
      if (dirty & /*$$scope, formMessageKey, form*/
      65668) {
        alert_changes.$$scope = { dirty, ctx: ctx2 };
      }
      alert.$set(alert_changes);
    },
    i(local) {
      if (current) return;
      transition_in(alert.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(alert.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(alert, detaching);
    }
  };
}
function create_default_slot_3$1(ctx) {
  var _a;
  let t_value = interpolate(
    /*formMessageKey*/
    ctx[7],
    null,
    /*form*/
    (_a = ctx[2]) == null ? void 0 : _a.message
  ) + "";
  let t3;
  return {
    c() {
      t3 = text(t_value);
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    p(ctx2, dirty) {
      var _a2;
      if (dirty & /*formMessageKey, form*/
      132 && t_value !== (t_value = interpolate(
        /*formMessageKey*/
        ctx2[7],
        null,
        /*form*/
        (_a2 = ctx2[2]) == null ? void 0 : _a2.message
      ) + "")) set_data(t3, t_value);
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_each_block$5(ctx) {
  var _a, _b;
  let callbackmapper;
  let current;
  callbackmapper = new Callback_mapper({
    props: {
      props: {
        callback: (
          /*callback*/
          ctx[13]
        ),
        callbackMetadata: (
          /*metadata*/
          (_a = ctx[4]) == null ? void 0 : _a.callbacks[
            /*idx*/
            ctx[15]
          ]
        ),
        selfSubmitFunction: (
          /*determineSubmission*/
          ctx[10]
        ),
        stepMetadata: (
          /*metadata*/
          ((_b = ctx[4]) == null ? void 0 : _b.step) && __spreadValues(
            {},
            /*metadata*/
            ctx[4].step
          )
        ),
        style: (
          /*$style*/
          ctx[9]
        )
      }
    }
  });
  return {
    c() {
      create_component(callbackmapper.$$.fragment);
    },
    m(target, anchor) {
      mount_component(callbackmapper, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2, _b2;
      const callbackmapper_changes = {};
      if (dirty & /*modifiedCallbacks, metadata, $style*/
      784) callbackmapper_changes.props = {
        callback: (
          /*callback*/
          ctx2[13]
        ),
        callbackMetadata: (
          /*metadata*/
          (_a2 = ctx2[4]) == null ? void 0 : _a2.callbacks[
            /*idx*/
            ctx2[15]
          ]
        ),
        selfSubmitFunction: (
          /*determineSubmission*/
          ctx2[10]
        ),
        stepMetadata: (
          /*metadata*/
          ((_b2 = ctx2[4]) == null ? void 0 : _b2.step) && __spreadValues(
            {},
            /*metadata*/
            ctx2[4].step
          )
        ),
        style: (
          /*$style*/
          ctx2[9]
        )
      };
      callbackmapper.$set(callbackmapper_changes);
    },
    i(local) {
      if (current) return;
      transition_in(callbackmapper.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(callbackmapper.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(callbackmapper, detaching);
    }
  };
}
function create_if_block_1$6(ctx) {
  var _a;
  let button;
  let current;
  button = new Button({
    props: {
      busy: (
        /*journey*/
        (_a = ctx[3]) == null ? void 0 : _a.loading
      ),
      style: "primary",
      type: "submit",
      width: "full",
      $$slots: { default: [create_default_slot_2$4] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(button.$$.fragment);
    },
    m(target, anchor) {
      mount_component(button, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      const button_changes = {};
      if (dirty & /*journey*/
      8) button_changes.busy = /*journey*/
      (_a2 = ctx2[3]) == null ? void 0 : _a2.loading;
      if (dirty & /*$$scope*/
      65536) {
        button_changes.$$scope = { dirty, ctx: ctx2 };
      }
      button.$set(button_changes);
    },
    i(local) {
      if (current) return;
      transition_in(button.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(button.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(button, detaching);
    }
  };
}
function create_if_block$8(ctx) {
  var _a;
  let button;
  let current;
  button = new Button({
    props: {
      busy: (
        /*journey*/
        (_a = ctx[3]) == null ? void 0 : _a.loading
      ),
      style: "primary",
      type: "submit",
      width: "full",
      $$slots: { default: [create_default_slot_1$7] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(button.$$.fragment);
    },
    m(target, anchor) {
      mount_component(button, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      const button_changes = {};
      if (dirty & /*journey*/
      8) button_changes.busy = /*journey*/
      (_a2 = ctx2[3]) == null ? void 0 : _a2.loading;
      if (dirty & /*$$scope, buttons*/
      65600) {
        button_changes.$$scope = { dirty, ctx: ctx2 };
      }
      button.$set(button_changes);
    },
    i(local) {
      if (current) return;
      transition_in(button.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(button.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(button, detaching);
    }
  };
}
function create_default_slot_2$4(ctx) {
  let t3;
  let current;
  t3 = new Locale_strings({ props: { key: "loginButton" } });
  return {
    c() {
      create_component(t3.$$.fragment);
    },
    m(target, anchor) {
      mount_component(t3, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(t3, detaching);
    }
  };
}
function create_default_slot_1$7(ctx) {
  let t3;
  let current;
  t3 = new Locale_strings({
    props: { key: (
      /*buttons*/
      ctx[6][0].text
    ) }
  });
  return {
    c() {
      create_component(t3.$$.fragment);
    },
    m(target, anchor) {
      mount_component(t3, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const t_changes = {};
      if (dirty & /*buttons*/
      64) t_changes.key = /*buttons*/
      ctx2[6][0].text;
      t3.$set(t_changes);
    },
    i(local) {
      if (current) return;
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(t3, detaching);
    }
  };
}
function create_default_slot$8(ctx) {
  var _a;
  let t0;
  let t1;
  let t22;
  let show_if;
  let current_block_type_index;
  let if_block2;
  let if_block2_anchor;
  let current;
  let if_block0 = (
    /*componentStyle*/
    ctx[1] !== "inline" && create_if_block_3$5(ctx)
  );
  let if_block1 = (
    /*form*/
    ((_a = ctx[2]) == null ? void 0 : _a.message) && create_if_block_2$5(ctx)
  );
  let each_value = (
    /*modifiedCallbacks*/
    ctx[8]
  );
  let each_blocks = [];
  for (let i9 = 0; i9 < each_value.length; i9 += 1) {
    each_blocks[i9] = create_each_block$5(get_each_context$5(ctx, each_value, i9));
  }
  const out = (i9) => transition_out(each_blocks[i9], 1, 1, () => {
    each_blocks[i9] = null;
  });
  const if_block_creators = [create_if_block$8, create_if_block_1$6];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    var _a2, _b, _c, _d, _e;
    if (dirty & /*metadata*/
    16) show_if = null;
    if (
      /*buttons*/
      (_a2 = ctx2[6]) == null ? void 0 : _a2.length
    ) return 0;
    if (show_if == null) show_if = !!/*metadata*/
    (((_c = (_b = ctx2[4]) == null ? void 0 : _b.step) == null ? void 0 : _c.derived.isUserInputOptional) || !/*metadata*/
    ((_e = (_d = ctx2[4]) == null ? void 0 : _d.step) == null ? void 0 : _e.derived.isStepSelfSubmittable()));
    if (show_if) return 1;
    return -1;
  }
  if (~(current_block_type_index = select_block_type(ctx, -1))) {
    if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  }
  return {
    c() {
      if (if_block0) if_block0.c();
      t0 = space();
      if (if_block1) if_block1.c();
      t1 = space();
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].c();
      }
      t22 = space();
      if (if_block2) if_block2.c();
      if_block2_anchor = empty();
    },
    m(target, anchor) {
      if (if_block0) if_block0.m(target, anchor);
      insert(target, t0, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, t1, anchor);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].m(target, anchor);
      }
      insert(target, t22, anchor);
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].m(target, anchor);
      }
      insert(target, if_block2_anchor, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      if (
        /*componentStyle*/
        ctx2[1] !== "inline"
      ) {
        if (if_block0) {
          if_block0.p(ctx2, dirty);
          if (dirty & /*componentStyle*/
          2) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_3$5(ctx2);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(t0.parentNode, t0);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      if (
        /*form*/
        (_a2 = ctx2[2]) == null ? void 0 : _a2.message
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
          if (dirty & /*form*/
          4) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block_2$5(ctx2);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(t1.parentNode, t1);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
      if (dirty & /*modifiedCallbacks, metadata, determineSubmission, $style*/
      1808) {
        each_value = /*modifiedCallbacks*/
        ctx2[8];
        let i9;
        for (i9 = 0; i9 < each_value.length; i9 += 1) {
          const child_ctx = get_each_context$5(ctx2, each_value, i9);
          if (each_blocks[i9]) {
            each_blocks[i9].p(child_ctx, dirty);
            transition_in(each_blocks[i9], 1);
          } else {
            each_blocks[i9] = create_each_block$5(child_ctx);
            each_blocks[i9].c();
            transition_in(each_blocks[i9], 1);
            each_blocks[i9].m(t22.parentNode, t22);
          }
        }
        group_outros();
        for (i9 = each_value.length; i9 < each_blocks.length; i9 += 1) {
          out(i9);
        }
        check_outros();
      }
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2, dirty);
      if (current_block_type_index === previous_block_index) {
        if (~current_block_type_index) {
          if_blocks[current_block_type_index].p(ctx2, dirty);
        }
      } else {
        if (if_block2) {
          group_outros();
          transition_out(if_blocks[previous_block_index], 1, 1, () => {
            if_blocks[previous_block_index] = null;
          });
          check_outros();
        }
        if (~current_block_type_index) {
          if_block2 = if_blocks[current_block_type_index];
          if (!if_block2) {
            if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
            if_block2.c();
          } else {
            if_block2.p(ctx2, dirty);
          }
          transition_in(if_block2, 1);
          if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
        } else {
          if_block2 = null;
        }
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block0);
      transition_in(if_block1);
      for (let i9 = 0; i9 < each_value.length; i9 += 1) {
        transition_in(each_blocks[i9]);
      }
      transition_in(if_block2);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(if_block1);
      each_blocks = each_blocks.filter(Boolean);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        transition_out(each_blocks[i9]);
      }
      transition_out(if_block2);
      current = false;
    },
    d(detaching) {
      if (if_block0) if_block0.d(detaching);
      if (detaching) detach(t0);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(t1);
      destroy_each(each_blocks, detaching);
      if (detaching) detach(t22);
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].d(detaching);
      }
      if (detaching) detach(if_block2_anchor);
    }
  };
}
function create_fragment$e(ctx) {
  var _a;
  let form_1;
  let updating_formEl;
  let current;
  function form_1_formEl_binding(value) {
    ctx[12](value);
  }
  let form_1_props = {
    ariaDescribedBy: "formFailureMessageAlert",
    onSubmitWhenValid: (
      /*form*/
      (_a = ctx[2]) == null ? void 0 : _a.submit
    ),
    $$slots: { default: [create_default_slot$8] },
    $$scope: { ctx }
  };
  if (
    /*formEl*/
    ctx[0] !== void 0
  ) {
    form_1_props.formEl = /*formEl*/
    ctx[0];
  }
  form_1 = new Form({ props: form_1_props });
  binding_callbacks.push(() => bind(form_1, "formEl", form_1_formEl_binding));
  return {
    c() {
      create_component(form_1.$$.fragment);
    },
    m(target, anchor) {
      mount_component(form_1, target, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      var _a2;
      const form_1_changes = {};
      if (dirty & /*form*/
      4) form_1_changes.onSubmitWhenValid = /*form*/
      (_a2 = ctx2[2]) == null ? void 0 : _a2.submit;
      if (dirty & /*$$scope, journey, buttons, metadata, modifiedCallbacks, $style, alertNeedsFocus, formMessageKey, form, componentStyle*/
      66558) {
        form_1_changes.$$scope = { dirty, ctx: ctx2 };
      }
      if (!updating_formEl && dirty & /*formEl*/
      1) {
        updating_formEl = true;
        form_1_changes.formEl = /*formEl*/
        ctx2[0];
        add_flush_callback(() => updating_formEl = false);
      }
      form_1.$set(form_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(form_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(form_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(form_1, detaching);
    }
  };
}
function instance$e($$self, $$props, $$invalidate) {
  let $style;
  component_subscribe($$self, styleStore, ($$value) => $$invalidate(9, $style = $$value));
  let { componentStyle } = $$props;
  let { form } = $$props;
  let { formEl = null } = $$props;
  let { journey: journey2 } = $$props;
  let { metadata } = $$props;
  let { step } = $$props;
  let alertNeedsFocus = false;
  let buttons;
  let formMessageKey = "";
  let modifiedCallbacks = [];
  function determineSubmission() {
    var _a;
    if ((_a = metadata == null ? void 0 : metadata.step) == null ? void 0 : _a.derived.isStepSelfSubmittable()) {
      form == null ? void 0 : form.submit();
    }
  }
  afterUpdate(() => {
    $$invalidate(5, alertNeedsFocus = !!(form == null ? void 0 : form.message));
  });
  function form_1_formEl_binding(value) {
    formEl = value;
    $$invalidate(0, formEl);
  }
  $$self.$$set = ($$props2) => {
    if ("componentStyle" in $$props2) $$invalidate(1, componentStyle = $$props2.componentStyle);
    if ("form" in $$props2) $$invalidate(2, form = $$props2.form);
    if ("formEl" in $$props2) $$invalidate(0, formEl = $$props2.formEl);
    if ("journey" in $$props2) $$invalidate(3, journey2 = $$props2.journey);
    if ("metadata" in $$props2) $$invalidate(4, metadata = $$props2.metadata);
    if ("step" in $$props2) $$invalidate(11, step = $$props2.step);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*form, step*/
    2052) {
      {
        $$invalidate(7, formMessageKey = convertStringToKey(form == null ? void 0 : form.message));
        const confirmationCallbacks = step.getCallbacksOfType(l.ConfirmationCallback);
        if (confirmationCallbacks.length) {
          const confirmationCb = confirmationCallbacks[0];
          $$invalidate(6, buttons = confirmationCb.getOptions().map((option, index) => ({ value: `${index}`, text: option })));
        }
        $$invalidate(8, modifiedCallbacks = step.callbacks.filter((callback) => {
          if (callback.getType() === l.ConfirmationCallback) {
            return false;
          }
          return true;
        }));
      }
    }
  };
  return [
    formEl,
    componentStyle,
    form,
    journey2,
    metadata,
    alertNeedsFocus,
    buttons,
    formMessageKey,
    modifiedCallbacks,
    $style,
    determineSubmission,
    step,
    form_1_formEl_binding
  ];
}
var One_time_password = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$e, create_fragment$e, safe_not_equal, {
      componentStyle: 1,
      form: 2,
      formEl: 0,
      journey: 3,
      metadata: 4,
      step: 11
    });
  }
};
function create_fragment$d(ctx) {
  let svg;
  let path0;
  let path1;
  let title;
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[3].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[2],
    null
  );
  return {
    c() {
      svg = svg_element("svg");
      path0 = svg_element("path");
      path1 = svg_element("path");
      title = svg_element("title");
      if (default_slot) default_slot.c();
      attr(path0, "d", "M0 0h24v24H0z");
      attr(path0, "fill", "none");
      attr(path1, "d", "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z");
      attr(
        svg,
        "class",
        /*classes*/
        ctx[0]
      );
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(
        svg,
        "height",
        /*size*/
        ctx[1]
      );
      attr(svg, "viewBox", "0 0 24 24");
      attr(
        svg,
        "width",
        /*size*/
        ctx[1]
      );
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path0);
      append(svg, path1);
      append(svg, title);
      if (default_slot) {
        default_slot.m(title, null);
      }
      current = true;
    },
    p(ctx2, [dirty]) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        4)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[2],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[2]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[2],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (!current || dirty & /*classes*/
      1) {
        attr(
          svg,
          "class",
          /*classes*/
          ctx2[0]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "height",
          /*size*/
          ctx2[1]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "width",
          /*size*/
          ctx2[1]
        );
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(svg);
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function instance$d($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { classes = "" } = $$props;
  let { size = "24px" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("classes" in $$props2) $$invalidate(0, classes = $$props2.classes);
    if ("size" in $$props2) $$invalidate(1, size = $$props2.size);
    if ("$$scope" in $$props2) $$invalidate(2, $$scope = $$props2.$$scope);
  };
  return [classes, size, $$scope, slots];
}
var New_user_icon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$d, create_fragment$d, safe_not_equal, { classes: 0, size: 1 });
  }
};
function get_each_context$4(ctx, list, i9) {
  const child_ctx = ctx.slice();
  child_ctx[13] = list[i9];
  child_ctx[15] = i9;
  return child_ctx;
}
function create_if_block_2$4(ctx) {
  var _a;
  let t0;
  let h1;
  let t1;
  let t22;
  let p4;
  let t3;
  let current;
  let if_block = (
    /*form*/
    ((_a = ctx[2]) == null ? void 0 : _a.icon) && create_if_block_3$4()
  );
  t1 = new Locale_strings({ props: { key: "registerHeader" } });
  t3 = new Locale_strings({
    props: { key: "alreadyHaveAnAccount", html: true }
  });
  return {
    c() {
      if (if_block) if_block.c();
      t0 = space();
      h1 = element("h1");
      create_component(t1.$$.fragment);
      t22 = space();
      p4 = element("p");
      create_component(t3.$$.fragment);
      attr(h1, "class", "tw_primary-header dark:tw_primary-header_dark");
      attr(p4, "class", "tw_text-base tw_text-center tw_-mt-5 tw_mb-2 tw_py-4 tw_text-secondary-dark dark:tw_text-secondary-light");
    },
    m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      insert(target, t0, anchor);
      insert(target, h1, anchor);
      mount_component(t1, h1, null);
      insert(target, t22, anchor);
      insert(target, p4, anchor);
      mount_component(t3, p4, null);
      ctx[11](p4);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      if (
        /*form*/
        (_a2 = ctx2[2]) == null ? void 0 : _a2.icon
      ) {
        if (if_block) {
          if (dirty & /*form*/
          4) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block_3$4();
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(t0.parentNode, t0);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      transition_in(t1.$$.fragment, local);
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      transition_out(t1.$$.fragment, local);
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (if_block) if_block.d(detaching);
      if (detaching) detach(t0);
      if (detaching) detach(h1);
      destroy_component(t1);
      if (detaching) detach(t22);
      if (detaching) detach(p4);
      destroy_component(t3);
      ctx[11](null);
    }
  };
}
function create_if_block_3$4(ctx) {
  let div;
  let newusericon;
  let current;
  newusericon = new New_user_icon({
    props: {
      classes: "tw_text-gray-400 tw_fill-current",
      size: "72px"
    }
  });
  return {
    c() {
      div = element("div");
      create_component(newusericon.$$.fragment);
      attr(div, "class", "tw_flex tw_justify-center");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(newusericon, div, null);
      current = true;
    },
    i(local) {
      if (current) return;
      transition_in(newusericon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(newusericon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(newusericon);
    }
  };
}
function create_if_block_1$5(ctx) {
  let alert;
  let current;
  alert = new Alert({
    props: {
      id: "formFailureMessageAlert",
      needsFocus: (
        /*alertNeedsFocus*/
        ctx[6]
      ),
      type: "error",
      $$slots: { default: [create_default_slot_2$3] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(alert.$$.fragment);
    },
    m(target, anchor) {
      mount_component(alert, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const alert_changes = {};
      if (dirty & /*alertNeedsFocus*/
      64) alert_changes.needsFocus = /*alertNeedsFocus*/
      ctx2[6];
      if (dirty & /*$$scope, formMessageKey, form*/
      65668) {
        alert_changes.$$scope = { dirty, ctx: ctx2 };
      }
      alert.$set(alert_changes);
    },
    i(local) {
      if (current) return;
      transition_in(alert.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(alert.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(alert, detaching);
    }
  };
}
function create_default_slot_2$3(ctx) {
  var _a;
  let t_value = interpolate(
    /*formMessageKey*/
    ctx[7],
    null,
    /*form*/
    (_a = ctx[2]) == null ? void 0 : _a.message
  ) + "";
  let t3;
  return {
    c() {
      t3 = text(t_value);
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    p(ctx2, dirty) {
      var _a2;
      if (dirty & /*formMessageKey, form*/
      132 && t_value !== (t_value = interpolate(
        /*formMessageKey*/
        ctx2[7],
        null,
        /*form*/
        (_a2 = ctx2[2]) == null ? void 0 : _a2.message
      ) + "")) set_data(t3, t_value);
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_each_block$4(ctx) {
  var _a, _b;
  let callbackmapper;
  let current;
  callbackmapper = new Callback_mapper({
    props: {
      props: {
        callback: (
          /*callback*/
          ctx[13]
        ),
        callbackMetadata: (
          /*metadata*/
          (_a = ctx[4]) == null ? void 0 : _a.callbacks[
            /*idx*/
            ctx[15]
          ]
        ),
        selfSubmitFunction: (
          /*determineSubmission*/
          ctx[10]
        ),
        stepMetadata: (
          /*metadata*/
          ((_b = ctx[4]) == null ? void 0 : _b.step) && __spreadValues(
            {},
            /*metadata*/
            ctx[4].step
          )
        ),
        style: (
          /*$styleStore*/
          ctx[9]
        )
      }
    }
  });
  return {
    c() {
      create_component(callbackmapper.$$.fragment);
    },
    m(target, anchor) {
      mount_component(callbackmapper, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2, _b2;
      const callbackmapper_changes = {};
      if (dirty & /*step, metadata, $styleStore*/
      560) callbackmapper_changes.props = {
        callback: (
          /*callback*/
          ctx2[13]
        ),
        callbackMetadata: (
          /*metadata*/
          (_a2 = ctx2[4]) == null ? void 0 : _a2.callbacks[
            /*idx*/
            ctx2[15]
          ]
        ),
        selfSubmitFunction: (
          /*determineSubmission*/
          ctx2[10]
        ),
        stepMetadata: (
          /*metadata*/
          ((_b2 = ctx2[4]) == null ? void 0 : _b2.step) && __spreadValues(
            {},
            /*metadata*/
            ctx2[4].step
          )
        ),
        style: (
          /*$styleStore*/
          ctx2[9]
        )
      };
      callbackmapper.$set(callbackmapper_changes);
    },
    i(local) {
      if (current) return;
      transition_in(callbackmapper.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(callbackmapper.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(callbackmapper, detaching);
    }
  };
}
function create_if_block$7(ctx) {
  var _a;
  let button;
  let current;
  button = new Button({
    props: {
      busy: (
        /*journey*/
        (_a = ctx[3]) == null ? void 0 : _a.loading
      ),
      style: "primary",
      type: "submit",
      width: "full",
      $$slots: { default: [create_default_slot_1$6] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(button.$$.fragment);
    },
    m(target, anchor) {
      mount_component(button, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      const button_changes = {};
      if (dirty & /*journey*/
      8) button_changes.busy = /*journey*/
      (_a2 = ctx2[3]) == null ? void 0 : _a2.loading;
      if (dirty & /*$$scope*/
      65536) {
        button_changes.$$scope = { dirty, ctx: ctx2 };
      }
      button.$set(button_changes);
    },
    i(local) {
      if (current) return;
      transition_in(button.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(button.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(button, detaching);
    }
  };
}
function create_default_slot_1$6(ctx) {
  let t3;
  let current;
  t3 = new Locale_strings({ props: { key: "registerButton" } });
  return {
    c() {
      create_component(t3.$$.fragment);
    },
    m(target, anchor) {
      mount_component(t3, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(t3, detaching);
    }
  };
}
function create_default_slot$7(ctx) {
  var _a, _b, _c, _d, _e;
  let t0;
  let t1;
  let t22;
  let show_if = (
    /*metadata*/
    ((_b = (_a = ctx[4]) == null ? void 0 : _a.step) == null ? void 0 : _b.derived.isUserInputOptional) || !/*metadata*/
    ((_d = (_c = ctx[4]) == null ? void 0 : _c.step) == null ? void 0 : _d.derived.isStepSelfSubmittable())
  );
  let if_block2_anchor;
  let current;
  let if_block0 = (
    /*componentStyle*/
    ctx[1] !== "inline" && create_if_block_2$4(ctx)
  );
  let if_block1 = (
    /*form*/
    ctx[2].message && create_if_block_1$5(ctx)
  );
  let each_value = (
    /*step*/
    (_e = ctx[5]) == null ? void 0 : _e.callbacks
  );
  let each_blocks = [];
  for (let i9 = 0; i9 < each_value.length; i9 += 1) {
    each_blocks[i9] = create_each_block$4(get_each_context$4(ctx, each_value, i9));
  }
  const out = (i9) => transition_out(each_blocks[i9], 1, 1, () => {
    each_blocks[i9] = null;
  });
  let if_block2 = show_if && create_if_block$7(ctx);
  return {
    c() {
      if (if_block0) if_block0.c();
      t0 = space();
      if (if_block1) if_block1.c();
      t1 = space();
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].c();
      }
      t22 = space();
      if (if_block2) if_block2.c();
      if_block2_anchor = empty();
    },
    m(target, anchor) {
      if (if_block0) if_block0.m(target, anchor);
      insert(target, t0, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, t1, anchor);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].m(target, anchor);
      }
      insert(target, t22, anchor);
      if (if_block2) if_block2.m(target, anchor);
      insert(target, if_block2_anchor, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2, _b2, _c2, _d2, _e2;
      if (
        /*componentStyle*/
        ctx2[1] !== "inline"
      ) {
        if (if_block0) {
          if_block0.p(ctx2, dirty);
          if (dirty & /*componentStyle*/
          2) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_2$4(ctx2);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(t0.parentNode, t0);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      if (
        /*form*/
        ctx2[2].message
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
          if (dirty & /*form*/
          4) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block_1$5(ctx2);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(t1.parentNode, t1);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
      if (dirty & /*step, metadata, determineSubmission, $styleStore*/
      1584) {
        each_value = /*step*/
        (_a2 = ctx2[5]) == null ? void 0 : _a2.callbacks;
        let i9;
        for (i9 = 0; i9 < each_value.length; i9 += 1) {
          const child_ctx = get_each_context$4(ctx2, each_value, i9);
          if (each_blocks[i9]) {
            each_blocks[i9].p(child_ctx, dirty);
            transition_in(each_blocks[i9], 1);
          } else {
            each_blocks[i9] = create_each_block$4(child_ctx);
            each_blocks[i9].c();
            transition_in(each_blocks[i9], 1);
            each_blocks[i9].m(t22.parentNode, t22);
          }
        }
        group_outros();
        for (i9 = each_value.length; i9 < each_blocks.length; i9 += 1) {
          out(i9);
        }
        check_outros();
      }
      if (dirty & /*metadata*/
      16) show_if = /*metadata*/
      ((_c2 = (_b2 = ctx2[4]) == null ? void 0 : _b2.step) == null ? void 0 : _c2.derived.isUserInputOptional) || !/*metadata*/
      ((_e2 = (_d2 = ctx2[4]) == null ? void 0 : _d2.step) == null ? void 0 : _e2.derived.isStepSelfSubmittable());
      if (show_if) {
        if (if_block2) {
          if_block2.p(ctx2, dirty);
          if (dirty & /*metadata*/
          16) {
            transition_in(if_block2, 1);
          }
        } else {
          if_block2 = create_if_block$7(ctx2);
          if_block2.c();
          transition_in(if_block2, 1);
          if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
        }
      } else if (if_block2) {
        group_outros();
        transition_out(if_block2, 1, 1, () => {
          if_block2 = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block0);
      transition_in(if_block1);
      for (let i9 = 0; i9 < each_value.length; i9 += 1) {
        transition_in(each_blocks[i9]);
      }
      transition_in(if_block2);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(if_block1);
      each_blocks = each_blocks.filter(Boolean);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        transition_out(each_blocks[i9]);
      }
      transition_out(if_block2);
      current = false;
    },
    d(detaching) {
      if (if_block0) if_block0.d(detaching);
      if (detaching) detach(t0);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(t1);
      destroy_each(each_blocks, detaching);
      if (detaching) detach(t22);
      if (if_block2) if_block2.d(detaching);
      if (detaching) detach(if_block2_anchor);
    }
  };
}
function create_fragment$c(ctx) {
  var _a;
  let form_1;
  let updating_formEl;
  let current;
  function form_1_formEl_binding(value) {
    ctx[12](value);
  }
  let form_1_props = {
    ariaDescribedBy: "formFailureMessageAlert",
    onSubmitWhenValid: (
      /*form*/
      (_a = ctx[2]) == null ? void 0 : _a.submit
    ),
    $$slots: { default: [create_default_slot$7] },
    $$scope: { ctx }
  };
  if (
    /*formEl*/
    ctx[0] !== void 0
  ) {
    form_1_props.formEl = /*formEl*/
    ctx[0];
  }
  form_1 = new Form({ props: form_1_props });
  binding_callbacks.push(() => bind(form_1, "formEl", form_1_formEl_binding));
  return {
    c() {
      create_component(form_1.$$.fragment);
    },
    m(target, anchor) {
      mount_component(form_1, target, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      var _a2;
      const form_1_changes = {};
      if (dirty & /*form*/
      4) form_1_changes.onSubmitWhenValid = /*form*/
      (_a2 = ctx2[2]) == null ? void 0 : _a2.submit;
      if (dirty & /*$$scope, journey, metadata, step, $styleStore, alertNeedsFocus, formMessageKey, form, linkWrapper, componentStyle*/
      66558) {
        form_1_changes.$$scope = { dirty, ctx: ctx2 };
      }
      if (!updating_formEl && dirty & /*formEl*/
      1) {
        updating_formEl = true;
        form_1_changes.formEl = /*formEl*/
        ctx2[0];
        add_flush_callback(() => updating_formEl = false);
      }
      form_1.$set(form_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(form_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(form_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(form_1, detaching);
    }
  };
}
function instance$c($$self, $$props, $$invalidate) {
  let $styleStore;
  component_subscribe($$self, styleStore, ($$value) => $$invalidate(9, $styleStore = $$value));
  let { componentStyle } = $$props;
  let { form } = $$props;
  let { formEl = null } = $$props;
  let { journey: journey2 } = $$props;
  let { metadata } = $$props;
  let { step } = $$props;
  let alertNeedsFocus = false;
  let formMessageKey = "";
  let linkWrapper;
  function determineSubmission() {
    var _a;
    if ((_a = metadata == null ? void 0 : metadata.step) == null ? void 0 : _a.derived.isStepSelfSubmittable()) {
      form == null ? void 0 : form.submit();
    }
  }
  afterUpdate(() => {
    $$invalidate(6, alertNeedsFocus = !!(form == null ? void 0 : form.message));
  });
  onMount(() => {
    if (componentStyle === "modal") {
      captureLinks(linkWrapper, journey2);
    }
  });
  function p_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      linkWrapper = $$value;
      $$invalidate(8, linkWrapper);
    });
  }
  function form_1_formEl_binding(value) {
    formEl = value;
    $$invalidate(0, formEl);
  }
  $$self.$$set = ($$props2) => {
    if ("componentStyle" in $$props2) $$invalidate(1, componentStyle = $$props2.componentStyle);
    if ("form" in $$props2) $$invalidate(2, form = $$props2.form);
    if ("formEl" in $$props2) $$invalidate(0, formEl = $$props2.formEl);
    if ("journey" in $$props2) $$invalidate(3, journey2 = $$props2.journey);
    if ("metadata" in $$props2) $$invalidate(4, metadata = $$props2.metadata);
    if ("step" in $$props2) $$invalidate(5, step = $$props2.step);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*form*/
    4) {
      {
        $$invalidate(7, formMessageKey = convertStringToKey(form == null ? void 0 : form.message));
      }
    }
  };
  return [
    formEl,
    componentStyle,
    form,
    journey2,
    metadata,
    step,
    alertNeedsFocus,
    formMessageKey,
    linkWrapper,
    $styleStore,
    determineSubmission,
    p_binding,
    form_1_formEl_binding
  ];
}
var Registration = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$c, create_fragment$c, safe_not_equal, {
      componentStyle: 1,
      form: 2,
      formEl: 0,
      journey: 3,
      metadata: 4,
      step: 5
    });
  }
};
function get_each_context$3(ctx, list, i9) {
  const child_ctx = ctx.slice();
  child_ctx[15] = list[i9];
  child_ctx[17] = i9;
  return child_ctx;
}
function create_if_block_3$3(ctx) {
  var _a;
  let t0;
  let h1;
  let t1;
  let current;
  let if_block = (
    /*form*/
    ((_a = ctx[2]) == null ? void 0 : _a.icon) && create_if_block_4$2()
  );
  t1 = new Locale_strings({ props: { key: "loginHeader" } });
  return {
    c() {
      if (if_block) if_block.c();
      t0 = space();
      h1 = element("h1");
      create_component(t1.$$.fragment);
      attr(h1, "class", "tw_primary-header dark:tw_primary-header_dark");
    },
    m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      insert(target, t0, anchor);
      insert(target, h1, anchor);
      mount_component(t1, h1, null);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      if (
        /*form*/
        (_a2 = ctx2[2]) == null ? void 0 : _a2.icon
      ) {
        if (if_block) {
          if (dirty & /*form*/
          4) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block_4$2();
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(t0.parentNode, t0);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      transition_in(t1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      transition_out(t1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (if_block) if_block.d(detaching);
      if (detaching) detach(t0);
      if (detaching) detach(h1);
      destroy_component(t1);
    }
  };
}
function create_if_block_4$2(ctx) {
  let div;
  let keyicon;
  let current;
  keyicon = new Key_icon({
    props: {
      classes: "tw_text-gray-400 tw_fill-current",
      size: "72px"
    }
  });
  return {
    c() {
      div = element("div");
      create_component(keyicon.$$.fragment);
      attr(div, "class", "tw_flex tw_justify-center");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(keyicon, div, null);
      current = true;
    },
    i(local) {
      if (current) return;
      transition_in(keyicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(keyicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(keyicon);
    }
  };
}
function create_if_block_2$3(ctx) {
  let alert;
  let current;
  alert = new Alert({
    props: {
      id: "formFailureMessageAlert",
      needsFocus: (
        /*alertNeedsFocus*/
        ctx[6]
      ),
      type: "error",
      $$slots: { default: [create_default_slot_2$2] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(alert.$$.fragment);
    },
    m(target, anchor) {
      mount_component(alert, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const alert_changes = {};
      if (dirty & /*alertNeedsFocus*/
      64) alert_changes.needsFocus = /*alertNeedsFocus*/
      ctx2[6];
      if (dirty & /*$$scope, formMessageKey, form*/
      262276) {
        alert_changes.$$scope = { dirty, ctx: ctx2 };
      }
      alert.$set(alert_changes);
    },
    i(local) {
      if (current) return;
      transition_in(alert.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(alert.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(alert, detaching);
    }
  };
}
function create_default_slot_2$2(ctx) {
  var _a;
  let t_value = interpolate(
    /*formMessageKey*/
    ctx[7],
    null,
    /*form*/
    (_a = ctx[2]) == null ? void 0 : _a.message
  ) + "";
  let t3;
  return {
    c() {
      t3 = text(t_value);
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    p(ctx2, dirty) {
      var _a2;
      if (dirty & /*formMessageKey, form*/
      132 && t_value !== (t_value = interpolate(
        /*formMessageKey*/
        ctx2[7],
        null,
        /*form*/
        (_a2 = ctx2[2]) == null ? void 0 : _a2.message
      ) + "")) set_data(t3, t_value);
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_each_block$3(ctx) {
  var _a, _b;
  let callbackmapper;
  let current;
  callbackmapper = new Callback_mapper({
    props: {
      props: {
        callback: (
          /*callback*/
          ctx[15]
        ),
        callbackMetadata: (
          /*metadata*/
          (_a = ctx[4]) == null ? void 0 : _a.callbacks[
            /*idx*/
            ctx[17]
          ]
        ),
        selfSubmitFunction: (
          /*determineSubmission*/
          ctx[10]
        ),
        stepMetadata: (
          /*metadata*/
          ((_b = ctx[4]) == null ? void 0 : _b.step) && __spreadValues(
            {},
            /*metadata*/
            ctx[4].step
          )
        ),
        style: (
          /*$styleStore*/
          ctx[9]
        )
      }
    }
  });
  return {
    c() {
      create_component(callbackmapper.$$.fragment);
    },
    m(target, anchor) {
      mount_component(callbackmapper, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2, _b2;
      const callbackmapper_changes = {};
      if (dirty & /*step, metadata, $styleStore*/
      560) callbackmapper_changes.props = {
        callback: (
          /*callback*/
          ctx2[15]
        ),
        callbackMetadata: (
          /*metadata*/
          (_a2 = ctx2[4]) == null ? void 0 : _a2.callbacks[
            /*idx*/
            ctx2[17]
          ]
        ),
        selfSubmitFunction: (
          /*determineSubmission*/
          ctx2[10]
        ),
        stepMetadata: (
          /*metadata*/
          ((_b2 = ctx2[4]) == null ? void 0 : _b2.step) && __spreadValues(
            {},
            /*metadata*/
            ctx2[4].step
          )
        ),
        style: (
          /*$styleStore*/
          ctx2[9]
        )
      };
      callbackmapper.$set(callbackmapper_changes);
    },
    i(local) {
      if (current) return;
      transition_in(callbackmapper.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(callbackmapper.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(callbackmapper, detaching);
    }
  };
}
function create_if_block_1$4(ctx) {
  var _a;
  let button;
  let current;
  button = new Button({
    props: {
      busy: (
        /*journey*/
        (_a = ctx[3]) == null ? void 0 : _a.loading
      ),
      style: "primary",
      type: "submit",
      width: "full",
      $$slots: { default: [create_default_slot_1$5] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(button.$$.fragment);
    },
    m(target, anchor) {
      mount_component(button, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      const button_changes = {};
      if (dirty & /*journey*/
      8) button_changes.busy = /*journey*/
      (_a2 = ctx2[3]) == null ? void 0 : _a2.loading;
      if (dirty & /*$$scope*/
      262144) {
        button_changes.$$scope = { dirty, ctx: ctx2 };
      }
      button.$set(button_changes);
    },
    i(local) {
      if (current) return;
      transition_in(button.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(button.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(button, detaching);
    }
  };
}
function create_default_slot_1$5(ctx) {
  let t3;
  let current;
  t3 = new Locale_strings({ props: { key: "loginButton" } });
  return {
    c() {
      create_component(t3.$$.fragment);
    },
    m(target, anchor) {
      mount_component(t3, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(t3, detaching);
    }
  };
}
function create_if_block$6(ctx) {
  let p0;
  let button0;
  let t1;
  let button1;
  let t3;
  let hr;
  let t4;
  let p1;
  let t5;
  let current;
  let mounted;
  let dispose;
  t5 = new Locale_strings({
    props: { key: "dontHaveAnAccount", html: true }
  });
  return {
    c() {
      p0 = element("p");
      button0 = element("button");
      button0.textContent = `${interpolate("forgotPassword", null, "Forgot Password?")}`;
      t1 = text("\n      \xA0\n      ");
      button1 = element("button");
      button1.textContent = `${interpolate("forgotUsername", null, "Forgot Username?")}`;
      t3 = space();
      hr = element("hr");
      t4 = space();
      p1 = element("p");
      create_component(t5.$$.fragment);
      attr(p0, "class", "tw_my-4 tw_text-base tw_text-center tw_text-link-dark dark:tw_text-link-light");
      attr(hr, "class", "tw_border-0 tw_border-b tw_border-secondary-light dark:tw_border-secondary-dark");
      attr(p1, "class", "tw_text-base tw_text-center tw_py-4 tw_text-secondary-dark dark:tw_text-secondary-light");
    },
    m(target, anchor) {
      insert(target, p0, anchor);
      append(p0, button0);
      append(p0, t1);
      append(p0, button1);
      insert(target, t3, anchor);
      insert(target, hr, anchor);
      insert(target, t4, anchor);
      insert(target, p1, anchor);
      mount_component(t5, p1, null);
      ctx[13](p1);
      current = true;
      if (!mounted) {
        dispose = [
          listen(button0, "click", prevent_default(
            /*click_handler*/
            ctx[11]
          )),
          listen(button1, "click", prevent_default(
            /*click_handler_1*/
            ctx[12]
          ))
        ];
        mounted = true;
      }
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(t5.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t5.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(p0);
      if (detaching) detach(t3);
      if (detaching) detach(hr);
      if (detaching) detach(t4);
      if (detaching) detach(p1);
      destroy_component(t5);
      ctx[13](null);
      mounted = false;
      run_all(dispose);
    }
  };
}
function create_default_slot$6(ctx) {
  var _a, _b, _c, _d, _e, _f;
  let t0;
  let t1;
  let t22;
  let show_if = (
    /*metadata*/
    ((_b = (_a = ctx[4]) == null ? void 0 : _a.step) == null ? void 0 : _b.derived.isUserInputOptional) || !/*metadata*/
    ((_d = (_c = ctx[4]) == null ? void 0 : _c.step) == null ? void 0 : _d.derived.isStepSelfSubmittable())
  );
  let t3;
  let if_block3_anchor;
  let current;
  let if_block0 = (
    /*componentStyle*/
    ctx[1] !== "inline" && create_if_block_3$3(ctx)
  );
  let if_block1 = (
    /*form*/
    ((_e = ctx[2]) == null ? void 0 : _e.message) && create_if_block_2$3(ctx)
  );
  let each_value = (
    /*step*/
    (_f = ctx[5]) == null ? void 0 : _f.callbacks
  );
  let each_blocks = [];
  for (let i9 = 0; i9 < each_value.length; i9 += 1) {
    each_blocks[i9] = create_each_block$3(get_each_context$3(ctx, each_value, i9));
  }
  const out = (i9) => transition_out(each_blocks[i9], 1, 1, () => {
    each_blocks[i9] = null;
  });
  let if_block2 = show_if && create_if_block_1$4(ctx);
  let if_block3 = (
    /*componentStyle*/
    ctx[1] !== "inline" && create_if_block$6(ctx)
  );
  return {
    c() {
      if (if_block0) if_block0.c();
      t0 = space();
      if (if_block1) if_block1.c();
      t1 = space();
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].c();
      }
      t22 = space();
      if (if_block2) if_block2.c();
      t3 = space();
      if (if_block3) if_block3.c();
      if_block3_anchor = empty();
    },
    m(target, anchor) {
      if (if_block0) if_block0.m(target, anchor);
      insert(target, t0, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, t1, anchor);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].m(target, anchor);
      }
      insert(target, t22, anchor);
      if (if_block2) if_block2.m(target, anchor);
      insert(target, t3, anchor);
      if (if_block3) if_block3.m(target, anchor);
      insert(target, if_block3_anchor, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2, _b2, _c2, _d2, _e2, _f2;
      if (
        /*componentStyle*/
        ctx2[1] !== "inline"
      ) {
        if (if_block0) {
          if_block0.p(ctx2, dirty);
          if (dirty & /*componentStyle*/
          2) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_3$3(ctx2);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(t0.parentNode, t0);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      if (
        /*form*/
        (_a2 = ctx2[2]) == null ? void 0 : _a2.message
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
          if (dirty & /*form*/
          4) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block_2$3(ctx2);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(t1.parentNode, t1);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
      if (dirty & /*step, metadata, determineSubmission, $styleStore*/
      1584) {
        each_value = /*step*/
        (_b2 = ctx2[5]) == null ? void 0 : _b2.callbacks;
        let i9;
        for (i9 = 0; i9 < each_value.length; i9 += 1) {
          const child_ctx = get_each_context$3(ctx2, each_value, i9);
          if (each_blocks[i9]) {
            each_blocks[i9].p(child_ctx, dirty);
            transition_in(each_blocks[i9], 1);
          } else {
            each_blocks[i9] = create_each_block$3(child_ctx);
            each_blocks[i9].c();
            transition_in(each_blocks[i9], 1);
            each_blocks[i9].m(t22.parentNode, t22);
          }
        }
        group_outros();
        for (i9 = each_value.length; i9 < each_blocks.length; i9 += 1) {
          out(i9);
        }
        check_outros();
      }
      if (dirty & /*metadata*/
      16) show_if = /*metadata*/
      ((_d2 = (_c2 = ctx2[4]) == null ? void 0 : _c2.step) == null ? void 0 : _d2.derived.isUserInputOptional) || !/*metadata*/
      ((_f2 = (_e2 = ctx2[4]) == null ? void 0 : _e2.step) == null ? void 0 : _f2.derived.isStepSelfSubmittable());
      if (show_if) {
        if (if_block2) {
          if_block2.p(ctx2, dirty);
          if (dirty & /*metadata*/
          16) {
            transition_in(if_block2, 1);
          }
        } else {
          if_block2 = create_if_block_1$4(ctx2);
          if_block2.c();
          transition_in(if_block2, 1);
          if_block2.m(t3.parentNode, t3);
        }
      } else if (if_block2) {
        group_outros();
        transition_out(if_block2, 1, 1, () => {
          if_block2 = null;
        });
        check_outros();
      }
      if (
        /*componentStyle*/
        ctx2[1] !== "inline"
      ) {
        if (if_block3) {
          if_block3.p(ctx2, dirty);
          if (dirty & /*componentStyle*/
          2) {
            transition_in(if_block3, 1);
          }
        } else {
          if_block3 = create_if_block$6(ctx2);
          if_block3.c();
          transition_in(if_block3, 1);
          if_block3.m(if_block3_anchor.parentNode, if_block3_anchor);
        }
      } else if (if_block3) {
        group_outros();
        transition_out(if_block3, 1, 1, () => {
          if_block3 = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block0);
      transition_in(if_block1);
      for (let i9 = 0; i9 < each_value.length; i9 += 1) {
        transition_in(each_blocks[i9]);
      }
      transition_in(if_block2);
      transition_in(if_block3);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(if_block1);
      each_blocks = each_blocks.filter(Boolean);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        transition_out(each_blocks[i9]);
      }
      transition_out(if_block2);
      transition_out(if_block3);
      current = false;
    },
    d(detaching) {
      if (if_block0) if_block0.d(detaching);
      if (detaching) detach(t0);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(t1);
      destroy_each(each_blocks, detaching);
      if (detaching) detach(t22);
      if (if_block2) if_block2.d(detaching);
      if (detaching) detach(t3);
      if (if_block3) if_block3.d(detaching);
      if (detaching) detach(if_block3_anchor);
    }
  };
}
function create_fragment$b(ctx) {
  var _a;
  let form_1;
  let updating_formEl;
  let current;
  function form_1_formEl_binding(value) {
    ctx[14](value);
  }
  let form_1_props = {
    ariaDescribedBy: "formFailureMessageAlert",
    onSubmitWhenValid: (
      /*form*/
      (_a = ctx[2]) == null ? void 0 : _a.submit
    ),
    $$slots: { default: [create_default_slot$6] },
    $$scope: { ctx }
  };
  if (
    /*formEl*/
    ctx[0] !== void 0
  ) {
    form_1_props.formEl = /*formEl*/
    ctx[0];
  }
  form_1 = new Form({ props: form_1_props });
  binding_callbacks.push(() => bind(form_1, "formEl", form_1_formEl_binding));
  return {
    c() {
      create_component(form_1.$$.fragment);
    },
    m(target, anchor) {
      mount_component(form_1, target, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      var _a2;
      const form_1_changes = {};
      if (dirty & /*form*/
      4) form_1_changes.onSubmitWhenValid = /*form*/
      (_a2 = ctx2[2]) == null ? void 0 : _a2.submit;
      if (dirty & /*$$scope, linkWrapper, journey, componentStyle, metadata, step, $styleStore, alertNeedsFocus, formMessageKey, form*/
      263166) {
        form_1_changes.$$scope = { dirty, ctx: ctx2 };
      }
      if (!updating_formEl && dirty & /*formEl*/
      1) {
        updating_formEl = true;
        form_1_changes.formEl = /*formEl*/
        ctx2[0];
        add_flush_callback(() => updating_formEl = false);
      }
      form_1.$set(form_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(form_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(form_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(form_1, detaching);
    }
  };
}
function instance$b($$self, $$props, $$invalidate) {
  let $styleStore;
  component_subscribe($$self, styleStore, ($$value) => $$invalidate(9, $styleStore = $$value));
  let { componentStyle } = $$props;
  let { form } = $$props;
  let { formEl = null } = $$props;
  let { journey: journey2 } = $$props;
  let { metadata } = $$props;
  let { step } = $$props;
  let alertNeedsFocus = false;
  let formMessageKey = "";
  let linkWrapper;
  function determineSubmission() {
    var _a;
    if ((_a = metadata == null ? void 0 : metadata.step) == null ? void 0 : _a.derived.isStepSelfSubmittable()) {
      form == null ? void 0 : form.submit();
    }
  }
  afterUpdate(() => {
    $$invalidate(6, alertNeedsFocus = !!(form == null ? void 0 : form.message));
  });
  onMount(() => {
    if (componentStyle === "modal") {
      captureLinks(linkWrapper, journey2);
    }
  });
  const click_handler = () => {
    journey2.push({ tree: "ResetPassword" });
  };
  const click_handler_1 = () => {
    journey2.push({ tree: "ForgottenUsername" });
  };
  function p1_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      linkWrapper = $$value;
      $$invalidate(8, linkWrapper);
    });
  }
  function form_1_formEl_binding(value) {
    formEl = value;
    $$invalidate(0, formEl);
  }
  $$self.$$set = ($$props2) => {
    if ("componentStyle" in $$props2) $$invalidate(1, componentStyle = $$props2.componentStyle);
    if ("form" in $$props2) $$invalidate(2, form = $$props2.form);
    if ("formEl" in $$props2) $$invalidate(0, formEl = $$props2.formEl);
    if ("journey" in $$props2) $$invalidate(3, journey2 = $$props2.journey);
    if ("metadata" in $$props2) $$invalidate(4, metadata = $$props2.metadata);
    if ("step" in $$props2) $$invalidate(5, step = $$props2.step);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*form*/
    4) {
      {
        $$invalidate(7, formMessageKey = convertStringToKey(form == null ? void 0 : form.message));
      }
    }
  };
  return [
    formEl,
    componentStyle,
    form,
    journey2,
    metadata,
    step,
    alertNeedsFocus,
    formMessageKey,
    linkWrapper,
    $styleStore,
    determineSubmission,
    click_handler,
    click_handler_1,
    p1_binding,
    form_1_formEl_binding
  ];
}
var Login = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$b, create_fragment$b, safe_not_equal, {
      componentStyle: 1,
      form: 2,
      formEl: 0,
      journey: 3,
      metadata: 4,
      step: 5
    });
  }
};
function create_fragment$a(ctx) {
  let svg;
  let path0;
  let path1;
  let path2;
  let path3;
  let path4;
  return {
    c() {
      svg = svg_element("svg");
      path0 = svg_element("path");
      path1 = svg_element("path");
      path2 = svg_element("path");
      path3 = svg_element("path");
      path4 = svg_element("path");
      attr(path0, "d", "M8.06 6.5a.5.5 0 0 1 .5.5v.776a11.5 11.5 0 0 1-.552 3.519l-1.331 4.14a.5.5 0 0 1-.952-.305l1.33-4.141a10.5 10.5 0 0 0 .504-3.213V7a.5.5 0 0 1 .5-.5Z");
      attr(path1, "d", "M6.06 7a2 2 0 1 1 4 0 .5.5 0 1 1-1 0 1 1 0 1 0-2 0v.332c0 .409-.022.816-.066 1.221A.5.5 0 0 1 6 8.447c.04-.37.06-.742.06-1.115V7Zm3.509 1a.5.5 0 0 1 .487.513 11.5 11.5 0 0 1-.587 3.339l-1.266 3.8a.5.5 0 0 1-.949-.317l1.267-3.8a10.5 10.5 0 0 0 .535-3.048A.5.5 0 0 1 9.569 8Zm-3.356 2.115a.5.5 0 0 1 .33.626L5.24 14.939a.5.5 0 1 1-.955-.296l1.303-4.199a.5.5 0 0 1 .625-.329Z");
      attr(path2, "d", "M4.759 5.833A3.501 3.501 0 0 1 11.559 7a.5.5 0 0 1-1 0 2.5 2.5 0 0 0-4.857-.833.5.5 0 1 1-.943-.334Zm.3 1.67a.5.5 0 0 1 .449.546 10.72 10.72 0 0 1-.4 2.031l-1.222 4.072a.5.5 0 1 1-.958-.287L4.15 9.793a9.72 9.72 0 0 0 .363-1.842.5.5 0 0 1 .546-.449Zm6 .647a.5.5 0 0 1 .5.5c0 1.28-.213 2.552-.632 3.762l-1.09 3.145a.5.5 0 0 1-.944-.327l1.089-3.145c.382-1.105.578-2.266.578-3.435a.5.5 0 0 1 .5-.5Z");
      attr(path3, "d", "M3.902 4.222a4.996 4.996 0 0 1 5.202-2.113.5.5 0 0 1-.208.979 3.996 3.996 0 0 0-4.163 1.69.5.5 0 0 1-.831-.556Zm6.72-.955a.5.5 0 0 1 .705-.052A4.99 4.99 0 0 1 13.059 7v1.5a.5.5 0 1 1-1 0V7a3.99 3.99 0 0 0-1.386-3.028.5.5 0 0 1-.051-.705ZM3.68 5.842a.5.5 0 0 1 .422.568c-.029.192-.044.39-.044.59 0 .71-.1 1.417-.298 2.1l-1.14 3.923a.5.5 0 1 1-.96-.279L2.8 8.821A6.531 6.531 0 0 0 3.058 7c0-.25.019-.496.054-.736a.5.5 0 0 1 .568-.422Zm8.882 3.66a.5.5 0 0 1 .456.54c-.084 1-.298 1.986-.64 2.934l-.744 2.068a.5.5 0 0 1-.941-.338l.745-2.07a10.51 10.51 0 0 0 .584-2.678.5.5 0 0 1 .54-.456Z");
      attr(path4, "d", "M4.81 1.37A6.5 6.5 0 0 1 14.56 7a.5.5 0 1 1-1 0 5.5 5.5 0 0 0-8.25-4.765.5.5 0 0 1-.5-.865Zm-.89 1.257a.5.5 0 0 1 .04.706A5.478 5.478 0 0 0 2.56 7a.5.5 0 0 1-1 0c0-1.664.626-3.184 1.655-4.333a.5.5 0 0 1 .706-.04ZM1.915 8.02a.5.5 0 0 1 .346.616l-.779 2.767a.5.5 0 1 1-.962-.27l.778-2.767a.5.5 0 0 1 .617-.346Zm12.15.481a.5.5 0 0 1 .49.51c-.03 1.499-.161 3.025-.727 4.533l-.07.187a.5.5 0 0 1-.936-.351l.07-.187c.506-1.35.634-2.74.663-4.202a.5.5 0 0 1 .51-.49Z");
      attr(
        svg,
        "class",
        /*classes*/
        ctx[0]
      );
      attr(
        svg,
        "height",
        /*size*/
        ctx[1]
      );
      attr(
        svg,
        "width",
        /*size*/
        ctx[1]
      );
      attr(svg, "viewBox", "0 0 16 16");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path0);
      append(svg, path1);
      append(svg, path2);
      append(svg, path3);
      append(svg, path4);
    },
    p(ctx2, [dirty]) {
      if (dirty & /*classes*/
      1) {
        attr(
          svg,
          "class",
          /*classes*/
          ctx2[0]
        );
      }
      if (dirty & /*size*/
      2) {
        attr(
          svg,
          "height",
          /*size*/
          ctx2[1]
        );
      }
      if (dirty & /*size*/
      2) {
        attr(
          svg,
          "width",
          /*size*/
          ctx2[1]
        );
      }
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
function instance$a($$self, $$props, $$invalidate) {
  let { classes = "" } = $$props;
  let { size = "24px" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("classes" in $$props2) $$invalidate(0, classes = $$props2.classes);
    if ("size" in $$props2) $$invalidate(1, size = $$props2.size);
  };
  return [classes, size];
}
var Fingerprint_icon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$a, create_fragment$a, safe_not_equal, { classes: 0, size: 1 });
  }
};
function create_if_block_4$1(ctx) {
  let div;
  let fingerprinticon;
  let current;
  fingerprinticon = new Fingerprint_icon({
    props: {
      classes: "tw_text-gray-400 tw_fill-current",
      size: "72px"
    }
  });
  return {
    c() {
      div = element("div");
      create_component(fingerprinticon.$$.fragment);
      attr(div, "class", "tw_flex tw_justify-center");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(fingerprinticon, div, null);
      current = true;
    },
    i(local) {
      if (current) return;
      transition_in(fingerprinticon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(fingerprinticon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(fingerprinticon);
    }
  };
}
function create_if_block_3$2(ctx) {
  let div;
  let spinner;
  let current;
  spinner = new Spinner({
    props: {
      colorClass: "tw_text-primary-light",
      layoutClasses: "tw_h-28 tw_w-28"
    }
  });
  return {
    c() {
      div = element("div");
      create_component(spinner.$$.fragment);
      attr(div, "class", "tw_text-center tw_w-full tw_py-4");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(spinner, div, null);
      current = true;
    },
    i(local) {
      if (current) return;
      transition_in(spinner.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(spinner.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(spinner);
    }
  };
}
function create_if_block_2$2(ctx) {
  let alert;
  let current;
  alert = new Alert({
    props: {
      id: formFailureMessageId$2,
      needsFocus: (
        /*alertNeedsFocus*/
        ctx[4]
      ),
      type: "error",
      $$slots: { default: [create_default_slot_2$1] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(alert.$$.fragment);
    },
    m(target, anchor) {
      mount_component(alert, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const alert_changes = {};
      if (dirty & /*alertNeedsFocus*/
      16) alert_changes.needsFocus = /*alertNeedsFocus*/
      ctx2[4];
      if (dirty & /*$$scope, formMessageKey, form*/
      262212) {
        alert_changes.$$scope = { dirty, ctx: ctx2 };
      }
      alert.$set(alert_changes);
    },
    i(local) {
      if (current) return;
      transition_in(alert.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(alert.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(alert, detaching);
    }
  };
}
function create_default_slot_2$1(ctx) {
  var _a;
  let t_value = interpolate(
    /*formMessageKey*/
    ctx[6],
    null,
    /*form*/
    (_a = ctx[2]) == null ? void 0 : _a.message
  ) + "";
  let t3;
  return {
    c() {
      t3 = text(t_value);
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    p(ctx2, dirty) {
      var _a2;
      if (dirty & /*formMessageKey, form*/
      68 && t_value !== (t_value = interpolate(
        /*formMessageKey*/
        ctx2[6],
        null,
        /*form*/
        (_a2 = ctx2[2]) == null ? void 0 : _a2.message
      ) + "")) set_data(t3, t_value);
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_else_block$2(ctx) {
  let header;
  let current_block_type_index;
  let if_block;
  let current;
  const if_block_creators = [create_if_block_1$3, create_else_block_1];
  const if_blocks = [];
  function select_block_type_1(ctx2, dirty) {
    if (
      /*requestsDeviceName*/
      ctx2[3]
    ) return 0;
    return 1;
  }
  current_block_type_index = select_block_type_1(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      header = element("header");
      if_block.c();
      attr(header, "class", `tw_input-spacing`);
      attr(header, "id", formHeaderId$2);
    },
    m(target, anchor) {
      insert(target, header, anchor);
      if_blocks[current_block_type_index].m(header, null);
      current = true;
    },
    p(ctx2, dirty) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type_1(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(header, null);
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(header);
      if_blocks[current_block_type_index].d();
    }
  };
}
function create_if_block$5(ctx) {
  let header;
  let div;
  let spinner;
  let t0;
  let h1;
  let t1;
  let t22;
  let p4;
  let t3;
  let current;
  spinner = new Spinner({
    props: {
      colorClass: "tw_text-primary-light",
      layoutClasses: "tw_h-28 tw_w-28"
    }
  });
  t1 = new Locale_strings({ props: { key: "verifyYourIdentity" } });
  t3 = new Locale_strings({
    props: { key: "useDeviceForIdentityVerification" }
  });
  return {
    c() {
      header = element("header");
      div = element("div");
      create_component(spinner.$$.fragment);
      t0 = space();
      h1 = element("h1");
      create_component(t1.$$.fragment);
      t22 = space();
      p4 = element("p");
      create_component(t3.$$.fragment);
      attr(div, "class", "tw_text-center tw_w-full tw_py-4");
      attr(h1, "class", "tw_primary-header dark:tw_primary-header_dark");
      attr(p4, "class", "tw_text-center tw_-mt-5 tw_mb-2 tw_py-4 tw_text-secondary-dark dark:tw_text-secondary-light");
      attr(header, "id", formHeaderId$2);
    },
    m(target, anchor) {
      insert(target, header, anchor);
      append(header, div);
      mount_component(spinner, div, null);
      append(header, t0);
      append(header, h1);
      mount_component(t1, h1, null);
      append(header, t22);
      append(header, p4);
      mount_component(t3, p4, null);
      current = true;
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(spinner.$$.fragment, local);
      transition_in(t1.$$.fragment, local);
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(spinner.$$.fragment, local);
      transition_out(t1.$$.fragment, local);
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(header);
      destroy_component(spinner);
      destroy_component(t1);
      destroy_component(t3);
    }
  };
}
function create_else_block_1(ctx) {
  let h1;
  let t0;
  let t1;
  let p4;
  let t22;
  let current;
  t0 = new Locale_strings({
    props: {
      key: "registerYourDevice",
      values: {
        name: (
          /*deviceName*/
          ctx[5].length > 0 ? (
            /*deviceName*/
            ctx[5]
          ) : interpolate("yourDevice")
        )
      }
    }
  });
  t22 = new Locale_strings({
    props: {
      key: "chooseYourDeviceForIdentityVerification"
    }
  });
  return {
    c() {
      h1 = element("h1");
      create_component(t0.$$.fragment);
      t1 = space();
      p4 = element("p");
      create_component(t22.$$.fragment);
      attr(h1, "class", "tw_primary-header dark:tw_primary-header_dark");
      attr(p4, "class", "tw_text-center tw_-mt-5 tw_mb-2 tw_py-4 tw_text-secondary-dark dark:tw_text-secondary-light");
    },
    m(target, anchor) {
      insert(target, h1, anchor);
      mount_component(t0, h1, null);
      insert(target, t1, anchor);
      insert(target, p4, anchor);
      mount_component(t22, p4, null);
      current = true;
    },
    p(ctx2, dirty) {
      const t0_changes = {};
      if (dirty & /*deviceName*/
      32) t0_changes.values = {
        name: (
          /*deviceName*/
          ctx2[5].length > 0 ? (
            /*deviceName*/
            ctx2[5]
          ) : interpolate("yourDevice")
        )
      };
      t0.$set(t0_changes);
    },
    i(local) {
      if (current) return;
      transition_in(t0.$$.fragment, local);
      transition_in(t22.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t0.$$.fragment, local);
      transition_out(t22.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(h1);
      destroy_component(t0);
      if (detaching) detach(t1);
      if (detaching) detach(p4);
      destroy_component(t22);
    }
  };
}
function create_if_block_1$3(ctx) {
  let h1;
  let t0;
  let t1;
  let input;
  let t22;
  let button;
  let current;
  t0 = new Locale_strings({ props: { key: "nameYourDevice" } });
  input = new Floating_label2({
    props: {
      type: "text",
      isRequired: false,
      isFirstInvalidInput: false,
      key: "devicename",
      onChange: (
        /*updateDeviceName*/
        ctx[11]
      ),
      label: interpolate("optionallyNameDevice")
    }
  });
  button = new Button({
    props: {
      style: "primary",
      type: "submit",
      width: "full",
      onClick: (
        /*func*/
        ctx[15]
      ),
      $$slots: { default: [create_default_slot_1$4] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      h1 = element("h1");
      create_component(t0.$$.fragment);
      t1 = space();
      create_component(input.$$.fragment);
      t22 = space();
      create_component(button.$$.fragment);
      attr(h1, "class", "tw_primary-header dark:tw_primary-header_dark");
    },
    m(target, anchor) {
      insert(target, h1, anchor);
      mount_component(t0, h1, null);
      insert(target, t1, anchor);
      mount_component(input, target, anchor);
      insert(target, t22, anchor);
      mount_component(button, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const button_changes = {};
      if (dirty & /*requestsDeviceName, waitingForWebAuthnAPI*/
      520) button_changes.onClick = /*func*/
      ctx2[15];
      if (dirty & /*$$scope*/
      262144) {
        button_changes.$$scope = { dirty, ctx: ctx2 };
      }
      button.$set(button_changes);
    },
    i(local) {
      if (current) return;
      transition_in(t0.$$.fragment, local);
      transition_in(input.$$.fragment, local);
      transition_in(button.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t0.$$.fragment, local);
      transition_out(input.$$.fragment, local);
      transition_out(button.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(h1);
      destroy_component(t0);
      if (detaching) detach(t1);
      destroy_component(input, detaching);
      if (detaching) detach(t22);
      destroy_component(button, detaching);
    }
  };
}
function create_default_slot_1$4(ctx) {
  let t3;
  let current;
  t3 = new Locale_strings({ props: { key: "nextButton" } });
  return {
    c() {
      create_component(t3.$$.fragment);
    },
    m(target, anchor) {
      mount_component(t3, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(t3, detaching);
    }
  };
}
function create_default_slot$5(ctx) {
  var _a, _b;
  let t0;
  let t1;
  let t22;
  let current_block_type_index;
  let if_block3;
  let if_block3_anchor;
  let current;
  let if_block0 = (
    /*form*/
    ((_a = ctx[2]) == null ? void 0 : _a.icon) && /*componentStyle*/
    ctx[1] !== "inline" && create_if_block_4$1()
  );
  let if_block1 = (
    /*waitingForWebAuthnAPI*/
    ctx[9] && create_if_block_3$2()
  );
  let if_block2 = (
    /*form*/
    ((_b = ctx[2]) == null ? void 0 : _b.message) && create_if_block_2$2(ctx)
  );
  const if_block_creators = [create_if_block$5, create_else_block$2];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*webAuthnType*/
      ctx2[10] === i8.Authentication
    ) return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block3 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      if (if_block0) if_block0.c();
      t0 = space();
      if (if_block1) if_block1.c();
      t1 = space();
      if (if_block2) if_block2.c();
      t22 = space();
      if_block3.c();
      if_block3_anchor = empty();
    },
    m(target, anchor) {
      if (if_block0) if_block0.m(target, anchor);
      insert(target, t0, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, t1, anchor);
      if (if_block2) if_block2.m(target, anchor);
      insert(target, t22, anchor);
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, if_block3_anchor, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2, _b2;
      if (
        /*form*/
        ((_a2 = ctx2[2]) == null ? void 0 : _a2.icon) && /*componentStyle*/
        ctx2[1] !== "inline"
      ) {
        if (if_block0) {
          if (dirty & /*form, componentStyle*/
          6) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_4$1();
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(t0.parentNode, t0);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      if (
        /*waitingForWebAuthnAPI*/
        ctx2[9]
      ) {
        if (if_block1) {
          if (dirty & /*waitingForWebAuthnAPI*/
          512) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block_3$2();
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(t1.parentNode, t1);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
      if (
        /*form*/
        (_b2 = ctx2[2]) == null ? void 0 : _b2.message
      ) {
        if (if_block2) {
          if_block2.p(ctx2, dirty);
          if (dirty & /*form*/
          4) {
            transition_in(if_block2, 1);
          }
        } else {
          if_block2 = create_if_block_2$2(ctx2);
          if_block2.c();
          transition_in(if_block2, 1);
          if_block2.m(t22.parentNode, t22);
        }
      } else if (if_block2) {
        group_outros();
        transition_out(if_block2, 1, 1, () => {
          if_block2 = null;
        });
        check_outros();
      }
      if_block3.p(ctx2, dirty);
    },
    i(local) {
      if (current) return;
      transition_in(if_block0);
      transition_in(if_block1);
      transition_in(if_block2);
      transition_in(if_block3);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(if_block1);
      transition_out(if_block2);
      transition_out(if_block3);
      current = false;
    },
    d(detaching) {
      if (if_block0) if_block0.d(detaching);
      if (detaching) detach(t0);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(t1);
      if (if_block2) if_block2.d(detaching);
      if (detaching) detach(t22);
      if_blocks[current_block_type_index].d(detaching);
      if (detaching) detach(if_block3_anchor);
    }
  };
}
function create_fragment$9(ctx) {
  let form_1;
  let updating_formEl;
  let current;
  function form_1_formEl_binding(value) {
    ctx[16](value);
  }
  let form_1_props = {
    ariaDescribedBy: (
      /*formAriaDescriptor*/
      ctx[7]
    ),
    id: formElementId$2,
    needsFocus: (
      /*formNeedsFocus*/
      ctx[8]
    ),
    $$slots: { default: [create_default_slot$5] },
    $$scope: { ctx }
  };
  if (
    /*formEl*/
    ctx[0] !== void 0
  ) {
    form_1_props.formEl = /*formEl*/
    ctx[0];
  }
  form_1 = new Form({ props: form_1_props });
  binding_callbacks.push(() => bind(form_1, "formEl", form_1_formEl_binding));
  return {
    c() {
      create_component(form_1.$$.fragment);
    },
    m(target, anchor) {
      mount_component(form_1, target, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      const form_1_changes = {};
      if (dirty & /*formAriaDescriptor*/
      128) form_1_changes.ariaDescribedBy = /*formAriaDescriptor*/
      ctx2[7];
      if (dirty & /*formNeedsFocus*/
      256) form_1_changes.needsFocus = /*formNeedsFocus*/
      ctx2[8];
      if (dirty & /*$$scope, requestsDeviceName, waitingForWebAuthnAPI, deviceName, alertNeedsFocus, formMessageKey, form, componentStyle*/
      262782) {
        form_1_changes.$$scope = { dirty, ctx: ctx2 };
      }
      if (!updating_formEl && dirty & /*formEl*/
      1) {
        updating_formEl = true;
        form_1_changes.formEl = /*formEl*/
        ctx2[0];
        add_flush_callback(() => updating_formEl = false);
      }
      form_1.$set(form_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(form_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(form_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(form_1, detaching);
    }
  };
}
var formFailureMessageId$2 = "genericStepFailureMessage";
var formHeaderId$2 = "genericStepHeader";
var formElementId$2 = "genericStepForm";
function instance$9($$self, $$props, $$invalidate) {
  let { allowWebAuthn = true } = $$props;
  let { componentStyle } = $$props;
  let { form } = $$props;
  let { formEl = null } = $$props;
  let { step } = $$props;
  let alertNeedsFocus = false;
  let deviceName2 = "";
  let noDeviceRegistered = false;
  let formMessageKey = "";
  let formAriaDescriptor = "genericStepHeader";
  let formNeedsFocus = false;
  let requestsDeviceName = true;
  let waitingForWebAuthnAPI = false;
  let webAuthnType = T2.getWebAuthnStepType(step);
  function updateDeviceName(event) {
    const target = event.target;
    $$invalidate(5, deviceName2 = target.value);
  }
  afterUpdate(() => {
    if (form == null ? void 0 : form.message) {
      $$invalidate(7, formAriaDescriptor = formFailureMessageId$2);
      $$invalidate(4, alertNeedsFocus = true);
      $$invalidate(8, formNeedsFocus = false);
    } else {
      $$invalidate(7, formAriaDescriptor = formHeaderId$2);
      $$invalidate(4, alertNeedsFocus = false);
      $$invalidate(8, formNeedsFocus = true);
    }
  });
  async function callWebAuthnApi() {
    try {
      switch (webAuthnType) {
        case i8.Registration: {
          try {
            await T2.register(step, deviceName2);
            $$invalidate(14, noDeviceRegistered = true);
          } catch (err) {
          }
          break;
        }
        case i8.Authentication: {
          await T2.authenticate(step);
          break;
        }
        default:
          break;
      }
    } catch (err) {
    }
    form.submit();
  }
  const func = () => {
    $$invalidate(3, requestsDeviceName = false);
    $$invalidate(9, waitingForWebAuthnAPI = true);
  };
  function form_1_formEl_binding(value) {
    formEl = value;
    $$invalidate(0, formEl);
  }
  $$self.$$set = ($$props2) => {
    if ("allowWebAuthn" in $$props2) $$invalidate(12, allowWebAuthn = $$props2.allowWebAuthn);
    if ("componentStyle" in $$props2) $$invalidate(1, componentStyle = $$props2.componentStyle);
    if ("form" in $$props2) $$invalidate(2, form = $$props2.form);
    if ("formEl" in $$props2) $$invalidate(0, formEl = $$props2.formEl);
    if ("step" in $$props2) $$invalidate(13, step = $$props2.step);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*form, allowWebAuthn, noDeviceRegistered, requestsDeviceName*/
    20492) {
      {
        $$invalidate(6, formMessageKey = convertStringToKey(form == null ? void 0 : form.message));
        if (allowWebAuthn && !noDeviceRegistered) {
          if (i8.Registration === webAuthnType && !requestsDeviceName || i8.Authentication === webAuthnType) {
            callWebAuthnApi();
          }
        }
      }
    }
  };
  return [
    formEl,
    componentStyle,
    form,
    requestsDeviceName,
    alertNeedsFocus,
    deviceName2,
    formMessageKey,
    formAriaDescriptor,
    formNeedsFocus,
    waitingForWebAuthnAPI,
    webAuthnType,
    updateDeviceName,
    allowWebAuthn,
    step,
    noDeviceRegistered,
    func,
    form_1_formEl_binding
  ];
}
var Webauthn = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$9, create_fragment$9, safe_not_equal, {
      allowWebAuthn: 12,
      componentStyle: 1,
      form: 2,
      formEl: 0,
      step: 13
    });
  }
};
function create_fragment$8(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill-rule", "evenodd");
      attr(path, "d", "M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm2.146 5.146a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(
        svg,
        "height",
        /*size*/
        ctx[1]
      );
      attr(
        svg,
        "width",
        /*size*/
        ctx[1]
      );
      attr(
        svg,
        "class",
        /*classes*/
        ctx[0]
      );
      attr(svg, "fill", "currentColor");
      attr(svg, "viewBox", "0 0 16 18");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p(ctx2, [dirty]) {
      if (dirty & /*size*/
      2) {
        attr(
          svg,
          "height",
          /*size*/
          ctx2[1]
        );
      }
      if (dirty & /*size*/
      2) {
        attr(
          svg,
          "width",
          /*size*/
          ctx2[1]
        );
      }
      if (dirty & /*classes*/
      1) {
        attr(
          svg,
          "class",
          /*classes*/
          ctx2[0]
        );
      }
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
function instance$8($$self, $$props, $$invalidate) {
  let { classes = "" } = $$props;
  let { size = "24px" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("classes" in $$props2) $$invalidate(0, classes = $$props2.classes);
    if ("size" in $$props2) $$invalidate(1, size = $$props2.size);
  };
  return [classes, size];
}
var Shield_check_icon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$8, create_fragment$8, safe_not_equal, { classes: 0, size: 1 });
  }
};
function get_each_context$2(ctx, list, i9) {
  const child_ctx = ctx.slice();
  child_ctx[11] = list[i9];
  return child_ctx;
}
function create_if_block$4(ctx) {
  let div;
  let clipboardicon;
  let current;
  clipboardicon = new Shield_check_icon({
    props: {
      classes: "tw_text-gray-400 tw_fill-current",
      size: "72px"
    }
  });
  return {
    c() {
      div = element("div");
      create_component(clipboardicon.$$.fragment);
      attr(div, "class", "tw_flex tw_justify-center");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(clipboardicon, div, null);
      current = true;
    },
    i(local) {
      if (current) return;
      transition_in(clipboardicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(clipboardicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(clipboardicon);
    }
  };
}
function create_each_block$2(ctx) {
  let li;
  let span;
  let t0_value = (
    /*code*/
    ctx[11] + ""
  );
  let t0;
  let t1;
  return {
    c() {
      li = element("li");
      span = element("span");
      t0 = text(t0_value);
      t1 = space();
      attr(span, "class", "tw_text-secondary-dark dark:tw_text-secondary-light");
      attr(li, "class", "tw_text-center");
    },
    m(target, anchor) {
      insert(target, li, anchor);
      append(li, span);
      append(span, t0);
      append(li, t1);
    },
    p(ctx2, dirty) {
      if (dirty & /*codes*/
      64 && t0_value !== (t0_value = /*code*/
      ctx2[11] + "")) set_data(t0, t0_value);
    },
    d(detaching) {
      if (detaching) detach(li);
    }
  };
}
function create_default_slot_1$3(ctx) {
  let t3;
  let current;
  t3 = new Locale_strings({ props: { key: "nextButton" } });
  return {
    c() {
      create_component(t3.$$.fragment);
    },
    m(target, anchor) {
      mount_component(t3, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(t3, detaching);
    }
  };
}
function create_default_slot$4(ctx) {
  var _a, _b;
  let t0;
  let header;
  let h1;
  let t1;
  let t22;
  let p0;
  let t3;
  let t4;
  let hr;
  let t5;
  let h2;
  let t6;
  let t7;
  let p1;
  let t8;
  let t9;
  let ol;
  let t10;
  let p22;
  let t11;
  let t12;
  let button;
  let current;
  let if_block = (
    /*form*/
    ((_a = ctx[2]) == null ? void 0 : _a.icon) && /*componentStyle*/
    ctx[1] !== "inline" && create_if_block$4()
  );
  t1 = new Locale_strings({
    props: { key: "yourMultiFactorAuthIsEnabled" }
  });
  t3 = new Locale_strings({
    props: {
      key: "useThisNewMfaToHelpVerifyYourIdentity"
    }
  });
  t6 = new Locale_strings({ props: { key: "dontGetLockedOut" } });
  t8 = new Locale_strings({
    props: {
      html: true,
      key: "yourRecoveryCodesToAccessAccountForLostDevice"
    }
  });
  let each_value = (
    /*codes*/
    ctx[6]
  );
  let each_blocks = [];
  for (let i9 = 0; i9 < each_value.length; i9 += 1) {
    each_blocks[i9] = create_each_block$2(get_each_context$2(ctx, each_value, i9));
  }
  t11 = new Locale_strings({
    props: {
      html: true,
      key: "useOneOfTheseCodes",
      values: { name: (
        /*name*/
        ctx[7]
      ) }
    }
  });
  button = new Button({
    props: {
      busy: (
        /*journey*/
        (_b = ctx[3]) == null ? void 0 : _b.loading
      ),
      style: "primary",
      type: "submit",
      width: "full",
      $$slots: { default: [create_default_slot_1$3] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      if (if_block) if_block.c();
      t0 = space();
      header = element("header");
      h1 = element("h1");
      create_component(t1.$$.fragment);
      t22 = space();
      p0 = element("p");
      create_component(t3.$$.fragment);
      t4 = space();
      hr = element("hr");
      t5 = space();
      h2 = element("h2");
      create_component(t6.$$.fragment);
      t7 = space();
      p1 = element("p");
      create_component(t8.$$.fragment);
      t9 = space();
      ol = element("ol");
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].c();
      }
      t10 = space();
      p22 = element("p");
      create_component(t11.$$.fragment);
      t12 = space();
      create_component(button.$$.fragment);
      attr(h1, "class", "tw_primary-header dark:tw_primary-header_dark");
      attr(p0, "class", "tw_-mt-5 tw_mb-2 tw_py-4 tw_text-sm tw_text-secondary-dark dark:tw_text-secondary-light");
      attr(header, "id", formHeaderId$1);
      attr(hr, "class", "tw_border-collapse tw_border-secondary-light dark:tw_border-secondary-dark tw_mb-8");
      attr(h2, "class", "tw_secondary-header dark:tw_secondary-header_dark tw_text-lg");
      attr(p1, "class", "tw_text-sm tw_text-secondary-dark dark:tw_text-secondary-light tw_my-6");
      attr(ol, "class", "tw_font-mono tw_border tw_border-secondary-light dark:tw_border-secondary-dark tw_bg-white dark:tw_bg-body-dark tw_list-decimal tw_text-secondary-light dark:tw_text-secondary-light tw_py-4 tw_list-inside tw_rounded-md tw_mb-4 tw_columns-2");
      attr(p22, "class", "tw_text-sm tw_text-secondary-dark dark:tw_text-secondary-light tw_my-6");
    },
    m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      insert(target, t0, anchor);
      insert(target, header, anchor);
      append(header, h1);
      mount_component(t1, h1, null);
      append(header, t22);
      append(header, p0);
      mount_component(t3, p0, null);
      insert(target, t4, anchor);
      insert(target, hr, anchor);
      insert(target, t5, anchor);
      insert(target, h2, anchor);
      mount_component(t6, h2, null);
      insert(target, t7, anchor);
      insert(target, p1, anchor);
      mount_component(t8, p1, null);
      insert(target, t9, anchor);
      insert(target, ol, anchor);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].m(ol, null);
      }
      insert(target, t10, anchor);
      insert(target, p22, anchor);
      mount_component(t11, p22, null);
      insert(target, t12, anchor);
      mount_component(button, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2, _b2;
      if (
        /*form*/
        ((_a2 = ctx2[2]) == null ? void 0 : _a2.icon) && /*componentStyle*/
        ctx2[1] !== "inline"
      ) {
        if (if_block) {
          if (dirty & /*form, componentStyle*/
          6) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$4();
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(t0.parentNode, t0);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
      if (dirty & /*codes*/
      64) {
        each_value = /*codes*/
        ctx2[6];
        let i9;
        for (i9 = 0; i9 < each_value.length; i9 += 1) {
          const child_ctx = get_each_context$2(ctx2, each_value, i9);
          if (each_blocks[i9]) {
            each_blocks[i9].p(child_ctx, dirty);
          } else {
            each_blocks[i9] = create_each_block$2(child_ctx);
            each_blocks[i9].c();
            each_blocks[i9].m(ol, null);
          }
        }
        for (; i9 < each_blocks.length; i9 += 1) {
          each_blocks[i9].d(1);
        }
        each_blocks.length = each_value.length;
      }
      const t11_changes = {};
      if (dirty & /*name*/
      128) t11_changes.values = { name: (
        /*name*/
        ctx2[7]
      ) };
      t11.$set(t11_changes);
      const button_changes = {};
      if (dirty & /*journey*/
      8) button_changes.busy = /*journey*/
      (_b2 = ctx2[3]) == null ? void 0 : _b2.loading;
      if (dirty & /*$$scope*/
      16384) {
        button_changes.$$scope = { dirty, ctx: ctx2 };
      }
      button.$set(button_changes);
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      transition_in(t1.$$.fragment, local);
      transition_in(t3.$$.fragment, local);
      transition_in(t6.$$.fragment, local);
      transition_in(t8.$$.fragment, local);
      transition_in(t11.$$.fragment, local);
      transition_in(button.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      transition_out(t1.$$.fragment, local);
      transition_out(t3.$$.fragment, local);
      transition_out(t6.$$.fragment, local);
      transition_out(t8.$$.fragment, local);
      transition_out(t11.$$.fragment, local);
      transition_out(button.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (if_block) if_block.d(detaching);
      if (detaching) detach(t0);
      if (detaching) detach(header);
      destroy_component(t1);
      destroy_component(t3);
      if (detaching) detach(t4);
      if (detaching) detach(hr);
      if (detaching) detach(t5);
      if (detaching) detach(h2);
      destroy_component(t6);
      if (detaching) detach(t7);
      if (detaching) detach(p1);
      destroy_component(t8);
      if (detaching) detach(t9);
      if (detaching) detach(ol);
      destroy_each(each_blocks, detaching);
      if (detaching) detach(t10);
      if (detaching) detach(p22);
      destroy_component(t11);
      if (detaching) detach(t12);
      destroy_component(button, detaching);
    }
  };
}
function create_fragment$7(ctx) {
  let form_1;
  let updating_formEl;
  let current;
  function form_1_formEl_binding(value) {
    ctx[10](value);
  }
  let form_1_props = {
    ariaDescribedBy: (
      /*formAriaDescriptor*/
      ctx[4]
    ),
    id: formElementId$1,
    needsFocus: (
      /*formNeedsFocus*/
      ctx[5]
    ),
    onSubmitWhenValid: (
      /*func*/
      ctx[9]
    ),
    $$slots: { default: [create_default_slot$4] },
    $$scope: { ctx }
  };
  if (
    /*formEl*/
    ctx[0] !== void 0
  ) {
    form_1_props.formEl = /*formEl*/
    ctx[0];
  }
  form_1 = new Form({ props: form_1_props });
  binding_callbacks.push(() => bind(form_1, "formEl", form_1_formEl_binding));
  return {
    c() {
      create_component(form_1.$$.fragment);
    },
    m(target, anchor) {
      mount_component(form_1, target, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      const form_1_changes = {};
      if (dirty & /*formAriaDescriptor*/
      16) form_1_changes.ariaDescribedBy = /*formAriaDescriptor*/
      ctx2[4];
      if (dirty & /*formNeedsFocus*/
      32) form_1_changes.needsFocus = /*formNeedsFocus*/
      ctx2[5];
      if (dirty & /*form*/
      4) form_1_changes.onSubmitWhenValid = /*func*/
      ctx2[9];
      if (dirty & /*$$scope, journey, name, codes, form, componentStyle*/
      16590) {
        form_1_changes.$$scope = { dirty, ctx: ctx2 };
      }
      if (!updating_formEl && dirty & /*formEl*/
      1) {
        updating_formEl = true;
        form_1_changes.formEl = /*formEl*/
        ctx2[0];
        add_flush_callback(() => updating_formEl = false);
      }
      form_1.$set(form_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(form_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(form_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(form_1, detaching);
    }
  };
}
var formFailureMessageId$1 = "genericStepFailureMessage";
var formHeaderId$1 = "genericStepHeader";
var formElementId$1 = "genericStepForm";
function instance$7($$self, $$props, $$invalidate) {
  let { componentStyle } = $$props;
  let { form } = $$props;
  let { formEl = null } = $$props;
  let { journey: journey2 } = $$props;
  let { step } = $$props;
  let formAriaDescriptor = "genericStepHeader";
  let formNeedsFocus = false;
  let codes = [];
  let name = "New Security Key";
  afterUpdate(() => {
    if (form == null ? void 0 : form.message) {
      $$invalidate(4, formAriaDescriptor = formFailureMessageId$1);
      $$invalidate(5, formNeedsFocus = false);
    } else {
      $$invalidate(4, formAriaDescriptor = formHeaderId$1);
      $$invalidate(5, formNeedsFocus = true);
    }
  });
  const func = () => form.submit();
  function form_1_formEl_binding(value) {
    formEl = value;
    $$invalidate(0, formEl);
  }
  $$self.$$set = ($$props2) => {
    if ("componentStyle" in $$props2) $$invalidate(1, componentStyle = $$props2.componentStyle);
    if ("form" in $$props2) $$invalidate(2, form = $$props2.form);
    if ("formEl" in $$props2) $$invalidate(0, formEl = $$props2.formEl);
    if ("journey" in $$props2) $$invalidate(3, journey2 = $$props2.journey);
    if ("step" in $$props2) $$invalidate(8, step = $$props2.step);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*step*/
    256) {
      {
        $$invalidate(6, codes = p$1.getCodes(step));
        $$invalidate(7, name = p$1.getDeviceName(step));
      }
    }
  };
  return [
    formEl,
    componentStyle,
    form,
    journey2,
    formAriaDescriptor,
    formNeedsFocus,
    codes,
    name,
    step,
    func,
    form_1_formEl_binding
  ];
}
var Recovery_codes = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$7, create_fragment$7, safe_not_equal, {
      componentStyle: 1,
      form: 2,
      formEl: 0,
      journey: 3,
      step: 8
    });
  }
};
function create_fragment$6(ctx) {
  let svg;
  let path;
  let title;
  let current;
  const default_slot_template = (
    /*#slots*/
    ctx[3].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx,
    /*$$scope*/
    ctx[2],
    null
  );
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      title = svg_element("title");
      if (default_slot) default_slot.c();
      attr(path, "fill-rule", "evenodd");
      attr(path, "d", "M10 1.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1Zm-5 0A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5v1A1.5 1.5 0 0 1 9.5 4h-3A1.5 1.5 0 0 1 5 2.5v-1Zm-2 0h1v1A2.5 2.5 0 0 0 6.5 5h3A2.5 2.5 0 0 0 12 2.5v-1h1a2 2 0 0 1 2 2V14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2Z");
      attr(
        svg,
        "class",
        /*classes*/
        ctx[0]
      );
      attr(
        svg,
        "width",
        /*size*/
        ctx[1]
      );
      attr(
        svg,
        "height",
        /*size*/
        ctx[1]
      );
      attr(svg, "viewBox", "0 0 16 16");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
      append(svg, title);
      if (default_slot) {
        default_slot.m(title, null);
      }
      current = true;
    },
    p(ctx2, [dirty]) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        4)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx2,
            /*$$scope*/
            ctx2[2],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx2[2]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx2[2],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (!current || dirty & /*classes*/
      1) {
        attr(
          svg,
          "class",
          /*classes*/
          ctx2[0]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "width",
          /*size*/
          ctx2[1]
        );
      }
      if (!current || dirty & /*size*/
      2) {
        attr(
          svg,
          "height",
          /*size*/
          ctx2[1]
        );
      }
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(svg);
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function instance$6($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { classes = "" } = $$props;
  let { size = "24px" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("classes" in $$props2) $$invalidate(0, classes = $$props2.classes);
    if ("size" in $$props2) $$invalidate(1, size = $$props2.size);
    if ("$$scope" in $$props2) $$invalidate(2, $$scope = $$props2.$$scope);
  };
  return [classes, size, $$scope, slots];
}
var Clipboard_icon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$6, create_fragment$6, safe_not_equal, { classes: 0, size: 1 });
  }
};
function create_fragment$5(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "d", "M3 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V2zm6 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0z");
      attr(
        svg,
        "class",
        /*classes*/
        ctx[0]
      );
      attr(
        svg,
        "height",
        /*size*/
        ctx[1]
      );
      attr(svg, "viewBox", "0 0 16 16");
      attr(
        svg,
        "width",
        /*size*/
        ctx[1]
      );
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p(ctx2, [dirty]) {
      if (dirty & /*classes*/
      1) {
        attr(
          svg,
          "class",
          /*classes*/
          ctx2[0]
        );
      }
      if (dirty & /*size*/
      2) {
        attr(
          svg,
          "height",
          /*size*/
          ctx2[1]
        );
      }
      if (dirty & /*size*/
      2) {
        attr(
          svg,
          "width",
          /*size*/
          ctx2[1]
        );
      }
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
function instance$5($$self, $$props, $$invalidate) {
  let { classes = "" } = $$props;
  let { size = "24px" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("classes" in $$props2) $$invalidate(0, classes = $$props2.classes);
    if ("size" in $$props2) $$invalidate(1, size = $$props2.size);
  };
  return [classes, size];
}
var Mobile_icon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$5, create_fragment$5, safe_not_equal, { classes: 0, size: 1 });
  }
};
function get_if_ctx(ctx) {
  var _a;
  const child_ctx = ctx.slice();
  const constants_0 = {
    callback: (
      /*pollingWaitCb*/
      child_ctx[10]
    ),
    callbackMetadata: (
      /*metadata*/
      (_a = child_ctx[1]) == null ? void 0 : _a.callbacks[
        /*pollingWaitIdx*/
        child_ctx[15]
      ]
    ),
    options: { inline: true },
    selfSubmitFunction: (
      /*determineSubmission*/
      child_ctx[16]
    ),
    style: (
      /*$style*/
      child_ctx[14]
    )
  };
  child_ctx[22] = constants_0;
  return child_ctx;
}
function get_each_context$1(ctx, list, i9) {
  const child_ctx = ctx.slice();
  child_ctx[23] = list[i9];
  child_ctx[25] = i9;
  return child_ctx;
}
function create_if_block_4(ctx) {
  var _a;
  let t0;
  let h1;
  let t1;
  let t22;
  let p4;
  let t3;
  let current;
  let if_block = (
    /*form*/
    ((_a = ctx[0]) == null ? void 0 : _a.icon) && create_if_block_5()
  );
  t1 = new Locale_strings({
    props: { key: "twoFactorAuthentication" }
  });
  t3 = new Locale_strings({
    props: { key: "scanQrCodeWithAuthenticator" }
  });
  return {
    c() {
      if (if_block) if_block.c();
      t0 = space();
      h1 = element("h1");
      create_component(t1.$$.fragment);
      t22 = space();
      p4 = element("p");
      create_component(t3.$$.fragment);
      attr(h1, "class", "tw_primary-header dark:tw_primary-header_dark");
      attr(p4, "class", "tw_text-center tw_text-sm tw_-mt-5 tw_mb-2 tw_py-4 tw_text-secondary-dark dark:tw_text-secondary-light");
    },
    m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      insert(target, t0, anchor);
      insert(target, h1, anchor);
      mount_component(t1, h1, null);
      insert(target, t22, anchor);
      insert(target, p4, anchor);
      mount_component(t3, p4, null);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      if (
        /*form*/
        (_a2 = ctx2[0]) == null ? void 0 : _a2.icon
      ) {
        if (if_block) {
          if (dirty & /*form*/
          1) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block_5();
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(t0.parentNode, t0);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      transition_in(t1.$$.fragment, local);
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      transition_out(t1.$$.fragment, local);
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (if_block) if_block.d(detaching);
      if (detaching) detach(t0);
      if (detaching) detach(h1);
      destroy_component(t1);
      if (detaching) detach(t22);
      if (detaching) detach(p4);
      destroy_component(t3);
    }
  };
}
function create_if_block_5(ctx) {
  let div;
  let mobileicon;
  let current;
  mobileicon = new Mobile_icon({
    props: {
      classes: "tw_text-gray-400 tw_fill-current",
      size: "72px"
    }
  });
  return {
    c() {
      div = element("div");
      create_component(mobileicon.$$.fragment);
      attr(div, "class", "tw_flex tw_justify-center tw_mb-6");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(mobileicon, div, null);
      current = true;
    },
    i(local) {
      if (current) return;
      transition_in(mobileicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(mobileicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(mobileicon);
    }
  };
}
function create_if_block_3$1(ctx) {
  let alert;
  let current;
  alert = new Alert({
    props: {
      id: "formFailureMessageAlert",
      needsFocus: (
        /*alertNeedsFocus*/
        ctx[5]
      ),
      type: "error",
      $$slots: { default: [create_default_slot_4] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(alert.$$.fragment);
    },
    m(target, anchor) {
      mount_component(alert, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const alert_changes = {};
      if (dirty & /*alertNeedsFocus*/
      32) alert_changes.needsFocus = /*alertNeedsFocus*/
      ctx2[5];
      if (dirty & /*$$scope, formMessageKey, form*/
      67108993) {
        alert_changes.$$scope = { dirty, ctx: ctx2 };
      }
      alert.$set(alert_changes);
    },
    i(local) {
      if (current) return;
      transition_in(alert.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(alert.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(alert, detaching);
    }
  };
}
function create_default_slot_4(ctx) {
  var _a;
  let t_value = interpolate(
    /*formMessageKey*/
    ctx[7],
    null,
    /*form*/
    (_a = ctx[0]) == null ? void 0 : _a.message
  ) + "";
  let t3;
  return {
    c() {
      t3 = text(t_value);
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    p(ctx2, dirty) {
      var _a2;
      if (dirty & /*formMessageKey, form*/
      129 && t_value !== (t_value = interpolate(
        /*formMessageKey*/
        ctx2[7],
        null,
        /*form*/
        (_a2 = ctx2[0]) == null ? void 0 : _a2.message
      ) + "")) set_data(t3, t_value);
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_if_block_2$1(ctx) {
  let div;
  let spinner;
  let t0;
  let p4;
  let t1;
  let current;
  spinner = new Spinner({
    props: {
      colorClass: "tw_text-primary-light",
      layoutClasses: "tw_h-24 tw_my-6 tw_w-24"
    }
  });
  t1 = new Locale_strings({ props: { key: "loading" } });
  return {
    c() {
      div = element("div");
      create_component(spinner.$$.fragment);
      t0 = space();
      p4 = element("p");
      create_component(t1.$$.fragment);
      attr(p4, "class", "tw_text-secondary-dark dark:tw_text-secondary-light");
      attr(div, "class", "tw_text-center");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(spinner, div, null);
      append(div, t0);
      append(div, p4);
      mount_component(t1, p4, null);
      current = true;
    },
    i(local) {
      if (current) return;
      transition_in(spinner.$$.fragment, local);
      transition_in(t1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(spinner.$$.fragment, local);
      transition_out(t1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(spinner);
      destroy_component(t1);
    }
  };
}
function create_each_block$1(ctx) {
  var _a, _b;
  let callbackmapper;
  let current;
  callbackmapper = new Callback_mapper({
    props: {
      props: {
        callback: (
          /*callback*/
          ctx[23]
        ),
        callbackMetadata: (
          /*metadata*/
          (_a = ctx[1]) == null ? void 0 : _a.callbacks[
            /*idx*/
            ctx[25]
          ]
        ),
        selfSubmitFunction: (
          /*determineSubmission*/
          ctx[16]
        ),
        stepMetadata: (
          /*metadata*/
          ((_b = ctx[1]) == null ? void 0 : _b.step) && __spreadValues(
            {},
            /*metadata*/
            ctx[1].step
          )
        ),
        style: (
          /*$style*/
          ctx[14]
        )
      }
    }
  });
  return {
    c() {
      create_component(callbackmapper.$$.fragment);
    },
    m(target, anchor) {
      mount_component(callbackmapper, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2, _b2;
      const callbackmapper_changes = {};
      if (dirty & /*modifiedCallbacks, metadata, $style*/
      16642) callbackmapper_changes.props = {
        callback: (
          /*callback*/
          ctx2[23]
        ),
        callbackMetadata: (
          /*metadata*/
          (_a2 = ctx2[1]) == null ? void 0 : _a2.callbacks[
            /*idx*/
            ctx2[25]
          ]
        ),
        selfSubmitFunction: (
          /*determineSubmission*/
          ctx2[16]
        ),
        stepMetadata: (
          /*metadata*/
          ((_b2 = ctx2[1]) == null ? void 0 : _b2.step) && __spreadValues(
            {},
            /*metadata*/
            ctx2[1].step
          )
        ),
        style: (
          /*$style*/
          ctx2[14]
        )
      };
      callbackmapper.$set(callbackmapper_changes);
    },
    i(local) {
      if (current) return;
      transition_in(callbackmapper.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(callbackmapper.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(callbackmapper, detaching);
    }
  };
}
function create_if_block_1$2(ctx) {
  let pollingwait;
  let current;
  const pollingwait_spread_levels = [
    /*newProps*/
    ctx[22]
  ];
  let pollingwait_props = {};
  for (let i9 = 0; i9 < pollingwait_spread_levels.length; i9 += 1) {
    pollingwait_props = assign(pollingwait_props, pollingwait_spread_levels[i9]);
  }
  pollingwait = new Polling_wait({ props: pollingwait_props });
  return {
    c() {
      create_component(pollingwait.$$.fragment);
    },
    m(target, anchor) {
      mount_component(pollingwait, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const pollingwait_changes = dirty & /*pollingWaitCb, metadata, pollingWaitIdx, determineSubmission, $style*/
      115714 ? get_spread_update(pollingwait_spread_levels, [get_spread_object(
        /*newProps*/
        ctx2[22]
      )]) : {};
      pollingwait.$set(pollingwait_changes);
    },
    i(local) {
      if (current) return;
      transition_in(pollingwait.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(pollingwait.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(pollingwait, detaching);
    }
  };
}
function create_default_slot_3(ctx) {
  let t3;
  let current;
  t3 = new Locale_strings({
    props: { key: "onMobileOpenInAuthenticator" }
  });
  return {
    c() {
      create_component(t3.$$.fragment);
    },
    m(target, anchor) {
      mount_component(t3, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(t3, detaching);
    }
  };
}
function create_default_slot_2(ctx) {
  let t3;
  let current;
  t3 = new Locale_strings({ props: { key: "copyUrl" } });
  return {
    c() {
      create_component(t3.$$.fragment);
    },
    m(target, anchor) {
      mount_component(t3, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(t3, detaching);
    }
  };
}
function create_if_block$3(ctx) {
  var _a;
  let button;
  let current;
  button = new Button({
    props: {
      busy: (
        /*journey*/
        (_a = ctx[4]) == null ? void 0 : _a.loading
      ),
      style: "primary",
      type: "submit",
      width: "full",
      $$slots: { default: [create_default_slot_1$2] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(button.$$.fragment);
    },
    m(target, anchor) {
      mount_component(button, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2;
      const button_changes = {};
      if (dirty & /*journey*/
      16) button_changes.busy = /*journey*/
      (_a2 = ctx2[4]) == null ? void 0 : _a2.loading;
      if (dirty & /*$$scope, buttons*/
      67108928) {
        button_changes.$$scope = { dirty, ctx: ctx2 };
      }
      button.$set(button_changes);
    },
    i(local) {
      if (current) return;
      transition_in(button.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(button.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(button, detaching);
    }
  };
}
function create_default_slot_1$2(ctx) {
  let t3;
  let current;
  t3 = new Locale_strings({
    props: { key: (
      /*buttons*/
      ctx[6][0].text
    ) }
  });
  return {
    c() {
      create_component(t3.$$.fragment);
    },
    m(target, anchor) {
      mount_component(t3, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const t_changes = {};
      if (dirty & /*buttons*/
      64) t_changes.key = /*buttons*/
      ctx2[6][0].text;
      t3.$set(t_changes);
    },
    i(local) {
      if (current) return;
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(t3, detaching);
    }
  };
}
function create_default_slot$3(ctx) {
  var _a, _b;
  let t0;
  let t1;
  let t22;
  let canvas2;
  let t3;
  let t4;
  let t5;
  let details;
  let summary;
  let t6;
  let t7;
  let div1;
  let link;
  let t8;
  let p4;
  let t9;
  let t10;
  let div0;
  let label;
  let t11;
  let t12;
  let button;
  let clipboardicon;
  let t13;
  let input;
  let t14;
  let if_block4_anchor;
  let current;
  let mounted;
  let dispose;
  let if_block0 = (
    /*componentStyle*/
    ctx[3] !== "inline" && create_if_block_4(ctx)
  );
  let if_block1 = (
    /*form*/
    ((_a = ctx[0]) == null ? void 0 : _a.message) && create_if_block_3$1(ctx)
  );
  let if_block2 = !/*moduleLoaded*/
  ctx[9] && create_if_block_2$1();
  let each_value = (
    /*modifiedCallbacks*/
    ctx[8]
  );
  let each_blocks = [];
  for (let i9 = 0; i9 < each_value.length; i9 += 1) {
    each_blocks[i9] = create_each_block$1(get_each_context$1(ctx, each_value, i9));
  }
  const out = (i9) => transition_out(each_blocks[i9], 1, 1, () => {
    each_blocks[i9] = null;
  });
  let if_block3 = (
    /*pollingWaitCb*/
    ctx[10] && create_if_block_1$2(get_if_ctx(ctx))
  );
  t6 = new Locale_strings({ props: { key: "qrCodeNotWorking" } });
  link = new Link({
    props: {
      href: (
        /*qrCodeUrl*/
        ctx[12]
      ),
      classes: "tw_block tw_my-6",
      target: "_self",
      $$slots: { default: [create_default_slot_3] },
      $$scope: { ctx }
    }
  });
  t9 = new Locale_strings({ props: { key: "copyAndPasteUrlBelow" } });
  t11 = new Locale_strings({ props: { key: "url" } });
  clipboardicon = new Clipboard_icon({
    props: {
      classes: "tw_fill-current tw_inline-block tw_align-top",
      size: "16",
      $$slots: { default: [create_default_slot_2] },
      $$scope: { ctx }
    }
  });
  let if_block4 = (
    /*buttons*/
    ((_b = ctx[6]) == null ? void 0 : _b.length) && create_if_block$3(ctx)
  );
  return {
    c() {
      if (if_block0) if_block0.c();
      t0 = space();
      if (if_block1) if_block1.c();
      t1 = space();
      if (if_block2) if_block2.c();
      t22 = space();
      canvas2 = element("canvas");
      t3 = space();
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].c();
      }
      t4 = space();
      if (if_block3) if_block3.c();
      t5 = space();
      details = element("details");
      summary = element("summary");
      create_component(t6.$$.fragment);
      t7 = space();
      div1 = element("div");
      create_component(link.$$.fragment);
      t8 = space();
      p4 = element("p");
      create_component(t9.$$.fragment);
      t10 = space();
      div0 = element("div");
      label = element("label");
      create_component(t11.$$.fragment);
      t12 = space();
      button = element("button");
      create_component(clipboardicon.$$.fragment);
      t13 = space();
      input = element("input");
      t14 = space();
      if (if_block4) if_block4.c();
      if_block4_anchor = empty();
      attr(canvas2, "class", "tw_m-auto tw_mb-6");
      attr(canvas2, "data-testid", "qr-code-canvas");
      attr(p4, "class", "tw_text-base tw_my-6");
      attr(label, "for", "mfa-registration-url");
      attr(button, "class", "tw_absolute tw_h-4 tw_bg-background-dark tw_right-1 tw_top-1 tw_shadow-[0_0_1rem_2rem_black] tw_shadow-background-light dark:tw_shadow-background-dark tw_text-secondary-dark dark:tw_text-secondary-light");
      attr(input, "class", "tw_bg-transparent tw_border-none focus-visible:tw_outline-none tw_font-mono tw_w-full");
      attr(input, "id", "mfa-registration-url");
      input.value = /*qrCodeUrl*/
      ctx[12];
      attr(div0, "class", "tw_relative tw_overflow-hidden");
      attr(div1, "class", "tw_overflow-hidden");
      attr(details, "class", "tw_my-6 tw_text-secondary-dark dark:tw_text-secondary-light");
    },
    m(target, anchor) {
      if (if_block0) if_block0.m(target, anchor);
      insert(target, t0, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, t1, anchor);
      if (if_block2) if_block2.m(target, anchor);
      insert(target, t22, anchor);
      insert(target, canvas2, anchor);
      ctx[19](canvas2);
      insert(target, t3, anchor);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].m(target, anchor);
      }
      insert(target, t4, anchor);
      if (if_block3) if_block3.m(target, anchor);
      insert(target, t5, anchor);
      insert(target, details, anchor);
      append(details, summary);
      mount_component(t6, summary, null);
      append(details, t7);
      append(details, div1);
      mount_component(link, div1, null);
      append(div1, t8);
      append(div1, p4);
      mount_component(t9, p4, null);
      append(div1, t10);
      append(div1, div0);
      append(div0, label);
      mount_component(t11, label, null);
      append(div0, t12);
      append(div0, button);
      mount_component(clipboardicon, button, null);
      append(div0, t13);
      append(div0, input);
      ctx[20](input);
      insert(target, t14, anchor);
      if (if_block4) if_block4.m(target, anchor);
      insert(target, if_block4_anchor, anchor);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*copyUrl*/
          ctx[17]
        );
        mounted = true;
      }
    },
    p(ctx2, dirty) {
      var _a2, _b2;
      if (
        /*componentStyle*/
        ctx2[3] !== "inline"
      ) {
        if (if_block0) {
          if_block0.p(ctx2, dirty);
          if (dirty & /*componentStyle*/
          8) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_4(ctx2);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(t0.parentNode, t0);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      if (
        /*form*/
        (_a2 = ctx2[0]) == null ? void 0 : _a2.message
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
          if (dirty & /*form*/
          1) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block_3$1(ctx2);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(t1.parentNode, t1);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
      if (!/*moduleLoaded*/
      ctx2[9]) {
        if (if_block2) {
          if (dirty & /*moduleLoaded*/
          512) {
            transition_in(if_block2, 1);
          }
        } else {
          if_block2 = create_if_block_2$1();
          if_block2.c();
          transition_in(if_block2, 1);
          if_block2.m(t22.parentNode, t22);
        }
      } else if (if_block2) {
        group_outros();
        transition_out(if_block2, 1, 1, () => {
          if_block2 = null;
        });
        check_outros();
      }
      if (dirty & /*modifiedCallbacks, metadata, determineSubmission, $style*/
      82178) {
        each_value = /*modifiedCallbacks*/
        ctx2[8];
        let i9;
        for (i9 = 0; i9 < each_value.length; i9 += 1) {
          const child_ctx = get_each_context$1(ctx2, each_value, i9);
          if (each_blocks[i9]) {
            each_blocks[i9].p(child_ctx, dirty);
            transition_in(each_blocks[i9], 1);
          } else {
            each_blocks[i9] = create_each_block$1(child_ctx);
            each_blocks[i9].c();
            transition_in(each_blocks[i9], 1);
            each_blocks[i9].m(t4.parentNode, t4);
          }
        }
        group_outros();
        for (i9 = each_value.length; i9 < each_blocks.length; i9 += 1) {
          out(i9);
        }
        check_outros();
      }
      if (
        /*pollingWaitCb*/
        ctx2[10]
      ) {
        if (if_block3) {
          if_block3.p(get_if_ctx(ctx2), dirty);
          if (dirty & /*pollingWaitCb*/
          1024) {
            transition_in(if_block3, 1);
          }
        } else {
          if_block3 = create_if_block_1$2(get_if_ctx(ctx2));
          if_block3.c();
          transition_in(if_block3, 1);
          if_block3.m(t5.parentNode, t5);
        }
      } else if (if_block3) {
        group_outros();
        transition_out(if_block3, 1, 1, () => {
          if_block3 = null;
        });
        check_outros();
      }
      const link_changes = {};
      if (dirty & /*qrCodeUrl*/
      4096) link_changes.href = /*qrCodeUrl*/
      ctx2[12];
      if (dirty & /*$$scope*/
      67108864) {
        link_changes.$$scope = { dirty, ctx: ctx2 };
      }
      link.$set(link_changes);
      const clipboardicon_changes = {};
      if (dirty & /*$$scope*/
      67108864) {
        clipboardicon_changes.$$scope = { dirty, ctx: ctx2 };
      }
      clipboardicon.$set(clipboardicon_changes);
      if (!current || dirty & /*qrCodeUrl*/
      4096 && input.value !== /*qrCodeUrl*/
      ctx2[12]) {
        input.value = /*qrCodeUrl*/
        ctx2[12];
      }
      if (
        /*buttons*/
        (_b2 = ctx2[6]) == null ? void 0 : _b2.length
      ) {
        if (if_block4) {
          if_block4.p(ctx2, dirty);
          if (dirty & /*buttons*/
          64) {
            transition_in(if_block4, 1);
          }
        } else {
          if_block4 = create_if_block$3(ctx2);
          if_block4.c();
          transition_in(if_block4, 1);
          if_block4.m(if_block4_anchor.parentNode, if_block4_anchor);
        }
      } else if (if_block4) {
        group_outros();
        transition_out(if_block4, 1, 1, () => {
          if_block4 = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block0);
      transition_in(if_block1);
      transition_in(if_block2);
      for (let i9 = 0; i9 < each_value.length; i9 += 1) {
        transition_in(each_blocks[i9]);
      }
      transition_in(if_block3);
      transition_in(t6.$$.fragment, local);
      transition_in(link.$$.fragment, local);
      transition_in(t9.$$.fragment, local);
      transition_in(t11.$$.fragment, local);
      transition_in(clipboardicon.$$.fragment, local);
      transition_in(if_block4);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(if_block1);
      transition_out(if_block2);
      each_blocks = each_blocks.filter(Boolean);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        transition_out(each_blocks[i9]);
      }
      transition_out(if_block3);
      transition_out(t6.$$.fragment, local);
      transition_out(link.$$.fragment, local);
      transition_out(t9.$$.fragment, local);
      transition_out(t11.$$.fragment, local);
      transition_out(clipboardicon.$$.fragment, local);
      transition_out(if_block4);
      current = false;
    },
    d(detaching) {
      if (if_block0) if_block0.d(detaching);
      if (detaching) detach(t0);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(t1);
      if (if_block2) if_block2.d(detaching);
      if (detaching) detach(t22);
      if (detaching) detach(canvas2);
      ctx[19](null);
      if (detaching) detach(t3);
      destroy_each(each_blocks, detaching);
      if (detaching) detach(t4);
      if (if_block3) if_block3.d(detaching);
      if (detaching) detach(t5);
      if (detaching) detach(details);
      destroy_component(t6);
      destroy_component(link);
      destroy_component(t9);
      destroy_component(t11);
      destroy_component(clipboardicon);
      ctx[20](null);
      if (detaching) detach(t14);
      if (if_block4) if_block4.d(detaching);
      if (detaching) detach(if_block4_anchor);
      mounted = false;
      dispose();
    }
  };
}
function create_fragment$4(ctx) {
  var _a;
  let form_1;
  let updating_formEl;
  let current;
  function form_1_formEl_binding(value) {
    ctx[21](value);
  }
  let form_1_props = {
    ariaDescribedBy: "formFailureMessageAlert",
    onSubmitWhenValid: (
      /*form*/
      (_a = ctx[0]) == null ? void 0 : _a.submit
    ),
    $$slots: { default: [create_default_slot$3] },
    $$scope: { ctx }
  };
  if (
    /*formEl*/
    ctx[2] !== void 0
  ) {
    form_1_props.formEl = /*formEl*/
    ctx[2];
  }
  form_1 = new Form({ props: form_1_props });
  binding_callbacks.push(() => bind(form_1, "formEl", form_1_formEl_binding));
  return {
    c() {
      create_component(form_1.$$.fragment);
    },
    m(target, anchor) {
      mount_component(form_1, target, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      var _a2;
      const form_1_changes = {};
      if (dirty & /*form*/
      1) form_1_changes.onSubmitWhenValid = /*form*/
      (_a2 = ctx2[0]) == null ? void 0 : _a2.submit;
      if (dirty & /*$$scope, journey, buttons, qrCodeUrl, qrCodeEl, pollingWaitCb, metadata, $style, modifiedCallbacks, qrCodeCanvas, moduleLoaded, alertNeedsFocus, formMessageKey, form, componentStyle*/
      67141627) {
        form_1_changes.$$scope = { dirty, ctx: ctx2 };
      }
      if (!updating_formEl && dirty & /*formEl*/
      4) {
        updating_formEl = true;
        form_1_changes.formEl = /*formEl*/
        ctx2[2];
        add_flush_callback(() => updating_formEl = false);
      }
      form_1.$set(form_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(form_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(form_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(form_1, detaching);
    }
  };
}
function instance$4($$self, $$props, $$invalidate) {
  let $style;
  component_subscribe($$self, styleStore, ($$value) => $$invalidate(14, $style = $$value));
  let { componentStyle } = $$props;
  let { form } = $$props;
  let { formEl = null } = $$props;
  let { journey: journey2 } = $$props;
  let { metadata } = $$props;
  let { step } = $$props;
  let alertNeedsFocus = false;
  let buttons;
  let formMessageKey = "";
  let modifiedCallbacks = [];
  let moduleLoaded = false;
  let pollingWaitCb;
  let pollingWaitIdx;
  let qrCodeCanvas;
  let qrCodeUrl = "";
  let qrCodeEl;
  function determineSubmission() {
    var _a;
    if ((_a = metadata == null ? void 0 : metadata.step) == null ? void 0 : _a.derived.isStepSelfSubmittable()) {
      form == null ? void 0 : form.submit();
    }
  }
  async function copyUrl2() {
    qrCodeEl.select();
    document.execCommand("copy");
  }
  afterUpdate(() => {
    $$invalidate(5, alertNeedsFocus = !!(form == null ? void 0 : form.message));
  });
  onMount(() => {
    async function renderQrCodeImage() {
      try {
        const qrCodeModule = await Promise.resolve().then(function() {
          return browser;
        });
        $$invalidate(9, moduleLoaded = true);
        $$invalidate(12, qrCodeUrl = i$2.getQRCodeData(step).uri);
        qrCodeModule.toCanvas(
          qrCodeCanvas,
          qrCodeUrl,
          // Properties required for ForgeRock QR Codes
          {
            errorCorrectionLevel: "L",
            version: 20,
            width: 400
          },
          function(error) {
            if (error) {
              $$invalidate(0, form.message = interpolate("qrCodeFailedToRender"), form);
              console.error(error);
            }
          }
        );
      } catch (err) {
        $$invalidate(0, form.message = interpolate("qrCodeImportFailure"), form);
        console.error("Failed to import QR Code library");
      }
    }
    renderQrCodeImage();
  });
  function canvas_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      qrCodeCanvas = $$value;
      $$invalidate(11, qrCodeCanvas);
    });
  }
  function input_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      qrCodeEl = $$value;
      $$invalidate(13, qrCodeEl);
    });
  }
  function form_1_formEl_binding(value) {
    formEl = value;
    $$invalidate(2, formEl);
  }
  $$self.$$set = ($$props2) => {
    if ("componentStyle" in $$props2) $$invalidate(3, componentStyle = $$props2.componentStyle);
    if ("form" in $$props2) $$invalidate(0, form = $$props2.form);
    if ("formEl" in $$props2) $$invalidate(2, formEl = $$props2.formEl);
    if ("journey" in $$props2) $$invalidate(4, journey2 = $$props2.journey);
    if ("metadata" in $$props2) $$invalidate(1, metadata = $$props2.metadata);
    if ("step" in $$props2) $$invalidate(18, step = $$props2.step);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*metadata, step, form*/
    262147) {
      {
        if (metadata) {
          $$invalidate(1, metadata.step.derived.stageName = "QRCode", metadata);
        }
        const confirmationCallbacks = step.getCallbacksOfType(l.ConfirmationCallback);
        if (confirmationCallbacks.length) {
          const confirmationCb = confirmationCallbacks[0];
          $$invalidate(6, buttons = confirmationCb.getOptions().map((option, index) => ({ value: `${index}`, text: option })));
        }
        step.callbacks.forEach((callback, idx) => {
          if (callback.getType() === l.PollingWaitCallback) {
            $$invalidate(10, pollingWaitCb = callback);
          }
        });
        $$invalidate(7, formMessageKey = convertStringToKey(form == null ? void 0 : form.message));
        $$invalidate(8, modifiedCallbacks = step.callbacks.filter((callback) => {
          if (callback.getType() === l.TextOutputCallback) {
            return false;
          } else if (callback.getType() === l.ConfirmationCallback) {
            return false;
          } else if (callback.getType() === l.PollingWaitCallback) {
            return false;
          }
          return true;
        }));
      }
    }
  };
  return [
    form,
    metadata,
    formEl,
    componentStyle,
    journey2,
    alertNeedsFocus,
    buttons,
    formMessageKey,
    modifiedCallbacks,
    moduleLoaded,
    pollingWaitCb,
    qrCodeCanvas,
    qrCodeUrl,
    qrCodeEl,
    $style,
    pollingWaitIdx,
    determineSubmission,
    copyUrl2,
    step,
    canvas_binding,
    input_binding,
    form_1_formEl_binding
  ];
}
var Qr_code = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$4, create_fragment$4, safe_not_equal, {
      componentStyle: 3,
      form: 0,
      formEl: 2,
      journey: 4,
      metadata: 1,
      step: 18
    });
  }
};
function create_fragment$3(ctx) {
  let svg;
  let path;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "d", "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z");
      attr(
        svg,
        "class",
        /*classes*/
        ctx[0]
      );
      attr(
        svg,
        "height",
        /*size*/
        ctx[1]
      );
      attr(
        svg,
        "width",
        /*size*/
        ctx[1]
      );
      attr(svg, "viewBox", "0 0 16 16");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p(ctx2, [dirty]) {
      if (dirty & /*classes*/
      1) {
        attr(
          svg,
          "class",
          /*classes*/
          ctx2[0]
        );
      }
      if (dirty & /*size*/
      2) {
        attr(
          svg,
          "height",
          /*size*/
          ctx2[1]
        );
      }
      if (dirty & /*size*/
      2) {
        attr(
          svg,
          "width",
          /*size*/
          ctx2[1]
        );
      }
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
function instance$3($$self, $$props, $$invalidate) {
  let { classes = "" } = $$props;
  let { size = "24px" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("classes" in $$props2) $$invalidate(0, classes = $$props2.classes);
    if ("size" in $$props2) $$invalidate(1, size = $$props2.size);
  };
  return [classes, size];
}
var Email_icon = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$3, create_fragment$3, safe_not_equal, { classes: 0, size: 1 });
  }
};
function get_each_context(ctx, list, i9) {
  const child_ctx = ctx.slice();
  child_ctx[16] = list[i9];
  child_ctx[18] = i9;
  return child_ctx;
}
function create_if_block_1$1(ctx) {
  let div;
  let emailicon;
  let current;
  emailicon = new Email_icon({
    props: {
      classes: "tw_text-gray-400 tw_fill-current",
      size: "72px"
    }
  });
  return {
    c() {
      div = element("div");
      create_component(emailicon.$$.fragment);
      attr(div, "class", "tw_flex tw_justify-center");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(emailicon, div, null);
      current = true;
    },
    i(local) {
      if (current) return;
      transition_in(emailicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(emailicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(emailicon);
    }
  };
}
function create_if_block$2(ctx) {
  let alert;
  let current;
  alert = new Alert({
    props: {
      id: formFailureMessageId,
      needsFocus: (
        /*alertNeedsFocus*/
        ctx[6]
      ),
      type: "error",
      $$slots: { default: [create_default_slot_1$1] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(alert.$$.fragment);
    },
    m(target, anchor) {
      mount_component(alert, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const alert_changes = {};
      if (dirty & /*alertNeedsFocus*/
      64) alert_changes.needsFocus = /*alertNeedsFocus*/
      ctx2[6];
      if (dirty & /*$$scope, formMessageKey, form*/
      524420) {
        alert_changes.$$scope = { dirty, ctx: ctx2 };
      }
      alert.$set(alert_changes);
    },
    i(local) {
      if (current) return;
      transition_in(alert.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(alert.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(alert, detaching);
    }
  };
}
function create_default_slot_1$1(ctx) {
  var _a;
  let t_value = interpolate(
    /*formMessageKey*/
    ctx[7],
    null,
    /*form*/
    (_a = ctx[2]) == null ? void 0 : _a.message
  ) + "";
  let t3;
  return {
    c() {
      t3 = text(t_value);
    },
    m(target, anchor) {
      insert(target, t3, anchor);
    },
    p(ctx2, dirty) {
      var _a2;
      if (dirty & /*formMessageKey, form*/
      132 && t_value !== (t_value = interpolate(
        /*formMessageKey*/
        ctx2[7],
        null,
        /*form*/
        (_a2 = ctx2[2]) == null ? void 0 : _a2.message
      ) + "")) set_data(t3, t_value);
    },
    d(detaching) {
      if (detaching) detach(t3);
    }
  };
}
function create_each_block(ctx) {
  var _a, _b;
  let callbackmapper;
  let current;
  callbackmapper = new Callback_mapper({
    props: {
      props: {
        callback: (
          /*callback*/
          ctx[16]
        ),
        callbackMetadata: (
          /*metadata*/
          (_a = ctx[4]) == null ? void 0 : _a.callbacks[
            /*idx*/
            ctx[18]
          ]
        ),
        selfSubmitFunction: (
          /*determineSubmission*/
          ctx[12]
        ),
        stepMetadata: (
          /*metadata*/
          ((_b = ctx[4]) == null ? void 0 : _b.step) && __spreadValues(
            {},
            /*metadata*/
            ctx[4].step
          )
        ),
        style: (
          /*$styleStore*/
          ctx[11]
        )
      }
    }
  });
  return {
    c() {
      create_component(callbackmapper.$$.fragment);
    },
    m(target, anchor) {
      mount_component(callbackmapper, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2, _b2;
      const callbackmapper_changes = {};
      if (dirty & /*step, metadata, $styleStore*/
      2096) callbackmapper_changes.props = {
        callback: (
          /*callback*/
          ctx2[16]
        ),
        callbackMetadata: (
          /*metadata*/
          (_a2 = ctx2[4]) == null ? void 0 : _a2.callbacks[
            /*idx*/
            ctx2[18]
          ]
        ),
        selfSubmitFunction: (
          /*determineSubmission*/
          ctx2[12]
        ),
        stepMetadata: (
          /*metadata*/
          ((_b2 = ctx2[4]) == null ? void 0 : _b2.step) && __spreadValues(
            {},
            /*metadata*/
            ctx2[4].step
          )
        ),
        style: (
          /*$styleStore*/
          ctx2[11]
        )
      };
      callbackmapper.$set(callbackmapper_changes);
    },
    i(local) {
      if (current) return;
      transition_in(callbackmapper.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(callbackmapper.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(callbackmapper, detaching);
    }
  };
}
function create_default_slot$2(ctx) {
  var _a, _b, _c, _d;
  let t0;
  let header;
  let h1;
  let sanitize2;
  let t1;
  let t22;
  let t3;
  let backto;
  let current;
  let if_block0 = (
    /*form*/
    ((_a = ctx[2]) == null ? void 0 : _a.icon) && /*componentStyle*/
    ctx[1] !== "inline" && create_if_block_1$1()
  );
  sanitize2 = new Server_strings({
    props: {
      html: true,
      string: (
        /*step*/
        ((_b = ctx[5]) == null ? void 0 : _b.getHeader()) || interpolate("checkYourEmail")
      )
    }
  });
  let if_block1 = (
    /*form*/
    ((_c = ctx[2]) == null ? void 0 : _c.message) && create_if_block$2(ctx)
  );
  let each_value = (
    /*step*/
    (_d = ctx[5]) == null ? void 0 : _d.callbacks
  );
  let each_blocks = [];
  for (let i9 = 0; i9 < each_value.length; i9 += 1) {
    each_blocks[i9] = create_each_block(get_each_context(ctx, each_value, i9));
  }
  const out = (i9) => transition_out(each_blocks[i9], 1, 1, () => {
    each_blocks[i9] = null;
  });
  backto = new Back_to({ props: { journey: (
    /*journey*/
    ctx[3]
  ) } });
  return {
    c() {
      if (if_block0) if_block0.c();
      t0 = space();
      header = element("header");
      h1 = element("h1");
      create_component(sanitize2.$$.fragment);
      t1 = space();
      if (if_block1) if_block1.c();
      t22 = space();
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].c();
      }
      t3 = space();
      create_component(backto.$$.fragment);
      attr(h1, "class", "tw_primary-header dark:tw_primary-header_dark");
      attr(header, "id", formHeaderId);
    },
    m(target, anchor) {
      if (if_block0) if_block0.m(target, anchor);
      insert(target, t0, anchor);
      insert(target, header, anchor);
      append(header, h1);
      mount_component(sanitize2, h1, null);
      ctx[14](header);
      insert(target, t1, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, t22, anchor);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        each_blocks[i9].m(target, anchor);
      }
      insert(target, t3, anchor);
      mount_component(backto, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2, _b2, _c2, _d2;
      if (
        /*form*/
        ((_a2 = ctx2[2]) == null ? void 0 : _a2.icon) && /*componentStyle*/
        ctx2[1] !== "inline"
      ) {
        if (if_block0) {
          if (dirty & /*form, componentStyle*/
          6) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_1$1();
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(t0.parentNode, t0);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      const sanitize_changes = {};
      if (dirty & /*step*/
      32) sanitize_changes.string = /*step*/
      ((_b2 = ctx2[5]) == null ? void 0 : _b2.getHeader()) || interpolate("checkYourEmail");
      sanitize2.$set(sanitize_changes);
      if (
        /*form*/
        (_c2 = ctx2[2]) == null ? void 0 : _c2.message
      ) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
          if (dirty & /*form*/
          4) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block$2(ctx2);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(t22.parentNode, t22);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
      if (dirty & /*step, metadata, determineSubmission, $styleStore*/
      6192) {
        each_value = /*step*/
        (_d2 = ctx2[5]) == null ? void 0 : _d2.callbacks;
        let i9;
        for (i9 = 0; i9 < each_value.length; i9 += 1) {
          const child_ctx = get_each_context(ctx2, each_value, i9);
          if (each_blocks[i9]) {
            each_blocks[i9].p(child_ctx, dirty);
            transition_in(each_blocks[i9], 1);
          } else {
            each_blocks[i9] = create_each_block(child_ctx);
            each_blocks[i9].c();
            transition_in(each_blocks[i9], 1);
            each_blocks[i9].m(t3.parentNode, t3);
          }
        }
        group_outros();
        for (i9 = each_value.length; i9 < each_blocks.length; i9 += 1) {
          out(i9);
        }
        check_outros();
      }
      const backto_changes = {};
      if (dirty & /*journey*/
      8) backto_changes.journey = /*journey*/
      ctx2[3];
      backto.$set(backto_changes);
    },
    i(local) {
      if (current) return;
      transition_in(if_block0);
      transition_in(sanitize2.$$.fragment, local);
      transition_in(if_block1);
      for (let i9 = 0; i9 < each_value.length; i9 += 1) {
        transition_in(each_blocks[i9]);
      }
      transition_in(backto.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(sanitize2.$$.fragment, local);
      transition_out(if_block1);
      each_blocks = each_blocks.filter(Boolean);
      for (let i9 = 0; i9 < each_blocks.length; i9 += 1) {
        transition_out(each_blocks[i9]);
      }
      transition_out(backto.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (if_block0) if_block0.d(detaching);
      if (detaching) detach(t0);
      if (detaching) detach(header);
      destroy_component(sanitize2);
      ctx[14](null);
      if (detaching) detach(t1);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(t22);
      destroy_each(each_blocks, detaching);
      if (detaching) detach(t3);
      destroy_component(backto, detaching);
    }
  };
}
function create_fragment$2(ctx) {
  let form_1;
  let updating_formEl;
  let current;
  function form_1_formEl_binding(value) {
    ctx[15](value);
  }
  let form_1_props = {
    ariaDescribedBy: (
      /*formAriaDescriptor*/
      ctx[8]
    ),
    id: formElementId,
    needsFocus: (
      /*formNeedsFocus*/
      ctx[9]
    ),
    onSubmitWhenValid: (
      /*submitFormWrapper*/
      ctx[13]
    ),
    $$slots: { default: [create_default_slot$2] },
    $$scope: { ctx }
  };
  if (
    /*formEl*/
    ctx[0] !== void 0
  ) {
    form_1_props.formEl = /*formEl*/
    ctx[0];
  }
  form_1 = new Form({ props: form_1_props });
  binding_callbacks.push(() => bind(form_1, "formEl", form_1_formEl_binding));
  return {
    c() {
      create_component(form_1.$$.fragment);
    },
    m(target, anchor) {
      mount_component(form_1, target, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      const form_1_changes = {};
      if (dirty & /*formAriaDescriptor*/
      256) form_1_changes.ariaDescribedBy = /*formAriaDescriptor*/
      ctx2[8];
      if (dirty & /*formNeedsFocus*/
      512) form_1_changes.needsFocus = /*formNeedsFocus*/
      ctx2[9];
      if (dirty & /*$$scope, journey, step, metadata, $styleStore, alertNeedsFocus, formMessageKey, form, linkWrapper, componentStyle*/
      527614) {
        form_1_changes.$$scope = { dirty, ctx: ctx2 };
      }
      if (!updating_formEl && dirty & /*formEl*/
      1) {
        updating_formEl = true;
        form_1_changes.formEl = /*formEl*/
        ctx2[0];
        add_flush_callback(() => updating_formEl = false);
      }
      form_1.$set(form_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(form_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(form_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(form_1, detaching);
    }
  };
}
var formFailureMessageId = "genericStepFailureMessage";
var formHeaderId = "genericStepHeader";
var formElementId = "genericStepForm";
function instance$2($$self, $$props, $$invalidate) {
  let $styleStore;
  component_subscribe($$self, styleStore, ($$value) => $$invalidate(11, $styleStore = $$value));
  let { componentStyle } = $$props;
  let { form } = $$props;
  let { formEl = null } = $$props;
  let { journey: journey2 } = $$props;
  let { metadata } = $$props;
  let { step } = $$props;
  let alertNeedsFocus = false;
  let formMessageKey = "";
  let formAriaDescriptor = "genericStepHeader";
  let formNeedsFocus = false;
  let linkWrapper;
  function determineSubmission() {
    var _a;
    if ((_a = metadata == null ? void 0 : metadata.step) == null ? void 0 : _a.derived.isStepSelfSubmittable()) {
      submitFormWrapper();
    }
  }
  function submitFormWrapper() {
    $$invalidate(6, alertNeedsFocus = false);
    $$invalidate(9, formNeedsFocus = false);
    form == null ? void 0 : form.submit();
  }
  afterUpdate(() => {
    if (form == null ? void 0 : form.message) {
      $$invalidate(8, formAriaDescriptor = formFailureMessageId);
      $$invalidate(6, alertNeedsFocus = true);
      $$invalidate(9, formNeedsFocus = false);
    } else {
      $$invalidate(8, formAriaDescriptor = formHeaderId);
      $$invalidate(6, alertNeedsFocus = false);
      $$invalidate(9, formNeedsFocus = true);
    }
  });
  onMount(() => captureLinks(linkWrapper, journey2));
  function header_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      linkWrapper = $$value;
      $$invalidate(10, linkWrapper);
    });
  }
  function form_1_formEl_binding(value) {
    formEl = value;
    $$invalidate(0, formEl);
  }
  $$self.$$set = ($$props2) => {
    if ("componentStyle" in $$props2) $$invalidate(1, componentStyle = $$props2.componentStyle);
    if ("form" in $$props2) $$invalidate(2, form = $$props2.form);
    if ("formEl" in $$props2) $$invalidate(0, formEl = $$props2.formEl);
    if ("journey" in $$props2) $$invalidate(3, journey2 = $$props2.journey);
    if ("metadata" in $$props2) $$invalidate(4, metadata = $$props2.metadata);
    if ("step" in $$props2) $$invalidate(5, step = $$props2.step);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*step, form*/
    36) {
      {
        shouldRedirectFromStep(step) && f$1.redirect(step);
        $$invalidate(7, formMessageKey = convertStringToKey(form == null ? void 0 : form.message));
      }
    }
  };
  return [
    formEl,
    componentStyle,
    form,
    journey2,
    metadata,
    step,
    alertNeedsFocus,
    formMessageKey,
    formAriaDescriptor,
    formNeedsFocus,
    linkWrapper,
    $styleStore,
    determineSubmission,
    submitFormWrapper,
    header_binding,
    form_1_formEl_binding
  ];
}
var Email_suspend = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$2, create_fragment$2, safe_not_equal, {
      componentStyle: 1,
      form: 2,
      formEl: 0,
      journey: 3,
      metadata: 4,
      step: 5
    });
  }
};
function mapStepToStage(currentStep) {
  if (!currentStep || currentStep.type !== "Step") {
    return Generic;
  }
  switch ((currentStep == null ? void 0 : currentStep.getStage) && currentStep.getStage()) {
    case "OneTimePassword":
      return One_time_password;
    case "DefaultRegistration":
      return Registration;
    case "DefaultLogin":
      return Login;
  }
  if (T2.getWebAuthnStepType(currentStep)) {
    return Webauthn;
  }
  if (p$1.isDisplayStep(currentStep)) {
    return Recovery_codes;
  }
  if (i$2.isQRCodeStep(currentStep)) {
    return Qr_code;
  }
  const suspendedTextOutput = currentStep.getCallbacksOfType(l.SuspendedTextOutputCallback);
  if (suspendedTextOutput.length > 0) {
    return Email_suspend;
  }
  return Generic;
}
function create_else_block$1(ctx) {
  let alert;
  let t3;
  let button;
  let current;
  alert = new Alert({
    props: {
      id: "unrecoverableStepError",
      needsFocus: (
        /*alertNeedsFocus*/
        ctx[4]
      ),
      type: "error",
      $$slots: { default: [create_default_slot_1] },
      $$scope: { ctx }
    }
  });
  button = new Button({
    props: {
      style: "secondary",
      onClick: (
        /*tryAgain*/
        ctx[7]
      ),
      $$slots: { default: [create_default_slot$1] },
      $$scope: { ctx }
    }
  });
  return {
    c() {
      create_component(alert.$$.fragment);
      t3 = space();
      create_component(button.$$.fragment);
    },
    m(target, anchor) {
      mount_component(alert, target, anchor);
      insert(target, t3, anchor);
      mount_component(button, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const alert_changes = {};
      if (dirty & /*alertNeedsFocus*/
      16) alert_changes.needsFocus = /*alertNeedsFocus*/
      ctx2[4];
      if (dirty & /*$$scope*/
      512) {
        alert_changes.$$scope = { dirty, ctx: ctx2 };
      }
      alert.$set(alert_changes);
      const button_changes = {};
      if (dirty & /*$$scope*/
      512) {
        button_changes.$$scope = { dirty, ctx: ctx2 };
      }
      button.$set(button_changes);
    },
    i(local) {
      if (current) return;
      transition_in(alert.$$.fragment, local);
      transition_in(button.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(alert.$$.fragment, local);
      transition_out(button.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(alert, detaching);
      if (detaching) detach(t3);
      destroy_component(button, detaching);
    }
  };
}
function create_if_block_3(ctx) {
  let div;
  let spinner;
  let current;
  spinner = new Spinner({
    props: {
      colorClass: "tw_text-primary-light",
      layoutClasses: "tw_h-28 tw_w-28"
    }
  });
  return {
    c() {
      div = element("div");
      create_component(spinner.$$.fragment);
      attr(div, "class", "tw_text-center tw_w-full tw_py-4");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(spinner, div, null);
      current = true;
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(spinner.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(spinner.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(spinner);
    }
  };
}
function create_if_block$1(ctx) {
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block_1, create_if_block_2];
  const if_blocks = [];
  function select_block_type_1(ctx2, dirty) {
    var _a;
    if (
      /*$journeyStore*/
      ctx2[5] && !/*$journeyStore*/
      ctx2[5].step
    ) return 0;
    if (
      /*$journeyStore*/
      ((_a = ctx2[5].step) == null ? void 0 : _a.type) === r$a.Step
    ) return 1;
    return -1;
  }
  if (~(current_block_type_index = select_block_type_1(ctx))) {
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  }
  return {
    c() {
      if (if_block) if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].m(target, anchor);
      }
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type_1(ctx2);
      if (current_block_type_index === previous_block_index) {
        if (~current_block_type_index) {
          if_blocks[current_block_type_index].p(ctx2, dirty);
        }
      } else {
        if (if_block) {
          group_outros();
          transition_out(if_blocks[previous_block_index], 1, 1, () => {
            if_blocks[previous_block_index] = null;
          });
          check_outros();
        }
        if (~current_block_type_index) {
          if_block = if_blocks[current_block_type_index];
          if (!if_block) {
            if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
            if_block.c();
          } else {
            if_block.p(ctx2, dirty);
          }
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        } else {
          if_block = null;
        }
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].d(detaching);
      }
      if (detaching) detach(if_block_anchor);
    }
  };
}
function create_default_slot_1(ctx) {
  let t3;
  let current;
  t3 = new Locale_strings({
    props: { html: true, key: "unrecoverableError" }
  });
  return {
    c() {
      create_component(t3.$$.fragment);
    },
    m(target, anchor) {
      mount_component(t3, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(t3, detaching);
    }
  };
}
function create_default_slot$1(ctx) {
  let t3;
  let current;
  t3 = new Locale_strings({ props: { key: "tryAgain" } });
  return {
    c() {
      create_component(t3.$$.fragment);
    },
    m(target, anchor) {
      mount_component(t3, target, anchor);
      current = true;
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(t3.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(t3.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(t3, detaching);
    }
  };
}
function create_if_block_2(ctx) {
  let switch_instance;
  let updating_formEl;
  let switch_instance_anchor;
  let current;
  function switch_instance_formEl_binding(value) {
    ctx[8](value);
  }
  var switch_value = mapStepToStage(
    /*$journeyStore*/
    ctx[5].step
  );
  function switch_props(ctx2) {
    var _a, _b;
    let switch_instance_props = {
      componentStyle: (
        /*componentStyle*/
        ctx2[1]
      ),
      form: {
        icon: (
          /*displayIcon*/
          ctx2[2]
        ),
        message: (
          /*$journeyStore*/
          ((_a = ctx2[5].error) == null ? void 0 : _a.message) || ""
        ),
        status: (
          /*$journeyStore*/
          ((_b = ctx2[5].error) == null ? void 0 : _b.code) ? "error" : "ok"
        ),
        submit: (
          /*submitForm*/
          ctx2[6]
        )
      },
      journey: {
        loading: (
          /*$journeyStore*/
          ctx2[5].loading
        ),
        pop: (
          /*journeyStore*/
          ctx2[3].pop
        ),
        push: (
          /*journeyStore*/
          ctx2[3].push
        ),
        stack
      },
      metadata: (
        /*$journeyStore*/
        ctx2[5].metadata
      ),
      step: (
        /*$journeyStore*/
        ctx2[5].step
      )
    };
    if (
      /*formEl*/
      ctx2[0] !== void 0
    ) {
      switch_instance_props.formEl = /*formEl*/
      ctx2[0];
    }
    return { props: switch_instance_props };
  }
  if (switch_value) {
    switch_instance = construct_svelte_component(switch_value, switch_props(ctx));
    binding_callbacks.push(() => bind(switch_instance, "formEl", switch_instance_formEl_binding));
  }
  return {
    c() {
      if (switch_instance) create_component(switch_instance.$$.fragment);
      switch_instance_anchor = empty();
    },
    m(target, anchor) {
      if (switch_instance) mount_component(switch_instance, target, anchor);
      insert(target, switch_instance_anchor, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a, _b;
      const switch_instance_changes = {};
      if (dirty & /*componentStyle*/
      2) switch_instance_changes.componentStyle = /*componentStyle*/
      ctx2[1];
      if (dirty & /*displayIcon, $journeyStore*/
      36) switch_instance_changes.form = {
        icon: (
          /*displayIcon*/
          ctx2[2]
        ),
        message: (
          /*$journeyStore*/
          ((_a = ctx2[5].error) == null ? void 0 : _a.message) || ""
        ),
        status: (
          /*$journeyStore*/
          ((_b = ctx2[5].error) == null ? void 0 : _b.code) ? "error" : "ok"
        ),
        submit: (
          /*submitForm*/
          ctx2[6]
        )
      };
      if (dirty & /*$journeyStore, journeyStore*/
      40) switch_instance_changes.journey = {
        loading: (
          /*$journeyStore*/
          ctx2[5].loading
        ),
        pop: (
          /*journeyStore*/
          ctx2[3].pop
        ),
        push: (
          /*journeyStore*/
          ctx2[3].push
        ),
        stack
      };
      if (dirty & /*$journeyStore*/
      32) switch_instance_changes.metadata = /*$journeyStore*/
      ctx2[5].metadata;
      if (dirty & /*$journeyStore*/
      32) switch_instance_changes.step = /*$journeyStore*/
      ctx2[5].step;
      if (!updating_formEl && dirty & /*formEl*/
      1) {
        updating_formEl = true;
        switch_instance_changes.formEl = /*formEl*/
        ctx2[0];
        add_flush_callback(() => updating_formEl = false);
      }
      if (switch_value !== (switch_value = mapStepToStage(
        /*$journeyStore*/
        ctx2[5].step
      ))) {
        if (switch_instance) {
          group_outros();
          const old_component = switch_instance;
          transition_out(old_component.$$.fragment, 1, 0, () => {
            destroy_component(old_component, 1);
          });
          check_outros();
        }
        if (switch_value) {
          switch_instance = construct_svelte_component(switch_value, switch_props(ctx2));
          binding_callbacks.push(() => bind(switch_instance, "formEl", switch_instance_formEl_binding));
          create_component(switch_instance.$$.fragment);
          transition_in(switch_instance.$$.fragment, 1);
          mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
        } else {
          switch_instance = null;
        }
      } else if (switch_value) {
        switch_instance.$set(switch_instance_changes);
      }
    },
    i(local) {
      if (current) return;
      if (switch_instance) transition_in(switch_instance.$$.fragment, local);
      current = true;
    },
    o(local) {
      if (switch_instance) transition_out(switch_instance.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(switch_instance_anchor);
      if (switch_instance) destroy_component(switch_instance, detaching);
    }
  };
}
function create_if_block_1(ctx) {
  let div;
  let spinner;
  let current;
  spinner = new Spinner({
    props: {
      colorClass: "tw_text-primary-light",
      layoutClasses: "tw_h-28 tw_w-28"
    }
  });
  return {
    c() {
      div = element("div");
      create_component(spinner.$$.fragment);
      attr(div, "class", "tw_text-center tw_w-full tw_py-4");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(spinner, div, null);
      current = true;
    },
    p: noop,
    i(local) {
      if (current) return;
      transition_in(spinner.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(spinner.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(spinner);
    }
  };
}
function create_fragment$1(ctx) {
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block$1, create_if_block_3, create_else_block$1];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*$journeyStore*/
      ctx2[5] && !/*$journeyStore*/
      ctx2[5].completed
    ) return 0;
    if (
      /*$journeyStore*/
      ctx2[5] && /*$journeyStore*/
      ctx2[5].successful
    ) return 1;
    return 2;
  }
  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(if_block_anchor.parentNode, if_block_anchor);
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if_blocks[current_block_type_index].d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function instance$1($$self, $$props, $$invalidate) {
  let $journeyStore, $$unsubscribe_journeyStore = noop, $$subscribe_journeyStore = () => ($$unsubscribe_journeyStore(), $$unsubscribe_journeyStore = subscribe(journeyStore2, ($$value) => $$invalidate(5, $journeyStore = $$value)), journeyStore2);
  $$self.$$.on_destroy.push(() => $$unsubscribe_journeyStore());
  let { componentStyle } = $$props;
  let { displayIcon } = $$props;
  let { formEl = null } = $$props;
  let { journeyStore: journeyStore2 } = $$props;
  $$subscribe_journeyStore();
  if (!$journeyStore) {
    console.error("Widget missing configuration. Import and call `configuration()`, then use `set()` to configure.");
  }
  let alertNeedsFocus = false;
  function submitForm() {
    journeyStore2 == null ? void 0 : journeyStore2.next($journeyStore.step);
  }
  function tryAgain2() {
    journeyStore2 == null ? void 0 : journeyStore2.reset();
    journeyStore2 == null ? void 0 : journeyStore2.next();
  }
  afterUpdate(() => {
    $$invalidate(4, alertNeedsFocus = $journeyStore && !$journeyStore.successful);
  });
  function switch_instance_formEl_binding(value) {
    formEl = value;
    $$invalidate(0, formEl);
  }
  $$self.$$set = ($$props2) => {
    if ("componentStyle" in $$props2) $$invalidate(1, componentStyle = $$props2.componentStyle);
    if ("displayIcon" in $$props2) $$invalidate(2, displayIcon = $$props2.displayIcon);
    if ("formEl" in $$props2) $$invalidate(0, formEl = $$props2.formEl);
    if ("journeyStore" in $$props2) $$subscribe_journeyStore($$invalidate(3, journeyStore2 = $$props2.journeyStore));
  };
  return [
    formEl,
    componentStyle,
    displayIcon,
    journeyStore2,
    alertNeedsFocus,
    $journeyStore,
    submitForm,
    tryAgain2,
    switch_instance_formEl_binding
  ];
}
var Journey = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$1, create_fragment$1, safe_not_equal, {
      componentStyle: 1,
      displayIcon: 2,
      formEl: 0,
      journeyStore: 3
    });
  }
};
function create_else_block(ctx) {
  var _a, _b, _c;
  let div;
  let journey_1;
  let updating_formEl;
  let current;
  function journey_1_formEl_binding_1(value) {
    ctx[9](value);
  }
  let journey_1_props = {
    componentStyle: "inline",
    displayIcon: (
      /*$styleStore*/
      (_c = (_b = (_a = ctx[4]) == null ? void 0 : _a.stage) == null ? void 0 : _b.icon) != null ? _c : true
    ),
    journeyStore: (
      /*journeyStore*/
      ctx[5]
    )
  };
  if (
    /*formEl*/
    ctx[3] !== void 0
  ) {
    journey_1_props.formEl = /*formEl*/
    ctx[3];
  }
  journey_1 = new Journey({ props: journey_1_props });
  binding_callbacks.push(() => bind(journey_1, "formEl", journey_1_formEl_binding_1));
  return {
    c() {
      div = element("div");
      create_component(journey_1.$$.fragment);
      attr(div, "class", "fr_widget-root");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(journey_1, div, null);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2, _b2, _c2;
      const journey_1_changes = {};
      if (dirty & /*$styleStore*/
      16) journey_1_changes.displayIcon = /*$styleStore*/
      (_c2 = (_b2 = (_a2 = ctx2[4]) == null ? void 0 : _a2.stage) == null ? void 0 : _b2.icon) != null ? _c2 : true;
      if (!updating_formEl && dirty & /*formEl*/
      8) {
        updating_formEl = true;
        journey_1_changes.formEl = /*formEl*/
        ctx2[3];
        add_flush_callback(() => updating_formEl = false);
      }
      journey_1.$set(journey_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(journey_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(journey_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(journey_1);
    }
  };
}
function create_if_block(ctx) {
  var _a, _b;
  let div;
  let dialog;
  let updating_dialogEl;
  let current;
  function dialog_dialogEl_binding(value) {
    ctx[7](value);
  }
  let dialog_props = {
    dialogId: "sampleDialog",
    withHeader: (
      /*$styleStore*/
      (_b = (_a = ctx[4]) == null ? void 0 : _a.sections) == null ? void 0 : _b.header
    ),
    $$slots: { default: [create_default_slot] },
    $$scope: { ctx }
  };
  if (
    /*dialogEl*/
    ctx[2] !== void 0
  ) {
    dialog_props.dialogEl = /*dialogEl*/
    ctx[2];
  }
  dialog = new Dialog({ props: dialog_props });
  binding_callbacks.push(() => bind(dialog, "dialogEl", dialog_dialogEl_binding));
  ctx[8](dialog);
  return {
    c() {
      div = element("div");
      create_component(dialog.$$.fragment);
      attr(div, "class", "fr_widget-root");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(dialog, div, null);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2, _b2;
      const dialog_changes = {};
      if (dirty & /*$styleStore*/
      16) dialog_changes.withHeader = /*$styleStore*/
      (_b2 = (_a2 = ctx2[4]) == null ? void 0 : _a2.sections) == null ? void 0 : _b2.header;
      if (dirty & /*$$scope, $styleStore, formEl*/
      1048) {
        dialog_changes.$$scope = { dirty, ctx: ctx2 };
      }
      if (!updating_dialogEl && dirty & /*dialogEl*/
      4) {
        updating_dialogEl = true;
        dialog_changes.dialogEl = /*dialogEl*/
        ctx2[2];
        add_flush_callback(() => updating_dialogEl = false);
      }
      dialog.$set(dialog_changes);
    },
    i(local) {
      if (current) return;
      transition_in(dialog.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(dialog.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      ctx[8](null);
      destroy_component(dialog);
    }
  };
}
function create_default_slot(ctx) {
  var _a, _b, _c, _d;
  let journey_1;
  let updating_formEl;
  let current;
  function journey_1_formEl_binding(value) {
    ctx[6](value);
  }
  let journey_1_props = {
    componentStyle: "modal",
    displayIcon: (
      /*$styleStore*/
      (_d = (_b = (_a = ctx[4]) == null ? void 0 : _a.stage) == null ? void 0 : _b.icon) != null ? _d : !/*$styleStore*/
      ((_c = ctx[4]) == null ? void 0 : _c.logo)
    ),
    journeyStore: (
      /*journeyStore*/
      ctx[5]
    )
  };
  if (
    /*formEl*/
    ctx[3] !== void 0
  ) {
    journey_1_props.formEl = /*formEl*/
    ctx[3];
  }
  journey_1 = new Journey({ props: journey_1_props });
  binding_callbacks.push(() => bind(journey_1, "formEl", journey_1_formEl_binding));
  return {
    c() {
      create_component(journey_1.$$.fragment);
    },
    m(target, anchor) {
      mount_component(journey_1, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      var _a2, _b2, _c2, _d2;
      const journey_1_changes = {};
      if (dirty & /*$styleStore*/
      16) journey_1_changes.displayIcon = /*$styleStore*/
      (_d2 = (_b2 = (_a2 = ctx2[4]) == null ? void 0 : _a2.stage) == null ? void 0 : _b2.icon) != null ? _d2 : !/*$styleStore*/
      ((_c2 = ctx2[4]) == null ? void 0 : _c2.logo);
      if (!updating_formEl && dirty & /*formEl*/
      8) {
        updating_formEl = true;
        journey_1_changes.formEl = /*formEl*/
        ctx2[3];
        add_flush_callback(() => updating_formEl = false);
      }
      journey_1.$set(journey_1_changes);
    },
    i(local) {
      if (current) return;
      transition_in(journey_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(journey_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(journey_1, detaching);
    }
  };
}
function create_fragment(ctx) {
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block, create_else_block];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (
      /*type*/
      ctx2[0] === "modal"
    ) return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(if_block_anchor.parentNode, if_block_anchor);
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if_blocks[current_block_type_index].d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
var api = widgetApiFactory(componentApi());
var configuration = api.configuration;
var journey = api.journey;
var request = api.request;
var user = api.user;
var protect = api.protect;
function instance($$self, $$props, $$invalidate) {
  let $styleStore;
  component_subscribe($$self, styleStore, ($$value) => $$invalidate(4, $styleStore = $$value));
  let { type = "modal" } = $$props;
  const { journeyStore: journeyStore2 } = api.getStores();
  let dialogComp;
  let dialogEl;
  let formEl;
  onMount(() => {
    mount(dialogComp, dialogEl);
  });
  function journey_1_formEl_binding(value) {
    formEl = value;
    $$invalidate(3, formEl);
  }
  function dialog_dialogEl_binding(value) {
    dialogEl = value;
    $$invalidate(2, dialogEl);
  }
  function dialog_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      dialogComp = $$value;
      $$invalidate(1, dialogComp);
    });
  }
  function journey_1_formEl_binding_1(value) {
    formEl = value;
    $$invalidate(3, formEl);
  }
  $$self.$$set = ($$props2) => {
    if ("type" in $$props2) $$invalidate(0, type = $$props2.type);
  };
  return [
    type,
    dialogComp,
    dialogEl,
    formEl,
    $styleStore,
    journeyStore2,
    journey_1_formEl_binding,
    dialog_dialogEl_binding,
    dialog_binding,
    journey_1_formEl_binding_1
  ];
}
var Widget = class extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance, create_fragment, safe_not_equal, { type: 0 });
  }
};
function commonjsRequire(path) {
  throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
if (typeof window < "u") {
  (function(s5, h2) {
    typeof s5.CustomEvent != "function" && (s5.CustomEvent = /* @__PURE__ */ function() {
      return function(r10, t3) {
        t3 = t3 || { bubbles: false, cancelable: false, detail: null };
        var e2 = document.createEvent("CustomEvent");
        return e2.initCustomEvent(r10, t3.bubbles, t3.cancelable, t3.detail), e2;
      };
    }());
  })(window), function() {
    var s5 = "st-ping-div";
    function h2(u4) {
      document.readyState !== "loading" ? u4() : document.addEventListener("DOMContentLoaded", u4);
    }
    function r10(u4) {
      h2(function() {
        if (u4) {
          var c5 = (l2 = document.getElementById(s5)) || ((l2 = document.createElement("div")).style.border = "none", l2.style.position = "absolute", l2.style.top = "-999px", l2.style.left = "-999px", l2.style.width = "0", l2.style.height = "0", l2.style.visibility = "hidden", l2.style.overflow = "hidden", l2.id = s5, document.body.appendChild(l2), l2);
          window._pingOneSignalsToken = getComputedStyle(c5, "::after").content.replace(
            /['"]+/g,
            ""
          ), document.dispatchEvent(new CustomEvent("PingOneSignalsTokenReadyEvent"));
        }
        var l2, d4;
        d4 = "Finished - " + (u4 ? "success" : "failure"), window["enable-logs-pingOneSignals"] && console.log(d4);
      });
    }
    var t3, e2, n2, i9, a5 = document.querySelector("script[data-pingOneSignalsSkipToken]");
    if (a5 && a5.getAttribute("data-pingOneSignalsSkipToken") === "true")
      return window._pingOneSignalsToken = "skipped_token_" + (/* @__PURE__ */ new Date()).getTime(), h2(function() {
        document.dispatchEvent(new CustomEvent("PingOneSignalsTokenSkippedEvent"));
      });
    window._pingOneSignalsToken || (window._pingOneSignalsToken = "uninitialized_token_" + (/* @__PURE__ */ new Date()).getTime()), t3 = window._pingOneSignalsCustomHost || "apps.pingone.com", e2 = { sdkVersion: "5.3.5w", platform: navigator.platform || "" }, n2 = encodeURIComponent(
      function(u4) {
        var c5, l2, d4, p4, m, k2, x, y3 = "", C = 0, A2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        for (u4 = function(P2) {
          P2 = P2.replace(/\r\n/g, `
`);
          for (var D2 = "", j = 0; j < P2.length; j++) {
            var z2 = P2.charCodeAt(j);
            z2 < 128 ? D2 += String.fromCharCode(z2) : (127 < z2 && z2 < 2048 ? D2 += String.fromCharCode(z2 >> 6 | 192) : (D2 += String.fromCharCode(z2 >> 12 | 224), D2 += String.fromCharCode(z2 >> 6 & 63 | 128)), D2 += String.fromCharCode(63 & z2 | 128));
          }
          return D2;
        }(u4); C < u4.length; )
          p4 = (c5 = u4.charCodeAt(C++)) >> 2, m = (3 & c5) << 4 | (l2 = u4.charCodeAt(C++)) >> 4, k2 = (15 & l2) << 2 | (d4 = u4.charCodeAt(C++)) >> 6, x = 63 & d4, isNaN(l2) ? k2 = x = 64 : isNaN(d4) && (x = 64), y3 = y3 + A2.charAt(p4) + A2.charAt(m) + A2.charAt(k2) + A2.charAt(x);
        return y3;
      }(
        function(u4, c5) {
          for (var l2 = [], d4 = 0; d4 < u4.length; d4++) {
            var p4 = u4.charCodeAt(d4) ^ c5.charCodeAt(d4 % c5.length);
            l2.push(String.fromCharCode(p4));
          }
          return l2.join("");
        }(JSON.stringify(e2), "dkiBm42")
      )
    ), (i9 = document.createElement("link")).type = "text/css", i9.rel = "stylesheet", i9.href = "https://" + t3 + "/signals/sdk/pong.css?body=" + n2 + "&e=2", (document.head || document.getElementsByTagName("head")[0]).appendChild(i9), i9.onload = function() {
      r10(true);
    }, i9.onerror = function() {
      r10(false);
    };
  }(), function(s5) {
    s5._POSignalsEntities || (s5._POSignalsEntities = {}), s5._pingOneSignals && console.warn("PingOne Signals script was imported multiple times");
  }(window), function(s5) {
    function h2(d4) {
      var p4 = this.constructor;
      return this.then(
        function(m) {
          return p4.resolve(d4()).then(function() {
            return m;
          });
        },
        function(m) {
          return p4.resolve(d4()).then(function() {
            return p4.reject(m);
          });
        }
      );
    }
    var r10 = setTimeout;
    function t3(d4) {
      return !!(d4 && d4.length !== void 0);
    }
    function e2() {
    }
    function n2(d4) {
      if (!(this instanceof n2))
        throw new TypeError("Promises must be constructed via new");
      if (typeof d4 != "function")
        throw new TypeError("not a function");
      this._state = 0, this._handled = false, this._value = void 0, this._deferreds = [], l2(d4, this);
    }
    function i9(d4, p4) {
      for (; d4._state === 3; )
        d4 = d4._value;
      d4._state !== 0 ? (d4._handled = true, n2._immediateFn(function() {
        var m = d4._state === 1 ? p4.onFulfilled : p4.onRejected;
        if (m !== null) {
          var k2;
          try {
            k2 = m(d4._value);
          } catch (x) {
            return void u4(p4.promise, x);
          }
          a5(p4.promise, k2);
        } else
          (d4._state === 1 ? a5 : u4)(p4.promise, d4._value);
      })) : d4._deferreds.push(p4);
    }
    function a5(d4, p4) {
      try {
        if (p4 === d4)
          throw new TypeError("A promise cannot be resolved with itself.");
        if (p4 && (typeof p4 == "object" || typeof p4 == "function")) {
          var m = p4.then;
          if (p4 instanceof n2)
            return d4._state = 3, d4._value = p4, void c5(d4);
          if (typeof m == "function")
            return void l2(
              (k2 = m, x = p4, function() {
                k2.apply(x, arguments);
              }),
              d4
            );
        }
        d4._state = 1, d4._value = p4, c5(d4);
      } catch (y3) {
        u4(d4, y3);
      }
      var k2, x;
    }
    function u4(d4, p4) {
      d4._state = 2, d4._value = p4, c5(d4);
    }
    function c5(d4) {
      d4._state === 2 && d4._deferreds.length === 0 && n2._immediateFn(function() {
        d4._handled || n2._unhandledRejectionFn(d4._value);
      });
      for (var p4 = 0, m = d4._deferreds.length; p4 < m; p4++)
        i9(d4, d4._deferreds[p4]);
      d4._deferreds = null;
    }
    function l2(d4, p4) {
      var m = false;
      try {
        d4(
          function(k2) {
            m || (m = true, a5(p4, k2));
          },
          function(k2) {
            m || (m = true, u4(p4, k2));
          }
        );
      } catch (k2) {
        if (m)
          return;
        m = true, u4(p4, k2);
      }
    }
    n2.prototype.catch = function(d4) {
      return this.then(null, d4);
    }, n2.prototype.then = function(d4, p4) {
      var m = new this.constructor(e2);
      return i9(
        this,
        new function(k2, x, y3) {
          this.onFulfilled = typeof k2 == "function" ? k2 : null, this.onRejected = typeof x == "function" ? x : null, this.promise = y3;
        }(d4, p4, m)
      ), m;
    }, n2.prototype.finally = h2, n2.all = function(d4) {
      return new n2(function(p4, m) {
        if (!t3(d4))
          return m(new TypeError("Promise.all accepts an array"));
        var k2 = Array.prototype.slice.call(d4);
        if (k2.length === 0)
          return p4([]);
        var x = k2.length;
        function y3(A2, P2) {
          try {
            if (P2 && (typeof P2 == "object" || typeof P2 == "function")) {
              var D2 = P2.then;
              if (typeof D2 == "function")
                return void D2.call(
                  P2,
                  function(j) {
                    y3(A2, j);
                  },
                  m
                );
            }
            k2[A2] = P2, --x == 0 && p4(k2);
          } catch (j) {
            m(j);
          }
        }
        for (var C = 0; C < k2.length; C++)
          y3(C, k2[C]);
      });
    }, n2.resolve = function(d4) {
      return d4 && typeof d4 == "object" && d4.constructor === n2 ? d4 : new n2(function(p4) {
        p4(d4);
      });
    }, n2.reject = function(d4) {
      return new n2(function(p4, m) {
        m(d4);
      });
    }, n2.race = function(d4) {
      return new n2(function(p4, m) {
        if (!t3(d4))
          return m(new TypeError("Promise.race accepts an array"));
        for (var k2 = 0, x = d4.length; k2 < x; k2++)
          n2.resolve(d4[k2]).then(p4, m);
      });
    }, n2._immediateFn = typeof setImmediate == "function" && function(d4) {
      setImmediate(d4);
    } || function(d4) {
      r10(d4, 0);
    }, n2._unhandledRejectionFn = function(d4) {
      typeof console < "u" && console && console.warn("Possible Unhandled Promise Rejection:", d4);
    }, typeof s5.Promise != "function" ? s5.Promise = n2 : s5.Promise.prototype.finally || (s5.Promise.prototype.finally = h2);
  }(window), function(s5, h2) {
    (M2 || (M2 = {})).PromiseQueue = function() {
      var r10 = function() {
      };
      function t3(e2, n2, i9) {
        this.options = i9 = i9 || {}, this.pendingPromises = 0, this.maxPendingPromises = e2 !== void 0 ? e2 : 1 / 0, this.maxQueuedPromises = n2 !== void 0 ? n2 : 1 / 0, this.queue = [];
      }
      return t3.prototype.add = function(e2) {
        var n2 = this;
        return new Promise(function(i9, a5, u4) {
          n2.queue.length >= n2.maxQueuedPromises ? a5(new Error("Queue limit reached")) : (n2.queue.push({ promiseGenerator: e2, resolve: i9, reject: a5, notify: u4 || r10 }), n2._dequeue());
        });
      }, t3.prototype.getPendingLength = function() {
        return this.pendingPromises;
      }, t3.prototype.getQueueLength = function() {
        return this.queue.length;
      }, t3.prototype._dequeue = function() {
        var e2 = this;
        if (this.pendingPromises >= this.maxPendingPromises)
          return false;
        var n2, i9 = this.queue.shift();
        if (!i9)
          return this.options.onEmpty && this.options.onEmpty(), false;
        try {
          this.pendingPromises++, (n2 = i9.promiseGenerator(), n2 && typeof n2.then == "function" ? n2 : new Promise(function(a5) {
            a5(n2);
          })).then(
            function(a5) {
              e2.pendingPromises--, i9.resolve(a5), e2._dequeue();
            },
            function(a5) {
              e2.pendingPromises--, i9.reject(a5), e2._dequeue();
            },
            function(a5) {
              i9.notify(a5);
            }
          );
        } catch (a5) {
          e2.pendingPromises--, i9.reject(a5), e2._dequeue();
        }
        return true;
      }, t3;
    }();
  }(), function(s5) {
    var h2 = "input is invalid type", r10 = !s5.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", t3 = "0123456789abcdef".split(""), e2 = [-2147483648, 8388608, 32768, 128], n2 = [24, 16, 8, 0], i9 = [
      1116352408,
      1899447441,
      3049323471,
      3921009573,
      961987163,
      1508970993,
      2453635748,
      2870763221,
      3624381080,
      310598401,
      607225278,
      1426881987,
      1925078388,
      2162078206,
      2614888103,
      3248222580,
      3835390401,
      4022224774,
      264347078,
      604807628,
      770255983,
      1249150122,
      1555081692,
      1996064986,
      2554220882,
      2821834349,
      2952996808,
      3210313671,
      3336571891,
      3584528711,
      113926993,
      338241895,
      666307205,
      773529912,
      1294757372,
      1396182291,
      1695183700,
      1986661051,
      2177026350,
      2456956037,
      2730485921,
      2820302411,
      3259730800,
      3345764771,
      3516065817,
      3600352804,
      4094571909,
      275423344,
      430227734,
      506948616,
      659060556,
      883997877,
      958139571,
      1322822218,
      1537002063,
      1747873779,
      1955562222,
      2024104815,
      2227730452,
      2361852424,
      2428436474,
      2756734187,
      3204031479,
      3329325298
    ], a5 = ["hex", "array", "digest", "arrayBuffer"], u4 = [];
    !s5.JS_SHA256_NO_NODE_JS && Array.isArray || (Array.isArray = function(y3) {
      return Object.prototype.toString.call(y3) === "[object Array]";
    }), !r10 || !s5.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function(y3) {
      return typeof y3 == "object" && y3.buffer && y3.buffer.constructor === ArrayBuffer;
    });
    var c5 = function(y3, C) {
      return function(A2) {
        return new m(C, true).update(A2)[y3]();
      };
    }, l2 = function(y3) {
      var C = c5("hex", y3);
      C.create = function() {
        return new m(y3);
      }, C.update = function(D2) {
        return C.create().update(D2);
      };
      for (var A2 = 0; A2 < a5.length; ++A2) {
        var P2 = a5[A2];
        C[P2] = c5(P2, y3);
      }
      return C;
    }, d4 = function(y3, C) {
      return function(A2, P2) {
        return new k2(A2, C, true).update(P2)[y3]();
      };
    }, p4 = function(y3) {
      var C = d4("hex", y3);
      C.create = function(D2) {
        return new k2(D2, y3);
      }, C.update = function(D2, j) {
        return C.create(D2).update(j);
      };
      for (var A2 = 0; A2 < a5.length; ++A2) {
        var P2 = a5[A2];
        C[P2] = d4(P2, y3);
      }
      return C;
    };
    function m(y3, C) {
      C ? (u4[0] = u4[16] = u4[1] = u4[2] = u4[3] = u4[4] = u4[5] = u4[6] = u4[7] = u4[8] = u4[9] = u4[10] = u4[11] = u4[12] = u4[13] = u4[14] = u4[15] = 0, this.blocks = u4) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], y3 ? (this.h0 = 3238371032, this.h1 = 914150663, this.h2 = 812702999, this.h3 = 4144912697, this.h4 = 4290775857, this.h5 = 1750603025, this.h6 = 1694076839, this.h7 = 3204075428) : (this.h0 = 1779033703, this.h1 = 3144134277, this.h2 = 1013904242, this.h3 = 2773480762, this.h4 = 1359893119, this.h5 = 2600822924, this.h6 = 528734635, this.h7 = 1541459225), this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = false, this.first = true, this.is224 = y3;
    }
    function k2(y3, C, A2) {
      var P2, D2 = typeof y3;
      if (D2 === "string") {
        var j, z2 = [], B = y3.length, T3 = 0;
        for (P2 = 0; P2 < B; ++P2)
          (j = y3.charCodeAt(P2)) < 128 ? z2[T3++] = j : j < 2048 ? (z2[T3++] = 192 | j >> 6, z2[T3++] = 128 | 63 & j) : j < 55296 || j >= 57344 ? (z2[T3++] = 224 | j >> 12, z2[T3++] = 128 | j >> 6 & 63, z2[T3++] = 128 | 63 & j) : (j = 65536 + ((1023 & j) << 10 | 1023 & y3.charCodeAt(++P2)), z2[T3++] = 240 | j >> 18, z2[T3++] = 128 | j >> 12 & 63, z2[T3++] = 128 | j >> 6 & 63, z2[T3++] = 128 | 63 & j);
        y3 = z2;
      } else {
        if (D2 !== "object")
          throw new Error(h2);
        if (y3 === null)
          throw new Error(h2);
        if (r10 && y3.constructor === ArrayBuffer)
          y3 = new Uint8Array(y3);
        else if (!(Array.isArray(y3) || r10 && ArrayBuffer.isView(y3)))
          throw new Error(h2);
      }
      y3.length > 64 && (y3 = new m(C, true).update(y3).array());
      var L2 = [], E2 = [];
      for (P2 = 0; P2 < 64; ++P2) {
        var H2 = y3[P2] || 0;
        L2[P2] = 92 ^ H2, E2[P2] = 54 ^ H2;
      }
      m.call(this, C, A2), this.update(E2), this.oKeyPad = L2, this.inner = true, this.sharedMemory = A2;
    }
    m.prototype.update = function(y3) {
      if (!this.finalized) {
        var C, A2 = typeof y3;
        if (A2 !== "string") {
          if (A2 !== "object")
            throw new Error(h2);
          if (y3 === null)
            throw new Error(h2);
          if (r10 && y3.constructor === ArrayBuffer)
            y3 = new Uint8Array(y3);
          else if (!(Array.isArray(y3) || r10 && ArrayBuffer.isView(y3)))
            throw new Error(h2);
          C = true;
        }
        for (var P2, D2, j = 0, z2 = y3.length, B = this.blocks; j < z2; ) {
          if (this.hashed && (this.hashed = false, B[0] = this.block, B[16] = B[1] = B[2] = B[3] = B[4] = B[5] = B[6] = B[7] = B[8] = B[9] = B[10] = B[11] = B[12] = B[13] = B[14] = B[15] = 0), C)
            for (D2 = this.start; j < z2 && D2 < 64; ++j)
              B[D2 >> 2] |= y3[j] << n2[3 & D2++];
          else
            for (D2 = this.start; j < z2 && D2 < 64; ++j)
              (P2 = y3.charCodeAt(j)) < 128 ? B[D2 >> 2] |= P2 << n2[3 & D2++] : P2 < 2048 ? (B[D2 >> 2] |= (192 | P2 >> 6) << n2[3 & D2++], B[D2 >> 2] |= (128 | 63 & P2) << n2[3 & D2++]) : P2 < 55296 || P2 >= 57344 ? (B[D2 >> 2] |= (224 | P2 >> 12) << n2[3 & D2++], B[D2 >> 2] |= (128 | P2 >> 6 & 63) << n2[3 & D2++], B[D2 >> 2] |= (128 | 63 & P2) << n2[3 & D2++]) : (P2 = 65536 + ((1023 & P2) << 10 | 1023 & y3.charCodeAt(++j)), B[D2 >> 2] |= (240 | P2 >> 18) << n2[3 & D2++], B[D2 >> 2] |= (128 | P2 >> 12 & 63) << n2[3 & D2++], B[D2 >> 2] |= (128 | P2 >> 6 & 63) << n2[3 & D2++], B[D2 >> 2] |= (128 | 63 & P2) << n2[3 & D2++]);
          this.lastByteIndex = D2, this.bytes += D2 - this.start, D2 >= 64 ? (this.block = B[16], this.start = D2 - 64, this.hash(), this.hashed = true) : this.start = D2;
        }
        return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
      }
    }, m.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = true;
        var y3 = this.blocks, C = this.lastByteIndex;
        y3[16] = this.block, y3[C >> 2] |= e2[3 & C], this.block = y3[16], C >= 56 && (this.hashed || this.hash(), y3[0] = this.block, y3[16] = y3[1] = y3[2] = y3[3] = y3[4] = y3[5] = y3[6] = y3[7] = y3[8] = y3[9] = y3[10] = y3[11] = y3[12] = y3[13] = y3[14] = y3[15] = 0), y3[14] = this.hBytes << 3 | this.bytes >>> 29, y3[15] = this.bytes << 3, this.hash();
      }
    }, m.prototype.hash = function() {
      var y3, C, A2, P2, D2, j, z2, B, T3, L2 = this.h0, E2 = this.h1, H2 = this.h2, S = this.h3, U2 = this.h4, W2 = this.h5, J3 = this.h6, Q = this.h7, oe = this.blocks;
      for (y3 = 16; y3 < 64; ++y3)
        C = ((D2 = oe[y3 - 15]) >>> 7 | D2 << 25) ^ (D2 >>> 18 | D2 << 14) ^ D2 >>> 3, A2 = ((D2 = oe[y3 - 2]) >>> 17 | D2 << 15) ^ (D2 >>> 19 | D2 << 13) ^ D2 >>> 10, oe[y3] = oe[y3 - 16] + C + oe[y3 - 7] + A2 << 0;
      for (T3 = E2 & H2, y3 = 0; y3 < 64; y3 += 4)
        this.first ? (this.is224 ? (j = 300032, Q = (D2 = oe[0] - 1413257819) - 150054599 << 0, S = D2 + 24177077 << 0) : (j = 704751109, Q = (D2 = oe[0] - 210244248) - 1521486534 << 0, S = D2 + 143694565 << 0), this.first = false) : (C = (L2 >>> 2 | L2 << 30) ^ (L2 >>> 13 | L2 << 19) ^ (L2 >>> 22 | L2 << 10), P2 = (j = L2 & E2) ^ L2 & H2 ^ T3, Q = S + (D2 = Q + (A2 = (U2 >>> 6 | U2 << 26) ^ (U2 >>> 11 | U2 << 21) ^ (U2 >>> 25 | U2 << 7)) + (U2 & W2 ^ ~U2 & J3) + i9[y3] + oe[y3]) << 0, S = D2 + (C + P2) << 0), C = (S >>> 2 | S << 30) ^ (S >>> 13 | S << 19) ^ (S >>> 22 | S << 10), P2 = (z2 = S & L2) ^ S & E2 ^ j, J3 = H2 + (D2 = J3 + (A2 = (Q >>> 6 | Q << 26) ^ (Q >>> 11 | Q << 21) ^ (Q >>> 25 | Q << 7)) + (Q & U2 ^ ~Q & W2) + i9[y3 + 1] + oe[y3 + 1]) << 0, C = ((H2 = D2 + (C + P2) << 0) >>> 2 | H2 << 30) ^ (H2 >>> 13 | H2 << 19) ^ (H2 >>> 22 | H2 << 10), P2 = (B = H2 & S) ^ H2 & L2 ^ z2, W2 = E2 + (D2 = W2 + (A2 = (J3 >>> 6 | J3 << 26) ^ (J3 >>> 11 | J3 << 21) ^ (J3 >>> 25 | J3 << 7)) + (J3 & Q ^ ~J3 & U2) + i9[y3 + 2] + oe[y3 + 2]) << 0, C = ((E2 = D2 + (C + P2) << 0) >>> 2 | E2 << 30) ^ (E2 >>> 13 | E2 << 19) ^ (E2 >>> 22 | E2 << 10), P2 = (T3 = E2 & H2) ^ E2 & S ^ B, U2 = L2 + (D2 = U2 + (A2 = (W2 >>> 6 | W2 << 26) ^ (W2 >>> 11 | W2 << 21) ^ (W2 >>> 25 | W2 << 7)) + (W2 & J3 ^ ~W2 & Q) + i9[y3 + 3] + oe[y3 + 3]) << 0, L2 = D2 + (C + P2) << 0;
      this.h0 = this.h0 + L2 << 0, this.h1 = this.h1 + E2 << 0, this.h2 = this.h2 + H2 << 0, this.h3 = this.h3 + S << 0, this.h4 = this.h4 + U2 << 0, this.h5 = this.h5 + W2 << 0, this.h6 = this.h6 + J3 << 0, this.h7 = this.h7 + Q << 0;
    }, m.prototype.hex = function() {
      this.finalize();
      var y3 = this.h0, C = this.h1, A2 = this.h2, P2 = this.h3, D2 = this.h4, j = this.h5, z2 = this.h6, B = this.h7, T3 = t3[y3 >> 28 & 15] + t3[y3 >> 24 & 15] + t3[y3 >> 20 & 15] + t3[y3 >> 16 & 15] + t3[y3 >> 12 & 15] + t3[y3 >> 8 & 15] + t3[y3 >> 4 & 15] + t3[15 & y3] + t3[C >> 28 & 15] + t3[C >> 24 & 15] + t3[C >> 20 & 15] + t3[C >> 16 & 15] + t3[C >> 12 & 15] + t3[C >> 8 & 15] + t3[C >> 4 & 15] + t3[15 & C] + t3[A2 >> 28 & 15] + t3[A2 >> 24 & 15] + t3[A2 >> 20 & 15] + t3[A2 >> 16 & 15] + t3[A2 >> 12 & 15] + t3[A2 >> 8 & 15] + t3[A2 >> 4 & 15] + t3[15 & A2] + t3[P2 >> 28 & 15] + t3[P2 >> 24 & 15] + t3[P2 >> 20 & 15] + t3[P2 >> 16 & 15] + t3[P2 >> 12 & 15] + t3[P2 >> 8 & 15] + t3[P2 >> 4 & 15] + t3[15 & P2] + t3[D2 >> 28 & 15] + t3[D2 >> 24 & 15] + t3[D2 >> 20 & 15] + t3[D2 >> 16 & 15] + t3[D2 >> 12 & 15] + t3[D2 >> 8 & 15] + t3[D2 >> 4 & 15] + t3[15 & D2] + t3[j >> 28 & 15] + t3[j >> 24 & 15] + t3[j >> 20 & 15] + t3[j >> 16 & 15] + t3[j >> 12 & 15] + t3[j >> 8 & 15] + t3[j >> 4 & 15] + t3[15 & j] + t3[z2 >> 28 & 15] + t3[z2 >> 24 & 15] + t3[z2 >> 20 & 15] + t3[z2 >> 16 & 15] + t3[z2 >> 12 & 15] + t3[z2 >> 8 & 15] + t3[z2 >> 4 & 15] + t3[15 & z2];
      return this.is224 || (T3 += t3[B >> 28 & 15] + t3[B >> 24 & 15] + t3[B >> 20 & 15] + t3[B >> 16 & 15] + t3[B >> 12 & 15] + t3[B >> 8 & 15] + t3[B >> 4 & 15] + t3[15 & B]), T3;
    }, m.prototype.toString = m.prototype.hex, m.prototype.digest = function() {
      this.finalize();
      var y3 = this.h0, C = this.h1, A2 = this.h2, P2 = this.h3, D2 = this.h4, j = this.h5, z2 = this.h6, B = this.h7, T3 = [
        y3 >> 24 & 255,
        y3 >> 16 & 255,
        y3 >> 8 & 255,
        255 & y3,
        C >> 24 & 255,
        C >> 16 & 255,
        C >> 8 & 255,
        255 & C,
        A2 >> 24 & 255,
        A2 >> 16 & 255,
        A2 >> 8 & 255,
        255 & A2,
        P2 >> 24 & 255,
        P2 >> 16 & 255,
        P2 >> 8 & 255,
        255 & P2,
        D2 >> 24 & 255,
        D2 >> 16 & 255,
        D2 >> 8 & 255,
        255 & D2,
        j >> 24 & 255,
        j >> 16 & 255,
        j >> 8 & 255,
        255 & j,
        z2 >> 24 & 255,
        z2 >> 16 & 255,
        z2 >> 8 & 255,
        255 & z2
      ];
      return this.is224 || T3.push(B >> 24 & 255, B >> 16 & 255, B >> 8 & 255, 255 & B), T3;
    }, m.prototype.array = m.prototype.digest, m.prototype.arrayBuffer = function() {
      this.finalize();
      var y3 = new ArrayBuffer(this.is224 ? 28 : 32), C = new DataView(y3);
      return C.setUint32(0, this.h0), C.setUint32(4, this.h1), C.setUint32(8, this.h2), C.setUint32(12, this.h3), C.setUint32(16, this.h4), C.setUint32(20, this.h5), C.setUint32(24, this.h6), this.is224 || C.setUint32(28, this.h7), y3;
    }, k2.prototype = new m(), k2.prototype.finalize = function() {
      if (m.prototype.finalize.call(this), this.inner) {
        this.inner = false;
        var y3 = this.array();
        m.call(this, this.is224, this.sharedMemory), this.update(this.oKeyPad), this.update(y3), m.prototype.finalize.call(this);
      }
    };
    var x = l2();
    x.sha256 = x, x.sha224 = l2(true), x.sha256.hmac = p4(), x.sha224.hmac = p4(true), s5.sha256 = x.sha256, s5.sha224 = x.sha224;
  }(M2 || (M2 = {})), (M2 || (M2 = {})).FingerprintJS = function(s5) {
    function h2(_2, O3) {
      _2 = [_2[0] >>> 16, 65535 & _2[0], _2[1] >>> 16, 65535 & _2[1]], O3 = [O3[0] >>> 16, 65535 & O3[0], O3[1] >>> 16, 65535 & O3[1]];
      var w2 = [0, 0, 0, 0];
      return w2[3] += _2[3] + O3[3], w2[2] += w2[3] >>> 16, w2[3] &= 65535, w2[2] += _2[2] + O3[2], w2[1] += w2[2] >>> 16, w2[2] &= 65535, w2[1] += _2[1] + O3[1], w2[0] += w2[1] >>> 16, w2[1] &= 65535, w2[0] += _2[0] + O3[0], w2[0] &= 65535, [w2[0] << 16 | w2[1], w2[2] << 16 | w2[3]];
    }
    function r10(_2, O3) {
      _2 = [_2[0] >>> 16, 65535 & _2[0], _2[1] >>> 16, 65535 & _2[1]], O3 = [O3[0] >>> 16, 65535 & O3[0], O3[1] >>> 16, 65535 & O3[1]];
      var w2 = [0, 0, 0, 0];
      return w2[3] += _2[3] * O3[3], w2[2] += w2[3] >>> 16, w2[3] &= 65535, w2[2] += _2[2] * O3[3], w2[1] += w2[2] >>> 16, w2[2] &= 65535, w2[2] += _2[3] * O3[2], w2[1] += w2[2] >>> 16, w2[2] &= 65535, w2[1] += _2[1] * O3[3], w2[0] += w2[1] >>> 16, w2[1] &= 65535, w2[1] += _2[2] * O3[2], w2[0] += w2[1] >>> 16, w2[1] &= 65535, w2[1] += _2[3] * O3[1], w2[0] += w2[1] >>> 16, w2[1] &= 65535, w2[0] += _2[0] * O3[3] + _2[1] * O3[2] + _2[2] * O3[1] + _2[3] * O3[0], w2[0] &= 65535, [w2[0] << 16 | w2[1], w2[2] << 16 | w2[3]];
    }
    function t3(_2, O3) {
      return (O3 %= 64) == 32 ? [_2[1], _2[0]] : O3 < 32 ? [_2[0] << O3 | _2[1] >>> 32 - O3, _2[1] << O3 | _2[0] >>> 32 - O3] : (O3 -= 32, [_2[1] << O3 | _2[0] >>> 32 - O3, _2[0] << O3 | _2[1] >>> 32 - O3]);
    }
    function e2(_2, O3) {
      return (O3 %= 64) == 0 ? _2 : O3 < 32 ? [_2[0] << O3 | _2[1] >>> 32 - O3, _2[1] << O3] : [_2[1] << O3 - 32, 0];
    }
    function n2(_2, O3) {
      return [_2[0] ^ O3[0], _2[1] ^ O3[1]];
    }
    function i9(_2) {
      return _2 = n2(
        _2 = r10(
          _2 = n2(_2 = r10(_2 = n2(_2, [0, _2[0] >>> 1]), [4283543511, 3981806797]), [
            0,
            _2[0] >>> 1
          ]),
          [3301882366, 444984403]
        ),
        [0, _2[0] >>> 1]
      );
    }
    function a5(_2, O3) {
      _2 = _2 || "", O3 = O3 || 0;
      var w2, K = _2.length % 16, V2 = _2.length - K, o2 = [0, O3], g = [0, O3], v = [0, 0], f3 = [0, 0], b3 = [2277735313, 289559509], I = [1291169091, 658871167];
      for (w2 = 0; w2 < V2; w2 += 16)
        v = [
          255 & _2.charCodeAt(w2 + 4) | (255 & _2.charCodeAt(w2 + 5)) << 8 | (255 & _2.charCodeAt(w2 + 6)) << 16 | (255 & _2.charCodeAt(w2 + 7)) << 24,
          255 & _2.charCodeAt(w2) | (255 & _2.charCodeAt(w2 + 1)) << 8 | (255 & _2.charCodeAt(w2 + 2)) << 16 | (255 & _2.charCodeAt(w2 + 3)) << 24
        ], f3 = [
          255 & _2.charCodeAt(w2 + 12) | (255 & _2.charCodeAt(w2 + 13)) << 8 | (255 & _2.charCodeAt(w2 + 14)) << 16 | (255 & _2.charCodeAt(w2 + 15)) << 24,
          255 & _2.charCodeAt(w2 + 8) | (255 & _2.charCodeAt(w2 + 9)) << 8 | (255 & _2.charCodeAt(w2 + 10)) << 16 | (255 & _2.charCodeAt(w2 + 11)) << 24
        ], o2 = h2(
          r10(
            o2 = h2(o2 = t3(o2 = n2(o2, v = r10(v = t3(v = r10(v, b3), 31), I)), 27), g),
            [0, 5]
          ),
          [0, 1390208809]
        ), g = h2(
          r10(
            g = h2(g = t3(g = n2(g, f3 = r10(f3 = t3(f3 = r10(f3, I), 33), b3)), 31), o2),
            [0, 5]
          ),
          [0, 944331445]
        );
      switch (v = [0, 0], f3 = [0, 0], K) {
        case 15:
          f3 = n2(f3, e2([0, _2.charCodeAt(w2 + 14)], 48));
        case 14:
          f3 = n2(f3, e2([0, _2.charCodeAt(w2 + 13)], 40));
        case 13:
          f3 = n2(f3, e2([0, _2.charCodeAt(w2 + 12)], 32));
        case 12:
          f3 = n2(f3, e2([0, _2.charCodeAt(w2 + 11)], 24));
        case 11:
          f3 = n2(f3, e2([0, _2.charCodeAt(w2 + 10)], 16));
        case 10:
          f3 = n2(f3, e2([0, _2.charCodeAt(w2 + 9)], 8));
        case 9:
          g = n2(g, f3 = r10(f3 = t3(f3 = r10(f3 = n2(f3, [0, _2.charCodeAt(w2 + 8)]), I), 33), b3));
        case 8:
          v = n2(v, e2([0, _2.charCodeAt(w2 + 7)], 56));
        case 7:
          v = n2(v, e2([0, _2.charCodeAt(w2 + 6)], 48));
        case 6:
          v = n2(v, e2([0, _2.charCodeAt(w2 + 5)], 40));
        case 5:
          v = n2(v, e2([0, _2.charCodeAt(w2 + 4)], 32));
        case 4:
          v = n2(v, e2([0, _2.charCodeAt(w2 + 3)], 24));
        case 3:
          v = n2(v, e2([0, _2.charCodeAt(w2 + 2)], 16));
        case 2:
          v = n2(v, e2([0, _2.charCodeAt(w2 + 1)], 8));
        case 1:
          o2 = n2(o2, v = r10(v = t3(v = r10(v = n2(v, [0, _2.charCodeAt(w2)]), b3), 31), I));
      }
      return o2 = n2(o2, [0, _2.length]), g = h2(g = n2(g, [0, _2.length]), o2 = h2(o2, g)), o2 = i9(o2), g = h2(g = i9(g), o2 = h2(o2, g)), ("00000000" + (o2[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (o2[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (g[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (g[1] >>> 0).toString(16)).slice(-8);
    }
    var u4 = function() {
      return (u4 = Object.assign || function(_2) {
        for (var O3, w2 = 1, K = arguments.length; w2 < K; w2++)
          for (var V2 in O3 = arguments[w2])
            Object.prototype.hasOwnProperty.call(O3, V2) && (_2[V2] = O3[V2]);
        return _2;
      }).apply(this, arguments);
    };
    function c5(_2, O3, w2, K) {
      return new (w2 || (w2 = Promise))(function(V2, o2) {
        function g(b3) {
          try {
            f3(K.next(b3));
          } catch (I) {
            o2(I);
          }
        }
        function v(b3) {
          try {
            f3(K.throw(b3));
          } catch (I) {
            o2(I);
          }
        }
        function f3(b3) {
          var I;
          b3.done ? V2(b3.value) : (I = b3.value, I instanceof w2 ? I : new w2(function(F2) {
            F2(I);
          })).then(g, v);
        }
        f3((K = K.apply(_2, O3 || [])).next());
      });
    }
    function l2(_2, O3) {
      var w2, K, V2, o2, g = {
        label: 0,
        sent: function() {
          if (1 & V2[0])
            throw V2[1];
          return V2[1];
        },
        trys: [],
        ops: []
      };
      return o2 = { next: v(0), throw: v(1), return: v(2) }, typeof Symbol == "function" && (o2[Symbol.iterator] = function() {
        return this;
      }), o2;
      function v(f3) {
        return function(b3) {
          return function(I) {
            if (w2)
              throw new TypeError("Generator is already executing.");
            for (; g; )
              try {
                if (w2 = 1, K && (V2 = 2 & I[0] ? K.return : I[0] ? K.throw || ((V2 = K.return) && V2.call(K), 0) : K.next) && !(V2 = V2.call(K, I[1])).done)
                  return V2;
                switch (K = 0, V2 && (I = [2 & I[0], V2.value]), I[0]) {
                  case 0:
                  case 1:
                    V2 = I;
                    break;
                  case 4:
                    return g.label++, { value: I[1], done: false };
                  case 5:
                    g.label++, K = I[1], I = [0];
                    continue;
                  case 7:
                    I = g.ops.pop(), g.trys.pop();
                    continue;
                  default:
                    if (!(V2 = (V2 = g.trys).length > 0 && V2[V2.length - 1]) && (I[0] === 6 || I[0] === 2)) {
                      g = 0;
                      continue;
                    }
                    if (I[0] === 3 && (!V2 || I[1] > V2[0] && I[1] < V2[3])) {
                      g.label = I[1];
                      break;
                    }
                    if (I[0] === 6 && g.label < V2[1]) {
                      g.label = V2[1], V2 = I;
                      break;
                    }
                    if (V2 && g.label < V2[2]) {
                      g.label = V2[2], g.ops.push(I);
                      break;
                    }
                    V2[2] && g.ops.pop(), g.trys.pop();
                    continue;
                }
                I = O3.call(_2, g);
              } catch (F2) {
                I = [6, F2], K = 0;
              } finally {
                w2 = V2 = 0;
              }
            if (5 & I[0])
              throw I[1];
            return { value: I[0] ? I[1] : void 0, done: true };
          }([f3, b3]);
        };
      }
    }
    var d4 = window;
    function p4(_2) {
      return parseInt(_2);
    }
    function m(_2) {
      return parseFloat(_2);
    }
    function k2(_2) {
      return _2.reduce(function(O3, w2) {
        return O3 + (w2 ? 1 : 0);
      }, 0);
    }
    var x = window, y3 = navigator, C = document;
    function A2() {
      return k2([
        "MSCSSMatrix" in x,
        "msSetImmediate" in x,
        "msIndexedDB" in x,
        "msMaxTouchPoints" in y3,
        "msPointerEnabled" in y3
      ]) >= 4;
    }
    function P2() {
      return k2(["msWriteProfilerMark" in x, "MSStream" in x, "msLaunchUri" in y3, "msSaveBlob" in y3]) >= 3 && !A2();
    }
    function D2() {
      return k2([
        "webkitPersistentStorage" in y3,
        "webkitTemporaryStorage" in y3,
        y3.vendor.indexOf("Google") === 0,
        "webkitResolveLocalFileSystemURL" in x,
        "BatteryManager" in x,
        "webkitMediaStream" in x,
        "webkitSpeechGrammar" in x
      ]) >= 5;
    }
    function j() {
      return k2([
        "ApplePayError" in x,
        "CSSPrimitiveValue" in x,
        "Counter" in x,
        y3.vendor.indexOf("Apple") === 0,
        "getStorageUpdates" in y3,
        "WebKitMediaKeys" in x
      ]) >= 4;
    }
    function z2() {
      return k2([
        "safari" in x,
        !("DeviceMotionEvent" in x),
        !("ongestureend" in x),
        !("standalone" in y3)
      ]) >= 3;
    }
    var B = window, T3 = document;
    function L2(_2, O3, w2) {
      (function(K) {
        return K && typeof K.setValueAtTime == "function";
      })(O3) && O3.setValueAtTime(w2, _2.currentTime);
    }
    function E2(_2) {
      var O3 = new Error(_2);
      return O3.name = _2, O3;
    }
    var H2 = document, S = "mmMwWLliI0O&1", U2 = ["monospace", "sans-serif", "serif"], W2 = [
      "sans-serif-thin",
      "ARNO PRO",
      "Agency FB",
      "Arabic Typesetting",
      "Arial Unicode MS",
      "AvantGarde Bk BT",
      "BankGothic Md BT",
      "Batang",
      "Bitstream Vera Sans Mono",
      "Calibri",
      "Century",
      "Century Gothic",
      "Clarendon",
      "EUROSTILE",
      "Franklin Gothic",
      "Futura Bk BT",
      "Futura Md BT",
      "GOTHAM",
      "Gill Sans",
      "HELV",
      "Haettenschweiler",
      "Helvetica Neue",
      "Humanst521 BT",
      "Leelawadee",
      "Letter Gothic",
      "Levenim MT",
      "Lucida Bright",
      "Lucida Sans",
      "Menlo",
      "MS Mincho",
      "MS Outlook",
      "MS Reference Specialty",
      "MS UI Gothic",
      "MT Extra",
      "MYRIAD PRO",
      "Marlett",
      "Meiryo UI",
      "Microsoft Uighur",
      "Minion Pro",
      "Monotype Corsiva",
      "PMingLiU",
      "Pristina",
      "SCRIPTINA",
      "Segoe UI Light",
      "Serifa",
      "SimHei",
      "Small Fonts",
      "Staccato222 BT",
      "TRAJAN PRO",
      "Univers CE 55 Medium",
      "Vrinda",
      "ZWAdobeF"
    ], J3 = {
      fontStyle: "normal",
      fontWeight: "normal",
      letterSpacing: "normal",
      lineBreak: "auto",
      lineHeight: "normal",
      textTransform: "none",
      textAlign: "left",
      textDecoration: "none",
      textShadow: "none",
      whiteSpace: "normal",
      wordBreak: "normal",
      wordSpacing: "normal",
      position: "absolute",
      left: "-9999px",
      fontSize: "48px"
    }, Q = navigator, oe = window, q = navigator, fe = window, N2 = window, G = window, Y = document, te = {
      osCpu: function() {
        return navigator.oscpu;
      },
      languages: function() {
        var _2 = [], O3 = q.language || q.userLanguage || q.browserLanguage || q.systemLanguage;
        if (O3 !== void 0 && _2.push([O3]), Array.isArray(q.languages))
          D2() && k2([
            !("MediaSettingsRange" in x),
            "RTCEncodedAudioFrame" in x,
            "" + x.Intl == "[object Intl]",
            "" + x.Reflect == "[object Reflect]"
          ]) >= 3 || _2.push(q.languages);
        else if (typeof q.languages == "string") {
          var w2 = q.languages;
          w2 && _2.push(w2.split(","));
        }
        return _2;
      },
      colorDepth: function() {
        return window.screen.colorDepth;
      },
      deviceMemory: function() {
        return _2 = m(navigator.deviceMemory), O3 = void 0, typeof _2 == "number" && isNaN(_2) ? O3 : _2;
        var _2, O3;
      },
      screenResolution: function() {
        var _2 = [p4(fe.screen.width), p4(fe.screen.height)];
        return _2.sort().reverse(), _2;
      },
      availableScreenResolution: function() {
        if (N2.screen.availWidth && N2.screen.availHeight) {
          var _2 = [p4(N2.screen.availWidth), p4(N2.screen.availHeight)];
          return _2.sort().reverse(), _2;
        }
      },
      hardwareConcurrency: function() {
        try {
          var _2 = p4(navigator.hardwareConcurrency);
          return isNaN(_2) ? 1 : _2;
        } catch (e3) {
          return 1;
        }
      },
      timezoneOffset: function() {
        var _2 = (/* @__PURE__ */ new Date()).getFullYear();
        return Math.max(
          m(new Date(_2, 0, 1).getTimezoneOffset()),
          m(new Date(_2, 6, 1).getTimezoneOffset())
        );
      },
      timezone: function() {
        var _2;
        if (!((_2 = G.Intl) === null || _2 === void 0) && _2.DateTimeFormat)
          return new G.Intl.DateTimeFormat().resolvedOptions().timeZone;
      },
      sessionStorage: function() {
        try {
          return !!window.sessionStorage;
        } catch (e3) {
          return true;
        }
      },
      localStorage: function() {
        try {
          return !!window.localStorage;
        } catch (e3) {
          return true;
        }
      },
      indexedDB: function() {
        if (!A2() && !P2())
          try {
            return !!window.indexedDB;
          } catch (e3) {
            return true;
          }
      },
      openDatabase: function() {
        return !!window.openDatabase;
      },
      cpuClass: function() {
        return navigator.cpuClass;
      },
      platform: function() {
        return navigator.platform;
      },
      plugins: function() {
        if (A2())
          return [];
        if (navigator.plugins) {
          for (var _2 = [], O3 = 0; O3 < navigator.plugins.length; ++O3) {
            var w2 = navigator.plugins[O3];
            if (w2) {
              for (var K = [], V2 = 0; V2 < w2.length; ++V2) {
                var o2 = w2[V2];
                K.push({ type: o2.type, suffixes: o2.suffixes });
              }
              _2.push({ name: w2.name, description: w2.description, mimeTypes: K });
            }
          }
          return _2;
        }
      },
      canvas: function() {
        var _2 = function() {
          var V2 = document.createElement("canvas");
          return V2.width = 240, V2.height = 140, V2.style.display = "inline", [V2, V2.getContext("2d")];
        }(), O3 = _2[0], w2 = _2[1];
        if (!function(V2, o2) {
          return !(!o2 || !V2.toDataURL);
        }(O3, w2))
          return { winding: false, data: "" };
        w2.rect(0, 0, 10, 10), w2.rect(2, 2, 6, 6);
        var K = !w2.isPointInPath(5, 5, "evenodd");
        return w2.textBaseline = "alphabetic", w2.fillStyle = "#f60", w2.fillRect(125, 1, 62, 20), w2.fillStyle = "#069", w2.font = "11pt no-real-font-123", w2.fillText("Cwm fjordbank \xF0\u0178\u02DC\u0192 gly", 2, 15), w2.fillStyle = "rgba(102, 204, 0, 0.2)", w2.font = "18pt Arial", w2.fillText("Cwm fjordbank \xF0\u0178\u02DC\u0192 gly", 4, 45), w2.globalCompositeOperation = "multiply", w2.fillStyle = "rgb(255,0,255)", w2.beginPath(), w2.arc(50, 50, 50, 0, 2 * Math.PI, true), w2.closePath(), w2.fill(), w2.fillStyle = "rgb(0,255,255)", w2.beginPath(), w2.arc(100, 50, 50, 0, 2 * Math.PI, true), w2.closePath(), w2.fill(), w2.fillStyle = "rgb(255,255,0)", w2.beginPath(), w2.arc(75, 100, 50, 0, 2 * Math.PI, true), w2.closePath(), w2.fill(), w2.fillStyle = "rgb(255,0,255)", w2.arc(75, 75, 75, 0, 2 * Math.PI, true), w2.arc(75, 75, 25, 0, 2 * Math.PI, true), w2.fill("evenodd"), {
          winding: K,
          data: function(V2) {
            return V2.toDataURL();
          }(O3)
        };
      },
      touchSupport: function() {
        var _2, O3 = 0;
        Q.maxTouchPoints !== void 0 ? O3 = p4(Q.maxTouchPoints) : Q.msMaxTouchPoints !== void 0 && (O3 = Q.msMaxTouchPoints);
        try {
          document.createEvent("TouchEvent"), _2 = true;
        } catch (e3) {
          _2 = false;
        }
        return { maxTouchPoints: O3, touchEvent: _2, touchStart: "ontouchstart" in oe };
      },
      fonts: function() {
        var _2 = H2.body, O3 = H2.createElement("div"), w2 = H2.createElement("div"), K = {}, V2 = {}, o2 = function() {
          var X = H2.createElement("span");
          X.textContent = S;
          for (var ie = 0, de = Object.keys(J3); ie < de.length; ie++) {
            var pe = de[ie];
            X.style[pe] = J3[pe];
          }
          return X;
        }, g = function(X) {
          return U2.some(function(ie, de) {
            return X[de].offsetWidth !== K[ie] || X[de].offsetHeight !== V2[ie];
          });
        }, v = U2.map(function(X) {
          var ie = o2();
          return ie.style.fontFamily = X, O3.appendChild(ie), ie;
        });
        _2.appendChild(O3);
        for (var f3 = 0, b3 = U2.length; f3 < b3; f3++)
          K[U2[f3]] = v[f3].offsetWidth, V2[U2[f3]] = v[f3].offsetHeight;
        var I = function() {
          for (var X = {}, ie = function(ge) {
            X[ge] = U2.map(function(ye) {
              var he = function(be, we) {
                var me = o2();
                return me.style.fontFamily = "'" + be + "'," + we, me;
              }(ge, ye);
              return w2.appendChild(he), he;
            });
          }, de = 0, pe = W2; de < pe.length; de++)
            ie(pe[de]);
          return X;
        }();
        _2.appendChild(w2);
        for (var F2 = [], R = 0, ne = W2.length; R < ne; R++)
          g(I[W2[R]]) && F2.push(W2[R]);
        return _2.removeChild(w2), _2.removeChild(O3), F2;
      },
      audio: function() {
        return c5(this, void 0, void 0, function() {
          var _2, O3, w2, K, V2, o2;
          return l2(this, function(g) {
            switch (g.label) {
              case 0:
                if (!(_2 = B.OfflineAudioContext || B.webkitOfflineAudioContext))
                  return [2, -2];
                if (j() && !z2() && !(k2([
                  "DOMRectList" in x,
                  "RTCPeerConnectionIceEvent" in x,
                  "SVGGeometryElement" in x,
                  "ontransitioncancel" in x
                ]) >= 3))
                  return [2, -1];
                O3 = new _2(1, 44100, 44100), (w2 = O3.createOscillator()).type = "triangle", L2(O3, w2.frequency, 1e4), K = O3.createDynamicsCompressor(), L2(O3, K.threshold, -50), L2(O3, K.knee, 40), L2(O3, K.ratio, 12), L2(O3, K.reduction, -20), L2(O3, K.attack, 0), L2(O3, K.release, 0.25), w2.connect(K), K.connect(O3.destination), w2.start(0), g.label = 1;
              case 1:
                return g.trys.push([1, 3, 4, 5]), [
                  4,
                  function(v) {
                    return new Promise(function(f3, b3) {
                      v.oncomplete = function(R) {
                        return f3(R.renderedBuffer);
                      };
                      var I = 3, F2 = function() {
                        switch (v.startRendering(), v.state) {
                          case "running":
                            setTimeout(function() {
                              return b3(E2("timeout"));
                            }, 1e3);
                            break;
                          case "suspended":
                            T3.hidden || I--, I > 0 ? setTimeout(F2, 500) : b3(E2("suspended"));
                        }
                      };
                      F2();
                    });
                  }(O3)
                ];
              case 2:
                return V2 = g.sent(), [3, 5];
              case 3:
                if ((o2 = g.sent()).name === "timeout" || o2.name === "suspended")
                  return [2, -3];
                throw o2;
              case 4:
                return w2.disconnect(), K.disconnect(), [7];
              case 5:
                return [
                  2,
                  function(v) {
                    for (var f3 = 0, b3 = 4500; b3 < 5e3; ++b3)
                      f3 += Math.abs(v[b3]);
                    return f3;
                  }(V2.getChannelData(0))
                ];
            }
          });
        });
      },
      pluginsSupport: function() {
        return navigator.plugins !== void 0;
      },
      productSub: function() {
        return navigator.productSub;
      },
      emptyEvalLength: function() {
        return eval.toString().length;
      },
      errorFF: function() {
        try {
          throw "a";
        } catch (_2) {
          try {
            return _2.toSource(), true;
          } catch (e3) {
            return false;
          }
        }
      },
      vendor: function() {
        return navigator.vendor;
      },
      chrome: function() {
        return window.chrome !== void 0;
      },
      cookiesEnabled: function() {
        try {
          Y.cookie = "cookietest=1; SameSite=Strict;";
          var _2 = Y.cookie.indexOf("cookietest=") !== -1;
          return Y.cookie = "cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT", _2;
        } catch (e3) {
          return false;
        }
      }
    };
    function ae(_2, O3, w2) {
      return c5(this, void 0, void 0, function() {
        var K, V2, o2, g, v, f3, b3, I, F2;
        return l2(this, function(R) {
          switch (R.label) {
            case 0:
              K = Date.now(), V2 = {}, o2 = 0, g = Object.keys(_2), R.label = 1;
            case 1:
              if (!(o2 < g.length))
                return [3, 7];
              if (v = g[o2], function(ne, X) {
                for (var ie = 0, de = ne.length; ie < de; ++ie)
                  if (ne[ie] === X)
                    return true;
                return false;
              }(w2, v))
                return [3, 6];
              f3 = void 0, R.label = 2;
            case 2:
              return R.trys.push([2, 4, , 5]), F2 = {}, [4, _2[v](O3)];
            case 3:
              return F2.value = R.sent(), f3 = F2, [3, 5];
            case 4:
              return b3 = R.sent(), f3 = b3 && typeof b3 == "object" && "message" in b3 ? { error: b3 } : { error: { message: b3 } }, [3, 5];
            case 5:
              I = Date.now(), V2[v] = u4(u4({}, f3), { duration: I - K }), K = I, R.label = 6;
            case 6:
              return o2++, [3, 1];
            case 7:
              return [2, V2];
          }
        });
      });
    }
    function se(_2) {
      return JSON.stringify(
        _2,
        function(O3, w2) {
          return w2 instanceof Error ? u4(
            {
              name: (K = w2).name,
              message: K.message,
              stack: (V2 = K.stack) === null || V2 === void 0 ? void 0 : V2.split(`
`)
            },
            K
          ) : w2;
          var K, V2;
        },
        2
      );
    }
    function le(_2) {
      return a5(
        function(O3) {
          for (var w2 = "", K = 0, V2 = Object.keys(O3); K < V2.length; K++) {
            var o2 = V2[K], g = O3[o2], v = g.error ? "error" : JSON.stringify(g.value);
            w2 += (w2 ? "|" : "") + o2.replace(/([:|\\])/g, "\\$1") + ":" + v;
          }
          return w2;
        }(_2)
      );
    }
    var ee = function() {
      function _2() {
      }
      return _2.prototype.get = function(O3) {
        return O3 === void 0 && (O3 = {}), c5(this, void 0, void 0, function() {
          var w2, K;
          return l2(this, function(V2) {
            switch (V2.label) {
              case 0:
                return [4, ae(te, void 0, [])];
              case 1:
                return w2 = V2.sent(), K = /* @__PURE__ */ function(o2) {
                  var g;
                  return {
                    components: o2,
                    get visitorId() {
                      return g === void 0 && (g = le(this.components)), g;
                    },
                    set visitorId(v) {
                      g = v;
                    }
                  };
                }(w2), O3.debug && console.log(
                  `Copy the text below to get the debug data:

\`\`\`
version: 3.0.5
userAgent: ` + navigator.userAgent + `
getOptions: ` + JSON.stringify(O3, void 0, 2) + `
visitorId: ` + K.visitorId + `
components: ` + se(w2) + "\n```"
                ), [2, K];
            }
          });
        });
      }, _2;
    }();
    function ue(_2) {
      var O3 = (_2 === void 0 ? {} : _2).delayFallback, w2 = O3 === void 0 ? 50 : O3;
      return c5(this, void 0, void 0, function() {
        return l2(this, function(K) {
          switch (K.label) {
            case 0:
              return [
                4,
                (V2 = w2, o2 = 2 * w2, o2 === void 0 && (o2 = 1 / 0), new Promise(function(g) {
                  d4.requestIdleCallback ? d4.requestIdleCallback(
                    function() {
                      return g();
                    },
                    { timeout: o2 }
                  ) : setTimeout(g, Math.min(V2, o2));
                }))
              ];
            case 1:
              return K.sent(), [2, new ee()];
          }
          var V2, o2;
        });
      });
    }
    var re = { load: ue, hashComponents: le, componentsToDebugString: se }, ce = a5;
    return s5.componentsToDebugString = se, s5.default = re, s5.getComponents = ae, s5.hashComponents = le, s5.isChromium = D2, s5.isDesktopSafari = z2, s5.isEdgeHTML = P2, s5.isGecko = function() {
      var _2;
      return k2([
        "buildID" in y3,
        ((_2 = C.documentElement) === null || _2 === void 0 ? void 0 : _2.style) && "MozAppearance" in C.documentElement.style,
        "MediaRecorderErrorEvent" in x,
        "mozInnerScreenX" in x,
        "CSSMozDocumentRule" in x,
        "CanvasCaptureMediaStream" in x
      ]) >= 4;
    }, s5.isTrident = A2, s5.isWebKit = j, s5.load = ue, s5.murmurX64Hash128 = ce, s5;
  }({}), function(s5) {
    var h2, r10, t3 = function(T3, L2) {
      var E2 = typeof Symbol == "function" && T3[Symbol.iterator];
      if (!E2)
        return T3;
      var H2, S, U2 = E2.call(T3), W2 = [];
      try {
        for (; (L2 === void 0 || L2-- > 0) && !(H2 = U2.next()).done; )
          W2.push(H2.value);
      } catch (J3) {
        S = { error: J3 };
      } finally {
        try {
          H2 && !H2.done && (E2 = U2.return) && E2.call(U2);
        } finally {
          if (S)
            throw S.error;
        }
      }
      return W2;
    }, e2 = function(T3, L2, E2) {
      if (E2 || arguments.length === 2)
        for (var H2, S = 0, U2 = L2.length; S < U2; S++)
          !H2 && S in L2 || (H2 || (H2 = Array.prototype.slice.call(L2, 0, S)), H2[S] = L2[S]);
      return T3.concat(H2 || Array.prototype.slice.call(L2));
    }, n2 = /* @__PURE__ */ new WeakMap(), i9 = /* @__PURE__ */ new WeakMap(), a5 = /* @__PURE__ */ new WeakMap(), u4 = /* @__PURE__ */ new WeakMap(), c5 = /* @__PURE__ */ new WeakMap(), l2 = {
      get: function(T3, L2, E2) {
        if (T3 instanceof IDBTransaction) {
          if (L2 === "done")
            return i9.get(T3);
          if (L2 === "objectStoreNames")
            return T3.objectStoreNames || a5.get(T3);
          if (L2 === "store")
            return E2.objectStoreNames[1] ? void 0 : E2.objectStore(E2.objectStoreNames[0]);
        }
        return m(T3[L2]);
      },
      set: function(T3, L2, E2) {
        return T3[L2] = E2, true;
      },
      has: function(T3, L2) {
        return T3 instanceof IDBTransaction && (L2 === "done" || L2 === "store") || L2 in T3;
      }
    };
    function d4(T3) {
      return T3 !== IDBDatabase.prototype.transaction || "objectStoreNames" in IDBTransaction.prototype ? (r10 || (r10 = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
      ])).includes(T3) ? function() {
        for (var L2 = [], E2 = 0; E2 < arguments.length; E2++)
          L2[E2] = arguments[E2];
        return T3.apply(k2(this), L2), m(n2.get(this));
      } : function() {
        for (var L2 = [], E2 = 0; E2 < arguments.length; E2++)
          L2[E2] = arguments[E2];
        return m(T3.apply(k2(this), L2));
      } : function(L2) {
        for (var E2 = [], H2 = 1; H2 < arguments.length; H2++)
          E2[H2 - 1] = arguments[H2];
        var S = T3.call.apply(T3, e2([k2(this), L2], t3(E2), false));
        return a5.set(S, L2.sort ? L2.sort() : [L2]), m(S);
      };
    }
    function p4(T3) {
      return typeof T3 == "function" ? d4(T3) : (T3 instanceof IDBTransaction && function(E2) {
        if (!i9.has(E2)) {
          var H2 = new Promise(function(S, U2) {
            var W2 = function() {
              E2.removeEventListener("complete", J3), E2.removeEventListener("error", Q), E2.removeEventListener("abort", Q);
            }, J3 = function() {
              S(), W2();
            }, Q = function() {
              U2(E2.error || new DOMException("AbortError", "AbortError")), W2();
            };
            E2.addEventListener("complete", J3), E2.addEventListener("error", Q), E2.addEventListener("abort", Q);
          });
          i9.set(E2, H2);
        }
      }(T3), L2 = T3, (h2 || (h2 = [IDBDatabase, IDBObjectStore, IDBIndex, IDBCursor, IDBTransaction])).some(
        function(E2) {
          return L2 instanceof E2;
        }
      ) ? new Proxy(T3, l2) : T3);
      var L2;
    }
    function m(T3) {
      if (T3 instanceof IDBRequest)
        return L2 = T3, (E2 = new Promise(function(S, U2) {
          var W2 = function() {
            L2.removeEventListener("success", J3), L2.removeEventListener("error", Q);
          }, J3 = function() {
            S(m(L2.result)), W2();
          }, Q = function() {
            U2(L2.error), W2();
          };
          L2.addEventListener("success", J3), L2.addEventListener("error", Q);
        })).then(function(S) {
          S instanceof IDBCursor && n2.set(S, L2);
        }).catch(function() {
        }), c5.set(E2, L2), E2;
      var L2, E2;
      if (u4.has(T3))
        return u4.get(T3);
      var H2 = p4(T3);
      return H2 !== T3 && (u4.set(T3, H2), c5.set(H2, T3)), H2;
    }
    var k2 = function(T3) {
      return c5.get(T3);
    }, x = function() {
      return (x = Object.assign || function(T3) {
        for (var L2, E2 = 1, H2 = arguments.length; E2 < H2; E2++)
          for (var S in L2 = arguments[E2])
            Object.prototype.hasOwnProperty.call(L2, S) && (T3[S] = L2[S]);
        return T3;
      }).apply(this, arguments);
    }, y3 = function(T3, L2, E2, H2) {
      return new (E2 || (E2 = Promise))(function(S, U2) {
        function W2(oe) {
          try {
            Q(H2.next(oe));
          } catch (q) {
            U2(q);
          }
        }
        function J3(oe) {
          try {
            Q(H2.throw(oe));
          } catch (q) {
            U2(q);
          }
        }
        function Q(oe) {
          var q;
          oe.done ? S(oe.value) : (q = oe.value, q instanceof E2 ? q : new E2(function(fe) {
            fe(q);
          })).then(W2, J3);
        }
        Q((H2 = H2.apply(T3, L2 || [])).next());
      });
    }, C = function(T3, L2) {
      var E2, H2, S, U2, W2 = {
        label: 0,
        sent: function() {
          if (1 & S[0])
            throw S[1];
          return S[1];
        },
        trys: [],
        ops: []
      };
      return U2 = { next: J3(0), throw: J3(1), return: J3(2) }, typeof Symbol == "function" && (U2[Symbol.iterator] = function() {
        return this;
      }), U2;
      function J3(Q) {
        return function(oe) {
          return function(q) {
            if (E2)
              throw new TypeError("Generator is already executing.");
            for (; W2; )
              try {
                if (E2 = 1, H2 && (S = 2 & q[0] ? H2.return : q[0] ? H2.throw || ((S = H2.return) && S.call(H2), 0) : H2.next) && !(S = S.call(H2, q[1])).done)
                  return S;
                switch (H2 = 0, S && (q = [2 & q[0], S.value]), q[0]) {
                  case 0:
                  case 1:
                    S = q;
                    break;
                  case 4:
                    return W2.label++, { value: q[1], done: false };
                  case 5:
                    W2.label++, H2 = q[1], q = [0];
                    continue;
                  case 7:
                    q = W2.ops.pop(), W2.trys.pop();
                    continue;
                  default:
                    if (!((S = (S = W2.trys).length > 0 && S[S.length - 1]) || q[0] !== 6 && q[0] !== 2)) {
                      W2 = 0;
                      continue;
                    }
                    if (q[0] === 3 && (!S || q[1] > S[0] && q[1] < S[3])) {
                      W2.label = q[1];
                      break;
                    }
                    if (q[0] === 6 && W2.label < S[1]) {
                      W2.label = S[1], S = q;
                      break;
                    }
                    if (S && W2.label < S[2]) {
                      W2.label = S[2], W2.ops.push(q);
                      break;
                    }
                    S[2] && W2.ops.pop(), W2.trys.pop();
                    continue;
                }
                q = L2.call(T3, W2);
              } catch (fe) {
                q = [6, fe], H2 = 0;
              } finally {
                E2 = S = 0;
              }
            if (5 & q[0])
              throw q[1];
            return { value: q[0] ? q[1] : void 0, done: true };
          }([Q, oe]);
        };
      }
    }, A2 = function(T3, L2) {
      var E2 = typeof Symbol == "function" && T3[Symbol.iterator];
      if (!E2)
        return T3;
      var H2, S, U2 = E2.call(T3), W2 = [];
      try {
        for (; (L2 === void 0 || L2-- > 0) && !(H2 = U2.next()).done; )
          W2.push(H2.value);
      } catch (J3) {
        S = { error: J3 };
      } finally {
        try {
          H2 && !H2.done && (E2 = U2.return) && E2.call(U2);
        } finally {
          if (S)
            throw S.error;
        }
      }
      return W2;
    }, P2 = function(T3, L2, E2) {
      if (E2 || arguments.length === 2)
        for (var H2, S = 0, U2 = L2.length; S < U2; S++)
          !H2 && S in L2 || (H2 || (H2 = Array.prototype.slice.call(L2, 0, S)), H2[S] = L2[S]);
      return T3.concat(H2 || Array.prototype.slice.call(L2));
    }, D2 = ["get", "getKey", "getAll", "getAllKeys", "count"], j = ["put", "add", "delete", "clear"], z2 = /* @__PURE__ */ new Map();
    function B(T3, L2) {
      if (T3 instanceof IDBDatabase && !(L2 in T3) && typeof L2 == "string") {
        if (z2.get(L2))
          return z2.get(L2);
        var E2 = L2.replace(/FromIndex$/, ""), H2 = L2 !== E2, S = j.includes(E2);
        if (E2 in (H2 ? IDBIndex : IDBObjectStore).prototype && (S || D2.includes(E2))) {
          var U2 = function(W2) {
            for (var J3 = [], Q = 1; Q < arguments.length; Q++)
              J3[Q - 1] = arguments[Q];
            return y3(this, void 0, void 0, function() {
              var oe, q, fe;
              return C(this, function(N2) {
                switch (N2.label) {
                  case 0:
                    return oe = this.transaction(W2, S ? "readwrite" : "readonly"), q = oe.store, H2 && (q = q.index(J3.shift())), [4, Promise.all([(fe = q)[E2].apply(fe, P2([], A2(J3), false)), S && oe.done])];
                  case 1:
                    return [2, N2.sent()[0]];
                }
              });
            });
          };
          return z2.set(L2, U2), U2;
        }
      }
    }
    l2 = function(T3) {
      return x(x({}, T3), {
        get: function(L2, E2, H2) {
          return B(L2, E2) || T3.get(L2, E2, H2);
        },
        has: function(L2, E2) {
          return !!B(L2, E2) || T3.has(L2, E2);
        }
      });
    }(l2), s5.deleteDB = function(T3, L2) {
      var E2 = (L2 === void 0 ? {} : L2).blocked, H2 = indexedDB.deleteDatabase(T3);
      return E2 && H2.addEventListener("blocked", function(S) {
        return E2(S.oldVersion, S);
      }), m(H2).then(function() {
      });
    }, s5.openDB = function(T3, L2, E2) {
      var H2 = E2 === void 0 ? {} : E2, S = H2.blocked, U2 = H2.upgrade, W2 = H2.blocking, J3 = H2.terminated, Q = indexedDB.open(T3, L2), oe = m(Q);
      return U2 && Q.addEventListener("upgradeneeded", function(q) {
        U2(m(Q.result), q.oldVersion, q.newVersion, m(Q.transaction), q);
      }), S && Q.addEventListener("blocked", function(q) {
        return S(q.oldVersion, q.newVersion, q);
      }), oe.then(function(q) {
        J3 && q.addEventListener("close", function() {
          return J3();
        }), W2 && q.addEventListener("versionchange", function(fe) {
          return W2(fe.oldVersion, fe.newVersion, fe);
        });
      }).catch(function() {
      }), oe;
    }, s5.unwrap = k2, s5.wrap = m;
  }(M2 || (M2 = {})), function(s5) {
    function h2(r10, t3) {
      var e2;
      t3 = t3 || {}, this._id = h2._generateUUID(), this._promise = t3.promise || Promise, this._frameId = t3.frameId || "CrossStorageClient-" + this._id, this._origin = h2._getOrigin(r10), this._requests = {}, this._connected = false, this._closed = false, this._count = 0, this._timeout = t3.timeout || 5e3, this._listener = null, this._installListener(), t3.frameId && (e2 = document.getElementById(t3.frameId)), e2 && this._poll(), e2 = e2 || this._createFrame(r10), this._hub = e2.contentWindow;
    }
    h2.frameStyle = {
      width: 0,
      height: 0,
      border: "none",
      display: "none",
      position: "absolute",
      top: "-999px",
      left: "-999px"
    }, h2._getOrigin = function(r10) {
      var t3;
      return (t3 = document.createElement("a")).href = r10, t3.host || (t3 = window.location), ((t3.protocol && t3.protocol !== ":" ? t3.protocol : window.location.protocol) + "//" + t3.host).replace(/:80$|:443$/, "");
    }, h2._generateUUID = function() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(r10) {
        var t3 = 16 * Math.random() | 0;
        return (r10 == "x" ? t3 : 3 & t3 | 8).toString(16);
      });
    }, h2.prototype.onConnect = function() {
      var r10 = this;
      return this._connected ? this._promise.resolve() : this._closed ? this._promise.reject(new Error("CrossStorageClient has closed")) : (this._requests.connect || (this._requests.connect = []), new this._promise(function(t3, e2) {
        var n2 = setTimeout(function() {
          e2(new Error("CrossStorageClient could not connect"));
        }, r10._timeout);
        r10._requests.connect.push(function(i9) {
          if (clearTimeout(n2), i9)
            return e2(i9);
          t3();
        });
      }));
    }, h2.prototype.set = function(r10, t3) {
      return this._request("set", { key: r10, value: t3 });
    }, h2.prototype.getSignedPayload = function(r10, t3) {
      return console.log("sending payload: ", r10, " deviceId: ", t3), this._request("getSignedData", { payload: r10, deviceId: t3 });
    }, h2.prototype.getDeviceDetails = function(r10) {
      return this._request("getDeviceDetails", { deviceName: r10 });
    }, h2.prototype.setDeviceDetails = function(r10, t3) {
      return this._request("setDeviceDetails", { deviceName: r10, deviceId: t3 });
    }, h2.prototype.get = function(r10) {
      var t3 = Array.prototype.slice.call(arguments);
      return this._request("get", { keys: t3 });
    }, h2.prototype.del = function() {
      var r10 = Array.prototype.slice.call(arguments);
      return this._request("del", { keys: r10 });
    }, h2.prototype.clear = function() {
      return this._request("clear");
    }, h2.prototype.getKeys = function() {
      return this._request("getKeys");
    }, h2.prototype.close = function(r10) {
      const t3 = this._frameId, e2 = this;
      this._request("close").catch(function(n2) {
      }).finally(function() {
        try {
          var n2 = document.getElementById(t3);
          n2 && !r10 && n2.parentNode.removeChild(n2), window.removeEventListener ? window.removeEventListener("message", e2._listener, false) : window.detachEvent("onmessage", e2._listener), e2._connected = false, e2._closed = true;
        } catch (e3) {
        }
      });
    }, h2.prototype._installListener = function() {
      var r10 = this;
      this._listener = function(t3) {
        var e2, n2, i9;
        if (!r10._closed && t3.data && typeof t3.data == "string" && (t3.origin === "null" ? "file://" : t3.origin) === r10._origin)
          if (t3.data !== "cross-storage:unavailable") {
            if (t3.data.indexOf("cross-storage:") !== -1 && !r10._connected) {
              if (r10._connected = true, !r10._requests.connect)
                return;
              for (e2 = 0; e2 < r10._requests.connect.length; e2++)
                r10._requests.connect[e2](n2);
              delete r10._requests.connect;
            }
            if (t3.data !== "cross-storage:ready") {
              try {
                i9 = JSON.parse(t3.data);
              } catch (e3) {
                return;
              }
              i9.id && r10._requests[i9.id] && r10._requests[i9.id](i9.error, i9.result);
            }
          } else {
            if (r10._closed || r10.close(), !r10._requests.connect)
              return;
            for (n2 = new Error("Closing client. Could not access localStorage in hub."), e2 = 0; e2 < r10._requests.connect.length; e2++)
              r10._requests.connect[e2](n2);
          }
      }, window.addEventListener ? window.addEventListener("message", this._listener, false) : window.attachEvent("onmessage", this._listener);
    }, h2.prototype._poll = function() {
      var r10, t3, e2;
      e2 = (r10 = this)._origin === "file://" ? "*" : r10._origin, t3 = setInterval(function() {
        if (r10._connected)
          return clearInterval(t3);
        r10._hub && r10._hub.postMessage("cross-storage:poll", e2);
      }, 1e3);
    }, h2.prototype._createFrame = function(r10) {
      var t3, e2;
      for (e2 in (t3 = window.document.createElement("iframe")).id = this._frameId, h2.frameStyle)
        h2.frameStyle.hasOwnProperty(e2) && (t3.style[e2] = h2.frameStyle[e2]);
      return window.document.body.appendChild(t3), t3.src = r10, t3;
    }, h2.prototype._request = function(r10, t3) {
      var e2, n2;
      return this._closed ? this._promise.reject(new Error("CrossStorageClient has closed")) : ((n2 = this)._count++, e2 = { id: this._id + ":" + n2._count, method: "cross-storage:" + r10, params: t3 }, new this._promise(function(i9, a5) {
        var u4, c5, l2;
        u4 = setTimeout(function() {
          n2._requests[e2.id] && (delete n2._requests[e2.id], a5(new Error("Timeout: could not perform " + e2.method)));
        }, n2._timeout), n2._requests[e2.id] = function(d4, p4) {
          if (clearTimeout(u4), delete n2._requests[e2.id], d4)
            return a5(new Error(d4));
          i9(p4);
        }, Array.prototype.toJSON && (c5 = Array.prototype.toJSON, Array.prototype.toJSON = null), l2 = n2._origin === "file://" ? "*" : n2._origin, n2._hub.postMessage(JSON.stringify(e2), l2), c5 && (Array.prototype.toJSON = c5);
      }));
    }, s5.CrossStorageClient = h2;
  }(M2 || (M2 = {})), function() {
    typeof Object.assign != "function" && Object.defineProperty(Object, "assign", {
      value: function(s5, h2) {
        if (s5 == null)
          throw new TypeError("Cannot convert undefined or null to object");
        for (var r10 = Object(s5), t3 = 1; t3 < arguments.length; t3++) {
          var e2 = arguments[t3];
          if (e2 != null)
            for (var n2 in e2)
              Object.prototype.hasOwnProperty.call(e2, n2) && (r10[n2] = e2[n2]);
        }
        return r10;
      },
      writable: true,
      configurable: true
    });
  }(), Array.from || (Array.from = function() {
    var s5 = Object.prototype.toString, h2 = function(e2) {
      return typeof e2 == "function" || s5.call(e2) === "[object Function]";
    }, r10 = Math.pow(2, 53) - 1, t3 = function(e2) {
      var n2 = function(i9) {
        var a5 = Number(i9);
        return isNaN(a5) ? 0 : a5 !== 0 && isFinite(a5) ? (a5 > 0 ? 1 : -1) * Math.floor(Math.abs(a5)) : a5;
      }(e2);
      return Math.min(Math.max(n2, 0), r10);
    };
    return function(e2) {
      var n2 = Object(e2);
      if (e2 == null)
        throw new TypeError("Array.from requires an array-like object - not null or undefined");
      var i9, a5 = arguments.length > 1 ? arguments[1] : void 0;
      if (a5 !== void 0) {
        if (!h2(a5))
          throw new TypeError(
            "Array.from: when provided, the second argument must be a function"
          );
        arguments.length > 2 && (i9 = arguments[2]);
      }
      for (var u4, c5 = t3(n2.length), l2 = h2(this) ? Object(new this(c5)) : new Array(c5), d4 = 0; d4 < c5; )
        u4 = n2[d4], l2[d4] = a5 ? i9 === void 0 ? a5(u4, d4) : a5.call(i9, u4, d4) : u4, d4 += 1;
      return l2.length = c5, l2;
    };
  }()), function() {
    String.prototype.endsWith || (String.prototype.endsWith = function(s5, h2) {
      return (h2 === void 0 || h2 > this.length) && (h2 = this.length), this.substring(h2 - s5.length, h2) === s5;
    });
  }(), function() {
    Promise.allSettled = Promise.allSettled || function(s5) {
      return Promise.all(
        s5.map(function(h2) {
          return h2.then(function(r10) {
            return { status: "fulfilled", value: r10 };
          }).catch(function(r10) {
            return { status: "rejected", reason: r10 };
          });
        })
      );
    };
  }(), function(s5, h2) {
    var r10 = "model", t3 = "name", e2 = "type", n2 = "vendor", i9 = "version", a5 = "mobile", u4 = "tablet", c5 = "smarttv", l2 = function(P2) {
      for (var D2 = {}, j = 0; j < P2.length; j++)
        D2[P2[j].toUpperCase()] = P2[j];
      return D2;
    }, d4 = function(P2, D2) {
      return typeof P2 == "string" && p4(D2).indexOf(p4(P2)) !== -1;
    }, p4 = function(P2) {
      return P2.toLowerCase();
    }, m = function(P2, D2) {
      if (typeof P2 == "string")
        return P2 = P2.replace(/^\s\s*/, "").replace(/\s\s*$/, ""), D2 === void 0 ? P2 : P2.substring(0, 255);
    }, k2 = function(P2, D2) {
      for (var j, z2, B, T3, L2, E2, H2 = 0; H2 < D2.length && !L2; ) {
        var S = D2[H2], U2 = D2[H2 + 1];
        for (j = z2 = 0; j < S.length && !L2; )
          if (L2 = S[j++].exec(P2))
            for (B = 0; B < U2.length; B++)
              E2 = L2[++z2], typeof (T3 = U2[B]) == "object" && T3.length > 0 ? T3.length === 2 ? typeof T3[1] == "function" ? this[T3[0]] = T3[1].call(this, E2) : this[T3[0]] = T3[1] : T3.length === 3 ? typeof T3[1] != "function" || T3[1].exec && T3[1].test ? this[T3[0]] = E2 ? E2.replace(T3[1], T3[2]) : void 0 : this[T3[0]] = E2 ? T3[1].call(this, E2, T3[2]) : void 0 : T3.length === 4 && (this[T3[0]] = E2 ? T3[3].call(this, E2.replace(T3[1], T3[2])) : void 0) : this[T3] = E2 || void 0;
        H2 += 2;
      }
    }, x = function(P2, D2) {
      for (var j in D2)
        if (typeof D2[j] == "object" && D2[j].length > 0) {
          for (var z2 = 0; z2 < D2[j].length; z2++)
            if (d4(D2[j][z2], P2))
              return j === "?" ? void 0 : j;
        } else if (d4(D2[j], P2))
          return j === "?" ? void 0 : j;
      return P2;
    }, y3 = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2e3: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      8.1: "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    }, C = {
      browser: [
        [/\b(?:crmo|crios)\/([\w\.]+)/i],
        [i9, [t3, "Chrome"]],
        [/edg(?:e|ios|a)?\/([\w\.]+)/i],
        [i9, [t3, "Edge"]],
        [
          /(opera mini)\/([-\w\.]+)/i,
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
        ],
        [t3, i9],
        [/opios[\/ ]+([\w\.]+)/i],
        [i9, [t3, "Opera Mini"]],
        [/\bopr\/([\w\.]+)/i],
        [i9, [t3, "Opera"]],
        [
          /(kindle)\/([\w\.]+)/i,
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
          /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
          /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
          /(?:ms|\()(ie) ([\w\.]+)/i,
          /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,
          /(weibo)__([\d\.]+)/i
        ],
        [t3, i9],
        [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],
        [i9, [t3, "UCBrowser"]],
        [/\bqbcore\/([\w\.]+)/i],
        [i9, [t3, "WeChat(Win) Desktop"]],
        [/micromessenger\/([\w\.]+)/i],
        [i9, [t3, "WeChat"]],
        [/konqueror\/([\w\.]+)/i],
        [i9, [t3, "Konqueror"]],
        [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],
        [i9, [t3, "IE"]],
        [/yabrowser\/([\w\.]+)/i],
        [i9, [t3, "Yandex"]],
        [/(avast|avg)\/([\w\.]+)/i],
        [[t3, /(.+)/, "$1 Secure Browser"], i9],
        [/\bfocus\/([\w\.]+)/i],
        [i9, [t3, "Firefox Focus"]],
        [/\bopt\/([\w\.]+)/i],
        [i9, [t3, "Opera Touch"]],
        [/coc_coc\w+\/([\w\.]+)/i],
        [i9, [t3, "Coc Coc"]],
        [/dolfin\/([\w\.]+)/i],
        [i9, [t3, "Dolphin"]],
        [/coast\/([\w\.]+)/i],
        [i9, [t3, "Opera Coast"]],
        [/miuibrowser\/([\w\.]+)/i],
        [i9, [t3, "MIUI Browser"]],
        [/fxios\/([-\w\.]+)/i],
        [i9, [t3, "Firefox"]],
        [/\bqihu|(qi?ho?o?|360)browser/i],
        [[t3, "360 Browser"]],
        [/(oculus|samsung|sailfish)browser\/([\w\.]+)/i],
        [[t3, /(.+)/, "$1 Browser"], i9],
        [/(comodo_dragon)\/([\w\.]+)/i],
        [[t3, /_/g, " "], i9],
        [
          /(electron)\/([\w\.]+) safari/i,
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
        ],
        [t3, i9],
        [/(metasr)[\/ ]?([\w\.]+)/i, /(lbbrowser)/i],
        [t3],
        [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],
        [[t3, "Facebook"], i9],
        [
          /safari (line)\/([\w\.]+)/i,
          /\b(line)\/([\w\.]+)\/iab/i,
          /(chromium|instagram)[\/ ]([-\w\.]+)/i
        ],
        [t3, i9],
        [/\bgsa\/([\w\.]+) .*safari\//i],
        [i9, [t3, "GSA"]],
        [/headlesschrome(?:\/([\w\.]+)| )/i],
        [i9, [t3, "Chrome Headless"]],
        [/ wv\).+(chrome)\/([\w\.]+)/i],
        [[t3, "Chrome WebView"], i9],
        [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],
        [i9, [t3, "Android Browser"]],
        [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],
        [t3, i9],
        [/version\/([\w\.]+) .*mobile\/\w+ (safari)/i],
        [i9, [t3, "Mobile Safari"]],
        [/version\/([\w\.]+) .*(mobile ?safari|safari)/i],
        [i9, t3],
        [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],
        [
          t3,
          [
            i9,
            x,
            {
              "1.0": "/8",
              1.2: "/1",
              1.3: "/3",
              "2.0": "/412",
              "2.0.2": "/416",
              "2.0.3": "/417",
              "2.0.4": "/419",
              "?": "/"
            }
          ]
        ],
        [/(webkit|khtml)\/([\w\.]+)/i],
        [t3, i9],
        [/(navigator|netscape\d?)\/([-\w\.]+)/i],
        [[t3, "Netscape"], i9],
        [/mobile vr; rv:([\w\.]+)\).+firefox/i],
        [i9, [t3, "Firefox Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          /(swiftfox)/i,
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          /(firefox)\/([\w\.]+)/i,
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          /(links) \(([\w\.]+)/i
        ],
        [t3, i9]
      ],
      cpu: [
        [/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i],
        [["architecture", "amd64"]],
        [/(ia32(?=;))/i],
        [["architecture", p4]],
        [/((?:i[346]|x)86)[;\)]/i],
        [["architecture", "ia32"]],
        [/\b(aarch64|arm(v?8e?l?|_?64))\b/i],
        [["architecture", "arm64"]],
        [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i],
        [["architecture", "armhf"]],
        [/windows (ce|mobile); ppc;/i],
        [["architecture", "arm"]],
        [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i],
        [["architecture", /ower/, "", p4]],
        [/(sun4\w)[;\)]/i],
        [["architecture", "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
        ],
        [["architecture", p4]]
      ],
      device: [
        [/\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],
        [r10, [n2, "Samsung"], [e2, u4]],
        [/\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i],
        [r10, [n2, "Samsung"], [e2, a5]],
        [/\((ip(?:hone|od)[\w ]*);/i],
        [r10, [n2, "Apple"], [e2, a5]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [r10, [n2, "Apple"], [e2, u4]],
        [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i],
        [r10, [n2, "Huawei"], [e2, u4]],
        [
          /(?:huawei|honor)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i
        ],
        [r10, [n2, "Huawei"], [e2, a5]],
        [
          /\b(poco[\w ]+)(?: bui|\))/i,
          /\b; (\w+) build\/hm\1/i,
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
        ],
        [
          [r10, /_/g, " "],
          [n2, "Xiaomi"],
          [e2, a5]
        ],
        [/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i],
        [
          [r10, /_/g, " "],
          [n2, "Xiaomi"],
          [e2, u4]
        ],
        [
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [r10, [n2, "OPPO"], [e2, a5]],
        [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i],
        [r10, [n2, "Vivo"], [e2, a5]],
        [/\b(rmx[12]\d{3})(?: bui|;|\))/i],
        [r10, [n2, "Realme"], [e2, a5]],
        [
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [r10, [n2, "Motorola"], [e2, a5]],
        [/\b(mz60\d|xoom[2 ]{0,2}) build\//i],
        [r10, [n2, "Motorola"], [e2, u4]],
        [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],
        [r10, [n2, "LG"], [e2, u4]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [r10, [n2, "LG"], [e2, a5]],
        [
          /(ideatab[-\w ]+)/i,
          /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [r10, [n2, "Lenovo"], [e2, u4]],
        [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i],
        [
          [r10, /_/g, " "],
          [n2, "Nokia"],
          [e2, a5]
        ],
        [/(pixel c)\b/i],
        [r10, [n2, "Google"], [e2, u4]],
        [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],
        [r10, [n2, "Google"], [e2, a5]],
        [
          /droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [r10, [n2, "Sony"], [e2, a5]],
        [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i],
        [
          [r10, "Xperia Tablet"],
          [n2, "Sony"],
          [e2, u4]
        ],
        [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],
        [r10, [n2, "OnePlus"], [e2, a5]],
        [/(alexa)webm/i, /(kf[a-z]{2}wi)( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i],
        [r10, [n2, "Amazon"], [e2, u4]],
        [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],
        [
          [r10, /(.+)/g, "Fire Phone $1"],
          [n2, "Amazon"],
          [e2, a5]
        ],
        [/(playbook);[-\w\),; ]+(rim)/i],
        [r10, n2, [e2, u4]],
        [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i],
        [r10, [n2, "BlackBerry"], [e2, a5]],
        [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],
        [r10, [n2, "ASUS"], [e2, u4]],
        [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],
        [r10, [n2, "ASUS"], [e2, a5]],
        [/(nexus 9)/i],
        [r10, [n2, "HTC"], [e2, u4]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i
        ],
        [n2, [r10, /_/g, " "], [e2, a5]],
        [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],
        [r10, [n2, "Acer"], [e2, u4]],
        [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i],
        [r10, [n2, "Meizu"], [e2, a5]],
        [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],
        [r10, [n2, "Sharp"], [e2, a5]],
        [
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
          /(hp) ([\w ]+\w)/i,
          /(asus)-?(\w+)/i,
          /(microsoft); (lumia[\w ]+)/i,
          /(lenovo)[-_ ]?([-\w]+)/i,
          /(jolla)/i,
          /(oppo) ?([\w ]+) bui/i
        ],
        [n2, r10, [e2, a5]],
        [
          /(archos) (gamepad2?)/i,
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          /(kindle)\/([\w\.]+)/i,
          /(nook)[\w ]+build\/(\w+)/i,
          /(dell) (strea[kpr\d ]*[\dko])/i,
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          /(trinity)[- ]*(t\d{3}) bui/i,
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          /(vodafone) ([\w ]+)(?:\)| bui)/i
        ],
        [n2, r10, [e2, u4]],
        [/(surface duo)/i],
        [r10, [n2, "Microsoft"], [e2, u4]],
        [/droid [\d\.]+; (fp\du?)(?: b|\))/i],
        [r10, [n2, "Fairphone"], [e2, a5]],
        [/(u304aa)/i],
        [r10, [n2, "AT&T"], [e2, a5]],
        [/\bsie-(\w*)/i],
        [r10, [n2, "Siemens"], [e2, a5]],
        [/\b(rct\w+) b/i],
        [r10, [n2, "RCA"], [e2, u4]],
        [/\b(venue[\d ]{2,7}) b/i],
        [r10, [n2, "Dell"], [e2, u4]],
        [/\b(q(?:mv|ta)\w+) b/i],
        [r10, [n2, "Verizon"], [e2, u4]],
        [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],
        [r10, [n2, "Barnes & Noble"], [e2, u4]],
        [/\b(tm\d{3}\w+) b/i],
        [r10, [n2, "NuVision"], [e2, u4]],
        [/\b(k88) b/i],
        [r10, [n2, "ZTE"], [e2, u4]],
        [/\b(nx\d{3}j) b/i],
        [r10, [n2, "ZTE"], [e2, a5]],
        [/\b(gen\d{3}) b.+49h/i],
        [r10, [n2, "Swiss"], [e2, a5]],
        [/\b(zur\d{3}) b/i],
        [r10, [n2, "Swiss"], [e2, u4]],
        [/\b((zeki)?tb.*\b) b/i],
        [r10, [n2, "Zeki"], [e2, u4]],
        [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i],
        [[n2, "Dragon Touch"], r10, [e2, u4]],
        [/\b(ns-?\w{0,9}) b/i],
        [r10, [n2, "Insignia"], [e2, u4]],
        [/\b((nxa|next)-?\w{0,9}) b/i],
        [r10, [n2, "NextBook"], [e2, u4]],
        [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],
        [[n2, "Voice"], r10, [e2, a5]],
        [/\b(lvtel\-)?(v1[12]) b/i],
        [[n2, "LvTel"], r10, [e2, a5]],
        [/\b(ph-1) /i],
        [r10, [n2, "Essential"], [e2, a5]],
        [/\b(v(100md|700na|7011|917g).*\b) b/i],
        [r10, [n2, "Envizen"], [e2, u4]],
        [/\b(trio[-\w\. ]+) b/i],
        [r10, [n2, "MachSpeed"], [e2, u4]],
        [/\btu_(1491) b/i],
        [r10, [n2, "Rotor"], [e2, u4]],
        [/(shield[\w ]+) b/i],
        [r10, [n2, "Nvidia"], [e2, u4]],
        [/(sprint) (\w+)/i],
        [n2, r10, [e2, a5]],
        [/(kin\.[onetw]{3})/i],
        [
          [r10, /\./g, " "],
          [n2, "Microsoft"],
          [e2, a5]
        ],
        [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],
        [r10, [n2, "Zebra"], [e2, u4]],
        [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],
        [r10, [n2, "Zebra"], [e2, a5]],
        [/(ouya)/i, /(nintendo) ([wids3utch]+)/i],
        [n2, r10, [e2, "console"]],
        [/droid.+; (shield) bui/i],
        [r10, [n2, "Nvidia"], [e2, "console"]],
        [/(playstation [345portablevi]+)/i],
        [r10, [n2, "Sony"], [e2, "console"]],
        [/\b(xbox(?: one)?(?!; xbox))[\); ]/i],
        [r10, [n2, "Microsoft"], [e2, "console"]],
        [/smart-tv.+(samsung)/i],
        [n2, [e2, c5]],
        [/hbbtv.+maple;(\d+)/i],
        [
          [r10, /^/, "SmartTV"],
          [n2, "Samsung"],
          [e2, c5]
        ],
        [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],
        [
          [n2, "LG"],
          [e2, c5]
        ],
        [/(apple) ?tv/i],
        [n2, [r10, "Apple TV"], [e2, c5]],
        [/crkey/i],
        [
          [r10, "Chromecast"],
          [n2, "Google"],
          [e2, c5]
        ],
        [/droid.+aft(\w)( bui|\))/i],
        [r10, [n2, "Amazon"], [e2, c5]],
        [/\(dtv[\);].+(aquos)/i],
        [r10, [n2, "Sharp"], [e2, c5]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i
        ],
        [
          [n2, m],
          [r10, m],
          [e2, c5]
        ],
        [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],
        [[e2, c5]],
        [/((pebble))app/i],
        [n2, r10, [e2, "wearable"]],
        [/droid.+; (glass) \d/i],
        [r10, [n2, "Google"], [e2, "wearable"]],
        [/droid.+; (wt63?0{2,3})\)/i],
        [r10, [n2, "Zebra"], [e2, "wearable"]],
        [/(quest( 2)?)/i],
        [r10, [n2, "Facebook"], [e2, "wearable"]],
        [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],
        [n2, [e2, "embedded"]],
        [/droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i],
        [r10, [e2, a5]],
        [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],
        [r10, [e2, u4]],
        [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],
        [[e2, u4]],
        [/(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i],
        [[e2, a5]],
        [/(android[-\w\. ]{0,9});.+buil/i],
        [r10, [n2, "Generic"]]
      ],
      engine: [
        [/windows.+ edge\/([\w\.]+)/i],
        [i9, [t3, "EdgeHTML"]],
        [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],
        [i9, [t3, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          /ekioh(flow)\/([\w\.]+)/i,
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          /(icab)[\/ ]([23]\.[\d\.]+)/i
        ],
        [t3, i9],
        [/rv\:([\w\.]{1,9})\b.+(gecko)/i],
        [i9, t3]
      ],
      os: [
        [/microsoft (windows) (vista|xp)/i],
        [t3, i9],
        [
          /(windows) nt 6\.2; (arm)/i,
          /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
          /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
        ],
        [t3, [i9, x, y3]],
        [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i],
        [
          [t3, "Windows"],
          [i9, x, y3]
        ],
        [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /cfnetwork\/.+darwin/i],
        [
          [i9, /_/g, "."],
          [t3, "iOS"]
        ],
        [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i],
        [
          [t3, "Mac OS"],
          [i9, /_/g, "."]
        ],
        [/droid ([\w\.]+)\b.+(android[- ]x86)/i],
        [i9, t3],
        [
          /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
          /(blackberry)\w*\/([\w\.]*)/i,
          /(tizen|kaios)[\/ ]([\w\.]+)/i,
          /\((series40);/i
        ],
        [t3, i9],
        [/\(bb(10);/i],
        [i9, [t3, "BlackBerry"]],
        [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i],
        [i9, [t3, "Symbian"]],
        [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],
        [i9, [t3, "Firefox OS"]],
        [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],
        [i9, [t3, "webOS"]],
        [/crkey\/([\d\.]+)/i],
        [i9, [t3, "Chromecast"]],
        [/(cros) [\w]+ ([\w\.]+\w)/i],
        [[t3, "Chromium OS"], i9],
        [
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          /(xbox); +xbox ([^\);]+)/i,
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          /(mint)[\/\(\) ]?(\w*)/i,
          /(mageia|vectorlinux)[; ]/i,
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          /(hurd|linux) ?([\w\.]*)/i,
          /(gnu) ?([\w\.]*)/i,
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          /(haiku) (\w+)/i
        ],
        [t3, i9],
        [/(sunos) ?([\w\.\d]*)/i],
        [[t3, "Solaris"], i9],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,
          /(unix) ?([\w\.]*)/i
        ],
        [t3, i9]
      ]
    }, A2 = function(P2, D2) {
      if (typeof P2 == "object" && (D2 = P2, P2 = void 0), !(this instanceof A2))
        return new A2(P2, D2).getResult();
      var j = P2 || (typeof window < "u" && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : ""), z2 = D2 ? function(B, T3) {
        var L2 = {};
        for (var E2 in B)
          T3[E2] && T3[E2].length % 2 == 0 ? L2[E2] = T3[E2].concat(B[E2]) : L2[E2] = B[E2];
        return L2;
      }(C, D2) : C;
      return this.getBrowser = function() {
        var B, T3 = {};
        return T3.name = void 0, T3.version = void 0, k2.call(T3, j, z2.browser), T3.major = typeof (B = T3.version) == "string" ? B.replace(/[^\d\.]/g, "").split(".")[0] : void 0, T3;
      }, this.getCPU = function() {
        var B = { architecture: void 0 };
        return k2.call(B, j, z2.cpu), B;
      }, this.getDevice = function() {
        var B = { vendor: void 0, model: void 0, type: void 0 };
        return k2.call(B, j, z2.device), B;
      }, this.getEngine = function() {
        var B = { name: void 0, version: void 0 };
        return k2.call(B, j, z2.engine), B;
      }, this.getOS = function() {
        var B = { name: void 0, version: void 0 };
        return k2.call(B, j, z2.os), B;
      }, this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      }, this.getUA = function() {
        return j;
      }, this.setUA = function(B) {
        return j = typeof B == "string" && B.length > 255 ? m(B, 255) : B, this;
      }, this.setUA(j), this;
    };
    A2.VERSION = "1.0.2", A2.BROWSER = l2([t3, i9, "major"]), A2.CPU = l2(["architecture"]), A2.DEVICE = l2([r10, n2, e2, "console", a5, c5, u4, "wearable", "embedded"]), A2.ENGINE = A2.OS = l2([t3, i9]), s5.UAParser = A2;
  }(M2 || (M2 = {})), (M2 || (M2 = {})).pako = function s5(h2, r10, t3) {
    function e2(a5, u4) {
      if (!r10[a5]) {
        if (!h2[a5]) {
          var c5 = typeof commonjsRequire == "function" && commonjsRequire;
          if (!u4 && c5)
            return c5(a5, true);
          if (n2)
            return n2(a5, true);
          var l2 = new Error("Cannot find module '" + a5 + "'");
          throw l2.code = "MODULE_NOT_FOUND", l2;
        }
        var d4 = r10[a5] = { exports: {} };
        h2[a5][0].call(
          d4.exports,
          function(p4) {
            var m = h2[a5][1][p4];
            return e2(m || p4);
          },
          d4,
          d4.exports,
          s5,
          h2,
          r10,
          t3
        );
      }
      return r10[a5].exports;
    }
    for (var n2 = typeof commonjsRequire == "function" && commonjsRequire, i9 = 0; i9 < t3.length; i9++)
      e2(t3[i9]);
    return e2;
  }(
    {
      1: [
        function(s5, h2, r10) {
          function t3(a5, u4) {
            return Object.prototype.hasOwnProperty.call(a5, u4);
          }
          var e2 = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
          r10.assign = function(a5) {
            for (var u4 = Array.prototype.slice.call(arguments, 1); u4.length; ) {
              var c5 = u4.shift();
              if (c5) {
                if (typeof c5 != "object")
                  throw new TypeError(c5 + "must be non-object");
                for (var l2 in c5)
                  t3(c5, l2) && (a5[l2] = c5[l2]);
              }
            }
            return a5;
          }, r10.shrinkBuf = function(a5, u4) {
            return a5.length === u4 ? a5 : a5.subarray ? a5.subarray(0, u4) : (a5.length = u4, a5);
          };
          var n2 = {
            arraySet: function(a5, u4, c5, l2, d4) {
              if (u4.subarray && a5.subarray)
                a5.set(u4.subarray(c5, c5 + l2), d4);
              else
                for (var p4 = 0; p4 < l2; p4++)
                  a5[d4 + p4] = u4[c5 + p4];
            },
            flattenChunks: function(a5) {
              var u4, c5, l2, d4, p4, m;
              for (l2 = 0, u4 = 0, c5 = a5.length; u4 < c5; u4++)
                l2 += a5[u4].length;
              for (m = new Uint8Array(l2), d4 = 0, u4 = 0, c5 = a5.length; u4 < c5; u4++)
                p4 = a5[u4], m.set(p4, d4), d4 += p4.length;
              return m;
            }
          }, i9 = {
            arraySet: function(a5, u4, c5, l2, d4) {
              for (var p4 = 0; p4 < l2; p4++)
                a5[d4 + p4] = u4[c5 + p4];
            },
            flattenChunks: function(a5) {
              return [].concat.apply([], a5);
            }
          };
          r10.setTyped = function(a5) {
            a5 ? (r10.Buf8 = Uint8Array, r10.Buf16 = Uint16Array, r10.Buf32 = Int32Array, r10.assign(r10, n2)) : (r10.Buf8 = Array, r10.Buf16 = Array, r10.Buf32 = Array, r10.assign(r10, i9));
          }, r10.setTyped(e2);
        },
        {}
      ],
      2: [
        function(s5, h2, r10) {
          function t3(c5, l2) {
            if (l2 < 65537 && (c5.subarray && i9 || !c5.subarray && n2))
              return String.fromCharCode.apply(null, e2.shrinkBuf(c5, l2));
            for (var d4 = "", p4 = 0; p4 < l2; p4++)
              d4 += String.fromCharCode(c5[p4]);
            return d4;
          }
          var e2 = s5("./common"), n2 = true, i9 = true;
          try {
            String.fromCharCode.apply(null, [0]);
          } catch (e3) {
            n2 = false;
          }
          try {
            String.fromCharCode.apply(null, new Uint8Array(1));
          } catch (e3) {
            i9 = false;
          }
          for (var a5 = new e2.Buf8(256), u4 = 0; u4 < 256; u4++)
            a5[u4] = u4 >= 252 ? 6 : u4 >= 248 ? 5 : u4 >= 240 ? 4 : u4 >= 224 ? 3 : u4 >= 192 ? 2 : 1;
          a5[254] = a5[254] = 1, r10.string2buf = function(c5) {
            var l2, d4, p4, m, k2, x = c5.length, y3 = 0;
            for (m = 0; m < x; m++)
              (64512 & (d4 = c5.charCodeAt(m))) == 55296 && m + 1 < x && (64512 & (p4 = c5.charCodeAt(m + 1))) == 56320 && (d4 = 65536 + (d4 - 55296 << 10) + (p4 - 56320), m++), y3 += d4 < 128 ? 1 : d4 < 2048 ? 2 : d4 < 65536 ? 3 : 4;
            for (l2 = new e2.Buf8(y3), k2 = 0, m = 0; k2 < y3; m++)
              (64512 & (d4 = c5.charCodeAt(m))) == 55296 && m + 1 < x && (64512 & (p4 = c5.charCodeAt(m + 1))) == 56320 && (d4 = 65536 + (d4 - 55296 << 10) + (p4 - 56320), m++), d4 < 128 ? l2[k2++] = d4 : d4 < 2048 ? (l2[k2++] = 192 | d4 >>> 6, l2[k2++] = 128 | 63 & d4) : d4 < 65536 ? (l2[k2++] = 224 | d4 >>> 12, l2[k2++] = 128 | d4 >>> 6 & 63, l2[k2++] = 128 | 63 & d4) : (l2[k2++] = 240 | d4 >>> 18, l2[k2++] = 128 | d4 >>> 12 & 63, l2[k2++] = 128 | d4 >>> 6 & 63, l2[k2++] = 128 | 63 & d4);
            return l2;
          }, r10.buf2binstring = function(c5) {
            return t3(c5, c5.length);
          }, r10.binstring2buf = function(c5) {
            for (var l2 = new e2.Buf8(c5.length), d4 = 0, p4 = l2.length; d4 < p4; d4++)
              l2[d4] = c5.charCodeAt(d4);
            return l2;
          }, r10.buf2string = function(c5, l2) {
            var d4, p4, m, k2, x = l2 || c5.length, y3 = new Array(2 * x);
            for (p4 = 0, d4 = 0; d4 < x; )
              if ((m = c5[d4++]) < 128)
                y3[p4++] = m;
              else if ((k2 = a5[m]) > 4)
                y3[p4++] = 65533, d4 += k2 - 1;
              else {
                for (m &= k2 === 2 ? 31 : k2 === 3 ? 15 : 7; k2 > 1 && d4 < x; )
                  m = m << 6 | 63 & c5[d4++], k2--;
                k2 > 1 ? y3[p4++] = 65533 : m < 65536 ? y3[p4++] = m : (m -= 65536, y3[p4++] = 55296 | m >> 10 & 1023, y3[p4++] = 56320 | 1023 & m);
              }
            return t3(y3, p4);
          }, r10.utf8border = function(c5, l2) {
            var d4;
            for ((l2 = l2 || c5.length) > c5.length && (l2 = c5.length), d4 = l2 - 1; d4 >= 0 && (192 & c5[d4]) == 128; )
              d4--;
            return d4 < 0 || d4 === 0 ? l2 : d4 + a5[c5[d4]] > l2 ? d4 : l2;
          };
        },
        { "./common": 1 }
      ],
      3: [
        function(s5, h2, r10) {
          h2.exports = function(t3, e2, n2, i9) {
            for (var a5 = 65535 & t3 | 0, u4 = t3 >>> 16 & 65535 | 0, c5 = 0; n2 !== 0; ) {
              n2 -= c5 = n2 > 2e3 ? 2e3 : n2;
              do
                u4 = u4 + (a5 = a5 + e2[i9++] | 0) | 0;
              while (--c5);
              a5 %= 65521, u4 %= 65521;
            }
            return a5 | u4 << 16 | 0;
          };
        },
        {}
      ],
      4: [
        function(s5, h2, r10) {
          var t3 = function() {
            for (var e2, n2 = [], i9 = 0; i9 < 256; i9++) {
              e2 = i9;
              for (var a5 = 0; a5 < 8; a5++)
                e2 = 1 & e2 ? 3988292384 ^ e2 >>> 1 : e2 >>> 1;
              n2[i9] = e2;
            }
            return n2;
          }();
          h2.exports = function(e2, n2, i9, a5) {
            var u4 = t3, c5 = a5 + i9;
            e2 ^= -1;
            for (var l2 = a5; l2 < c5; l2++)
              e2 = e2 >>> 8 ^ u4[255 & (e2 ^ n2[l2])];
            return -1 ^ e2;
          };
        },
        {}
      ],
      5: [
        function(s5, h2, r10) {
          function t3(o2, g) {
            return o2.msg = H2[g], g;
          }
          function e2(o2) {
            return (o2 << 1) - (o2 > 4 ? 9 : 0);
          }
          function n2(o2) {
            for (var g = o2.length; --g >= 0; )
              o2[g] = 0;
          }
          function i9(o2) {
            var g = o2.state, v = g.pending;
            v > o2.avail_out && (v = o2.avail_out), v !== 0 && (B.arraySet(o2.output, g.pending_buf, g.pending_out, v, o2.next_out), o2.next_out += v, g.pending_out += v, o2.total_out += v, o2.avail_out -= v, g.pending -= v, g.pending === 0 && (g.pending_out = 0));
          }
          function a5(o2, g) {
            T3._tr_flush_block(
              o2,
              o2.block_start >= 0 ? o2.block_start : -1,
              o2.strstart - o2.block_start,
              g
            ), o2.block_start = o2.strstart, i9(o2.strm);
          }
          function u4(o2, g) {
            o2.pending_buf[o2.pending++] = g;
          }
          function c5(o2, g) {
            o2.pending_buf[o2.pending++] = g >>> 8 & 255, o2.pending_buf[o2.pending++] = 255 & g;
          }
          function l2(o2, g, v, f3) {
            var b3 = o2.avail_in;
            return b3 > f3 && (b3 = f3), b3 === 0 ? 0 : (o2.avail_in -= b3, B.arraySet(g, o2.input, o2.next_in, b3, v), o2.state.wrap === 1 ? o2.adler = L2(o2.adler, g, b3, v) : o2.state.wrap === 2 && (o2.adler = E2(o2.adler, g, b3, v)), o2.next_in += b3, o2.total_in += b3, b3);
          }
          function d4(o2, g) {
            var v, f3, b3 = o2.max_chain_length, I = o2.strstart, F2 = o2.prev_length, R = o2.nice_match, ne = o2.strstart > o2.w_size - re ? o2.strstart - (o2.w_size - re) : 0, X = o2.window, ie = o2.w_mask, de = o2.prev, pe = o2.strstart + ue, ge = X[I + F2 - 1], ye = X[I + F2];
            o2.prev_length >= o2.good_match && (b3 >>= 2), R > o2.lookahead && (R = o2.lookahead);
            do
              if (X[(v = g) + F2] === ye && X[v + F2 - 1] === ge && X[v] === X[I] && X[++v] === X[I + 1]) {
                I += 2, v++;
                do
                  ;
                while (X[++I] === X[++v] && X[++I] === X[++v] && X[++I] === X[++v] && X[++I] === X[++v] && X[++I] === X[++v] && X[++I] === X[++v] && X[++I] === X[++v] && X[++I] === X[++v] && I < pe);
                if (f3 = ue - (pe - I), I = pe - ue, f3 > F2) {
                  if (o2.match_start = g, F2 = f3, f3 >= R)
                    break;
                  ge = X[I + F2 - 1], ye = X[I + F2];
                }
              }
            while ((g = de[g & ie]) > ne && --b3 != 0);
            return F2 <= o2.lookahead ? F2 : o2.lookahead;
          }
          function p4(o2) {
            var g, v, f3, b3, I, F2 = o2.w_size;
            do {
              if (b3 = o2.window_size - o2.lookahead - o2.strstart, o2.strstart >= F2 + (F2 - re)) {
                B.arraySet(o2.window, o2.window, F2, F2, 0), o2.match_start -= F2, o2.strstart -= F2, o2.block_start -= F2, g = v = o2.hash_size;
                do
                  f3 = o2.head[--g], o2.head[g] = f3 >= F2 ? f3 - F2 : 0;
                while (--v);
                g = v = F2;
                do
                  f3 = o2.prev[--g], o2.prev[g] = f3 >= F2 ? f3 - F2 : 0;
                while (--v);
                b3 += F2;
              }
              if (o2.strm.avail_in === 0)
                break;
              if (v = l2(o2.strm, o2.window, o2.strstart + o2.lookahead, b3), o2.lookahead += v, o2.lookahead + o2.insert >= ee)
                for (I = o2.strstart - o2.insert, o2.ins_h = o2.window[I], o2.ins_h = (o2.ins_h << o2.hash_shift ^ o2.window[I + 1]) & o2.hash_mask; o2.insert && (o2.ins_h = (o2.ins_h << o2.hash_shift ^ o2.window[I + ee - 1]) & o2.hash_mask, o2.prev[I & o2.w_mask] = o2.head[o2.ins_h], o2.head[o2.ins_h] = I, I++, o2.insert--, !(o2.lookahead + o2.insert < ee)); )
                  ;
            } while (o2.lookahead < re && o2.strm.avail_in !== 0);
          }
          function m(o2, g) {
            for (var v, f3; ; ) {
              if (o2.lookahead < re) {
                if (p4(o2), o2.lookahead < re && g === S)
                  return O3;
                if (o2.lookahead === 0)
                  break;
              }
              if (v = 0, o2.lookahead >= ee && (o2.ins_h = (o2.ins_h << o2.hash_shift ^ o2.window[o2.strstart + ee - 1]) & o2.hash_mask, v = o2.prev[o2.strstart & o2.w_mask] = o2.head[o2.ins_h], o2.head[o2.ins_h] = o2.strstart), v !== 0 && o2.strstart - v <= o2.w_size - re && (o2.match_length = d4(o2, v)), o2.match_length >= ee)
                if (f3 = T3._tr_tally(o2, o2.strstart - o2.match_start, o2.match_length - ee), o2.lookahead -= o2.match_length, o2.match_length <= o2.max_lazy_match && o2.lookahead >= ee) {
                  o2.match_length--;
                  do
                    o2.strstart++, o2.ins_h = (o2.ins_h << o2.hash_shift ^ o2.window[o2.strstart + ee - 1]) & o2.hash_mask, v = o2.prev[o2.strstart & o2.w_mask] = o2.head[o2.ins_h], o2.head[o2.ins_h] = o2.strstart;
                  while (--o2.match_length != 0);
                  o2.strstart++;
                } else
                  o2.strstart += o2.match_length, o2.match_length = 0, o2.ins_h = o2.window[o2.strstart], o2.ins_h = (o2.ins_h << o2.hash_shift ^ o2.window[o2.strstart + 1]) & o2.hash_mask;
              else
                f3 = T3._tr_tally(o2, 0, o2.window[o2.strstart]), o2.lookahead--, o2.strstart++;
              if (f3 && (a5(o2, false), o2.strm.avail_out === 0))
                return O3;
            }
            return o2.insert = o2.strstart < ee - 1 ? o2.strstart : ee - 1, g === U2 ? (a5(o2, true), o2.strm.avail_out === 0 ? K : V2) : o2.last_lit && (a5(o2, false), o2.strm.avail_out === 0) ? O3 : w2;
          }
          function k2(o2, g) {
            for (var v, f3, b3; ; ) {
              if (o2.lookahead < re) {
                if (p4(o2), o2.lookahead < re && g === S)
                  return O3;
                if (o2.lookahead === 0)
                  break;
              }
              if (v = 0, o2.lookahead >= ee && (o2.ins_h = (o2.ins_h << o2.hash_shift ^ o2.window[o2.strstart + ee - 1]) & o2.hash_mask, v = o2.prev[o2.strstart & o2.w_mask] = o2.head[o2.ins_h], o2.head[o2.ins_h] = o2.strstart), o2.prev_length = o2.match_length, o2.prev_match = o2.match_start, o2.match_length = ee - 1, v !== 0 && o2.prev_length < o2.max_lazy_match && o2.strstart - v <= o2.w_size - re && (o2.match_length = d4(o2, v), o2.match_length <= 5 && (o2.strategy === oe || o2.match_length === ee && o2.strstart - o2.match_start > 4096) && (o2.match_length = ee - 1)), o2.prev_length >= ee && o2.match_length <= o2.prev_length) {
                b3 = o2.strstart + o2.lookahead - ee, f3 = T3._tr_tally(o2, o2.strstart - 1 - o2.prev_match, o2.prev_length - ee), o2.lookahead -= o2.prev_length - 1, o2.prev_length -= 2;
                do
                  ++o2.strstart <= b3 && (o2.ins_h = (o2.ins_h << o2.hash_shift ^ o2.window[o2.strstart + ee - 1]) & o2.hash_mask, v = o2.prev[o2.strstart & o2.w_mask] = o2.head[o2.ins_h], o2.head[o2.ins_h] = o2.strstart);
                while (--o2.prev_length != 0);
                if (o2.match_available = 0, o2.match_length = ee - 1, o2.strstart++, f3 && (a5(o2, false), o2.strm.avail_out === 0))
                  return O3;
              } else if (o2.match_available) {
                if ((f3 = T3._tr_tally(o2, 0, o2.window[o2.strstart - 1])) && a5(o2, false), o2.strstart++, o2.lookahead--, o2.strm.avail_out === 0)
                  return O3;
              } else
                o2.match_available = 1, o2.strstart++, o2.lookahead--;
            }
            return o2.match_available && (f3 = T3._tr_tally(o2, 0, o2.window[o2.strstart - 1]), o2.match_available = 0), o2.insert = o2.strstart < ee - 1 ? o2.strstart : ee - 1, g === U2 ? (a5(o2, true), o2.strm.avail_out === 0 ? K : V2) : o2.last_lit && (a5(o2, false), o2.strm.avail_out === 0) ? O3 : w2;
          }
          function x(o2, g) {
            for (var v, f3, b3, I, F2 = o2.window; ; ) {
              if (o2.lookahead <= ue) {
                if (p4(o2), o2.lookahead <= ue && g === S)
                  return O3;
                if (o2.lookahead === 0)
                  break;
              }
              if (o2.match_length = 0, o2.lookahead >= ee && o2.strstart > 0 && (b3 = o2.strstart - 1, (f3 = F2[b3]) === F2[++b3] && f3 === F2[++b3] && f3 === F2[++b3])) {
                I = o2.strstart + ue;
                do
                  ;
                while (f3 === F2[++b3] && f3 === F2[++b3] && f3 === F2[++b3] && f3 === F2[++b3] && f3 === F2[++b3] && f3 === F2[++b3] && f3 === F2[++b3] && f3 === F2[++b3] && b3 < I);
                o2.match_length = ue - (I - b3), o2.match_length > o2.lookahead && (o2.match_length = o2.lookahead);
              }
              if (o2.match_length >= ee ? (v = T3._tr_tally(o2, 1, o2.match_length - ee), o2.lookahead -= o2.match_length, o2.strstart += o2.match_length, o2.match_length = 0) : (v = T3._tr_tally(o2, 0, o2.window[o2.strstart]), o2.lookahead--, o2.strstart++), v && (a5(o2, false), o2.strm.avail_out === 0))
                return O3;
            }
            return o2.insert = 0, g === U2 ? (a5(o2, true), o2.strm.avail_out === 0 ? K : V2) : o2.last_lit && (a5(o2, false), o2.strm.avail_out === 0) ? O3 : w2;
          }
          function y3(o2, g) {
            for (var v; ; ) {
              if (o2.lookahead === 0 && (p4(o2), o2.lookahead === 0)) {
                if (g === S)
                  return O3;
                break;
              }
              if (o2.match_length = 0, v = T3._tr_tally(o2, 0, o2.window[o2.strstart]), o2.lookahead--, o2.strstart++, v && (a5(o2, false), o2.strm.avail_out === 0))
                return O3;
            }
            return o2.insert = 0, g === U2 ? (a5(o2, true), o2.strm.avail_out === 0 ? K : V2) : o2.last_lit && (a5(o2, false), o2.strm.avail_out === 0) ? O3 : w2;
          }
          function C(o2, g, v, f3, b3) {
            this.good_length = o2, this.max_lazy = g, this.nice_length = v, this.max_chain = f3, this.func = b3;
          }
          function A2() {
            this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = N2, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new B.Buf16(2 * se), this.dyn_dtree = new B.Buf16(2 * (2 * te + 1)), this.bl_tree = new B.Buf16(2 * (2 * ae + 1)), n2(this.dyn_ltree), n2(this.dyn_dtree), n2(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new B.Buf16(le + 1), this.heap = new B.Buf16(2 * Y + 1), n2(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new B.Buf16(2 * Y + 1), n2(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
          }
          function P2(o2) {
            var g;
            return o2 && o2.state ? (o2.total_in = o2.total_out = 0, o2.data_type = fe, (g = o2.state).pending = 0, g.pending_out = 0, g.wrap < 0 && (g.wrap = -g.wrap), g.status = g.wrap ? ce : _2, o2.adler = g.wrap === 2 ? 0 : 1, g.last_flush = S, T3._tr_init(g), W2) : t3(o2, J3);
          }
          function D2(o2) {
            var g = P2(o2);
            return g === W2 && function(v) {
              v.window_size = 2 * v.w_size, n2(v.head), v.max_lazy_match = z2[v.level].max_lazy, v.good_match = z2[v.level].good_length, v.nice_match = z2[v.level].nice_length, v.max_chain_length = z2[v.level].max_chain, v.strstart = 0, v.block_start = 0, v.lookahead = 0, v.insert = 0, v.match_length = v.prev_length = ee - 1, v.match_available = 0, v.ins_h = 0;
            }(o2.state), g;
          }
          function j(o2, g, v, f3, b3, I) {
            if (!o2)
              return J3;
            var F2 = 1;
            if (g === Q && (g = 6), f3 < 0 ? (F2 = 0, f3 = -f3) : f3 > 15 && (F2 = 2, f3 -= 16), b3 < 1 || b3 > G || v !== N2 || f3 < 8 || f3 > 15 || g < 0 || g > 9 || I < 0 || I > q)
              return t3(o2, J3);
            f3 === 8 && (f3 = 9);
            var R = new A2();
            return o2.state = R, R.strm = o2, R.wrap = F2, R.gzhead = null, R.w_bits = f3, R.w_size = 1 << R.w_bits, R.w_mask = R.w_size - 1, R.hash_bits = b3 + 7, R.hash_size = 1 << R.hash_bits, R.hash_mask = R.hash_size - 1, R.hash_shift = ~~((R.hash_bits + ee - 1) / ee), R.window = new B.Buf8(2 * R.w_size), R.head = new B.Buf16(R.hash_size), R.prev = new B.Buf16(R.w_size), R.lit_bufsize = 1 << b3 + 6, R.pending_buf_size = 4 * R.lit_bufsize, R.pending_buf = new B.Buf8(R.pending_buf_size), R.d_buf = 1 * R.lit_bufsize, R.l_buf = 3 * R.lit_bufsize, R.level = g, R.strategy = I, R.method = v, D2(o2);
          }
          var z2, B = s5("../utils/common"), T3 = s5("./trees"), L2 = s5("./adler32"), E2 = s5("./crc32"), H2 = s5("./messages"), S = 0, U2 = 4, W2 = 0, J3 = -2, Q = -1, oe = 1, q = 4, fe = 2, N2 = 8, G = 9, Y = 286, te = 30, ae = 19, se = 2 * Y + 1, le = 15, ee = 3, ue = 258, re = ue + ee + 1, ce = 42, _2 = 113, O3 = 1, w2 = 2, K = 3, V2 = 4;
          z2 = [
            new C(0, 0, 0, 0, function(o2, g) {
              var v = 65535;
              for (v > o2.pending_buf_size - 5 && (v = o2.pending_buf_size - 5); ; ) {
                if (o2.lookahead <= 1) {
                  if (p4(o2), o2.lookahead === 0 && g === S)
                    return O3;
                  if (o2.lookahead === 0)
                    break;
                }
                o2.strstart += o2.lookahead, o2.lookahead = 0;
                var f3 = o2.block_start + v;
                if ((o2.strstart === 0 || o2.strstart >= f3) && (o2.lookahead = o2.strstart - f3, o2.strstart = f3, a5(o2, false), o2.strm.avail_out === 0) || o2.strstart - o2.block_start >= o2.w_size - re && (a5(o2, false), o2.strm.avail_out === 0))
                  return O3;
              }
              return o2.insert = 0, g === U2 ? (a5(o2, true), o2.strm.avail_out === 0 ? K : V2) : (o2.strstart > o2.block_start && (a5(o2, false), o2.strm.avail_out), O3);
            }),
            new C(4, 4, 8, 4, m),
            new C(4, 5, 16, 8, m),
            new C(4, 6, 32, 32, m),
            new C(4, 4, 16, 16, k2),
            new C(8, 16, 32, 32, k2),
            new C(8, 16, 128, 128, k2),
            new C(8, 32, 128, 256, k2),
            new C(32, 128, 258, 1024, k2),
            new C(32, 258, 258, 4096, k2)
          ], r10.deflateInit = function(o2, g) {
            return j(o2, g, N2, 15, 8, 0);
          }, r10.deflateInit2 = j, r10.deflateReset = D2, r10.deflateResetKeep = P2, r10.deflateSetHeader = function(o2, g) {
            return o2 && o2.state ? o2.state.wrap !== 2 ? J3 : (o2.state.gzhead = g, W2) : J3;
          }, r10.deflate = function(o2, g) {
            var v, f3, b3, I;
            if (!o2 || !o2.state || g > 5 || g < 0)
              return o2 ? t3(o2, J3) : J3;
            if (f3 = o2.state, !o2.output || !o2.input && o2.avail_in !== 0 || f3.status === 666 && g !== U2)
              return t3(o2, o2.avail_out === 0 ? -5 : J3);
            if (f3.strm = o2, v = f3.last_flush, f3.last_flush = g, f3.status === ce)
              if (f3.wrap === 2)
                o2.adler = 0, u4(f3, 31), u4(f3, 139), u4(f3, 8), f3.gzhead ? (u4(
                  f3,
                  (f3.gzhead.text ? 1 : 0) + (f3.gzhead.hcrc ? 2 : 0) + (f3.gzhead.extra ? 4 : 0) + (f3.gzhead.name ? 8 : 0) + (f3.gzhead.comment ? 16 : 0)
                ), u4(f3, 255 & f3.gzhead.time), u4(f3, f3.gzhead.time >> 8 & 255), u4(f3, f3.gzhead.time >> 16 & 255), u4(f3, f3.gzhead.time >> 24 & 255), u4(f3, f3.level === 9 ? 2 : f3.strategy >= 2 || f3.level < 2 ? 4 : 0), u4(f3, 255 & f3.gzhead.os), f3.gzhead.extra && f3.gzhead.extra.length && (u4(f3, 255 & f3.gzhead.extra.length), u4(f3, f3.gzhead.extra.length >> 8 & 255)), f3.gzhead.hcrc && (o2.adler = E2(o2.adler, f3.pending_buf, f3.pending, 0)), f3.gzindex = 0, f3.status = 69) : (u4(f3, 0), u4(f3, 0), u4(f3, 0), u4(f3, 0), u4(f3, 0), u4(f3, f3.level === 9 ? 2 : f3.strategy >= 2 || f3.level < 2 ? 4 : 0), u4(f3, 3), f3.status = _2);
              else {
                var F2 = N2 + (f3.w_bits - 8 << 4) << 8;
                F2 |= (f3.strategy >= 2 || f3.level < 2 ? 0 : f3.level < 6 ? 1 : f3.level === 6 ? 2 : 3) << 6, f3.strstart !== 0 && (F2 |= 32), F2 += 31 - F2 % 31, f3.status = _2, c5(f3, F2), f3.strstart !== 0 && (c5(f3, o2.adler >>> 16), c5(f3, 65535 & o2.adler)), o2.adler = 1;
              }
            if (f3.status === 69)
              if (f3.gzhead.extra) {
                for (b3 = f3.pending; f3.gzindex < (65535 & f3.gzhead.extra.length) && (f3.pending !== f3.pending_buf_size || (f3.gzhead.hcrc && f3.pending > b3 && (o2.adler = E2(o2.adler, f3.pending_buf, f3.pending - b3, b3)), i9(o2), b3 = f3.pending, f3.pending !== f3.pending_buf_size)); )
                  u4(f3, 255 & f3.gzhead.extra[f3.gzindex]), f3.gzindex++;
                f3.gzhead.hcrc && f3.pending > b3 && (o2.adler = E2(o2.adler, f3.pending_buf, f3.pending - b3, b3)), f3.gzindex === f3.gzhead.extra.length && (f3.gzindex = 0, f3.status = 73);
              } else
                f3.status = 73;
            if (f3.status === 73)
              if (f3.gzhead.name) {
                b3 = f3.pending;
                do {
                  if (f3.pending === f3.pending_buf_size && (f3.gzhead.hcrc && f3.pending > b3 && (o2.adler = E2(o2.adler, f3.pending_buf, f3.pending - b3, b3)), i9(o2), b3 = f3.pending, f3.pending === f3.pending_buf_size)) {
                    I = 1;
                    break;
                  }
                  I = f3.gzindex < f3.gzhead.name.length ? 255 & f3.gzhead.name.charCodeAt(f3.gzindex++) : 0, u4(f3, I);
                } while (I !== 0);
                f3.gzhead.hcrc && f3.pending > b3 && (o2.adler = E2(o2.adler, f3.pending_buf, f3.pending - b3, b3)), I === 0 && (f3.gzindex = 0, f3.status = 91);
              } else
                f3.status = 91;
            if (f3.status === 91)
              if (f3.gzhead.comment) {
                b3 = f3.pending;
                do {
                  if (f3.pending === f3.pending_buf_size && (f3.gzhead.hcrc && f3.pending > b3 && (o2.adler = E2(o2.adler, f3.pending_buf, f3.pending - b3, b3)), i9(o2), b3 = f3.pending, f3.pending === f3.pending_buf_size)) {
                    I = 1;
                    break;
                  }
                  I = f3.gzindex < f3.gzhead.comment.length ? 255 & f3.gzhead.comment.charCodeAt(f3.gzindex++) : 0, u4(f3, I);
                } while (I !== 0);
                f3.gzhead.hcrc && f3.pending > b3 && (o2.adler = E2(o2.adler, f3.pending_buf, f3.pending - b3, b3)), I === 0 && (f3.status = 103);
              } else
                f3.status = 103;
            if (f3.status === 103 && (f3.gzhead.hcrc ? (f3.pending + 2 > f3.pending_buf_size && i9(o2), f3.pending + 2 <= f3.pending_buf_size && (u4(f3, 255 & o2.adler), u4(f3, o2.adler >> 8 & 255), o2.adler = 0, f3.status = _2)) : f3.status = _2), f3.pending !== 0) {
              if (i9(o2), o2.avail_out === 0)
                return f3.last_flush = -1, W2;
            } else if (o2.avail_in === 0 && e2(g) <= e2(v) && g !== U2)
              return t3(o2, -5);
            if (f3.status === 666 && o2.avail_in !== 0)
              return t3(o2, -5);
            if (o2.avail_in !== 0 || f3.lookahead !== 0 || g !== S && f3.status !== 666) {
              var R = f3.strategy === 2 ? y3(f3, g) : f3.strategy === 3 ? x(f3, g) : z2[f3.level].func(f3, g);
              if (R !== K && R !== V2 || (f3.status = 666), R === O3 || R === K)
                return o2.avail_out === 0 && (f3.last_flush = -1), W2;
              if (R === w2 && (g === 1 ? T3._tr_align(f3) : g !== 5 && (T3._tr_stored_block(f3, 0, 0, false), g === 3 && (n2(f3.head), f3.lookahead === 0 && (f3.strstart = 0, f3.block_start = 0, f3.insert = 0))), i9(o2), o2.avail_out === 0))
                return f3.last_flush = -1, W2;
            }
            return g !== U2 ? W2 : f3.wrap <= 0 ? 1 : (f3.wrap === 2 ? (u4(f3, 255 & o2.adler), u4(f3, o2.adler >> 8 & 255), u4(f3, o2.adler >> 16 & 255), u4(f3, o2.adler >> 24 & 255), u4(f3, 255 & o2.total_in), u4(f3, o2.total_in >> 8 & 255), u4(f3, o2.total_in >> 16 & 255), u4(f3, o2.total_in >> 24 & 255)) : (c5(f3, o2.adler >>> 16), c5(f3, 65535 & o2.adler)), i9(o2), f3.wrap > 0 && (f3.wrap = -f3.wrap), f3.pending !== 0 ? W2 : 1);
          }, r10.deflateEnd = function(o2) {
            var g;
            return o2 && o2.state ? (g = o2.state.status) !== ce && g !== 69 && g !== 73 && g !== 91 && g !== 103 && g !== _2 && g !== 666 ? t3(o2, J3) : (o2.state = null, g === _2 ? t3(o2, -3) : W2) : J3;
          }, r10.deflateSetDictionary = function(o2, g) {
            var v, f3, b3, I, F2, R, ne, X, ie = g.length;
            if (!o2 || !o2.state || (v = o2.state, (I = v.wrap) === 2 || I === 1 && v.status !== ce || v.lookahead))
              return J3;
            for (I === 1 && (o2.adler = L2(o2.adler, g, ie, 0)), v.wrap = 0, ie >= v.w_size && (I === 0 && (n2(v.head), v.strstart = 0, v.block_start = 0, v.insert = 0), X = new B.Buf8(v.w_size), B.arraySet(X, g, ie - v.w_size, v.w_size, 0), g = X, ie = v.w_size), F2 = o2.avail_in, R = o2.next_in, ne = o2.input, o2.avail_in = ie, o2.next_in = 0, o2.input = g, p4(v); v.lookahead >= ee; ) {
              f3 = v.strstart, b3 = v.lookahead - (ee - 1);
              do
                v.ins_h = (v.ins_h << v.hash_shift ^ v.window[f3 + ee - 1]) & v.hash_mask, v.prev[f3 & v.w_mask] = v.head[v.ins_h], v.head[v.ins_h] = f3, f3++;
              while (--b3);
              v.strstart = f3, v.lookahead = ee - 1, p4(v);
            }
            return v.strstart += v.lookahead, v.block_start = v.strstart, v.insert = v.lookahead, v.lookahead = 0, v.match_length = v.prev_length = ee - 1, v.match_available = 0, o2.next_in = R, o2.input = ne, o2.avail_in = F2, v.wrap = I, W2;
          }, r10.deflateInfo = "pako deflate (from Nodeca project)";
        },
        { "../utils/common": 1, "./adler32": 3, "./crc32": 4, "./messages": 6, "./trees": 7 }
      ],
      6: [
        function(s5, h2, r10) {
          h2.exports = {
            2: "need dictionary",
            1: "stream end",
            0: "",
            "-1": "file error",
            "-2": "stream error",
            "-3": "data error",
            "-4": "insufficient memory",
            "-5": "buffer error",
            "-6": "incompatible version"
          };
        },
        {}
      ],
      7: [
        function(s5, h2, r10) {
          function t3(o2) {
            for (var g = o2.length; --g >= 0; )
              o2[g] = 0;
          }
          function e2(o2, g, v, f3, b3) {
            this.static_tree = o2, this.extra_bits = g, this.extra_base = v, this.elems = f3, this.max_length = b3, this.has_stree = o2 && o2.length;
          }
          function n2(o2, g) {
            this.dyn_tree = o2, this.max_code = 0, this.stat_desc = g;
          }
          function i9(o2) {
            return o2 < 256 ? ue[o2] : ue[256 + (o2 >>> 7)];
          }
          function a5(o2, g) {
            o2.pending_buf[o2.pending++] = 255 & g, o2.pending_buf[o2.pending++] = g >>> 8 & 255;
          }
          function u4(o2, g, v) {
            o2.bi_valid > Q - v ? (o2.bi_buf |= g << o2.bi_valid & 65535, a5(o2, o2.bi_buf), o2.bi_buf = g >> Q - o2.bi_valid, o2.bi_valid += v - Q) : (o2.bi_buf |= g << o2.bi_valid & 65535, o2.bi_valid += v);
          }
          function c5(o2, g, v) {
            u4(o2, v[2 * g], v[2 * g + 1]);
          }
          function l2(o2, g) {
            var v = 0;
            do
              v |= 1 & o2, o2 >>>= 1, v <<= 1;
            while (--g > 0);
            return v >>> 1;
          }
          function d4(o2, g, v) {
            var f3, b3, I = new Array(J3 + 1), F2 = 0;
            for (f3 = 1; f3 <= J3; f3++)
              I[f3] = F2 = F2 + v[f3 - 1] << 1;
            for (b3 = 0; b3 <= g; b3++) {
              var R = o2[2 * b3 + 1];
              R !== 0 && (o2[2 * b3] = l2(I[R]++, R));
            }
          }
          function p4(o2) {
            var g;
            for (g = 0; g < H2; g++)
              o2.dyn_ltree[2 * g] = 0;
            for (g = 0; g < S; g++)
              o2.dyn_dtree[2 * g] = 0;
            for (g = 0; g < U2; g++)
              o2.bl_tree[2 * g] = 0;
            o2.dyn_ltree[2 * q] = 1, o2.opt_len = o2.static_len = 0, o2.last_lit = o2.matches = 0;
          }
          function m(o2) {
            o2.bi_valid > 8 ? a5(o2, o2.bi_buf) : o2.bi_valid > 0 && (o2.pending_buf[o2.pending++] = o2.bi_buf), o2.bi_buf = 0, o2.bi_valid = 0;
          }
          function k2(o2, g, v, f3) {
            var b3 = 2 * g, I = 2 * v;
            return o2[b3] < o2[I] || o2[b3] === o2[I] && f3[g] <= f3[v];
          }
          function x(o2, g, v) {
            for (var f3 = o2.heap[v], b3 = v << 1; b3 <= o2.heap_len && (b3 < o2.heap_len && k2(g, o2.heap[b3 + 1], o2.heap[b3], o2.depth) && b3++, !k2(g, f3, o2.heap[b3], o2.depth)); )
              o2.heap[v] = o2.heap[b3], v = b3, b3 <<= 1;
            o2.heap[v] = f3;
          }
          function y3(o2, g, v) {
            var f3, b3, I, F2, R = 0;
            if (o2.last_lit !== 0)
              do
                f3 = o2.pending_buf[o2.d_buf + 2 * R] << 8 | o2.pending_buf[o2.d_buf + 2 * R + 1], b3 = o2.pending_buf[o2.l_buf + R], R++, f3 === 0 ? c5(o2, b3, g) : (c5(o2, (I = re[b3]) + E2 + 1, g), (F2 = Y[I]) !== 0 && u4(o2, b3 -= ce[I], F2), c5(o2, I = i9(--f3), v), (F2 = te[I]) !== 0 && u4(o2, f3 -= _2[I], F2));
              while (R < o2.last_lit);
            c5(o2, q, g);
          }
          function C(o2, g) {
            var v, f3, b3, I = g.dyn_tree, F2 = g.stat_desc.static_tree, R = g.stat_desc.has_stree, ne = g.stat_desc.elems, X = -1;
            for (o2.heap_len = 0, o2.heap_max = W2, v = 0; v < ne; v++)
              I[2 * v] !== 0 ? (o2.heap[++o2.heap_len] = X = v, o2.depth[v] = 0) : I[2 * v + 1] = 0;
            for (; o2.heap_len < 2; )
              I[2 * (b3 = o2.heap[++o2.heap_len] = X < 2 ? ++X : 0)] = 1, o2.depth[b3] = 0, o2.opt_len--, R && (o2.static_len -= F2[2 * b3 + 1]);
            for (g.max_code = X, v = o2.heap_len >> 1; v >= 1; v--)
              x(o2, I, v);
            b3 = ne;
            do
              v = o2.heap[1], o2.heap[1] = o2.heap[o2.heap_len--], x(o2, I, 1), f3 = o2.heap[1], o2.heap[--o2.heap_max] = v, o2.heap[--o2.heap_max] = f3, I[2 * b3] = I[2 * v] + I[2 * f3], o2.depth[b3] = (o2.depth[v] >= o2.depth[f3] ? o2.depth[v] : o2.depth[f3]) + 1, I[2 * v + 1] = I[2 * f3 + 1] = b3, o2.heap[1] = b3++, x(o2, I, 1);
            while (o2.heap_len >= 2);
            o2.heap[--o2.heap_max] = o2.heap[1], function(ie, de) {
              var pe, ge, ye, he, be, we, me = de.dyn_tree, Ae = de.max_code, Ie = de.stat_desc.static_tree, Oe = de.stat_desc.has_stree, Pe = de.stat_desc.extra_bits, Te = de.stat_desc.extra_base, Ee = de.stat_desc.max_length, Se = 0;
              for (he = 0; he <= J3; he++)
                ie.bl_count[he] = 0;
              for (me[2 * ie.heap[ie.heap_max] + 1] = 0, pe = ie.heap_max + 1; pe < W2; pe++)
                (he = me[2 * me[2 * (ge = ie.heap[pe]) + 1] + 1] + 1) > Ee && (he = Ee, Se++), me[2 * ge + 1] = he, ge > Ae || (ie.bl_count[he]++, be = 0, ge >= Te && (be = Pe[ge - Te]), we = me[2 * ge], ie.opt_len += we * (he + be), Oe && (ie.static_len += we * (Ie[2 * ge + 1] + be)));
              if (Se !== 0) {
                do {
                  for (he = Ee - 1; ie.bl_count[he] === 0; )
                    he--;
                  ie.bl_count[he]--, ie.bl_count[he + 1] += 2, ie.bl_count[Ee]--, Se -= 2;
                } while (Se > 0);
                for (he = Ee; he !== 0; he--)
                  for (ge = ie.bl_count[he]; ge !== 0; )
                    (ye = ie.heap[--pe]) > Ae || (me[2 * ye + 1] !== he && (ie.opt_len += (he - me[2 * ye + 1]) * me[2 * ye], me[2 * ye + 1] = he), ge--);
              }
            }(o2, g), d4(I, X, o2.bl_count);
          }
          function A2(o2, g, v) {
            var f3, b3, I = -1, F2 = g[1], R = 0, ne = 7, X = 4;
            for (F2 === 0 && (ne = 138, X = 3), g[2 * (v + 1) + 1] = 65535, f3 = 0; f3 <= v; f3++)
              b3 = F2, F2 = g[2 * (f3 + 1) + 1], ++R < ne && b3 === F2 || (R < X ? o2.bl_tree[2 * b3] += R : b3 !== 0 ? (b3 !== I && o2.bl_tree[2 * b3]++, o2.bl_tree[2 * fe]++) : R <= 10 ? o2.bl_tree[2 * N2]++ : o2.bl_tree[2 * G]++, R = 0, I = b3, F2 === 0 ? (ne = 138, X = 3) : b3 === F2 ? (ne = 6, X = 3) : (ne = 7, X = 4));
          }
          function P2(o2, g, v) {
            var f3, b3, I = -1, F2 = g[1], R = 0, ne = 7, X = 4;
            for (F2 === 0 && (ne = 138, X = 3), f3 = 0; f3 <= v; f3++)
              if (b3 = F2, F2 = g[2 * (f3 + 1) + 1], !(++R < ne && b3 === F2)) {
                if (R < X)
                  do
                    c5(o2, b3, o2.bl_tree);
                  while (--R != 0);
                else
                  b3 !== 0 ? (b3 !== I && (c5(o2, b3, o2.bl_tree), R--), c5(o2, fe, o2.bl_tree), u4(o2, R - 3, 2)) : R <= 10 ? (c5(o2, N2, o2.bl_tree), u4(o2, R - 3, 3)) : (c5(o2, G, o2.bl_tree), u4(o2, R - 11, 7));
                R = 0, I = b3, F2 === 0 ? (ne = 138, X = 3) : b3 === F2 ? (ne = 6, X = 3) : (ne = 7, X = 4);
              }
          }
          function D2(o2, g, v, f3) {
            u4(o2, (T3 << 1) + (f3 ? 1 : 0), 3), function(b3, I, F2, R) {
              m(b3), R && (a5(b3, F2), a5(b3, ~F2)), j.arraySet(b3.pending_buf, b3.window, I, F2, b3.pending), b3.pending += F2;
            }(o2, g, v, true);
          }
          var j = s5("../utils/common"), z2 = 0, B = 1, T3 = 0, L2 = 29, E2 = 256, H2 = E2 + 1 + L2, S = 30, U2 = 19, W2 = 2 * H2 + 1, J3 = 15, Q = 16, oe = 7, q = 256, fe = 16, N2 = 17, G = 18, Y = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0
          ], te = [
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13
          ], ae = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7], se = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], le = new Array(2 * (H2 + 2));
          t3(le);
          var ee = new Array(2 * S);
          t3(ee);
          var ue = new Array(512);
          t3(ue);
          var re = new Array(256);
          t3(re);
          var ce = new Array(L2);
          t3(ce);
          var _2 = new Array(S);
          t3(_2);
          var O3, w2, K, V2 = false;
          r10._tr_init = function(o2) {
            V2 || (function() {
              var g, v, f3, b3, I, F2 = new Array(J3 + 1);
              for (f3 = 0, b3 = 0; b3 < L2 - 1; b3++)
                for (ce[b3] = f3, g = 0; g < 1 << Y[b3]; g++)
                  re[f3++] = b3;
              for (re[f3 - 1] = b3, I = 0, b3 = 0; b3 < 16; b3++)
                for (_2[b3] = I, g = 0; g < 1 << te[b3]; g++)
                  ue[I++] = b3;
              for (I >>= 7; b3 < S; b3++)
                for (_2[b3] = I << 7, g = 0; g < 1 << te[b3] - 7; g++)
                  ue[256 + I++] = b3;
              for (v = 0; v <= J3; v++)
                F2[v] = 0;
              for (g = 0; g <= 143; )
                le[2 * g + 1] = 8, g++, F2[8]++;
              for (; g <= 255; )
                le[2 * g + 1] = 9, g++, F2[9]++;
              for (; g <= 279; )
                le[2 * g + 1] = 7, g++, F2[7]++;
              for (; g <= 287; )
                le[2 * g + 1] = 8, g++, F2[8]++;
              for (d4(le, H2 + 1, F2), g = 0; g < S; g++)
                ee[2 * g + 1] = 5, ee[2 * g] = l2(g, 5);
              O3 = new e2(le, Y, E2 + 1, H2, J3), w2 = new e2(ee, te, 0, S, J3), K = new e2(new Array(0), ae, 0, U2, oe);
            }(), V2 = true), o2.l_desc = new n2(o2.dyn_ltree, O3), o2.d_desc = new n2(o2.dyn_dtree, w2), o2.bl_desc = new n2(o2.bl_tree, K), o2.bi_buf = 0, o2.bi_valid = 0, p4(o2);
          }, r10._tr_stored_block = D2, r10._tr_flush_block = function(o2, g, v, f3) {
            var b3, I, F2 = 0;
            o2.level > 0 ? (o2.strm.data_type === 2 && (o2.strm.data_type = function(R) {
              var ne, X = 4093624447;
              for (ne = 0; ne <= 31; ne++, X >>>= 1)
                if (1 & X && R.dyn_ltree[2 * ne] !== 0)
                  return z2;
              if (R.dyn_ltree[18] !== 0 || R.dyn_ltree[20] !== 0 || R.dyn_ltree[26] !== 0)
                return B;
              for (ne = 32; ne < E2; ne++)
                if (R.dyn_ltree[2 * ne] !== 0)
                  return B;
              return z2;
            }(o2)), C(o2, o2.l_desc), C(o2, o2.d_desc), F2 = function(R) {
              var ne;
              for (A2(R, R.dyn_ltree, R.l_desc.max_code), A2(R, R.dyn_dtree, R.d_desc.max_code), C(R, R.bl_desc), ne = U2 - 1; ne >= 3 && R.bl_tree[2 * se[ne] + 1] === 0; ne--)
                ;
              return R.opt_len += 3 * (ne + 1) + 5 + 5 + 4, ne;
            }(o2), b3 = o2.opt_len + 3 + 7 >>> 3, (I = o2.static_len + 3 + 7 >>> 3) <= b3 && (b3 = I)) : b3 = I = v + 5, v + 4 <= b3 && g !== -1 ? D2(o2, g, v, f3) : o2.strategy === 4 || I === b3 ? (u4(o2, 2 + (f3 ? 1 : 0), 3), y3(o2, le, ee)) : (u4(o2, 4 + (f3 ? 1 : 0), 3), function(R, ne, X, ie) {
              var de;
              for (u4(R, ne - 257, 5), u4(R, X - 1, 5), u4(R, ie - 4, 4), de = 0; de < ie; de++)
                u4(R, R.bl_tree[2 * se[de] + 1], 3);
              P2(R, R.dyn_ltree, ne - 1), P2(R, R.dyn_dtree, X - 1);
            }(o2, o2.l_desc.max_code + 1, o2.d_desc.max_code + 1, F2 + 1), y3(o2, o2.dyn_ltree, o2.dyn_dtree)), p4(o2), f3 && m(o2);
          }, r10._tr_tally = function(o2, g, v) {
            return o2.pending_buf[o2.d_buf + 2 * o2.last_lit] = g >>> 8 & 255, o2.pending_buf[o2.d_buf + 2 * o2.last_lit + 1] = 255 & g, o2.pending_buf[o2.l_buf + o2.last_lit] = 255 & v, o2.last_lit++, g === 0 ? o2.dyn_ltree[2 * v]++ : (o2.matches++, g--, o2.dyn_ltree[2 * (re[v] + E2 + 1)]++, o2.dyn_dtree[2 * i9(g)]++), o2.last_lit === o2.lit_bufsize - 1;
          }, r10._tr_align = function(o2) {
            u4(o2, 2, 3), c5(o2, q, le), function(g) {
              g.bi_valid === 16 ? (a5(g, g.bi_buf), g.bi_buf = 0, g.bi_valid = 0) : g.bi_valid >= 8 && (g.pending_buf[g.pending++] = 255 & g.bi_buf, g.bi_buf >>= 8, g.bi_valid -= 8);
            }(o2);
          };
        },
        { "../utils/common": 1 }
      ],
      8: [
        function(s5, h2, r10) {
          h2.exports = function() {
            this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
          };
        },
        {}
      ],
      "/lib/deflate.js": [
        function(s5, h2, r10) {
          function t3(x) {
            if (!(this instanceof t3))
              return new t3(x);
            this.options = i9.assign(
              {
                level: p4,
                method: k2,
                chunkSize: 16384,
                windowBits: 15,
                memLevel: 8,
                strategy: m,
                to: ""
              },
              x || {}
            );
            var y3 = this.options;
            y3.raw && y3.windowBits > 0 ? y3.windowBits = -y3.windowBits : y3.gzip && y3.windowBits > 0 && y3.windowBits < 16 && (y3.windowBits += 16), this.err = 0, this.msg = "", this.ended = false, this.chunks = [], this.strm = new c5(), this.strm.avail_out = 0;
            var C = n2.deflateInit2(
              this.strm,
              y3.level,
              y3.method,
              y3.windowBits,
              y3.memLevel,
              y3.strategy
            );
            if (C !== d4)
              throw new Error(u4[C]);
            if (y3.header && n2.deflateSetHeader(this.strm, y3.header), y3.dictionary) {
              var A2;
              if (A2 = typeof y3.dictionary == "string" ? a5.string2buf(y3.dictionary) : l2.call(y3.dictionary) === "[object ArrayBuffer]" ? new Uint8Array(y3.dictionary) : y3.dictionary, (C = n2.deflateSetDictionary(this.strm, A2)) !== d4)
                throw new Error(u4[C]);
              this._dict_set = true;
            }
          }
          function e2(x, y3) {
            var C = new t3(y3);
            if (C.push(x, true), C.err)
              throw C.msg || u4[C.err];
            return C.result;
          }
          var n2 = s5("./zlib/deflate"), i9 = s5("./utils/common"), a5 = s5("./utils/strings"), u4 = s5("./zlib/messages"), c5 = s5("./zlib/zstream"), l2 = Object.prototype.toString, d4 = 0, p4 = -1, m = 0, k2 = 8;
          t3.prototype.push = function(x, y3) {
            var C, A2, P2 = this.strm, D2 = this.options.chunkSize;
            if (this.ended)
              return false;
            A2 = y3 === ~~y3 ? y3 : y3 === true ? 4 : 0, typeof x == "string" ? P2.input = a5.string2buf(x) : l2.call(x) === "[object ArrayBuffer]" ? P2.input = new Uint8Array(x) : P2.input = x, P2.next_in = 0, P2.avail_in = P2.input.length;
            do {
              if (P2.avail_out === 0 && (P2.output = new i9.Buf8(D2), P2.next_out = 0, P2.avail_out = D2), (C = n2.deflate(P2, A2)) !== 1 && C !== d4)
                return this.onEnd(C), this.ended = true, false;
              P2.avail_out !== 0 && (P2.avail_in !== 0 || A2 !== 4 && A2 !== 2) || (this.options.to === "string" ? this.onData(a5.buf2binstring(i9.shrinkBuf(P2.output, P2.next_out))) : this.onData(i9.shrinkBuf(P2.output, P2.next_out)));
            } while ((P2.avail_in > 0 || P2.avail_out === 0) && C !== 1);
            return A2 === 4 ? (C = n2.deflateEnd(this.strm), this.onEnd(C), this.ended = true, C === d4) : A2 !== 2 || (this.onEnd(d4), P2.avail_out = 0, true);
          }, t3.prototype.onData = function(x) {
            this.chunks.push(x);
          }, t3.prototype.onEnd = function(x) {
            x === d4 && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = i9.flattenChunks(this.chunks)), this.chunks = [], this.err = x, this.msg = this.strm.msg;
          }, r10.Deflate = t3, r10.deflate = e2, r10.deflateRaw = function(x, y3) {
            return (y3 = y3 || {}).raw = true, e2(x, y3);
          }, r10.gzip = function(x, y3) {
            return (y3 = y3 || {}).gzip = true, e2(x, y3);
          };
        },
        {
          "./utils/common": 1,
          "./utils/strings": 2,
          "./zlib/deflate": 5,
          "./zlib/messages": 6,
          "./zlib/zstream": 8
        }
      ]
    },
    {},
    []
  )("/lib/deflate.js"), (M2 || (M2 = {})).evaluateModernizr = function() {
    (function(s5, h2, r10, t3) {
      function e2(N2, G) {
        return typeof N2 === G;
      }
      function n2() {
        return typeof r10.createElement != "function" ? r10.createElement(arguments[0]) : j ? r10.createElementNS.call(r10, "http://www.w3.org/2000/svg", arguments[0]) : r10.createElement.apply(r10, arguments);
      }
      function i9(N2, G) {
        return !!~("" + N2).indexOf(G);
      }
      function a5(N2, G, Y, te) {
        var ae, se, le, ee, ue = "modernizr", re = n2("div"), ce = function() {
          var _2 = r10.body;
          return _2 || ((_2 = n2(j ? "svg" : "body")).fake = true), _2;
        }();
        if (parseInt(Y, 10))
          for (; Y--; )
            (le = n2("div")).id = te ? te[Y] : ue + (Y + 1), re.appendChild(le);
        return (ae = n2("style")).type = "text/css", ae.id = "s" + ue, (ce.fake ? ce : re).appendChild(ae), ce.appendChild(re), ae.styleSheet ? ae.styleSheet.cssText = N2 : ae.appendChild(r10.createTextNode(N2)), re.id = ue, ce.fake && (ce.style.background = "", ce.style.overflow = "hidden", ee = D2.style.overflow, D2.style.overflow = "hidden", D2.appendChild(ce)), se = G(re, N2), ce.fake ? (ce.parentNode.removeChild(ce), D2.style.overflow = ee, D2.offsetHeight) : re.parentNode.removeChild(re), !!se;
      }
      function u4(N2) {
        return N2.replace(/([A-Z])/g, function(G, Y) {
          return "-" + Y.toLowerCase();
        }).replace(/^ms-/, "-ms-");
      }
      function c5(N2, G, Y) {
        var te;
        if ("getComputedStyle" in h2) {
          te = getComputedStyle.call(h2, N2, G);
          var ae = h2.console;
          te !== null ? Y && (te = te.getPropertyValue(Y)) : ae && ae[ae.error ? "error" : "log"].call(
            ae,
            "getComputedStyle returning null, its possible modernizr test results are inaccurate"
          );
        } else
          te = !G && N2.currentStyle && N2.currentStyle[Y];
        return te;
      }
      function l2(N2, G) {
        var Y = N2.length;
        if ("CSS" in h2 && "supports" in h2.CSS) {
          for (; Y--; )
            if (h2.CSS.supports(u4(N2[Y]), G))
              return true;
          return false;
        }
        if ("CSSSupportsRule" in h2) {
          for (var te = []; Y--; )
            te.push("(" + u4(N2[Y]) + ":" + G + ")");
          return a5(
            "@supports (" + (te = te.join(" or ")) + ") { #modernizr { position: absolute; } }",
            function(ae) {
              return c5(ae, null, "position") === "absolute";
            }
          );
        }
        return t3;
      }
      function d4(N2) {
        return N2.replace(/([a-z])-([a-z])/g, function(G, Y, te) {
          return Y + te.toUpperCase();
        }).replace(/^-/, "");
      }
      function p4(N2, G, Y, te) {
        function ae() {
          le && (delete E2.style, delete E2.modElem);
        }
        if (te = !e2(te, "undefined") && te, !e2(Y, "undefined")) {
          var se = l2(N2, Y);
          if (!e2(se, "undefined"))
            return se;
        }
        for (var le, ee, ue, re, ce, _2 = ["modernizr", "tspan", "samp"]; !E2.style && _2.length; )
          le = true, E2.modElem = n2(_2.shift()), E2.style = E2.modElem.style;
        for (ue = N2.length, ee = 0; ee < ue; ee++)
          if (re = N2[ee], ce = E2.style[re], i9(re, "-") && (re = d4(re)), E2.style[re] !== t3) {
            if (te || e2(Y, "undefined"))
              return ae(), G !== "pfx" || re;
            try {
              E2.style[re] = Y;
            } catch (e3) {
            }
            if (E2.style[re] !== ce)
              return ae(), G !== "pfx" || re;
          }
        return ae(), false;
      }
      function m(N2, G) {
        return function() {
          return N2.apply(G, arguments);
        };
      }
      function k2(N2, G, Y, te, ae) {
        var se = N2.charAt(0).toUpperCase() + N2.slice(1), le = (N2 + " " + T3.join(se + " ") + se).split(" ");
        return e2(G, "string") || e2(G, "undefined") ? p4(le, G, te, ae) : function(ee, ue, re) {
          var ce;
          for (var _2 in ee)
            if (ee[_2] in ue)
              return re === false ? ee[_2] : e2(ce = ue[ee[_2]], "function") ? m(ce, re || ue) : ce;
          return false;
        }(le = (N2 + " " + H2.join(se + " ") + se).split(" "), G, Y);
      }
      function x(N2, G, Y) {
        return k2(N2, t3, t3, G, Y);
      }
      var y3 = [], C = {
        _version: "3.11.1",
        _config: { classPrefix: "", enableClasses: true, enableJSClass: true, usePrefixes: true },
        _q: [],
        on: function(N2, G) {
          var Y = this;
          setTimeout(function() {
            G(Y[N2]);
          }, 0);
        },
        addTest: function(N2, G, Y) {
          y3.push({ name: N2, fn: G, options: Y });
        },
        addAsyncTest: function(N2) {
          y3.push({ name: null, fn: N2 });
        }
      }, A2 = function() {
      };
      A2.prototype = C, A2 = new A2();
      var P2 = [], D2 = r10.documentElement, j = D2.nodeName.toLowerCase() === "svg", z2 = function() {
        var N2 = !("onblur" in D2);
        return function(G, Y) {
          var te;
          return !!G && (Y && typeof Y != "string" || (Y = n2(Y || "div")), !(te = (G = "on" + G) in Y) && N2 && (Y.setAttribute || (Y = n2("div")), Y.setAttribute(G, ""), te = typeof Y[G] == "function", Y[G] !== t3 && (Y[G] = t3), Y.removeAttribute(G)), te);
        };
      }();
      C.hasEvent = z2, A2.addTest("ambientlight", z2("devicelight", h2)), A2.addTest("applicationcache", "applicationCache" in h2), function() {
        var N2 = n2("audio");
        A2.addTest("audio", function() {
          var G = false;
          try {
            (G = !!N2.canPlayType) && (G = new Boolean(G));
          } catch (e3) {
          }
          return G;
        });
        try {
          N2.canPlayType && (A2.addTest(
            "audio.ogg",
            N2.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, "")
          ), A2.addTest(
            "audio.mp3",
            N2.canPlayType('audio/mpeg; codecs="mp3"').replace(/^no$/, "")
          ), A2.addTest(
            "audio.opus",
            N2.canPlayType('audio/ogg; codecs="opus"') || N2.canPlayType('audio/webm; codecs="opus"').replace(/^no$/, "")
          ), A2.addTest("audio.wav", N2.canPlayType('audio/wav; codecs="1"').replace(/^no$/, "")), A2.addTest(
            "audio.m4a",
            (N2.canPlayType("audio/x-m4a;") || N2.canPlayType("audio/aac;")).replace(
              /^no$/,
              ""
            )
          ));
        } catch (e3) {
        }
      }();
      var B = "Moz O ms Webkit", T3 = C._config.usePrefixes ? B.split(" ") : [];
      C._cssomPrefixes = T3;
      var L2 = { elem: n2("modernizr") };
      A2._q.push(function() {
        delete L2.elem;
      });
      var E2 = { style: L2.elem.style };
      A2._q.unshift(function() {
        delete E2.style;
      });
      var H2 = C._config.usePrefixes ? B.toLowerCase().split(" ") : [];
      C._domPrefixes = H2, C.testAllProps = k2;
      var S = function(N2) {
        var G, Y = Q.length, te = h2.CSSRule;
        if (te === void 0)
          return t3;
        if (!N2)
          return false;
        if ((G = (N2 = N2.replace(/^@/, "")).replace(/-/g, "_").toUpperCase() + "_RULE") in te)
          return "@" + N2;
        for (var ae = 0; ae < Y; ae++) {
          var se = Q[ae];
          if (se.toUpperCase() + "_" + G in te)
            return "@-" + se.toLowerCase() + "-" + N2;
        }
        return false;
      };
      C.atRule = S;
      var U2 = C.prefixed = function(N2, G, Y) {
        return N2.indexOf("@") === 0 ? S(N2) : (N2.indexOf("-") !== -1 && (N2 = d4(N2)), G ? k2(N2, G, Y) : k2(N2, "pfx"));
      };
      A2.addTest("batteryapi", !!U2("battery", navigator) || !!U2("getBattery", navigator), {
        aliases: ["battery-api"]
      }), A2.addTest(
        "blobconstructor",
        function() {
          try {
            return !!new Blob();
          } catch (e3) {
            return false;
          }
        },
        { aliases: ["blob-constructor"] }
      ), A2.addTest("contextmenu", "contextMenu" in D2 && "HTMLMenuItemElement" in h2), A2.addTest("cors", "XMLHttpRequest" in h2 && "withCredentials" in new XMLHttpRequest());
      var W2 = U2("crypto", h2);
      A2.addTest("crypto", !!U2("subtle", W2)), A2.addTest("customelements", "customElements" in h2), A2.addTest("customprotocolhandler", function() {
        if (!navigator.registerProtocolHandler)
          return false;
        try {
          navigator.registerProtocolHandler("thisShouldFail");
        } catch (N2) {
          return N2 instanceof TypeError;
        }
        return false;
      }), A2.addTest("customevent", "CustomEvent" in h2 && typeof h2.CustomEvent == "function"), A2.addTest("dart", !!U2("startDart", navigator)), A2.addTest(
        "dataview",
        typeof DataView < "u" && "getFloat64" in DataView.prototype
      ), A2.addTest("eventlistener", "addEventListener" in h2), A2.addTest("forcetouch", function() {
        return !!z2(U2("mouseforcewillbegin", h2, false), h2) && MouseEvent.WEBKIT_FORCE_AT_MOUSE_DOWN && MouseEvent.WEBKIT_FORCE_AT_FORCE_MOUSE_DOWN;
      }), A2.addTest("fullscreen", !(!U2("exitFullscreen", r10, false) && !U2("cancelFullScreen", r10, false))), A2.addTest("gamepads", !!U2("getGamepads", navigator)), A2.addTest("geolocation", "geolocation" in navigator), A2.addTest("ie8compat", !h2.addEventListener && !!r10.documentMode && r10.documentMode === 7), A2.addTest("intl", !!U2("Intl", h2)), A2.addTest("json", "JSON" in h2 && "parse" in JSON && "stringify" in JSON), C.testAllProps = x, A2.addTest("ligatures", x("fontFeatureSettings", '"liga" 1')), A2.addTest("messagechannel", "MessageChannel" in h2), A2.addTest("notification", function() {
        if (!h2.Notification || !h2.Notification.requestPermission)
          return false;
        if (h2.Notification.permission === "granted")
          return true;
        try {
          new h2.Notification("");
        } catch (N2) {
          if (N2.name === "TypeError")
            return false;
        }
        return true;
      }), A2.addTest("pagevisibility", !!U2("hidden", r10, false)), A2.addTest("performance", !!U2("performance", h2));
      var J3 = [""].concat(H2);
      C._domPrefixesAll = J3, A2.addTest("pointerevents", function() {
        for (var N2 = 0, G = J3.length; N2 < G; N2++)
          if (z2(J3[N2] + "pointerdown"))
            return true;
        return false;
      }), A2.addTest("pointerlock", !!U2("exitPointerLock", r10)), A2.addTest("queryselector", "querySelector" in r10 && "querySelectorAll" in r10), A2.addTest("quotamanagement", function() {
        var N2 = U2("temporaryStorage", navigator), G = U2("persistentStorage", navigator);
        return !(!N2 || !G);
      }), A2.addTest("requestanimationframe", !!U2("requestAnimationFrame", h2), { aliases: ["raf"] }), A2.addTest("serviceworker", "serviceWorker" in navigator);
      var Q = C._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
      C._prefixes = Q;
      var oe = function() {
        var N2 = h2.matchMedia || h2.msMatchMedia;
        return N2 ? function(G) {
          var Y = N2(G);
          return Y && Y.matches || false;
        } : function(G) {
          var Y = false;
          return a5("@media " + G + " { #modernizr { position: absolute; } }", function(te) {
            Y = c5(te, null, "position") === "absolute";
          }), Y;
        };
      }();
      C.mq = oe, A2.addTest("touchevents", function() {
        if ("ontouchstart" in h2 || h2.TouchEvent || h2.DocumentTouch && r10 instanceof DocumentTouch)
          return true;
        var N2 = ["(", Q.join("touch-enabled),("), "heartz", ")"].join("");
        return oe(N2);
      }), A2.addTest("typedarrays", "ArrayBuffer" in h2), A2.addTest("vibrate", !!U2("vibrate", navigator)), function() {
        var N2 = n2("video");
        A2.addTest("video", function() {
          var G = false;
          try {
            (G = !!N2.canPlayType) && (G = new Boolean(G));
          } catch (e3) {
          }
          return G;
        });
        try {
          N2.canPlayType && (A2.addTest(
            "video.ogg",
            N2.canPlayType('video/ogg; codecs="theora"').replace(/^no$/, "")
          ), A2.addTest(
            "video.h264",
            N2.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, "")
          ), A2.addTest(
            "video.h265",
            N2.canPlayType('video/mp4; codecs="hev1"').replace(/^no$/, "")
          ), A2.addTest(
            "video.webm",
            N2.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/, "")
          ), A2.addTest(
            "video.vp9",
            N2.canPlayType('video/webm; codecs="vp9"').replace(/^no$/, "")
          ), A2.addTest(
            "video.hls",
            N2.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/, "")
          ), A2.addTest(
            "video.av1",
            N2.canPlayType('video/mp4; codecs="av01"').replace(/^no$/, "")
          ));
        } catch (e3) {
        }
      }(), A2.addTest("webgl", function() {
        return "WebGLRenderingContext" in h2;
      });
      var q = false;
      try {
        q = "WebSocket" in h2 && h2.WebSocket.CLOSING === 2;
      } catch (e3) {
      }
      A2.addTest("websockets", q), A2.addTest("xdomainrequest", "XDomainRequest" in h2), A2.addTest("matchmedia", !!U2("matchMedia", h2)), function() {
        var N2, G, Y, te, ae, se;
        for (var le in y3)
          if (y3.hasOwnProperty(le)) {
            if (N2 = [], (G = y3[le]).name && (N2.push(G.name.toLowerCase()), G.options && G.options.aliases && G.options.aliases.length))
              for (Y = 0; Y < G.options.aliases.length; Y++)
                N2.push(G.options.aliases[Y].toLowerCase());
            for (te = e2(G.fn, "function") ? G.fn() : G.fn, ae = 0; ae < N2.length; ae++)
              (se = N2[ae].split(".")).length === 1 ? A2[se[0]] = te : (A2[se[0]] && (!A2[se[0]] || A2[se[0]] instanceof Boolean) || (A2[se[0]] = new Boolean(A2[se[0]])), A2[se[0]][se[1]] = te), P2.push((te ? "" : "no-") + se.join("-"));
          }
      }(), delete C.addTest, delete C.addAsyncTest;
      for (var fe = 0; fe < A2._q.length; fe++)
        A2._q[fe]();
      s5.Modernizr = A2;
    })(M2 || (M2 = {}), window, document);
  };
  Z = function(s5, h2, r10, t3) {
    return new (r10 || (r10 = Promise))(function(e2, n2) {
      function i9(c5) {
        try {
          u4(t3.next(c5));
        } catch (l2) {
          n2(l2);
        }
      }
      function a5(c5) {
        try {
          u4(t3.throw(c5));
        } catch (l2) {
          n2(l2);
        }
      }
      function u4(c5) {
        var l2;
        c5.done ? e2(c5.value) : (l2 = c5.value, l2 instanceof r10 ? l2 : new r10(function(d4) {
          d4(l2);
        })).then(i9, a5);
      }
      u4((t3 = t3.apply(s5, h2 || [])).next());
    });
  }, $ = function(s5, h2) {
    var r10, t3, e2, n2, i9 = {
      label: 0,
      sent: function() {
        if (1 & e2[0])
          throw e2[1];
        return e2[1];
      },
      trys: [],
      ops: []
    };
    return n2 = { next: a5(0), throw: a5(1), return: a5(2) }, typeof Symbol == "function" && (n2[Symbol.iterator] = function() {
      return this;
    }), n2;
    function a5(u4) {
      return function(c5) {
        return function(l2) {
          if (r10)
            throw new TypeError("Generator is already executing.");
          for (; i9; )
            try {
              if (r10 = 1, t3 && (e2 = 2 & l2[0] ? t3.return : l2[0] ? t3.throw || ((e2 = t3.return) && e2.call(t3), 0) : t3.next) && !(e2 = e2.call(t3, l2[1])).done)
                return e2;
              switch (t3 = 0, e2 && (l2 = [2 & l2[0], e2.value]), l2[0]) {
                case 0:
                case 1:
                  e2 = l2;
                  break;
                case 4:
                  return i9.label++, { value: l2[1], done: false };
                case 5:
                  i9.label++, t3 = l2[1], l2 = [0];
                  continue;
                case 7:
                  l2 = i9.ops.pop(), i9.trys.pop();
                  continue;
                default:
                  if (!(e2 = (e2 = i9.trys).length > 0 && e2[e2.length - 1]) && (l2[0] === 6 || l2[0] === 2)) {
                    i9 = 0;
                    continue;
                  }
                  if (l2[0] === 3 && (!e2 || l2[1] > e2[0] && l2[1] < e2[3])) {
                    i9.label = l2[1];
                    break;
                  }
                  if (l2[0] === 6 && i9.label < e2[1]) {
                    i9.label = e2[1], e2 = l2;
                    break;
                  }
                  if (e2 && i9.label < e2[2]) {
                    i9.label = e2[2], i9.ops.push(l2);
                    break;
                  }
                  e2[2] && i9.ops.pop(), i9.trys.pop();
                  continue;
              }
              l2 = h2.call(s5, i9);
            } catch (d4) {
              l2 = [6, d4], t3 = 0;
            } finally {
              r10 = e2 = 0;
            }
          if (5 & l2[0])
            throw l2[1];
          return { value: l2[0] ? l2[1] : void 0, done: true };
        }([u4, c5]);
      };
    }
  }, ve = function() {
    return (ve = Object.assign || function(s5) {
      for (var h2, r10 = 1, t3 = arguments.length; r10 < t3; r10++)
        for (var e2 in h2 = arguments[r10])
          Object.prototype.hasOwnProperty.call(h2, e2) && (s5[e2] = h2[e2]);
      return s5;
    }).apply(this, arguments);
  };
  (function(s5) {
    (function(h2) {
      var r10 = function() {
        function t3() {
          this._isIphoneOrIPad = false, (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i)) && (this._isIphoneOrIPad = true), this.initUAParser();
        }
        return Object.defineProperty(t3.prototype, "userAgentData", {
          get: function() {
            return this._userAgentData;
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3.prototype, "deviceType", {
          get: function() {
            return this._deviceType || (h2.Util.isMobile ? this._deviceType = this.mobileType || this.desktopType || t3.UNKNOWN_DEVICE_TYPE : this._deviceType = this.desktopType || this.mobileType || t3.UNKNOWN_DEVICE_TYPE), this._deviceType;
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3.prototype, "isIphoneOrIPad", {
          get: function() {
            return this._isIphoneOrIPad;
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3.prototype, "browserName", {
          get: function() {
            return this._userAgentData && this._userAgentData.browser && this._userAgentData.browser.name ? this._userAgentData.browser.name.trim() : "";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3.prototype, "browserVersion", {
          get: function() {
            return this._userAgentData && this._userAgentData.browser && this._userAgentData.browser.version ? this._userAgentData.browser.version.trim() : "";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3.prototype, "osName", {
          get: function() {
            return this._userAgentData && this._userAgentData.os && this._userAgentData.os.name ? this._userAgentData.os.name.trim() : "";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3.prototype, "osVersion", {
          get: function() {
            return this._userAgentData && this._userAgentData.os && this._userAgentData.os.version ? this._userAgentData.os.version.trim() : "";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3.prototype, "deviceCategory", {
          get: function() {
            return this._userAgentData && this._userAgentData.device ? this._userAgentData.device.type : "";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3.prototype, "engineName", {
          get: function() {
            return this._userAgentData && this._userAgentData.engine && this._userAgentData.engine.name ? this._userAgentData.engine.name.trim() : "";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3.prototype, "engineVersion", {
          get: function() {
            return this._userAgentData && this._userAgentData.engine && this._userAgentData.engine.version ? this._userAgentData.engine.version.trim() : "";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3.prototype, "cpuArchitecture", {
          get: function() {
            return this._userAgentData && this._userAgentData.cpu && this._userAgentData.cpu.architecture ? this._userAgentData.cpu.architecture.trim() : "";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3.prototype, "deviceModel", {
          get: function() {
            return this._userAgentData && this._userAgentData.device && this._userAgentData.device.model ? this._userAgentData.device.model.trim() : "";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3.prototype, "deviceVendor", {
          get: function() {
            return this._userAgentData && this._userAgentData.device && this._userAgentData.device.vendor ? this._userAgentData.device.vendor.trim() : "";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3.prototype, "desktopType", {
          get: function() {
            var e2 = this.browserName;
            this.browserVersion && (e2 = e2 + "(" + this.browserVersion + ")");
            var n2 = this.osName;
            this.osVersion && (n2 = n2 + "(" + this.osVersion + ")");
            var i9 = e2 && n2 ? e2 + "-" + n2 : e2 || n2;
            return i9 ? i9.trim() : "";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3.prototype, "mobileType", {
          get: function() {
            var e2 = this.deviceModel, n2 = this.deviceVendor, i9 = e2 && n2 ? e2 + " " + n2 : e2 || n2;
            return i9 ? i9.trim() : "";
          },
          enumerable: false,
          configurable: true
        }), t3.prototype.initUAParser = function() {
          try {
            var e2 = new s5.UAParser();
            e2.setUA(navigator.userAgent), this._userAgentData = e2.getResult();
          } catch (n2) {
            h2.Logger.warn("UAParser failure", n2);
          }
        }, t3.UNKNOWN_DEVICE_TYPE = "unknown", t3;
      }();
      h2.BrowserInfo = r10;
    })(s5._POSignalsUtils || (s5._POSignalsUtils = {}));
  })(M2 || (M2 = {})), function(s5) {
    (function(h2) {
      var r10 = function() {
        function t3() {
        }
        return Object.defineProperty(t3, "CLIENT_VERSION", {
          get: function() {
            return "5.3.5w";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3, "SALT", {
          get: function() {
            return "ST8irbd3bB";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3, "TAB_UUID_KEY", {
          get: function() {
            return "pos_tid";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3, "OPS_KEY", {
          get: function() {
            return "pos_ops";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3, "DEVICE_ID_KEY", {
          get: function() {
            return "SecuredTouchDeviceId";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3, "LAST_DEVICE_KEY_RESYNC", {
          get: function() {
            return "DeviceRefreshDate";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3, "CAPTURED_KEYBOARD_INTERACTIONS", {
          get: function() {
            return "pos_cki";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3, "CAPTURED_MOUSE_INTERACTIONS", {
          get: function() {
            return "pos_cmi";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3, "CAPTURED_GESTURES", {
          get: function() {
            return "pos_cg";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3, "CAPTURED_INDIRECT", {
          get: function() {
            return "pos_cie";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3, "CAPTURED_TAGS", {
          get: function() {
            return "pos_ct";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3, "KEYBOARD_INTERACTIONS_COUNT", {
          get: function() {
            return "pos_kic";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3, "MOUSE_INTERACTIONS_COUNT", {
          get: function() {
            return "pos_mic";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3, "GESTURES_COUNT", {
          get: function() {
            return "pos_gc";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3, "EVENT_COUNTERS", {
          get: function() {
            return "pos_ec";
          },
          enumerable: false,
          configurable: true
        }), t3;
      }();
      h2.Constants = r10;
    })(s5._POSignalsUtils || (s5._POSignalsUtils = {}));
  }(M2 || (M2 = {})), function(s5) {
    (function(h2) {
      var r10 = function() {
        function t3(e2, n2, i9) {
          if (e2 === void 0 && (e2 = "RSA-PSS"), n2 === void 0 && (n2 = ["sign", "verify"]), i9 === void 0 && (i9 = "SHA-256"), this.signingKeyType = e2, this.keyUsage = n2, this.algorithm = i9, this._crypto = window.crypto || window.msCrypto, !this._crypto || !this._crypto.subtle)
            throw new Error("Cryptography API not supported in this browser");
        }
        return t3.prototype.generateKeys = function() {
          return Z(this, void 0, void 0, function() {
            return $(this, function(e2) {
              return [
                2,
                this._crypto.subtle.generateKey(
                  {
                    name: this.signingKeyType,
                    modulusLength: 2048,
                    publicExponent: new Uint8Array([1, 0, 1]),
                    hash: { name: this.algorithm }
                  },
                  false,
                  this.keyUsage
                )
              ];
            });
          });
        }, t3.prototype.exportPublicKey = function(e2) {
          return Z(this, void 0, void 0, function() {
            var n2, i9, a5;
            return $(this, function(u4) {
              switch (u4.label) {
                case 0:
                  return [4, this._crypto.subtle.exportKey("spki", e2.publicKey)];
                case 1:
                  return n2 = u4.sent(), i9 = h2.Util.ab2str(n2), a5 = btoa(i9), h2.Logger.debug("Exported base64 pub key: ", a5), [2, a5];
              }
            });
          });
        }, t3.prototype.exportPrivateKey = function(e2) {
          return Z(this, void 0, void 0, function() {
            var n2, i9, a5, u4;
            return $(this, function(c5) {
              switch (c5.label) {
                case 0:
                  return [4, this._crypto.subtle.exportKey("pkcs8", e2.privateKey)];
                case 1:
                  return n2 = c5.sent(), i9 = h2.Util.ab2str(n2), a5 = btoa(i9), u4 = `-----BEGIN PRIVATE KEY-----
` + a5 + `
-----END PRIVATE KEY-----`, h2.Logger.debug("Exported base64 pem:", u4), [2, u4];
              }
            });
          });
        }, t3.prototype.signChallenge = function(e2, n2, i9) {
          return i9 === void 0 && (i9 = 0), Z(this, void 0, void 0, function() {
            var a5, u4, c5;
            return $(this, function(l2) {
              switch (l2.label) {
                case 0:
                  return a5 = h2.Util.string2buf(e2), [
                    4,
                    this._crypto.subtle.sign(
                      { name: this.signingKeyType, saltLength: i9, hash: this.algorithm },
                      n2,
                      a5
                    )
                  ];
                case 1:
                  return u4 = l2.sent(), c5 = btoa(String.fromCharCode.apply(null, new Uint8Array(u4))), h2.Logger.debug("Signed challenge: ", c5), [2, c5];
              }
            });
          });
        }, t3;
      }();
      h2.CryptoOperator = r10;
    })(s5._POSignalsUtils || (s5._POSignalsUtils = {}));
  }(M2 || (M2 = {})), function(s5) {
    (function(h2) {
      var r10 = function() {
        function t3() {
        }
        return Object.defineProperty(t3, "isLogEnabled", {
          get: function() {
            return this._isLogEnabled || window["enable-logs-pingOneSignals"];
          },
          set: function(e2) {
            this._isLogEnabled = e2;
          },
          enumerable: false,
          configurable: true
        }), t3.debug = function(e2) {
          for (var n2 = [], i9 = 1; i9 < arguments.length; i9++)
            n2[i9 - 1] = arguments[i9];
          e2 = t3.TAG + " " + e2, t3.isLogEnabled && (n2 && n2.length > 0 ? console.debug ? console.debug(e2, n2) : console.log(e2, n2) : console.debug ? console.debug(e2) : console.log(e2));
        }, t3.error = function(e2) {
          for (var n2 = [], i9 = 1; i9 < arguments.length; i9++)
            n2[i9 - 1] = arguments[i9];
          e2 = t3.TAG + " " + e2, t3.isLogEnabled && (n2 && n2.length > 0 ? console.error(e2, n2) : console.error(e2));
        }, t3.warn = function(e2) {
          for (var n2 = [], i9 = 1; i9 < arguments.length; i9++)
            n2[i9 - 1] = arguments[i9];
          e2 = t3.TAG + " " + e2, t3.isLogEnabled && (n2 && n2.length > 0 ? console.warn(e2, n2) : console.warn(e2));
        }, t3.info = function(e2) {
          for (var n2 = [], i9 = 1; i9 < arguments.length; i9++)
            n2[i9 - 1] = arguments[i9];
          e2 = t3.TAG + " " + e2, t3.isLogEnabled && (n2 && n2.length > 0 ? console.info(e2, n2) : console.info(e2));
        }, t3.TAG = "[SignalsSDK]", t3;
      }();
      h2.Logger = r10;
    })(s5._POSignalsUtils || (s5._POSignalsUtils = {}));
  }(M2 || (M2 = {})), function(s5) {
    (function(h2) {
      var r10 = function() {
        function t3() {
        }
        return Object.defineProperty(t3, "INITIALIZATION_ERROR", {
          get: function() {
            return "INITIALIZATION_ERROR";
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3, "UNEXPECTED_ERROR", {
          get: function() {
            return "UNEXPECTED_ERROR";
          },
          enumerable: false,
          configurable: true
        }), t3;
      }();
      h2.POErrorCodes = r10;
    })(s5._POSignalsUtils || (s5._POSignalsUtils = {}));
  }(M2 || (M2 = {})), function(s5) {
    (function(h2) {
      var r10 = function() {
        function t3() {
        }
        return Object.defineProperty(t3, "isMobile", {
          get: function() {
            var e2, n2 = false;
            return e2 = navigator.userAgent || navigator.vendor || window.opera, (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
              e2
            ) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
              e2.substr(0, 4)
            )) && (n2 = true), n2;
          },
          enumerable: false,
          configurable: true
        }), t3.newGuid = function() {
          return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e2) {
            var n2 = 16 * Math.random() | 0;
            return (e2 === "x" ? n2 : 3 & n2 | 8).toString(16);
          });
        }, t3.ieFix = function() {
          (navigator.userAgent.indexOf("MSIE") != -1 ? /MSIE (\d+\.\d+);/ : /Trident.*rv[ :]*(\d+\.\d+)/).test(navigator.userAgent) && (document.body.setAttribute("style", "-ms-touch-action:none;"), document.body.style.touchAction = "none", document.body.style.msTouchAction = "none");
        }, t3.now = function() {
          var e2 = window.performance || {};
          return e2.now = e2.now || e2.webkitNow || e2.msNow || e2.oNow || e2.mozNow || function() {
            return (/* @__PURE__ */ new Date()).getTime();
          }, e2.now();
        }, t3.base64Uint8Array = function(e2) {
          var n2, i9 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a5 = e2.length, u4 = "";
          for (n2 = 0; n2 < a5; n2 += 3)
            u4 += i9[e2[n2] >> 2], u4 += i9[(3 & e2[n2]) << 4 | e2[n2 + 1] >> 4], u4 += i9[(15 & e2[n2 + 1]) << 2 | e2[n2 + 2] >> 6], u4 += i9[63 & e2[n2 + 2]];
          return a5 % 3 == 2 ? u4 = u4.substring(0, u4.length - 1) + "=" : a5 % 3 == 1 && (u4 = u4.substring(0, u4.length - 2) + "=="), u4;
        }, t3.string2buf = function(e2) {
          if (typeof TextEncoder == "function" && TextEncoder.prototype.encode)
            return new TextEncoder().encode(e2);
          var n2, i9, a5, u4, c5, l2 = e2.length, d4 = 0;
          for (u4 = 0; u4 < l2; u4++)
            (64512 & (i9 = e2.charCodeAt(u4))) == 55296 && u4 + 1 < l2 && (64512 & (a5 = e2.charCodeAt(u4 + 1))) == 56320 && (i9 = 65536 + (i9 - 55296 << 10) + (a5 - 56320), u4++), d4 += i9 < 128 ? 1 : i9 < 2048 ? 2 : i9 < 65536 ? 3 : 4;
          for (n2 = new Uint8Array(d4), c5 = 0, u4 = 0; c5 < d4; u4++)
            (64512 & (i9 = e2.charCodeAt(u4))) == 55296 && u4 + 1 < l2 && (64512 & (a5 = e2.charCodeAt(u4 + 1))) == 56320 && (i9 = 65536 + (i9 - 55296 << 10) + (a5 - 56320), u4++), i9 < 128 ? n2[c5++] = i9 : i9 < 2048 ? (n2[c5++] = 192 | i9 >>> 6, n2[c5++] = 128 | 63 & i9) : i9 < 65536 ? (n2[c5++] = 224 | i9 >>> 12, n2[c5++] = 128 | i9 >>> 6 & 63, n2[c5++] = 128 | 63 & i9) : (n2[c5++] = 240 | i9 >>> 18, n2[c5++] = 128 | i9 >>> 12 & 63, n2[c5++] = 128 | i9 >>> 6 & 63, n2[c5++] = 128 | 63 & i9);
          return n2;
        }, t3.utf8Encode = function(e2) {
          e2 = e2.replace(/\r\n/g, `
`);
          for (var n2 = "", i9 = 0; i9 < e2.length; i9++) {
            var a5 = e2.charCodeAt(i9);
            a5 < 128 ? n2 += String.fromCharCode(a5) : a5 > 127 && a5 < 2048 ? (n2 += String.fromCharCode(a5 >> 6 | 192), n2 += String.fromCharCode(63 & a5 | 128)) : (n2 += String.fromCharCode(a5 >> 12 | 224), n2 += String.fromCharCode(a5 >> 6 & 63 | 128), n2 += String.fromCharCode(63 & a5 | 128));
          }
          return n2;
        }, t3.hash = function(e2) {
          var n2 = t3.hashCache.get(e2);
          return n2 || (n2 = s5.sha256(e2 + h2.Constants.SALT), t3.hashCache.set(e2, n2)), n2;
        }, t3.hashMini = function(e2) {
          var n2, i9, a5 = "" + JSON.stringify(e2), u4 = 2166136261;
          for (n2 = 0, i9 = a5.length; n2 < i9; n2++)
            u4 = Math.imul(31, u4) + a5.charCodeAt(n2) | 0;
          return ("0000000" + (u4 >>> 0).toString(16)).substr(-8);
        }, t3.hashCode = function(e2) {
          var n2 = 0, i9 = e2 ? e2.length : 0, a5 = 0;
          if (i9 > 0)
            for (; a5 < i9; )
              n2 = (n2 << 5) - n2 + e2.charCodeAt(a5++) | 0;
          return n2;
        }, t3.mod = function(e2, n2) {
          return (t3.hashCode(e2) % n2 + n2) % n2;
        }, t3.isEmail = function(e2) {
          try {
            return e2 && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              e2.toLowerCase()
            );
          } catch (n2) {
            return h2.Logger.warn("isEmail function failed to parse string", n2), false;
          }
        }, t3.getEmailDomain = function(e2) {
          return t3.isEmail(e2) ? e2.substring(e2.lastIndexOf("@") + 1) : "";
        }, t3.extendPrimitiveValues = function(e2, n2, i9) {
          for (var a5 = t3.allKeys(n2), u4 = 0; u4 < a5.length; )
            t3.isObject(n2[a5[u4]]) || i9 && (!i9 || e2[a5[u4]] !== void 0) || (e2[a5[u4]] = n2[a5[u4]]), u4++;
          return e2;
        }, t3.flatten = function(e2) {
          var n2 = {};
          return t3.dive("", e2, n2), n2;
        }, t3.isFunction = function(e2) {
          return e2 && typeof e2 == "function";
        }, t3.isPassiveSupported = function() {
          var e2 = false, n2 = function() {
          };
          try {
            var i9 = {
              get passive() {
                return e2 = true, true;
              }
            };
            window.addEventListener("test", n2, i9), window.removeEventListener("test", n2, false);
          } catch (e3) {
            e2 = false;
          }
          return e2;
        }, t3.getAttribute = function(e2, n2) {
          try {
            if (e2 && typeof e2.getAttribute == "function")
              return e2.getAttribute(n2) || "";
          } catch (e3) {
          }
          return "";
        }, t3.createInvisibleElement = function(e2) {
          try {
            var n2 = document.createElement(e2);
            return n2.style.display = "none", n2.style.border = "none", n2.style.position = "absolute", n2.style.top = "-999px", n2.style.left = "-999px", n2.style.width = "0", n2.style.height = "0", n2.style.visibility = "hidden", n2;
          } catch (i9) {
            return h2.Logger.warn("Failed to create element", i9), null;
          }
        }, t3.values = function(e2) {
          for (var n2 = t3.allKeys(e2), i9 = n2.length, a5 = Array(i9), u4 = 0; u4 < i9; u4++)
            a5[u4] = e2[n2[u4]];
          return a5;
        }, t3.getValuesOfMap = function(e2) {
          if (this.isFunction(e2.values))
            return Array.from(e2.values());
          var n2 = [];
          return e2.forEach(function(i9) {
            return n2.push(i9);
          }), n2;
        }, t3.typesCounter = function(e2) {
          for (var n2 = {}, i9 = 0, a5 = e2; i9 < a5.length; i9++) {
            var u4 = a5[i9];
            n2[u4.type] = (n2[u4.type] || 0) + 1;
          }
          return n2;
        }, t3.modifiersKeys = function(e2) {
          var n2 = [];
          return e2.getModifierState && [
            "Alt",
            "AltGraph",
            "CapsLock",
            "Control",
            "Fn",
            "FnLock",
            "Hyper",
            "Meta",
            "NumLock",
            "OS",
            "ScrollLock",
            "Shift",
            "Super",
            "Symbol",
            "SymbolLock"
          ].forEach(function(i9) {
            e2.getModifierState(i9.toString()) && n2.push(i9);
          }), n2;
        }, t3.getElementText = function(e2) {
          var n2, i9;
          return e2 instanceof HTMLInputElement ? ["checkbox", "radio"].indexOf(e2.type) >= 0 ? "" + e2.checked : e2.value : e2 instanceof HTMLSelectElement ? (i9 = (n2 = e2.selectedOptions) === null || n2 === void 0 ? void 0 : n2[0]) === null || i9 === void 0 ? void 0 : i9.innerText : e2.innerText;
        }, t3.getSrcElement = function(e2) {
          return e2.srcElement || e2.target;
        }, t3.getObjectType = function(e2) {
          try {
            var n2 = /function (.{1,})\(/.exec(e2.constructor.toString());
            return n2 && n2.length > 1 ? n2[1] : "";
          } catch (e3) {
            return "";
          }
        }, t3.isSelectorMatches = function(e2, n2, i9) {
          try {
            var a5 = Element.prototype, u4 = a5.matches || a5.webkitMatchesSelector || a5.mozMatchesSelector || a5.msMatchesSelector, c5 = 0;
            do {
              if (u4.call(e2, n2))
                return e2;
              e2 = e2.parentElement || e2.parentNode;
            } while (e2 !== null && e2.nodeType === 1 && c5++ < i9);
            return null;
          } catch (e3) {
            return null;
          }
        }, t3.anySelectorMatches = function(e2, n2, i9) {
          try {
            for (var a5 = 0, u4 = n2; a5 < u4.length; a5++) {
              var c5 = u4[a5];
              if (this.isSelectorMatches(e2, c5, i9))
                return true;
            }
          } catch (l2) {
            h2.Logger.warn(l2);
          }
          return false;
        }, t3.isArray = function(e2) {
          return Array.isArray ? Array.isArray(e2) : Object.prototype.toString.call(e2) === "[object Array]";
        }, t3.safeJsonParse = function(e2) {
          var n2 = null;
          try {
            e2 && (n2 = JSON.parse(e2));
          } catch (i9) {
            h2.Logger.warn("Failed to parse object " + i9), n2 = null;
          }
          return n2;
        }, t3.getElementSelectionStart = function(e2) {
          var n2;
          try {
            n2 = e2.selectionStart;
          } catch (e3) {
            n2 = "";
          }
          return n2;
        }, t3.getElementSelectionEnd = function(e2) {
          var n2;
          try {
            n2 = e2.selectionEnd;
          } catch (e3) {
            n2 = "";
          }
          return n2;
        }, t3.isClickableInput = function(e2) {
          return e2 && [
            "button",
            "checkbox",
            "color",
            "radio",
            "range",
            "image",
            "submit",
            "file",
            "reset"
          ].indexOf(e2.type) >= 0;
        }, t3.isTextInput = function(e2) {
          return e2 && [
            "date",
            "datetime-local",
            "email",
            "month",
            "number",
            "password",
            "search",
            "tel",
            "text",
            "time",
            "url",
            "week",
            "datetime"
          ].indexOf(e2.type) >= 0;
        }, t3.getDeviceOrientation = function() {
          var e2 = screen.orientation || screen.mozOrientation || {}, n2 = screen.msOrientation || e2.type, i9 = e2.angle;
          return {
            orientation: n2 == null ? void 0 : n2.toString(),
            angle: i9 == null ? void 0 : i9.toString()
          };
        }, t3.getDevToolsState = function() {
          var e2, n2, i9 = window.outerWidth - window.innerWidth > 160, a5 = window.outerHeight - window.innerHeight > 160, u4 = i9 ? "vertical" : "horizontal";
          return a5 && i9 || !(!((n2 = (e2 = window.Firebug) === null || e2 === void 0 ? void 0 : e2.chrome) === null || n2 === void 0) && n2.isInitialized || i9 || a5) ? { open: false, orientation: void 0 } : { open: true, orientation: u4 };
        }, t3.getCookie = function(e2) {
          var n2 = document.cookie.match("(^|;) ?" + e2 + "=([^;]*)(;|$)");
          return n2 ? n2[2] : null;
        }, t3.setCookie = function(e2, n2, i9) {
          var a5 = /* @__PURE__ */ new Date();
          a5.setTime(a5.getTime() + 1e3 * i9), document.cookie = e2 + "=" + n2 + ";path=/;secure;SameSite=None;expires=" + a5.toUTCString();
        }, t3.deleteCookie = function(e2) {
          t3.setCookie(e2, "", -1);
        }, t3.delay = function(e2) {
          return new Promise(function(n2) {
            return setTimeout(n2, e2);
          });
        }, t3.getHostnameFromRegex = function(e2) {
          if (e2) {
            var n2 = e2.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
            return n2 && n2[1];
          }
          return null;
        }, t3.inIframe = function() {
          try {
            return window.self !== window.top;
          } catch (e2) {
            return true;
          }
        }, t3.promiseTimeout = function(e2, n2) {
          var i9 = new Promise(function(a5, u4) {
            var c5 = setTimeout(function() {
              clearTimeout(c5), u4(new Error("Timed out in " + e2 + "ms."));
            }, e2);
          });
          return Promise.race([n2, i9]);
        }, t3.getProperty = function(e2, n2) {
          return n2.split(".").reduce(function(i9, a5) {
            return i9 ? i9[a5] : null;
          }, e2);
        }, t3.filterReduce = function(e2, n2) {
          return Object.keys(e2).filter(function(i9) {
            return n2(e2[i9]);
          }).reduce(function(i9, a5) {
            var u4;
            return ve(ve({}, i9), ((u4 = {})[a5] = e2[a5], u4));
          }, {});
        }, t3.dive = function(e2, n2, i9) {
          for (var a5 in n2)
            if (n2.hasOwnProperty(a5)) {
              var u4 = a5, c5 = n2[a5];
              e2.length > 0 && (u4 = e2 + "." + a5), t3.isObject(c5) ? t3.dive(u4, c5, i9) : i9[u4] = c5;
            }
        }, t3.isObject = function(e2) {
          var n2 = typeof e2;
          return n2 === "function" || n2 === "object" && !!e2;
        }, t3.allKeys = function(e2) {
          if (!t3.isObject(e2))
            return [];
          var n2 = [];
          for (var i9 in e2)
            n2.push(i9);
          return n2;
        }, t3.encryptionString = function(e2, n2) {
          for (var i9 = [], a5 = 0; a5 < e2.length; a5++) {
            var u4 = e2.charCodeAt(a5) ^ n2.charCodeAt(a5 % n2.length);
            i9.push(String.fromCharCode(u4));
          }
          return i9.join("");
        }, t3.encryptionBytes = function(e2, n2) {
          for (var i9 = new Uint8Array(e2.length), a5 = 0; a5 < e2.length; a5++)
            i9[a5] = e2[a5] ^ n2.charCodeAt(a5 % n2.length);
          return i9;
        }, t3.parseJwt = function(e2) {
          var n2 = e2.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"), i9 = decodeURIComponent(
            window.atob(n2).split("").map(function(a5) {
              return "%" + ("00" + a5.charCodeAt(0).toString(16)).slice(-2);
            }).join("")
          );
          return JSON.parse(i9);
        }, t3.calculateMeanTimeDeltasBetweenEvents = function(e2) {
          var n2 = 0;
          if ((e2 == null ? void 0 : e2.length) > 1) {
            for (var i9 = e2[0].epochTs, a5 = 1; a5 < e2.length; a5++)
              n2 += e2[a5].epochTs - i9, i9 = e2[a5].epochTs;
            n2 /= e2.length - 1;
          }
          return n2;
        }, t3.sortEventsByTimestamp = function(e2) {
          return e2.sort(function(n2, i9) {
            return n2.eventTs > i9.eventTs ? 1 : n2.eventTs < i9.eventTs ? -1 : n2.epochTs > i9.epochTs ? 1 : n2.epochTs < i9.epochTs ? -1 : n2.type === "click" ? 1 : -1;
          });
        }, t3.distanceBetweenPoints = function(e2, n2) {
          return Math.sqrt(Math.pow(e2.getX() - n2.getX(), 2) + Math.pow(e2.getY() - n2.getY(), 2));
        }, t3.calculateMeanDistanceBetweenPoints = function(e2) {
          var n2 = 0;
          if ((e2 == null ? void 0 : e2.length) > 1) {
            for (var i9 = 1; i9 < e2.length; i9++)
              n2 += t3.distanceBetweenPoints(e2[i9 - 1], e2[i9]);
            n2 /= e2.length - 1;
          }
          return n2;
        }, t3.filterArrayByLength = function(e2, n2) {
          return e2.length <= n2 ? e2 : e2.slice(0, n2).concat(e2[e2.length - 1]);
        }, t3.keepFirstEventsWithDistance = function(e2) {
          var n2 = e2.events, i9 = e2.threshold, a5 = e2.min, u4 = e2.max;
          if (n2.length <= a5)
            return n2;
          var c5, l2 = n2[0];
          for (c5 = 1; c5 < n2.length && c5 < u4 && !(Math.max(Math.abs(n2[c5].getX() - l2.getX()), Math.abs(n2[c5].getY() - l2.getY())) >= i9); c5++)
            ;
          return n2.slice(0, Math.max(c5 + 1, a5));
        }, t3.ab2str = function(e2) {
          return String.fromCharCode.apply(null, new Uint8Array(e2));
        }, t3.str2ab = function(e2) {
          for (var n2 = new ArrayBuffer(e2.length), i9 = new Uint8Array(n2), a5 = 0, u4 = e2.length; a5 < u4; a5++)
            i9[a5] = e2.charCodeAt(a5);
          return n2;
        }, t3.hashCache = /* @__PURE__ */ new Map(), t3.keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", t3;
      }();
      h2.Util = r10;
    })(s5._POSignalsUtils || (s5._POSignalsUtils = {}));
  }(M2 || (M2 = {})), Z = function(s5, h2, r10, t3) {
    return new (r10 || (r10 = Promise))(function(e2, n2) {
      function i9(c5) {
        try {
          u4(t3.next(c5));
        } catch (l2) {
          n2(l2);
        }
      }
      function a5(c5) {
        try {
          u4(t3.throw(c5));
        } catch (l2) {
          n2(l2);
        }
      }
      function u4(c5) {
        var l2;
        c5.done ? e2(c5.value) : (l2 = c5.value, l2 instanceof r10 ? l2 : new r10(function(d4) {
          d4(l2);
        })).then(i9, a5);
      }
      u4((t3 = t3.apply(s5, h2 || [])).next());
    });
  }, $ = function(s5, h2) {
    var r10, t3, e2, n2, i9 = {
      label: 0,
      sent: function() {
        if (1 & e2[0])
          throw e2[1];
        return e2[1];
      },
      trys: [],
      ops: []
    };
    return n2 = { next: a5(0), throw: a5(1), return: a5(2) }, typeof Symbol == "function" && (n2[Symbol.iterator] = function() {
      return this;
    }), n2;
    function a5(u4) {
      return function(c5) {
        return function(l2) {
          if (r10)
            throw new TypeError("Generator is already executing.");
          for (; i9; )
            try {
              if (r10 = 1, t3 && (e2 = 2 & l2[0] ? t3.return : l2[0] ? t3.throw || ((e2 = t3.return) && e2.call(t3), 0) : t3.next) && !(e2 = e2.call(t3, l2[1])).done)
                return e2;
              switch (t3 = 0, e2 && (l2 = [2 & l2[0], e2.value]), l2[0]) {
                case 0:
                case 1:
                  e2 = l2;
                  break;
                case 4:
                  return i9.label++, { value: l2[1], done: false };
                case 5:
                  i9.label++, t3 = l2[1], l2 = [0];
                  continue;
                case 7:
                  l2 = i9.ops.pop(), i9.trys.pop();
                  continue;
                default:
                  if (!(e2 = (e2 = i9.trys).length > 0 && e2[e2.length - 1]) && (l2[0] === 6 || l2[0] === 2)) {
                    i9 = 0;
                    continue;
                  }
                  if (l2[0] === 3 && (!e2 || l2[1] > e2[0] && l2[1] < e2[3])) {
                    i9.label = l2[1];
                    break;
                  }
                  if (l2[0] === 6 && i9.label < e2[1]) {
                    i9.label = e2[1], e2 = l2;
                    break;
                  }
                  if (e2 && i9.label < e2[2]) {
                    i9.label = e2[2], i9.ops.push(l2);
                    break;
                  }
                  e2[2] && i9.ops.pop(), i9.trys.pop();
                  continue;
              }
              l2 = h2.call(s5, i9);
            } catch (d4) {
              l2 = [6, d4], t3 = 0;
            } finally {
              r10 = e2 = 0;
            }
          if (5 & l2[0])
            throw l2[1];
          return { value: l2[0] ? l2[1] : void 0, done: true };
        }([u4, c5]);
      };
    }
  }, function(s5) {
    var h2 = s5.openDB;
    (function(r10) {
      var t3 = function() {
        function e2() {
        }
        return e2.initDB = function() {
          return Z(this, void 0, void 0, function() {
            var n2, i9 = this;
            return $(this, function(a5) {
              if (!(window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB))
                throw new Error("IndexedDB is not supported");
              return n2 = new e2(), [
                2,
                new Promise(function(u4) {
                  return Z(i9, void 0, void 0, function() {
                    var c5;
                    return $(this, function(l2) {
                      switch (l2.label) {
                        case 0:
                          return c5 = n2, [
                            4,
                            h2(this._PingDBName, e2._version, {
                              upgrade: function(d4, p4, m, k2, x) {
                                d4.createObjectStore(e2._storeDefaultName);
                              }
                            })
                          ];
                        case 1:
                          return c5.indexedDatabase = l2.sent(), u4(n2), [2];
                      }
                    });
                  });
                })
              ];
            });
          });
        }, e2.prototype.close = function() {
          this.indexedDatabase.close();
        }, e2.prototype.getValue = function(n2) {
          return this.indexedDatabase.get(e2._storeDefaultName, n2);
        }, e2.prototype.setValue = function(n2, i9) {
          return this.indexedDatabase.put(e2._storeDefaultName, i9, n2);
        }, e2._PingDBName = "Ping", e2._version = 1, e2._storeDefaultName = "PING_ONE", e2;
      }();
      r10.IndexedDBStorage = t3;
    })(s5._POSignalsStorage || (s5._POSignalsStorage = {}));
  }(M2 || (M2 = {})), function(s5) {
    (function(h2) {
      var r10 = function() {
        function e2(n2, i9) {
          this.crossStorageClient = new s5.CrossStorageClient(n2, i9);
        }
        return e2.prototype.get = function(n2) {
          var i9 = s5._POSignalsUtils.Util.hash(n2);
          return this.crossStorageClient.get(i9);
        }, e2.prototype.del = function(n2) {
          return this.crossStorageClient.del(s5._POSignalsUtils.Util.hash(n2));
        }, e2.prototype.set = function(n2, i9, a5) {
          return this.crossStorageClient.set(s5._POSignalsUtils.Util.hash(n2), i9, a5);
        }, e2.prototype.onConnect = function() {
          return this.crossStorageClient.onConnect();
        }, e2.prototype.close = function(n2) {
          return this.crossStorageClient.close(n2);
        }, e2.prototype.getSignedPayload = function(n2, i9) {
          return this.crossStorageClient.getSignedPayload(n2, i9);
        }, e2.prototype.getDeviceDetails = function(n2) {
          var i9 = s5._POSignalsUtils.Util.hash(n2);
          return this.crossStorageClient.getDeviceDetails(i9);
        }, e2.prototype.setDeviceDetails = function(n2, i9) {
          var a5 = s5._POSignalsUtils.Util.hash(n2);
          return this.crossStorageClient.setDeviceDetails(a5, i9);
        }, e2;
      }();
      h2.CrossStorage = r10;
      var t3 = function() {
        function e2(n2) {
          this.storage = n2;
        }
        return e2.prototype.get = function(n2) {
          return Promise.resolve(this.storage.getItem(n2));
        }, e2.prototype.del = function(n2) {
          return this.storage.removeItem(n2), Promise.resolve();
        }, e2.prototype.set = function(n2, i9) {
          return this.storage.setItem(n2, i9), Promise.resolve();
        }, e2.prototype.onConnect = function() {
          return Promise.resolve();
        }, e2.prototype.close = function(n2) {
          return Promise.resolve();
        }, e2.prototype.getSignedPayload = function(n2, i9) {
          return Promise.resolve([]);
        }, e2.prototype.getDeviceDetails = function(n2) {
          return Promise.resolve([]);
        }, e2.prototype.setDeviceDetails = function(n2, i9) {
          return Promise.resolve([]);
        }, e2;
      }();
      h2.CrossStorageFallback = t3;
    })(s5._POSignalsStorage || (s5._POSignalsStorage = {}));
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10(t3, e2, n2) {
        this.deviceId = t3, this.dbStorage = e2, this.cryptoHandler = n2;
      }
      return r10.prototype.getExportedPublicKey = function() {
        return Z(this, void 0, void 0, function() {
          var t3;
          return $(this, function(e2) {
            switch (e2.label) {
              case 0:
                return [4, this.getDeviceKeys()];
              case 1:
                return (t3 = e2.sent()) ? [2, this.cryptoHandler.exportPublicKey(t3)] : [2];
            }
          });
        });
      }, r10.prototype.setDeviceKeys = function(t3) {
        return Z(this, void 0, void 0, function() {
          var e2;
          return $(this, function(n2) {
            switch (n2.label) {
              case 0:
                return [4, this.dbStorage.setValue(this.deviceId, t3)];
              case 1:
                return e2 = n2.sent(), this.cachedDeviceKey = t3, [2, e2];
            }
          });
        });
      }, r10.prototype.associateDeviceKeys = function() {
        return Z(this, void 0, void 0, function() {
          var t3;
          return $(this, function(e2) {
            switch (e2.label) {
              case 0:
                return [4, this.cryptoHandler.generateKeys()];
              case 1:
                return t3 = e2.sent(), s5._POSignalsUtils.Logger.info("Associating new device domain keys"), [4, this.setDeviceKeys(t3)];
              case 2:
                return e2.sent(), [2, t3];
            }
          });
        });
      }, r10.prototype.signDeviceWithKeys = function(t3) {
        return Z(this, void 0, void 0, function() {
          var e2, n2, i9;
          return $(this, function(a5) {
            switch (a5.label) {
              case 0:
                return n2 = (e2 = this.cryptoHandler).signChallenge, i9 = [t3], [4, this.getDeviceKeys()];
              case 1:
                return [2, n2.apply(e2, i9.concat([a5.sent().privateKey, r10._default_salt]))];
            }
          });
        });
      }, r10.prototype.getDeviceKeys = function() {
        return Z(this, void 0, void 0, function() {
          var t3;
          return $(this, function(e2) {
            switch (e2.label) {
              case 0:
                return this.cachedDeviceKey ? [3, 2] : (t3 = this, [4, this.dbStorage.getValue(this.deviceId)]);
              case 1:
                t3.cachedDeviceKey = e2.sent(), e2.label = 2;
              case 2:
                return [2, this.cachedDeviceKey];
            }
          });
        });
      }, r10._default_salt = 32, r10;
    }();
    s5.DeviceKeys = h2;
  }(M2 || (M2 = {})), function(s5) {
    (function(h2) {
      var r10 = function() {
        function t3() {
          this._disabledStorage = [], this.assertionValues = [
            "BROWSER_ENGINE_VERSION",
            "NAVIGATOR_LANGUAGE",
            "OS_NAME",
            "OS_VERSION",
            "NAVIGATOR_USER_AGENT",
            "FINGER_PRINT",
            "RESOLUTION",
            "PUSH_NOTIFICATIONS_SUPPORTED",
            "COOKIES_ENABLED",
            "IS_INCOGNITO",
            "IS_PRIVATE_MODE"
          ];
          try {
            window.sessionStorage.setItem("_st_storage_enabled_check", "test"), window.sessionStorage.removeItem("_st_storage_enabled_check"), this.signalsSessionStorage = window.sessionStorage;
          } catch (e2) {
            s5._POSignalsUtils.Logger.warn("session storage disabled"), this._disabledStorage.push("sessionStorage"), this.signalsSessionStorage = new h2.StorageFallback();
          }
          try {
            window.localStorage.setItem("_st_storage_enabled_check", "test"), window.localStorage.removeItem("_st_storage_enabled_check"), this.signalsLocalStorage = new h2.StorageWrapper(window.localStorage);
          } catch (e2) {
            s5._POSignalsUtils.Logger.warn("local storage disabled"), this._disabledStorage.push("localStorage"), this.signalsLocalStorage = new h2.StorageWrapper(new h2.StorageFallback()), this.crossStorage = new h2.CrossStorageFallback(this.signalsLocalStorage);
          }
        }
        return t3.prototype.setStorageConfig = function(e2) {
          this.disableHub = e2.disableHub, this.hubUrl = e2.hubUrl, this.universalTrustEnabled = this.isUniversalTrustEnabled(
            e2.universalDeviceIdentification
          ), this.devEnv = e2.devEnv;
        }, Object.defineProperty(t3, "instance", {
          get: function() {
            return t3._instance || (t3._instance = new t3()), t3._instance;
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3.prototype, "tabUUID", {
          get: function() {
            var e2 = this.signalsSessionStorage.getItem(
              s5._POSignalsUtils.Constants.TAB_UUID_KEY
            );
            return e2 || (e2 = s5._POSignalsUtils.Util.newGuid(), this.signalsSessionStorage.setItem(
              s5._POSignalsUtils.Constants.TAB_UUID_KEY,
              e2
            )), e2;
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3.prototype, "ops", {
          get: function() {
            var e2 = Number(
              this.signalsSessionStorage.getItem(s5._POSignalsUtils.Constants.OPS_KEY)
            );
            return isNaN(e2) ? null : e2;
          },
          set: function(e2) {
            e2 ? this.signalsSessionStorage.setItem(
              s5._POSignalsUtils.Constants.OPS_KEY,
              e2.toString()
            ) : this.signalsSessionStorage.removeItem(s5._POSignalsUtils.Constants.OPS_KEY);
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3.prototype, "disabledStorage", {
          get: function() {
            return this._disabledStorage;
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3.prototype, "sessionStorage", {
          get: function() {
            return this.signalsSessionStorage;
          },
          enumerable: false,
          configurable: true
        }), Object.defineProperty(t3.prototype, "localStorage", {
          get: function() {
            return this.signalsLocalStorage;
          },
          enumerable: false,
          configurable: true
        }), t3.prototype.initDeviceIdentity = function() {
          return Z(this, void 0, void 0, function() {
            var e2, n2, i9;
            return $(this, function(a5) {
              switch (a5.label) {
                case 0:
                  return (n2 = this.signalsLocalStorage.getItem(
                    s5._POSignalsUtils.Constants.DEVICE_ID_KEY
                  )) && (this.cachedDeviceId = n2), this.universalTrustEnabled ? (this.deviceTrust = { attestation: {}, dtts: (/* @__PURE__ */ new Date()).getTime() }, this.disableHub && (this.deviceTrust.hubDisabled = true), i9 = this, [4, h2.IndexedDBStorage.initDB()]) : [3, 3];
                case 1:
                  return i9.indexedDBStorage = a5.sent(), [4, this.loadLocalDeviceTrust()];
                case 2:
                  e2 = a5.sent(), a5.label = 3;
                case 3:
                  return this.disableHub || n2 && !this.shouldFallbackToP1Key(e2) ? [3, 5] : [4, this.fallbackToCrossStorage(this.hubUrl)];
                case 4:
                  return a5.sent(), [3, 6];
                case 5:
                  this.crossStorage = new h2.CrossStorageFallback(this.signalsLocalStorage), a5.label = 6;
                case 6:
                  return this.getDeviceId() ? [3, 8] : [4, this.associateDeviceDetails(this.disableHub)];
                case 7:
                  a5.sent(), a5.label = 8;
                case 8:
                  return !this.universalTrustEnabled || this.getDeviceId() && e2 ? [3, 10] : [4, this.createDomainKeys(this.disableHub)];
                case 9:
                  a5.sent(), a5.label = 10;
                case 10:
                  return [2, this.getDeviceId()];
              }
            });
          });
        }, t3.prototype.shouldFallbackToP1Key = function(e2) {
          return this.universalTrustEnabled && !this.disableHub && (!e2 || this.isRefreshRequired(this.deviceKeyRsyncIntervals));
        }, t3.prototype.isRefreshRequired = function(e2) {
          if (e2 === void 0 && (e2 = 3), !this.deviceTrust.dtts)
            return true;
          var n2 = this.signalsLocalStorage.getItem(
            s5._POSignalsUtils.Constants.LAST_DEVICE_KEY_RESYNC
          );
          if (!n2 || isNaN(parseInt(n2)))
            return true;
          var i9 = this.deviceTrust.dtts - n2 > 864e5 * e2;
          return i9 && s5._POSignalsUtils.Logger.debug("Refresh required"), i9;
        }, t3.prototype.loadLocalDeviceTrust = function() {
          return Z(this, void 0, void 0, function() {
            var e2, n2;
            return $(this, function(i9) {
              switch (i9.label) {
                case 0:
                  return i9.trys.push([0, 4, , 5]), this.cachedDeviceId ? this.cachedDeviceId ? (this.domainDeviceKeys = new s5.DeviceKeys(
                    this.getDeviceId(),
                    this.indexedDBStorage,
                    new s5._POSignalsUtils.CryptoOperator()
                  ), [4, this.domainDeviceKeys.getDeviceKeys()]) : [3, 3] : (s5._POSignalsUtils.Logger.debug(
                    "No device id found on customer domain"
                  ), [2, false]);
                case 1:
                  return i9.sent() ? (e2 = this.deviceTrust.attestation, [4, this.domainDeviceKeys.getExportedPublicKey()]) : (s5._POSignalsUtils.Logger.debug(
                    "No device keys found on customer domain"
                  ), [2, false]);
                case 2:
                  return e2.deviceKey = i9.sent(), this.crossStorage = new h2.CrossStorageFallback(this.signalsLocalStorage), [2, true];
                case 3:
                  return [3, 5];
                case 4:
                  return n2 = i9.sent(), s5._POSignalsUtils.Logger.error("Domain PKI initialization failed", n2), [2, false];
                case 5:
                  return [2];
              }
            });
          });
        }, t3.prototype.createDomainKeys = function(e2) {
          return Z(this, void 0, void 0, function() {
            var n2, i9;
            return $(this, function(a5) {
              switch (a5.label) {
                case 0:
                  return a5.trys.push([0, 3, , 4]), !e2 && this._disabledStorage.lastIndexOf("hub") > -1 ? (s5._POSignalsUtils.Logger.debug(
                    "Hub unavailable - skipping domain trust creation"
                  ), [2]) : (this.domainDeviceKeys = new s5.DeviceKeys(
                    this.getDeviceId(),
                    this.indexedDBStorage,
                    new s5._POSignalsUtils.CryptoOperator()
                  ), [4, this.domainDeviceKeys.associateDeviceKeys()]);
                case 1:
                  return a5.sent(), n2 = this.deviceTrust.attestation, [4, this.domainDeviceKeys.getExportedPublicKey()];
                case 2:
                  return n2.deviceKey = a5.sent(), [3, 4];
                case 3:
                  return i9 = a5.sent(), s5._POSignalsUtils.Logger.error("Domain PKI initialization failed", i9), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }, t3.prototype.getDeviceId = function() {
          return this.cachedDeviceId;
        }, t3.prototype.associateDeviceDetails = function(e2) {
          var n2, i9;
          return Z(this, void 0, void 0, function() {
            var a5;
            return $(this, function(u4) {
              switch (u4.label) {
                case 0:
                  return s5._POSignalsUtils.Logger.debug("Associating fresh device details"), this.cachedDeviceId = "Id-" + s5._POSignalsUtils.Util.newGuid(), this.signalsLocalStorage.setItem(
                    s5._POSignalsUtils.Constants.DEVICE_ID_KEY,
                    this.cachedDeviceId
                  ), e2 ? [3, 4] : this.universalTrustEnabled ? (a5 = this.deviceTrust.attestation, [
                    4,
                    this.crossStorage.setDeviceDetails(
                      s5._POSignalsUtils.Constants.DEVICE_ID_KEY,
                      this.cachedDeviceId
                    )
                  ]) : [3, 2];
                case 1:
                  return a5.fallbackDeviceKey = u4.sent()[0], [3, 4];
                case 2:
                  return [
                    4,
                    this.crossStorage.set(
                      s5._POSignalsUtils.Constants.DEVICE_ID_KEY,
                      this.cachedDeviceId
                    )
                  ];
                case 3:
                  u4.sent(), u4.label = 4;
                case 4:
                  return s5._POSignalsUtils.Logger.debug(
                    "PingOne Signals deviceId: " + this.cachedDeviceId
                  ), [
                    2,
                    [
                      this.cachedDeviceId,
                      (i9 = (n2 = this.deviceTrust) === null || n2 === void 0 ? void 0 : n2.attestation) === null || i9 === void 0 ? void 0 : i9.fallbackDeviceKey
                    ]
                  ];
              }
            });
          });
        }, t3.prototype.addAssertion = function(e2) {
          return Z(this, void 0, void 0, function() {
            var n2, i9, a5, u4, c5, l2, d4;
            return $(this, function(p4) {
              switch (p4.label) {
                case 0:
                  if (p4.trys.push([0, 5, 6, 7]), !this.universalTrustEnabled || !this.deviceTrust.attestation.deviceKey && !this.deviceTrust.attestation.fallbackDeviceKey)
                    return [2];
                  for (n2 = (n2 = e2.deviceId).concat("-" + e2.deviceType), i9 = 0, a5 = this.assertionValues; i9 < a5.length; i9++)
                    u4 = a5[i9], e2[u4] != null && e2[u4] != null && (n2 = n2.concat("-" + e2[u4]));
                  return n2 = n2.concat("-" + this.deviceTrust.dtts), s5._POSignalsUtils.Logger.debug("Device identityContract " + n2), this.deviceTrust.attestation.fallbackDeviceKey && this.crossStorage ? (c5 = this.deviceTrust.attestation, [4, this.crossStorage.getSignedPayload(n2, this.getDeviceId())]) : [3, 2];
                case 1:
                  return c5.deviceToken = p4.sent()[1], this.signalsLocalStorage.setItem(
                    s5._POSignalsUtils.Constants.LAST_DEVICE_KEY_RESYNC,
                    (/* @__PURE__ */ new Date()).getTime()
                  ), [3, 4];
                case 2:
                  return l2 = this.deviceTrust.attestation, [4, this.domainDeviceKeys.signDeviceWithKeys(n2)];
                case 3:
                  l2.deviceToken = p4.sent(), p4.label = 4;
                case 4:
                  return [3, 7];
                case 5:
                  return d4 = p4.sent(), s5._POSignalsUtils.Logger.warn("Device attestation failed:", d4), [3, 7];
                case 6:
                  return this.universalTrustEnabled && s5._POSignalsUtils.Logger.info(
                    "Device attestation " + JSON.stringify(this.deviceTrust, null, 2)
                  ), [7];
                case 7:
                  return [2];
              }
            });
          });
        }, t3.prototype.closeTrustStore = function() {
          try {
            this.crossStorage.close(this.devEnv), this.indexedDBStorage && this.indexedDBStorage.close();
          } catch (e2) {
            s5._POSignalsUtils.Logger.info("Unable to close trust store:", e2);
          }
        }, t3.prototype.fallbackToCrossStorage = function(e2) {
          return Z(this, void 0, void 0, function() {
            var n2;
            return $(this, function(i9) {
              switch (i9.label) {
                case 0:
                  s5._POSignalsUtils.Logger.debug(
                    "PingOne Signals cross storage is required, initializing"
                  ), i9.label = 1;
                case 1:
                  return i9.trys.push([1, 3, , 4]), [4, this.initCrossStorage(e2)];
                case 2:
                  return i9.sent(), s5._POSignalsUtils.Logger.info("PingOne Signals cross storage initiated"), [3, 4];
                case 3:
                  return n2 = i9.sent(), s5._POSignalsUtils.Logger.warn(
                    "PingOne Signals Session crossStorage failed to connect " + n2
                  ), this._disabledStorage.push("hub"), this.crossStorage = new h2.CrossStorageFallback(this.signalsLocalStorage), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }, t3.prototype.initCrossStorage = function(e2) {
          return Z(this, void 0, void 0, function() {
            var n2, i9, a5, u4, c5;
            return $(this, function(l2) {
              switch (l2.label) {
                case 0:
                  return n2 = this.universalTrustEnabled ? "1.0.7" : "1.0.1", i9 = "https://apps.pingone.com/signals/web-sdk/hub-" + n2 + "/hub.html", (a5 = ((e2 == null ? void 0 : e2.trim()) || i9).replace(
                    /\/$/,
                    ""
                  )).endsWith("html") || (a5 += "/hub.html"), this.crossStorage = new h2.CrossStorage(a5, { timeout: 2e3 }), [4, this.crossStorage.onConnect()];
                case 1:
                  return l2.sent(), this.universalTrustEnabled ? [
                    4,
                    this.crossStorage.getDeviceDetails(
                      s5._POSignalsUtils.Constants.DEVICE_ID_KEY
                    )
                  ] : [3, 3];
                case 2:
                  return u4 = l2.sent(), this.cachedDeviceId = u4[0], [3, 5];
                case 3:
                  return c5 = this, [4, this.crossStorage.get(s5._POSignalsUtils.Constants.DEVICE_ID_KEY)];
                case 4:
                  c5.cachedDeviceId = l2.sent(), l2.label = 5;
                case 5:
                  return this.cachedDeviceId ? this.signalsLocalStorage.setItem(
                    s5._POSignalsUtils.Constants.DEVICE_ID_KEY,
                    this.cachedDeviceId
                  ) : s5._POSignalsUtils.Logger.info("no device id from hub"), this.universalTrustEnabled && (u4 && u4[1] ? (this.deviceTrust.attestation.fallbackDeviceKey = u4[1], s5._POSignalsUtils.Logger.info(
                    "Using fallback device keys from hub " + this.deviceTrust.attestation.fallbackDeviceKey
                  )) : s5._POSignalsUtils.Logger.info("failed to use any device keys")), [2];
              }
            });
          });
        }, t3.prototype.isUniversalTrustEnabled = function(e2) {
          return e2 != null && (typeof e2 == "boolean" ? e2 : typeof e2 == "string" && e2.toLowerCase() === "true");
        }, t3;
      }();
      h2.SessionStorage = r10;
    })(s5._POSignalsStorage || (s5._POSignalsStorage = {}));
  }(M2 || (M2 = {})), function(s5) {
    (function(h2) {
      var r10 = function() {
        function e2(n2) {
          this.storage = n2;
        }
        return e2.prototype.getItem = function(n2) {
          var i9 = s5._POSignalsUtils.Util.hash(n2), a5 = this.storage.getItem(i9);
          return a5 || (a5 = this.storage.getItem(n2)) && (this.storage.setItem(i9, a5), this.storage.removeItem(n2)), a5;
        }, e2.prototype.removeItem = function(n2) {
          return this.storage.removeItem(s5._POSignalsUtils.Util.hash(n2));
        }, e2.prototype.setItem = function(n2, i9) {
          return this.storage.setItem(s5._POSignalsUtils.Util.hash(n2), i9);
        }, e2;
      }();
      h2.StorageWrapper = r10;
      var t3 = function() {
        function e2() {
          this.internalStorageMap = /* @__PURE__ */ new Map();
        }
        return e2.prototype.getItem = function(n2) {
          return this.internalStorageMap.get(n2);
        }, e2.prototype.removeItem = function(n2) {
          this.internalStorageMap.delete(n2);
        }, e2.prototype.setItem = function(n2, i9) {
          this.internalStorageMap.set(n2, i9);
        }, e2;
      }();
      h2.StorageFallback = t3;
    })(s5._POSignalsStorage || (s5._POSignalsStorage = {}));
  }(M2 || (M2 = {})), ve = function() {
    return (ve = Object.assign || function(s5) {
      for (var h2, r10 = 1, t3 = arguments.length; r10 < t3; r10++)
        for (var e2 in h2 = arguments[r10])
          Object.prototype.hasOwnProperty.call(h2, e2) && (s5[e2] = h2[e2]);
      return s5;
    }).apply(this, arguments);
  }, Z = function(s5, h2, r10, t3) {
    return new (r10 || (r10 = Promise))(function(e2, n2) {
      function i9(c5) {
        try {
          u4(t3.next(c5));
        } catch (l2) {
          n2(l2);
        }
      }
      function a5(c5) {
        try {
          u4(t3.throw(c5));
        } catch (l2) {
          n2(l2);
        }
      }
      function u4(c5) {
        var l2;
        c5.done ? e2(c5.value) : (l2 = c5.value, l2 instanceof r10 ? l2 : new r10(function(d4) {
          d4(l2);
        })).then(i9, a5);
      }
      u4((t3 = t3.apply(s5, h2 || [])).next());
    });
  }, $ = function(s5, h2) {
    var r10, t3, e2, n2, i9 = {
      label: 0,
      sent: function() {
        if (1 & e2[0])
          throw e2[1];
        return e2[1];
      },
      trys: [],
      ops: []
    };
    return n2 = { next: a5(0), throw: a5(1), return: a5(2) }, typeof Symbol == "function" && (n2[Symbol.iterator] = function() {
      return this;
    }), n2;
    function a5(u4) {
      return function(c5) {
        return function(l2) {
          if (r10)
            throw new TypeError("Generator is already executing.");
          for (; i9; )
            try {
              if (r10 = 1, t3 && (e2 = 2 & l2[0] ? t3.return : l2[0] ? t3.throw || ((e2 = t3.return) && e2.call(t3), 0) : t3.next) && !(e2 = e2.call(t3, l2[1])).done)
                return e2;
              switch (t3 = 0, e2 && (l2 = [2 & l2[0], e2.value]), l2[0]) {
                case 0:
                case 1:
                  e2 = l2;
                  break;
                case 4:
                  return i9.label++, { value: l2[1], done: false };
                case 5:
                  i9.label++, t3 = l2[1], l2 = [0];
                  continue;
                case 7:
                  l2 = i9.ops.pop(), i9.trys.pop();
                  continue;
                default:
                  if (!(e2 = (e2 = i9.trys).length > 0 && e2[e2.length - 1]) && (l2[0] === 6 || l2[0] === 2)) {
                    i9 = 0;
                    continue;
                  }
                  if (l2[0] === 3 && (!e2 || l2[1] > e2[0] && l2[1] < e2[3])) {
                    i9.label = l2[1];
                    break;
                  }
                  if (l2[0] === 6 && i9.label < e2[1]) {
                    i9.label = e2[1], e2 = l2;
                    break;
                  }
                  if (e2 && i9.label < e2[2]) {
                    i9.label = e2[2], i9.ops.push(l2);
                    break;
                  }
                  e2[2] && i9.ops.pop(), i9.trys.pop();
                  continue;
              }
              l2 = h2.call(s5, i9);
            } catch (d4) {
              l2 = [6, d4], t3 = 0;
            } finally {
              r10 = e2 = 0;
            }
          if (5 & l2[0])
            throw l2[1];
          return { value: l2[0] ? l2[1] : void 0, done: true };
        }([u4, c5]);
      };
    }
  }, function(s5) {
    (function(h2) {
      var r10 = function() {
        function t3() {
        }
        return t3.prototype.isCanvasSupported = function() {
          var e2 = document.createElement("canvas");
          return !(!e2.getContext || !e2.getContext("2d"));
        }, t3.prototype.getWebglCanvas = function(e2) {
          var n2 = document.createElement("canvas"), i9 = null;
          try {
            i9 = e2 === "webgl" ? n2.getContext("webgl") || n2.getContext("experimental-webgl") : n2.getContext("webgl2");
          } catch (e3) {
          }
          return i9 || (i9 = null), i9;
        }, t3.prototype.isWebGlSupported = function(e2) {
          if (!this.isCanvasSupported())
            return false;
          var n2 = this.getWebglCanvas(e2);
          return (e2 === "webgl" ? !!window.WebGLRenderingContext : !!window.WebGL2RenderingContext) && !!n2;
        }, t3.prototype.isWebGl = function(e2) {
          return !!this.isWebGlSupported(e2) && !!this.getWebglCanvas(e2);
        }, t3.prototype.getWebglVendorAndRenderer = function(e2) {
          try {
            if (this.isWebGlSupported(e2)) {
              var n2 = this.getWebglCanvas(e2), i9 = n2.getExtension("WEBGL_debug_renderer_info");
              return n2.getParameter(i9.UNMASKED_VENDOR_WEBGL) + "~" + n2.getParameter(i9.UNMASKED_RENDERER_WEBGL);
            }
          } catch (e3) {
          }
          return null;
        }, t3.prototype.getHasLiedLanguages = function() {
          if (navigator.languages !== void 0)
            try {
              if (navigator.languages[0].substr(0, 2) !== navigator.language.substr(0, 2))
                return true;
            } catch (e2) {
              return true;
            }
          return false;
        }, t3.prototype.getHasLiedResolution = function() {
          return window.screen.width < window.screen.availWidth || window.screen.height < window.screen.availHeight;
        }, t3.prototype.getHasLiedOs = function() {
          var e2, n2 = navigator.userAgent.toLowerCase(), i9 = navigator.oscpu, a5 = navigator.platform.toLowerCase();
          return e2 = n2.indexOf("windows phone") >= 0 ? "Windows Phone" : n2.indexOf("win") >= 0 ? "Windows" : n2.indexOf("android") >= 0 ? "Android" : n2.indexOf("linux") >= 0 || n2.indexOf("cros") >= 0 ? "Linux" : n2.indexOf("iphone") >= 0 || n2.indexOf("ipad") >= 0 ? "iOS" : n2.indexOf("mac") >= 0 ? "Mac" : "Other", ("ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) && e2 !== "Windows Phone" && e2 !== "Android" && e2 !== "iOS" && e2 !== "Other" || i9 !== void 0 && ((i9 = i9.toLowerCase()).indexOf("win") >= 0 && e2 !== "Windows" && e2 !== "Windows Phone" || i9.indexOf("linux") >= 0 && e2 !== "Linux" && e2 !== "Android" || i9.indexOf("mac") >= 0 && e2 !== "Mac" && e2 !== "iOS" || (i9.indexOf("win") === -1 && i9.indexOf("linux") === -1 && i9.indexOf("mac") === -1) != (e2 === "Other")) ? true : a5.indexOf("win") >= 0 && e2 !== "Windows" && e2 !== "Windows Phone" || (a5.indexOf("linux") >= 0 || a5.indexOf("android") >= 0 || a5.indexOf("pike") >= 0) && e2 !== "Linux" && e2 !== "Android" || (a5.indexOf("mac") >= 0 || a5.indexOf("ipad") >= 0 || a5.indexOf("ipod") >= 0 || a5.indexOf("iphone") >= 0) && e2 !== "Mac" && e2 !== "iOS" || (a5.indexOf("win") < 0 && a5.indexOf("linux") < 0 && a5.indexOf("mac") < 0 && a5.indexOf("iphone") < 0 && a5.indexOf("ipad") < 0) != (e2 === "Other") || navigator.plugins === void 0 && e2 !== "Windows" && e2 !== "Windows Phone";
        }, t3.prototype.getHasLiedBrowser = function() {
          var e2, n2 = navigator.userAgent.toLowerCase(), i9 = navigator.productSub;
          if (((e2 = n2.indexOf("firefox") >= 0 ? "Firefox" : n2.indexOf("opera") >= 0 || n2.indexOf("opr") >= 0 ? "Opera" : n2.indexOf("chrome") >= 0 ? "Chrome" : n2.indexOf("safari") >= 0 ? "Safari" : n2.indexOf("trident") >= 0 ? "Internet Explorer" : "Other") == "Chrome" || e2 === "Safari" || e2 === "Opera") && i9 !== "20030107")
            return true;
          var a5, u4 = eval.toString().length;
          if (u4 === 37 && e2 !== "Safari" && e2 !== "Firefox" && e2 !== "Other" || u4 === 39 && e2 !== "Internet Explorer" && e2 !== "Other" || u4 === 33 && e2 !== "Chrome" && e2 !== "Opera" && e2 !== "Other")
            return true;
          try {
            throw "a";
          } catch (c5) {
            try {
              c5.toSource(), a5 = true;
            } catch (e3) {
              a5 = false;
            }
          }
          return a5 && e2 !== "Firefox" && e2 !== "Other";
        }, t3;
      }();
      h2.FingerprintLegacyMetadata = r10;
    })(s5._POSignalsMetadata || (s5._POSignalsMetadata = {}));
  }(M2 || (M2 = {})), function(s5) {
    (function(h2) {
      var r10 = function() {
        function t3(e2, n2) {
          this.sessionData = e2, this.metadataParams = n2, this.deviceId = null, this.hasMicrophone = null, this.hasSpeakers = null, this.hasWebcam = null, this.isBatterySupported = null, this.batteryLevel = null, this.batteryCharging = null, this.batteryChargingTime = null, this.batteryDischargingTime = null, this.headlessTests = /* @__PURE__ */ new Map(), this.lieTests = {}, this.gpsSupported = null, this.fingerPrintComponentKeys = /* @__PURE__ */ new Set([
            "navigatorPlatform",
            "colorDepth",
            "deviceMemory",
            "pixelRatio",
            "hardwareConcurrency",
            "screenResolution",
            "availableScreenResolution",
            "timezoneOffset",
            "timezone",
            "sessionStorage",
            "localStorage",
            "indexedDB",
            "addBehavior",
            "openDatabase",
            "cpuClass",
            "platform",
            "canvas",
            "adBlock",
            "touchSupport",
            "fonts",
            "audio",
            "osCpu",
            "productSub",
            "emptyEvalLength",
            "errorFF",
            "chrome",
            "cookiesEnabled"
          ]), this.webGlStatus = -1, this.numberOfVideoDevices = 0, this.numberOfAudioDevices = 0, this.videoInputDevices = [], this.audioInputDevices = [], this.audioOutputDevices = [], this.webRtcIps = /* @__PURE__ */ new Map(), this.lastCalculatedMetadata = null, this.metadataQueue = new s5.PromiseQueue(1);
        }
        return Object.defineProperty(t3.prototype, "OPS", {
          get: function() {
            if (!this.metadataParams.browserInfo.isIphoneOrIPad)
              return 0;
            var e2 = this.sessionData.ops;
            return e2 || (e2 = this.getOps(), this.sessionData.ops = e2), e2;
          },
          enumerable: false,
          configurable: true
        }), t3.prototype.getDeviceAttributes = function() {
          return Z(this, void 0, void 0, function() {
            var e2 = this;
            return $(this, function(n2) {
              return [
                2,
                this.metadataQueue.add(function() {
                  return Z(e2, void 0, void 0, function() {
                    var i9;
                    return $(this, function(a5) {
                      switch (a5.label) {
                        case 0:
                          return this.lastCalculatedMetadata ? [3, 3] : (i9 = this, [4, this.calculateDeviceMetadata()]);
                        case 1:
                          return i9.lastCalculatedMetadata = a5.sent(), s5._POSignalsUtils.Logger.info("calculated device attributes."), s5._POSignalsUtils.Logger.info(
                            "PingOne Signals deviceId: " + this.deviceId
                          ), [4, this.sessionData.addAssertion(this.lastCalculatedMetadata)];
                        case 2:
                          a5.sent(), this.sessionData.closeTrustStore(), a5.label = 3;
                        case 3:
                          return [2, this.lastCalculatedMetadata];
                      }
                    });
                  });
                })
              ];
            });
          });
        }, t3.prototype.getObfsInfo = function() {
          return { identifier: "x1", key: "Xq7tSbjB517mhZwt" };
        }, t3.prototype.calculateDeviceMetadata = function() {
          return Z(this, void 0, void 0, function() {
            var e2, n2, i9, a5, u4;
            return $(this, function(c5) {
              switch (c5.label) {
                case 0:
                  return this.gpsSupported = navigator.geolocation != null, e2 = this.metadataParams.metadataBlackList, n2 = [
                    this.sessionData.initDeviceIdentity().catch(function(l2) {
                      s5._POSignalsUtils.Logger.warn("failed to get deviceId info", l2);
                    }),
                    this.getFingerPrint(e2).catch(function(l2) {
                      s5._POSignalsUtils.Logger.warn(
                        "failed to get fingerprint info",
                        l2.message
                      );
                    }),
                    this.getPrivateMode().catch(function(l2) {
                      return s5._POSignalsUtils.Logger.warn("failed to get incognito info", l2);
                    }),
                    h2.Incognito.isPrivateMode().catch(function(l2) {
                      return s5._POSignalsUtils.Logger.warn(
                        "failed to get private mode info",
                        l2
                      );
                    }),
                    this.getPermissionsMetadata().catch(function(l2) {
                      return s5._POSignalsUtils.Logger.warn(
                        "failed to get permissions info",
                        l2
                      );
                    }),
                    new h2.DetectHeadless(e2).getHeadlessResults().catch(function(l2) {
                      return s5._POSignalsUtils.Logger.warn(
                        "failed to get headless results",
                        l2
                      );
                    }),
                    new h2.DetectLies(e2).getAllLies().catch(function(l2) {
                      return s5._POSignalsUtils.Logger.warn("failed to get lies results", l2);
                    }),
                    this.audioIntVideoInit().catch(function(l2) {
                      return s5._POSignalsUtils.Logger.warn(
                        "failed to get audio-video info",
                        l2
                      );
                    }),
                    this.batteryInit().catch(function(l2) {
                      return s5._POSignalsUtils.Logger.warn("failed to get battery info", l2);
                    })
                  ], [4, Promise.all(n2)];
                case 1:
                  return u4 = c5.sent(), this.deviceId = u4[0], this.fingerPrint = u4[1], this.isPrivateMode = u4[2], this.isPrivateModeV2 = u4[3], this.permissions = u4[4], this.headlessTests = u4[5], this.lieTests = u4[6], i9 = {
                    ops: this.OPS,
                    devicePixelRatio: window.devicePixelRatio,
                    screenWidth: window.screen.width,
                    screenHeight: window.screen.height
                  }, s5._POSignalsUtils.Util.extendPrimitiveValues(i9, screen, false), a5 = [
                    {
                      deviceId: this.deviceId,
                      deviceType: this.metadataParams.browserInfo.deviceType,
                      osVersion: (this.metadataParams.browserInfo.osName + " " + this.metadataParams.browserInfo.osVersion).trim() || ""
                    }
                  ], [4, this.getIdentificationMetadata(e2)];
                case 2:
                  return [
                    2,
                    ve.apply(void 0, [
                      ve.apply(void 0, [
                        ve.apply(void 0, [
                          ve.apply(void 0, a5.concat([c5.sent()])),
                          this.getIoMetadata()
                        ]),
                        this.getSensorsMetadata()
                      ]),
                      i9
                    ])
                  ];
              }
            });
          });
        }, t3.prototype.batteryInit = function() {
          return Z(this, void 0, void 0, function() {
            var e2, n2 = this;
            return $(this, function(i9) {
              switch (i9.label) {
                case 0:
                  return e2 = this, [
                    4,
                    s5._POSignalsUtils.Util.promiseTimeout(
                      50,
                      new Promise(function(a5, u4) {
                        navigator.getBattery ? (n2.isBatterySupported = true, navigator.getBattery().then(function(c5) {
                          c5 && (e2.batteryLevel = c5.level, e2.batteryCharging = c5.charging, e2.batteryChargingTime = c5.chargingTime, e2.batteryDischargingTime = c5.dischargingTime), a5();
                        }).catch(function(c5) {
                          s5._POSignalsUtils.Logger.warn("Battery " + c5), a5();
                        })) : (s5._POSignalsUtils.Logger.debug("Battery not supported!"), a5());
                      })
                    )
                  ];
                case 1:
                  return i9.sent(), [2];
              }
            });
          });
        }, t3.prototype.enumerateDevicesEnabled = function() {
          var e2 = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          return !s5._POSignalsUtils.Util.inIframe() || !e2;
        }, t3.prototype.getRTCPeerConnection = function() {
          var e2 = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
          if (!e2) {
            var n2 = window["iframe.contentWindow"];
            n2 && (e2 = n2.RTCPeerConnection || n2.mozRTCPeerConnection || n2.webkitRTCPeerConnection);
          }
          return e2;
        }, t3.prototype.collectWebRtc = function() {
          var e2 = this;
          try {
            var n2 = {}, i9 = this.getRTCPeerConnection(), a5 = new i9(
              { iceServers: [{ urls: this.metadataParams.webRtcUrl.trim() }] },
              { optional: [{ RtpDataChannels: true }] }
            );
            a5.onicecandidate = function(u4) {
              if (u4.candidate) {
                var c5 = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec(
                  u4.candidate.candidate
                )[1];
                n2[c5] === void 0 && (u4.candidate.candidate.indexOf("host") > 0 ? e2.webRtcIps.set("WEB_RTC_HOST_IP", c5) : u4.candidate.candidate.indexOf("srflx") > 0 && e2.webRtcIps.set("WEB_RTC_SRFLX_IP", c5)), n2[c5] = true;
              }
            }, a5.createDataChannel(""), a5.createOffer(
              function(u4) {
                a5.setLocalDescription(
                  u4,
                  function() {
                  },
                  function() {
                  }
                );
              },
              function() {
              }
            );
          } catch (e3) {
          }
        }, t3.prototype.audioIntVideoInit = function() {
          return Z(this, void 0, void 0, function() {
            var e2, n2 = this;
            return $(this, function(i9) {
              switch (i9.label) {
                case 0:
                  return e2 = this, [
                    4,
                    s5._POSignalsUtils.Util.promiseTimeout(
                      50,
                      new Promise(function(a5, u4) {
                        return n2.enumerateDevicesEnabled() ? navigator.mediaDevices && navigator.mediaDevices.enumerateDevices ? void navigator.mediaDevices.enumerateDevices().then(function(c5) {
                          c5.forEach(function(l2) {
                            l2.kind && (l2.kind.toLowerCase() == "audioinput" ? (e2.hasMicrophone = true, e2.numberOfAudioDevices++, l2.label && e2.audioInputDevices.push(l2.label)) : l2.kind.toLowerCase() == "videoinput" ? (e2.hasWebcam = true, e2.numberOfVideoDevices++, l2.label && e2.videoInputDevices.push(l2.label)) : l2.kind.toLowerCase() == "audiooutput" && (e2.hasSpeakers = true, e2.numberOfAudioDevices++, l2.label && e2.audioOutputDevices.push(l2.label)));
                          }), a5();
                        }).catch(function(c5) {
                          s5._POSignalsUtils.Logger.warn("enumerateDevices failed", c5), a5();
                        }) : (s5._POSignalsUtils.Logger.debug(
                          "enumerateDevices() not supported."
                        ), void a5()) : (s5._POSignalsUtils.Logger.debug(
                          "enumerateDevices() cannot run within safari iframe"
                        ), void a5());
                      })
                    )
                  ];
                case 1:
                  return i9.sent(), [2];
              }
            });
          });
        }, t3.prototype.getFingerPrint = function(e2) {
          return Z(this, void 0, void 0, function() {
            var n2, i9, a5 = this;
            return $(this, function(u4) {
              switch (u4.label) {
                case 0:
                  return e2.has("fingerprint") ? [2, Promise.resolve("")] : (n2 = new Promise(function(c5, l2) {
                    return Z(a5, void 0, void 0, function() {
                      var d4, p4;
                      return $(this, function(m) {
                        switch (m.label) {
                          case 0:
                            return m.trys.push([0, 3, , 4]), [4, s5.FingerprintJS.load()];
                          case 1:
                            return [4, m.sent().get()];
                          case 2:
                            return d4 = m.sent(), this.fingerPrint = d4.visitorId, this.fingerPrintComponents = d4.components, c5(d4.visitorId), [3, 4];
                          case 3:
                            return p4 = m.sent(), s5._POSignalsUtils.Logger.warn(
                              "Failed to get FingerPrint " + p4
                            ), l2({ err: p4, message: "FingerPrint failed" }), [3, 4];
                          case 4:
                            return [2];
                        }
                      });
                    });
                  }), i9 = new Promise(function(c5, l2) {
                    return Z(a5, void 0, void 0, function() {
                      return $(this, function(d4) {
                        switch (d4.label) {
                          case 0:
                            return [
                              4,
                              s5._POSignalsUtils.Util.delay(
                                this.metadataParams.fingerprintTimeoutMillis
                              )
                            ];
                          case 1:
                            return d4.sent(), l2({ message: "Fingerprint timeout" }), [2];
                        }
                      });
                    });
                  }), [4, Promise.race([n2, i9])]);
                case 1:
                  return [2, u4.sent()];
              }
            });
          });
        }, t3.prototype.getSensorsMetadata = function() {
          var e2 = {};
          return this.flatAndAddMetadata(e2, "DEDVCE_LIGHT_SUPPORTED", function() {
            return "ondevicelight" in window;
          }), this.flatAndAddMetadata(e2, "IS_TOUCH_DEVICE", function() {
            return "ontouchstart" in window;
          }), window.DeviceMotionEvent || this.flatAndAddMetadata(e2, "ACCELEROMETER_SUPPORTED", function() {
            return false;
          }), window.DeviceOrientationEvent || this.flatAndAddMetadata(e2, "GYROSCOPE_SUPPORTED", function() {
            return false;
          }), this.flatAndAddMetadata(e2, "PROXIMITY_SUPPORTED", function() {
            return "ondeviceproximity" in window;
          }), e2;
        }, t3.prototype.getIdentificationMetadata = function(e2) {
          return Z(this, void 0, void 0, function() {
            var n2, i9, a5, u4, c5, l2, d4, p4, m, k2, x, y3, C, A2, P2, D2, j, z2, B, T3, L2, E2 = this;
            return $(this, function(H2) {
              switch (H2.label) {
                case 0:
                  return n2 = this, i9 = {}, this.flatAndAddMetadata(i9, "FINGER_PRINT", function() {
                    return E2.fingerPrint;
                  }), this.metadataParams.browserInfo.userAgentData && (this.flatAndAddMetadata(i9, "OS_NAME", function() {
                    return E2.metadataParams.browserInfo.osName;
                  }), this.flatAndAddMetadata(i9, "OS_VERSION", function() {
                    return E2.metadataParams.browserInfo.osVersion;
                  })), this.metadataParams.browserInfo.userAgentData && (this.flatAndAddMetadata(i9, "DEVICE_MODEL", function() {
                    return E2.metadataParams.browserInfo.deviceModel;
                  }), this.flatAndAddMetadata(i9, "DEVICE_VENDOR", function() {
                    return E2.metadataParams.browserInfo.deviceVendor;
                  })), this.metadataParams.browserInfo.userAgentData && (this.flatAndAddMetadata(i9, "BROWSER_ENGINE_NAME", function() {
                    return E2.metadataParams.browserInfo.engineName;
                  }), this.flatAndAddMetadata(i9, "BROWSER_ENGINE_VERSION", function() {
                    return E2.metadataParams.browserInfo.engineVersion;
                  })), this.metadataParams.browserInfo.userAgentData && this.flatAndAddMetadata(i9, "CPU_ARCHITECTURE", function() {
                    return E2.metadataParams.browserInfo.cpuArchitecture;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_VENDOR", function() {
                    return navigator.vendor;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_PLUGINS_LENGTH", function() {
                    return navigator.plugins ? navigator.plugins.length : null;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_MIME_TYPES_LENGTH", function() {
                    return navigator.mimeTypes ? navigator.mimeTypes.length : null;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_LANGUAGE", function() {
                    return navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_LANGUAGES", function() {
                    return navigator.languages;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_MAX_TOUCH_POINTS", function() {
                    return navigator.maxTouchPoints || navigator.msMaxTouchPoints;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_POINTER_ENABLED", function() {
                    return navigator.pointerEnabled || navigator.msPointerEnabled;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_WEB_DRIVER", function() {
                    return navigator.webdriver;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_HARDWARE_CONCURRENCY", function() {
                    return navigator.hardwareConcurrency;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_VIBRATE", function() {
                    return navigator.vibrate != null;
                  }), this.flatAndAddMetadata(i9, "PUSH_NOTIFICATIONS_SUPPORTED", function() {
                    return "Notification" in window;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_APP_CODE_NAME", function() {
                    return navigator.appCodeName;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_APP_NAME", function() {
                    return navigator.appName;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_APP_VERSION", function() {
                    return navigator.appVersion;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_ON_LINE", function() {
                    return navigator.onLine;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_PLATFORM", function() {
                    return navigator.platform;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_PRODUCT", function() {
                    return navigator.product;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_USER_AGENT", function() {
                    return navigator.userAgent;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_PDF_VIEWER_ENABLED", function() {
                    return navigator.pdfViewerEnabled;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_DEVICE_MEMORY", function() {
                    return navigator.deviceMemory;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_CONNECTION_RTT", function() {
                    return navigator.connection ? navigator.connection.rtt : null;
                  }), e2.has("modernizr") ? [3, 2] : [4, this.safeAddModernizrFeatures(i9)];
                case 1:
                  H2.sent(), H2.label = 2;
                case 2:
                  if ((a5 = window._pingOneSignalsPingResult || window._ST_PING) ? this.flatAndAddMetadata(i9, "JS_CHALLENGE", function() {
                    return a5;
                  }) : this.flatAndAddMetadata(i9, "JS_CHALLENGE", function() {
                    return "unknown";
                  }), u4 = new h2.FingerprintLegacyMetadata(), this.flatAndAddMetadata(i9, "IS_WEBGL", function() {
                    return u4.isWebGl("webgl");
                  }), this.flatAndAddMetadata(i9, "WEBGLVENDORANDRENDERER", function() {
                    return u4.getWebglVendorAndRenderer("webgl");
                  }), this.flatAndAddMetadata(i9, "IS_WEBGL2", function() {
                    return u4.isWebGl("webgl2");
                  }), this.flatAndAddMetadata(i9, "WEBGL2VENDORANDRENDERER", function() {
                    return u4.getWebglVendorAndRenderer("webgl2");
                  }), this.flatAndAddMetadata(i9, "HASLIEDLANGUAGES", function() {
                    return u4.getHasLiedLanguages();
                  }), this.flatAndAddMetadata(i9, "HASLIEDRESOLUTION", function() {
                    return u4.getHasLiedResolution();
                  }), this.flatAndAddMetadata(i9, "HASLIEDOS", function() {
                    return u4.getHasLiedOs();
                  }), this.flatAndAddMetadata(i9, "HASLIEDBROWSER", function() {
                    return u4.getHasLiedBrowser();
                  }), this.fingerPrintComponents)
                    for (d4 in c5 = function(S) {
                      if (!l2.fingerPrintComponents.hasOwnProperty(S))
                        return "continue";
                      var U2 = l2.fingerPrintComponents[S];
                      S == "fonts" ? l2.flatAndAddMetadata(i9, "JS_FONTS", function() {
                        return U2.value.length;
                      }) : S == "canvas" ? l2.flatAndAddMetadata(i9, "IS_CANVAS", function() {
                        return U2.value != null;
                      }) : S == "screenResolution" && U2.value && U2.value.length ? l2.flatAndAddMetadata(i9, "RESOLUTION", function() {
                        return U2.value.join(",");
                      }) : S == "availableScreenResolution" && U2.value && U2.value.length ? l2.flatAndAddMetadata(i9, "AVAILABLE_RESOLUTION", function() {
                        return U2.value.join(",");
                      }) : S == "touchSupport" && U2.value ? l2.flatAndAddMetadata(i9, "TOUCH_SUPPORT", function() {
                        return U2.value;
                      }) : S == "audio" && U2.value ? l2.flatAndAddMetadata(i9, "AUDIO_FINGERPRINT", function() {
                        return U2.value;
                      }) : S == "osCpu" && U2.value ? l2.flatAndAddMetadata(i9, "OS_CPU", function() {
                        return U2.value;
                      }) : S == "productSub" && U2.value ? l2.flatAndAddMetadata(i9, "PRODUCT_SUB", function() {
                        return U2.value;
                      }) : S == "emptyEvalLength" && U2.value ? l2.flatAndAddMetadata(
                        i9,
                        "EMPTY_EVAL_LENGTH",
                        function() {
                          return U2.value;
                        }
                      ) : S == "errorFF" && U2.value ? l2.flatAndAddMetadata(i9, "ERROR_FF", function() {
                        return U2.value;
                      }) : S == "chrome" && U2.value ? l2.flatAndAddMetadata(i9, "CHROME", function() {
                        return U2.value;
                      }) : S == "cookiesEnabled" && U2.value ? l2.flatAndAddMetadata(
                        i9,
                        "COOKIES_ENABLED",
                        function() {
                          return U2.value;
                        }
                      ) : n2.fingerPrintComponentKeys.has(S) && S != null && l2.flatAndAddMetadata(
                        i9,
                        S.toUpperCase(),
                        function() {
                          return U2.value;
                        }
                      );
                    }, l2 = this, this.fingerPrintComponents)
                      c5(d4);
                  for (y3 in this.flatAndAddMetadata(i9, "IS_INCOGNITO", function() {
                    return E2.isPrivateMode;
                  }), this.flatAndAddMetadata(i9, "IS_PRIVATE_MODE", function() {
                    return E2.isPrivateModeV2;
                  }), this.flatAndAddMetadata(i9, "IS_WEB_GLSTATUS", function() {
                    return E2.webGlStatus;
                  }), p4 = {
                    selenium: navigator.webdriver || s5._POSignalsUtils.Util.getAttribute(
                      window.document.documentElement,
                      "webdriver"
                    ) || "",
                    phantomjs: {
                      _phantom: window._phantom || "",
                      __phantomas: window.__phantomas || "",
                      callPhantom: window.callPhantom || ""
                    },
                    nodejs: { Buffer: window.Buffer || "" },
                    couchjs: { emit: window.emit || "" },
                    rhino: { spawn: window.spawn || "" },
                    chromium: {
                      domAutomationController: window.domAutomationController || "",
                      domAutomation: window.domAutomation || ""
                    },
                    outerWidth: window.outerWidth,
                    outerHeight: window.outerHeight
                  }, this.flatAndAddMetadata(i9, "HEADLESS", function() {
                    return p4;
                  }), this.flatAndAddMetadata(i9, "HEADLESS", function() {
                    return E2.headlessTests;
                  }), this.flatAndAddMetadata(i9, "LIES", function() {
                    var S = {};
                    for (var U2 in E2.lieTests)
                      S[U2] = JSON.stringify(E2.lieTests[U2]);
                    return Object.keys(S).length > 0 ? S : null;
                  }), this.flatAndAddMetadata(i9, "STEALTH", function() {
                    return new h2.DetectStealth(e2).getStealthResult();
                  }), this.flatAndAddMetadata(i9, "REF_LINK", function() {
                    return document.referrer;
                  }), this.flatAndAddMetadata(i9, "PLUGINS", function() {
                    for (var S = { length: navigator.plugins.length, details: [] }, U2 = 0; U2 < S.length; U2++)
                      S.details.push({
                        length: navigator.plugins[U2].length,
                        name: navigator.plugins[U2].name,
                        version: navigator.plugins[U2].version,
                        filename: navigator.plugins[U2].filename
                      });
                    return S;
                  }), this.flatAndAddMetadata(i9, "AUDIO", function() {
                    return E2.numberOfAudioDevices;
                  }), this.flatAndAddMetadata(i9, "VIDEO", function() {
                    return E2.numberOfVideoDevices;
                  }), this.flatAndAddMetadata(i9, "VIDEO_INPUT_DEVICES", function() {
                    return E2.videoInputDevices.toString();
                  }), this.flatAndAddMetadata(i9, "AUDIO_INPUT_DEVICES", function() {
                    return E2.audioInputDevices.toString();
                  }), this.flatAndAddMetadata(i9, "AUDIO_OUTPUT_DEVICES", function() {
                    return E2.audioOutputDevices.toString();
                  }), this.flatAndAddMetadata(i9, "MEDIA_CODEC_MP4_AVC1", function() {
                    return E2.getMediaCodec('video/mp4;; codecs = "avc1.42E01E"');
                  }), this.flatAndAddMetadata(i9, "MEDIA_CODEC_X_M4A", function() {
                    return E2.getMediaCodec("audio/x-m4a");
                  }), this.flatAndAddMetadata(i9, "MEDIA_CODEC_AAC", function() {
                    return E2.getMediaCodec("audio/aac");
                  }), m = this.metadataParams.additionalMediaCodecs, k2 = function(S) {
                    if (!m.hasOwnProperty(S))
                      return "continue";
                    x.flatAndAddMetadata(i9, "MEDIA_CODEC_" + S, function() {
                      return E2.getMediaCodec(m[S]);
                    });
                  }, x = this, m)
                    k2(y3);
                  window.performance && window.performance.memory && (this.flatAndAddMetadata(i9, "MEMORY_HEAP_SIZE_LIMIT", function() {
                    return window.performance.memory.jsHeapSizeLimit;
                  }), this.flatAndAddMetadata(i9, "MEMORY_TOTAL_HEAP_SIZE", function() {
                    return window.performance.memory.totalJSHeapSize;
                  }), this.flatAndAddMetadata(i9, "MEMORY_USED_HEAP_SIZE", function() {
                    return window.performance.memory.usedJSHeapSize;
                  })), this.flatAndAddMetadata(i9, "IS_ACCEPT_COOKIES", function() {
                    return navigator.cookieEnabled;
                  }), this.flatAndAddMetadata(i9, "selenium_in_document", function() {
                    return h2.SeleniumProperties.seleniumInDocument();
                  }), this.flatAndAddMetadata(i9, "selenium_in_window", function() {
                    return h2.SeleniumProperties.seleniumInWindow();
                  }), this.flatAndAddMetadata(i9, "selenium_in_navigator", function() {
                    return h2.SeleniumProperties.seleniumInNavigator();
                  }), this.flatAndAddMetadata(i9, "selenium_sequentum", function() {
                    return h2.SeleniumProperties.seleniumSequentum();
                  }), this.flatAndAddMetadata(i9, "DOCUMENT_ELEMENT_SELENIUM", function() {
                    return s5._POSignalsUtils.Util.getAttribute(
                      window.document.documentElement,
                      "selenium"
                    );
                  }), this.flatAndAddMetadata(i9, "DOCUMENT_ELEMENT_WEBDRIVER", function() {
                    return s5._POSignalsUtils.Util.getAttribute(
                      window.document.documentElement,
                      "webdriver"
                    );
                  }), this.flatAndAddMetadata(i9, "DOCUMENT_ELEMENT_DRIVER", function() {
                    return s5._POSignalsUtils.Util.getAttribute(
                      window.document.documentElement,
                      "driver"
                    );
                  }), this.flatAndAddMetadata(i9, "window_html_webdriver", function() {
                    return !!s5._POSignalsUtils.Util.getAttribute(
                      document.getElementsByTagName("html")[0],
                      "webdriver"
                    );
                  }), this.flatAndAddMetadata(i9, "window_geb", function() {
                    return !!window.geb;
                  }), this.flatAndAddMetadata(i9, "window_awesomium", function() {
                    return !!window.awesomium;
                  }), this.flatAndAddMetadata(i9, "window_RunPerfTest", function() {
                    return !!window.RunPerfTest;
                  }), this.flatAndAddMetadata(i9, "window_fmget_targets", function() {
                    return !!window.fmget_targets;
                  }), this.flatAndAddMetadata(i9, "hasTrustToken", function() {
                    return "hasTrustToken" in document;
                  }), this.flatAndAddMetadata(i9, "trustTokenOperationError", function() {
                    return "trustTokenOperationError" in XMLHttpRequest.prototype;
                  }), this.flatAndAddMetadata(i9, "setTrustToken", function() {
                    return "setTrustToken" in XMLHttpRequest.prototype;
                  }), this.flatAndAddMetadata(i9, "trustToken", function() {
                    return "trustToken" in HTMLIFrameElement.prototype;
                  }), this.flatAndAddMetadata(i9, "localStorage.length", function() {
                    return localStorage.length;
                  }), this.flatAndAddMetadata(i9, "sessionStorage.length", function() {
                    return sessionStorage.length;
                  }), this.sessionData.disabledStorage.forEach(function(S) {
                    E2.flatAndAddMetadata(i9, S.toUpperCase() + "_FAILED", function() {
                      return true;
                    });
                  }), this.flatAndAddMetadata(i9, "WEB_RTC_ENABLED", function() {
                    return !!E2.getRTCPeerConnection();
                  }), this.metadataParams.webRtcUrl && this.metadataParams.webRtcUrl.length > 0 && (this.collectWebRtc(), this.webRtcIps.forEach(function(S, U2) {
                    U2 != null && S != null && E2.flatAndAddMetadata(i9, U2, function() {
                      return S;
                    });
                  }), this.webRtcIps.clear()), window.matchMedia && this.flatAndAddMetadata(i9, "MQ_SCREEN", function() {
                    var S = window.matchMedia(
                      "(min-width: " + (window.innerWidth - 1) + "px)"
                    );
                    return { matches: S.matches, media: S.media };
                  }), this.addIframeData(i9, e2), window.Notification && this.flatAndAddMetadata(i9, "NOTIFICATION_PERMISSION", function() {
                    return window.Notification.permission;
                  }), this.flatAndAddMetadata(i9, "HAS_CHROME_APP", function() {
                    return window.chrome && "app" in window.chrome;
                  }), this.flatAndAddMetadata(i9, "HAS_CHROME_CSI", function() {
                    return window.chrome && "csi" in window.chrome;
                  }), this.flatAndAddMetadata(i9, "HAS_CHROME_LOADTIMES", function() {
                    return window.chrome && "loadTimes" in window.chrome;
                  }), this.flatAndAddMetadata(i9, "HAS_CHROME_RUNTIME", function() {
                    return window.chrome && "runtime" in window.chrome;
                  }), this.flatAndAddMetadata(i9, "CHROMIUM_MATH", t3.detectChromium), this.addClientHints(i9), this.flatAndAddMetadata(i9, "NAVIGATOR_KEYBOARD_SUPPORTED", function() {
                    return !!navigator.keyboard;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_HID_SUPPORTED", function() {
                    return !!navigator.hid;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_SERIAL_SUPPORTED", function() {
                    return !!navigator.serial;
                  }), this.flatAndAddMetadata(i9, "NAVIGATOR_PRESENTATION_SUPPORTED", function() {
                    return !!navigator.presentation;
                  }), H2.label = 3;
                case 3:
                  return H2.trys.push([3, 6, , 7]), e2.has("floc") || !s5.Util.isFunction(document.interestCohort) ? [3, 5] : [4, s5.Util.promiseTimeout(100, document.interestCohort())];
                case 4:
                  C = H2.sent(), A2 = C.id, P2 = C.version, this.flatAndAddMetadata(i9, "floc_id", function() {
                    return A2;
                  }), this.flatAndAddMetadata(i9, "floc_version", function() {
                    return P2;
                  }), H2.label = 5;
                case 5:
                  return [3, 7];
                case 6:
                  return H2.sent(), [3, 7];
                case 7:
                  for (z2 in D2 = function(S) {
                    j.flatAndAddMetadata(i9, S, function() {
                      return s5._POSignalsUtils.Util.getProperty(
                        window,
                        E2.metadataParams.dataPoints[S]
                      );
                    });
                  }, j = this, this.metadataParams.dataPoints)
                    D2(z2);
                  for (T3 in B = this.metadataParams.propertyDescriptors)
                    B.hasOwnProperty(T3) && (L2 = T3 === "window" ? window : window[T3]) && this.addPropertyDescriptorInfo(
                      L2,
                      T3.toUpperCase() + "_PROPERTY_DESCRIPTOR",
                      B[T3],
                      i9
                    );
                  return [2, i9];
              }
            });
          });
        }, t3.prototype.addClientHints = function(e2) {
          try {
            var n2 = navigator.userAgentData;
            if (!n2)
              return;
            this.flatAndAddMetadata(e2, "NAVIGATOR_CLIENT_HINTS_PLATFORM", function() {
              return n2.platform;
            }), this.flatAndAddMetadata(e2, "NAVIGATOR_CLIENT_HINTS_MOBILE", function() {
              return n2.mobile;
            });
            var i9 = n2.brands;
            if (!i9)
              return;
            for (var a5 = function(l2) {
              if (i9[l2].hasOwnProperty("brand") && i9[l2].hasOwnProperty("version")) {
                var d4 = i9[l2].brand + ":" + i9[l2].version;
                u4.flatAndAddMetadata(e2, "NAVIGATOR_CLIENT_HINTS_BRAND_" + l2, function() {
                  return d4;
                });
              }
            }, u4 = this, c5 = 0; c5 < i9.length; c5++)
              a5(c5);
          } catch (l2) {
            s5._POSignalsUtils.Logger.warn("failed to add client hints", l2);
          }
        }, t3.prototype.addPropertyDescriptorInfo = function(e2, n2, i9, a5) {
          try {
            for (var u4 = function(p4) {
              c5.flatAndAddMetadata(a5, n2 + "_" + p4.toUpperCase(), function() {
                var m = e2.prototype ? e2.prototype : e2, k2 = Object.getOwnPropertyDescriptor(m, p4);
                if (k2) {
                  var x = k2.get ? k2.get.toString() : void 0;
                  return JSON.stringify({
                    configurable: k2.configurable,
                    enumerable: k2.enumerable,
                    value: k2.value,
                    writable: k2.writable,
                    getter: x != null && x.length < 100 ? x : void 0
                  });
                }
                return "undefined";
              });
            }, c5 = this, l2 = 0, d4 = i9; l2 < d4.length; l2++)
              u4(d4[l2]);
          } catch (p4) {
            s5._POSignalsUtils.Logger.warn("failed to add properties descriptor", p4);
          }
        }, t3.prototype.addIframeData = function(e2, n2) {
          if (!n2.has("IFRAME_DATA"))
            try {
              var i9 = s5._POSignalsUtils.Util.createInvisibleElement("iframe");
              if (!i9)
                return;
              i9.srcdoc = "blank page", document.body.appendChild(i9), this.flatAndAddMetadata(e2, "IFRAME_CHROME", function() {
                return typeof i9.contentWindow.chrome;
              }), this.flatAndAddMetadata(e2, "IFRAME_WIDTH", function() {
                return i9.contentWindow.screen.width;
              }), this.flatAndAddMetadata(e2, "IFRAME_HEIGHT", function() {
                return i9.contentWindow.screen.height;
              }), i9.remove();
            } catch (a5) {
              s5._POSignalsUtils.Logger.warn("failed to add iframe data", a5);
            }
        }, t3.prototype.getPermissionsMetadata = function() {
          return Z(this, void 0, void 0, function() {
            var e2, n2, i9, a5, u4, c5;
            return $(this, function(l2) {
              switch (l2.label) {
                case 0:
                  if (e2 = {}, n2 = [
                    "accelerometer",
                    "accessibility-events",
                    "ambient-light-sensor",
                    "background-sync",
                    "camera",
                    "clipboard-read",
                    "clipboard-write",
                    "geolocation",
                    "gyroscope",
                    "magnetometer",
                    "microphone",
                    "midi",
                    "notifications",
                    "payment-handler",
                    "persistent-storage",
                    "push"
                  ], i9 = [], navigator.permissions)
                    for (u4 in a5 = function(d4) {
                      var p4 = n2[d4];
                      i9.push(
                        navigator.permissions.query({ name: p4 }).then(function(m) {
                          e2[p4] = m.state;
                        }).catch(function(m) {
                        })
                      );
                    }, n2)
                      a5(u4);
                  l2.label = 1;
                case 1:
                  return l2.trys.push([1, 3, , 4]), [4, Promise.all(i9)];
                case 2:
                  return l2.sent(), [3, 4];
                case 3:
                  return c5 = l2.sent(), s5._POSignalsUtils.Logger.warn(c5), [3, 4];
                case 4:
                  return [2, e2];
              }
            });
          });
        }, t3.prototype.getMediaCodec = function(e2) {
          var n2 = document.createElement("video");
          if (n2 && n2.canPlayType)
            return n2.canPlayType(e2);
        }, t3.prototype.safeAddModernizrFeatures = function(e2) {
          return Z(this, void 0, void 0, function() {
            var n2, i9, a5, u4, c5, l2;
            return $(this, function(d4) {
              switch (d4.label) {
                case 0:
                  return s5.evaluateModernizr(), n2 = this, i9 = s5.Modernizr, a5 = i9.prefixed, u4 = i9.hasEvent, this.flatAndAddMetadata(e2, "ambient_light", function() {
                    return i9.ambientlight;
                  }), this.flatAndAddMetadata(e2, "application_cache", function() {
                    return i9.applicationcache;
                  }), this.flatAndAddMetadata(e2, "audio", function() {
                    return !!i9.audio;
                  }), i9.audio && this.flatAndAddMetadata(e2, "audio", function() {
                    return i9.audio;
                  }), this.flatAndAddMetadata(e2, "battery_api", function() {
                    return !!a5("battery", navigator) || !!a5("getBattery", navigator);
                  }), this.flatAndAddMetadata(e2, "blob_constructor", function() {
                    return i9.blobconstructor;
                  }), this.flatAndAddMetadata(e2, "context_menu", function() {
                    return i9.contextmenu;
                  }), this.flatAndAddMetadata(e2, "cors", function() {
                    return i9.cors;
                  }), this.flatAndAddMetadata(e2, "cryptography", function() {
                    return i9.cryptography;
                  }), this.flatAndAddMetadata(e2, "custom_elements", function() {
                    return i9.customelements;
                  }), this.flatAndAddMetadata(e2, "custom_protocol_handler", function() {
                    return i9.customprotocolhandler;
                  }), this.flatAndAddMetadata(e2, "custom_event", function() {
                    return i9.customevent;
                  }), this.flatAndAddMetadata(e2, "dart", function() {
                    return i9.dart;
                  }), this.flatAndAddMetadata(e2, "data_view", function() {
                    return i9.dataview;
                  }), this.flatAndAddMetadata(e2, "event_listener", function() {
                    return i9.eventlistener;
                  }), [4, this.safeModernizrOn("exiforientation")];
                case 1:
                  return c5 = d4.sent(), n2.flatAndAddMetadata(e2, "exif_orientation", function() {
                    return c5;
                  }), this.flatAndAddMetadata(e2, "force_touch", function() {
                    return i9.forcetouch;
                  }), i9.forcetouch && (this.flatAndAddMetadata(
                    e2,
                    "force_touch.mouse_force_will_begin",
                    function() {
                      return u4(a5("mouseforcewillbegin", window, false), window);
                    }
                  ), this.flatAndAddMetadata(
                    e2,
                    "force_touch.webkit_force_at_mouse_down",
                    function() {
                      return MouseEvent.WEBKIT_FORCE_AT_MOUSE_DOWN;
                    }
                  ), this.flatAndAddMetadata(
                    e2,
                    "force_touch.webkit_force_at_force_mouse_down",
                    function() {
                      return MouseEvent.WEBKIT_FORCE_AT_FORCE_MOUSE_DOWN;
                    }
                  )), this.flatAndAddMetadata(e2, "full_screen", function() {
                    return i9.fullscreen;
                  }), this.flatAndAddMetadata(e2, "game_pads", function() {
                    return i9.gamepads;
                  }), this.flatAndAddMetadata(e2, "geo_location", function() {
                    return i9.geolocation;
                  }), this.flatAndAddMetadata(e2, "ie8compat", function() {
                    return i9.ie8compat;
                  }), [4, this.safeModernizrOn("indexeddb")];
                case 2:
                  return l2 = d4.sent(), n2.flatAndAddMetadata(e2, "indexed_db", function() {
                    return l2;
                  }), this.flatAndAddMetadata(e2, "indexed_db_blob", function() {
                    return i9.indexeddbblob;
                  }), this.flatAndAddMetadata(e2, "internationalization", function() {
                    return i9.intl;
                  }), this.flatAndAddMetadata(e2, "json", function() {
                    return i9.json;
                  }), this.flatAndAddMetadata(e2, "ligatures", function() {
                    return i9.ligatures;
                  }), this.flatAndAddMetadata(e2, "media_source", function() {
                    return "MediaSource" in window;
                  }), this.flatAndAddMetadata(e2, "message_channel", function() {
                    return i9.messagechannel;
                  }), this.flatAndAddMetadata(e2, "notification", function() {
                    return i9.notification;
                  }), this.flatAndAddMetadata(e2, "page_visibility", function() {
                    return i9.pagevisibility;
                  }), this.flatAndAddMetadata(e2, "performance", function() {
                    return i9.performance;
                  }), this.flatAndAddMetadata(e2, "pointer_events", function() {
                    return i9.pointerevents;
                  }), this.flatAndAddMetadata(e2, "pointer_lock", function() {
                    return i9.pointerlock;
                  }), this.flatAndAddMetadata(e2, "proximity", function() {
                    return i9.proximity;
                  }), this.flatAndAddMetadata(e2, "query_selector", function() {
                    return i9.queryselector;
                  }), this.flatAndAddMetadata(e2, "quota_management", function() {
                    return i9.quotamanagement;
                  }), this.flatAndAddMetadata(e2, "request_animation_frame", function() {
                    return i9.requestanimationframe;
                  }), this.flatAndAddMetadata(e2, "service_worker", function() {
                    return i9.serviceworker;
                  }), this.flatAndAddMetadata(e2, "touch_events", function() {
                    return i9.touchevents;
                  }), this.flatAndAddMetadata(e2, "typed_arrays", function() {
                    return i9.typedarrays;
                  }), this.flatAndAddMetadata(e2, "vibrate", function() {
                    return i9.vibrate;
                  }), this.flatAndAddMetadata(e2, "video", function() {
                    return !!i9.video;
                  }), i9.video && this.flatAndAddMetadata(e2, "video", function() {
                    return i9.video;
                  }), this.flatAndAddMetadata(e2, "web_gl", function() {
                    return i9.webgl;
                  }), this.flatAndAddMetadata(e2, "web_sockets", function() {
                    return i9.websockets;
                  }), this.flatAndAddMetadata(e2, "x_domain_request", function() {
                    return i9.xdomainrequest;
                  }), this.flatAndAddMetadata(e2, "matchmedia", function() {
                    return i9.matchmedia;
                  }), [2];
              }
            });
          });
        }, t3.prototype.getIoMetadata = function() {
          var e2 = this, n2 = {}, i9 = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
          return this.flatAndAddMetadata(n2, "NETWORK_TYPE", function() {
            return i9 ? i9.type : null;
          }), this.flatAndAddMetadata(n2, "NETWORK_DOWNLOAD_MAX", function() {
            return i9 ? i9.downlinkMax : null;
          }), this.flatAndAddMetadata(n2, "BLUTOOTH_SUPPORTED", function() {
            return !!navigator.bluetooth;
          }), this.flatAndAddMetadata(n2, "HAS_SPEAKERS", function() {
            return e2.hasSpeakers;
          }), this.flatAndAddMetadata(n2, "HAS_MICROPHONE", function() {
            return e2.hasMicrophone;
          }), this.flatAndAddMetadata(n2, "HAS_CAMERA", function() {
            return e2.hasWebcam;
          }), this.flatAndAddMetadata(n2, "BATTERY_SUPPORTED", function() {
            return e2.isBatterySupported;
          }), this.flatAndAddMetadata(n2, "BATTERY_LEVEL", function() {
            return e2.batteryLevel;
          }), this.flatAndAddMetadata(n2, "BATTERY_CHARGING", function() {
            return e2.batteryCharging;
          }), this.flatAndAddMetadata(n2, "BATTERY_CHARGING_TIME", function() {
            return e2.batteryChargingTime;
          }), this.flatAndAddMetadata(n2, "BATTERY_DISCHARGING_TIME", function() {
            return e2.batteryDischargingTime;
          }), this.flatAndAddMetadata(n2, "GPS_SUPPORTED", function() {
            return e2.gpsSupported;
          }), this.flatAndAddMetadata(n2, "IS_MOBILE", function() {
            return s5._POSignalsUtils.Util.isMobile;
          }), this.flatAndAddMetadata(n2, "HAS_TOUCH", function() {
            return "ontouchstart" in document.documentElement;
          }), this.flatAndAddMetadata(n2, "PERMISSIONS", function() {
            return e2.permissions;
          }), this.flatAndAddMetadata(n2, "PREFERS_COLOR_SCHEME", function() {
            return window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : void 0;
          }), n2;
        }, t3.prototype.safeAddMetadata = function(e2, n2, i9) {
          try {
            var a5 = new Set(this.metadataParams.metadataBlackList || []);
            n2 == null || i9 == null || a5.has(n2) || (e2[n2] = i9);
          } catch (u4) {
            s5._POSignalsUtils.Logger.warn("Failed to add " + n2 + " -> " + i9 + ", " + u4);
          }
        }, t3.prototype.safeModernizrOn = function(e2) {
          return Z(this, void 0, void 0, function() {
            var n2, i9;
            return $(this, function(a5) {
              switch (a5.label) {
                case 0:
                  return n2 = new Promise(function(u4) {
                    try {
                      s5.Modernizr.on(e2, function(c5) {
                        u4(c5);
                      });
                    } catch (c5) {
                      u4(null), s5._POSignalsUtils.Logger.warn(
                        "Modernizr.on Failed with feature " + e2,
                        c5
                      );
                    }
                  }), i9 = s5._POSignalsUtils.Util.delay(250).then(function() {
                    return null;
                  }), [4, Promise.race([n2, i9])];
                case 1:
                  return [2, a5.sent()];
              }
            });
          });
        }, t3.prototype.flatAndAddMetadata = function(e2, n2, i9) {
          try {
            var a5 = new Set(this.metadataParams.metadataBlackList || []);
            if (!n2 || a5.has(n2))
              return;
            var u4 = i9();
            if (typeof u4 == "object" && u4 !== null) {
              var c5 = s5._POSignalsUtils.Util.flatten(u4);
              for (var l2 in c5)
                this.safeAddMetadata(e2, n2 + "." + l2, c5[l2]);
            } else
              this.safeAddMetadata(e2, n2, u4);
          } catch (d4) {
            s5._POSignalsUtils.Logger.warn("Failed to add " + n2, d4);
          }
        }, t3.prototype.getOps = function() {
          var e2, n2 = /* @__PURE__ */ new Date(), i9 = 0;
          do
            i9++, e2 = (/* @__PURE__ */ new Date()).getTime() - n2.getTime();
          while (e2 < 500);
          var a5 = i9 / e2;
          return s5._POSignalsUtils.Logger.debug("Ops : " + a5), a5;
        }, t3.prototype.getPrivateMode = function() {
          return Z(this, void 0, void 0, function() {
            var e2;
            return $(this, function(n2) {
              return e2 = this, [
                2,
                new Promise(function(i9, a5) {
                  e2.detectPrivateMode(function(u4) {
                    i9(u4);
                  });
                })
              ];
            });
          });
        }, t3.prototype.detectPrivateMode = function(e2) {
          var n2, i9 = e2.bind(null, true), a5 = e2.bind(null, false);
          window.webkitRequestFileSystem ? window.webkitRequestFileSystem(0, 0, a5, i9) : "MozAppearance" in document.documentElement.style ? ((n2 = indexedDB.open("test")).onerror = i9, n2.onsuccess = a5) : /constructor/i.test(window.HTMLElement) || window.safari ? function() {
            try {
              localStorage.length || (localStorage.x = 1, localStorage.removeItem("x")), a5();
            } catch (e3) {
              navigator.cookieEnabled ? i9() : a5();
            }
          }() : window.indexedDB || !window.PointerEvent && !window.MSPointerEvent ? a5() : i9();
        }, t3.detectChromium = function() {
          return Math.acos(0.123) == 1.4474840516030247 && Math.acosh(Math.SQRT2) == 0.881373587019543 && Math.atan(2) == 1.1071487177940904 && Math.atanh(0.5) == 0.5493061443340548 && Math.cbrt(Math.PI) == 1.4645918875615231 && Math.cos(21 * Math.LN2) == -0.4067775970251724 && Math.cosh(492 * Math.LOG2E) == 9199870313877772e292 && Math.expm1(1) == 1.718281828459045 && Math.hypot(6 * Math.PI, -100) == 101.76102278593319 && Math.log10(Math.PI) == 0.4971498726941338 && Math.sin(Math.PI) == 12246467991473532e-32 && Math.sinh(Math.PI) == 11.548739357257748 && Math.tan(10 * Math.LOG2E) == -3.3537128705376014 && Math.tanh(0.123) == 0.12238344189440875 && Math.pow(Math.PI, -100) == 19275814160560204e-66;
        }, t3;
      }();
      h2.Metadata = r10;
    })(s5._POSignalsMetadata || (s5._POSignalsMetadata = {}));
  }(M2 || (M2 = {})), function(s5) {
    (function(h2) {
      var r10 = function() {
        function t3() {
        }
        return t3.seleniumInDocument = function() {
          for (var e2 = 0, n2 = [
            "__webdriver_evaluate",
            "__selenium_evaluate",
            "__webdriver_script_function",
            "__webdriver_script_func",
            "__webdriver_script_fn",
            "__fxdriver_evaluate",
            "__driver_unwrapped",
            "__webdriver_unwrapped",
            "__driver_evaluate",
            "__selenium_unwrapped",
            "__fxdriver_unwrapped"
          ]; e2 < n2.length; e2++)
            if (document[n2[e2]])
              return true;
          return false;
        }, t3.seleniumInWindow = function() {
          for (var e2 = 0, n2 = [
            "_phantom",
            "__nightmare",
            "_selenium",
            "callPhantom",
            "calledSelenium",
            "callSelenium",
            "_Selenium_IDE_Recorder"
          ]; e2 < n2.length; e2++)
            if (window[n2[e2]])
              return true;
          return false;
        }, t3.seleniumInNavigator = function() {
          for (var e2 = 0, n2 = [
            "webdriver",
            "__driver_evaluate",
            "__webdriver_evaluate",
            "__selenium_evaluate",
            "__fxdriver_evaluate",
            "__driver_unwrapped",
            "__webdriver_unwrapped",
            "__selenium_unwrapped",
            "__fxdriver_unwrapped",
            "_Selenium_IDE_Recorder",
            "_selenium",
            "calledSelenium",
            "_WEBDRIVER_ELEM_CACHE",
            "ChromeDriverw",
            "driver-evaluate",
            "webdriver-evaluate",
            "selenium-evaluate",
            "webdriverCommand",
            "webdriver-evaluate-response",
            "__webdriverFunc",
            "__webdriver_script_fn",
            "__$webdriverAsyncExecutor",
            "__lastWatirAlert",
            "__lastWatirConfirm",
            "__lastWatirPrompt",
            "$chrome_asyncScriptInfo",
            "$cdc_asdjflasutopfhvcZLmcfl_"
          ]; e2 < n2.length; e2++)
            if (navigator[n2[e2]])
              return true;
          return false;
        }, t3.seleniumSequentum = function() {
          return window.external && window.external.toString() && window.external.toString().indexOf("Sequentum") != -1;
        }, t3;
      }();
      h2.SeleniumProperties = r10;
    })(s5._POSignalsMetadata || (s5._POSignalsMetadata = {}));
  }(M2 || (M2 = {})), function(s5) {
    (function(h2) {
      var r10 = function() {
        function t3(e2) {
          this.propertyBlackList = e2;
        }
        return t3.prototype.getHeadlessResults = function() {
          return Z(this, void 0, void 0, function() {
            var e2, n2 = this;
            return $(this, function(i9) {
              switch (i9.label) {
                case 0:
                  return [4, this.headlessResults(window)];
                case 1:
                  return e2 = i9.sent(), [
                    4,
                    this.test(e2, "iframe_window", function() {
                      return Z(n2, void 0, void 0, function() {
                        var a5, u4;
                        return $(this, function(c5) {
                          switch (c5.label) {
                            case 0:
                              return Object.getOwnPropertyDescriptors && (a5 = s5._POSignalsUtils.Util.createInvisibleElement("iframe")) ? (a5.srcdoc = "page intentionally left blank", document.body.appendChild(a5), Object.getOwnPropertyDescriptors(
                                HTMLIFrameElement.prototype
                              ).contentWindow.get.toString() !== "function get contentWindow() { [native code] }" ? [2, true] : a5.contentWindow === window ? [2, true] : [4, this.headlessResults(a5.contentWindow)]) : [2];
                            case 1:
                              return u4 = c5.sent(), a5.remove(), [2, u4];
                          }
                        });
                      });
                    })
                  ];
                case 2:
                  return i9.sent(), [2, e2];
              }
            });
          });
        }, t3.prototype.headlessResults = function(e2) {
          return Z(this, void 0, void 0, function() {
            var n2, i9, a5 = this;
            return $(this, function(u4) {
              switch (u4.label) {
                case 0:
                  return n2 = /* @__PURE__ */ new Map(), (i9 = []).push(
                    this.test(n2, "headless_chrome", function() {
                      return Z(a5, void 0, void 0, function() {
                        return $(this, function(c5) {
                          return [2, /HeadlessChrome/.test(e2.navigator.userAgent)];
                        });
                      });
                    })
                  ), i9.push(
                    this.test(n2, "navigator.webdriver_present", function() {
                      return Z(a5, void 0, void 0, function() {
                        return $(this, function(c5) {
                          return [2, "webdriver" in e2.navigator];
                        });
                      });
                    })
                  ), i9.push(
                    this.test(n2, "window.chrome_missing", function() {
                      return Z(a5, void 0, void 0, function() {
                        return $(this, function(c5) {
                          return [2, /Chrome/.test(e2.navigator.userAgent) && !e2.chrome];
                        });
                      });
                    })
                  ), i9.push(
                    this.test(n2, "permissions_api", function() {
                      return Z(a5, void 0, void 0, function() {
                        var c5;
                        return $(this, function(l2) {
                          switch (l2.label) {
                            case 0:
                              return e2.navigator.permissions && e2.Notification ? [
                                4,
                                e2.navigator.permissions.query({ name: "notifications" })
                              ] : [3, 2];
                            case 1:
                              return c5 = l2.sent(), [
                                2,
                                e2.Notification.permission === "denied" && c5.state === "prompt"
                              ];
                            case 2:
                              return [2];
                          }
                        });
                      });
                    })
                  ), i9.push(
                    this.test(n2, "permissions_api_overriden", function() {
                      return Z(a5, void 0, void 0, function() {
                        var c5;
                        return $(this, function(l2) {
                          return (c5 = e2.navigator.permissions) ? c5.query.toString() !== "function query() { [native code] }" ? [2, true] : c5.query.toString.toString() !== "function toString() { [native code] }" ? [2, true] : c5.query.toString.hasOwnProperty("[[Handler]]") && c5.query.toString.hasOwnProperty("[[Target]]") && c5.query.toString.hasOwnProperty("[[IsRevoked]]") ? [2, true] : [2, c5.hasOwnProperty("query")] : [2];
                        });
                      });
                    })
                  ), i9.push(
                    this.test(n2, "navigator.plugins_empty", function() {
                      return Z(a5, void 0, void 0, function() {
                        return $(this, function(c5) {
                          return [2, navigator.plugins.length === 0];
                        });
                      });
                    })
                  ), i9.push(
                    this.test(n2, "navigator.languages_blank", function() {
                      return Z(a5, void 0, void 0, function() {
                        return $(this, function(c5) {
                          return [2, navigator.languages === ""];
                        });
                      });
                    })
                  ), i9.push(
                    this.test(n2, "consistent_plugins_prototype", function() {
                      return Z(a5, void 0, void 0, function() {
                        var c5;
                        return $(this, function(l2) {
                          return c5 = PluginArray.prototype === navigator.plugins.__proto__, navigator.plugins.length > 0 && (c5 = c5 && Plugin.prototype === navigator.plugins[0].__proto__), [2, c5];
                        });
                      });
                    })
                  ), i9.push(
                    this.test(n2, "consistent_mimetypes_prototype", function() {
                      return Z(a5, void 0, void 0, function() {
                        var c5;
                        return $(this, function(l2) {
                          return c5 = MimeTypeArray.prototype === navigator.mimeTypes.__proto__, navigator.mimeTypes.length > 0 && (c5 = c5 && MimeType.prototype === navigator.mimeTypes[0].__proto__), [2, c5];
                        });
                      });
                    })
                  ), [4, Promise.all(i9)];
                case 1:
                  return u4.sent(), [2, n2];
              }
            });
          });
        }, t3.prototype.test = function(e2, n2, i9) {
          return Z(this, void 0, void 0, function() {
            var a5, u4;
            return $(this, function(c5) {
              switch (c5.label) {
                case 0:
                  return c5.trys.push([0, 3, , 4]), this.propertyBlackList.has(n2) ? [3, 2] : [4, s5._POSignalsUtils.Util.promiseTimeout(100, i9())];
                case 1:
                  (a5 = c5.sent()) != null && (e2[n2] = a5), c5.label = 2;
                case 2:
                  return [3, 4];
                case 3:
                  return u4 = c5.sent(), s5._POSignalsUtils.Logger.warn(n2 + " headless test was failed", u4), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }, t3;
      }();
      h2.DetectHeadless = r10;
    })(s5._POSignalsMetadata || (s5._POSignalsMetadata = {}));
  }(M2 || (M2 = {})), function(s5) {
    (function(h2) {
      var r10 = function() {
        function t3(e2) {
          this.propertyBlackList = e2, this.result = {};
        }
        return t3.prototype.documentLie = function(e2, n2) {
          if (n2.lied)
            for (var i9 = 0, a5 = n2.lieTypes; i9 < a5.length; i9++) {
              var u4 = a5[i9];
              this.result[u4] || (this.result[u4] = []), this.result[u4].push(e2);
            }
        }, t3.prototype.getLies = function(e2, n2, i9) {
          var a5 = this;
          if (i9 === void 0 && (i9 = null), typeof e2 != "function")
            return { lied: false, lieTypes: [] };
          var u4 = e2.name.replace(/get\s/, ""), c5 = {
            undefined_properties: function() {
              return !!i9 && t3.getUndefinedValueLie(i9, u4);
            },
            to_string: function() {
              return t3.getToStringLie(e2, u4, a5.iframeWindow);
            },
            prototype_in_function: function() {
              return t3.getPrototypeInFunctionLie(e2);
            },
            own_property: function() {
              return t3.getOwnPropertyLie(e2);
            },
            object_to_string_error: function() {
              return t3.getNewObjectToStringTypeErrorLie(e2);
            }
          }, l2 = Object.keys(c5).filter(function(d4) {
            return !a5.propertyBlackList.has("LIES." + d4) && !!c5[d4]();
          });
          return { lied: l2.length > 0, lieTypes: l2 };
        }, t3.prototype.getAllLies = function() {
          return Z(this, void 0, void 0, function() {
            var e2;
            return $(this, function(n2) {
              switch (n2.label) {
                case 0:
                  return this.propertyBlackList.has("LIES") ? [2, this.result] : (this.propertyBlackList.has("LIES_IFRAME") || (e2 = s5._POSignalsUtils.Util.createInvisibleElement("iframe")) && (document.body.appendChild(e2), this.iframeWindow = e2), [
                    4,
                    Promise.all([
                      this.searchLies(
                        function() {
                          return AnalyserNode;
                        },
                        { target: ["minDecibels"] }
                      ),
                      this.searchLies(
                        function() {
                          return AudioBuffer;
                        },
                        { target: ["copyFromChannel"] }
                      ),
                      this.searchLies(
                        function() {
                          return BiquadFilterNode;
                        },
                        { target: ["getFrequencyResponse"] }
                      ),
                      this.searchLies(
                        function() {
                          return CanvasRenderingContext2D;
                        },
                        { target: ["getLineDash"] }
                      ),
                      this.searchLies(
                        function() {
                          return DOMRect;
                        },
                        { target: ["height"] }
                      ),
                      this.searchLies(
                        function() {
                          return DOMRectReadOnly;
                        },
                        { target: ["left"] }
                      ),
                      this.searchLies(
                        function() {
                          return Element;
                        },
                        { target: ["getClientRects"] }
                      ),
                      this.searchLies(
                        function() {
                          return HTMLCanvasElement;
                        },
                        { target: ["height"] }
                      ),
                      this.searchLies(
                        function() {
                          return Math;
                        },
                        { target: ["sinh"] }
                      ),
                      this.searchLies(
                        function() {
                          return MediaDevices;
                        },
                        { target: ["enumerateDevices"] }
                      ),
                      this.searchLies(
                        function() {
                          return Navigator;
                        },
                        { target: ["plugins"] }
                      ),
                      this.searchLies(
                        function() {
                          return OffscreenCanvasRenderingContext2D;
                        },
                        { target: ["getLineDash"] }
                      ),
                      this.searchLies(
                        function() {
                          return SVGRect;
                        },
                        { target: ["x"] }
                      )
                    ])
                  ]);
                case 1:
                  return n2.sent(), this.iframeWindow.remove(), [2, this.result];
              }
            });
          });
        }, t3.prototype.searchLies = function(e2, n2) {
          var i9 = n2 === void 0 ? {} : n2, a5 = i9.target, u4 = a5 === void 0 ? [] : a5, c5 = i9.ignore, l2 = c5 === void 0 ? [] : c5;
          return Z(this, void 0, void 0, function() {
            var d4, p4, m = this;
            return $(this, function(k2) {
              try {
                if (d4 = e2(), (x = d4) === void 0 || !x)
                  return [2];
              } catch (e3) {
                return [2];
              }
              var x;
              return p4 = d4.prototype ? d4.prototype : d4, Object.getOwnPropertyNames(p4).forEach(function(y3) {
                if (!(y3 == "constructor" || u4.length && !new Set(u4).has(y3) || l2.length && new Set(l2).has(y3))) {
                  var C = /\s(.+)\]/, A2 = (d4.name ? d4.name : C.test(d4) ? C.exec(d4)[1] : void 0) + "." + y3;
                  try {
                    var P2 = d4.prototype ? d4.prototype : d4;
                    try {
                      if (typeof P2[y3] == "function") {
                        var D2 = m.getLies(P2[y3], P2);
                        return void m.documentLie(A2, D2);
                      }
                    } catch (e3) {
                    }
                    var j = Object.getOwnPropertyDescriptor(P2, y3).get, z2 = m.getLies(j, P2, d4);
                    m.documentLie(A2, z2);
                  } catch (B) {
                    s5._POSignalsUtils.Logger.warn("failed " + y3 + " test execution", B);
                  }
                }
              }), [2];
            });
          });
        }, t3.getUndefinedValueLie = function(e2, n2) {
          var i9 = e2.name, a5 = window[i9.charAt(0).toLowerCase() + i9.slice(1)];
          return !!a5 && (Object.getOwnPropertyDescriptor(a5, n2) !== void 0 || Reflect.getOwnPropertyDescriptor(a5, n2) !== void 0);
        }, t3.getToStringLie = function(e2, n2, i9) {
          var a5, u4;
          try {
            a5 = i9.Function.prototype.toString.call(e2);
          } catch (e3) {
          }
          try {
            u4 = i9.Function.prototype.toString.call(e2.toString);
          } catch (e3) {
          }
          var c5 = a5 || e2.toString(), l2 = u4 || e2.toString.toString(), d4 = function(p4) {
            var m;
            return (m = {})["function " + p4 + "() { [native code] }"] = true, m["function get " + p4 + "() { [native code] }"] = true, m["function () { [native code] }"] = true, m["function " + p4 + `() {
    [native code]
}`] = true, m["function get " + p4 + `() {
    [native code]
}`] = true, m[`function () {
    [native code]
}`] = true, m;
          };
          return !d4(n2)[c5] || !d4("toString")[l2];
        }, t3.getPrototypeInFunctionLie = function(e2) {
          return "prototype" in e2;
        }, t3.getOwnPropertyLie = function(e2) {
          return e2.hasOwnProperty("arguments") || e2.hasOwnProperty("caller") || e2.hasOwnProperty("prototype") || e2.hasOwnProperty("toString");
        }, t3.getNewObjectToStringTypeErrorLie = function(e2) {
          try {
            return Object.create(e2).toString(), true;
          } catch (l2) {
            var n2 = l2.stack.split(`
`), i9 = /at Object\.apply/, a5 = !n2.slice(1).find(function(d4) {
              return i9.test(d4);
            }), u4 = l2.constructor.name == "TypeError" && n2.length > 1, c5 = "chrome" in window || h2.Metadata.detectChromium();
            return !(!u4 || !c5 || /at Function\.toString/.test(n2[1]) && a5) || !u4;
          }
        }, t3;
      }();
      h2.DetectLies = r10;
    })(s5._POSignalsMetadata || (s5._POSignalsMetadata = {}));
  }(M2 || (M2 = {})), function(s5) {
    (function(h2) {
      var r10 = function() {
        function t3(e2) {
          this.propertyBlackList = e2, this.result = /* @__PURE__ */ new Map();
        }
        return t3.prototype.getStealthResult = function() {
          return this.addStealthTest("srcdoc_throws_error", function() {
            try {
              return !!document.createElement("iframe").srcdoc;
            } catch (e2) {
              return true;
            }
          }), this.addStealthTest("srcdoc_triggers_window_proxy", function() {
            var e2 = document.createElement("iframe");
            return e2.srcdoc = "" + s5._POSignalsUtils.Util.hashMini(crypto.getRandomValues(new Uint32Array(10))), !!e2.contentWindow;
          }), this.addStealthTest("index_chrome_too_high", function() {
            var e2 = "cookieStore" in window ? "cookieStore" : "ondevicemotion" in window ? "ondevicemotion" : "speechSynthesis", n2 = [];
            for (var i9 in window)
              n2.push(i9);
            return n2.indexOf("chrome") > n2.indexOf(e2);
          }), this.addStealthTest("chrome_runtime_functions_invalid", function() {
            if (!("chrome" in window && "runtime" in window.chrome))
              return false;
            try {
              return "prototype" in window.chrome.runtime.sendMessage || "prototype" in window.chrome.runtime.connect || (new window.chrome.runtime.sendMessage(), new window.chrome.runtime.connect(), true);
            } catch (e2) {
              return e2.constructor.name != "TypeError";
            }
          }), this.addStealthTest("Function_prototype_toString_invalid_typeError", function() {
            var e2 = new t3.StackTraceTester();
            return e2.isInvalidStackTraceSize(Function.prototype.toString) || e2.isInvalidStackTraceSize(function() {
            });
          }), this.result;
        }, t3.prototype.addStealthTest = function(e2, n2) {
          if (!this.propertyBlackList.has(e2))
            try {
              this.result[e2] = n2();
            } catch (i9) {
              s5._POSignalsUtils.Logger.warn("stealth test " + e2 + " failed", i9);
            }
        }, t3.StackTraceTester = function() {
          function e2() {
          }
          return e2.prototype.isInvalidStackTraceSize = function(n2) {
            var i9 = this;
            try {
              return this.you = function() {
                return Object.create(n2).toString();
              }, this.cant = function() {
                return i9.you();
              }, this.hide = function() {
                return i9.cant();
              }, this.hide(), true;
            } catch (d4) {
              var a5 = d4.stack.split(`
`), u4 = !/at Object\.apply/.test(a5[1]), c5 = d4.constructor.name == "TypeError" && a5.length >= 5, l2 = "chrome" in window || h2.Metadata.detectChromium();
              return !(!c5 || !l2 || u4 && /at Function\.toString/.test(a5[1]) && /\.you/.test(a5[2]) && /\.cant/.test(a5[3]) && /\.hide/.test(a5[4])) || !c5;
            }
          }, e2;
        }(), t3;
      }();
      h2.DetectStealth = r10;
    })(s5._POSignalsMetadata || (s5._POSignalsMetadata = {}));
  }(M2 || (M2 = {})), function(s5) {
    (function(h2) {
      var r10 = function() {
        function t3() {
        }
        return t3.isPrivateMode = function() {
          return new Promise(function(e2) {
            var n2, i9, a5 = function() {
              return e2(true);
            }, u4 = function() {
              return e2(false);
            };
            try {
              if ((i9 = navigator && /(?=.*(opera|chrome)).*/i.test(navigator.userAgent) && navigator.storage && navigator.storage.estimate) && navigator.storage.estimate().then(function(c5) {
                c5.quota < 12e7 ? a5() : u4();
              }).catch(function(c5) {
                u4();
              }), i9 || function() {
                var c5 = "MozAppearance" in document.documentElement.style;
                if (c5)
                  if (indexedDB == null)
                    a5();
                  else {
                    var l2 = indexedDB.open("inPrivate");
                    l2.onsuccess = u4, l2.onerror = a5;
                  }
                return c5;
              }() || function() {
                var c5 = navigator && navigator.userAgent && navigator.userAgent.match(/Version\/([0-9\._]+).*Safari/);
                if (c5) {
                  if (parseInt(c5[1], 10) < 11)
                    return function() {
                      try {
                        localStorage.length || (localStorage.setItem("inPrivate", "0"), localStorage.removeItem("inPrivate")), u4();
                      } catch (e3) {
                        navigator.cookieEnabled ? a5() : u4();
                      }
                      return true;
                    }();
                  try {
                    window.openDatabase(null, null, null, null), u4();
                  } catch (e3) {
                    a5();
                  }
                }
                return !!c5;
              }() || ((n2 = !window.indexedDB && (window.PointerEvent || window.MSPointerEvent)) && a5(), n2))
                return;
            } catch (e3) {
            }
            return u4();
          });
        }, t3;
      }();
      h2.Incognito = r10;
    })(s5._POSignalsMetadata || (s5._POSignalsMetadata = {}));
  }(M2 || (M2 = {}));
  _e = /* @__PURE__ */ function() {
    var s5 = function(h2, r10) {
      return (s5 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t3, e2) {
        t3.__proto__ = e2;
      } || function(t3, e2) {
        for (var n2 in e2)
          e2.hasOwnProperty(n2) && (t3[n2] = e2[n2]);
      })(h2, r10);
    };
    return function(h2, r10) {
      function t3() {
        this.constructor = h2;
      }
      s5(h2, r10), h2.prototype = r10 === null ? Object.create(r10) : (t3.prototype = r10.prototype, new t3());
    };
  }();
  Z = function(s5, h2, r10, t3) {
    return new (r10 || (r10 = Promise))(function(e2, n2) {
      function i9(c5) {
        try {
          u4(t3.next(c5));
        } catch (l2) {
          n2(l2);
        }
      }
      function a5(c5) {
        try {
          u4(t3.throw(c5));
        } catch (l2) {
          n2(l2);
        }
      }
      function u4(c5) {
        var l2;
        c5.done ? e2(c5.value) : (l2 = c5.value, l2 instanceof r10 ? l2 : new r10(function(d4) {
          d4(l2);
        })).then(i9, a5);
      }
      u4((t3 = t3.apply(s5, h2 || [])).next());
    });
  }, $ = function(s5, h2) {
    var r10, t3, e2, n2, i9 = {
      label: 0,
      sent: function() {
        if (1 & e2[0])
          throw e2[1];
        return e2[1];
      },
      trys: [],
      ops: []
    };
    return n2 = { next: a5(0), throw: a5(1), return: a5(2) }, typeof Symbol == "function" && (n2[Symbol.iterator] = function() {
      return this;
    }), n2;
    function a5(u4) {
      return function(c5) {
        return function(l2) {
          if (r10)
            throw new TypeError("Generator is already executing.");
          for (; i9; )
            try {
              if (r10 = 1, t3 && (e2 = 2 & l2[0] ? t3.return : l2[0] ? t3.throw || ((e2 = t3.return) && e2.call(t3), 0) : t3.next) && !(e2 = e2.call(t3, l2[1])).done)
                return e2;
              switch (t3 = 0, e2 && (l2 = [2 & l2[0], e2.value]), l2[0]) {
                case 0:
                case 1:
                  e2 = l2;
                  break;
                case 4:
                  return i9.label++, { value: l2[1], done: false };
                case 5:
                  i9.label++, t3 = l2[1], l2 = [0];
                  continue;
                case 7:
                  l2 = i9.ops.pop(), i9.trys.pop();
                  continue;
                default:
                  if (!(e2 = (e2 = i9.trys).length > 0 && e2[e2.length - 1]) && (l2[0] === 6 || l2[0] === 2)) {
                    i9 = 0;
                    continue;
                  }
                  if (l2[0] === 3 && (!e2 || l2[1] > e2[0] && l2[1] < e2[3])) {
                    i9.label = l2[1];
                    break;
                  }
                  if (l2[0] === 6 && i9.label < e2[1]) {
                    i9.label = e2[1], e2 = l2;
                    break;
                  }
                  if (e2 && i9.label < e2[2]) {
                    i9.label = e2[2], i9.ops.push(l2);
                    break;
                  }
                  e2[2] && i9.ops.pop(), i9.trys.pop();
                  continue;
              }
              l2 = h2.call(s5, i9);
            } catch (d4) {
              l2 = [6, d4], t3 = 0;
            } finally {
              r10 = e2 = 0;
            }
          if (5 & l2[0])
            throw l2[1];
          return { value: l2[0] ? l2[1] : void 0, done: true };
        }([u4, c5]);
      };
    }
  }, ve = function() {
    return (ve = Object.assign || function(s5) {
      for (var h2, r10 = 1, t3 = arguments.length; r10 < t3; r10++)
        for (var e2 in h2 = arguments[r10])
          Object.prototype.hasOwnProperty.call(h2, e2) && (s5[e2] = h2[e2]);
      return s5;
    }).apply(this, arguments);
  }, function(s5) {
    (function(h2) {
      h2[h2.Unknown = 0] = "Unknown", h2[h2.FlingRight = 1] = "FlingRight", h2[h2.FlingLeft = 2] = "FlingLeft", h2[h2.FlingUp = 3] = "FlingUp", h2[h2.FlingDown = 4] = "FlingDown", h2[h2.Diagonal = 5] = "Diagonal", h2[h2.ScrollRight = 6] = "ScrollRight", h2[h2.ScrollLeft = 7] = "ScrollLeft", h2[h2.ScrollUp = 8] = "ScrollUp", h2[h2.ScrollDown = 9] = "ScrollDown", h2[h2.Tap = 10] = "Tap", h2[h2.DoubleTap = 11] = "DoubleTap";
    })(s5.GestureType || (s5.GestureType = {}));
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function d4(p4, m) {
        this.handler = p4, this.isOnce = m, this.isExecuted = false;
      }
      return d4.prototype.execute = function(p4, m, k2) {
        if (!this.isOnce || !this.isExecuted) {
          this.isExecuted = true;
          var x = this.handler;
          p4 ? setTimeout(function() {
            x.apply(m, k2);
          }, 1) : x.apply(m, k2);
        }
      }, d4;
    }(), r10 = function() {
      function d4() {
        this._wrap = new i9(this), this._subscriptions = new Array();
      }
      return d4.prototype.subscribe = function(p4) {
        p4 && this._subscriptions.push(new h2(p4, false));
      }, d4.prototype.sub = function(p4) {
        this.subscribe(p4);
      }, d4.prototype.one = function(p4) {
        p4 && this._subscriptions.push(new h2(p4, true));
      }, d4.prototype.has = function(p4) {
        if (p4) {
          for (var m = 0, k2 = this._subscriptions; m < k2.length; m++)
            if (k2[m].handler == p4)
              return true;
        }
        return false;
      }, d4.prototype.unsubscribe = function(p4) {
        if (p4) {
          for (var m = 0; m < this._subscriptions.length; m++)
            if (this._subscriptions[m].handler == p4) {
              this._subscriptions.splice(m, 1);
              break;
            }
        }
      }, d4.prototype.unsub = function(p4) {
        this.unsubscribe(p4);
      }, d4.prototype._dispatch = function(p4, m, k2) {
        for (var x = 0; x < this._subscriptions.length; x++) {
          var y3 = this._subscriptions[x];
          if (y3.isOnce) {
            if (y3.isExecuted === true)
              continue;
            this._subscriptions.splice(x, 1), x--;
          }
          y3.execute(p4, m, k2);
        }
      }, d4.prototype.asEvent = function() {
        return this._wrap;
      }, d4;
    }();
    s5.DispatcherBase = r10;
    var t3 = function(d4) {
      function p4() {
        return d4 !== null && d4.apply(this, arguments) || this;
      }
      return _e(p4, d4), p4.prototype.dispatch = function(m, k2) {
        this._dispatch(false, this, arguments);
      }, p4.prototype.dispatchAsync = function(m, k2) {
        this._dispatch(true, this, arguments);
      }, p4;
    }(r10);
    s5.EventDispatcher = t3;
    var e2 = function(d4) {
      function p4() {
        return d4 !== null && d4.apply(this, arguments) || this;
      }
      return _e(p4, d4), p4.prototype.dispatch = function(m) {
        this._dispatch(false, this, arguments);
      }, p4.prototype.dispatchAsync = function(m) {
        this._dispatch(true, this, arguments);
      }, p4;
    }(r10), n2 = function(d4) {
      function p4() {
        return d4 !== null && d4.apply(this, arguments) || this;
      }
      return _e(p4, d4), p4.prototype.dispatch = function() {
        this._dispatch(false, this, arguments);
      }, p4.prototype.dispatchAsync = function() {
        this._dispatch(true, this, arguments);
      }, p4;
    }(r10), i9 = function() {
      function d4(p4) {
        this._subscribe = function(m) {
          return p4.subscribe(m);
        }, this._unsubscribe = function(m) {
          return p4.unsubscribe(m);
        }, this._one = function(m) {
          return p4.one(m);
        }, this._has = function(m) {
          return p4.has(m);
        };
      }
      return d4.prototype.subscribe = function(p4) {
        this._subscribe(p4);
      }, d4.prototype.sub = function(p4) {
        this.subscribe(p4);
      }, d4.prototype.unsubscribe = function(p4) {
        this._unsubscribe(p4);
      }, d4.prototype.unsub = function(p4) {
        this.unsubscribe(p4);
      }, d4.prototype.one = function(p4) {
        this._one(p4);
      }, d4.prototype.has = function(p4) {
        return this._has(p4);
      }, d4;
    }(), a5 = function() {
      function d4() {
        this._events = {};
      }
      return d4.prototype.get = function(p4) {
        var m = this._events[p4];
        return m || (m = this.createDispatcher(), this._events[p4] = m, m);
      }, d4.prototype.remove = function(p4) {
        this._events[p4] = null;
      }, d4;
    }(), u4 = function(d4) {
      function p4() {
        return d4 !== null && d4.apply(this, arguments) || this;
      }
      return _e(p4, d4), p4.prototype.createDispatcher = function() {
        return new t3();
      }, p4;
    }(a5), c5 = function(d4) {
      function p4() {
        return d4 !== null && d4.apply(this, arguments) || this;
      }
      return _e(p4, d4), p4.prototype.createDispatcher = function() {
        return new e2();
      }, p4;
    }(a5), l2 = function(d4) {
      function p4() {
        return d4 !== null && d4.apply(this, arguments) || this;
      }
      return _e(p4, d4), p4.prototype.createDispatcher = function() {
        return new n2();
      }, p4;
    }(a5);
    (function() {
      function d4() {
        this._events = new u4();
      }
      Object.defineProperty(d4.prototype, "events", {
        get: function() {
          return this._events;
        },
        enumerable: false,
        configurable: true
      }), d4.prototype.subscribe = function(p4, m) {
        this._events.get(p4).subscribe(m);
      }, d4.prototype.sub = function(p4, m) {
        this.subscribe(p4, m);
      }, d4.prototype.unsubscribe = function(p4, m) {
        this._events.get(p4).unsubscribe(m);
      }, d4.prototype.unsub = function(p4, m) {
        this.unsubscribe(p4, m);
      }, d4.prototype.one = function(p4, m) {
        this._events.get(p4).one(m);
      }, d4.prototype.has = function(p4, m) {
        return this._events.get(p4).has(m);
      };
    })(), function() {
      function d4() {
        this._events = new c5();
      }
      Object.defineProperty(d4.prototype, "events", {
        get: function() {
          return this._events;
        },
        enumerable: false,
        configurable: true
      }), d4.prototype.subscribe = function(p4, m) {
        this._events.get(p4).subscribe(m);
      }, d4.prototype.sub = function(p4, m) {
        this.subscribe(p4, m);
      }, d4.prototype.one = function(p4, m) {
        this._events.get(p4).one(m);
      }, d4.prototype.has = function(p4, m) {
        return this._events.get(p4).has(m);
      }, d4.prototype.unsubscribe = function(p4, m) {
        this._events.get(p4).unsubscribe(m);
      }, d4.prototype.unsub = function(p4, m) {
        this.unsubscribe(p4, m);
      };
    }(), function() {
      function d4() {
        this._events = new l2();
      }
      Object.defineProperty(d4.prototype, "events", {
        get: function() {
          return this._events;
        },
        enumerable: false,
        configurable: true
      }), d4.prototype.one = function(p4, m) {
        this._events.get(p4).one(m);
      }, d4.prototype.has = function(p4, m) {
        return this._events.get(p4).has(m);
      }, d4.prototype.subscribe = function(p4, m) {
        this._events.get(p4).subscribe(m);
      }, d4.prototype.sub = function(p4, m) {
        this.subscribe(p4, m);
      }, d4.prototype.unsubscribe = function(p4, m) {
        this._events.get(p4).unsubscribe(m);
      }, d4.prototype.unsub = function(p4, m) {
        this.unsubscribe(p4, m);
      };
    }();
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10(t3) {
        this._isStarted = false, this._isEventsStarted = false, this._gestureTimestamps = [], this._maxSensorSamples = 0, this._sensorsTimestampDeltaInMillis = 0, this._accelerometerList = [], this._gyroscopeList = [], this._linearAccelerometerList = [], this._rotationList = [], this.orientationImplementationFix = 1, this.delegate = t3, window.navigator.userAgent.match(
          /^.*(iPhone|iPad).*(OS\s[0-9]).*(CriOS|Version)\/[.0-9]*\sMobile.*$/i
        ) && (this.orientationImplementationFix = -1), this.accelerometerUpdateHandle = this.accelerometerUpdate.bind(this), this.orientationUpdateHandle = this.orientationUpdate.bind(this);
      }
      return Object.defineProperty(r10.prototype, "LAST_GESTURE_SENSOR_TIMEOUT_MILI_SECONDS", {
        get: function() {
          return 3e3;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "accX", {
        get: function() {
          return this._accX;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "accY", {
        get: function() {
          return this._accY;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "accZ", {
        get: function() {
          return this._accZ;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "lienarAccX", {
        get: function() {
          return this._lienarAccX;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "lienarAccY", {
        get: function() {
          return this._lienarAccY;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "lienarAccZ", {
        get: function() {
          return this._lienarAccZ;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "isStarted", {
        get: function() {
          return this._isStarted;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "rotX", {
        get: function() {
          return this._rotX;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "rotY", {
        get: function() {
          return this._rotY;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "rotZ", {
        get: function() {
          return this._rotZ;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "maxSensorSamples", {
        get: function() {
          return this._maxSensorSamples;
        },
        set: function(t3) {
          this._maxSensorSamples = t3;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "sensorsTimestampDeltaInMillis", {
        get: function() {
          return this._sensorsTimestampDeltaInMillis;
        },
        set: function(t3) {
          this._sensorsTimestampDeltaInMillis = t3;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "accelerometerList", {
        get: function() {
          return this.getRelevantSensorSamples(this._accelerometerList);
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "gyroscopeList", {
        get: function() {
          return this.getRelevantSensorSamples(this._gyroscopeList);
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "linearAccelerometerList", {
        get: function() {
          return this.getRelevantSensorSamples(this._linearAccelerometerList);
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "rotationList", {
        get: function() {
          return this._rotationList;
        },
        enumerable: false,
        configurable: true
      }), r10.prototype.start = function() {
        this._isStarted || (this._isStarted = true, s5._POSignalsUtils.Logger.debug("Sensor events started..."));
      }, r10.prototype.getRotationListCopy = function() {
        return this._rotationList ? Array.from(this._rotationList) : [];
      }, r10.prototype.stop = function() {
        this._isStarted && (window.DeviceMotionEvent != null && window.removeEventListener("devicemotion", this.accelerometerUpdateHandle, true), window.DeviceOrientationEvent && window.removeEventListener("deviceorientation", this.orientationUpdateHandle, true), this._isStarted = false, s5._POSignalsUtils.Logger.debug("Sensor events stopped"));
      }, r10.prototype.getRelevantSensorSamples = function(t3) {
        if (t3.length == 0 || this._sensorsTimestampDeltaInMillis < 1 || this._gestureTimestamps.length == 0)
          return t3;
        for (var e2 = /* @__PURE__ */ new Map(), n2 = null, i9 = 0, a5 = 0; a5 < t3.length; a5++)
          for (var u4 = 0; u4 < this._gestureTimestamps.length; u4++)
            (i9 = t3[a5].timestamp) >= (n2 = this._gestureTimestamps[u4]).start - this._sensorsTimestampDeltaInMillis && i9 <= n2.end + this._sensorsTimestampDeltaInMillis && e2.set(t3[a5].timestamp, t3[a5]);
        return s5._POSignalsUtils.Util.getValuesOfMap(e2);
      }, r10.prototype.stopEvents = function() {
        this._isEventsStarted && (window.DeviceMotionEvent != null && window.removeEventListener("devicemotion", this.accelerometerUpdateHandle, true), window.DeviceOrientationEvent && window.removeEventListener("deviceorientation", this.orientationUpdateHandle, true), this._isEventsStarted = false, s5._POSignalsUtils.Logger.debug("Sensor events stopped listening"));
      }, r10.prototype.startEvents = function() {
        this._isEventsStarted || (window.DeviceMotionEvent != null ? this.delegate.addEventListener(
          window,
          "devicemotion",
          this.accelerometerUpdateHandle,
          true
        ) : s5._POSignalsUtils.Logger.warn("DeviceMotion not supported!"), window.DeviceOrientationEvent ? this.delegate.addEventListener(
          window,
          "deviceorientation",
          this.orientationUpdateHandle,
          true
        ) : s5._POSignalsUtils.Logger.warn("DeviceOrientation not supported!"), s5._POSignalsUtils.Logger.debug("Sensor events start listening..."), this._isEventsStarted = true);
      }, r10.prototype.reset = function() {
        this._accelerometerList = [], this._gyroscopeList = [], this._linearAccelerometerList = [], this._rotationList = [], this._gestureTimestamps.length > 0 ? this._gestureTimestamps = [
          this._gestureTimestamps[this._gestureTimestamps.length - 1]
        ] : this._gestureTimestamps = [], this._accX = 0, this._accY = 0, this._accZ = 0, this._rotX = 0, this._rotY = 0, this._rotZ = 0;
      }, r10.prototype.onGesture = function(t3) {
        this._isEventsStarted || this.startEvents(), t3.events.length > 1 && this._gestureTimestamps.push({
          start: t3.events[0].eventTs,
          end: t3.events[t3.events.length - 1].eventTs
        });
      }, r10.prototype.puaseSensorsCollectionIfNoActivity = function(t3) {
        return (this._gestureTimestamps.length > 0 ? this._gestureTimestamps[this._gestureTimestamps.length - 1].end : 0) > 0 ? Math.abs(t3 - this._gestureTimestamps[this._gestureTimestamps.length - 1].end) > this.LAST_GESTURE_SENSOR_TIMEOUT_MILI_SECONDS && (this.stopEvents(), true) : (this.stopEvents(), true);
      }, r10.prototype.getDeviceAcceleration = function(t3) {
        return t3 && t3.x != null && t3.y != null && t3.z != null ? t3 : null;
      }, r10.prototype.accelerometerUpdate = function(t3) {
        try {
          if (!this.delegate.collectBehavioralData() || this.puaseSensorsCollectionIfNoActivity(s5._POSignalsUtils.Util.now()))
            return;
          var e2 = this.getDeviceAcceleration(t3.accelerationIncludingGravity);
          e2 && (this._accX = e2.x * this.orientationImplementationFix, this._accY = e2.y * this.orientationImplementationFix, this._accZ = e2.z, this.safeAddSensorSample(
            {
              x: this._accX,
              y: this._accY,
              z: this._accX,
              timestamp: s5._POSignalsUtils.Util.now()
            },
            this._accelerometerList
          ));
          var n2 = this.getDeviceAcceleration(t3.acceleration);
          n2 && (this._lienarAccX = n2.x * this.orientationImplementationFix, this._lienarAccY = n2.y * this.orientationImplementationFix, this._lienarAccZ = n2.z, this.safeAddSensorSample(
            {
              x: this._lienarAccX,
              y: this._lienarAccY,
              z: this._lienarAccZ,
              timestamp: s5._POSignalsUtils.Util.now()
            },
            this._linearAccelerometerList
          )), t3.rotationRate && t3.rotationRate.alpha != null && t3.rotationRate.beta != null && t3.rotationRate.gamma != null && (this._rotX = t3.rotationRate.alpha, this._rotY = t3.rotationRate.beta, this._rotZ = t3.rotationRate.gamma, this.safeAddSensorSample(
            {
              x: this._rotX,
              y: this._rotY,
              z: this._rotZ,
              timestamp: s5._POSignalsUtils.Util.now()
            },
            this._gyroscopeList
          ));
        } catch (i9) {
          s5._POSignalsUtils.Logger.warn("error in accelerometer handler", i9);
        }
      }, r10.prototype.orientationUpdate = function(t3) {
        try {
          if (!this.delegate.collectBehavioralData() || this.puaseSensorsCollectionIfNoActivity(s5._POSignalsUtils.Util.now()))
            return;
          t3.alpha != null && t3.beta != null && t3.gamma != null && this.safeAddSensorSample(
            { x: t3.alpha, y: t3.beta, z: t3.gamma, timestamp: s5._POSignalsUtils.Util.now() },
            this._rotationList
          );
        } catch (e2) {
          s5._POSignalsUtils.Logger.warn("error in orientation handler", e2);
        }
      }, r10.prototype.safeAddSensorSample = function(t3, e2) {
        this.maxSensorSamples > e2.length && e2.push(t3);
      }, r10;
    }();
    s5.Sensors = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10() {
        this._pointerParams = new s5.PointerParams();
      }
      return Object.defineProperty(r10, "instance", {
        get: function() {
          return r10._instance || (r10._instance = new r10()), r10._instance;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "pointerParams", {
        get: function() {
          return this._pointerParams;
        },
        enumerable: false,
        configurable: true
      }), r10;
    }();
    s5.PointerConfig = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2;
    (function(t3) {
      t3[t3.Up = 1] = "Up", t3[t3.Down = 2] = "Down", t3[t3.Left = 3] = "Left", t3[t3.Right = 4] = "Right";
    })(h2 || (h2 = {}));
    var r10 = function() {
      function t3(e2, n2) {
        this.BEHAVIORAL_TYPE = "gestures", this._isStarted = false, this._onGesture = new s5.EventDispatcher(), this.touchSnapshotsMap = /* @__PURE__ */ new Map(), this.snapshotStartTime = /* @__PURE__ */ new Map(), this.delegate = e2, this.sensors = n2, this.touchStartHandler = this.touchStart.bind(this), this.touchMoveHandler = this.touchMove.bind(this), this.touchEndHandler = this.touchEnd.bind(this), this.touchCancelHandler = this.touchCancel.bind(this);
      }
      return Object.defineProperty(t3.prototype, "onGesture", {
        get: function() {
          return this._onGesture.asEvent();
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(t3.prototype, "isStarted", {
        get: function() {
          return this._isStarted;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(t3.prototype, "SCROLL_MIN_DURATION", {
        get: function() {
          return 500;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(t3.prototype, "SWIPE_MAX_ANGLE", {
        get: function() {
          return 45;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(t3.prototype, "TAP_MOVEMENT_TRESHOLD", {
        get: function() {
          return 10;
        },
        enumerable: false,
        configurable: true
      }), t3.prototype.countEvents = function(e2) {
        for (var n2 = {}, i9 = 0, a5 = e2; i9 < a5.length; i9++) {
          var u4 = a5[i9];
          n2[u4.type] = (n2[u4.type] || 0) + 1;
        }
        return n2;
      }, t3.prototype.clearTouchSnapshots = function(e2) {
        this.touchSnapshotsMap.delete(e2), this.snapshotStartTime.delete(e2);
      }, t3.prototype.getTouchSnapshots = function(e2) {
        var n2;
        return this.touchSnapshotsMap.has(e2) ? n2 = this.touchSnapshotsMap.get(e2) : (n2 = [], this.touchSnapshotsMap.set(e2, n2)), n2;
      }, t3.prototype.isEmpty = function() {
        return this.touchSnapshotsMap.size === 0;
      }, t3.prototype.start = function() {
        this._isStarted || (this.delegate.addEventListener(document, "touchstart", this.touchStartHandler), this.delegate.addEventListener(document, "touchmove", this.touchMoveHandler), this.delegate.addEventListener(document, "touchend", this.touchEndHandler), this.delegate.addEventListener(document, "touchcancel", this.touchCancelHandler), this._isStarted = true);
      }, t3.prototype.stop = function() {
        this._isStarted && (document.removeEventListener("touchstart", this.touchStartHandler), document.removeEventListener("touchmove", this.touchMoveHandler), document.removeEventListener("touchend", this.touchEndHandler), document.removeEventListener("touchcancel", this.touchCancelHandler), this._isStarted = false);
      }, t3.prototype.touchStart = function(e2) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE) || s5.PointerConfig.instance.pointerParams.eventsToIgnore.has(e2.type))
            return;
          s5._POSignalsUtils.Logger.debug("touchstart(" + e2.changedTouches.length + ")", e2), e2.changedTouches.length > 0 && this.pushSnapshot(e2);
        } catch (n2) {
          s5._POSignalsUtils.Logger.warn("error in touchStart handler", n2);
        }
      }, t3.prototype.touchMove = function(e2) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE) || s5.PointerConfig.instance.pointerParams.eventsToIgnore.has(e2.type))
            return;
          s5._POSignalsUtils.Logger.debug("touchmove(" + e2.changedTouches.length + ")", e2), e2.changedTouches.length > 0 && this.pushSnapshot(e2);
        } catch (n2) {
          s5._POSignalsUtils.Logger.warn("error in touchMove handler", n2);
        }
      }, t3.prototype.touchEnd = function(e2) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE))
            return void this._onGesture.dispatch(this, null);
          if (s5.PointerConfig.instance.pointerParams.eventsToIgnore.has(e2.type))
            return;
          s5._POSignalsUtils.Logger.debug("touchend(" + e2.changedTouches.length + ")", e2), this.gestureEnd(e2);
        } catch (n2) {
          s5._POSignalsUtils.Logger.warn("error in touchEnd handler", n2);
        }
      }, t3.prototype.touchCancel = function(e2) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE))
            return void this._onGesture.dispatch(this, null);
          if (s5.PointerConfig.instance.pointerParams.eventsToIgnore.has(e2.type))
            return;
          s5._POSignalsUtils.Logger.debug("touchcancel(" + e2.changedTouches.length + ")", e2), this.gestureEnd(e2);
        } catch (n2) {
          s5._POSignalsUtils.Logger.warn("error in touchCancel handler", n2);
        }
      }, t3.prototype.gestureEnd = function(e2) {
        e2.changedTouches.length > 0 && this.pushSnapshot(e2);
        for (var n2 = 0; n2 < e2.changedTouches.length; n2++) {
          var i9 = e2.changedTouches.item(n2), a5 = this.getTouchSnapshots(i9.identifier);
          a5.length > 0 && (this.isTap(a5) ? this.dispatchGesture(s5.GestureType.Tap, i9.identifier) : this.dispatchGesture(this.calcGestureType(a5), i9.identifier));
        }
      }, t3.prototype.calcGestureType = function(e2) {
        var n2, i9 = this.getDirection(e2);
        if (this.isFling(e2))
          switch (i9) {
            case h2.Up:
              n2 = s5.GestureType.FlingUp;
              break;
            case h2.Right:
              n2 = s5.GestureType.FlingRight;
              break;
            case h2.Down:
              n2 = s5.GestureType.FlingDown;
              break;
            case h2.Left:
              n2 = s5.GestureType.FlingLeft;
          }
        else if (this.isScroll(e2))
          switch (i9) {
            case h2.Up:
              n2 = s5.GestureType.ScrollUp;
              break;
            case h2.Right:
              n2 = s5.GestureType.ScrollRight;
              break;
            case h2.Down:
              n2 = s5.GestureType.ScrollDown;
              break;
            case h2.Left:
              n2 = s5.GestureType.ScrollLeft;
          }
        return n2;
      }, t3.prototype.pushSnapshot = function(e2) {
        if (e2.changedTouches && e2.changedTouches.length > 0)
          for (var n2, i9 = function() {
            var c5 = e2.changedTouches.item(u4);
            n2 = c5.radiusX && c5.radiusY ? (c5.radiusX + c5.radiusY) / 2 : null, a5.snapshotStartTime.has(c5.identifier) || a5.snapshotStartTime.set(c5.identifier, (/* @__PURE__ */ new Date()).getTime());
            var l2 = a5.getTouchSnapshots(c5.identifier);
            l2.length < s5.PointerConfig.instance.pointerParams.maxSnapshotsCount && l2.push({
              type: e2.type,
              eventTs: e2.timeStamp,
              epochTs: (/* @__PURE__ */ new Date()).getTime(),
              relativeX: c5.screenX,
              relativeY: c5.screenY,
              x: c5.clientX,
              y: c5.clientY,
              pressure: c5.force,
              size: n2,
              xaccelerometer: a5.sensors.accX,
              yaccelerometer: a5.sensors.accY,
              zaccelerometer: a5.sensors.accZ,
              xlinearaccelerometer: a5.sensors.lienarAccX,
              ylinearaccelerometer: a5.sensors.lienarAccY,
              zlinearaccelerometer: a5.sensors.lienarAccZ,
              xrotation: a5.sensors.rotX,
              yrotation: a5.sensors.rotY,
              zrotation: a5.sensors.rotZ,
              radiusX: c5.radiusX,
              radiusY: c5.radiusY,
              rotationAngle: c5.rotationAngle,
              pageX: c5.pageX,
              pageY: c5.pageY,
              getX: function() {
                return c5.screenX;
              },
              getY: function() {
                return c5.screenY;
              }
            });
          }, a5 = this, u4 = 0; u4 < e2.changedTouches.length; u4++)
            i9();
      }, t3.prototype.dispatchGesture = function(e2, n2) {
        var i9 = this.touchSnapshotsMap.get(n2) || [], a5 = i9.filter(function(u4) {
          return u4.type === "touchmove";
        });
        this._onGesture.dispatch(this, {
          epochTs: this.snapshotStartTime.get(n2) || 0,
          counter: this.delegate.gesturesCounter,
          type: e2,
          events: i9,
          eventCounters: this.countEvents(i9),
          duration: this.delegate.getInteractionDuration(i9),
          additionalData: this.delegate.additionalData,
          uiControl: void 0,
          timeProximity: s5._POSignalsUtils.Util.calculateMeanTimeDeltasBetweenEvents(a5),
          meanEuclidean: s5._POSignalsUtils.Util.calculateMeanDistanceBetweenPoints(a5),
          reduction: {}
        }), this.clearTouchSnapshots(n2);
      }, t3.prototype.isTap = function(e2) {
        var n2 = Math.abs(e2[0].x - e2[1].x), i9 = Math.abs(e2[0].y - e2[1].y);
        return e2.length == 2 && n2 < this.TAP_MOVEMENT_TRESHOLD && i9 < this.TAP_MOVEMENT_TRESHOLD;
      }, t3.prototype.isFling = function(e2) {
        return e2.length > 1 && e2[e2.length - 1].eventTs - e2[0].eventTs < this.SCROLL_MIN_DURATION;
      }, t3.prototype.isScroll = function(e2) {
        return e2.length > 1 && e2[e2.length - 1].eventTs - e2[0].eventTs > this.SCROLL_MIN_DURATION;
      }, t3.prototype.getDirection = function(e2) {
        var n2 = this.calcAngle(e2[0], e2[e2.length - 1]);
        return n2 > 90 - this.SWIPE_MAX_ANGLE && n2 <= 90 + this.SWIPE_MAX_ANGLE ? h2.Up : n2 > 180 - this.SWIPE_MAX_ANGLE && n2 <= 180 + this.SWIPE_MAX_ANGLE ? h2.Right : n2 > 270 - this.SWIPE_MAX_ANGLE && n2 <= 270 + this.SWIPE_MAX_ANGLE ? h2.Down : h2.Left;
      }, t3.prototype.calcAngle = function(e2, n2) {
        return 180 * Math.atan2(n2.y - e2.y, n2.x - e2.x) / Math.PI + 180;
      }, t3;
    }();
    s5.GestureEvents = r10;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10(t3) {
        this.key = t3, this.cache = this.loadFromStorage();
      }
      return r10.prototype.loadFromStorage = function() {
        var t3 = r10.sessionStorage.getItem(this.key);
        return t3 || (t3 = JSON.stringify([])), JSON.parse(t3);
      }, r10.prototype.get = function() {
        return this.cache;
      }, Object.defineProperty(r10.prototype, "length", {
        get: function() {
          return this.cache.length;
        },
        enumerable: false,
        configurable: true
      }), r10.prototype.push = function(t3) {
        var e2 = this.cache.push(t3);
        return r10.sessionStorage.setItem(this.key, JSON.stringify(this.cache)), e2;
      }, r10.prototype.set = function(t3) {
        this.cache = t3, r10.sessionStorage.setItem(this.key, JSON.stringify(this.cache));
      }, r10.prototype.remove = function(t3) {
        this.cache.splice(t3, 1), r10.sessionStorage.setItem(this.key, JSON.stringify(this.cache));
      }, r10.prototype.concat = function(t3) {
        return this.cache.concat(t3);
      }, r10.prototype.clear = function() {
        this.cache = [], r10.sessionStorage.removeItem(this.key);
      }, r10.sessionStorage = s5._POSignalsStorage.SessionStorage.instance.sessionStorage, r10;
    }();
    s5.StorageArray = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10() {
        this.MAX_TAGS = 10, this._tags = new s5.StorageArray(s5._POSignalsUtils.Constants.CAPTURED_TAGS);
      }
      return Object.defineProperty(r10, "instance", {
        get: function() {
          return r10._instance || (r10._instance = new r10()), r10._instance;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "tags", {
        get: function() {
          return this._tags.get();
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "disableTags", {
        set: function(t3) {
          this._disableTags = t3;
        },
        enumerable: false,
        configurable: true
      }), r10.prototype.setTag = function(t3, e2) {
        var n2;
        if (!this._disableTags)
          if (s5.PointerConfig.instance.pointerParams.enabled)
            if (t3) {
              var i9 = s5.PointerConfig.instance.pointerParams.tagsBlacklistRegex;
              if (i9 && (t3.match(i9) || e2 != null && e2.match(i9)))
                s5._POSignalsUtils.Logger.info("Tag name or value is blacklisted");
              else if (!(this._tags.length >= this.MAX_TAGS)) {
                this._tags.push({
                  name: t3.trim(),
                  value: ((n2 = e2 == null ? void 0 : e2.trim) === null || n2 === void 0 ? void 0 : n2.call(e2)) || void 0,
                  epochTs: Date.now(),
                  timestamp: Date.now()
                });
                var a5 = e2 ? t3 + ":" + e2 : t3;
                s5._POSignalsUtils.Logger.info("Add tag: " + a5);
              }
            } else
              s5._POSignalsUtils.Logger.info("Can't add tag, missing name");
          else
            s5._POSignalsUtils.Logger.info("Can't add tag, PingOneSignals SDK is disabled");
      }, r10.prototype.reset = function() {
        this._tags.clear();
      }, r10;
    }();
    s5.Tags = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10(t3) {
        this.client = t3;
      }
      return r10.prototype.calculateStrategyResult = function(t3, e2) {
        return {
          shouldCollect: this.client.getBufferSize() < s5.PointerConfig.instance.pointerParams.bufferSize
        };
      }, r10;
    }();
    s5.FirstInteractionsStrategy = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2;
    (function(t3) {
      t3[t3.RICH = 3] = "RICH", t3[t3.CLICK = 2] = "CLICK", t3[t3.MOVE = 1] = "MOVE", t3[t3.POOR = 0] = "POOR";
    })(h2 || (h2 = {}));
    var r10 = function() {
      function t3(e2) {
        this.client = e2, this.MAX_INTERACTIONS_PER_TYPE = 5, this.MAX_MOUSE_AND_GESTURE = this.MAX_INTERACTIONS_PER_TYPE + 1, this.RICH_MOUSE_MOVES_AMOUNT = 8, this.MIN_KEYBOARD_EVENTS = 4;
      }
      return t3.prototype.isRichMouseInteraction = function(e2) {
        return e2.mousemove >= this.RICH_MOUSE_MOVES_AMOUNT && this.isClickInteraction(e2);
      }, t3.prototype.isClickInteraction = function(e2) {
        return e2.mousedown > 0 && e2.mouseup > 0;
      }, t3.prototype.isMoveInteraction = function(e2) {
        return e2.mousemove >= this.RICH_MOUSE_MOVES_AMOUNT;
      }, t3.prototype.classifyMouseInteraction = function(e2) {
        var n2 = s5._POSignalsUtils.Util.typesCounter(e2.events);
        return this.isRichMouseInteraction(n2) ? h2.RICH : this.isClickInteraction(n2) ? h2.CLICK : this.isMoveInteraction(n2) ? h2.MOVE : h2.POOR;
      }, t3.prototype.findMinPriorityGestureIndex = function(e2, n2) {
        if (n2.length === 0)
          return -1;
        for (var i9 = e2 ? -1 : 0, a5 = e2 ? e2.events.length : n2[0].events.length, u4 = 0; u4 < n2.length; u4++)
          n2[u4].events.length < a5 && (i9 = u4, a5 = n2[u4].events.length);
        return i9;
      }, t3.prototype.calculateStrategyResult = function(e2, n2) {
        var i9 = this.client.getBehavioralData();
        switch (n2) {
          case "mouse":
            if (i9.mouse.interactions.length < this.MAX_INTERACTIONS_PER_TYPE) {
              if (i9.touch.interactions.length + i9.mouse.interactions.length >= this.MAX_MOUSE_AND_GESTURE) {
                var a5 = this.findMinPriorityGestureIndex(null, i9.touch.interactions);
                if (a5 !== -1)
                  return { shouldCollect: true, remove: { type: "touch", index: a5 } };
              }
              return { shouldCollect: true };
            }
            var u4 = this.classifyMouseInteraction(e2);
            if (u4 === h2.POOR)
              return { shouldCollect: false };
            for (var c5 = -1, l2 = u4, d4 = 0; d4 < i9.mouse.interactions.length; d4++) {
              var p4 = this.classifyMouseInteraction(i9.mouse.interactions[d4]);
              p4 < l2 && (c5 = d4, l2 = p4);
            }
            return c5 === -1 ? { shouldCollect: false } : { shouldCollect: true, remove: { type: "mouse", index: c5 } };
          case "keyboard":
            if (i9.keyboard.interactions.length < this.MAX_INTERACTIONS_PER_TYPE)
              return { shouldCollect: true };
            if (e2.events.length < this.MIN_KEYBOARD_EVENTS)
              return { shouldCollect: false };
            for (d4 = 0; d4 < i9.keyboard.interactions.length; d4++)
              if (i9.keyboard.interactions[d4].events.length < this.MIN_KEYBOARD_EVENTS)
                return { shouldCollect: true, remove: { type: "keyboard", index: d4 } };
            return { shouldCollect: false };
          case "touch":
            if (i9.touch.interactions.length < this.MAX_INTERACTIONS_PER_TYPE && i9.touch.interactions.length + i9.mouse.interactions.length < this.MAX_MOUSE_AND_GESTURE)
              return { shouldCollect: true };
            var m = e2, k2 = this.findMinPriorityGestureIndex(m, i9.touch.interactions);
            return k2 === -1 ? { shouldCollect: false } : { shouldCollect: true, remove: { type: "touch", index: k2 } };
        }
      }, t3;
    }();
    s5.PriorityStrategy = r10;
  }(M2 || (M2 = {})), function(s5) {
    var h2;
    (function(t3) {
      t3[t3.FIRST_INTERACTIONS = 0] = "FIRST_INTERACTIONS", t3[t3.PRIORITY_INTERACTIONS = 1] = "PRIORITY_INTERACTIONS";
    })(h2 = s5.BufferingStrategyType || (s5.BufferingStrategyType = {}));
    var r10 = function() {
      function t3() {
      }
      return t3.createBufferingStrategy = function(e2, n2) {
        switch (e2) {
          case h2.FIRST_INTERACTIONS:
            return new s5.FirstInteractionsStrategy(n2);
          case h2.PRIORITY_INTERACTIONS:
            return new s5.PriorityStrategy(n2);
        }
      }, t3;
    }();
    s5.StrategyFactory = r10;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10(t3) {
        this.sessionData = t3, this.instanceUUID = s5._POSignalsUtils.Util.newGuid(), this._isBehavioralDataPaused = false, this.started = false, this.initQueue = new s5.PromiseQueue(1);
      }
      return r10.instance = function() {
        if (!this._instance) {
          var t3 = s5._POSignalsStorage.SessionStorage.instance;
          if (!document.body)
            throw s5._POSignalsUtils.Logger.error(
              "PingOne Signals can be started only after DOM Ready!"
            ), new Error("PingOne Signals can be started only after DOM Ready!");
          this._instance = new s5.Client(t3, s5.BufferingStrategyType.PRIORITY_INTERACTIONS);
        }
        return this._instance;
      }, r10.prototype.getData = function() {
        return Z(this, void 0, void 0, function() {
          return $(this, function(t3) {
            switch (t3.label) {
              case 0:
                if (!this.startedPromise)
                  throw new Error("SDK not initialized");
                return [4, this.startedPromise];
              case 1:
                return t3.sent(), [4, this.dataHandler.getData(Date.now())];
              case 2:
                return [2, t3.sent()];
            }
          });
        });
      }, r10.prototype.addTag = function(t3, e2) {
        s5.Tags.instance.setTag(t3, e2);
      }, r10.prototype.start = function(t3) {
        var e2, n2;
        return t3 === void 0 && (t3 = {}), Z(this, void 0, void 0, function() {
          var i9, a5;
          return $(this, function(u4) {
            switch (u4.label) {
              case 0:
                return (e2 = t3.waitForWindowLoad) === null || e2 === void 0 || e2 ? [4, this.loadEventPromise()] : [3, 2];
              case 1:
                u4.sent(), u4.label = 2;
              case 2:
                if (this.initParams = t3, this.validateStartParams(t3), this.clientVersion = s5._POSignalsUtils.Constants.CLIENT_VERSION, this.started)
                  return s5._POSignalsUtils.Logger.warn("SDK already initialized"), [2];
                this.browserInfo = new s5._POSignalsUtils.BrowserInfo(), s5._POSignalsUtils.Logger.isLogEnabled = !!t3.consoleLogEnabled || !!t3.devEnv, s5._POSignalsUtils.Logger.info("Starting Signals SDK..."), s5.Tags.instance.disableTags = !!this.initParams.disableTags, this.sessionData.setStorageConfig(t3), i9 = s5.PointerConfig.instance.pointerParams, a5 = {
                  additionalMediaCodecs: i9.additionalMediaCodecs,
                  browserInfo: this.browserInfo,
                  fingerprintTimeoutMillis: i9.fingerprintTimeoutMillis,
                  metadataBlackList: new Set(
                    i9.metadataBlackList.concat(t3.deviceAttributesToIgnore)
                  ),
                  propertyDescriptors: i9.propertyDescriptors,
                  webRtcUrl: i9.webRtcUrl,
                  dataPoints: i9.metadataDataPoints
                }, this.metadata = new s5._POSignalsMetadata.Metadata(this.sessionData, a5), this.dataHandler = new s5.DataHandler(
                  this.clientVersion,
                  this.instanceUUID,
                  this.initParams,
                  this.metadata,
                  this,
                  t3.externalIdentifiers,
                  this.sessionData
                ), ((n2 = this.initParams.behavioralDataCollection) === null || n2 === void 0 || n2) && this.refreshListening(), t3.lazyMetadata || this.metadata.getDeviceAttributes(), this.started = true;
                try {
                  this.logInit(), this.addStartupTags();
                } catch (c5) {
                  s5._POSignalsUtils.Logger.warn("SDK post init failed", c5);
                }
                return [2];
            }
          });
        });
      }, r10.prototype.logInit = function() {
        var t3, e2;
        s5._POSignalsUtils.Logger.info(
          "PingOne Signals initialized. " + JSON.stringify(
            {
              timestamp: (/* @__PURE__ */ new Date()).getTime(),
              sdkVersion: this.clientVersion,
              instanceUUID: this.instanceUUID,
              tabUUID: this.sessionData.tabUUID
            },
            null,
            2
          )
        );
        var n2 = function() {
          return s5._POSignalsUtils.Logger.info("Token Ready: " + window._pingOneSignalsToken);
        }, i9 = function() {
          s5._POSignalsUtils.Logger.info("Signals token fetch is disabled"), window._pingOneSignalsToken = void 0;
        };
        ((t3 = window._pingOneSignalsToken) === null || t3 === void 0 ? void 0 : t3.substring(0, 7)) === "skipped" ? i9() : ((e2 = window._pingOneSignalsToken) === null || e2 === void 0 ? void 0 : e2.substring(0, 13)) !== "uninitialized" && n2(), document.addEventListener("PingOneSignalsTokenReadyEvent", n2), document.addEventListener("PingOneSignalsTokenSkippedEvent", i9);
      }, Object.defineProperty(r10.prototype, "isBehavioralDataPaused", {
        get: function() {
          return this._isBehavioralDataPaused;
        },
        enumerable: false,
        configurable: true
      }), r10.prototype.getSignalsToken = function() {
        var t3 = "";
        if (typeof window._pingOneSignalsToken == "string" && 0 <= window._pingOneSignalsToken.indexOf(":")) {
          var e2 = window._pingOneSignalsToken.match(/t:(.*?)(&|$)/g);
          e2 && 0 < e2.length && (t3 = e2[0].replace(/&s*$/, "").replace(/t:/, ""));
        } else
          typeof window._pingOneSignalsToken == "string" && (t3 = window._pingOneSignalsToken);
        return t3;
      }, r10.prototype.pauseBehavioralData = function() {
        this._isBehavioralDataPaused || (this._isBehavioralDataPaused = true, this.addTag("SDK paused behaviorally"));
      }, r10.prototype.resumeBehavioralData = function() {
        this._isBehavioralDataPaused && (this._isBehavioralDataPaused = false, this.addTag("SDK resumed behaviorally"));
      }, r10.prototype.startSignals = function(t3) {
        return Z(this, void 0, void 0, function() {
          var e2, n2, i9 = this;
          return $(this, function(a5) {
            switch (a5.label) {
              case 0:
                return a5.trys.push([0, 2, , 3]), this.startedPromise = this.initQueue.add(function() {
                  return i9.start(t3);
                }), [4, this.startedPromise];
              case 1:
                return [2, a5.sent()];
              case 2:
                throw e2 = a5.sent(), n2 = {
                  id: s5._POSignalsUtils.POErrorCodes.INITIALIZATION_ERROR,
                  message: e2.message,
                  code: "SDK initialization failed."
                }, new Error(JSON.stringify(n2));
              case 3:
                return [2];
            }
          });
        });
      }, r10.prototype.validateStartParams = function(t3) {
        if (!document.body)
          throw s5._POSignalsUtils.Logger.error(
            "PingOne Signals can be started only after DOM Ready!"
          ), new Error("PingOne Signals can be started only after DOM Ready!");
        t3.externalIdentifiers = t3.externalIdentifiers || {};
      }, r10.prototype.loadEventPromise = function() {
        return Z(this, void 0, void 0, function() {
          return $(this, function(t3) {
            return [
              2,
              new Promise(function(e2) {
                document.readyState === "complete" ? e2() : window.addEventListener("load", function(n2) {
                  e2();
                });
              })
            ];
          });
        });
      }, r10.prototype.addStartupTags = function() {
        this.addTag("SDK started"), document.referrer && this.addTag("referrer", document.referrer), this.addTag("location", window.location.href);
      }, r10;
    }();
    s5.ClientBase = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10(t3) {
        this.BEHAVIORAL_TYPE = "indirect", this._isStarted = false, this._onClipboardEvent = new s5.EventDispatcher(), this.delegate = t3, this.onClipboardEventHandler = this.onEvent.bind(this);
      }
      return Object.defineProperty(r10.prototype, "isStarted", {
        get: function() {
          return this._isStarted;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "onClipboardEvent", {
        get: function() {
          return this._onClipboardEvent.asEvent();
        },
        enumerable: false,
        configurable: true
      }), r10.prototype.onEvent = function(t3) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE))
            return;
          this._onClipboardEvent.dispatch(this, this.createClipboardEvent(t3));
        } catch (e2) {
          s5._POSignalsUtils.Logger.warn("error in clipboard handler", e2);
        }
      }, r10.prototype.createClipboardEvent = function(t3) {
        var e2 = s5._POSignalsUtils.Util.getSrcElement(t3);
        return {
          category: "ClipboardEvent",
          type: t3.type,
          eventTs: t3.timeStamp,
          epochTs: (/* @__PURE__ */ new Date()).getTime(),
          additionalData: {
            locationHref: location.href,
            stId: this.delegate.getElementsStID(e2),
            elementId: e2 == null ? void 0 : e2.id
          }
        };
      }, r10.prototype.start = function() {
        this._isStarted || (this._isStarted = true, this.delegate.addEventListener(document, "cut", this.onClipboardEventHandler), this.delegate.addEventListener(document, "copy", this.onClipboardEventHandler), this.delegate.addEventListener(document, "paste", this.onClipboardEventHandler));
      }, r10.prototype.stop = function() {
        this._isStarted && (this._isStarted = false, document.removeEventListener("cut", this.onClipboardEventHandler), document.removeEventListener("copy", this.onClipboardEventHandler), document.removeEventListener("paste", this.onClipboardEventHandler));
      }, r10;
    }();
    s5.ClipboardEvents = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10(t3) {
        this.BEHAVIORAL_TYPE = "indirect", this._isStarted = false, this._onDragEvent = new s5.EventDispatcher(), this.delegate = t3, this.onDragEventHandler = this.onEvent.bind(this);
      }
      return Object.defineProperty(r10.prototype, "isStarted", {
        get: function() {
          return this._isStarted;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "onDragEvent", {
        get: function() {
          return this._onDragEvent.asEvent();
        },
        enumerable: false,
        configurable: true
      }), r10.prototype.createDragEvent = function(t3) {
        return {
          category: "DragEvent",
          type: t3.type,
          eventTs: t3.timeStamp,
          epochTs: (/* @__PURE__ */ new Date()).getTime(),
          additionalData: { locationHref: location.href }
        };
      }, r10.prototype.onEvent = function(t3) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE))
            return;
          this._onDragEvent.dispatch(this, this.createDragEvent(t3));
        } catch (e2) {
          s5._POSignalsUtils.Logger.warn("error in drag handler", e2);
        }
      }, r10.prototype.start = function() {
        this._isStarted || (this._isStarted = true, this.delegate.addEventListener(document, "dragstart", this.onDragEventHandler), this.delegate.addEventListener(document, "dragexit", this.onDragEventHandler), this.delegate.addEventListener(document, "drop", this.onDragEventHandler), this.delegate.addEventListener(document, "dragend", this.onDragEventHandler));
      }, r10.prototype.stop = function() {
        this._isStarted && (this._isStarted = false, document.removeEventListener("dragstart", this.onDragEventHandler), document.removeEventListener("dragexit", this.onDragEventHandler), document.removeEventListener("drop", this.onDragEventHandler), document.removeEventListener("dragend", this.onDragEventHandler));
      }, r10;
    }();
    s5.DragEvents = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10(t3) {
        this.BEHAVIORAL_TYPE = "indirect", this._isStarted = false, this._onFocusEvent = new s5.EventDispatcher(), this.delegate = t3, this.onFocusEventHandler = this.onEvent.bind(this);
      }
      return Object.defineProperty(r10.prototype, "isStarted", {
        get: function() {
          return this._isStarted;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "onFocusEvent", {
        get: function() {
          return this._onFocusEvent.asEvent();
        },
        enumerable: false,
        configurable: true
      }), r10.prototype.getRelatedTarget = function(t3) {
        if (!t3.relatedTarget)
          return { type: "", stId: "", elementId: "" };
        var e2 = {
          type: s5._POSignalsUtils.Util.getObjectType(t3.relatedTarget),
          stId: "",
          elementId: ""
        };
        t3.relatedTarget.id && (e2.elementId = t3.relatedTarget.id);
        try {
          var n2 = t3.relatedTarget;
          e2.stId = this.delegate.getElementsStID(n2);
        } catch (e3) {
        }
        return e2;
      }, r10.prototype.createFocusEvent = function(t3) {
        var e2 = s5._POSignalsUtils.Util.getSrcElement(t3), n2 = this.getRelatedTarget(t3);
        return {
          category: "FocusEvent",
          type: t3.type,
          eventTs: t3.timeStamp,
          epochTs: (/* @__PURE__ */ new Date()).getTime(),
          additionalData: {
            locationHref: location.href,
            stId: this.delegate.getElementsStID(e2),
            elementId: e2 ? e2.id : "",
            relatedTarget: n2
          }
        };
      }, r10.prototype.onEvent = function(t3) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE))
            return;
          this._onFocusEvent.dispatch(this, this.createFocusEvent(t3));
        } catch (e2) {
          s5._POSignalsUtils.Logger.warn("error in focus handler", e2);
        }
      }, r10.prototype.start = function() {
        this._isStarted || (this._isStarted = true, this.delegate.addEventListener(document, "DOMFocusIn", this.onFocusEventHandler), this.delegate.addEventListener(document, "DOMFocusOut", this.onFocusEventHandler), this.delegate.addEventListener(document, "focus", this.onFocusEventHandler), this.delegate.addEventListener(document, "focusin", this.onFocusEventHandler), this.delegate.addEventListener(document, "focusout", this.onFocusEventHandler));
      }, r10.prototype.stop = function() {
        this._isStarted && (this._isStarted = false, document.removeEventListener("DOMFocusIn", this.onFocusEventHandler), document.removeEventListener("DOMFocusOut", this.onFocusEventHandler), document.removeEventListener("focus", this.onFocusEventHandler), document.removeEventListener("focusin", this.onFocusEventHandler), document.removeEventListener("focusout", this.onFocusEventHandler));
      }, r10;
    }();
    s5.FocusEvents = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10(t3) {
        this.BEHAVIORAL_TYPE = "indirect", this._isStarted = false, this._onUIEvent = new s5.EventDispatcher(), this.delegate = t3, this.onUIEventHandler = this.onEvent.bind(this);
      }
      return Object.defineProperty(r10.prototype, "isStarted", {
        get: function() {
          return this._isStarted;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "onUIEvent", {
        get: function() {
          return this._onUIEvent.asEvent();
        },
        enumerable: false,
        configurable: true
      }), r10.prototype.createUIEvent = function(t3) {
        return {
          category: "UIEvent",
          type: t3.type,
          eventTs: t3.timeStamp,
          epochTs: (/* @__PURE__ */ new Date()).getTime(),
          additionalData: { locationHref: location.href }
        };
      }, r10.prototype.onEvent = function(t3) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE))
            return;
          this._onUIEvent.dispatch(this, this.createUIEvent(t3));
        } catch (e2) {
          s5._POSignalsUtils.Logger.warn("error in UIEvent handler", e2);
        }
      }, r10.prototype.start = function() {
        this._isStarted || (this._isStarted = true, this.delegate.addEventListener(document, "resize", this.onUIEventHandler), this.delegate.addEventListener(document, "scroll", this.onUIEventHandler), this.delegate.addEventListener(document, "select", this.onUIEventHandler));
      }, r10.prototype.stop = function() {
        this._isStarted && (this._isStarted = false, document.removeEventListener("resize", this.onUIEventHandler), document.removeEventListener("scroll", this.onUIEventHandler), document.removeEventListener("select", this.onUIEventHandler));
      }, r10;
    }();
    s5.UIEvents = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10(t3) {
        this.BEHAVIORAL_TYPE = "indirect", this.visibilityChangeEventName = "visibilitychange", this.hiddenProperty = "hidden", this._isStarted = false, this._onGeneralEvent = new s5.EventDispatcher(), this.delegate = t3, this.onGeneralEventHandler = this.onEvent.bind(this), this.onLangChangeHandler = this.onLangChangeEvent.bind(this), this.onOrientationChangeHandler = this.onOrientationChangeEvent.bind(this), this.onVisibilityChangeHandler = this.onVisibilityChangeEvent.bind(this), document.msHidden !== void 0 ? (this.hiddenProperty = "msHidden", this.visibilityChangeEventName = "msvisibilitychange") : document.webkitHidden !== void 0 && (this.hiddenProperty = "webkitHidden", this.visibilityChangeEventName = "webkitvisibilitychange");
      }
      return Object.defineProperty(r10.prototype, "isStarted", {
        get: function() {
          return this._isStarted;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "onGeneralEvent", {
        get: function() {
          return this._onGeneralEvent.asEvent();
        },
        enumerable: false,
        configurable: true
      }), r10.prototype.onEvent = function(t3) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE))
            return;
          this._onGeneralEvent.dispatch(this, this.createGeneralEvent(t3));
        } catch (e2) {
          s5._POSignalsUtils.Logger.warn("error in general event handler", e2);
        }
      }, r10.prototype.onLangChangeEvent = function(t3) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE))
            return;
          var e2 = this.createGeneralEvent(t3);
          this._onGeneralEvent.dispatch(this, e2);
        } catch (n2) {
          s5._POSignalsUtils.Logger.warn("error in LangChange event handler", n2);
        }
      }, r10.prototype.onOrientationChangeEvent = function(t3) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE))
            return;
          var e2 = this.createGeneralEvent(t3), n2 = s5._POSignalsUtils.Util.getDeviceOrientation();
          e2.additionalData.deviceOrientation = n2.orientation, e2.additionalData.deviceAngle = n2.angle, this._onGeneralEvent.dispatch(this, e2);
        } catch (i9) {
          s5._POSignalsUtils.Logger.warn("error in OrientationChange event handler", i9);
        }
      }, r10.prototype.onVisibilityChangeEvent = function(t3) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE))
            return;
          var e2 = this.createGeneralEvent(t3);
          e2.additionalData.hidden = !!document[this.hiddenProperty], document.visibilityState && (e2.additionalData.visibilityState = document.visibilityState.toString()), this._onGeneralEvent.dispatch(this, e2);
        } catch (n2) {
          s5._POSignalsUtils.Logger.warn("error in VisibilityChange event handler", n2);
        }
      }, r10.prototype.createGeneralEvent = function(t3) {
        return {
          category: "Event",
          type: t3.type,
          eventTs: t3.timeStamp,
          epochTs: (/* @__PURE__ */ new Date()).getTime(),
          additionalData: { locationHref: location.href }
        };
      }, r10.prototype.start = function() {
        this._isStarted || (this._isStarted = true, this.delegate.addEventListener(
          document,
          this.visibilityChangeEventName,
          this.onVisibilityChangeHandler
        ), this.delegate.addEventListener(document, "change", this.onGeneralEventHandler), this.delegate.addEventListener(
          document,
          "fullscreenchange",
          this.onGeneralEventHandler
        ), this.delegate.addEventListener(document, "invalid", this.onGeneralEventHandler), this.delegate.addEventListener(window, "languagechange", this.onLangChangeHandler), this.delegate.addEventListener(
          window,
          "orientationchange",
          this.onOrientationChangeHandler
        ), this.delegate.addEventListener(document, "seeked", this.onGeneralEventHandler), this.delegate.addEventListener(document, "seeking", this.onGeneralEventHandler), this.delegate.addEventListener(document, "selectstart", this.onGeneralEventHandler), this.delegate.addEventListener(
          document,
          "selectionchange",
          this.onGeneralEventHandler
        ), this.delegate.addEventListener(document, "submit", this.onGeneralEventHandler), this.delegate.addEventListener(document, "volumechange", this.onGeneralEventHandler), this.delegate.addEventListener(document, "reset", this.onGeneralEventHandler), this.delegate.addEventListener(document, "textInput", this.onGeneralEventHandler));
      }, r10.prototype.stop = function() {
        this._isStarted && (this._isStarted = false, document.removeEventListener(
          this.visibilityChangeEventName,
          this.onVisibilityChangeHandler
        ), document.removeEventListener("change", this.onGeneralEventHandler), document.removeEventListener("fullscreenchange", this.onGeneralEventHandler), document.removeEventListener("invalid", this.onGeneralEventHandler), window.removeEventListener("languagechange", this.onLangChangeHandler), window.removeEventListener("orientationchange", this.onOrientationChangeHandler), document.removeEventListener("seeked", this.onGeneralEventHandler), document.removeEventListener("seeking", this.onGeneralEventHandler), document.removeEventListener("selectstart", this.onGeneralEventHandler), document.removeEventListener("selectionchange", this.onGeneralEventHandler), document.removeEventListener("submit", this.onGeneralEventHandler), document.removeEventListener("volumechange", this.onGeneralEventHandler), document.removeEventListener("reset", this.onGeneralEventHandler), document.removeEventListener("textInput", this.onGeneralEventHandler));
      }, r10;
    }();
    s5.GeneralEvents = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10(t3) {
        this.DEFAULT_INDIRECT_IDLE_INTERVAL = 1e3, this.MAX_INDIRECT_EVENTS = 25, this._onIndirect = new s5.EventDispatcher(), this.indirectEvents = [], this.idleTimeInMillis = this.DEFAULT_INDIRECT_IDLE_INTERVAL, this.lastIndirectEventTimestamp = 0, this._isStarted = false, this.clipboardEvents = new s5.ClipboardEvents(t3), this.clipboardEvents.onClipboardEvent.subscribe(this.handleEvent.bind(this)), this.dragEvents = new s5.DragEvents(t3), this.dragEvents.onDragEvent.subscribe(this.handleEvent.bind(this)), this.focusEvents = new s5.FocusEvents(t3), this.focusEvents.onFocusEvent.subscribe(this.handleEvent.bind(this)), this.uiEvents = new s5.UIEvents(t3), this.uiEvents.onUIEvent.subscribe(this.handleEvent.bind(this)), this.generalEvents = new s5.GeneralEvents(t3), this.generalEvents.onGeneralEvent.subscribe(this.handleEvent.bind(this)), this.onTimeElapsedHandler = this.onTimeElapsed.bind(this);
      }
      return Object.defineProperty(r10.prototype, "onIndirect", {
        get: function() {
          return this._onIndirect.asEvent();
        },
        enumerable: false,
        configurable: true
      }), r10.prototype.onTimeElapsed = function() {
        return Z(this, void 0, void 0, function() {
          return $(this, function(t3) {
            return this.indirectEvents.length > 0 && (/* @__PURE__ */ new Date()).getTime() - this.lastIndirectEventTimestamp >= this.idleTimeInMillis && this.dispatch(), [2];
          });
        });
      }, r10.prototype.handleEvent = function(t3, e2) {
        this.lastIndirectEventTimestamp = (/* @__PURE__ */ new Date()).getTime(), this.pushEvent(e2);
      }, r10.prototype.pushEvent = function(t3) {
        this.indirectEvents.push(t3), this.indirectEvents.length >= this.MAX_INDIRECT_EVENTS && this.dispatch();
      }, r10.prototype.clearBuffer = function() {
        var t3 = { events: this.indirectEvents };
        return this.indirectEvents = [], t3;
      }, r10.prototype.dispatch = function() {
        try {
          clearInterval(this.updateIntervalHandle), this._onIndirect.dispatch(this, this.clearBuffer()), this.updateIntervalHandle = setInterval(
            this.onTimeElapsedHandler,
            s5.PointerConfig.instance.pointerParams.indirectIntervalMillis
          );
        } catch (t3) {
          s5._POSignalsUtils.Logger.warn("Failed to dispatch indirect events", t3);
        }
      }, Object.defineProperty(r10.prototype, "isStarted", {
        get: function() {
          return this._isStarted;
        },
        enumerable: false,
        configurable: true
      }), r10.prototype.start = function() {
        this._isStarted || (this.updateIntervalHandle = setInterval(
          this.onTimeElapsedHandler,
          s5.PointerConfig.instance.pointerParams.indirectIntervalMillis
        ), this.clipboardEvents.start(), this.dragEvents.start(), this.focusEvents.start(), this.uiEvents.start(), this.generalEvents.start(), this._isStarted = true);
      }, r10.prototype.stop = function() {
        this._isStarted && (this.clipboardEvents.stop(), this.dragEvents.stop(), this.focusEvents.stop(), this.uiEvents.stop(), this.generalEvents.stop(), clearInterval(this.updateIntervalHandle), this.updateIntervalHandle = null, this._isStarted = false);
      }, r10.prototype.unsubscribe = function() {
        this.clipboardEvents.onClipboardEvent.unsubscribe(this.handleEvent.bind(this)), this.dragEvents.onDragEvent.unsubscribe(this.handleEvent.bind(this)), this.focusEvents.onFocusEvent.unsubscribe(this.handleEvent.bind(this)), this.uiEvents.onUIEvent.unsubscribe(this.handleEvent.bind(this)), this.generalEvents.onGeneralEvent.unsubscribe(this.handleEvent.bind(this));
      }, r10;
    }();
    s5.IndirectClient = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10() {
        this.config = {}, this._cacheHash = 0, this.cache = /* @__PURE__ */ new Map();
      }
      return r10.prototype.refreshCssSelectors = function(t3) {
        try {
          if (!t3)
            return;
          var e2 = s5._POSignalsUtils.Util.hashCode(JSON.stringify(t3));
          if (this._cacheHash === e2)
            return;
          this.config = t3, this._cacheHash = e2, this.cache = /* @__PURE__ */ new Map();
        } catch (n2) {
          s5._POSignalsUtils.Logger.warn("Failed to set css selectors", n2);
        }
      }, r10.prototype.getIdentification = function(t3, e2) {
        if (this.cache.get(t3) === null)
          return null;
        if (this.cache.get(t3) !== void 0)
          return this.cache.get(t3);
        for (var n2 in this.config)
          try {
            if (!this.config.hasOwnProperty(n2))
              continue;
            var i9 = this.config[n2] || [];
            s5._POSignalsUtils.Util.isArray(i9) || (i9 = [].concat(i9));
            for (var a5 = 0, u4 = i9; a5 < u4.length; a5++) {
              var c5 = u4[a5];
              if (s5._POSignalsUtils.Util.isSelectorMatches(t3, c5, e2))
                return this.cache.set(t3, n2), n2;
            }
          } catch (l2) {
            s5._POSignalsUtils.Logger.warn("Failed to find selector for " + n2, l2);
          }
        return this.cache.set(t3, null), null;
      }, Object.defineProperty(r10.prototype, "cacheHash", {
        get: function() {
          return this._cacheHash;
        },
        enumerable: false,
        configurable: true
      }), r10;
    }();
    s5.ElementsIdentifications = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10(t3, e2) {
        this.BEHAVIORAL_TYPE = "eventKeyboard", this._isStarted = false, this._onInteraction = new s5.EventDispatcher(), this._onEnterPress = new s5.EventDispatcher(), this._onObfuscatedValue = new s5.EventDispatcher(), this.interactionsMap = /* @__PURE__ */ new Map(), this._fieldsIdentifications = new s5.ElementsIdentifications(), this.keyStrokeMap = /* @__PURE__ */ new Map(), this.delegate = t3, this.uiControlManager = e2, this.onKeyDownHandle = this.onKeyDown.bind(this), this.onKeyUpHandle = this.onKeyUp.bind(this), this.onFocusHandle = this.onFocus.bind(this), this.onBlurHandle = this.onBlur.bind(this);
      }
      return Object.defineProperty(r10.prototype, "isStarted", {
        get: function() {
          return this._isStarted;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "onInteraction", {
        get: function() {
          return this._onInteraction.asEvent();
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "onEnterPress", {
        get: function() {
          return this._onEnterPress.asEvent();
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "onObfuscatedValue", {
        get: function() {
          return this._onObfuscatedValue.asEvent();
        },
        enumerable: false,
        configurable: true
      }), r10.prototype.refreshKeyboardCssSelectors = function(t3) {
        this._fieldsIdentifications.refreshCssSelectors(t3);
      }, Object.defineProperty(r10.prototype, "modifiersKeys", {
        get: function() {
          return [
            "Alt",
            "AltGraph",
            "CapsLock",
            "Control",
            "Fn",
            "FnLock",
            "Hyper",
            "Meta",
            "NumLock",
            "OS",
            "ScrollLock",
            "Shift",
            "Super",
            "Symbol",
            "SymbolLock"
          ];
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "specialKeys", {
        get: function() {
          return [
            "Tab",
            "Shift",
            "Backspace",
            "Enter",
            "CapsLock",
            "Meta",
            "Delete",
            "Alt",
            "ArrowDown",
            "ArrowUp",
            "Control",
            "ArrowLeft",
            "End",
            "Unidentified",
            "Home",
            "ArrowRight",
            "Insert",
            "Pause",
            "PageDown",
            "PageUp",
            "F1",
            "F2",
            "F3",
            "F4",
            "F5",
            "F6",
            "F7",
            "F8",
            "F9",
            "F10",
            "F11",
            "F12",
            "AltGraph",
            "Escape"
          ];
        },
        enumerable: false,
        configurable: true
      }), r10.prototype.countEvent = function(t3, e2) {
        e2 && (e2.eventCounters[t3] = (e2.eventCounters[t3] || 0) + 1);
      }, r10.prototype.clearBuffer = function() {
        var t3 = s5._POSignalsUtils.Util.getValuesOfMap(this.interactionsMap);
        return this.interactionsMap.clear(), t3;
      }, r10.prototype.start = function() {
        this._isStarted ? s5._POSignalsUtils.Logger.debug("Desktop Keyboard events already listening") : (this.delegate.addEventListener(document, "keydown", this.onKeyDownHandle), this.delegate.addEventListener(document, "keyup", this.onKeyUpHandle), this.delegate.addEventListener(document, "focus", this.onFocusHandle, true), this.delegate.addEventListener(document, "blur", this.onBlurHandle, true), this._isStarted = true, s5._POSignalsUtils.Logger.debug("Desktop Keyboard events start listening..."));
      }, r10.prototype.stop = function() {
        this._isStarted ? (document.removeEventListener("keydown", this.onKeyDownHandle), document.removeEventListener("keyup", this.onKeyUpHandle), document.removeEventListener("focus", this.onFocusHandle, true), document.removeEventListener("blur", this.onBlurHandle, true), this._isStarted = false, s5._POSignalsUtils.Logger.debug("Desktop Keyboard events stop listening...")) : s5._POSignalsUtils.Logger.debug("Desktop Keyboard events already stopped");
      }, r10.prototype.getInteractionFromElement = function(t3) {
        var e2, n2 = null, i9 = null, a5 = s5._POSignalsUtils.Util.getSrcElement(t3);
        if (a5 && a5 instanceof HTMLInputElement && !s5._POSignalsUtils.Util.isClickableInput(a5) && s5._POSignalsUtils.Util.isFunction(a5.getAttribute) && !(!((e2 = a5.hasAttribute) === null || e2 === void 0) && e2.call(a5, "data-st-ignore")) && !s5._POSignalsUtils.Util.anySelectorMatches(
          a5,
          s5.PointerConfig.instance.pointerParams.keyboardCssSelectorsBlacklist,
          0
        )) {
          i9 = this.delegate.getElementsStID(a5);
          for (var u4 = s5.PointerConfig.instance.pointerParams.keyboardIdentifierAttributes, c5 = 0; c5 < u4.length && !i9; c5++)
            i9 = a5.getAttribute(u4[c5]);
          i9 && !s5.PointerConfig.instance.pointerParams.keyboardFieldBlackList.has(i9) && ((n2 = this.interactionsMap.get(a5)) || (n2 = {
            epochTs: (/* @__PURE__ */ new Date()).getTime(),
            stId: i9,
            elementId: s5._POSignalsUtils.Util.getAttribute(a5, "id"),
            name: s5._POSignalsUtils.Util.getAttribute(a5, "name"),
            type: s5._POSignalsUtils.Util.getAttribute(a5, "type"),
            events: [],
            counter: this.delegate.keyboardCounter,
            eventCounters: {},
            duration: 0,
            numOfDeletions: 0,
            additionalData: this.delegate.additionalData
          }, this.interactionsMap.set(a5, n2)));
        }
        return n2;
      }, r10.prototype.getKeyCode = function(t3) {
        return t3.keyCode ? t3.keyCode : t3.which ? t3.which : t3.code ? s5._POSignalsUtils.Util.hashCode(t3.code) : s5._POSignalsUtils.Util.hashCode(t3.key) + (t3.location || 0);
      }, r10.prototype.getKeyboardEvent = function(t3) {
        return t3 || window.event;
      }, r10.prototype.getKeystrokeId = function(t3, e2) {
        var n2, i9 = this.getKeyCode(t3);
        return e2 === "keyup" && (this.keyStrokeMap.has(i9) ? (n2 = this.keyStrokeMap.get(i9), this.keyStrokeMap.delete(i9)) : n2 = s5._POSignalsUtils.Util.newGuid()), e2 === "keydown" && (this.keyStrokeMap.has(i9) && t3.repeat ? n2 = this.keyStrokeMap.get(i9) : (n2 = s5._POSignalsUtils.Util.newGuid(), this.keyStrokeMap.set(i9, n2))), n2;
      }, r10.prototype.createKeyboardInteractionEvent = function(t3, e2) {
        var n2 = s5._POSignalsUtils.Util.getSrcElement(e2), i9 = n2.value ? n2.value.toString().length : 0;
        return {
          type: t3,
          eventTs: e2.timeStamp,
          epochTs: (/* @__PURE__ */ new Date()).getTime(),
          selectionStart: s5._POSignalsUtils.Util.getElementSelectionStart(n2),
          selectionEnd: s5._POSignalsUtils.Util.getElementSelectionEnd(n2),
          key: null,
          keystrokeId: null,
          currentLength: i9
        };
      }, r10.prototype.enrichKeyboardEvent = function(t3, e2) {
        (this.modifiersKeys.indexOf(t3.key) >= 0 || this.specialKeys.indexOf(t3.key) >= 0) && (e2.key = t3.key), e2.keystrokeId = this.getKeystrokeId(t3, e2.type);
        var n2 = s5._POSignalsUtils.Util.getSrcElement(t3);
        e2.currentLength = String(n2.value).length;
      }, r10.prototype.onFocus = function(t3) {
        var e2, n2;
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE))
            return void this._onInteraction.dispatch(this, null);
          t3 = this.getKeyboardEvent(t3);
          var i9 = this.getInteractionFromElement(t3);
          if (this.countEvent(t3.type, i9), s5.PointerConfig.instance.pointerParams.eventsToIgnore.has(t3.type))
            return;
          if (i9) {
            var a5 = this.createKeyboardInteractionEvent("focus", t3);
            i9.events.push(a5);
            var u4 = this.uiControlManager.createUIControlData(t3);
            u4 && (i9.uiControl = { uiElement: u4.uiElement, enrichedData: u4.enrichedData }, ((n2 = (e2 = u4.uiElement) === null || e2 === void 0 ? void 0 : e2.id) === null || n2 === void 0 ? void 0 : n2.length) > 0 && s5._POSignalsUtils.Logger.info(
              "Typing in element with id '" + u4.uiElement.id + "'"
            ));
          }
        } catch (c5) {
          s5._POSignalsUtils.Logger.warn("error in keyboard focus handler", c5);
        }
      }, r10.prototype.onKeyUp = function(t3) {
        try {
          if ((t3 = this.getKeyboardEvent(t3)).keyCode !== 13 && t3.which !== 13 || this._onEnterPress.dispatch(this, s5._POSignalsUtils.Util.getSrcElement(t3)), !this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE))
            return void this._onInteraction.dispatch(this, null);
          var e2 = this.getInteractionFromElement(t3);
          if (this.countEvent(t3.type, e2), s5.PointerConfig.instance.pointerParams.eventsToIgnore.has(t3.type))
            return;
          if (e2) {
            var n2 = this.createKeyboardInteractionEvent("keyup", t3);
            this.enrichKeyboardEvent(t3, n2), e2.events.push(n2);
          } else
            this.keyStrokeMap.delete(this.getKeyCode(t3));
        } catch (i9) {
          s5._POSignalsUtils.Logger.warn("error in keyUp handler", i9);
        }
      }, r10.prototype.isEmpty = function() {
        return this.interactionsMap.size === 0;
      }, r10.prototype.onKeyDown = function(t3) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE))
            return void this._onInteraction.dispatch(this, null);
          t3 = this.getKeyboardEvent(t3);
          var e2 = this.getInteractionFromElement(t3);
          if (this.countEvent(t3.type, e2), s5.PointerConfig.instance.pointerParams.eventsToIgnore.has(t3.type))
            return;
          if (e2) {
            var n2 = this.createKeyboardInteractionEvent("keydown", t3);
            this.enrichKeyboardEvent(t3, n2), e2.events.push(n2);
          }
        } catch (i9) {
          s5._POSignalsUtils.Logger.warn("error in keyDown handler", i9);
        }
      }, r10.prototype.onBlur = function(t3) {
        try {
          t3 = this.getKeyboardEvent(t3);
          var e2 = this.getInteractionFromElement(t3);
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE))
            return void this._onInteraction.dispatch(this, null);
          if (this.countEvent(t3.type, e2), s5.PointerConfig.instance.pointerParams.eventsToIgnore.has(t3.type))
            return;
          if (e2) {
            var n2 = this.createKeyboardInteractionEvent("blur", t3);
            e2.events.push(n2), e2.duration = this.delegate.getInteractionDuration(e2.events), e2.numOfDeletions = this.calculateNumOfDeletions(e2.events);
            var i9 = s5._POSignalsUtils.Util.getSrcElement(t3);
            this.interactionsMap.delete(i9), this._onInteraction.dispatch(this, e2);
          }
        } catch (a5) {
          s5._POSignalsUtils.Logger.warn("error in blur handler", a5);
        }
      }, r10.prototype.calculateNumOfDeletions = function(t3) {
        if (!(t3 != null && t3[0]))
          return 0;
        for (var e2 = 0, n2 = t3[0].currentLength, i9 = 1; i9 < t3.length; i9++)
          t3[i9].currentLength < n2 && e2++, n2 = t3[i9].currentLength;
        return e2;
      }, Object.defineProperty(r10.prototype, "fieldsIdentifications", {
        get: function() {
          return this._fieldsIdentifications;
        },
        enumerable: false,
        configurable: true
      }), r10;
    }();
    s5.Keyboard = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10(t3, e2) {
        var n2, i9 = this, a5 = s5.PointerConfig.instance.pointerParams.uiModelingElementFilters, u4 = s5._POSignalsUtils.Util.getAttribute, c5 = (n2 = t3.getBoundingClientRect) === null || n2 === void 0 ? void 0 : n2.call(t3);
        this._htmlElement = t3, this._data = {
          location: this.getUIElementAttribute(a5.location, function() {
            return window.location.href;
          }),
          id: this.getUIElementAttribute(a5.id, function() {
            return u4(t3, "id");
          }),
          aria_label: this.getUIElementAttribute(a5.aria_label, function() {
            return u4(t3, "aria-label");
          }),
          data_st_field: this.getUIElementAttribute(a5.data_st_field, function() {
            return e2.getElementsStID(t3);
          }),
          data_st_tag: this.getUIElementAttribute(a5.data_st_tag, function() {
            return u4(t3, "data-st-tag");
          }),
          data_selenium: this.getUIElementAttribute(a5.data_selenium, function() {
            return u4(t3, "data-selenium");
          }),
          data_selenium_id: this.getUIElementAttribute(a5.data_selenium_id, function() {
            return u4(t3, "data-selenium-id");
          }),
          data_testid: this.getUIElementAttribute(a5.data_testid, function() {
            return u4(t3, "data-testid");
          }),
          data_test_id: this.getUIElementAttribute(a5.data_test_id, function() {
            return u4(t3, "data-test-id");
          }),
          data_qa_id: this.getUIElementAttribute(a5.data_qa_id, function() {
            return u4(t3, "data-qa-id");
          }),
          data_id: this.getUIElementAttribute(a5.data_id, function() {
            return u4(t3, "data-id");
          }),
          name: this.getUIElementAttribute(a5.name, function() {
            return u4(t3, "name");
          }),
          placeholder: this.getUIElementAttribute(a5.placeholder, function() {
            return u4(t3, "placeholder");
          }),
          role: this.getUIElementAttribute(a5.role, function() {
            return u4(t3, "role");
          }),
          type: this.getUIElementAttribute(a5.type, function() {
            return u4(t3, "type");
          }),
          nodeTypeInt: this.getUIElementAttribute(a5.nodeTypeInt, function() {
            return t3.nodeType;
          }),
          nodeName: this.getUIElementAttribute(a5.nodeName, function() {
            return t3.nodeName;
          }),
          cursorType: this.getUIElementAttribute(a5.cursorType, function() {
            return window.getComputedStyle(t3).cursor;
          }),
          text: this.getUIElementAttribute(a5.text, function() {
            return i9.getElementText(t3);
          }),
          textLength: this.getUIElementAttribute(a5.textLength, function() {
            var l2;
            return ((l2 = i9.getElementText(t3)) === null || l2 === void 0 ? void 0 : l2.length) || null;
          }),
          bottom: this.getUIElementAttribute(a5.bottom, function() {
            return c5 == null ? void 0 : c5.bottom;
          }),
          height: this.getUIElementAttribute(a5.height, function() {
            return c5 == null ? void 0 : c5.height;
          }),
          left: this.getUIElementAttribute(a5.left, function() {
            return c5 == null ? void 0 : c5.left;
          }),
          right: this.getUIElementAttribute(a5.right, function() {
            return c5 == null ? void 0 : c5.right;
          }),
          top: this.getUIElementAttribute(a5.top, function() {
            return c5 == null ? void 0 : c5.top;
          }),
          width: this.getUIElementAttribute(a5.width, function() {
            return c5 == null ? void 0 : c5.width;
          }),
          x: this.getUIElementAttribute(a5.x, function() {
            return c5 == null ? void 0 : c5.x;
          }),
          y: this.getUIElementAttribute(a5.y, function() {
            return c5 == null ? void 0 : c5.y;
          })
        }, this._data.elementId = this.getStrongestElementID();
      }
      return Object.defineProperty(r10.prototype, "data", {
        get: function() {
          return s5._POSignalsUtils.Util.filterReduce(this._data, function(t3) {
            return t3 != null && t3 !== "";
          });
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "htmlElement", {
        get: function() {
          return this._htmlElement;
        },
        enumerable: false,
        configurable: true
      }), r10.prototype.getUIElementAttribute = function(t3, e2) {
        var n2;
        try {
          if ((n2 = t3 == null ? void 0 : t3.enabled) === null || n2 === void 0 || n2) {
            var i9 = e2();
            return typeof i9 == "string" && (typeof (t3 == null ? void 0 : t3.maxLength) == "number" && i9.length > t3.maxLength && (i9 = i9.substring(0, t3.maxLength)), t3 != null && t3.filterRegex && (i9 = i9.replace(new RegExp(t3.filterRegex, "g"), "*"))), i9;
          }
        } catch (a5) {
          s5._POSignalsUtils.Logger.warn("Failed to add ui element attribute", a5);
        }
        return null;
      }, r10.prototype.getStrongestElementID = function() {
        return this._data.data_st_field || this._data.data_selenium_id || this._data.data_selenium || this._data.data_testid || this._data.data_test_id || this._data.data_qa_id || this._data.data_id || this._data.id || "";
      }, r10.prototype.getElementText = function(t3) {
        return t3 instanceof HTMLInputElement && !s5._POSignalsUtils.Util.isClickableInput(t3) ? null : s5._POSignalsUtils.Util.getElementText(t3);
      }, r10.prototype.equals = function(t3) {
        return !!t3 && !(t3.location && location.href.indexOf(t3.location) < 0) && (!t3.elementId || t3.elementId === this._data.elementId) && (!t3.id || t3.id === this._data.id) && (!t3.aria_label || t3.aria_label === this._data.aria_label) && (!t3.data_st_field || t3.data_st_field === this._data.data_st_field) && (!t3.data_st_tag || t3.data_st_tag === this._data.data_st_tag) && (!t3.data_selenium || t3.data_selenium === this._data.data_selenium) && (!t3.data_selenium_id || t3.data_selenium_id === this._data.data_selenium_id) && (!t3.data_testid || t3.data_testid === this._data.data_testid) && (!t3.data_test_id || t3.data_test_id === this._data.data_test_id) && (!t3.data_qa_id || t3.data_qa_id === this._data.data_qa_id) && (!t3.data_id || t3.data_id === this._data.data_id) && (!t3.name || t3.name === this._data.name) && (!t3.placeholder || t3.placeholder === this._data.placeholder) && (!t3.role || t3.role === this._data.role) && (!t3.type || t3.type === this._data.type) && (!t3.nodeTypeInt || t3.nodeTypeInt === this._data.nodeTypeInt) && (!t3.nodeName || t3.nodeName === this._data.nodeName) && (!t3.cursorType || t3.cursorType === this._data.cursorType) && (!t3.text || t3.text === this._data.text) && (!t3.textLength || t3.textLength === this._data.textLength) && (!t3.bottom || t3.bottom === this._data.bottom) && (!t3.height || t3.height === this._data.height) && (!t3.left || t3.left === this._data.left) && (!t3.right || t3.right === this._data.right) && (!t3.top || t3.top === this._data.top) && (!t3.width || t3.width === this._data.width) && (!t3.x || t3.x === this._data.x) && (!t3.y || t3.y === this._data.y);
      }, r10.createCssSelector = function(t3) {
        var e2 = "";
        return t3 != null && t3.nodeName && (e2 += t3.nodeName.toLowerCase()), t3 != null && t3.id && (e2 += '[id="' + t3.id + '"]'), t3 != null && t3.aria_label && (e2 += '[aria-label="' + t3.aria_label + '"]'), t3 != null && t3.data_st_field && (e2 += '[data-st-field="' + t3.data_st_field + '"]'), t3 != null && t3.data_st_tag && (e2 += '[data-st-tag="' + t3.data_st_tag + '"]'), t3 != null && t3.data_selenium && (e2 += '[data-selenium="' + t3.data_selenium + '"]'), t3 != null && t3.data_selenium_id && (e2 += '[data-selenium-id="' + t3.data_selenium_id + '"]'), t3 != null && t3.data_testid && (e2 += '[data-testid="' + t3.data_testid + '"]'), t3 != null && t3.data_test_id && (e2 += '[data-test-id="' + t3.data_test_id + '"]'), t3 != null && t3.data_qa_id && (e2 += '[data-qa-id="' + t3.data_qa_id + '"]'), t3 != null && t3.data_id && (e2 += '[data-id="' + t3.data_id + '"]'), t3 != null && t3.name && (e2 += '[name="' + t3.name + '"]'), t3 != null && t3.placeholder && (e2 += '[placeholder="' + t3.placeholder + '"]'), t3 != null && t3.role && (e2 += '[role="' + t3.role + '"]'), t3 != null && t3.type && (e2 += '[type="' + t3.type + '"]'), e2;
      }, r10;
    }();
    s5.UiElement = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10(t3) {
        this._clientDelegate = t3;
      }
      return r10.prototype.createUIControlData = function(t3) {
        var e2 = s5._POSignalsUtils.Util.getSrcElement(t3);
        if (!e2)
          return null;
        var n2 = s5.PointerConfig.instance.pointerParams.uiModelingBlacklistRegex;
        if (n2 && window.location.href.match(n2))
          return s5._POSignalsUtils.Logger.debug("ui control data is disabled for this url"), null;
        var i9 = new s5.UiElement(e2, this._clientDelegate);
        return this.findMatchingUiControl(i9) || { uiElement: i9.data };
      }, r10.prototype.findMatchingUiControl = function(t3, e2) {
        e2 === void 0 && (e2 = 0);
        try {
          var n2 = s5.PointerConfig.instance.pointerParams.uiControlsConfig;
          if (n2.length === 0 || e2 > s5.PointerConfig.instance.pointerParams.uiModelingMaxMatchingParents)
            return null;
          for (var i9 = false, a5 = 0, u4 = n2; a5 < u4.length; a5++) {
            var c5 = u4[a5];
            if ((c5.tagConfig || c5.enrichedData) && (i9 = true, t3.equals(c5.uiElement)))
              return {
                uiElement: t3.data,
                enrichedData: c5.enrichedData,
                tagConfig: c5.tagConfig
              };
          }
          if (!i9)
            return null;
          var l2 = t3.htmlElement.parentElement;
          if ((l2 == null ? void 0 : l2.nodeType) === Node.ELEMENT_NODE) {
            var d4 = new s5.UiElement(l2, this._clientDelegate);
            return this.findMatchingUiControl(d4, e2 + 1);
          }
        } catch (p4) {
          s5._POSignalsUtils.Logger.warn("failed to find matching ui control", p4);
        }
        return null;
      }, r10.prototype.convertToTagValueConfig = function(t3) {
        var e2;
        return {
          context: (e2 = t3 == null ? void 0 : t3.uiElement) === null || e2 === void 0 ? void 0 : e2.location,
          valueSelector: s5.UiElement.createCssSelector(
            t3 == null ? void 0 : t3.uiElement
          ),
          operation: t3 == null ? void 0 : t3.operation,
          valueMandatory: t3 == null ? void 0 : t3.valueMandatory
        };
      }, r10;
    }();
    s5.UIControlManager = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10(t3, e2) {
        this.BEHAVIORAL_TYPE = "mouse", this._isStarted = false, this._onInteraction = new s5.EventDispatcher(), this._onClickEvent = new s5.EventDispatcher(), this.lastMouseInteractionTimestamp = null, this.mouseEventsCounter = 0, this.eventCounters = {}, this.delegate = t3, this.uiControlManager = e2, this.wheelOptions = !!s5._POSignalsUtils.Util.isPassiveSupported() && { passive: true }, this.onPointerHandle = this.onPointerEvent.bind(this), this.onClickHandle = this.onClick.bind(this), this.onDblclickHandle = this.onMouseClickEvent.bind(this), this.onMousedownHandle = this.onMouseClickEvent.bind(this), this.onMousemoveHandle = this.onMouseEvent.bind(this), this.onMouseoutHandle = this.onMouseout.bind(this), this.onMouseoverHandle = this.onMouseEvent.bind(this), this.onMouseupHandle = this.onMouseClickEvent.bind(this), this.onWheelHandle = this.onMouseEvent.bind(this), this.interactionUpdateHandle = this.interactionUpdate.bind(this);
      }
      return Object.defineProperty(r10.prototype, "isStarted", {
        get: function() {
          return this._isStarted;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "onInteraction", {
        get: function() {
          return this._onInteraction.asEvent();
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "onClickEvent", {
        get: function() {
          return this._onClickEvent.asEvent();
        },
        enumerable: false,
        configurable: true
      }), r10.prototype.countEvent = function(t3) {
        this.eventCounters[t3] = (this.eventCounters[t3] || 0) + 1;
      }, r10.prototype.interactionUpdate = function() {
        this.lastMouseInteraction ? (/* @__PURE__ */ new Date()).getTime() - this.lastMouseInteractionTimestamp >= s5.PointerConfig.instance.pointerParams.mouseIdleTimeoutMillis && this.dispatch() : !this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE) && (/* @__PURE__ */ new Date()).getTime() - this.lastMouseInteractionTimestamp <= s5.PointerConfig.instance.pointerParams.mouseIntervalMillis && this.dispatch();
      }, r10.prototype.enrichLastInteraction = function() {
        var t3;
        if (this.lastMouseInteraction) {
          this.lastMouseInteraction.eventCounters = this.eventCounters, this.lastMouseInteraction.duration = this.delegate.getInteractionDuration(
            this.lastMouseInteraction.events
          );
          var e2 = (t3 = this.lastMouseInteraction.events) === null || t3 === void 0 ? void 0 : t3.filter(function(n2) {
            return n2.type === "mousemove";
          });
          this.lastMouseInteraction.timeProximity = s5._POSignalsUtils.Util.calculateMeanTimeDeltasBetweenEvents(e2), this.lastMouseInteraction.meanEuclidean = s5._POSignalsUtils.Util.calculateMeanDistanceBetweenPoints(e2);
        }
      }, r10.prototype.dispatch = function() {
        try {
          this.enrichLastInteraction(), this._onInteraction.dispatch(this, this.lastMouseInteraction), this.eventCounters = {}, this.lastMouseInteraction = null, this.mouseEventsCounter = 0;
        } catch (t3) {
          s5._POSignalsUtils.Logger.warn("Failed to dispatch mouse events", t3);
        }
      }, r10.prototype.updateInteraction = function(t3, e2) {
        this.lastMouseInteraction || (this.lastMouseInteraction = {
          epochTs: (/* @__PURE__ */ new Date()).getTime(),
          events: [],
          counter: this.delegate.mouseCounter,
          additionalData: this.delegate.additionalData,
          eventCounters: {},
          duration: 0,
          timeProximity: 0,
          uiControl: void 0,
          meanEuclidean: 0,
          reduction: {}
        }), this.lastMouseInteraction.events.push(t3), this.mouseEventsCounter++, e2 && (this.lastMouseInteraction.uiControl = {
          uiElement: e2.uiElement,
          enrichedData: e2.enrichedData
        }, this.delegate.addUiControlTags(e2.tagConfig)), this.mouseEventsCounter >= s5.PointerConfig.instance.pointerParams.maxMouseEvents && this.dispatch();
      }, r10.prototype.start = function() {
        this._isStarted ? s5._POSignalsUtils.Logger.debug("Desktop Mouse events already listening") : (this.delegate.addEventListener(document, "click", this.onClickHandle, true), this.delegate.addEventListener(document, "dblclick", this.onDblclickHandle), this.delegate.addEventListener(document, "mousedown", this.onMousedownHandle), this.delegate.addEventListener(document, "mousemove", this.onMousemoveHandle), this.delegate.addEventListener(document, "mouseout", this.onMouseoutHandle), this.delegate.addEventListener(document, "mouseover", this.onMouseoverHandle), this.delegate.addEventListener(document, "mouseup", this.onMouseupHandle), this.delegate.addEventListener(
          document,
          "wheel",
          this.onWheelHandle,
          this.wheelOptions
        ), this.delegate.addEventListener(document, "pointerover", this.onPointerHandle), this.delegate.addEventListener(document, "pointerenter", this.onPointerHandle), this.delegate.addEventListener(document, "pointerdown", this.onPointerHandle), this.delegate.addEventListener(document, "pointermove", this.onPointerHandle), this.delegate.addEventListener(document, "pointerup", this.onPointerHandle), this.delegate.addEventListener(document, "pointercancel", this.onPointerHandle), this.delegate.addEventListener(document, "pointerout", this.onPointerHandle), this.delegate.addEventListener(document, "pointerleave", this.onPointerHandle), this.updateIntervalHandle = setInterval(
          this.interactionUpdateHandle,
          s5.PointerConfig.instance.pointerParams.mouseIntervalMillis
        ), this._isStarted = true, s5._POSignalsUtils.Logger.debug("Desktop Mouse events start listening..."));
      }, r10.prototype.stop = function() {
        this._isStarted ? (document.removeEventListener("click", this.onClickHandle, true), document.removeEventListener("dblclick", this.onDblclickHandle), document.removeEventListener("mousedown", this.onMousedownHandle), document.removeEventListener("mousemove", this.onMousemoveHandle), document.removeEventListener("mouseout", this.onMouseoutHandle), document.removeEventListener("mouseover", this.onMouseoverHandle), document.removeEventListener("mouseup", this.onMouseupHandle), document.removeEventListener("wheel", this.onWheelHandle, this.wheelOptions), document.removeEventListener("pointerover", this.onPointerHandle), document.removeEventListener("pointerenter", this.onPointerHandle), document.removeEventListener("pointerdown", this.onPointerHandle), document.removeEventListener("pointermove", this.onPointerHandle), document.removeEventListener("pointerup", this.onPointerHandle), document.removeEventListener("pointercancel", this.onPointerHandle), document.removeEventListener("pointerout", this.onPointerHandle), document.removeEventListener("pointerleave", this.onPointerHandle), clearInterval(this.updateIntervalHandle), this.updateIntervalHandle = null, this._isStarted = false, s5._POSignalsUtils.Logger.debug("Desktop Mouse events stop listening...")) : s5._POSignalsUtils.Logger.debug("Desktop Mouse events already stopped");
      }, r10.prototype.onClick = function(t3) {
        var e2, n2;
        try {
          this.lastMouseInteractionTimestamp = (/* @__PURE__ */ new Date()).getTime();
          var i9 = s5._POSignalsUtils.Util.getSrcElement(t3);
          if (this._onClickEvent.dispatch(this, i9), !this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE) || (this.countEvent(t3.type), s5.PointerConfig.instance.pointerParams.eventsToIgnore.has(t3.type)))
            return;
          var a5 = this.uiControlManager.createUIControlData(t3);
          this.updateInteraction(this.createMouseClickEvent(t3.type, t3), a5), this.dispatch(), ((n2 = (e2 = a5 == null ? void 0 : a5.uiElement) === null || e2 === void 0 ? void 0 : e2.id) === null || n2 === void 0 ? void 0 : n2.length) > 0 && s5._POSignalsUtils.Logger.info(
            "Tapped on element with id '" + a5.uiElement.id + "'"
          );
        } catch (u4) {
          s5._POSignalsUtils.Logger.warn("error in " + t3.type + " handler", u4);
        }
      }, r10.prototype.onMouseout = function(t3) {
        try {
          this.onMouseEvent(t3);
          var e2 = t3.relatedTarget || t3.toElement;
          e2 && e2.nodeName !== "HTML" || this.dispatch();
        } catch (n2) {
          s5._POSignalsUtils.Logger.warn("error in " + t3.type + " handler", n2);
        }
      }, r10.prototype.onMouseEvent = function(t3) {
        try {
          if (t3.type !== "wheel" && (this.lastMouseInteractionTimestamp = (/* @__PURE__ */ new Date()).getTime()), !this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE) || (this.countEvent(t3.type), s5.PointerConfig.instance.pointerParams.eventsToIgnore.has(t3.type)))
            return;
          this.updateInteraction(this.createMouseEvent(t3.type, t3));
        } catch (e2) {
          s5._POSignalsUtils.Logger.warn("error in " + t3.type + " handler", e2);
        }
      }, r10.prototype.onMouseClickEvent = function(t3) {
        try {
          if (this.lastMouseInteractionTimestamp = (/* @__PURE__ */ new Date()).getTime(), !this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE) || (this.countEvent(t3.type), s5.PointerConfig.instance.pointerParams.eventsToIgnore.has(t3.type)))
            return;
          this.updateInteraction(this.createMouseClickEvent(t3.type, t3));
        } catch (e2) {
          s5._POSignalsUtils.Logger.warn("error in " + t3.type + " handler", e2);
        }
      }, r10.prototype.onPointerEvent = function(t3) {
        try {
          if (this.lastMouseInteractionTimestamp = (/* @__PURE__ */ new Date()).getTime(), !this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE) || (this.countEvent(t3.type), s5.PointerConfig.instance.pointerParams.eventsToIgnore.has(t3.type)))
            return;
          this.updateInteraction(this.createPointerEvent(t3.type, t3));
        } catch (e2) {
          s5._POSignalsUtils.Logger.warn("error in " + t3.type + " handler", e2);
        }
      }, r10.prototype.clearBuffer = function() {
        var t3 = null;
        return this.lastMouseInteraction && (t3 = this.lastMouseInteraction), this.lastMouseInteraction = null, t3;
      }, r10.prototype.isEmpty = function() {
        return !this.lastMouseInteraction;
      }, r10.prototype.createMouseEvent = function(t3, e2) {
        return {
          type: t3,
          eventTs: e2.timeStamp,
          epochTs: (/* @__PURE__ */ new Date()).getTime(),
          button: e2.button,
          offsetX: e2.offsetX,
          offsetY: e2.offsetY,
          pageX: e2.pageX,
          pageY: e2.pageY,
          screenX: e2.screenX,
          screenY: e2.screenY,
          getX: function() {
            return e2.screenX;
          },
          getY: function() {
            return e2.screenY;
          }
        };
      }, r10.prototype.createPointerEvent = function(t3, e2) {
        var n2 = this.createMouseEvent(t3, e2);
        return ve(ve({}, n2), {
          pointerId: e2.pointerId,
          width: e2.width,
          height: e2.height,
          pressure: e2.pressure,
          tangentialPressure: e2.tangentialPressure,
          tiltX: e2.tiltX,
          tiltY: e2.tiltY,
          twist: e2.twist,
          pointerType: e2.pointerType,
          isPrimary: e2.isPrimary
        });
      }, r10.prototype.createMouseClickEvent = function(t3, e2) {
        var n2 = this.createMouseEvent(t3, e2);
        if (e2.target && s5._POSignalsUtils.Util.isFunction(e2.target.getBoundingClientRect)) {
          var i9 = e2.target.getBoundingClientRect();
          n2.targetBottom = i9.bottom, n2.targetHeight = i9.height, n2.targetLeft = i9.left, n2.targetRight = i9.right, n2.targetTop = i9.top, n2.targetWidth = i9.width, n2.targetX = i9.x, n2.targetY = i9.y;
        }
        return n2;
      }, r10;
    }();
    s5.Mouse = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10(t3) {
        this.counter = 0, this.key = t3, this.counter = this.loadFromStorage();
      }
      return r10.prototype.loadFromStorage = function() {
        var t3 = r10.sessionStorage.getItem(this.key);
        return Number(t3) || 0;
      }, r10.prototype.get = function() {
        return this.counter;
      }, r10.prototype.increment = function(t3) {
        t3 === void 0 && (t3 = 1), this.counter += t3, r10.sessionStorage.setItem(this.key, this.counter);
      }, r10.prototype.decrement = function(t3) {
        t3 === void 0 && (t3 = 1), this.increment(-1 * t3);
      }, r10.prototype.reset = function() {
        this.counter = 0, r10.sessionStorage.removeItem(this.key);
      }, r10.sessionStorage = s5._POSignalsStorage.SessionStorage.instance.sessionStorage, r10;
    }();
    s5.StorageCounter = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10(t3) {
        this.mapKey = t3, this.cache = this.loadFromStorage();
      }
      return r10.prototype.loadFromStorage = function() {
        var t3 = r10.sessionStorage.getItem(this.mapKey);
        return t3 || (t3 = JSON.stringify({})), JSON.parse(t3);
      }, r10.prototype.asMap = function() {
        return this.cache;
      }, r10.prototype.set = function(t3, e2, n2) {
        n2 === void 0 && (n2 = true), this.cache[t3] = e2, n2 && r10.sessionStorage.setItem(this.mapKey, JSON.stringify(this.cache));
      }, r10.prototype.sync = function() {
        r10.sessionStorage.setItem(this.mapKey, JSON.stringify(this.cache));
      }, r10.prototype.get = function(t3) {
        return this.cache[t3];
      }, r10.prototype.delete = function(t3) {
        delete this.cache[t3], r10.sessionStorage.setItem(this.mapKey, JSON.stringify(this.cache));
      }, r10.prototype.values = function() {
        return s5._POSignalsUtils.Util.values(this.cache);
      }, r10.prototype.clear = function() {
        this.cache = {}, r10.sessionStorage.removeItem(this.mapKey);
      }, r10.sessionStorage = s5._POSignalsStorage.SessionStorage.instance.sessionStorage, r10;
    }();
    s5.StorageMap = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10() {
        this.config = {}, this._cacheHash = 0, this.cache = /* @__PURE__ */ new Map();
      }
      return r10.prototype.refreshConfig = function(t3) {
        try {
          if (!t3)
            return;
          var e2 = s5._POSignalsUtils.Util.hashCode(JSON.stringify(t3));
          if (this._cacheHash === e2)
            return;
          this.config = t3, this._cacheHash = e2, this.cache = /* @__PURE__ */ new Map();
        } catch (n2) {
          s5._POSignalsUtils.Logger.warn("Failed to set css selectors", n2);
        }
      }, r10.prototype.getMatchingTags = function(t3, e2) {
        var n2 = this.cache.get(t3);
        if (n2)
          return n2;
        var i9 = {};
        for (var a5 in this.config)
          try {
            if (!this.config.hasOwnProperty(a5))
              continue;
            var u4 = this.config[a5].selector || [];
            s5._POSignalsUtils.Util.isArray(u4) || (u4 = [].concat(u4));
            for (var c5 = 0, l2 = u4; c5 < l2.length; c5++) {
              var d4 = l2[c5];
              s5._POSignalsUtils.Util.isSelectorMatches(t3, d4, e2) && (i9[a5] = this.config[a5]);
            }
          } catch (p4) {
            s5._POSignalsUtils.Logger.warn("Failed to get the config for " + a5 + " tag", p4);
          }
        return this.cache.set(t3, i9), i9;
      }, r10.prototype.getValue = function(t3, e2) {
        if (e2 && t3)
          switch (e2 = e2.trim(), t3) {
            case "email_domain":
              return s5._POSignalsUtils.Util.getEmailDomain(e2);
            case "obfuscate":
              return "" + s5._POSignalsUtils.Util.mod(e2, 1e3);
            case "plain":
              return e2;
            case "zip":
              return e2.substr(0, 3);
            case "length":
              return "" + e2.length;
          }
        return "";
      }, Object.defineProperty(r10.prototype, "cacheHash", {
        get: function() {
          return this._cacheHash;
        },
        enumerable: false,
        configurable: true
      }), r10;
    }();
    s5.TagsIdentifications = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10() {
        this._reduceFactorMap = null;
      }
      return Object.defineProperty(r10.prototype, "reduceFactorMap", {
        get: function() {
          return this._reduceFactorMap;
        },
        set: function(t3) {
          this._reduceFactorMap = t3;
        },
        enumerable: false,
        configurable: true
      }), r10.prototype.reduceEventsByFactor = function(t3) {
        var e2 = this;
        try {
          if (!t3 || t3.length === 0 || !this.reduceFactorMap)
            return t3;
          for (var n2 = /* @__PURE__ */ new Map(), i9 = [], a5 = 0; a5 < t3.length; a5++)
            n2.get(t3[a5].type) ? n2.get(t3[a5].type).push(a5) : n2.set(t3[a5].type, [a5]);
          n2.forEach(function(c5, l2) {
            var d4 = e2.reduceFactorMap[l2] ? Number(e2.reduceFactorMap[l2]) : 0;
            e2.reduceByFactor(d4, c5, function(p4) {
              i9[c5[p4]] = true;
            });
          });
          var u4 = [];
          for (a5 = 0; a5 < t3.length; a5++)
            i9[a5] && u4.push(t3[a5]);
          return t3.length !== u4.length && s5._POSignalsUtils.Logger.debug(
            t3.length - u4.length + " events reduced out of " + t3.length
          ), u4;
        } catch (c5) {
          return s5._POSignalsUtils.Logger.warn("Failed to reduce events", c5), t3;
        }
      }, r10.prototype.reduceByFactor = function(t3, e2, n2) {
        t3 = Math.min(t3, 1);
        for (var i9 = Math.round(Math.max(e2.length * (1 - t3), 2)), a5 = (e2.length - 1) / (i9 - 1), u4 = Math.min(e2.length, i9), c5 = 0; c5 < u4; c5++)
          n2(Math.round(c5 * a5));
      }, r10;
    }();
    s5.ReduceFactor = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10(t3) {
        this.algorithm = t3;
      }
      return r10.prototype.reduce = function(t3, e2) {
        if (r10.TYPES_TO_REDUCE.indexOf(e2) === -1)
          return { keptEvents: t3, epsilon: 0 };
        if (t3.length <= r10.MIN_EVENTS_TO_REDUCE)
          return { keptEvents: t3, epsilon: 0 };
        var n2 = t3.length < 50 ? 0.55 : t3.length < 100 ? 0.35 : 0.2, i9 = t3.length < 50 ? 1 : t3.length < 100 ? 3 : 7, a5 = this.algorithm.reduceEvents(t3, i9), u4 = a5.length / t3.length;
        if (a5.length >= 10 && u4 >= n2)
          return { keptEvents: a5, epsilon: i9 };
        var c5 = t3.length < 50 ? 0.1 : t3.length < 100 ? 0.3 : 0.7, l2 = this.algorithm.reduceEvents(t3, c5), d4 = l2.length / t3.length;
        if (l2.length <= r10.MIN_EVENTS_TO_REDUCE || d4 <= n2)
          return { keptEvents: l2, epsilon: c5 };
        var p4 = (Math.min(i9, Math.pow(i9, u4 / n2)) * Math.abs(d4 - n2) + c5 * Math.abs(u4 - n2)) / Math.abs(u4 - d4);
        return (p4 < c5 || p4 > i9) && s5._POSignalsUtils.Logger.warn(
          "linear weighted average - calculated epsilon is out of range, lowEpsilon: " + c5 + ", highEpsilon: " + i9 + ", epsilon: " + p4
        ), { keptEvents: this.algorithm.reduceEvents(t3, p4), epsilon: p4 };
      }, r10.MIN_EVENTS_TO_REDUCE = 18, r10.TYPES_TO_REDUCE = ["mousemove", "touchmove"], r10;
    }();
    s5.RDPEpsilonStrategy = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10(t3) {
        this.rdpStrategy = t3;
      }
      return r10.prototype.reduceWithRPD = function(t3) {
        var e2 = this;
        if (!t3 || t3.length === 0)
          return { events: t3, reductionInfo: {} };
        for (var n2 = /* @__PURE__ */ new Map(), i9 = [], a5 = 0, u4 = t3; a5 < u4.length; a5++) {
          var c5 = u4[a5];
          n2.get(c5.type) ? n2.get(c5.type).push(c5) : n2.set(c5.type, [c5]);
        }
        var l2 = {};
        return n2.forEach(function(d4, p4) {
          var m = e2.rdpStrategy.reduce(d4, p4), k2 = m.keptEvents, x = m.epsilon;
          x > 0 && (l2[p4] = { epsilon: x, originalLength: d4.length, keptLength: k2.length }), i9 = i9.concat(k2);
        }), { events: s5._POSignalsUtils.Util.sortEventsByTimestamp(i9), reductionInfo: l2 };
      }, r10;
    }();
    s5.ReduceRDP = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10() {
      }
      return r10.prototype.getSqDist = function(t3, e2) {
        var n2 = t3.getX() - e2.getX(), i9 = t3.getY() - e2.getY();
        return n2 * n2 + i9 * i9;
      }, r10.prototype.getSqSegDist = function(t3, e2, n2) {
        var i9 = e2.getX(), a5 = e2.getY(), u4 = n2.getX() - i9, c5 = n2.getY() - a5;
        if (u4 !== 0 || c5 !== 0) {
          var l2 = ((t3.getX() - i9) * u4 + (t3.getY() - a5) * c5) / (u4 * u4 + c5 * c5);
          l2 > 1 ? (i9 = n2.getX(), a5 = n2.getY()) : l2 > 0 && (i9 += u4 * l2, a5 += c5 * l2);
        }
        return (u4 = t3.getX() - i9) * u4 + (c5 = t3.getY() - a5) * c5;
      }, r10.prototype.simplifyRadialDist = function(t3, e2) {
        for (var n2, i9 = t3[0], a5 = [i9], u4 = 1, c5 = t3.length; u4 < c5; u4++)
          n2 = t3[u4], this.getSqDist(n2, i9) > e2 && (a5.push(n2), i9 = n2);
        return i9 !== n2 && a5.push(n2), a5;
      }, r10.prototype.simplifyDPStep = function(t3, e2, n2, i9, a5) {
        for (var u4, c5 = i9, l2 = e2 + 1; l2 < n2; l2++) {
          var d4 = this.getSqSegDist(t3[l2], t3[e2], t3[n2]);
          d4 > c5 && (u4 = l2, c5 = d4);
        }
        c5 > i9 && (u4 - e2 > 1 && this.simplifyDPStep(t3, e2, u4, i9, a5), a5.push(t3[u4]), n2 - u4 > 1 && this.simplifyDPStep(t3, u4, n2, i9, a5));
      }, r10.prototype.simplifyDouglasPeucker = function(t3, e2) {
        var n2 = t3.length - 1, i9 = [t3[0]];
        return this.simplifyDPStep(t3, 0, n2, e2, i9), i9.push(t3[n2]), i9;
      }, r10.prototype.simplify = function(t3, e2, n2) {
        if (t3.length <= 2)
          return t3;
        var i9 = e2 !== void 0 ? e2 * e2 : 1;
        return t3 = n2 ? t3 : this.simplifyRadialDist(t3, i9), t3 = this.simplifyDouglasPeucker(t3, i9);
      }, r10.prototype.reduceEvents = function(t3, e2) {
        return this.simplify(t3, e2);
      }, r10;
    }();
    s5.RDPReduction = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10() {
      }
      return r10.prototype.filterMoveEvents = function(t3, e2) {
        if (t3.length <= 18)
          return t3;
        for (var n2 = t3.filter(function(d4) {
          return d4.type === e2;
        }), i9 = s5._POSignalsUtils.Util.keepFirstEventsWithDistance({
          events: n2,
          threshold: 200,
          min: 18,
          max: 30
        }), a5 = -1, u4 = {}, c5 = 0; c5 < t3.length; c5++) {
          var l2 = t3[c5];
          l2.type !== e2 && (l2.type !== "mousedown" ? u4[l2.type] || (i9.push(l2), u4[l2.type] = true) : a5 = c5);
        }
        return a5 >= 0 && i9.push(t3[a5]), s5._POSignalsUtils.Util.sortEventsByTimestamp(i9);
      }, r10;
    }();
    s5.EventsReduction = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10() {
        this.reduceFactor = new s5.ReduceFactor(), this.reduceRDP = new s5.ReduceRDP(new s5.RDPEpsilonStrategy(new s5.RDPReduction())), this.eventsReduction = new s5.EventsReduction();
      }
      return Object.defineProperty(r10.prototype, "reduceFactorMap", {
        set: function(t3) {
          this.reduceFactor.reduceFactorMap = t3;
        },
        enumerable: false,
        configurable: true
      }), r10.prototype.reduceGesture = function(t3) {
        var e2 = this.reduceRDP.reduceWithRPD(t3.events);
        t3.events = this.eventsReduction.filterMoveEvents(e2.events, "touchmove"), t3.reduction = e2.reductionInfo;
      }, r10.prototype.reduceKeyboardInteraction = function(t3) {
        t3.events = s5._POSignalsUtils.Util.filterArrayByLength(t3.events, 50);
      }, r10.prototype.reduceMouseInteraction = function(t3) {
        var e2 = this.reduceRDP.reduceWithRPD(t3.events);
        t3.events = this.eventsReduction.filterMoveEvents(e2.events, "mousemove"), t3.reduction = e2.reductionInfo;
      }, r10;
    }();
    s5.ReductionManager = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function(r10) {
      function t3(e2, n2) {
        var i9 = r10.call(this, e2) || this;
        return i9.tagsWithValueIdentifications = new s5.TagsIdentifications(), i9.reductionManager = new s5.ReductionManager(), i9.lastGestureTimestamp = 0, i9.currentBufferSize = 0, i9.bufferingStrategy = s5.StrategyFactory.createBufferingStrategy(n2, i9), i9.capturedKeyboardInteractions = new s5.StorageArray(
          s5._POSignalsUtils.Constants.CAPTURED_KEYBOARD_INTERACTIONS
        ), i9.keyboardInteractionsCount = new s5.StorageCounter(
          s5._POSignalsUtils.Constants.KEYBOARD_INTERACTIONS_COUNT
        ), i9.mouseInteractionsCount = new s5.StorageCounter(
          s5._POSignalsUtils.Constants.MOUSE_INTERACTIONS_COUNT
        ), i9.gesturesCount = new s5.StorageCounter(s5._POSignalsUtils.Constants.GESTURES_COUNT), i9.eventCounters = new s5.StorageMap(s5._POSignalsUtils.Constants.EVENT_COUNTERS), i9.capturedMouseInteractions = new s5.StorageArray(
          s5._POSignalsUtils.Constants.CAPTURED_MOUSE_INTERACTIONS
        ), i9.capturedGestures = new s5.StorageArray(
          s5._POSignalsUtils.Constants.CAPTURED_GESTURES
        ), i9.capturedIndirectEvents = new s5.StorageArray(
          s5._POSignalsUtils.Constants.CAPTURED_INDIRECT
        ), i9.currentBufferSize = i9.capturedGestures.length + i9.capturedMouseInteractions.length + i9.capturedKeyboardInteractions.length, i9.uiControlManager = new s5.UIControlManager(i9), i9.keyboard = new s5.Keyboard(i9, i9.uiControlManager), i9.keyboard.onInteraction.subscribe(i9.handleKeyboardInteraction.bind(i9)), i9.keyboard.onEnterPress.subscribe(i9.handleStTagOnEnter.bind(i9)), i9.keyboard.onObfuscatedValue.subscribe(i9.handleTagValueOnBlur.bind(i9)), i9.mouse = new s5.Mouse(i9, i9.uiControlManager), i9.mouse.onInteraction.subscribe(i9.handleMouseInteraction.bind(i9)), i9.mouse.onClickEvent.subscribe(i9.handleStTagOnClick.bind(i9)), i9.sensors = new s5.Sensors(i9), i9.gesture = new s5.GestureEvents(i9, i9.sensors), i9.gesture.onGesture.subscribe(i9.handleGesture.bind(i9)), i9.indirect = new s5.IndirectClient(i9), i9.indirect.onIndirect.subscribe(i9.handleIndirect.bind(i9)), i9.onUrlChangeHandler = i9.onUrlChange.bind(i9), i9.onEventHandler = i9.onEvent.bind(i9), i9;
      }
      return _e(t3, r10), Object.defineProperty(t3.prototype, "keyboardCounter", {
        get: function() {
          return this.keyboardInteractionsCount.get();
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(t3.prototype, "mouseCounter", {
        get: function() {
          return this.mouseInteractionsCount.get();
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(t3.prototype, "gesturesCounter", {
        get: function() {
          return this.gesturesCount.get();
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(t3.prototype, "additionalData", {
        get: function() {
          var e2 = s5._POSignalsUtils.Util.getDeviceOrientation();
          return {
            locationHref: location.href,
            devTools: s5._POSignalsUtils.Util.getDevToolsState(),
            innerWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
            innerHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
            outerWidth: window.outerWidth,
            outerHeight: window.outerHeight,
            width: screen.width,
            height: screen.height,
            availWidth: screen.availWidth,
            availHeight: screen.availHeight,
            pixelRatio: window.devicePixelRatio,
            deviceOrientation: e2.orientation,
            deviceAngle: e2.angle
          };
        },
        enumerable: false,
        configurable: true
      }), t3.prototype.getBehavioralData = function() {
        return this.clearIndirectBuffer(), {
          mouse: {
            count: this.mouseInteractionsCount.get(),
            interactions: this.capturedMouseInteractions.get()
          },
          keyboard: {
            count: this.keyboardInteractionsCount.get(),
            interactions: this.capturedKeyboardInteractions.get()
          },
          touch: {
            count: this.gesturesCount.get(),
            interactions: this.capturedGestures.get()
          },
          indirect: { events: this.capturedIndirectEvents.get() },
          eventCounters: this.eventCounters.asMap()
        };
      }, t3.prototype.getBufferSize = function() {
        return this.currentBufferSize;
      }, t3.prototype.getInteractionDuration = function(e2) {
        return (e2 == null ? void 0 : e2.length) > 0 ? e2[e2.length - 1].epochTs - e2[0].epochTs : 0;
      }, t3.prototype.dispose = function() {
        return Z(this, void 0, void 0, function() {
          return $(this, function(e2) {
            return this.stopListening(), this.keyboard.onInteraction.unsubscribe(
              this.handleKeyboardInteraction.bind(this)
            ), this.keyboard.onEnterPress.unsubscribe(this.handleStTagOnEnter.bind(this)), this.keyboard.onObfuscatedValue.unsubscribe(this.handleTagValueOnBlur.bind(this)), this.mouse.onInteraction.unsubscribe(this.handleMouseInteraction.bind(this)), this.mouse.onClickEvent.unsubscribe(this.handleStTagOnClick.bind(this)), this.gesture.onGesture.unsubscribe(this.handleGesture.bind(this)), this.indirect.unsubscribe(), this.indirect.onIndirect.unsubscribe(this.handleIndirect.bind(this)), [2];
          });
        });
      }, t3.prototype.collectBehavioralData = function(e2) {
        if (this.isBehavioralDataPaused)
          return false;
        var n2 = s5.PointerConfig.instance.pointerParams.behavioralBlacklist;
        return !(e2 && n2 && n2[e2]) || !window.location.href.match(n2[e2]);
      }, t3.prototype.getElementsStID = function(e2) {
        try {
          return s5._POSignalsUtils.Util.getAttribute(e2, "data-st-field") || this.keyboard.fieldsIdentifications.getIdentification(e2, 0) || "";
        } catch (n2) {
          return s5._POSignalsUtils.Logger.warn("failed to get element stId", n2), "";
        }
      }, t3.prototype.addEventListener = function(e2, n2, i9, a5) {
        s5.PointerConfig.instance.pointerParams.eventsBlackList.has(n2) || (e2.addEventListener(n2, this.onEventHandler, a5), e2.addEventListener(n2, i9, a5));
      }, t3.prototype.addUiControlTags = function(e2) {
        if ((e2 == null ? void 0 : e2.length) > 0)
          for (var n2 = false, i9 = 0, a5 = e2; i9 < a5.length; i9++) {
            var u4 = a5[i9];
            try {
              if (u4 != null && u4.name) {
                var c5 = this.uiControlManager.convertToTagValueConfig(u4.value);
                n2 = this.addSingleTagWithValue(u4.name, c5) || n2;
              }
            } catch (l2) {
              s5._POSignalsUtils.Logger.warn("failed to add tag config", l2);
            }
          }
      }, t3.prototype.refreshListening = function() {
        var e2 = s5.PointerConfig.instance;
        this.tagsWithValueIdentifications.refreshConfig(e2.pointerParams.remoteTags), this.reductionManager.reduceFactorMap = e2.pointerParams.eventsReduceFactorMap, this.keyboard.refreshKeyboardCssSelectors(e2.pointerParams.keyboardCssSelectors), this.sensors.maxSensorSamples = e2.pointerParams.maxSensorSamples, this.sensors.sensorsTimestampDeltaInMillis = e2.pointerParams.sensorsDeltaInMillis, this.mouse.start(), this.keyboard.start(), this.gesture.start(), this.indirect.start(), e2.pointerParams.maxSensorSamples == 0 ? this.sensors.stop() : this.sensors.start(), this.addEventListener(window, "_onlocationchange", this.onUrlChangeHandler), this.addEventListener(window, "popstate", this.onUrlChangeHandler);
      }, t3.prototype.addSingleTagWithValue = function(e2, n2) {
        try {
          if (n2 != null && n2.context && !window.location.href.match(n2.context))
            return false;
          var i9 = "";
          if (n2 != null && n2.operation && (n2 != null && n2.valueSelector)) {
            var a5 = document.querySelector(n2.valueSelector);
            if (a5) {
              var u4 = s5._POSignalsUtils.Util.getElementText(a5);
              i9 = this.tagsWithValueIdentifications.getValue(n2.operation, u4);
            }
          }
          if (n2 != null && n2.valueMandatory && !i9)
            return s5._POSignalsUtils.Logger.warn("tag '" + e2 + "' wasn't added. value is missing"), false;
          this.addTag(e2, i9);
        } catch (c5) {
          s5._POSignalsUtils.Logger.warn("failed to add " + e2 + " tag", c5);
        }
        return false;
      }, t3.prototype.addTagsWithValue = function(e2) {
        var n2 = false;
        for (var i9 in e2)
          e2.hasOwnProperty(i9) && (n2 = this.addSingleTagWithValue(i9, e2[i9]) || n2);
      }, t3.prototype.handleStTagOnEnter = function(e2, n2) {
        n2 instanceof HTMLInputElement && s5._POSignalsUtils.Util.isTextInput(n2) && this.handleStTagElement(n2);
      }, t3.prototype.handleTagValueOnBlur = function(e2, n2) {
        n2 && this.addTag(n2.fieldKey, n2.obfuscatedValue);
      }, t3.prototype.handleStTagOnClick = function(e2, n2) {
        n2 instanceof HTMLInputElement && !s5._POSignalsUtils.Util.isClickableInput(n2) || this.handleStTagElement(n2);
      }, t3.prototype.handleMouseInteraction = function(e2, n2) {
        if (n2) {
          this.mouseInteractionsCount.increment(), this.reductionManager.reduceMouseInteraction(n2);
          var i9 = this.bufferingStrategy.calculateStrategyResult(n2, "mouse");
          i9.shouldCollect && (i9.remove && this.removeInteraction(i9.remove), this.capturedMouseInteractions.push(n2), this.lastGestureTimestamp !== n2.events[n2.events.length - 1].eventTs && this.currentBufferSize++, this.eventCounters.sync());
        }
      }, t3.prototype.handleIndirect = function(e2, n2) {
        this.addIndirectEvents(n2), this.eventCounters.sync();
      }, t3.prototype.handleKeyboardInteraction = function(e2, n2) {
        if (n2) {
          this.keyboardInteractionsCount.increment(), this.reductionManager.reduceKeyboardInteraction(n2);
          var i9 = this.bufferingStrategy.calculateStrategyResult(n2, "keyboard");
          i9.shouldCollect && (i9.remove && this.removeInteraction(i9.remove), this.capturedKeyboardInteractions.push(n2), this.currentBufferSize++, this.eventCounters.sync());
        }
      }, t3.prototype.handleGesture = function(e2, n2) {
        var i9;
        if (this.isValidGesture(n2)) {
          this.gesturesCount.increment(), this.reductionManager.reduceGesture(n2);
          var a5 = this.bufferingStrategy.calculateStrategyResult(n2, "touch");
          a5.shouldCollect && (a5.remove && this.removeInteraction(a5.remove), this.sensors.onGesture(n2), this.capturedGestures.push(n2), this.currentBufferSize++, this.lastGestureTimestamp = (i9 = n2.events[n2.events.length - 1]) === null || i9 === void 0 ? void 0 : i9.eventTs, this.eventCounters.sync());
        }
      }, t3.prototype.clearIndirectBuffer = function() {
        var e2 = this.indirect.clearBuffer();
        this.addIndirectEvents(e2);
      }, t3.prototype.removeInteraction = function(e2) {
        switch (e2.type) {
          case "mouse":
            this.capturedMouseInteractions.remove(e2.index);
            break;
          case "keyboard":
            this.capturedKeyboardInteractions.remove(e2.index);
            break;
          case "touch":
            this.capturedGestures.remove(e2.index);
        }
      }, t3.prototype.addIndirectEvents = function(e2) {
        var n2;
        if (((n2 = e2 == null ? void 0 : e2.events) === null || n2 === void 0 ? void 0 : n2.length) > 0) {
          for (var i9 = [], a5 = s5._POSignalsUtils.Util.typesCounter(this.capturedIndirectEvents.get()), u4 = 0, c5 = e2.events; u4 < c5.length; u4++) {
            var l2 = c5[u4];
            s5.PointerConfig.instance.pointerParams.highPriorityIndirectEvents.has(l2.type) && this.capturedIndirectEvents.length + i9.length < s5.PointerConfig.instance.pointerParams.maxIndirectEvents && i9.push(l2), a5[l2.type] > 0 || (i9.push(l2), a5[l2.type] = 1);
          }
          this.capturedIndirectEvents.set(this.capturedIndirectEvents.concat(i9));
        }
      }, t3.prototype.onUrlChange = function() {
        this.addTag("location", window.location.href);
      }, t3.prototype.onEvent = function(e2) {
        this.isBehavioralDataPaused || this.eventCounters.set(e2.type, (this.eventCounters.get(e2.type) || 0) + 1, false);
      }, t3.prototype.handleStTagElement = function(e2) {
        if (e2) {
          var n2 = s5.PointerConfig.instance.pointerParams.maxSelectorChildren, i9 = this.tagsWithValueIdentifications.getMatchingTags(e2, n2);
          this.addTagsWithValue(i9);
          var a5 = s5._POSignalsUtils.Util.isSelectorMatches(e2, "[data-st-tag]", n2);
          if (a5 instanceof Element) {
            var u4 = s5._POSignalsUtils.Util.getAttribute(a5, "data-st-tag"), c5 = s5._POSignalsUtils.Util.getAttribute(a5, "data-st-tag-value");
            u4 && this.addTag(u4, c5);
          }
        }
      }, t3.prototype.stopListening = function() {
        this.keyboard.stop(), this.mouse.stop(), this.gesture.stop(), this.indirect.stop(), this.sensors.stop(), window.removeEventListener("_onlocationchange", this.onUrlChangeHandler), window.removeEventListener("popstate", this.onUrlChangeHandler);
      }, t3.prototype.clearBehavioralData = function() {
        this.capturedKeyboardInteractions.clear(), this.capturedMouseInteractions.clear(), this.capturedGestures.clear(), this.capturedIndirectEvents.clear(), this.sensors.reset(), s5.Tags.instance.reset(), this.currentBufferSize = 0, this.keyboardInteractionsCount.reset(), this.mouseInteractionsCount.reset(), this.gesturesCount.reset(), this.eventCounters.clear();
      }, t3.prototype.isValidGesture = function(e2) {
        var n2, i9;
        return ((n2 = e2 == null ? void 0 : e2.events) === null || n2 === void 0 ? void 0 : n2.length) > 0 && ((i9 = e2 == null ? void 0 : e2.events) === null || i9 === void 0 ? void 0 : i9.length) < s5.PointerConfig.instance.pointerParams.maxSnapshotsCount;
      }, t3;
    }(s5.ClientBase);
    s5.Client = h2;
  }(M2 || (M2 = {}));
  De = function() {
    function s5() {
    }
    return s5.getData = function() {
      return M2.ClientBase.instance().getData();
    }, s5.init = function(h2) {
      return M2._POSignalsUtils.Util.ieFix(), M2.ClientBase.instance().startSignals(h2);
    }, s5.initSilent = function(h2) {
      return this.init(h2);
    }, s5.pauseBehavioralData = function() {
      M2.ClientBase.instance().pauseBehavioralData();
    }, s5.resumeBehavioralData = function() {
      M2.ClientBase.instance().resumeBehavioralData();
    }, s5;
  }(), Ce = function(s5) {
    document.readyState !== "loading" ? s5() : document.addEventListener("DOMContentLoaded", s5);
  };
  Ce(function() {
    if (!window._pingOneSignalsReady) {
      var s5 = new CustomEvent("PingOneSignalsReadyEvent");
      document.dispatchEvent(s5), window._pingOneSignalsReady = true;
    }
  }), function(s5) {
    var h2 = function() {
      function r10(t3, e2, n2, i9, a5, u4, c5) {
        this.clientVersion = t3, this.instanceUUID = e2, this.initParams = n2, this.metadata = i9, this.behavioralDataHandler = a5, this.externalIdentifiers = u4, this.sessionStorage = c5;
      }
      return r10.prototype.getData = function(t3) {
        return Z(this, void 0, void 0, function() {
          var e2;
          return $(this, function(n2) {
            switch (n2.label) {
              case 0:
                return [4, this.getRiskData(t3)];
              case 1:
                return e2 = n2.sent(), [2, this.toString(e2)];
            }
          });
        });
      }, r10.prototype.getRiskData = function(t3) {
        return Z(this, void 0, void 0, function() {
          var e2, n2;
          return $(this, function(i9) {
            switch (i9.label) {
              case 0:
                return n2 = {}, [4, this.metadata.getDeviceAttributes()];
              case 1:
                return n2.deviceAttributes = i9.sent(), n2.behavioral = this.behavioralDataHandler.getBehavioralData(), n2.tags = s5.Tags.instance.tags, n2.sdkConfig = this.initParams, n2.epochTs = t3, n2.instanceUUID = this.instanceUUID, n2.tabUUID = s5._POSignalsStorage.SessionStorage.instance.tabUUID, n2.origin = location.origin, n2.href = location.href, n2.sdkVersion = this.clientVersion, n2.platform = "web", n2.clientToken = window._pingOneSignalsToken, n2.externalIdentifiers = this.externalIdentifiers, e2 = n2, this.sessionStorage.deviceTrust && (e2.deviceTrust = this.sessionStorage.deviceTrust), [2, e2];
            }
          });
        });
      }, r10.prototype.toString = function(t3) {
        var e2, n2 = this.metadata.getObfsInfo();
        try {
          e2 = s5._POSignalsUtils.Util.string2buf(JSON.stringify(t3));
        } catch (i9) {
          throw new Error("Failed to create data, " + i9.message);
        }
        try {
          e2 = s5.pako.gzip(e2);
        } catch (i9) {
          throw new Error("Failed to compress data, " + i9.message);
        }
        try {
          e2 = s5._POSignalsUtils.Util.encryptionBytes(e2, n2.key);
        } catch (i9) {
          throw new Error("failed to obfuscate data, " + i9.message);
        }
        try {
          return s5._POSignalsUtils.Util.base64Uint8Array(e2) + "." + btoa(n2.identifier);
        } catch (i9) {
          throw new Error("failed to encode data, " + i9.message);
        }
      }, r10;
    }();
    s5.DataHandler = h2;
  }(M2 || (M2 = {})), function(s5) {
    var h2 = function() {
      function r10() {
        this._configuration = {
          enabled: r10.ENABLED_DEFAULT,
          bufferSize: r10.BUFFER_SIZE_DEFAULT,
          maxSnapshotsCount: r10.MAX_SNAPSHOTS_COUNT_DEFAULT,
          sensors: r10.SENSORS_DEFAULT,
          metadataBlacklist: r10.METADATA_BLACK_LIST_DEFAULT,
          tagsBlacklistRegex: r10.TAGS_BLACK_LIST_REGEX_DEFAULT,
          behavioralBlacklist: r10.BEHAVIORAL_BLACK_LIST_DEFAULT,
          webRtcUrl: r10.WEB_RTC_URL_DEFAULT,
          eventsBlackList: r10.EVENTS_BLACK_LIST_DEFAULT,
          eventsToIgnore: r10.EVENTS_TO_IGNORE_DEFAULT,
          highPriorityIndirectEvents: r10.HIGH_PRIORITY_INDIRECT_EVENTS_DEFAULT,
          indirectIntervalMillis: r10.INDIRECT_INTERVAL_MILLIS_DEFAULT,
          mouseIntervalMillis: r10.MOUSE_INTERVAL_MILLIS_DEFAULT,
          mouseIdleTimeoutMillis: r10.MOUSE_IDLE_TIMEOUT_MILLIS_DEFAULT,
          maxMouseEvents: r10.MAX_MOUSE_EVENTS_DEFAULT,
          maxIndirectEvents: r10.MAX_INDIRECT_EVENTS_DEFAULT,
          keyboardFieldBlackList: r10.KEYBOARD_FIELD_BLACK_LIST_DEFAULT,
          keyboardCssSelectors: r10.KEYBOARD_CSS_SELECTORS_DEFAULT,
          keyboardCssSelectorsBlacklist: r10.KEYBOARD_CSS_SELECTORS_BLACKLIST_DEFAULT,
          keyboardIdentifierAttributes: r10.KEYBOARD_IDENTIFIER_ATTRIBUTES_DEFAULT,
          remoteTags: r10.REMOTE_TAGS_DEFAULT,
          maxSelectorChildren: r10.MAX_SELECTOR_CHILDREN_DEFAULT,
          eventsReduceFactorMap: r10.EVENTS_REDUCE_FACTOR_MAP_DEFAULT,
          propertyDescriptors: r10.PROPERTY_DESCRIPTORS_DEFAULT,
          additionalMediaCodecs: r10.ADDITIONAL_MEDIA_CODECS_DEFAULT,
          fingerprintTimeoutMillis: r10.FINGER_PRINT_TIMEOUT_MILLIS_DEFAULT,
          metadataDataPoints: r10.METADATA_DATA_POINTS_DEFAULT,
          uiModeling: r10.UI_MODELING_CONFIG_DEFAULT,
          uiControl: r10.UI_CONTROL_LIST_DEFAULT
        };
      }
      return r10.prototype.updateParams = function(t3) {
        t3 && (this._configuration = t3);
      }, Object.defineProperty(r10.prototype, "enabled", {
        get: function() {
          return typeof this._configuration.enabled == "boolean" ? this._configuration.enabled : r10.ENABLED_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "bufferSize", {
        get: function() {
          return typeof this._configuration.bufferSize == "number" && this._configuration.bufferSize > 0 ? this._configuration.bufferSize : r10.BUFFER_SIZE_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "maxSnapshotsCount", {
        get: function() {
          return typeof this._configuration.maxSnapshotsCount == "number" && this._configuration.maxSnapshotsCount >= 0 ? this._configuration.maxSnapshotsCount : r10.MAX_SNAPSHOTS_COUNT_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "maxSensorSamples", {
        get: function() {
          var t3 = this._configuration.sensors;
          return t3 && typeof t3.maxSensorSamples == "number" && t3.maxSensorSamples >= 0 ? t3.maxSensorSamples : r10.SENSORS_DEFAULT.maxSensorSamples;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "sensorsDeltaInMillis", {
        get: function() {
          var t3 = this._configuration.sensors;
          return t3 && typeof t3.sensorsDeltaInMillis == "number" && t3.sensorsDeltaInMillis >= 0 ? t3.sensorsDeltaInMillis : r10.SENSORS_DEFAULT.sensorsDeltaInMillis;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "metadataBlackList", {
        get: function() {
          var t3;
          return s5._POSignalsUtils.Util.isArray(this._configuration.metadataBlacklist) && ((t3 = this._configuration.metadataBlacklist) === null || t3 === void 0 ? void 0 : t3.length) > 0 ? this._configuration.metadataBlacklist : r10.METADATA_BLACK_LIST_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "behavioralBlacklist", {
        get: function() {
          return this._configuration.behavioralBlacklist ? this._configuration.behavioralBlacklist : r10.BEHAVIORAL_BLACK_LIST_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "tagsBlacklistRegex", {
        get: function() {
          return typeof this._configuration.tagsBlacklistRegex == "string" ? this._configuration.tagsBlacklistRegex : r10.TAGS_BLACK_LIST_REGEX_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "webRtcUrl", {
        get: function() {
          return typeof this._configuration.webRtcUrl == "string" ? this._configuration.webRtcUrl : r10.WEB_RTC_URL_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "eventsBlackList", {
        get: function() {
          return s5._POSignalsUtils.Util.isArray(this._configuration.eventsBlackList) && (this._configuration.eventsBlackList = new Set(
            this._configuration.eventsBlackList
          )), this._configuration.eventsBlackList instanceof Set ? this._configuration.eventsBlackList : r10.EVENTS_BLACK_LIST_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "eventsToIgnore", {
        get: function() {
          return s5._POSignalsUtils.Util.isArray(this._configuration.eventsToIgnore) && (this._configuration.eventsToIgnore = new Set(
            this._configuration.eventsToIgnore
          )), this._configuration.eventsToIgnore instanceof Set ? this._configuration.eventsToIgnore : r10.EVENTS_TO_IGNORE_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "highPriorityIndirectEvents", {
        get: function() {
          return s5._POSignalsUtils.Util.isArray(this._configuration.highPriorityIndirectEvents) && (this._configuration.highPriorityIndirectEvents = new Set(
            this._configuration.highPriorityIndirectEvents
          )), this._configuration.highPriorityIndirectEvents instanceof Set ? this._configuration.highPriorityIndirectEvents : r10.HIGH_PRIORITY_INDIRECT_EVENTS_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "indirectIntervalMillis", {
        get: function() {
          return typeof this._configuration.indirectIntervalMillis == "number" && this._configuration.indirectIntervalMillis > 0 ? this._configuration.indirectIntervalMillis : r10.INDIRECT_INTERVAL_MILLIS_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "mouseIntervalMillis", {
        get: function() {
          return typeof this._configuration.mouseIntervalMillis == "number" && this._configuration.mouseIntervalMillis > 0 ? this._configuration.mouseIntervalMillis : r10.MOUSE_INTERVAL_MILLIS_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "mouseIdleTimeoutMillis", {
        get: function() {
          return typeof this._configuration.mouseIdleTimeoutMillis == "number" && this._configuration.mouseIdleTimeoutMillis > 0 ? this._configuration.mouseIdleTimeoutMillis : r10.MOUSE_IDLE_TIMEOUT_MILLIS_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "maxMouseEvents", {
        get: function() {
          return typeof this._configuration.maxMouseEvents == "number" && this._configuration.maxMouseEvents >= 0 ? this._configuration.maxMouseEvents : r10.MAX_MOUSE_EVENTS_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "maxIndirectEvents", {
        get: function() {
          return typeof this._configuration.maxIndirectEvents == "number" && this._configuration.maxIndirectEvents >= 0 ? this._configuration.maxIndirectEvents : r10.MAX_INDIRECT_EVENTS_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "keyboardFieldBlackList", {
        get: function() {
          return s5._POSignalsUtils.Util.isArray(this._configuration.keyboardFieldBlackList) && (this._configuration.keyboardFieldBlackList = new Set(
            this._configuration.keyboardFieldBlackList
          )), this._configuration.keyboardFieldBlackList instanceof Set ? this._configuration.keyboardFieldBlackList : r10.KEYBOARD_FIELD_BLACK_LIST_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "keyboardCssSelectors", {
        get: function() {
          return this._configuration.keyboardCssSelectors ? this._configuration.keyboardCssSelectors : r10.KEYBOARD_CSS_SELECTORS_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "keyboardCssSelectorsBlacklist", {
        get: function() {
          return s5._POSignalsUtils.Util.isArray(
            this._configuration.keyboardCssSelectorsBlacklist
          ) ? this._configuration.keyboardCssSelectorsBlacklist : r10.KEYBOARD_CSS_SELECTORS_BLACKLIST_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "keyboardIdentifierAttributes", {
        get: function() {
          return s5._POSignalsUtils.Util.isArray(
            this._configuration.keyboardIdentifierAttributes
          ) ? this._configuration.keyboardIdentifierAttributes : r10.KEYBOARD_IDENTIFIER_ATTRIBUTES_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "remoteTags", {
        get: function() {
          return this._configuration.remoteTags ? this._configuration.remoteTags : r10.REMOTE_TAGS_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "maxSelectorChildren", {
        get: function() {
          return typeof this._configuration.maxSelectorChildren == "number" && this._configuration.maxSelectorChildren > 0 ? this._configuration.maxSelectorChildren : r10.MAX_SELECTOR_CHILDREN_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "eventsReduceFactorMap", {
        get: function() {
          return this._configuration.eventsReduceFactorMap ? this._configuration.eventsReduceFactorMap : r10.EVENTS_REDUCE_FACTOR_MAP_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "propertyDescriptors", {
        get: function() {
          return this._configuration.propertyDescriptors ? this._configuration.propertyDescriptors : r10.PROPERTY_DESCRIPTORS_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "additionalMediaCodecs", {
        get: function() {
          return this._configuration.additionalMediaCodecs ? this._configuration.additionalMediaCodecs : r10.ADDITIONAL_MEDIA_CODECS_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "fingerprintTimeoutMillis", {
        get: function() {
          return typeof this._configuration.fingerprintTimeoutMillis == "number" && this._configuration.fingerprintTimeoutMillis > 0 ? this._configuration.fingerprintTimeoutMillis : r10.FINGER_PRINT_TIMEOUT_MILLIS_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "metadataDataPoints", {
        get: function() {
          return this._configuration.metadataDataPoints ? this._configuration.metadataDataPoints : r10.METADATA_DATA_POINTS_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "uiModelingBlacklistRegex", {
        get: function() {
          var t3;
          return typeof ((t3 = this._configuration.uiModeling) === null || t3 === void 0 ? void 0 : t3.blacklistRegex) == "string" ? this._configuration.uiModeling.blacklistRegex : r10.UI_MODELING_CONFIG_DEFAULT.blacklistRegex;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "uiModelingElementFilters", {
        get: function() {
          var t3;
          return !((t3 = this._configuration.uiModeling) === null || t3 === void 0) && t3.uiElementFilters ? this._configuration.uiModeling.uiElementFilters : r10.UI_MODELING_CONFIG_DEFAULT.uiElementFilters;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "uiModelingMaxMatchingParents", {
        get: function() {
          var t3;
          return typeof ((t3 = this._configuration.uiModeling) === null || t3 === void 0 ? void 0 : t3.maxMatchingParents) == "number" ? this._configuration.uiModeling.maxMatchingParents : r10.UI_MODELING_CONFIG_DEFAULT.maxMatchingParents;
        },
        enumerable: false,
        configurable: true
      }), Object.defineProperty(r10.prototype, "uiControlsConfig", {
        get: function() {
          return s5._POSignalsUtils.Util.isArray(this._configuration.uiControl) ? this._configuration.uiControl : r10.UI_CONTROL_LIST_DEFAULT;
        },
        enumerable: false,
        configurable: true
      }), r10.ENABLED_DEFAULT = true, r10.BUFFER_SIZE_DEFAULT = 4, r10.MAX_SNAPSHOTS_COUNT_DEFAULT = 500, r10.METADATA_BLACK_LIST_DEFAULT = [], r10.TAGS_BLACK_LIST_REGEX_DEFAULT = "", r10.BEHAVIORAL_BLACK_LIST_DEFAULT = {}, r10.WEB_RTC_URL_DEFAULT = "", r10.EVENTS_BLACK_LIST_DEFAULT = /* @__PURE__ */ new Set(), r10.EVENTS_TO_IGNORE_DEFAULT = /* @__PURE__ */ new Set([
        "pointerover",
        "pointerenter",
        "pointerdown",
        "pointermove",
        "pointerup",
        "pointercancel",
        "pointerout",
        "pointerleave",
        "dragstart",
        "dragexit",
        "drop",
        "dragend"
      ]), r10.MAX_INDIRECT_EVENTS_DEFAULT = 15, r10.HIGH_PRIORITY_INDIRECT_EVENTS_DEFAULT = /* @__PURE__ */ new Set([
        "copy",
        "cut",
        "paste",
        "resize",
        "orientationchange",
        "languagechange",
        "submit",
        "select"
      ]), r10.INDIRECT_INTERVAL_MILLIS_DEFAULT = 1e3, r10.MOUSE_INTERVAL_MILLIS_DEFAULT = 1e3, r10.MOUSE_IDLE_TIMEOUT_MILLIS_DEFAULT = 1e3, r10.MAX_MOUSE_EVENTS_DEFAULT = 500, r10.KEYBOARD_FIELD_BLACK_LIST_DEFAULT = /* @__PURE__ */ new Set(), r10.KEYBOARD_CSS_SELECTORS_DEFAULT = {}, r10.KEYBOARD_CSS_SELECTORS_BLACKLIST_DEFAULT = [], r10.KEYBOARD_IDENTIFIER_ATTRIBUTES_DEFAULT = [
        "data-selenium",
        "data-selenium-id",
        "data-testid",
        "data-test-id",
        "data-qa-id",
        "data-id",
        "id"
      ], r10.REMOTE_TAGS_DEFAULT = {
        dv_form_submit: { selector: '[data-skbuttontype="form-submit"]' },
        login_attempt_email_domain: {
          selector: '[data-st-tag="login.login_attempt"]',
          operation: "email_domain",
          valueSelector: '[data-st-field="username"]',
          valueMandatory: true
        },
        login_attempt_hash: {
          selector: '[data-st-tag="login.login_attempt"]',
          operation: "obfuscate",
          valueSelector: '[data-st-field="username"]',
          valueMandatory: true
        },
        login_attempt_length: {
          selector: '[data-st-tag="login.login_attempt"]',
          operation: "length",
          valueSelector: '[data-st-field="username"]',
          valueMandatory: true
        },
        registration_attempt_email_domain: {
          selector: '[data-st-tag="registration.registration_attempt"]',
          operation: "email_domain",
          valueSelector: '[data-st-field="username"]',
          valueMandatory: true
        },
        registration_attempt_hash: {
          selector: '[data-st-tag="registration.registration_attempt"]',
          operation: "obfuscate",
          valueSelector: '[data-st-field="username"]',
          valueMandatory: true
        },
        registration_attempt_length: {
          selector: '[data-st-tag="registration.registration_attempt"]',
          operation: "length",
          valueSelector: '[data-st-field="username"]',
          valueMandatory: true
        }
      }, r10.MAX_SELECTOR_CHILDREN_DEFAULT = 2, r10.EVENTS_REDUCE_FACTOR_MAP_DEFAULT = {}, r10.PROPERTY_DESCRIPTORS_DEFAULT = {
        chrome: ["app", "csi", "loadtimes", "runtime"],
        navigator: ["webdriver"],
        Navigator: ["languages", "hardwareConcurrency"],
        window: ["outerWidth", "outerHeight"],
        Screen: ["width", "height"]
      }, r10.ADDITIONAL_MEDIA_CODECS_DEFAULT = {}, r10.FINGER_PRINT_TIMEOUT_MILLIS_DEFAULT = 3e3, r10.METADATA_DATA_POINTS_DEFAULT = {}, r10.UI_CONTROL_LIST_DEFAULT = [], r10.UI_MODELING_CONFIG_DEFAULT = {
        blacklistRegex: "",
        uiElementFilters: { text: { maxLength: 25 }, placeholder: { maxLength: 25 } },
        maxMatchingParents: 2
      }, r10.SENSORS_DEFAULT = { maxSensorSamples: 1, sensorsDeltaInMillis: 0 }, r10;
    }();
    s5.PointerParams = h2;
  }(M2 || (M2 = {})), window._POSignalsEntities = M2, window._pingOneSignals = De;
}
var M2;
var Z;
var $;
var ve;
var _e;
var De;
var Ce;
var index3 = /* @__PURE__ */ Object.freeze({
  __proto__: null
});
var browser$1 = {};
var canPromise$1 = function() {
  return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};
var qrcode = {};
var utils$1 = {};
var toSJISFunction;
var CODEWORDS_COUNT = [
  0,
  // Not used
  26,
  44,
  70,
  100,
  134,
  172,
  196,
  242,
  292,
  346,
  404,
  466,
  532,
  581,
  655,
  733,
  815,
  901,
  991,
  1085,
  1156,
  1258,
  1364,
  1474,
  1588,
  1706,
  1828,
  1921,
  2051,
  2185,
  2323,
  2465,
  2611,
  2761,
  2876,
  3034,
  3196,
  3362,
  3532,
  3706
];
utils$1.getSymbolSize = function getSymbolSize(version2) {
  if (!version2) throw new Error('"version" cannot be null or undefined');
  if (version2 < 1 || version2 > 40) throw new Error('"version" should be in range from 1 to 40');
  return version2 * 4 + 17;
};
utils$1.getSymbolTotalCodewords = function getSymbolTotalCodewords(version2) {
  return CODEWORDS_COUNT[version2];
};
utils$1.getBCHDigit = function(data) {
  let digit = 0;
  while (data !== 0) {
    digit++;
    data >>>= 1;
  }
  return digit;
};
utils$1.setToSJISFunction = function setToSJISFunction(f3) {
  if (typeof f3 !== "function") {
    throw new Error('"toSJISFunc" is not a valid function.');
  }
  toSJISFunction = f3;
};
utils$1.isKanjiModeEnabled = function() {
  return typeof toSJISFunction !== "undefined";
};
utils$1.toSJIS = function toSJIS(kanji2) {
  return toSJISFunction(kanji2);
};
var errorCorrectionLevel = {};
(function(exports) {
  exports.L = { bit: 1 };
  exports.M = { bit: 0 };
  exports.Q = { bit: 3 };
  exports.H = { bit: 2 };
  function fromString(string) {
    if (typeof string !== "string") {
      throw new Error("Param is not a string");
    }
    const lcStr = string.toLowerCase();
    switch (lcStr) {
      case "l":
      case "low":
        return exports.L;
      case "m":
      case "medium":
        return exports.M;
      case "q":
      case "quartile":
        return exports.Q;
      case "h":
      case "high":
        return exports.H;
      default:
        throw new Error("Unknown EC Level: " + string);
    }
  }
  exports.isValid = function isValid3(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
  };
  exports.from = function from(value, defaultValue) {
    if (exports.isValid(value)) {
      return value;
    }
    try {
      return fromString(value);
    } catch (e2) {
      return defaultValue;
    }
  };
})(errorCorrectionLevel);
function BitBuffer$1() {
  this.buffer = [];
  this.length = 0;
}
BitBuffer$1.prototype = {
  get: function(index) {
    const bufIndex = Math.floor(index / 8);
    return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
  },
  put: function(num, length) {
    for (let i9 = 0; i9 < length; i9++) {
      this.putBit((num >>> length - i9 - 1 & 1) === 1);
    }
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(bit) {
    const bufIndex = Math.floor(this.length / 8);
    if (this.buffer.length <= bufIndex) {
      this.buffer.push(0);
    }
    if (bit) {
      this.buffer[bufIndex] |= 128 >>> this.length % 8;
    }
    this.length++;
  }
};
var bitBuffer = BitBuffer$1;
function BitMatrix$1(size) {
  if (!size || size < 1) {
    throw new Error("BitMatrix size must be defined and greater than 0");
  }
  this.size = size;
  this.data = new Uint8Array(size * size);
  this.reservedBit = new Uint8Array(size * size);
}
BitMatrix$1.prototype.set = function(row, col, value, reserved) {
  const index = row * this.size + col;
  this.data[index] = value;
  if (reserved) this.reservedBit[index] = true;
};
BitMatrix$1.prototype.get = function(row, col) {
  return this.data[row * this.size + col];
};
BitMatrix$1.prototype.xor = function(row, col, value) {
  this.data[row * this.size + col] ^= value;
};
BitMatrix$1.prototype.isReserved = function(row, col) {
  return this.reservedBit[row * this.size + col];
};
var bitMatrix = BitMatrix$1;
var alignmentPattern = {};
(function(exports) {
  const getSymbolSize3 = utils$1.getSymbolSize;
  exports.getRowColCoords = function getRowColCoords(version2) {
    if (version2 === 1) return [];
    const posCount = Math.floor(version2 / 7) + 2;
    const size = getSymbolSize3(version2);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [size - 7];
    for (let i9 = 1; i9 < posCount - 1; i9++) {
      positions[i9] = positions[i9 - 1] - intervals;
    }
    positions.push(6);
    return positions.reverse();
  };
  exports.getPositions = function getPositions2(version2) {
    const coords = [];
    const pos = exports.getRowColCoords(version2);
    const posLength = pos.length;
    for (let i9 = 0; i9 < posLength; i9++) {
      for (let j = 0; j < posLength; j++) {
        if (i9 === 0 && j === 0 || // top-left
        i9 === 0 && j === posLength - 1 || // bottom-left
        i9 === posLength - 1 && j === 0) {
          continue;
        }
        coords.push([pos[i9], pos[j]]);
      }
    }
    return coords;
  };
})(alignmentPattern);
var finderPattern = {};
var getSymbolSize2 = utils$1.getSymbolSize;
var FINDER_PATTERN_SIZE = 7;
finderPattern.getPositions = function getPositions(version2) {
  const size = getSymbolSize2(version2);
  return [
    // top-left
    [0, 0],
    // top-right
    [size - FINDER_PATTERN_SIZE, 0],
    // bottom-left
    [0, size - FINDER_PATTERN_SIZE]
  ];
};
var maskPattern = {};
(function(exports) {
  exports.Patterns = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
  };
  const PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
  };
  exports.isValid = function isValid3(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
  };
  exports.from = function from(value) {
    return exports.isValid(value) ? parseInt(value, 10) : void 0;
  };
  exports.getPenaltyN1 = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for (let row = 0; row < size; row++) {
      sameCountCol = sameCountRow = 0;
      lastCol = lastRow = null;
      for (let col = 0; col < size; col++) {
        let module2 = data.get(row, col);
        if (module2 === lastCol) {
          sameCountCol++;
        } else {
          if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5);
          lastCol = module2;
          sameCountCol = 1;
        }
        module2 = data.get(col, row);
        if (module2 === lastRow) {
          sameCountRow++;
        } else {
          if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5);
          lastRow = module2;
          sameCountRow = 1;
        }
      }
      if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5);
      if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
  };
  exports.getPenaltyN2 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for (let row = 0; row < size - 1; row++) {
      for (let col = 0; col < size - 1; col++) {
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
      }
    }
    return points * PenaltyScores.N2;
  };
  exports.getPenaltyN3 = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for (let row = 0; row < size; row++) {
      bitsCol = bitsRow = 0;
      for (let col = 0; col < size; col++) {
        bitsCol = bitsCol << 1 & 2047 | data.get(row, col);
        if (col >= 10 && (bitsCol === 1488 || bitsCol === 93)) points++;
        bitsRow = bitsRow << 1 & 2047 | data.get(col, row);
        if (col >= 10 && (bitsRow === 1488 || bitsRow === 93)) points++;
      }
    }
    return points * PenaltyScores.N3;
  };
  exports.getPenaltyN4 = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for (let i9 = 0; i9 < modulesCount; i9++) darkCount += data.data[i9];
    const k2 = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k2 * PenaltyScores.N4;
  };
  function getMaskAt(maskPattern2, i9, j) {
    switch (maskPattern2) {
      case exports.Patterns.PATTERN000:
        return (i9 + j) % 2 === 0;
      case exports.Patterns.PATTERN001:
        return i9 % 2 === 0;
      case exports.Patterns.PATTERN010:
        return j % 3 === 0;
      case exports.Patterns.PATTERN011:
        return (i9 + j) % 3 === 0;
      case exports.Patterns.PATTERN100:
        return (Math.floor(i9 / 2) + Math.floor(j / 3)) % 2 === 0;
      case exports.Patterns.PATTERN101:
        return i9 * j % 2 + i9 * j % 3 === 0;
      case exports.Patterns.PATTERN110:
        return (i9 * j % 2 + i9 * j % 3) % 2 === 0;
      case exports.Patterns.PATTERN111:
        return (i9 * j % 3 + (i9 + j) % 2) % 2 === 0;
      default:
        throw new Error("bad maskPattern:" + maskPattern2);
    }
  }
  exports.applyMask = function applyMask(pattern, data) {
    const size = data.size;
    for (let col = 0; col < size; col++) {
      for (let row = 0; row < size; row++) {
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, getMaskAt(pattern, row, col));
      }
    }
  };
  exports.getBestMask = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys(exports.Patterns).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for (let p4 = 0; p4 < numPatterns; p4++) {
      setupFormatFunc(p4);
      exports.applyMask(p4, data);
      const penalty = exports.getPenaltyN1(data) + exports.getPenaltyN2(data) + exports.getPenaltyN3(data) + exports.getPenaltyN4(data);
      exports.applyMask(p4, data);
      if (penalty < lowerPenalty) {
        lowerPenalty = penalty;
        bestPattern = p4;
      }
    }
    return bestPattern;
  };
})(maskPattern);
var errorCorrectionCode = {};
var ECLevel$1 = errorCorrectionLevel;
var EC_BLOCKS_TABLE = [
  // L  M  Q  H
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  1,
  2,
  2,
  4,
  1,
  2,
  4,
  4,
  2,
  4,
  4,
  4,
  2,
  4,
  6,
  5,
  2,
  4,
  6,
  6,
  2,
  5,
  8,
  8,
  4,
  5,
  8,
  8,
  4,
  5,
  8,
  11,
  4,
  8,
  10,
  11,
  4,
  9,
  12,
  16,
  4,
  9,
  16,
  16,
  6,
  10,
  12,
  18,
  6,
  10,
  17,
  16,
  6,
  11,
  16,
  19,
  6,
  13,
  18,
  21,
  7,
  14,
  21,
  25,
  8,
  16,
  20,
  25,
  8,
  17,
  23,
  25,
  9,
  17,
  23,
  34,
  9,
  18,
  25,
  30,
  10,
  20,
  27,
  32,
  12,
  21,
  29,
  35,
  12,
  23,
  34,
  37,
  12,
  25,
  34,
  40,
  13,
  26,
  35,
  42,
  14,
  28,
  38,
  45,
  15,
  29,
  40,
  48,
  16,
  31,
  43,
  51,
  17,
  33,
  45,
  54,
  18,
  35,
  48,
  57,
  19,
  37,
  51,
  60,
  19,
  38,
  53,
  63,
  20,
  40,
  56,
  66,
  21,
  43,
  59,
  70,
  22,
  45,
  62,
  74,
  24,
  47,
  65,
  77,
  25,
  49,
  68,
  81
];
var EC_CODEWORDS_TABLE = [
  // L  M  Q  H
  7,
  10,
  13,
  17,
  10,
  16,
  22,
  28,
  15,
  26,
  36,
  44,
  20,
  36,
  52,
  64,
  26,
  48,
  72,
  88,
  36,
  64,
  96,
  112,
  40,
  72,
  108,
  130,
  48,
  88,
  132,
  156,
  60,
  110,
  160,
  192,
  72,
  130,
  192,
  224,
  80,
  150,
  224,
  264,
  96,
  176,
  260,
  308,
  104,
  198,
  288,
  352,
  120,
  216,
  320,
  384,
  132,
  240,
  360,
  432,
  144,
  280,
  408,
  480,
  168,
  308,
  448,
  532,
  180,
  338,
  504,
  588,
  196,
  364,
  546,
  650,
  224,
  416,
  600,
  700,
  224,
  442,
  644,
  750,
  252,
  476,
  690,
  816,
  270,
  504,
  750,
  900,
  300,
  560,
  810,
  960,
  312,
  588,
  870,
  1050,
  336,
  644,
  952,
  1110,
  360,
  700,
  1020,
  1200,
  390,
  728,
  1050,
  1260,
  420,
  784,
  1140,
  1350,
  450,
  812,
  1200,
  1440,
  480,
  868,
  1290,
  1530,
  510,
  924,
  1350,
  1620,
  540,
  980,
  1440,
  1710,
  570,
  1036,
  1530,
  1800,
  570,
  1064,
  1590,
  1890,
  600,
  1120,
  1680,
  1980,
  630,
  1204,
  1770,
  2100,
  660,
  1260,
  1860,
  2220,
  720,
  1316,
  1950,
  2310,
  750,
  1372,
  2040,
  2430
];
errorCorrectionCode.getBlocksCount = function getBlocksCount(version2, errorCorrectionLevel2) {
  switch (errorCorrectionLevel2) {
    case ECLevel$1.L:
      return EC_BLOCKS_TABLE[(version2 - 1) * 4 + 0];
    case ECLevel$1.M:
      return EC_BLOCKS_TABLE[(version2 - 1) * 4 + 1];
    case ECLevel$1.Q:
      return EC_BLOCKS_TABLE[(version2 - 1) * 4 + 2];
    case ECLevel$1.H:
      return EC_BLOCKS_TABLE[(version2 - 1) * 4 + 3];
    default:
      return void 0;
  }
};
errorCorrectionCode.getTotalCodewordsCount = function getTotalCodewordsCount(version2, errorCorrectionLevel2) {
  switch (errorCorrectionLevel2) {
    case ECLevel$1.L:
      return EC_CODEWORDS_TABLE[(version2 - 1) * 4 + 0];
    case ECLevel$1.M:
      return EC_CODEWORDS_TABLE[(version2 - 1) * 4 + 1];
    case ECLevel$1.Q:
      return EC_CODEWORDS_TABLE[(version2 - 1) * 4 + 2];
    case ECLevel$1.H:
      return EC_CODEWORDS_TABLE[(version2 - 1) * 4 + 3];
    default:
      return void 0;
  }
};
var polynomial = {};
var galoisField = {};
var EXP_TABLE = new Uint8Array(512);
var LOG_TABLE = new Uint8Array(256);
(function initTables() {
  let x = 1;
  for (let i9 = 0; i9 < 255; i9++) {
    EXP_TABLE[i9] = x;
    LOG_TABLE[x] = i9;
    x <<= 1;
    if (x & 256) {
      x ^= 285;
    }
  }
  for (let i9 = 255; i9 < 512; i9++) {
    EXP_TABLE[i9] = EXP_TABLE[i9 - 255];
  }
})();
galoisField.log = function log(n2) {
  if (n2 < 1) throw new Error("log(" + n2 + ")");
  return LOG_TABLE[n2];
};
galoisField.exp = function exp(n2) {
  return EXP_TABLE[n2];
};
galoisField.mul = function mul(x, y3) {
  if (x === 0 || y3 === 0) return 0;
  return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y3]];
};
(function(exports) {
  const GF = galoisField;
  exports.mul = function mul2(p1, p22) {
    const coeff = new Uint8Array(p1.length + p22.length - 1);
    for (let i9 = 0; i9 < p1.length; i9++) {
      for (let j = 0; j < p22.length; j++) {
        coeff[i9 + j] ^= GF.mul(p1[i9], p22[j]);
      }
    }
    return coeff;
  };
  exports.mod = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while (result.length - divisor.length >= 0) {
      const coeff = result[0];
      for (let i9 = 0; i9 < divisor.length; i9++) {
        result[i9] ^= GF.mul(divisor[i9], coeff);
      }
      let offset = 0;
      while (offset < result.length && result[offset] === 0) offset++;
      result = result.slice(offset);
    }
    return result;
  };
  exports.generateECPolynomial = function generateECPolynomial(degree) {
    let poly = new Uint8Array([1]);
    for (let i9 = 0; i9 < degree; i9++) {
      poly = exports.mul(poly, new Uint8Array([1, GF.exp(i9)]));
    }
    return poly;
  };
})(polynomial);
var Polynomial = polynomial;
function ReedSolomonEncoder$1(degree) {
  this.genPoly = void 0;
  this.degree = degree;
  if (this.degree) this.initialize(this.degree);
}
ReedSolomonEncoder$1.prototype.initialize = function initialize2(degree) {
  this.degree = degree;
  this.genPoly = Polynomial.generateECPolynomial(this.degree);
};
ReedSolomonEncoder$1.prototype.encode = function encode(data) {
  if (!this.genPoly) {
    throw new Error("Encoder not initialized");
  }
  const paddedData = new Uint8Array(data.length + this.degree);
  paddedData.set(data);
  const remainder = Polynomial.mod(paddedData, this.genPoly);
  const start = this.degree - remainder.length;
  if (start > 0) {
    const buff = new Uint8Array(this.degree);
    buff.set(remainder, start);
    return buff;
  }
  return remainder;
};
var reedSolomonEncoder = ReedSolomonEncoder$1;
var version = {};
var mode = {};
var versionCheck = {};
versionCheck.isValid = function isValid2(version2) {
  return !isNaN(version2) && version2 >= 1 && version2 <= 40;
};
var regex = {};
var numeric = "[0-9]+";
var alphanumeric = "[A-Z $%*+\\-./:]+";
var kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
kanji = kanji.replace(/u/g, "\\u");
var byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + kanji + ")(?:.|[\r\n]))+";
regex.KANJI = new RegExp(kanji, "g");
regex.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
regex.BYTE = new RegExp(byte, "g");
regex.NUMERIC = new RegExp(numeric, "g");
regex.ALPHANUMERIC = new RegExp(alphanumeric, "g");
var TEST_KANJI = new RegExp("^" + kanji + "$");
var TEST_NUMERIC = new RegExp("^" + numeric + "$");
var TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
regex.testKanji = function testKanji(str) {
  return TEST_KANJI.test(str);
};
regex.testNumeric = function testNumeric(str) {
  return TEST_NUMERIC.test(str);
};
regex.testAlphanumeric = function testAlphanumeric(str) {
  return TEST_ALPHANUMERIC.test(str);
};
(function(exports) {
  const VersionCheck = versionCheck;
  const Regex = regex;
  exports.NUMERIC = {
    id: "Numeric",
    bit: 1 << 0,
    ccBits: [10, 12, 14]
  };
  exports.ALPHANUMERIC = {
    id: "Alphanumeric",
    bit: 1 << 1,
    ccBits: [9, 11, 13]
  };
  exports.BYTE = {
    id: "Byte",
    bit: 1 << 2,
    ccBits: [8, 16, 16]
  };
  exports.KANJI = {
    id: "Kanji",
    bit: 1 << 3,
    ccBits: [8, 10, 12]
  };
  exports.MIXED = {
    bit: -1
  };
  exports.getCharCountIndicator = function getCharCountIndicator(mode2, version2) {
    if (!mode2.ccBits) throw new Error("Invalid mode: " + mode2);
    if (!VersionCheck.isValid(version2)) {
      throw new Error("Invalid version: " + version2);
    }
    if (version2 >= 1 && version2 < 10) return mode2.ccBits[0];
    else if (version2 < 27) return mode2.ccBits[1];
    return mode2.ccBits[2];
  };
  exports.getBestModeForData = function getBestModeForData(dataStr) {
    if (Regex.testNumeric(dataStr)) return exports.NUMERIC;
    else if (Regex.testAlphanumeric(dataStr)) return exports.ALPHANUMERIC;
    else if (Regex.testKanji(dataStr)) return exports.KANJI;
    else return exports.BYTE;
  };
  exports.toString = function toString2(mode2) {
    if (mode2 && mode2.id) return mode2.id;
    throw new Error("Invalid mode");
  };
  exports.isValid = function isValid3(mode2) {
    return mode2 && mode2.bit && mode2.ccBits;
  };
  function fromString(string) {
    if (typeof string !== "string") {
      throw new Error("Param is not a string");
    }
    const lcStr = string.toLowerCase();
    switch (lcStr) {
      case "numeric":
        return exports.NUMERIC;
      case "alphanumeric":
        return exports.ALPHANUMERIC;
      case "kanji":
        return exports.KANJI;
      case "byte":
        return exports.BYTE;
      default:
        throw new Error("Unknown mode: " + string);
    }
  }
  exports.from = function from(value, defaultValue) {
    if (exports.isValid(value)) {
      return value;
    }
    try {
      return fromString(value);
    } catch (e2) {
      return defaultValue;
    }
  };
})(mode);
(function(exports) {
  const Utils2 = utils$1;
  const ECCode2 = errorCorrectionCode;
  const ECLevel2 = errorCorrectionLevel;
  const Mode2 = mode;
  const VersionCheck = versionCheck;
  const G18 = 1 << 12 | 1 << 11 | 1 << 10 | 1 << 9 | 1 << 8 | 1 << 5 | 1 << 2 | 1 << 0;
  const G18_BCH = Utils2.getBCHDigit(G18);
  function getBestVersionForDataLength(mode2, length, errorCorrectionLevel2) {
    for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
      if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel2, mode2)) {
        return currentVersion;
      }
    }
    return void 0;
  }
  function getReservedBitsCount(mode2, version2) {
    return Mode2.getCharCountIndicator(mode2, version2) + 4;
  }
  function getTotalBitsFromDataArray(segments2, version2) {
    let totalBits = 0;
    segments2.forEach(function(data) {
      const reservedBits = getReservedBitsCount(data.mode, version2);
      totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
  }
  function getBestVersionForMixedData(segments2, errorCorrectionLevel2) {
    for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
      const length = getTotalBitsFromDataArray(segments2, currentVersion);
      if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel2, Mode2.MIXED)) {
        return currentVersion;
      }
    }
    return void 0;
  }
  exports.from = function from(value, defaultValue) {
    if (VersionCheck.isValid(value)) {
      return parseInt(value, 10);
    }
    return defaultValue;
  };
  exports.getCapacity = function getCapacity(version2, errorCorrectionLevel2, mode2) {
    if (!VersionCheck.isValid(version2)) {
      throw new Error("Invalid QR Code version");
    }
    if (typeof mode2 === "undefined") mode2 = Mode2.BYTE;
    const totalCodewords = Utils2.getSymbolTotalCodewords(version2);
    const ecTotalCodewords = ECCode2.getTotalCodewordsCount(version2, errorCorrectionLevel2);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode2 === Mode2.MIXED) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode2, version2);
    switch (mode2) {
      case Mode2.NUMERIC:
        return Math.floor(usableBits / 10 * 3);
      case Mode2.ALPHANUMERIC:
        return Math.floor(usableBits / 11 * 2);
      case Mode2.KANJI:
        return Math.floor(usableBits / 13);
      case Mode2.BYTE:
      default:
        return Math.floor(usableBits / 8);
    }
  };
  exports.getBestVersionForData = function getBestVersionForData(data, errorCorrectionLevel2) {
    let seg;
    const ecl = ECLevel2.from(errorCorrectionLevel2, ECLevel2.M);
    if (Array.isArray(data)) {
      if (data.length > 1) {
        return getBestVersionForMixedData(data, ecl);
      }
      if (data.length === 0) {
        return 1;
      }
      seg = data[0];
    } else {
      seg = data;
    }
    return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
  };
  exports.getEncodedBits = function getEncodedBits2(version2) {
    if (!VersionCheck.isValid(version2) || version2 < 7) {
      throw new Error("Invalid QR Code version");
    }
    let d4 = version2 << 12;
    while (Utils2.getBCHDigit(d4) - G18_BCH >= 0) {
      d4 ^= G18 << Utils2.getBCHDigit(d4) - G18_BCH;
    }
    return version2 << 12 | d4;
  };
})(version);
var formatInfo = {};
var Utils$3 = utils$1;
var G15 = 1 << 10 | 1 << 8 | 1 << 5 | 1 << 4 | 1 << 2 | 1 << 1 | 1 << 0;
var G15_MASK = 1 << 14 | 1 << 12 | 1 << 10 | 1 << 4 | 1 << 1;
var G15_BCH = Utils$3.getBCHDigit(G15);
formatInfo.getEncodedBits = function getEncodedBits(errorCorrectionLevel2, mask) {
  const data = errorCorrectionLevel2.bit << 3 | mask;
  let d4 = data << 10;
  while (Utils$3.getBCHDigit(d4) - G15_BCH >= 0) {
    d4 ^= G15 << Utils$3.getBCHDigit(d4) - G15_BCH;
  }
  return (data << 10 | d4) ^ G15_MASK;
};
var segments = {};
var Mode$4 = mode;
function NumericData(data) {
  this.mode = Mode$4.NUMERIC;
  this.data = data.toString();
}
NumericData.getBitsLength = function getBitsLength(length) {
  return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
NumericData.prototype.getLength = function getLength() {
  return this.data.length;
};
NumericData.prototype.getBitsLength = function getBitsLength2() {
  return NumericData.getBitsLength(this.data.length);
};
NumericData.prototype.write = function write(bitBuffer2) {
  let i9, group, value;
  for (i9 = 0; i9 + 3 <= this.data.length; i9 += 3) {
    group = this.data.substr(i9, 3);
    value = parseInt(group, 10);
    bitBuffer2.put(value, 10);
  }
  const remainingNum = this.data.length - i9;
  if (remainingNum > 0) {
    group = this.data.substr(i9);
    value = parseInt(group, 10);
    bitBuffer2.put(value, remainingNum * 3 + 1);
  }
};
var numericData = NumericData;
var Mode$3 = mode;
var ALPHA_NUM_CHARS = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  " ",
  "$",
  "%",
  "*",
  "+",
  "-",
  ".",
  "/",
  ":"
];
function AlphanumericData(data) {
  this.mode = Mode$3.ALPHANUMERIC;
  this.data = data;
}
AlphanumericData.getBitsLength = function getBitsLength3(length) {
  return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
AlphanumericData.prototype.getLength = function getLength2() {
  return this.data.length;
};
AlphanumericData.prototype.getBitsLength = function getBitsLength4() {
  return AlphanumericData.getBitsLength(this.data.length);
};
AlphanumericData.prototype.write = function write2(bitBuffer2) {
  let i9;
  for (i9 = 0; i9 + 2 <= this.data.length; i9 += 2) {
    let value = ALPHA_NUM_CHARS.indexOf(this.data[i9]) * 45;
    value += ALPHA_NUM_CHARS.indexOf(this.data[i9 + 1]);
    bitBuffer2.put(value, 11);
  }
  if (this.data.length % 2) {
    bitBuffer2.put(ALPHA_NUM_CHARS.indexOf(this.data[i9]), 6);
  }
};
var alphanumericData = AlphanumericData;
var encodeUtf8$1 = function encodeUtf8(input) {
  var result = [];
  var size = input.length;
  for (var index = 0; index < size; index++) {
    var point = input.charCodeAt(index);
    if (point >= 55296 && point <= 56319 && size > index + 1) {
      var second = input.charCodeAt(index + 1);
      if (second >= 56320 && second <= 57343) {
        point = (point - 55296) * 1024 + second - 56320 + 65536;
        index += 1;
      }
    }
    if (point < 128) {
      result.push(point);
      continue;
    }
    if (point < 2048) {
      result.push(point >> 6 | 192);
      result.push(point & 63 | 128);
      continue;
    }
    if (point < 55296 || point >= 57344 && point < 65536) {
      result.push(point >> 12 | 224);
      result.push(point >> 6 & 63 | 128);
      result.push(point & 63 | 128);
      continue;
    }
    if (point >= 65536 && point <= 1114111) {
      result.push(point >> 18 | 240);
      result.push(point >> 12 & 63 | 128);
      result.push(point >> 6 & 63 | 128);
      result.push(point & 63 | 128);
      continue;
    }
    result.push(239, 191, 189);
  }
  return new Uint8Array(result).buffer;
};
var encodeUtf82 = encodeUtf8$1;
var Mode$2 = mode;
function ByteData(data) {
  this.mode = Mode$2.BYTE;
  if (typeof data === "string") {
    data = encodeUtf82(data);
  }
  this.data = new Uint8Array(data);
}
ByteData.getBitsLength = function getBitsLength5(length) {
  return length * 8;
};
ByteData.prototype.getLength = function getLength3() {
  return this.data.length;
};
ByteData.prototype.getBitsLength = function getBitsLength6() {
  return ByteData.getBitsLength(this.data.length);
};
ByteData.prototype.write = function(bitBuffer2) {
  for (let i9 = 0, l2 = this.data.length; i9 < l2; i9++) {
    bitBuffer2.put(this.data[i9], 8);
  }
};
var byteData = ByteData;
var Mode$1 = mode;
var Utils$2 = utils$1;
function KanjiData(data) {
  this.mode = Mode$1.KANJI;
  this.data = data;
}
KanjiData.getBitsLength = function getBitsLength7(length) {
  return length * 13;
};
KanjiData.prototype.getLength = function getLength4() {
  return this.data.length;
};
KanjiData.prototype.getBitsLength = function getBitsLength8() {
  return KanjiData.getBitsLength(this.data.length);
};
KanjiData.prototype.write = function(bitBuffer2) {
  let i9;
  for (i9 = 0; i9 < this.data.length; i9++) {
    let value = Utils$2.toSJIS(this.data[i9]);
    if (value >= 33088 && value <= 40956) {
      value -= 33088;
    } else if (value >= 57408 && value <= 60351) {
      value -= 49472;
    } else {
      throw new Error(
        "Invalid SJIS character: " + this.data[i9] + "\nMake sure your charset is UTF-8"
      );
    }
    value = (value >>> 8 & 255) * 192 + (value & 255);
    bitBuffer2.put(value, 13);
  }
};
var kanjiData = KanjiData;
var dijkstra = { exports: {} };
(function(module2) {
  var dijkstra2 = {
    single_source_shortest_paths: function(graph, s5, d4) {
      var predecessors = {};
      var costs = {};
      costs[s5] = 0;
      var open = dijkstra2.PriorityQueue.make();
      open.push(s5, 0);
      var closest, u4, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
      while (!open.empty()) {
        closest = open.pop();
        u4 = closest.value;
        cost_of_s_to_u = closest.cost;
        adjacent_nodes = graph[u4] || {};
        for (v in adjacent_nodes) {
          if (adjacent_nodes.hasOwnProperty(v)) {
            cost_of_e = adjacent_nodes[v];
            cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
            cost_of_s_to_v = costs[v];
            first_visit = typeof costs[v] === "undefined";
            if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
              costs[v] = cost_of_s_to_u_plus_cost_of_e;
              open.push(v, cost_of_s_to_u_plus_cost_of_e);
              predecessors[v] = u4;
            }
          }
        }
      }
      if (typeof d4 !== "undefined" && typeof costs[d4] === "undefined") {
        var msg = ["Could not find a path from ", s5, " to ", d4, "."].join("");
        throw new Error(msg);
      }
      return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d4) {
      var nodes = [];
      var u4 = d4;
      while (u4) {
        nodes.push(u4);
        predecessors[u4];
        u4 = predecessors[u4];
      }
      nodes.reverse();
      return nodes;
    },
    find_path: function(graph, s5, d4) {
      var predecessors = dijkstra2.single_source_shortest_paths(graph, s5, d4);
      return dijkstra2.extract_shortest_path_from_predecessor_list(
        predecessors,
        d4
      );
    },
    /**
     * A very naive priority queue implementation.
     */
    PriorityQueue: {
      make: function(opts) {
        var T3 = dijkstra2.PriorityQueue, t3 = {}, key;
        opts = opts || {};
        for (key in T3) {
          if (T3.hasOwnProperty(key)) {
            t3[key] = T3[key];
          }
        }
        t3.queue = [];
        t3.sorter = opts.sorter || T3.default_sorter;
        return t3;
      },
      default_sorter: function(a5, b3) {
        return a5.cost - b3.cost;
      },
      /**
       * Add a new item to the queue and ensure the highest priority element
       * is at the front of the queue.
       */
      push: function(value, cost) {
        var item = { value, cost };
        this.queue.push(item);
        this.queue.sort(this.sorter);
      },
      /**
       * Return the highest priority element in the queue.
       */
      pop: function() {
        return this.queue.shift();
      },
      empty: function() {
        return this.queue.length === 0;
      }
    }
  };
  {
    module2.exports = dijkstra2;
  }
})(dijkstra);
var dijkstraExports = dijkstra.exports;
(function(exports) {
  const Mode2 = mode;
  const NumericData2 = numericData;
  const AlphanumericData2 = alphanumericData;
  const ByteData2 = byteData;
  const KanjiData2 = kanjiData;
  const Regex = regex;
  const Utils2 = utils$1;
  const dijkstra2 = dijkstraExports;
  function getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
  }
  function getSegments(regex2, mode2, str) {
    const segments2 = [];
    let result;
    while ((result = regex2.exec(str)) !== null) {
      segments2.push({
        data: result[0],
        index: result.index,
        mode: mode2,
        length: result[0].length
      });
    }
    return segments2;
  }
  function getSegmentsFromString(dataStr) {
    const numSegs = getSegments(Regex.NUMERIC, Mode2.NUMERIC, dataStr);
    const alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode2.ALPHANUMERIC, dataStr);
    let byteSegs;
    let kanjiSegs;
    if (Utils2.isKanjiModeEnabled()) {
      byteSegs = getSegments(Regex.BYTE, Mode2.BYTE, dataStr);
      kanjiSegs = getSegments(Regex.KANJI, Mode2.KANJI, dataStr);
    } else {
      byteSegs = getSegments(Regex.BYTE_KANJI, Mode2.BYTE, dataStr);
      kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s22) {
      return s1.index - s22.index;
    }).map(function(obj) {
      return {
        data: obj.data,
        mode: obj.mode,
        length: obj.length
      };
    });
  }
  function getSegmentBitsLength(length, mode2) {
    switch (mode2) {
      case Mode2.NUMERIC:
        return NumericData2.getBitsLength(length);
      case Mode2.ALPHANUMERIC:
        return AlphanumericData2.getBitsLength(length);
      case Mode2.KANJI:
        return KanjiData2.getBitsLength(length);
      case Mode2.BYTE:
        return ByteData2.getBitsLength(length);
    }
  }
  function mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
      const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
      if (prevSeg && prevSeg.mode === curr.mode) {
        acc[acc.length - 1].data += curr.data;
        return acc;
      }
      acc.push(curr);
      return acc;
    }, []);
  }
  function buildNodes(segs) {
    const nodes = [];
    for (let i9 = 0; i9 < segs.length; i9++) {
      const seg = segs[i9];
      switch (seg.mode) {
        case Mode2.NUMERIC:
          nodes.push([
            seg,
            { data: seg.data, mode: Mode2.ALPHANUMERIC, length: seg.length },
            { data: seg.data, mode: Mode2.BYTE, length: seg.length }
          ]);
          break;
        case Mode2.ALPHANUMERIC:
          nodes.push([
            seg,
            { data: seg.data, mode: Mode2.BYTE, length: seg.length }
          ]);
          break;
        case Mode2.KANJI:
          nodes.push([
            seg,
            { data: seg.data, mode: Mode2.BYTE, length: getStringByteLength(seg.data) }
          ]);
          break;
        case Mode2.BYTE:
          nodes.push([
            { data: seg.data, mode: Mode2.BYTE, length: getStringByteLength(seg.data) }
          ]);
      }
    }
    return nodes;
  }
  function buildGraph(nodes, version2) {
    const table = {};
    const graph = { start: {} };
    let prevNodeIds = ["start"];
    for (let i9 = 0; i9 < nodes.length; i9++) {
      const nodeGroup = nodes[i9];
      const currentNodeIds = [];
      for (let j = 0; j < nodeGroup.length; j++) {
        const node = nodeGroup[j];
        const key = "" + i9 + j;
        currentNodeIds.push(key);
        table[key] = { node, lastCount: 0 };
        graph[key] = {};
        for (let n2 = 0; n2 < prevNodeIds.length; n2++) {
          const prevNodeId = prevNodeIds[n2];
          if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
            graph[prevNodeId][key] = getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
            table[prevNodeId].lastCount += node.length;
          } else {
            if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
            graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) + 4 + Mode2.getCharCountIndicator(node.mode, version2);
          }
        }
      }
      prevNodeIds = currentNodeIds;
    }
    for (let n2 = 0; n2 < prevNodeIds.length; n2++) {
      graph[prevNodeIds[n2]].end = 0;
    }
    return { map: graph, table };
  }
  function buildSingleSegment(data, modesHint) {
    let mode2;
    const bestMode = Mode2.getBestModeForData(data);
    mode2 = Mode2.from(modesHint, bestMode);
    if (mode2 !== Mode2.BYTE && mode2.bit < bestMode.bit) {
      throw new Error('"' + data + '" cannot be encoded with mode ' + Mode2.toString(mode2) + ".\n Suggested mode is: " + Mode2.toString(bestMode));
    }
    if (mode2 === Mode2.KANJI && !Utils2.isKanjiModeEnabled()) {
      mode2 = Mode2.BYTE;
    }
    switch (mode2) {
      case Mode2.NUMERIC:
        return new NumericData2(data);
      case Mode2.ALPHANUMERIC:
        return new AlphanumericData2(data);
      case Mode2.KANJI:
        return new KanjiData2(data);
      case Mode2.BYTE:
        return new ByteData2(data);
    }
  }
  exports.fromArray = function fromArray(array) {
    return array.reduce(function(acc, seg) {
      if (typeof seg === "string") {
        acc.push(buildSingleSegment(seg, null));
      } else if (seg.data) {
        acc.push(buildSingleSegment(seg.data, seg.mode));
      }
      return acc;
    }, []);
  };
  exports.fromString = function fromString(data, version2) {
    const segs = getSegmentsFromString(data, Utils2.isKanjiModeEnabled());
    const nodes = buildNodes(segs);
    const graph = buildGraph(nodes, version2);
    const path = dijkstra2.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for (let i9 = 1; i9 < path.length - 1; i9++) {
      optimizedSegs.push(graph.table[path[i9]].node);
    }
    return exports.fromArray(mergeSegments(optimizedSegs));
  };
  exports.rawSplit = function rawSplit(data) {
    return exports.fromArray(
      getSegmentsFromString(data, Utils2.isKanjiModeEnabled())
    );
  };
})(segments);
var Utils$1 = utils$1;
var ECLevel = errorCorrectionLevel;
var BitBuffer = bitBuffer;
var BitMatrix = bitMatrix;
var AlignmentPattern = alignmentPattern;
var FinderPattern = finderPattern;
var MaskPattern = maskPattern;
var ECCode = errorCorrectionCode;
var ReedSolomonEncoder = reedSolomonEncoder;
var Version = version;
var FormatInfo = formatInfo;
var Mode = mode;
var Segments = segments;
function setupFinderPattern(matrix, version2) {
  const size = matrix.size;
  const pos = FinderPattern.getPositions(version2);
  for (let i9 = 0; i9 < pos.length; i9++) {
    const row = pos[i9][0];
    const col = pos[i9][1];
    for (let r10 = -1; r10 <= 7; r10++) {
      if (row + r10 <= -1 || size <= row + r10) continue;
      for (let c5 = -1; c5 <= 7; c5++) {
        if (col + c5 <= -1 || size <= col + c5) continue;
        if (r10 >= 0 && r10 <= 6 && (c5 === 0 || c5 === 6) || c5 >= 0 && c5 <= 6 && (r10 === 0 || r10 === 6) || r10 >= 2 && r10 <= 4 && c5 >= 2 && c5 <= 4) {
          matrix.set(row + r10, col + c5, true, true);
        } else {
          matrix.set(row + r10, col + c5, false, true);
        }
      }
    }
  }
}
function setupTimingPattern(matrix) {
  const size = matrix.size;
  for (let r10 = 8; r10 < size - 8; r10++) {
    const value = r10 % 2 === 0;
    matrix.set(r10, 6, value, true);
    matrix.set(6, r10, value, true);
  }
}
function setupAlignmentPattern(matrix, version2) {
  const pos = AlignmentPattern.getPositions(version2);
  for (let i9 = 0; i9 < pos.length; i9++) {
    const row = pos[i9][0];
    const col = pos[i9][1];
    for (let r10 = -2; r10 <= 2; r10++) {
      for (let c5 = -2; c5 <= 2; c5++) {
        if (r10 === -2 || r10 === 2 || c5 === -2 || c5 === 2 || r10 === 0 && c5 === 0) {
          matrix.set(row + r10, col + c5, true, true);
        } else {
          matrix.set(row + r10, col + c5, false, true);
        }
      }
    }
  }
}
function setupVersionInfo(matrix, version2) {
  const size = matrix.size;
  const bits = Version.getEncodedBits(version2);
  let row, col, mod;
  for (let i9 = 0; i9 < 18; i9++) {
    row = Math.floor(i9 / 3);
    col = i9 % 3 + size - 8 - 3;
    mod = (bits >> i9 & 1) === 1;
    matrix.set(row, col, mod, true);
    matrix.set(col, row, mod, true);
  }
}
function setupFormatInfo(matrix, errorCorrectionLevel2, maskPattern2) {
  const size = matrix.size;
  const bits = FormatInfo.getEncodedBits(errorCorrectionLevel2, maskPattern2);
  let i9, mod;
  for (i9 = 0; i9 < 15; i9++) {
    mod = (bits >> i9 & 1) === 1;
    if (i9 < 6) {
      matrix.set(i9, 8, mod, true);
    } else if (i9 < 8) {
      matrix.set(i9 + 1, 8, mod, true);
    } else {
      matrix.set(size - 15 + i9, 8, mod, true);
    }
    if (i9 < 8) {
      matrix.set(8, size - i9 - 1, mod, true);
    } else if (i9 < 9) {
      matrix.set(8, 15 - i9 - 1 + 1, mod, true);
    } else {
      matrix.set(8, 15 - i9 - 1, mod, true);
    }
  }
  matrix.set(size - 8, 8, 1, true);
}
function setupData(matrix, data) {
  const size = matrix.size;
  let inc = -1;
  let row = size - 1;
  let bitIndex = 7;
  let byteIndex = 0;
  for (let col = size - 1; col > 0; col -= 2) {
    if (col === 6) col--;
    while (true) {
      for (let c5 = 0; c5 < 2; c5++) {
        if (!matrix.isReserved(row, col - c5)) {
          let dark = false;
          if (byteIndex < data.length) {
            dark = (data[byteIndex] >>> bitIndex & 1) === 1;
          }
          matrix.set(row, col - c5, dark);
          bitIndex--;
          if (bitIndex === -1) {
            byteIndex++;
            bitIndex = 7;
          }
        }
      }
      row += inc;
      if (row < 0 || size <= row) {
        row -= inc;
        inc = -inc;
        break;
      }
    }
  }
}
function createData(version2, errorCorrectionLevel2, segments2) {
  const buffer = new BitBuffer();
  segments2.forEach(function(data) {
    buffer.put(data.mode.bit, 4);
    buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version2));
    data.write(buffer);
  });
  const totalCodewords = Utils$1.getSymbolTotalCodewords(version2);
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version2, errorCorrectionLevel2);
  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
  if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) {
    buffer.put(0, 4);
  }
  while (buffer.getLengthInBits() % 8 !== 0) {
    buffer.putBit(0);
  }
  const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
  for (let i9 = 0; i9 < remainingByte; i9++) {
    buffer.put(i9 % 2 ? 17 : 236, 8);
  }
  return createCodewords(buffer, version2, errorCorrectionLevel2);
}
function createCodewords(bitBuffer2, version2, errorCorrectionLevel2) {
  const totalCodewords = Utils$1.getSymbolTotalCodewords(version2);
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version2, errorCorrectionLevel2);
  const dataTotalCodewords = totalCodewords - ecTotalCodewords;
  const ecTotalBlocks = ECCode.getBlocksCount(version2, errorCorrectionLevel2);
  const blocksInGroup2 = totalCodewords % ecTotalBlocks;
  const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
  const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
  const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
  const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
  const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
  const rs = new ReedSolomonEncoder(ecCount);
  let offset = 0;
  const dcData = new Array(ecTotalBlocks);
  const ecData = new Array(ecTotalBlocks);
  let maxDataSize = 0;
  const buffer = new Uint8Array(bitBuffer2.buffer);
  for (let b3 = 0; b3 < ecTotalBlocks; b3++) {
    const dataSize = b3 < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
    dcData[b3] = buffer.slice(offset, offset + dataSize);
    ecData[b3] = rs.encode(dcData[b3]);
    offset += dataSize;
    maxDataSize = Math.max(maxDataSize, dataSize);
  }
  const data = new Uint8Array(totalCodewords);
  let index = 0;
  let i9, r10;
  for (i9 = 0; i9 < maxDataSize; i9++) {
    for (r10 = 0; r10 < ecTotalBlocks; r10++) {
      if (i9 < dcData[r10].length) {
        data[index++] = dcData[r10][i9];
      }
    }
  }
  for (i9 = 0; i9 < ecCount; i9++) {
    for (r10 = 0; r10 < ecTotalBlocks; r10++) {
      data[index++] = ecData[r10][i9];
    }
  }
  return data;
}
function createSymbol(data, version2, errorCorrectionLevel2, maskPattern2) {
  let segments2;
  if (Array.isArray(data)) {
    segments2 = Segments.fromArray(data);
  } else if (typeof data === "string") {
    let estimatedVersion = version2;
    if (!estimatedVersion) {
      const rawSegments = Segments.rawSplit(data);
      estimatedVersion = Version.getBestVersionForData(rawSegments, errorCorrectionLevel2);
    }
    segments2 = Segments.fromString(data, estimatedVersion || 40);
  } else {
    throw new Error("Invalid data");
  }
  const bestVersion = Version.getBestVersionForData(segments2, errorCorrectionLevel2);
  if (!bestVersion) {
    throw new Error("The amount of data is too big to be stored in a QR Code");
  }
  if (!version2) {
    version2 = bestVersion;
  } else if (version2 < bestVersion) {
    throw new Error(
      "\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n"
    );
  }
  const dataBits = createData(version2, errorCorrectionLevel2, segments2);
  const moduleCount = Utils$1.getSymbolSize(version2);
  const modules = new BitMatrix(moduleCount);
  setupFinderPattern(modules, version2);
  setupTimingPattern(modules);
  setupAlignmentPattern(modules, version2);
  setupFormatInfo(modules, errorCorrectionLevel2, 0);
  if (version2 >= 7) {
    setupVersionInfo(modules, version2);
  }
  setupData(modules, dataBits);
  if (isNaN(maskPattern2)) {
    maskPattern2 = MaskPattern.getBestMask(
      modules,
      setupFormatInfo.bind(null, modules, errorCorrectionLevel2)
    );
  }
  MaskPattern.applyMask(maskPattern2, modules);
  setupFormatInfo(modules, errorCorrectionLevel2, maskPattern2);
  return {
    modules,
    version: version2,
    errorCorrectionLevel: errorCorrectionLevel2,
    maskPattern: maskPattern2,
    segments: segments2
  };
}
qrcode.create = function create(data, options) {
  if (typeof data === "undefined" || data === "") {
    throw new Error("No input text");
  }
  let errorCorrectionLevel2 = ECLevel.M;
  let version2;
  let mask;
  if (typeof options !== "undefined") {
    errorCorrectionLevel2 = ECLevel.from(options.errorCorrectionLevel, ECLevel.M);
    version2 = Version.from(options.version);
    mask = MaskPattern.from(options.maskPattern);
    if (options.toSJISFunc) {
      Utils$1.setToSJISFunction(options.toSJISFunc);
    }
  }
  return createSymbol(data, version2, errorCorrectionLevel2, mask);
};
var canvas = {};
var utils = {};
(function(exports) {
  function hex2rgba(hex) {
    if (typeof hex === "number") {
      hex = hex.toString();
    }
    if (typeof hex !== "string") {
      throw new Error("Color should be defined as hex string");
    }
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) {
      throw new Error("Invalid hex color: " + hex);
    }
    if (hexCode.length === 3 || hexCode.length === 4) {
      hexCode = Array.prototype.concat.apply([], hexCode.map(function(c5) {
        return [c5, c5];
      }));
    }
    if (hexCode.length === 6) hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
      r: hexValue >> 24 & 255,
      g: hexValue >> 16 & 255,
      b: hexValue >> 8 & 255,
      a: hexValue & 255,
      hex: "#" + hexCode.slice(0, 6).join("")
    };
  }
  exports.getOptions = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : void 0;
    const scale = options.scale || 4;
    return {
      width,
      scale: width ? 4 : scale,
      margin,
      color: {
        dark: hex2rgba(options.color.dark || "#000000ff"),
        light: hex2rgba(options.color.light || "#ffffffff")
      },
      type: options.type,
      rendererOpts: options.rendererOpts || {}
    };
  };
  exports.getScale = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
  };
  exports.getImageWidth = function getImageWidth(qrSize, opts) {
    const scale = exports.getScale(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
  };
  exports.qrToImageData = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = exports.getScale(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [opts.color.light, opts.color.dark];
    for (let i9 = 0; i9 < symbolSize; i9++) {
      for (let j = 0; j < symbolSize; j++) {
        let posDst = (i9 * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i9 >= scaledMargin && j >= scaledMargin && i9 < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
          const iSrc = Math.floor((i9 - scaledMargin) / scale);
          const jSrc = Math.floor((j - scaledMargin) / scale);
          pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
      }
    }
  };
})(utils);
(function(exports) {
  const Utils2 = utils;
  function clearCanvas(ctx, canvas2, size) {
    ctx.clearRect(0, 0, canvas2.width, canvas2.height);
    if (!canvas2.style) canvas2.style = {};
    canvas2.height = size;
    canvas2.width = size;
    canvas2.style.height = size + "px";
    canvas2.style.width = size + "px";
  }
  function getCanvasElement() {
    try {
      return document.createElement("canvas");
    } catch (e2) {
      throw new Error("You need to specify a canvas element");
    }
  }
  exports.render = function render2(qrData, canvas2, options) {
    let opts = options;
    let canvasEl = canvas2;
    if (typeof opts === "undefined" && (!canvas2 || !canvas2.getContext)) {
      opts = canvas2;
      canvas2 = void 0;
    }
    if (!canvas2) {
      canvasEl = getCanvasElement();
    }
    opts = Utils2.getOptions(opts);
    const size = Utils2.getImageWidth(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    Utils2.qrToImageData(image.data, qrData, opts);
    clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
  };
  exports.renderToDataURL = function renderToDataURL(qrData, canvas2, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas2 || !canvas2.getContext)) {
      opts = canvas2;
      canvas2 = void 0;
    }
    if (!opts) opts = {};
    const canvasEl = exports.render(qrData, canvas2, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
  };
})(canvas);
var svgTag = {};
var Utils = utils;
function getColorAttrib(color, attrib) {
  const alpha = color.a / 255;
  const str = attrib + '="' + color.hex + '"';
  return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function svgCmd(cmd, x, y3) {
  let str = cmd + x;
  if (typeof y3 !== "undefined") str += " " + y3;
  return str;
}
function qrToPath(data, size, margin) {
  let path = "";
  let moveBy = 0;
  let newRow = false;
  let lineLength = 0;
  for (let i9 = 0; i9 < data.length; i9++) {
    const col = Math.floor(i9 % size);
    const row = Math.floor(i9 / size);
    if (!col && !newRow) newRow = true;
    if (data[i9]) {
      lineLength++;
      if (!(i9 > 0 && col > 0 && data[i9 - 1])) {
        path += newRow ? svgCmd("M", col + margin, 0.5 + row + margin) : svgCmd("m", moveBy, 0);
        moveBy = 0;
        newRow = false;
      }
      if (!(col + 1 < size && data[i9 + 1])) {
        path += svgCmd("h", lineLength);
        lineLength = 0;
      }
    } else {
      moveBy++;
    }
  }
  return path;
}
svgTag.render = function render(qrData, options, cb) {
  const opts = Utils.getOptions(options);
  const size = qrData.modules.size;
  const data = qrData.modules.data;
  const qrcodesize = size + opts.margin * 2;
  const bg = !opts.color.light.a ? "" : "<path " + getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
  const path = "<path " + getColorAttrib(opts.color.dark, "stroke") + ' d="' + qrToPath(data, size, opts.margin) + '"/>';
  const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
  const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
  const svgTag2 = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
  if (typeof cb === "function") {
    cb(null, svgTag2);
  }
  return svgTag2;
};
var canPromise = canPromise$1;
var QRCode = qrcode;
var CanvasRenderer = canvas;
var SvgRenderer = svgTag;
function renderCanvas(renderFunc, canvas2, text2, opts, cb) {
  const args = [].slice.call(arguments, 1);
  const argsNum = args.length;
  const isLastArgCb = typeof args[argsNum - 1] === "function";
  if (!isLastArgCb && !canPromise()) {
    throw new Error("Callback required as last argument");
  }
  if (isLastArgCb) {
    if (argsNum < 2) {
      throw new Error("Too few arguments provided");
    }
    if (argsNum === 2) {
      cb = text2;
      text2 = canvas2;
      canvas2 = opts = void 0;
    } else if (argsNum === 3) {
      if (canvas2.getContext && typeof cb === "undefined") {
        cb = opts;
        opts = void 0;
      } else {
        cb = opts;
        opts = text2;
        text2 = canvas2;
        canvas2 = void 0;
      }
    }
  } else {
    if (argsNum < 1) {
      throw new Error("Too few arguments provided");
    }
    if (argsNum === 1) {
      text2 = canvas2;
      canvas2 = opts = void 0;
    } else if (argsNum === 2 && !canvas2.getContext) {
      opts = text2;
      text2 = canvas2;
      canvas2 = void 0;
    }
    return new Promise(function(resolve, reject) {
      try {
        const data = QRCode.create(text2, opts);
        resolve(renderFunc(data, canvas2, opts));
      } catch (e2) {
        reject(e2);
      }
    });
  }
  try {
    const data = QRCode.create(text2, opts);
    cb(null, renderFunc(data, canvas2, opts));
  } catch (e2) {
    cb(e2);
  }
}
var create2 = browser$1.create = QRCode.create;
var toCanvas = browser$1.toCanvas = renderCanvas.bind(null, CanvasRenderer.render);
var toDataURL = browser$1.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL);
var toString = browser$1.toString = renderCanvas.bind(null, function(data, _2, opts) {
  return SvgRenderer.render(data, opts);
});
var browser = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  create: create2,
  default: browser$1,
  toCanvas,
  toDataURL,
  toString
}, [browser$1]);

// src/Widget.tsx
var import_jsx_runtime = require("react/jsx-runtime");
function Widget2({
  journeyName,
  redirectUrls,
  baseUrl = window.location.origin,
  authPath = "fr-callback.html",
  realmPath = "online",
  clientId = "loginWidgetPublicClient",
  onLoginSuccess
}) {
  const widgetRef = (0, import_react.useRef)(null);
  const [user2, setUser] = (0, import_react.useState)(null);
  const [showDisclaimer, setShowDisclaimer] = (0, import_react.useState)(false);
  (0, import_react.useEffect)(() => {
    const config = configuration();
    config.set({
      forgerock: {
        serverConfig: {
          baseUrl: new URL("openam", baseUrl).toString(),
          timeout: 3e3
        },
        realmPath,
        redirectUri: new URL(authPath, baseUrl).toString(),
        tree: "ULALogin",
        clientId,
        scope: "openid profile",
        tokenStore: "sessionStorage"
      },
      journeys: {
        register: {
          journey: "ULARegister",
          match: ["#/service/Registration"]
        },
        forgotUsername: {
          journey: "ULAForgotUsername",
          match: ["#/service/ForgotUsername"]
        },
        forgotPassword: {
          journey: "ULAForgotPassword",
          match: ["#/service/ForgotPassword"]
        }
      },
      content: {
        userName: "Email",
        nextButton: "Continue",
        backToDefault: "Return to sign in",
        backToLogin: "Return to sign in"
      },
      style: {
        labels: "stacked"
      }
    });
    const journeyEvents = journey();
    const url2 = new URL(window.location.href);
    const journeyParams = hasSsoSearchParams(url2) ? { journey: journeyName, resumeUrl: url2.toString() } : { journey: journeyName };
    journeyEvents.start(journeyParams);
    const journeyEventsUnsubscriber = journeyEvents.subscribe(async (event) => {
      var _a, _b, _c, _d;
      if (user2 !== event.user.response) {
        setUser(event.user.response);
      }
      if (event.user.successful) {
        const jweData = {
          sparkID: (_a = event.user.response) == null ? void 0 : _a.sub,
          accessToken: (_b = event.oauth.response) == null ? void 0 : _b.accessToken,
          refreshToken: (_c = event.oauth.response) == null ? void 0 : _c.refreshToken
        };
        await handleJwe(jweData, baseUrl);
        if (redirectUrls) {
          journeyEventsUnsubscriber();
          window.location.replace(
            redirectUrls.gotoUrl || ((_d = event.journey.response) == null ? void 0 : _d.successUrl) || redirectUrls.fallbackUrl
          );
        }
        if (onLoginSuccess) onLoginSuccess();
      }
      setShowDisclaimer(Boolean(event.journey.recaptchaAction));
    });
    return () => {
      journeyEventsUnsubscriber();
    };
  }, [redirectUrls, journeyName, baseUrl, clientId, realmPath]);
  (0, import_react.useEffect)(() => {
    const widget = new Widget({
      target: widgetRef.current,
      props: {
        type: "inline"
      }
    });
    return () => {
      widget.$destroy();
    };
  }, [widgetRef]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { className: "widget", children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { ref: widgetRef }),
    showDisclaimer ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("p", { className: "disclaimer", children: [
      "This site is protected by hCaptcha and its",
      " ",
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "a",
        {
          href: "https://www.hcaptcha.com/privacy",
          target: "_blank",
          rel: "noreferrer",
          className: "link",
          children: "Privacy Policy"
        }
      ),
      " ",
      "and",
      " ",
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "a",
        {
          href: "https://www.hcaptcha.com/terms",
          target: "_blank",
          rel: "noreferrer",
          className: "link",
          children: "Terms of Service"
        }
      ),
      " ",
      "apply."
    ] }) : null
  ] });
}
async function handleJwe(jweData, url2) {
  const jweUrl = new URL("/jwe", url2);
  return fetch(jweUrl, { method: "POST", body: JSON.stringify(jweData) });
}
function hasSsoSearchParams(url2) {
  const code = url2.searchParams.get("code");
  const state = url2.searchParams.get("state");
  const formPostEntry = url2.searchParams.get("form_post_entry");
  return Boolean(formPostEntry || code && state);
}
